
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kMIvJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4efe52960310a028$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("41VL9");

var $hVCgF = parcelRequire("hVCgF");

var $4L5YT = parcelRequire("4L5YT");

var $aPS2z = parcelRequire("aPS2z");

var $aZ5HL = parcelRequire("aZ5HL");

var $dZRaT = parcelRequire("dZRaT");

var $aV23b = parcelRequire("aV23b");

var $iEXnd = parcelRequire("iEXnd");

var $koAZ4 = parcelRequire("koAZ4");

var $eJrcF = parcelRequire("eJrcF");
var $gCY1z = parcelRequire("gCY1z");

var $4z2jV = parcelRequire("4z2jV");
const $4efe52960310a028$var$ProjectComponents = ()=>{
    const [{ match: match, location: location }] = (0, $gCY1z.useRouter)();
    const prefetchResult = (0, $eJrcF.useResource)((0, $aZ5HL.projectsComponentsResource));
    const projectContext = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { projectKey: projectKey } = match.params;
    if ((0, $aPS2z.isProjectArchivedCondition)(projectContext.data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aPS2z.RedirectToArchivedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEXnd.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVCgF.default), {
        appNameSuffixForV2Event: "project.components",
        appNameForV3OperationalEvent: "componentsProject"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, projectKey && projectContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4L5YT.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4z2jV.default), {
            projectContext: projectContext,
            tenantContext: tenantContext,
            prefetchResult: {
                ...prefetchResult
            },
            query: query,
            onQueryChanged: onQueryChanged
        })) : null));
};
var $4efe52960310a028$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($4efe52960310a028$var$ProjectComponents);

});
parcelRegister("hVCgF", function(module, exports) {
$parcel$export(module.exports, "default", () => $aeb7896d17d4ecc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $dFqXL = parcelRequire("dFqXL");
const $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
const $aeb7896d17d4ecc0$var$PageAppInitialisationAnalytics = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFqXL.MountEvent), {
        onMount: $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));
var $aeb7896d17d4ecc0$export$2e2bcd8739ae039 = $aeb7896d17d4ecc0$var$PageAppInitialisationAnalytics;

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("4L5YT", function(module, exports) {
$parcel$export(module.exports, "default", () => $81f1db8c99421cce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4cuZm = parcelRequire("4cuZm");

var $3ewCx = parcelRequire("3ewCx");

var $5zSvf = parcelRequire("5zSvf");

var $7A7EA = parcelRequire("7A7EA");
const $81f1db8c99421cce$var$QueryParamAdapterWithDefaults = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cuZm.default), {
        location: location,
        queryFromUrl: (0, $5zSvf.queryFromUrl),
        queryToUrl: (0, $7A7EA.queryToUrl),
        defaultQuery: (0, $3ewCx.initialQuery)
    }, children);
var $81f1db8c99421cce$export$2e2bcd8739ae039 = $81f1db8c99421cce$var$QueryParamAdapterWithDefaults;

});
parcelRegister("4cuZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $446b3862e19b2a93$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k4x9q = parcelRequire("k4x9q");

var $12DRg = parcelRequire("12DRg");

var $b5RwB = parcelRequire("b5RwB");

var $lcB5K = parcelRequire("lcB5K");

var $eoPnG = parcelRequire("eoPnG");

var $kuiVs = parcelRequire("kuiVs");
const $446b3862e19b2a93$var$GenericQueryParamAdapter = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))((0, $eoPnG.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kuiVs.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};
var $446b3862e19b2a93$export$2e2bcd8739ae039 = $446b3862e19b2a93$var$GenericQueryParamAdapter;

});
parcelRegister("eoPnG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36cbf0efe48d029$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");
const $c36cbf0efe48d029$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c36cbf0efe48d029$export$2e2bcd8739ae039 = $c36cbf0efe48d029$var$fromUrlTransformerFactory;

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});


parcelRegister("kuiVs", function(module, exports) {
$parcel$export(module.exports, "AdapterWithState", () => $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $b5RwB = parcelRequire("b5RwB");
class $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("3ewCx", function(module, exports) {
$parcel$export(module.exports, "initialQuery", () => $160ac875760a0d31$export$8af7177c92ae79e3);

var $cgnZX = parcelRequire("cgnZX");

var $5Ja1M = parcelRequire("5Ja1M");
const $160ac875760a0d31$export$8af7177c92ae79e3 = {
    orderField: (0, $5Ja1M.NAME),
    orderDirection: (0, $cgnZX.ASC),
    page: 1,
    filter: ''
};

});
parcelRegister("cgnZX", function(module, exports) {
$parcel$export(module.exports, "ASC", () => $95028c31dfca7847$export$1dee026a19752d6b);
$parcel$export(module.exports, "DESC", () => $95028c31dfca7847$export$b6abcf7fa1d94f65);
$parcel$export(module.exports, "ORDER_DIRECTION", () => $95028c31dfca7847$export$543711d9afc9aac1);
const $95028c31dfca7847$export$1dee026a19752d6b = 'ASC';
const $95028c31dfca7847$export$b6abcf7fa1d94f65 = 'DESC';
const $95028c31dfca7847$export$543711d9afc9aac1 = {
    [$95028c31dfca7847$export$1dee026a19752d6b]: $95028c31dfca7847$export$1dee026a19752d6b,
    [$95028c31dfca7847$export$b6abcf7fa1d94f65]: $95028c31dfca7847$export$b6abcf7fa1d94f65
};

});

parcelRegister("5Ja1M", function(module, exports) {
$parcel$export(module.exports, "NAME", () => $18eecb66f764622a$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $18eecb66f764622a$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $18eecb66f764622a$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $18eecb66f764622a$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELD", () => $18eecb66f764622a$export$55c82710eb02082c);
const $18eecb66f764622a$export$3c5e605ca7ade9f2 = 'NAME';
const $18eecb66f764622a$export$d44826c816b5619b = 'DESCRIPTION';
const $18eecb66f764622a$export$73dcda99369fd988 = 'LEAD';
const $18eecb66f764622a$export$1c62ab608c48125c = 'ISSUES';
const $18eecb66f764622a$export$55c82710eb02082c = {
    [$18eecb66f764622a$export$3c5e605ca7ade9f2]: $18eecb66f764622a$export$3c5e605ca7ade9f2,
    [$18eecb66f764622a$export$d44826c816b5619b]: $18eecb66f764622a$export$d44826c816b5619b,
    [$18eecb66f764622a$export$73dcda99369fd988]: $18eecb66f764622a$export$73dcda99369fd988,
    [$18eecb66f764622a$export$1c62ab608c48125c]: $18eecb66f764622a$export$1c62ab608c48125c
};

});


parcelRegister("5zSvf", function(module, exports) {
$parcel$export(module.exports, "queryFromUrl", () => $0e3813d7fef97ebd$export$34bcc098502c2587);

var $cgnZX = parcelRequire("cgnZX");

var $5Ja1M = parcelRequire("5Ja1M");
const $0e3813d7fef97ebd$var$getOrderEntity = (target, value, defaults)=>Object.values(target).includes(value) ? value : defaults;
const $0e3813d7fef97ebd$export$dbde9a25ef92ab90 = (field)=>$0e3813d7fef97ebd$var$getOrderEntity((0, $5Ja1M.ORDER_FIELD), field, (0, $5Ja1M.ORDER_FIELD).NAME);
const $0e3813d7fef97ebd$export$d13e6a6b186c83d7 = (direction)=>$0e3813d7fef97ebd$var$getOrderEntity((0, $cgnZX.ORDER_DIRECTION), direction, (0, $cgnZX.ORDER_DIRECTION).DESC);
const $0e3813d7fef97ebd$export$aa86da1aa250e687 = (page)=>typeof Number(page) === 'number' && Number(page) >= 1 ? Number(page) : 1;
const $0e3813d7fef97ebd$export$34bcc098502c2587 = ({ filter: filter, orderDirection: orderDirection, orderField: orderField, page: page })=>({
        filter: filter || '',
        orderDirection: $0e3813d7fef97ebd$export$d13e6a6b186c83d7(orderDirection),
        orderField: $0e3813d7fef97ebd$export$dbde9a25ef92ab90(orderField),
        page: $0e3813d7fef97ebd$export$aa86da1aa250e687(page)
    });

});

parcelRegister("7A7EA", function(module, exports) {
$parcel$export(module.exports, "queryToUrl", () => $d4281f015f2847e7$export$2ecaae24d8b0a6a8);
const $d4281f015f2847e7$export$2ecaae24d8b0a6a8 = (query)=>{
    if (query) {
        const { filter: filter, orderDirection: orderDirection, orderField: orderField, page: page } = query;
        return {
            filter: filter,
            orderDirection: orderDirection,
            orderField: orderField,
            page: page
        };
    }
    return {};
};

});


parcelRegister("aPS2z", function(module, exports) {
$parcel$export(module.exports, "isProjectArchivedCondition", () => $09ee4a6709eeeeea$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $09ee4a6709eeeeea$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $09ee4a6709eeeeea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $2mHfh = parcelRequire("2mHfh");

const $09ee4a6709eeeeea$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $09ee4a6709eeeeea$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, (projectContext)=>$09ee4a6709eeeeea$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
        }) : null);
};
const $09ee4a6709eeeeea$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
    });
var $09ee4a6709eeeeea$export$2e2bcd8739ae039 = $09ee4a6709eeeeea$var$RedirectIfProjectArchived;

});
const $5e412e91f864721a$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("4z2jV", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4855461600744bb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2QUmO = parcelRequire("2QUmO");

var $gu4K3 = parcelRequire("gu4K3");

var $cZTMg = parcelRequire("cZTMg");

var $1SsnA = parcelRequire("1SsnA");
const $b4855461600744bb$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    });
var $b4855461600744bb$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $1SsnA.default), {
    ProjectDirectoriesApp: $gu4K3.default,
    Updater: $b4855461600744bb$var$Updater
});

});
parcelRegister("gu4K3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8a7ed11cef31f91$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $fGnU6 = parcelRequire("fGnU6");

var $guWba = parcelRequire("guWba");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $gkJdp = parcelRequire("gkJdp");

var $jhUy1 = parcelRequire("jhUy1");

var $7eW8q = parcelRequire("7eW8q");

var $1jTqh = parcelRequire("1jTqh");

var $3ewCx = parcelRequire("3ewCx");

var $1jVSq = parcelRequire("1jVSq");

var $b4iNK = parcelRequire("b4iNK");

var $b1PaM = parcelRequire("b1PaM");

var $32E87 = parcelRequire("32E87");

var $gFEBu = parcelRequire("gFEBu");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");

var $alANc = parcelRequire("alANc");
class $f8a7ed11cef31f91$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            isAdmin: false,
            prefetchedData: null,
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            query: (0, $3ewCx.initialQuery),
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        const { locale: locale, projectKey: projectKey, projectId: projectId, projectName: projectName, isAdmin: isAdmin, projectType: projectType, prefetchedData: prefetchedData, query: query, onQueryChanged: onQueryChanged } = props;
        const project = {
            id: projectId,
            key: projectKey,
            name: projectName,
            type: projectType
        };
        const analyticsData = {
            projectType: projectType
        };
        this.store = (0, $32E87.default)((0, $1jTqh.default));
        this.store.dispatch((0, $b1PaM.set)({
            isAdmin: isAdmin,
            locale: locale,
            onQueryChanged: onQueryChanged
        }));
        this.store.dispatch((0, $gFEBu.set)(project));
        this.store.dispatch((0, $b4iNK.set)(analyticsData));
        this.store.dispatch((0, $ksVok.setQuery)(query || (0, $3ewCx.initialQuery)));
        if (prefetchedData) this.store.dispatch((0, $1jVSq.setComponentsPage)(prefetchedData));
        else this.store.dispatch((0, $1jVSq.getComponentsPageRequest)({
            page: (0, $hGeBN.getCurrentPage)(this.store.getState()),
            initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).VIEW
        }));
    }
    componentDidUpdate() {
        const { query: query } = this.props;
        if (query && query && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(query, (0, $hGeBN.getQuery)(this.store.getState()))) this.store.dispatch((0, $ksVok.setQuery)(query));
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkJdp.FlagsDispatcher), {
            mapper: (0, $7eW8q.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alANc.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null))));
    }
}

});
parcelRegister("gkJdp", function(module, exports) {
$parcel$export(module.exports, "FlagsDispatcher", () => $d4954b195b498ec0$export$9e60e3d40b6e758f);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");

var $1jGda = parcelRequire("1jGda");
const $d4954b195b498ec0$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1jGda.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $cSXp8.showFlag),
        dismissFlag: (0, $cSXp8.dismissFlag)
    });

});
parcelRegister("1jGda", function(module, exports) {
$parcel$export(module.exports, "Dispatcher", () => $fa7452c648b5a8e9$export$ab054a1ef92eeb01);

var $eJOHy = parcelRequire("eJOHy");

var $9M1e4 = parcelRequire("9M1e4");
const $fa7452c648b5a8e9$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eJOHy.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eJOHy.useMemo)(()=>(0, $9M1e4.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("9M1e4", function(module, exports) {
$parcel$export(module.exports, "createDispatcher", () => $3e53fcd3a1d0c324$export$7b259d28468da15b);

var $eJOHy = parcelRequire("eJOHy");

var $dyOHn = parcelRequire("dyOHn");

var $cSXp8 = parcelRequire("cSXp8");
const $3e53fcd3a1d0c324$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $3e53fcd3a1d0c324$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $cSXp8.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $cSXp8.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyOHn.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $3e53fcd3a1d0c324$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $cSXp8.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $3e53fcd3a1d0c324$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $3e53fcd3a1d0c324$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $3e53fcd3a1d0c324$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eJOHy.useMemo)(()=>$3e53fcd3a1d0c324$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $3e53fcd3a1d0c324$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $3e53fcd3a1d0c324$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $dyOHn.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e53fcd3a1d0c324$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $3e53fcd3a1d0c324$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e53fcd3a1d0c324$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $3e53fcd3a1d0c324$var$Dispatcher8DefaultStore;
};

});



parcelRegister("jhUy1", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPONENTS_REASON", () => $87fbd923e9501261$export$66a91c2022d4732);
const $87fbd923e9501261$export$397e49c56ae84012 = 'VIEW';
const $87fbd923e9501261$export$8fe76e5b77038f3e = 'FILTERING';
const $87fbd923e9501261$export$75081ca35b4dae45 = 'SORTING';
const $87fbd923e9501261$export$ceb692a4f4f3a013 = 'COMPONENT_CREATED';
const $87fbd923e9501261$export$fa4ff5560bcaba4d = 'COMPONENT_DELETED';
const $87fbd923e9501261$export$78216513f47e03b8 = 'COMPONENT_UPDATED';
const $87fbd923e9501261$export$66a91c2022d4732 = {
    VIEW: $87fbd923e9501261$export$397e49c56ae84012,
    FILTERING: $87fbd923e9501261$export$8fe76e5b77038f3e,
    SORTING: $87fbd923e9501261$export$75081ca35b4dae45,
    COMPONENT_CREATED: $87fbd923e9501261$export$ceb692a4f4f3a013,
    COMPONENT_DELETED: $87fbd923e9501261$export$fa4ff5560bcaba4d,
    COMPONENT_UPDATED: $87fbd923e9501261$export$78216513f47e03b8
};

});

parcelRegister("7eW8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $f682d443b83f6454$export$2e2bcd8739ae039);

var $1jVSq = parcelRequire("1jVSq");

var $kPxYw = parcelRequire("kPxYw");

var $9cwTh = parcelRequire("9cwTh");

var $g9TzU = parcelRequire("g9TzU");

var $lHc4k = parcelRequire("lHc4k");

var $l6qdi = parcelRequire("l6qdi");

var $cQmMQ = parcelRequire("cQmMQ");

var $h0wMW = parcelRequire("h0wMW");
const $f682d443b83f6454$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $1jVSq.ADD_COMPONENT_SUCCESS:
            return (0, $9cwTh.default)(action.payload.name);
        case 0, $1jVSq.ADD_COMPONENT_FAIL:
            return (0, $kPxYw.default)();
        case 0, $1jVSq.DELETE_COMPONENT_SUCCESS:
            return (0, $lHc4k.default)(action.payload.component.name);
        case 0, $1jVSq.DELETE_COMPONENT_FAILURE:
            return (0, $g9TzU.default)();
        case 0, $1jVSq.UPDATE_COMPONENT_SUCCESS:
            return (0, $h0wMW.default)(action.payload.componentName);
        case 0, $1jVSq.UPDATE_COMPONENT_FAIL:
            return (0, $l6qdi.default)();
        case 0, $1jVSq.INITIATE_UPDATE_COMPONENT_FAIL:
            return (0, $cQmMQ.default)();
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $f682d443b83f6454$export$2e2bcd8739ae039 = $f682d443b83f6454$var$flagsMapper;

});
parcelRegister("1jVSq", function(module, exports) {
$parcel$export(module.exports, "ADD_COMPONENT_SUCCESS", () => $44f76bd756fce206$export$c183a38d4b59a6d9);
$parcel$export(module.exports, "addComponentSuccess", () => $44f76bd756fce206$export$4d0d7b371036da7e);
$parcel$export(module.exports, "ADD_COMPONENT_FAIL", () => $44f76bd756fce206$export$4fa38ebaaae89345);
$parcel$export(module.exports, "addComponentFail", () => $44f76bd756fce206$export$cb5b2c24e0a5dde9);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT", () => $44f76bd756fce206$export$1c8d8242dfd2faaa);
$parcel$export(module.exports, "initiateUpdateComponent", () => $44f76bd756fce206$export$a82c94a7a4ba9a48);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT_SUCCESS", () => $44f76bd756fce206$export$65b2950c8245ca00);
$parcel$export(module.exports, "initiateUpdateComponentSuccess", () => $44f76bd756fce206$export$f029600573ab2333);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT_FAIL", () => $44f76bd756fce206$export$7c00c0ce897afa48);
$parcel$export(module.exports, "initiateUpdateComponentFail", () => $44f76bd756fce206$export$1e8dcb553d0c7dcf);
$parcel$export(module.exports, "UPDATE_COMPONENT_REQUEST", () => $44f76bd756fce206$export$b676f3c0288df16a);
$parcel$export(module.exports, "updateComponentRequest", () => $44f76bd756fce206$export$9553a85e2bc20da3);
$parcel$export(module.exports, "PATCH_COMPONENT", () => $44f76bd756fce206$export$76d71ef1b430c044);
$parcel$export(module.exports, "patchComponent", () => $44f76bd756fce206$export$c21b0e7ef80ba29f);
$parcel$export(module.exports, "UPDATE_COMPONENT_SUCCESS", () => $44f76bd756fce206$export$543e05e6a6883af);
$parcel$export(module.exports, "updateComponentSuccess", () => $44f76bd756fce206$export$77f1acf01c0045cd);
$parcel$export(module.exports, "UPDATE_COMPONENT_FAIL", () => $44f76bd756fce206$export$8cd0c0bce936b058);
$parcel$export(module.exports, "updateComponentFail", () => $44f76bd756fce206$export$d24cd5f476018727);
$parcel$export(module.exports, "UPDATE_COMPONENT_VALIDATION_FAIL", () => $44f76bd756fce206$export$6c721d766648f32a);
$parcel$export(module.exports, "updateComponentValidationFail", () => $44f76bd756fce206$export$18bef1cc777a2207);
$parcel$export(module.exports, "GET_COMPONENTS_PAGE_REQUEST", () => $44f76bd756fce206$export$61cc82f1967db37b);
$parcel$export(module.exports, "getComponentsPageRequest", () => $44f76bd756fce206$export$af441cb160ff9e19);
$parcel$export(module.exports, "SET_COMPONENTS_PAGE", () => $44f76bd756fce206$export$e0ab2efe830203fb);
$parcel$export(module.exports, "setComponentsPage", () => $44f76bd756fce206$export$4f58aa0a531045ac);
$parcel$export(module.exports, "DELETE_COMPONENT_SUCCESS", () => $44f76bd756fce206$export$da077ae08c543bd0);
$parcel$export(module.exports, "deleteComponentSuccess", () => $44f76bd756fce206$export$8d34c79dac47f8f3);
$parcel$export(module.exports, "DELETE_COMPONENT_FAILURE", () => $44f76bd756fce206$export$cccbe1054a0c3a89);
$parcel$export(module.exports, "deleteComponentFailure", () => $44f76bd756fce206$export$ac7d0962a47d8bf0);
const $44f76bd756fce206$export$c183a38d4b59a6d9 = 'root.ADD_COMPONENT_SUCCESS';
const $44f76bd756fce206$export$4d0d7b371036da7e = (payload)=>({
        type: $44f76bd756fce206$export$c183a38d4b59a6d9,
        payload: payload
    });
const $44f76bd756fce206$export$4fa38ebaaae89345 = 'root.ADD_COMPONENT_FAIL';
const $44f76bd756fce206$export$cb5b2c24e0a5dde9 = ()=>({
        type: $44f76bd756fce206$export$4fa38ebaaae89345
    });
const $44f76bd756fce206$export$1c8d8242dfd2faaa = 'root.INITIATE_UPDATE_COMPONENT';
const $44f76bd756fce206$export$a82c94a7a4ba9a48 = (payload)=>({
        type: $44f76bd756fce206$export$1c8d8242dfd2faaa,
        payload: payload
    });
const $44f76bd756fce206$export$65b2950c8245ca00 = 'root.INITIATE_UPDATE_COMPONENT_SUCCESS';
const $44f76bd756fce206$export$f029600573ab2333 = (payload)=>({
        type: $44f76bd756fce206$export$65b2950c8245ca00,
        payload: payload
    });
const $44f76bd756fce206$export$7c00c0ce897afa48 = 'root.INITIATE_UPDATE_COMPONENT_FAIL';
const $44f76bd756fce206$export$1e8dcb553d0c7dcf = (payload)=>({
        type: $44f76bd756fce206$export$7c00c0ce897afa48,
        payload: payload
    });
const $44f76bd756fce206$export$b676f3c0288df16a = 'root.UPDATE_COMPONENT_REQUEST';
const $44f76bd756fce206$export$9553a85e2bc20da3 = ()=>({
        type: $44f76bd756fce206$export$b676f3c0288df16a
    });
const $44f76bd756fce206$export$76d71ef1b430c044 = 'root.PATCH_COMPONENT';
const $44f76bd756fce206$export$c21b0e7ef80ba29f = (payload)=>({
        type: $44f76bd756fce206$export$76d71ef1b430c044,
        payload: payload
    });
const $44f76bd756fce206$export$543e05e6a6883af = 'root.UPDATE_COMPONENT_SUCCESS';
const $44f76bd756fce206$export$77f1acf01c0045cd = (payload)=>({
        type: $44f76bd756fce206$export$543e05e6a6883af,
        payload: payload
    });
const $44f76bd756fce206$export$8cd0c0bce936b058 = 'root.UPDATE_COMPONENT_FAIL';
const $44f76bd756fce206$export$d24cd5f476018727 = (payload)=>({
        type: $44f76bd756fce206$export$8cd0c0bce936b058,
        payload: payload
    });
const $44f76bd756fce206$export$6c721d766648f32a = 'root.UPDATE_COMPONENT_VALIDATION_FAIL';
const $44f76bd756fce206$export$18bef1cc777a2207 = (payload)=>({
        type: $44f76bd756fce206$export$6c721d766648f32a,
        payload: payload
    });
const $44f76bd756fce206$export$61cc82f1967db37b = 'components.GET_COMPONENTS_PAGE_REQUEST';
const $44f76bd756fce206$export$af441cb160ff9e19 = (payload)=>({
        type: $44f76bd756fce206$export$61cc82f1967db37b,
        payload: payload
    });
const $44f76bd756fce206$export$e0ab2efe830203fb = 'components.SET_COMPONENTS_PAGE';
const $44f76bd756fce206$export$4f58aa0a531045ac = (payload)=>({
        type: $44f76bd756fce206$export$e0ab2efe830203fb,
        payload: payload
    });
const $44f76bd756fce206$export$da077ae08c543bd0 = 'components.DELETE_COMPONENT_SUCCESS';
const $44f76bd756fce206$export$8d34c79dac47f8f3 = (payload)=>({
        type: $44f76bd756fce206$export$da077ae08c543bd0,
        payload: payload
    });
const $44f76bd756fce206$export$cccbe1054a0c3a89 = 'components.DELETE_COMPONENT_FAILURE';
const $44f76bd756fce206$export$ac7d0962a47d8bf0 = (payload)=>({
        type: $44f76bd756fce206$export$cccbe1054a0c3a89,
        payload: payload
    });

});

parcelRegister("kPxYw", function(module, exports) {
$parcel$export(module.exports, "default", () => $7231be40717f11c4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7231be40717f11c4$var$messages = (0, $7qGN1.defineMessages)({
    componentAdditionFailedTitle: {
        "id": "project-components.flags.component-addition-failed-title",
        "defaultMessage": "We couldn't create the component."
    },
    componentAdditionFailedDescription: {
        "id": "project-components.flags.component-addition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $7231be40717f11c4$var$AddError = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $7231be40717f11c4$var$messages.componentAdditionFailedTitle,
        description: $7231be40717f11c4$var$messages.componentAdditionFailedDescription,
        messageId: 'project-directories.components.flags.add.flag.error',
        messageType: 'transactional'
    });
var $7231be40717f11c4$export$2e2bcd8739ae039 = $7231be40717f11c4$var$AddError;

});

parcelRegister("9cwTh", function(module, exports) {
$parcel$export(module.exports, "default", () => $977ce40c328de2ba$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $977ce40c328de2ba$var$messages = (0, $7qGN1.defineMessages)({
    componentAddedTitle: {
        "id": "project-components.flags.component-added-title",
        "defaultMessage": "{name} added"
    }
});
const $977ce40c328de2ba$var$AddSuccess = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $977ce40c328de2ba$var$messages.componentAddedTitle,
            {
                name: name
            }
        ],
        messageId: 'project-directories.components.flags.add.flag.success',
        messageType: 'transactional'
    });
var $977ce40c328de2ba$export$2e2bcd8739ae039 = $977ce40c328de2ba$var$AddSuccess;

});

parcelRegister("g9TzU", function(module, exports) {
$parcel$export(module.exports, "default", () => $30000552dcbc7566$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $30000552dcbc7566$var$messages = (0, $7qGN1.defineMessages)({
    componentDeletionFailedTitle: {
        "id": "project-components.flags.component-deletion-failed-title",
        "defaultMessage": "We couldn't delete the component"
    },
    componentDeletionFailedDescription: {
        "id": "project-components.flags.component-deletion-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $30000552dcbc7566$var$DeleteError = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $30000552dcbc7566$var$messages.componentDeletionFailedTitle,
        description: $30000552dcbc7566$var$messages.componentDeletionFailedDescription,
        messageId: 'project-directories.components.flags.delete.flag.error',
        messageType: 'transactional'
    });
var $30000552dcbc7566$export$2e2bcd8739ae039 = $30000552dcbc7566$var$DeleteError;

});

parcelRegister("lHc4k", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e71bce5cdf6285e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3e71bce5cdf6285e$var$messages = (0, $7qGN1.defineMessages)({
    componentDeletedTitle: {
        "id": "project-components.flags.component-deleted-title",
        "defaultMessage": "{name} deleted"
    }
});
const $3e71bce5cdf6285e$var$DeleteSuccess = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $3e71bce5cdf6285e$var$messages.componentDeletedTitle,
            {
                name: name
            }
        ],
        messageId: 'project-directories.components.flags.delete.flag.success',
        messageType: 'transactional'
    });
var $3e71bce5cdf6285e$export$2e2bcd8739ae039 = $3e71bce5cdf6285e$var$DeleteSuccess;

});

parcelRegister("l6qdi", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3265721453af97$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0f3265721453af97$var$messages = (0, $7qGN1.defineMessages)({
    componentEditionFailedTitle: {
        "id": "project-components.flags.component-edition-failed-title",
        "defaultMessage": "We couldn't edit the component"
    },
    componentEditionFailedDescription: {
        "id": "project-components.flags.component-edition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $0f3265721453af97$var$UpdateError = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $0f3265721453af97$var$messages.componentEditionFailedTitle,
        description: $0f3265721453af97$var$messages.componentEditionFailedDescription,
        messageId: 'project-directories.components.flags.update.flag.error',
        messageType: 'transactional'
    });
var $0f3265721453af97$export$2e2bcd8739ae039 = $0f3265721453af97$var$UpdateError;

});

parcelRegister("cQmMQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a06ad7bd91025f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $54a06ad7bd91025f$var$messages = (0, $7qGN1.defineMessages)({
    componentEditionFailedTitle: {
        "id": "project-components.flags.component-edition-failed-title",
        "defaultMessage": "We couldn't edit the component"
    },
    componentEditionFailedDescription: {
        "id": "project-components.flags.component-edition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $54a06ad7bd91025f$var$UpdateInitiateError = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $54a06ad7bd91025f$var$messages.componentEditionFailedTitle,
        description: $54a06ad7bd91025f$var$messages.componentEditionFailedDescription,
        messageId: 'project-directories.components.flags.update.flag.error.initiate-error',
        messageType: 'transactional'
    });
var $54a06ad7bd91025f$export$2e2bcd8739ae039 = $54a06ad7bd91025f$var$UpdateInitiateError;

});

parcelRegister("h0wMW", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6c3b68edae67b8f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a6c3b68edae67b8f$var$messages = (0, $7qGN1.defineMessages)({
    componentEditedTitle: {
        "id": "project-components.flags.component-edited-title",
        "defaultMessage": "{name} updated"
    }
});
const $a6c3b68edae67b8f$var$UpdateSuccess = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $a6c3b68edae67b8f$var$messages.componentEditedTitle,
            {
                name: name
            }
        ],
        messageId: 'project-directories.components.flags.update.flag.success',
        messageType: 'transactional'
    });
var $a6c3b68edae67b8f$export$2e2bcd8739ae039 = $a6c3b68edae67b8f$var$UpdateSuccess;

});


parcelRegister("1jTqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $140d85ddfe929f54$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $9mpst = parcelRequire("9mpst");

var $kzE0g = parcelRequire("kzE0g");

var $2g4va = parcelRequire("2g4va");

var $dQXsh = parcelRequire("dQXsh");

var $dwddz = parcelRequire("dwddz");

var $9qzkY = parcelRequire("9qzkY");
var $140d85ddfe929f54$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $dwddz.retrieveComponents), (0, $9mpst.default), (0, $9qzkY.updateComponent), (0, $9qzkY.initiateUpdateComponent), (0, $kzE0g.successfulDelete), (0, $dQXsh.querySet), (0, $2g4va.queryPatched));

});
parcelRegister("9mpst", function(module, exports) {
$parcel$export(module.exports, "default", () => $e42badd8c7420e7c$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $hGeBN = parcelRequire("hGeBN");
const $e42badd8c7420e7c$var$createEpic = (action$, store)=>action$.ofType((0, $1jVSq.ADD_COMPONENT_SUCCESS)).mergeMap(()=>(0, $7kixv.Observable).of((0, $1jVSq.getComponentsPageRequest)({
            page: (0, $hGeBN.getCurrentPage)(store.getState()),
            initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).COMPONENT_CREATED
        })));
var $e42badd8c7420e7c$export$2e2bcd8739ae039 = $e42badd8c7420e7c$var$createEpic;

});
parcelRegister("hGeBN", function(module, exports) {
$parcel$export(module.exports, "getQuery", () => $3a0d8bb321efff91$export$71eec30d9db46a56);
$parcel$export(module.exports, "getOnQueryChanged", () => $3a0d8bb321efff91$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getOrderDirection", () => $3a0d8bb321efff91$export$2e04c020ca8711f5);
$parcel$export(module.exports, "getOrderField", () => $3a0d8bb321efff91$export$f1954ff3a9ce71ff);
$parcel$export(module.exports, "getFilter", () => $3a0d8bb321efff91$export$61ec8404f465cd36);
$parcel$export(module.exports, "getCurrentPage", () => $3a0d8bb321efff91$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getOrderBy", () => $3a0d8bb321efff91$export$128f09144c413f07);

var $9R5ZS = parcelRequire("9R5ZS");
const $3a0d8bb321efff91$export$71eec30d9db46a56 = (state)=>state.query;
const $3a0d8bb321efff91$export$59e4f8ebf6520bf7 = (state)=>state.context.onQueryChanged;
const $3a0d8bb321efff91$export$2e04c020ca8711f5 = (state)=>state.query.orderDirection;
const $3a0d8bb321efff91$export$f1954ff3a9ce71ff = (state)=>state.query.orderField;
const $3a0d8bb321efff91$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $3a0d8bb321efff91$export$7945ba8eb1c827e6 = (state)=>state.query.page;
const $3a0d8bb321efff91$export$128f09144c413f07 = (state)=>(0, $9R5ZS.mapToOrderFetch)($3a0d8bb321efff91$export$f1954ff3a9ce71ff(state), $3a0d8bb321efff91$export$2e04c020ca8711f5(state));

});
parcelRegister("9R5ZS", function(module, exports) {
$parcel$export(module.exports, "mapToOrderFetch", () => $ee308d4952ed1936$export$6236a5c184fedc41);

var $cgnZX = parcelRequire("cgnZX");

var $5Ja1M = parcelRequire("5Ja1M");
const $ee308d4952ed1936$export$cab2635bfaf51f49 = {
    [(0, $5Ja1M.NAME)]: 'name',
    [(0, $5Ja1M.DESCRIPTION)]: 'description',
    [(0, $5Ja1M.LEAD)]: 'lead',
    [(0, $5Ja1M.ISSUES)]: 'issueCount'
};
const $ee308d4952ed1936$export$6236a5c184fedc41 = (orderField, orderDirection)=>(orderDirection === (0, $cgnZX.DESC) ? '-' : '+') + $ee308d4952ed1936$export$cab2635bfaf51f49[orderField];

});



parcelRegister("kzE0g", function(module, exports) {
$parcel$export(module.exports, "successfulDelete", () => $01455f2bc2d5512e$export$fb40872e7cc28b47);
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $2CrAx = parcelRequire("2CrAx");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $7Z0qA = parcelRequire("7Z0qA");

var $hGeBN = parcelRequire("hGeBN");

var $dw49z = parcelRequire("dw49z");
const $01455f2bc2d5512e$export$fb40872e7cc28b47 = (action$, store)=>action$.ofType((0, $1jVSq.DELETE_COMPONENT_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const componentsPerPage = (0, $dw49z.getItemsOnPage)(state);
        const totalComponents = (0, $7Z0qA.getTotalItems)(state);
        const currentPage = (0, $hGeBN.getCurrentPage)(state);
        const predictedPage = (0, $2CrAx.predictPageToRequestAfterItemDeletion)(componentsPerPage, totalComponents, currentPage);
        return (0, $7kixv.Observable).of((0, $1jVSq.getComponentsPageRequest)({
            page: predictedPage,
            initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).COMPONENT_DELETED
        }));
    });

});
parcelRegister("2CrAx", function(module, exports) {
$parcel$export(module.exports, "calculateTotalPages", () => $e8881310cdd77edc$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $e8881310cdd77edc$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $e8881310cdd77edc$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $e8881310cdd77edc$export$407c10b4791d7a16);

const $e8881310cdd77edc$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $e8881310cdd77edc$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $e8881310cdd77edc$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $e8881310cdd77edc$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $e8881310cdd77edc$export$407c10b4791d7a16 = (input)=>[
        (0, $88c5923de10af20c$export$1dee026a19752d6b),
        (0, $88c5923de10af20c$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $88c5923de10af20c$export$1dee026a19752d6b = 'ASC';
const $88c5923de10af20c$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("7Z0qA", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $81d2807296badfc1$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getIds", () => $81d2807296badfc1$export$24b60fe7179439bc);
$parcel$export(module.exports, "getAris", () => $81d2807296badfc1$export$edc7a71bded50395);
$parcel$export(module.exports, "getName", () => $81d2807296badfc1$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getIssueCount", () => $81d2807296badfc1$export$56d545f19dc75191);
$parcel$export(module.exports, "getLead", () => $81d2807296badfc1$export$97850e2d25587c0d);
$parcel$export(module.exports, "getDescription", () => $81d2807296badfc1$export$67580b1c13935958);
$parcel$export(module.exports, "getDefaultAssignee", () => $81d2807296badfc1$export$725da8bee1e71eb0);
$parcel$export(module.exports, "getComponent", () => $81d2807296badfc1$export$21a8719ce41a1de2);
$parcel$export(module.exports, "getTotalItems", () => $81d2807296badfc1$export$cbc4bdd6c02fac4d);
const $81d2807296badfc1$export$dd1bc94b04021eeb = (state)=>state.components.list.length === 0;
const $81d2807296badfc1$export$24b60fe7179439bc = (state)=>state.components.list;
const $81d2807296badfc1$export$edc7a71bded50395 = (state)=>state.components.listAri;
const $81d2807296badfc1$export$7d9f7e9c1c02b41e = (state, id)=>state.components.byId[id].name;
const $81d2807296badfc1$export$56d545f19dc75191 = (state, id)=>state.components.byId[id].issueCount;
const $81d2807296badfc1$export$97850e2d25587c0d = (state, id)=>state.components.byId[id].lead;
const $81d2807296badfc1$export$67580b1c13935958 = (state, id)=>state.components.byId[id].description;
const $81d2807296badfc1$export$725da8bee1e71eb0 = (state, id)=>state.components.byId[id].defaultAssignee;
const $81d2807296badfc1$export$21a8719ce41a1de2 = (state, id)=>state.components.byId[id];
const $81d2807296badfc1$export$cbc4bdd6c02fac4d = (state)=>state.components.totalItems;

});

parcelRegister("dw49z", function(module, exports) {
$parcel$export(module.exports, "getItemsOnPage", () => $36dc31cfaf524593$export$104aa54211627bc7);
$parcel$export(module.exports, "isLoading", () => $36dc31cfaf524593$export$20bb0d907fbbe433);
$parcel$export(module.exports, "getStartAt", () => $36dc31cfaf524593$export$d33293070717f977);
$parcel$export(module.exports, "getMaxResults", () => $36dc31cfaf524593$export$152d338deb24dc62);
const $36dc31cfaf524593$export$104aa54211627bc7 = (state)=>state.ui.page.itemsOnPage;
const $36dc31cfaf524593$export$20bb0d907fbbe433 = (state)=>state.ui.page.isLoading;
const $36dc31cfaf524593$export$d33293070717f977 = (state, page)=>$36dc31cfaf524593$export$104aa54211627bc7(state) * (page - 1);
const $36dc31cfaf524593$export$152d338deb24dc62 = (state)=>$36dc31cfaf524593$export$104aa54211627bc7(state);

});


parcelRegister("2g4va", function(module, exports) {
$parcel$export(module.exports, "queryPatched", () => $bc3ccdadb2528cde$export$290869333b164745);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $k4x9q = parcelRequire("k4x9q");

var $7kixv = parcelRequire("7kixv");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");
const $bc3ccdadb2528cde$export$290869333b164745 = (action$, store)=>action$.ofType((0, $ksVok.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $hGeBN.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(payload, (0, $hGeBN.getQuery)(state)));
        return (0, $7kixv.Observable).empty();
    });

});
parcelRegister("ksVok", function(module, exports) {
$parcel$export(module.exports, "SET_QUERY", () => $1aa483360b5308ea$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $1aa483360b5308ea$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $1aa483360b5308ea$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $1aa483360b5308ea$export$8a4e224aafd3a2bf);
const $1aa483360b5308ea$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $1aa483360b5308ea$export$f3b215b0b382f63b = (payload)=>({
        type: $1aa483360b5308ea$export$11bcea24b35a126f,
        payload: payload
    });
const $1aa483360b5308ea$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $1aa483360b5308ea$export$8a4e224aafd3a2bf = (payload)=>({
        type: $1aa483360b5308ea$export$403065a1ff0b1663,
        payload: payload
    });

});


parcelRegister("dQXsh", function(module, exports) {
$parcel$export(module.exports, "querySet", () => $b6253b4ab52f02a6$export$46c38d4ac3e57dc5);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");
const $b6253b4ab52f02a6$export$46c38d4ac3e57dc5 = (action$, store)=>action$.ofType((0, $ksVok.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $hGeBN.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $7kixv.Observable).empty();
    });

});

parcelRegister("dwddz", function(module, exports) {
$parcel$export(module.exports, "retrieveComponents", () => $3043b7721e35d682$export$228e895d1b5c79dd);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("hfuHK");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $5Lnjk = parcelRequire("5Lnjk");


var $1jVSq = parcelRequire("1jVSq");

var $jv7JI = parcelRequire("jv7JI");

var $hGeBN = parcelRequire("hGeBN");

var $8gq4p = parcelRequire("8gq4p");

var $9stzB = parcelRequire("9stzB");

var $dw49z = parcelRequire("dw49z");
const $3043b7721e35d682$export$228e895d1b5c79dd = (action$, store)=>{
    const getComponentsRequestAction$ = action$.ofType((0, $1jVSq.GET_COMPONENTS_PAGE_REQUEST));
    return getComponentsRequestAction$.mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const page = payload.page;
        const projectKey = (0, $jv7JI.getProjectKey)(state);
        const startAt = (0, $dw49z.getStartAt)(state, page);
        const maxResults = (0, $dw49z.getMaxResults)(state);
        const orderBy = (0, $hGeBN.getOrderBy)(state);
        const filter = (0, $hGeBN.getFilter)(state);
        return (0, $7kixv.Observable).fromPromise((0, $5Lnjk.famaCatchAndLogFetchError)((0, $8gq4p.requestComponents)(projectKey, startAt, maxResults, orderBy, filter), (0, $e3510110549e2c61$export$b8b9d90f9e5bd72b), 'retrieveComponents', 'Error fetching components')).mergeMap((result)=>// @ts-expect-error - TS2769 - No overload matches this call.
            (0, $7kixv.Observable).of((0, $1jVSq.setComponentsPage)(result), (0, $9stzB.set)({
                message: ''
            }))).takeUntil(getComponentsRequestAction$).catch(()=>/*
				 * We are not logging the error here because it was already logged inside famaCatchAndLogFetchError call.
				 */ (0, $7kixv.Observable).of((0, $9stzB.set)({
                message: 'Error retrieving components'
            })));
    });
};

});
parcelRegister("5Lnjk", function(module, exports) {
$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $9688baba1b639fa7$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $9688baba1b639fa7$export$2e2bcd8739ae039);

var $lfZNE = parcelRequire("lfZNE");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");
const $9688baba1b639fa7$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $9688baba1b639fa7$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $14RSn.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $14RSn.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $9688baba1b639fa7$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData($9688baba1b639fa7$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $9688baba1b639fa7$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $9688baba1b639fa7$var$getStatusCodeGroup(error);
        (0, $lfZNE.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $9688baba1b639fa7$export$2e2bcd8739ae039 = $9688baba1b639fa7$var$catchAndLogFetchError;

});

const $e3510110549e2c61$export$b8b9d90f9e5bd72b = 'jiraProjectDirectoriesComponents';

parcelRegister("jv7JI", function(module, exports) {
$parcel$export(module.exports, "getProjectKey", () => $c37f3c936d75c0b3$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $c37f3c936d75c0b3$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectName", () => $c37f3c936d75c0b3$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjectType", () => $c37f3c936d75c0b3$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectDefaultAssignee", () => $c37f3c936d75c0b3$export$be28a82d4e8d697f);
$parcel$export(module.exports, "getProjectLead", () => $c37f3c936d75c0b3$export$478e7310480ee1ab);
$parcel$export(module.exports, "getProjectLeadName", () => $c37f3c936d75c0b3$export$c5b979a08b55628c);
$parcel$export(module.exports, "isComponentAdminContext", () => $c37f3c936d75c0b3$export$26a3de6cbed85df7);

var $dOwXt = parcelRequire("dOwXt");
const $c37f3c936d75c0b3$export$3988ae62b71be9a3 = (state)=>state.project;
const $c37f3c936d75c0b3$export$667f2a0f99c75faa = (state)=>state.project.key;
const $c37f3c936d75c0b3$export$89040d072f281f85 = (state)=>state.project.id;
const $c37f3c936d75c0b3$export$2cd058184eb75757 = (state)=>state.project.name;
const $c37f3c936d75c0b3$export$3dd0da95519c1a33 = (state)=>state.project.type;
const $c37f3c936d75c0b3$export$be28a82d4e8d697f = (state)=>state.project.defaultAssignee;
const $c37f3c936d75c0b3$export$478e7310480ee1ab = (state)=>state.project.lead;
const $c37f3c936d75c0b3$export$c5b979a08b55628c = (state)=>state.project.lead && state.project.lead.displayName;
const $c37f3c936d75c0b3$export$26a3de6cbed85df7 = ()=>{
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const pathname = (0, $dOwXt.default)() && (0, $dOwXt.default)().pathname || '';
    return pathname.endsWith && pathname.endsWith('/administer-components');
};

});

parcelRegister("8gq4p", function(module, exports) {
$parcel$export(module.exports, "requestComponents", () => $b65c4509d8363064$export$7ec8ef4a312fa6eb);
$parcel$export(module.exports, "getPrefetchedData", () => $b65c4509d8363064$export$191a95ab818c6ef2);
$parcel$export(module.exports, "requestComponent", () => $b65c4509d8363064$export$f20b154a1c4c6494);

var $k6LT0 = parcelRequire("k6LT0");

var $9hVFe = parcelRequire("9hVFe");

var $2xPWQ = parcelRequire("2xPWQ");

var $9R5ZS = parcelRequire("9R5ZS");

var $aOryt = parcelRequire("aOryt");

var $hmPg2 = parcelRequire("hmPg2");
const $b65c4509d8363064$export$519b99feca126399 = (projectKey, startAt, maxResults, orderBy, filter)=>{
    const encodedQuery = encodeURIComponent(filter);
    const componentSourceParam = '&componentSource=auto';
    return `/rest/api/2/project/${projectKey}/component?startAt=${startAt}&maxResults=${maxResults}&orderBy=${orderBy}&query=${encodedQuery}${componentSourceParam}`;
};
const $b65c4509d8363064$export$7ec8ef4a312fa6eb = async (projectKey, startAt = (0, $9hVFe.START_AT), maxResults = (0, $9hVFe.ITEMS_ON_PAGE), orderBy = (0, $9hVFe.ORDER), filter = (0, $9hVFe.FILTER))=>{
    const fullUrl = $b65c4509d8363064$export$519b99feca126399(projectKey, startAt, maxResults, orderBy, filter);
    const response = await fetch(fullUrl, (0, $2xPWQ.createOptions)('GET'));
    const json = await response.json();
    if (!response.ok) throw await (0, $k6LT0.getErrorFromResponse)(response, 'Failed to fetch');
    const { values: values, total: total } = json;
    return (0, $hmPg2.transformComponents)(values, total);
};
const $b65c4509d8363064$export$191a95ab818c6ef2 = (projectKey, query)=>{
    if (query) {
        const { orderDirection: orderDirection, orderField: orderField, filter: filter, page: page } = query;
        const orderBy = (0, $9R5ZS.mapToOrderFetch)(orderField, orderDirection);
        const maxResults = (0, $9hVFe.ITEMS_ON_PAGE);
        const startAt = (page - 1) * maxResults;
        return $b65c4509d8363064$export$7ec8ef4a312fa6eb(projectKey, startAt, maxResults, orderBy, filter);
    }
    return $b65c4509d8363064$export$7ec8ef4a312fa6eb(projectKey);
};
const $b65c4509d8363064$export$2756a9db83f319ac = (id)=>`/rest/api/2/component/${id}`;
const $b65c4509d8363064$export$f20b154a1c4c6494 = async (state, id)=>{
    const fullUrl = `${$b65c4509d8363064$export$2756a9db83f319ac(id)}`;
    const response = await fetch(fullUrl, (0, $2xPWQ.createOptions)('GET'));
    const json = await response.json();
    if (response.ok) return {
        id: id,
        component: (0, $hmPg2.transformComponentObj)(json)
    };
    throw (0, $aOryt.getErrorFromResultJson)(json, response.status);
};

});
parcelRegister("k6LT0", function(module, exports) {
$parcel$export(module.exports, "getErrorFromResponse", () => $79c4b7796896939e$export$7780d7826aafbede);

var $14RSn = parcelRequire("14RSn");

var $3ugTQ = parcelRequire("3ugTQ");
const $79c4b7796896939e$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $3ugTQ.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $14RSn.default)(response.status, errorMessage);
};

});

parcelRegister("9hVFe", function(module, exports) {
$parcel$export(module.exports, "ITEMS_ON_PAGE", () => $caa1e89c0fbdb99f$export$5364831c6b9eb7a3);
$parcel$export(module.exports, "PAGE", () => $caa1e89c0fbdb99f$export$d3d35020fa5b54f0);
$parcel$export(module.exports, "FILTER", () => $caa1e89c0fbdb99f$export$c1c49903035a02df);
$parcel$export(module.exports, "START_AT", () => $caa1e89c0fbdb99f$export$5a3b37e8556e32de);
$parcel$export(module.exports, "ORDER", () => $caa1e89c0fbdb99f$export$11e75bce9f7ea886);

var $2Jjb1 = parcelRequire("2Jjb1");
const $caa1e89c0fbdb99f$export$5364831c6b9eb7a3 = 25;
const $caa1e89c0fbdb99f$export$d3d35020fa5b54f0 = 1;
const $caa1e89c0fbdb99f$export$55c82710eb02082c = (0, $2Jjb1.NAME);
const $caa1e89c0fbdb99f$export$c1c49903035a02df = '';
const $caa1e89c0fbdb99f$export$5a3b37e8556e32de = 0;
const $caa1e89c0fbdb99f$export$11e75bce9f7ea886 = `+${(0, $2Jjb1.ORDER_FIELDS)[$caa1e89c0fbdb99f$export$55c82710eb02082c]}`;

});
parcelRegister("2Jjb1", function(module, exports) {
$parcel$export(module.exports, "NAME", () => $1f1ac4c9cec75841$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $1f1ac4c9cec75841$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $1f1ac4c9cec75841$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $1f1ac4c9cec75841$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELDS", () => $1f1ac4c9cec75841$export$e6d6c3d190bf100b);
const $1f1ac4c9cec75841$export$3c5e605ca7ade9f2 = 'NAME';
const $1f1ac4c9cec75841$export$d44826c816b5619b = 'DESCRIPTION';
const $1f1ac4c9cec75841$export$73dcda99369fd988 = 'LEAD';
const $1f1ac4c9cec75841$export$1c62ab608c48125c = 'ISSUES';
const $1f1ac4c9cec75841$export$e6d6c3d190bf100b = {
    [$1f1ac4c9cec75841$export$3c5e605ca7ade9f2]: 'name',
    [$1f1ac4c9cec75841$export$d44826c816b5619b]: 'description',
    [$1f1ac4c9cec75841$export$73dcda99369fd988]: 'lead',
    [$1f1ac4c9cec75841$export$1c62ab608c48125c]: 'issueCount'
};

});


parcelRegister("2xPWQ", function(module, exports) {
$parcel$export(module.exports, "createOptions", () => $fd212a9224b47ec2$export$830e3e7c910fe629);
const $fd212a9224b47ec2$export$830e3e7c910fe629 = (method, body)=>{
    const stringifiedBody = body ? JSON.stringify(body) : undefined;
    return {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        method: method,
        body: stringifiedBody
    };
};

});

parcelRegister("aOryt", function(module, exports) {
$parcel$export(module.exports, "ComponentValidationError", () => $9a911d379a297b74$export$2a0a959ca186c5a2);
$parcel$export(module.exports, "getErrorFromResultJson", () => $9a911d379a297b74$export$f94105122c76865e);

var $14RSn = parcelRequire("14RSn");
class $9a911d379a297b74$export$2a0a959ca186c5a2 extends Error {
    constructor(message, errors){
        super(message);
        this.errors = errors || {};
    }
}
const $9a911d379a297b74$export$f94105122c76865e = (resultJson, status)=>{
    const errors = resultJson.errors;
    if (errors && (errors.name || errors.componentLead)) return new $9a911d379a297b74$export$2a0a959ca186c5a2('', {
        name: resultJson.errors.name,
        componentLead: resultJson.errors.componentLead
    });
    const errorMessage = resultJson.errorMessages && resultJson.errorMessages[0];
    return new (0, $14RSn.default)(status, errorMessage);
};

});

parcelRegister("hmPg2", function(module, exports) {
$parcel$export(module.exports, "transformComponentObj", () => $a3ef206ce7c87278$export$f505eac0336ab290);
$parcel$export(module.exports, "transformComponents", () => $a3ef206ce7c87278$export$67cf173cea018455);
const $a3ef206ce7c87278$var$transformLead = (user)=>({
        displayName: user.displayName,
        key: user.key,
        active: user.active,
        accountId: user.accountId,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        // from PK - I could not see this code being used anywhere. Hence not updating to new url.
        profileUrl: `/jira/people/${user.accountId}`
    });
const $a3ef206ce7c87278$export$f505eac0336ab290 = (item)=>{
    const { name: name, description: description, assigneeType: assigneeType, lead: lead, componentBean: componentBean } = item;
    const { ari: ari, metadata: metadata } = componentBean ?? {};
    return {
        ari: ari,
        metadata: metadata,
        name: name,
        description: description,
        issueCount: item.issueCount ? item.issueCount : 0,
        defaultAssignee: assigneeType,
        lead: lead ? $a3ef206ce7c87278$var$transformLead(lead) : undefined
    };
};
const $a3ef206ce7c87278$export$79ccea7e11af4b35 = (item)=>({
        [item.id]: $a3ef206ce7c87278$export$f505eac0336ab290(item)
    });
const $a3ef206ce7c87278$export$67cf173cea018455 = (components, total)=>{
    const list = components.map((i)=>i.id);
    const listAri = components// Typesafe way to filter out undefined values.
    // Theoretically if global components are turned on, we will _only_ get back components with ARIs.
    // But to keep things happy with Typescript we need to handle undefined case as well.
    .flatMap(({ componentBean: componentBean })=>componentBean?.ari ? [
            componentBean?.ari
        ] : []);
    const byId = Object.assign({}, ...components.map((component)=>$a3ef206ce7c87278$export$79ccea7e11af4b35(component)));
    return {
        byId: byId,
        list: list,
        listAri: listAri,
        total: total
    };
};

});


parcelRegister("9stzB", function(module, exports) {
$parcel$export(module.exports, "SET", () => $12e0bce8acb7ca27$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $12e0bce8acb7ca27$export$adaa4cf7ef1b65be);
// set
const $12e0bce8acb7ca27$export$5e8f180ef0142226 = 'ui.error.SET';
const $12e0bce8acb7ca27$export$adaa4cf7ef1b65be = (payload)=>({
        type: $12e0bce8acb7ca27$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("9qzkY", function(module, exports) {
$parcel$export(module.exports, "initiateUpdateComponent", () => $b86e56a6b87524f9$export$a82c94a7a4ba9a48);
$parcel$export(module.exports, "updateComponent", () => $b86e56a6b87524f9$export$3d375ec46cfe3d13);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("hfuHK");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $aOryt = parcelRequire("aOryt");

var $hGeBN = parcelRequire("hGeBN");

var $8gq4p = parcelRequire("8gq4p");

var $7BAnu = parcelRequire("7BAnu");

var $86SzG = parcelRequire("86SzG");
const $b86e56a6b87524f9$export$a82c94a7a4ba9a48 = (action$, store)=>{
    const initiateUpdateComponent$ = action$.ofType((0, $1jVSq.INITIATE_UPDATE_COMPONENT));
    return initiateUpdateComponent$.mergeMap(()=>{
        const id = (0, $86SzG.getId)(store.getState());
        return (0, $7kixv.Observable).fromPromise((0, $8gq4p.requestComponent)(store.getState(), id)).mergeMap((result)=>(0, $7kixv.Observable).of((0, $1jVSq.initiateUpdateComponentSuccess)(result))).takeUntil(initiateUpdateComponent$).catch((e)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-components.state.epics.initate.update.component', e.message, e);
            return (0, $7kixv.Observable).of((0, $1jVSq.initiateUpdateComponentFail)({
                id: id,
                error: e
            }));
        });
    });
};
const $b86e56a6b87524f9$export$3d375ec46cfe3d13 = (action$, store)=>action$.ofType((0, $1jVSq.UPDATE_COMPONENT_REQUEST)).mergeMap(()=>(0, $7kixv.Observable).fromPromise((0, $7BAnu.updateComponent)(store.getState())).mergeMap(()=>(0, $7kixv.Observable).of((0, $1jVSq.updateComponentSuccess)({
                componentName: (0, $86SzG.getEditedComponentName)(store.getState())
            }), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $1jVSq.getComponentsPageRequest)({
                page: (0, $hGeBN.getCurrentPage)(store.getState()),
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).COMPONENT_UPDATED
            })))// @ts-expect-error - TS2345 - Argument of type '(error: ComponentRequestError) => Observable<UpdateComponentValidationFailAction> | Observable<UpdateComponentFailAction>' is not assignable to parameter of type '(err: any, caught: Observable<UpdateComponentSuccessAction>) => ObservableInput<UpdateComponentValidationFailAction>'.
        .catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-components.state.epics.update', error.message, error);
            if (error instanceof (0, $aOryt.ComponentValidationError)) return (0, $7kixv.Observable).of((0, $1jVSq.updateComponentValidationFail)(error));
            return (0, $7kixv.Observable).of((0, $1jVSq.updateComponentFail)(error));
        }));

});
parcelRegister("7BAnu", function(module, exports) {
$parcel$export(module.exports, "updateComponent", () => $ddd13d6b4aa5b30c$export$3d375ec46cfe3d13);

var $2xPWQ = parcelRequire("2xPWQ");

var $aOryt = parcelRequire("aOryt");

var $86SzG = parcelRequire("86SzG");

var $l94Bh = parcelRequire("l94Bh");
const $ddd13d6b4aa5b30c$export$d5777c038fb95c3f = (component)=>{
    if (!component) return {};
    const { name: name, lead: lead, defaultAssignee: defaultAssignee, description: description = '' } = component;
    return {
        name: name,
        description: description,
        assigneeType: defaultAssignee,
        leadAccountId: lead && lead.accountId || ''
    };
};
const $ddd13d6b4aa5b30c$export$3d375ec46cfe3d13 = async (state)=>{
    const componentId = (0, $86SzG.getId)(state);
    const component = (0, $86SzG.getEditedComponent)(state);
    const componentDataForRequest = $ddd13d6b4aa5b30c$export$d5777c038fb95c3f(component);
    const fullUrl = `${(0, $l94Bh.componentEndpointUrl)(componentId)}`;
    const result = await fetch(fullUrl, (0, $2xPWQ.createOptions)('PUT', componentDataForRequest));
    const resultJson = await result.json();
    if (result.ok) return component;
    throw (0, $aOryt.getErrorFromResultJson)(resultJson, result.status);
};

});
parcelRegister("86SzG", function(module, exports) {
$parcel$export(module.exports, "isInitialising", () => $54f312029cce6c80$export$afb304c64a235941);
$parcel$export(module.exports, "isEditing", () => $54f312029cce6c80$export$6ca2a662afed3e7f);
$parcel$export(module.exports, "saveIsInProgress", () => $54f312029cce6c80$export$6d46a811199c63f);
$parcel$export(module.exports, "getId", () => $54f312029cce6c80$export$218c8c3169c024d2);
$parcel$export(module.exports, "getEditedComponent", () => $54f312029cce6c80$export$6fc6dbafd8663a78);
$parcel$export(module.exports, "getEditedComponentName", () => $54f312029cce6c80$export$760bf67a250fa7f1);
$parcel$export(module.exports, "getNameErrorMessage", () => $54f312029cce6c80$export$6222164b63cc3ae9);
const $54f312029cce6c80$export$afb304c64a235941 = (state, id)=>state.ui.edit.initialiseInProgress && state.ui.edit.id === id;
const $54f312029cce6c80$export$6ca2a662afed3e7f = (state)=>!!state.ui.edit.id && !state.ui.edit.initialiseInProgress;
const $54f312029cce6c80$export$6d46a811199c63f = (state)=>state.ui.edit.saveIsInProgress;
const $54f312029cce6c80$export$218c8c3169c024d2 = (state)=>state.ui.edit.id || '';
const $54f312029cce6c80$export$6fc6dbafd8663a78 = (state)=>state.ui.edit.editedComponent;
const $54f312029cce6c80$export$760bf67a250fa7f1 = (state)=>state.ui.edit.editedComponent && state.ui.edit.editedComponent.name || '';
const $54f312029cce6c80$export$6222164b63cc3ae9 = (state)=>state.ui.edit.nameErrorMessage;
const $54f312029cce6c80$export$8802ac508ab8d49a = (state)=>state.ui.edit.leadErrorMessage;

});

parcelRegister("l94Bh", function(module, exports) {
$parcel$export(module.exports, "componentEndpointUrl", () => $948785493eae904c$export$e933405cdc2c0965);
const $948785493eae904c$export$e933405cdc2c0965 = (componentId)=>{
    const componentUrl = componentId ? `/${componentId}` : '';
    return `/rest/api/2/component${componentUrl}`;
};

});




parcelRegister("b4iNK", function(module, exports) {
$parcel$export(module.exports, "SET", () => $040c48c5c6ae491b$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $040c48c5c6ae491b$export$adaa4cf7ef1b65be);
const $040c48c5c6ae491b$export$5e8f180ef0142226 = 'analytics.SET';
const $040c48c5c6ae491b$export$adaa4cf7ef1b65be = (payload)=>({
        type: $040c48c5c6ae491b$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("b1PaM", function(module, exports) {
$parcel$export(module.exports, "SET", () => $4b0cf26cd6f96627$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $4b0cf26cd6f96627$export$adaa4cf7ef1b65be);
const $4b0cf26cd6f96627$export$5e8f180ef0142226 = 'context.SET';
const $4b0cf26cd6f96627$export$adaa4cf7ef1b65be = (payload)=>({
        type: $4b0cf26cd6f96627$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("32E87", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fadc1a0f381713d$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $8w5ze = parcelRequire("8w5ze");
const $7fadc1a0f381713d$var$createStore = (rootEpic, initialState, middlewares = [])=>(0, $gs6vs.default)({
        appName: 'Project components',
        rootReducer: $8w5ze.default,
        initialState: initialState,
        rootEpic: rootEpic,
        middlewares: middlewares
    });
var $7fadc1a0f381713d$export$2e2bcd8739ae039 = $7fadc1a0f381713d$var$createStore;

});
parcelRegister("8w5ze", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b5a70078aec7063$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $1ugir = parcelRequire("1ugir");

var $3owjv = parcelRequire("3owjv");

var $cz0JR = parcelRequire("cz0JR");

var $hI7Fg = parcelRequire("hI7Fg");

var $hrS6a = parcelRequire("hrS6a");

var $fm37p = parcelRequire("fm37p");
const $8b5a70078aec7063$var$combinedReducer = (0, $7HHI1.combineReducers)({
    components: $3owjv.default,
    project: $hI7Fg.default,
    ui: $fm37p.default,
    context: $cz0JR.default,
    analyticsData: $1ugir.default,
    query: $hrS6a.default
});
var $8b5a70078aec7063$export$2e2bcd8739ae039 = $8b5a70078aec7063$var$combinedReducer;

});
parcelRegister("1ugir", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4eee9f413e5b802$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $b4iNK = parcelRequire("b4iNK");
const $e4eee9f413e5b802$export$d4c72bab9d6cc13a = {
    projectType: ''
};
const $e4eee9f413e5b802$var$analyticsData = (state = $e4eee9f413e5b802$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $b4iNK.SET:
            return (0, $iWqim.freeze)(action.payload);
        default:
            return state;
    }
};
var $e4eee9f413e5b802$export$2e2bcd8739ae039 = $e4eee9f413e5b802$var$analyticsData;

});

parcelRegister("3owjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $591cb80136d63a5b$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $1jVSq = parcelRequire("1jVSq");
const $591cb80136d63a5b$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    byId: {},
    list: [],
    listAri: [],
    totalItems: 0
});
const $591cb80136d63a5b$var$components = (state = $591cb80136d63a5b$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $1jVSq.SET_COMPONENTS_PAGE:
            return (0, $iWqim.assign)(state, {
                byId: action.payload.byId,
                list: action.payload.list,
                listAri: action.payload.listAri,
                totalItems: action.payload.total
            });
        case 0, $1jVSq.PATCH_COMPONENT:
            {
                const componentId = action.payload.id;
                const originalComponent = (0, $iWqim.getIn)(state.byId, [
                    componentId
                ]);
                const patchedComponent = (0, $iWqim.assign)({}, originalComponent, action.payload.component);
                return (0, $iWqim.freeze)({
                    ...state,
                    byId: (0, $iWqim.assoc)(state.byId, componentId, patchedComponent)
                });
            }
        default:
            return state;
    }
};
var $591cb80136d63a5b$export$2e2bcd8739ae039 = $591cb80136d63a5b$var$components;

});

parcelRegister("cz0JR", function(module, exports) {
$parcel$export(module.exports, "default", () => $997f1a029468da0e$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $jbr6p = parcelRequire("jbr6p");

var $b1PaM = parcelRequire("b1PaM");
const $997f1a029468da0e$export$d4c72bab9d6cc13a = Object.freeze({
    isAdmin: false,
    locale: (0, $jbr6p.defaultLocale),
    onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $997f1a029468da0e$var$context = (state = $997f1a029468da0e$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $b1PaM.SET:
            return Object.freeze(action.payload);
        default:
            return state;
    }
};
var $997f1a029468da0e$export$2e2bcd8739ae039 = $997f1a029468da0e$var$context;

});

parcelRegister("hI7Fg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ccc94954e2aebc3$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $FhXEJ = parcelRequire("FhXEJ");

var $gFEBu = parcelRequire("gFEBu");
const $5ccc94954e2aebc3$export$d4c72bab9d6cc13a = {
    key: '',
    id: -1,
    name: '',
    type: (0, $FhXEJ.CORE_PROJECT)
};
const $5ccc94954e2aebc3$var$project = (state = $5ccc94954e2aebc3$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $gFEBu.SET:
            return (0, $iWqim.freeze)(action.payload);
        default:
            return state;
    }
};
var $5ccc94954e2aebc3$export$2e2bcd8739ae039 = $5ccc94954e2aebc3$var$project;

});
parcelRegister("gFEBu", function(module, exports) {
$parcel$export(module.exports, "SET", () => $3d923dc2eb4f0353$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $3d923dc2eb4f0353$export$adaa4cf7ef1b65be);
const $3d923dc2eb4f0353$export$5e8f180ef0142226 = 'project.SET';
const $3d923dc2eb4f0353$export$adaa4cf7ef1b65be = (payload)=>({
        type: $3d923dc2eb4f0353$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("hrS6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $71f1db55ccb6dc37$export$2e2bcd8739ae039);

var $3ewCx = parcelRequire("3ewCx");

var $ksVok = parcelRequire("ksVok");
const $71f1db55ccb6dc37$export$d4c72bab9d6cc13a = (0, $3ewCx.initialQuery);
const $71f1db55ccb6dc37$var$query = (state = $71f1db55ccb6dc37$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $ksVok.SET_QUERY:
            return action.payload;
        case 0, $ksVok.PATCH_QUERY:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $71f1db55ccb6dc37$export$2e2bcd8739ae039 = $71f1db55ccb6dc37$var$query;

});

parcelRegister("fm37p", function(module, exports) {
$parcel$export(module.exports, "default", () => $55c1c24a86c920ea$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $64PZZ = parcelRequire("64PZZ");

var $k6gXf = parcelRequire("k6gXf");

var $gHZQU = parcelRequire("gHZQU");

var $4kSRM = parcelRequire("4kSRM");

var $dRIYF = parcelRequire("dRIYF");
const $55c1c24a86c920ea$export$d4c72bab9d6cc13a = {
    add: (0, $64PZZ.initialState),
    edit: (0, $gHZQU.initialState),
    delete: (0, $k6gXf.initialState),
    error: (0, $4kSRM.initialState),
    page: (0, $dRIYF.initialState)
};
const $55c1c24a86c920ea$var$combinedReducer = (0, $7HHI1.combineReducers)({
    add: $64PZZ.default,
    edit: $gHZQU.default,
    delete: (0, $k6gXf.default),
    error: $4kSRM.default,
    page: $dRIYF.default
});
var $55c1c24a86c920ea$export$2e2bcd8739ae039 = $55c1c24a86c920ea$var$combinedReducer;

});
parcelRegister("64PZZ", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $0f66c2db17c7907a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $0f66c2db17c7907a$export$2e2bcd8739ae039);

var $1jVSq = parcelRequire("1jVSq");

var $gaIMx = parcelRequire("gaIMx");
const $0f66c2db17c7907a$export$d4c72bab9d6cc13a = {
    isOpen: false
};
const $0f66c2db17c7907a$var$add = (state = $0f66c2db17c7907a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $gaIMx.INITIATE:
            return {
                isOpen: true
            };
        case 0, $1jVSq.ADD_COMPONENT_SUCCESS:
        case 0, $gaIMx.CANCEL:
            return {
                isOpen: false
            };
        default:
            return state;
    }
};
var $0f66c2db17c7907a$export$2e2bcd8739ae039 = $0f66c2db17c7907a$var$add;

});
parcelRegister("gaIMx", function(module, exports) {
$parcel$export(module.exports, "INITIATE", () => $81afb621e76ec791$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $81afb621e76ec791$export$b14c4413e822aa8d);
$parcel$export(module.exports, "CANCEL", () => $81afb621e76ec791$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $81afb621e76ec791$export$70b61ad426ddbe54);
// initiate
const $81afb621e76ec791$export$643daa42aa3148d5 = 'ui.add.INITIATE';
const $81afb621e76ec791$export$b14c4413e822aa8d = ()=>({
        type: $81afb621e76ec791$export$643daa42aa3148d5
    });
const $81afb621e76ec791$export$2b10f4b30fb65583 = 'ui.add.CANCEL';
const $81afb621e76ec791$export$70b61ad426ddbe54 = ()=>({
        type: $81afb621e76ec791$export$2b10f4b30fb65583
    });

});


parcelRegister("k6gXf", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $f7f9f92ddb832f54$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $f7f9f92ddb832f54$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $jFHCE = parcelRequire("jFHCE");

var $3l9kN = parcelRequire("3l9kN");

var $1jVSq = parcelRequire("1jVSq");

var $3CaJv = parcelRequire("3CaJv");
const $f7f9f92ddb832f54$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    componentsBeingDeleted: [],
    spinner: {}
});
const $f7f9f92ddb832f54$var$deleteReducer = (state = $f7f9f92ddb832f54$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $3CaJv.DELETE_COMPONENT_STARTED:
            return (0, $iWqim.freeze)({
                ...state,
                spinner: {
                    ...state.spinner,
                    [action.payload.id]: true
                },
                componentsBeingDeleted: [
                    ...state.componentsBeingDeleted,
                    action.payload.id
                ]
            });
        case 0, $3CaJv.DELETE_COMPONENT_DIALOG_DISPLAYED:
            return (0, $iWqim.freeze)({
                ...state,
                spinner: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state.spinner, action.payload.id)
            });
        case 0, $1jVSq.DELETE_COMPONENT_FAILURE:
            {
                const componentsBeingDeleted = action.payload.isDialogOpen ? state.componentsBeingDeleted : (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(state.componentsBeingDeleted, action.payload.id);
                return (0, $iWqim.assign)(state, {
                    spinner: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state.spinner, action.payload.id),
                    componentsBeingDeleted: componentsBeingDeleted
                });
            }
        case 0, $3CaJv.DELETE_COMPONENT_CANCEL:
        case 0, $1jVSq.DELETE_COMPONENT_SUCCESS:
            return (0, $iWqim.freeze)({
                ...state,
                componentsBeingDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(state.componentsBeingDeleted, action.payload.id),
                spinner: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state.spinner, action.payload.id)
            });
        default:
            return state;
    }
};
var $f7f9f92ddb832f54$export$2e2bcd8739ae039 = $f7f9f92ddb832f54$var$deleteReducer;

});
parcelRegister("3l9kN", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $26ea92e191963c80$var$without = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, values) : [];
});
module.exports = $26ea92e191963c80$var$without;

});

parcelRegister("3CaJv", function(module, exports) {
$parcel$export(module.exports, "DELETE_COMPONENT_STARTED", () => $d7a66f63ca4576e9$export$1f324f2a5e0c1e6f);
$parcel$export(module.exports, "deleteComponentStarted", () => $d7a66f63ca4576e9$export$a37e7704966d1adf);
$parcel$export(module.exports, "DELETE_COMPONENT_DIALOG_DISPLAYED", () => $d7a66f63ca4576e9$export$9bfb374019bf36dd);
$parcel$export(module.exports, "deleteComponentDialogDisplayed", () => $d7a66f63ca4576e9$export$e3156991de922d9c);
$parcel$export(module.exports, "DELETE_COMPONENT_CANCEL", () => $d7a66f63ca4576e9$export$1aeaef53ac9bbd05);
$parcel$export(module.exports, "deleteComponentCancel", () => $d7a66f63ca4576e9$export$3a48db21ea62cc77);
const $d7a66f63ca4576e9$export$1f324f2a5e0c1e6f = 'ui.delete.DELETE_COMPONENT_STARTED';
const $d7a66f63ca4576e9$export$a37e7704966d1adf = (payload)=>({
        type: $d7a66f63ca4576e9$export$1f324f2a5e0c1e6f,
        payload: payload
    });
const $d7a66f63ca4576e9$export$9bfb374019bf36dd = 'ui.delete.DELETE_COMPONENT_DIALOG_DISPLAYED';
const $d7a66f63ca4576e9$export$e3156991de922d9c = (payload)=>({
        type: $d7a66f63ca4576e9$export$9bfb374019bf36dd,
        payload: payload
    });
const $d7a66f63ca4576e9$export$1aeaef53ac9bbd05 = 'ui.delete.DELETE_COMPONENT_CANCEL';
const $d7a66f63ca4576e9$export$3a48db21ea62cc77 = (payload)=>({
        type: $d7a66f63ca4576e9$export$1aeaef53ac9bbd05,
        payload: payload
    });

});


parcelRegister("gHZQU", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $0ac03ed87faddc2c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $0ac03ed87faddc2c$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $1jVSq = parcelRequire("1jVSq");

var $57k4O = parcelRequire("57k4O");
const $0ac03ed87faddc2c$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    saveIsInProgress: false,
    initialiseInProgress: false
});
const $0ac03ed87faddc2c$var$edit = (state = $0ac03ed87faddc2c$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $1jVSq.INITIATE_UPDATE_COMPONENT:
            return (0, $iWqim.freeze)({
                initialiseInProgress: true,
                id: action.payload.id,
                saveIsInProgress: false
            });
        case 0, $1jVSq.INITIATE_UPDATE_COMPONENT_SUCCESS:
            return (0, $iWqim.assign)(state, {
                initialiseInProgress: false,
                id: action.payload.id,
                editedComponent: action.payload.component,
                saveIsInProgress: false
            });
        case 0, $1jVSq.INITIATE_UPDATE_COMPONENT_FAIL:
            return (0, $iWqim.assign)(state, {
                initialiseInProgress: false,
                id: undefined,
                editedComponent: false,
                saveIsInProgress: false
            });
        case 0, $57k4O.UPDATE_EDITED_COMPONENT:
            return (0, $iWqim.assign)(state, {
                editedComponent: action.payload.component
            });
        case 0, $57k4O.CANCEL:
            return (0, $iWqim.assign)(state, {
                id: undefined,
                editedComponent: undefined,
                saveIsInProgress: false
            });
        case 0, $1jVSq.UPDATE_COMPONENT_REQUEST:
            return (0, $iWqim.assign)(state, {
                saveIsInProgress: true,
                nameErrorMessage: undefined,
                leadErrorMessage: undefined
            });
        case 0, $1jVSq.UPDATE_COMPONENT_SUCCESS:
            return (0, $iWqim.assign)(state, {
                saveIsInProgress: false,
                id: undefined,
                editedComponent: undefined
            });
        case 0, $1jVSq.UPDATE_COMPONENT_VALIDATION_FAIL:
            return (0, $iWqim.assign)(state, {
                nameErrorMessage: action.payload.errors.name,
                leadErrorMessage: action.payload.errors.componentLead,
                saveIsInProgress: false
            });
        case 0, $1jVSq.UPDATE_COMPONENT_FAIL:
            return (0, $iWqim.assign)(state, {
                saveIsInProgress: false
            });
        default:
            return state;
    }
};
var $0ac03ed87faddc2c$export$2e2bcd8739ae039 = $0ac03ed87faddc2c$var$edit;

});
parcelRegister("57k4O", function(module, exports) {
$parcel$export(module.exports, "UPDATE_EDITED_COMPONENT", () => $bf7064cedb443452$export$3e160f16eaac1ba0);
$parcel$export(module.exports, "updateEditedComponent", () => $bf7064cedb443452$export$5e01f454419fe080);
$parcel$export(module.exports, "CANCEL", () => $bf7064cedb443452$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $bf7064cedb443452$export$70b61ad426ddbe54);
const $bf7064cedb443452$export$3e160f16eaac1ba0 = 'ui.edit.UPDATE_EDITED_COMPONENT';
const $bf7064cedb443452$export$5e01f454419fe080 = (component)=>({
        type: $bf7064cedb443452$export$3e160f16eaac1ba0,
        payload: {
            component: component
        }
    });
const $bf7064cedb443452$export$2b10f4b30fb65583 = 'ui.edit.CANCEL';
const $bf7064cedb443452$export$70b61ad426ddbe54 = ()=>({
        type: $bf7064cedb443452$export$2b10f4b30fb65583
    });

});


parcelRegister("4kSRM", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $5b273690dad0431f$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $5b273690dad0431f$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $9stzB = parcelRequire("9stzB");
const $5b273690dad0431f$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    message: undefined
});
const $5b273690dad0431f$var$error = (state = $5b273690dad0431f$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9stzB.SET:
            return (0, $iWqim.freeze)({
                message: action.payload.message
            });
        default:
            return state;
    }
};
var $5b273690dad0431f$export$2e2bcd8739ae039 = $5b273690dad0431f$var$error;

});

parcelRegister("dRIYF", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $b357882ae866dc52$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $b357882ae866dc52$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $9hVFe = parcelRequire("9hVFe");

var $1jVSq = parcelRequire("1jVSq");

var $9stzB = parcelRequire("9stzB");
const $b357882ae866dc52$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    isLoading: false,
    itemsOnPage: (0, $9hVFe.ITEMS_ON_PAGE),
    currentPage: (0, $9hVFe.PAGE)
});
const $b357882ae866dc52$var$uiPageReducer = (state = $b357882ae866dc52$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $1jVSq.GET_COMPONENTS_PAGE_REQUEST:
            return (0, $iWqim.assign)(state, {
                isLoading: true,
                currentPage: action.payload.page
            });
        case 0, $9stzB.SET:
            return (0, $iWqim.assign)(state, {
                isLoading: false
            });
        case 0, $1jVSq.SET_COMPONENTS_PAGE:
            return (0, $iWqim.assign)(state, {
                isLoading: false
            });
        default:
            return state;
    }
};
var $b357882ae866dc52$export$2e2bcd8739ae039 = $b357882ae866dc52$var$uiPageReducer;

});




parcelRegister("alANc", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ba90a579d61ae7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cUVwW = parcelRequire("cUVwW");

var $e6HZJ = parcelRequire("e6HZJ");
const $47ba90a579d61ae7$var$containerStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.300'
});
class $47ba90a579d61ae7$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $47ba90a579d61ae7$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cUVwW.ContentWithGlobalComponentsProperty), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e6HZJ.default), null));
    }
}

});
parcelRegister("cUVwW", function(module, exports) {
$parcel$export(module.exports, "ContentWithGlobalComponentsProperty", () => $7c9b2f6299876f74$export$6822792b9dbc0ad0);

var $gnQAk = parcelRequire("gnQAk");

var $jhUy1 = parcelRequire("jhUy1");

var $1dBrd = parcelRequire("1dBrd");

var $1jVSq = parcelRequire("1jVSq");

var $a4ieE = parcelRequire("a4ieE");

var $jxax6 = parcelRequire("jxax6");

var $jv7JI = parcelRequire("jv7JI");

var $gaIMx = parcelRequire("gaIMx");

var $dw49z = parcelRequire("dw49z");

var $72B09 = parcelRequire("72B09");

var $2vgP4c = parcelRequire("2vgP4c");
const $7c9b2f6299876f74$var$mapStateToProps = (state)=>({
        status: (0, $72B09.getStatus)(state),
        editable: (0, $jxax6.isAdmin)(state),
        analyticsData: (0, $a4ieE.get)(state),
        projectKey: (0, $jv7JI.getProjectKey)(state),
        projectName: (0, $jv7JI.getProjectName)(state),
        projectType: (0, $jv7JI.getProjectType)(state),
        isAdminContext: (0, $jv7JI.isComponentAdminContext)(),
        // Toggles to `true` inherently when our `refreshComponents` function is
        // invoked. Resolves to `false` when asynchronous actions are finished.
        isLoading: (0, $dw49z.isLoading)(state)
    });
const $7c9b2f6299876f74$var$mapDispatchToProps = {
    onAddComponent: (0, $gaIMx.initiate)
};
const $7c9b2f6299876f74$var$mapDispatchToPropsGlobalComponentsProperty = (dispatch)=>({
        onAddComponent: ()=>{
            dispatch((0, $gaIMx.initiate)());
        },
        // Refresh cached components when toggling between Compass and Jira components..
        refreshComponents: ()=>{
            dispatch((0, $1jVSq.getComponentsPageRequest)({
                page: 0,
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).VIEW
            }));
        }
    });
var $7c9b2f6299876f74$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($7c9b2f6299876f74$var$mapStateToProps, $7c9b2f6299876f74$var$mapDispatchToProps)((0, $2vgP4c.default));
const $7c9b2f6299876f74$export$6822792b9dbc0ad0 = (0, $gnQAk.connect)($7c9b2f6299876f74$var$mapStateToProps, $7c9b2f6299876f74$var$mapDispatchToPropsGlobalComponentsProperty)((0, $1dBrd.withGlobalComponentsProperty)((0, $2vgP4c.default)));

});
parcelRegister("1dBrd", function(module, exports) {
$parcel$export(module.exports, "withGlobalComponentsProperty", () => $0afc2ccd6f75edde$export$8fb23a61064dd4a6);

var $eJOHy = parcelRequire("eJOHy");

var $iLdy3 = parcelRequire("iLdy3");

var $3vXi5 = parcelRequire("3vXi5");

var $2tP6n = parcelRequire("2tP6n");

var $5vQ2T = parcelRequire("5vQ2T");

var $cSXp8 = parcelRequire("cSXp8");

var $eS29z = parcelRequire("eS29z");

var $gFCH9 = parcelRequire("gFCH9");

var $cFukE = parcelRequire("cFukE");
const $0afc2ccd6f75edde$export$8fb23a61064dd4a6 = (WrappedComponent)=>(props)=>{
        const { projectKey: projectKey, refreshComponents: refreshComponents } = props;
        const { enabled: enabled, loading: loading, error: error, setProperty: setProperty } = (0, $3vXi5.useGlobalComponentsProperty)(projectKey);
        const { showFlag: showFlag } = (0, $cSXp8.useFlagService)();
        const provisionStatus = (0, $2tP6n.useCompassProvisionStatus)();
        const { startPollingBootstrapSyncStatus: startPollingBootstrapSyncStatus, stopPollingBootstrapSyncStatus: stopPollingBootstrapSyncStatus, isSyncInProgress: isSyncInProgress } = (0, $gFCH9.useGetBootstrapSyncStatus)();
        const { loading: permissionsLoading, hasCompassPermissions: hasCompassPermissions } = (0, $iLdy3.useGetCompassPermissions)();
        (0, $eJOHy.useEffect)(()=>{
            if (!loading && enabled === undefined && error) showFlag({
                type: 'error',
                title: (0, $cFukE.default).errorFetching,
                messageId: 'project-directories.components.common.services.with-global-components-property.show-flag.error.error-fetching',
                messageType: 'transactional'
            });
        }, [
            showFlag,
            loading,
            error,
            enabled
        ]);
        (0, $eJOHy.useEffect)(()=>{
            if (provisionStatus === 'error') showFlag({
                type: 'error',
                title: (0, $cFukE.default).errorProvisioning,
                messageId: 'project-directories.components.common.services.with-global-components-property.show-flag.error.error-provisioning',
                messageType: 'transactional'
            });
        }, [
            showFlag,
            provisionStatus
        ]);
        const toggleProperty = (0, $eJOHy.useCallback)((newValue)=>{
            setProperty(newValue).then(()=>{
                if (newValue) startPollingBootstrapSyncStatus();
                else stopPollingBootstrapSyncStatus();
                refreshComponents();
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $cFukE.default).errorToggling,
                    messageId: 'project-directories.components.common.services.with-global-components-property.show-flag.error.error-toggling',
                    messageType: 'transactional'
                });
            });
        }, [
            refreshComponents,
            setProperty,
            showFlag,
            startPollingBootstrapSyncStatus,
            stopPollingBootstrapSyncStatus
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !loading && provisionStatus !== 'loading' && provisionStatus !== 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
            attributes: {
                isCompassProvisioned: provisionStatus === 'provisioned',
                globalComponentsEnabled: enabled
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "compass-lodestone",
            id: "globalComponentsPropertyHOC",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            globalComponentsProperty: {
                enabled: enabled,
                hasCompassPermissions: hasCompassPermissions,
                loading: loading || isSyncInProgress || permissionsLoading,
                setProperty: toggleProperty
            }
        })));
    };

});
parcelRegister("iLdy3", function(module, exports) {
$parcel$export(module.exports, "useGetCompassPermissions", () => $fe91d454dfde250b$export$31f6fe789b504709);

var $eJOHy = parcelRequire("eJOHy");

var $fI7sV = parcelRequire("fI7sV");
function $fe91d454dfde250b$export$31f6fe789b504709() {
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [hasCompassPermissions, setHasCompassPermissions] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        (0, $fI7sV.getCompassPermissions)() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((result)=>{
            if (result.statusCode) setHasCompassPermissions(result.statusCode === 200);
            else setHasCompassPermissions(!!result.entitlements);
        }).catch((e)=>setError(e)).finally(()=>setLoading(false));
    }, []);
    return {
        loading: loading,
        hasCompassPermissions: hasCompassPermissions,
        error: error
    };
}

});
parcelRegister("fI7sV", function(module, exports) {
$parcel$export(module.exports, "getCompassPermissions", () => $6c7f2ab59517bf00$export$a60fbb9830f913a6);

var $3ugTQ = parcelRequire("3ugTQ");
const $6c7f2ab59517bf00$var$url = '/gateway/api/compass/v1/entitlements';
const $6c7f2ab59517bf00$export$a60fbb9830f913a6 = async ()=>{
    try {
        return await (0, $3ugTQ.performPostRequest)($6c7f2ab59517bf00$var$url, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entitlements: []
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403) return error;
        throw error;
    }
};

});


parcelRegister("3vXi5", function(module, exports) {
$parcel$export(module.exports, "useGlobalComponentsProperty", () => $508bf55092e05713$export$a070f388fcd93df0);

var $eJOHy = parcelRequire("eJOHy");

var $kxlQy = parcelRequire("kxlQy");

var $eJrcF = parcelRequire("eJrcF");

var $6zEUu = parcelRequire("6zEUu");

var $2aQVf = parcelRequire("2aQVf");
function $508bf55092e05713$export$a070f388fcd93df0(projectKey) {
    const { data: resourceData, loading: resourceLoading, error: resourceError, promise: resourcePromise } = (0, $eJrcF.useResource)((0, $6zEUu.projectGlobalComponentsResource));
    const [resourceAvailable] = (0, $eJOHy.useState)(Boolean(resourceData) || Boolean(resourcePromise) || Boolean(resourceError) || Boolean(resourceLoading));
    // If the resource is not available, fallback loading to true as per the old implementation
    const [loading, setLoading] = (0, $eJOHy.useState)(resourceAvailable ? resourceLoading : true);
    const [enabled, setEnabled] = (0, $eJOHy.useState)(resourceLoading === false ? resourceData?.value : undefined);
    const [error, setError] = (0, $eJOHy.useState)(resourceError instanceof Error ? resourceError : undefined);
    const loadGlobalComponentsProperty = (0, $eJOHy.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eJOHy.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (resourceLoading) resourcePromise?.then((d)=>resolveGlobalComponentsProperty(d?.value)).catch((e)=>resolveGlobalComponentsProperty(e));
        else if (!resourceAvailable) {
            // If resource does not exist, we need to load the property manually
            loadGlobalComponentsProperty();
            (0, $2aQVf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
        }
    }, [
        resourceLoading,
        resourcePromise,
        resolveGlobalComponentsProperty,
        loadGlobalComponentsProperty,
        projectKey,
        resourceAvailable
    ]);
    const setProperty = (0, $eJOHy.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $2aQVf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $kxlQy.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("kxlQy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6a23f038dd55eac$export$2e2bcd8739ae039);

var $gB3jQ = parcelRequire("gB3jQ");

var $2Ikeq = parcelRequire("2Ikeq");
var $b6a23f038dd55eac$export$2e2bcd8739ae039 = (0, $gB3jQ.default)((0, $2Ikeq.props));

});
parcelRegister("2Ikeq", function(module, exports) {
$parcel$export(module.exports, "props", () => $ac98d614b599dac0$export$8128bb6492cf3de7);

const $ac98d614b599dac0$var$MAX_RESULTS = 10;
const $ac98d614b599dac0$var$CACHE_SIZE = $ac98d614b599dac0$var$MAX_RESULTS * 2;
const $ac98d614b599dac0$var$COMPONENTS_CACHE_KEY = 'components';
const $ac98d614b599dac0$export$8128bb6492cf3de7 = {
    size: $ac98d614b599dac0$var$CACHE_SIZE,
    cacheKey: $ac98d614b599dac0$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)
};

});
const $08db7ac9f9f525e1$export$7271276960377470 = 'common-cache';
const $08db7ac9f9f525e1$export$a61768fefd33fcb1 = 'capacity exceeded';
const $08db7ac9f9f525e1$export$6c4d37c7f376a1de = 'clear';
const $08db7ac9f9f525e1$export$e271b26eefe41db8 = 'update';
const $08db7ac9f9f525e1$export$4bd2facc4a3e6aa1 = 'delete';
const $08db7ac9f9f525e1$export$26d12233004a7a60 = 'delete stale entry';
const $08db7ac9f9f525e1$export$1bb358554aac31c1 = 'get';
const $08db7ac9f9f525e1$export$61f74127e2b53cbe = 'hydrate';
const $08db7ac9f9f525e1$export$5e8f180ef0142226 = 'set';
const $08db7ac9f9f525e1$export$9eb68924983e00fb = 'get entries';
const $08db7ac9f9f525e1$export$bf340b99118a1511 = 'memory';
const $08db7ac9f9f525e1$export$2670cb7d5d4f7184 = 'local';
const $08db7ac9f9f525e1$export$b796061ff0c82e1a = 'session';



parcelRegister("2aQVf", function(module, exports) {
$parcel$export(module.exports, "getGlobalComponentsProperty", () => $36db035861e09445$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $36db035861e09445$export$71702a5b14caff65);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");
const $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $36db035861e09445$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $36db035861e09445$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $36db035861e09445$var$getProjectId = async (projectKey)=>{
    const project = await (0, $3ugTQ.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $36db035861e09445$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$36db035861e09445$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $36db035861e09445$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $36db035861e09445$var$url(projectId, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $36db035861e09445$var$url(projectKey, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $3ugTQ.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $36db035861e09445$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$36db035861e09445$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $36db035861e09445$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $36db035861e09445$var$url(projectId, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $36db035861e09445$var$url(projectKey, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $3ugTQ.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("2tP6n", function(module, exports) {
$parcel$export(module.exports, "hasCompassBeenProvisioned", () => $154623ef2e2d8b3c$export$f5f769750906cf9c);
$parcel$export(module.exports, "useCompassProvisionStatus", () => $154623ef2e2d8b3c$export$aa74b72c625075d2);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $eSnSE = parcelRequire("eSnSE");

var $3ugTQ = parcelRequire("3ugTQ");

var $cHtIB = parcelRequire("cHtIB");
const $154623ef2e2d8b3c$export$d76f7cdcb363ecda = 'compass';
const $154623ef2e2d8b3c$var$logErrorAndFireAnalytics = (errorMessage)=>{
    const { packageName: packageName, locationId: locationId, message: message, error: error } = errorMessage;
    (0, $eSnSE.default).safeErrorWithoutCustomerData(`${packageName}.${locationId}`, message, error);
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: locationId,
            packageName: packageName
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $154623ef2e2d8b3c$var$doOnError = (error)=>{
    $154623ef2e2d8b3c$var$logErrorAndFireAnalytics({
        packageName: 'jiraSoftwareCompassCrossFlowTouchPoint',
        locationId: 'services.license-information.has-compass-been-provisioned',
        message: 'Could not fetch license information.',
        error: error
    });
};
const $154623ef2e2d8b3c$var$getLicenseInformation = (cloudId)=>(0, $3ugTQ.performGetRequest)(`/gateway/api/xflow/${cloudId}/license-information`);
const $154623ef2e2d8b3c$export$f5f769750906cf9c = async (cloudId)=>{
    try {
        const data = await $154623ef2e2d8b3c$var$getLicenseInformation(cloudId);
        return data?.products?.[$154623ef2e2d8b3c$export$d76f7cdcb363ecda]?.state === 'ACTIVE';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        $154623ef2e2d8b3c$var$doOnError(err);
        throw err;
    }
};
const $154623ef2e2d8b3c$export$aa74b72c625075d2 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    (0, $eJOHy.useEffect)(()=>{
        const provisionedCheck = async ()=>{
            if (await $154623ef2e2d8b3c$export$f5f769750906cf9c(cloudId)) setStatus('provisioned');
            else setStatus('not-provisioned');
        };
        provisionedCheck().catch(()=>{
            setStatus('error');
        });
    }, [
        cloudId
    ]);
    return status;
};

});

parcelRegister("gFCH9", function(module, exports) {
$parcel$export(module.exports, "useGetBootstrapSyncStatus", () => $1d92f814e064f1bf$export$8810d87873b64f44);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $cd4tF = parcelRequire("cd4tF");
const $1d92f814e064f1bf$var$REQUEST_TIMEOUT = 2000;
const $1d92f814e064f1bf$var$bootstrapSyncUrl = '/rest/internal/1.0/component/sync/compass/status';
const $1d92f814e064f1bf$export$8810d87873b64f44 = (pollMax = 10)=>{
    const [error, setError] = (0, $eJOHy.useState)();
    const [bootstrapSyncStatus, setBootstrapSyncStatus] = (0, $eJOHy.useState)(undefined);
    const [isSyncInProgress, setIsSyncInProgress] = (0, $eJOHy.useState)(false);
    const timerRef = (0, $eJOHy.useRef)();
    const pollCount = (0, $eJOHy.useRef)(0);
    const resetRequest = (0, $eJOHy.useCallback)(()=>{
        setIsSyncInProgress(false);
        clearTimeout(timerRef.current);
        pollCount.current = 0;
    }, []);
    const handleError = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (err)=>{
        setError(err);
        resetRequest();
        setBootstrapSyncStatus((0, $cd4tF.requestStatus).ENDED);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'useGetBootstrapSyncStatus',
                packageName: 'jiraProjectDirectoriesComponents',
                teamName: 'compass-lodestone'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        resetRequest
    ]);
    const invokeRequest = (0, $eJOHy.useCallback)(async ()=>(0, $3ugTQ.performGetRequestWithRetry)($1d92f814e064f1bf$var$bootstrapSyncUrl, {
            retryAttempts: 3
        }), []);
    const startPollingBootstrapSyncStatus = (0, $eJOHy.useCallback)(()=>{
        const reinitiatePoll = (status)=>{
            if (!bootstrapSyncStatus || bootstrapSyncStatus !== (0, $cd4tF.requestStatus).COMPLETED || bootstrapSyncStatus !== (0, $cd4tF.requestStatus).ENDED) {
                setBootstrapSyncStatus(status);
                pollCount.current += 1;
                timerRef.current = setTimeout(startPollingBootstrapSyncStatus, $1d92f814e064f1bf$var$REQUEST_TIMEOUT);
            } else clearTimeout(timerRef.current);
        };
        setIsSyncInProgress(true);
        invokeRequest().then((data)=>{
            if (pollCount.current === pollMax) throw new Error('Polling attempts reached');
            // If Compass is not provisioned on a site, the sync status endpoint returns a 200 with no content.
            if (!data) {
                setBootstrapSyncStatus((0, $cd4tF.requestStatus).ENDED);
                resetRequest();
                return;
            }
            const { state: syncState } = data;
            switch(syncState){
                case (0, $cd4tF.requestStatus).COMPLETED:
                    setBootstrapSyncStatus((0, $cd4tF.requestStatus).COMPLETED);
                    resetRequest();
                    break;
                case (0, $cd4tF.requestStatus).IN_PROGESS:
                    reinitiatePoll((0, $cd4tF.requestStatus).IN_PROGESS);
                    break;
                case (0, $cd4tF.requestStatus).NOT_INITIATED:
                    reinitiatePoll((0, $cd4tF.requestStatus).NOT_INITIATED);
                    break;
                default:
                    setBootstrapSyncStatus((0, $cd4tF.requestStatus).ENDED);
                    resetRequest();
                    break;
            }
        }).catch((err)=>{
            handleError(err);
        });
    }, [
        invokeRequest,
        bootstrapSyncStatus,
        pollMax,
        resetRequest,
        handleError
    ]);
    const stopPollingBootstrapSyncStatus = (0, $eJOHy.useCallback)(()=>{
        setBootstrapSyncStatus((0, $cd4tF.requestStatus).ENDED);
        resetRequest();
    }, [
        resetRequest
    ]);
    return {
        error: error,
        isSyncInProgress: isSyncInProgress,
        bootstrapSyncStatus: bootstrapSyncStatus,
        startPollingBootstrapSyncStatus: startPollingBootstrapSyncStatus,
        stopPollingBootstrapSyncStatus: stopPollingBootstrapSyncStatus
    };
};

});
parcelRegister("cd4tF", function(module, exports) {
$parcel$export(module.exports, "requestStatus", () => $68f3795ed013d2f0$export$b623c9d52fb562b0);
const $68f3795ed013d2f0$export$b623c9d52fb562b0 = {
    ENDED: 'ENDED',
    COMPLETED: 'COMPLETED',
    IN_PROGESS: 'IN_PROGRESS',
    NOT_INITIATED: 'NOT_INITIATED'
};

});


parcelRegister("cFukE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5412364ddae0d57$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d5412364ddae0d57$var$messages = (0, $7qGN1.defineMessages)({
    errorToggling: {
        "id": "project-directories.components.common.services.with-global-components-property.error-toggling",
        "defaultMessage": "Error updating Global Components Property"
    },
    errorFetching: {
        "id": "project-directories.components.common.services.with-global-components-property.error-fetching",
        "defaultMessage": "Error fetching Global Components Property"
    },
    errorProvisioning: {
        "id": "project-directories.components.common.services.with-global-components-property.error-provisioning",
        "defaultMessage": "Error fetching Compass provisioning state"
    }
});
var $d5412364ddae0d57$export$2e2bcd8739ae039 = $d5412364ddae0d57$var$messages;

});


parcelRegister("a4ieE", function(module, exports) {
$parcel$export(module.exports, "get", () => $e68d9a3680f2d454$export$3988ae62b71be9a3);
const $e68d9a3680f2d454$export$3988ae62b71be9a3 = (state)=>state.analyticsData;

});

parcelRegister("jxax6", function(module, exports) {
$parcel$export(module.exports, "isAdmin", () => $24a17ef08335b553$export$fc970ed23da99565);
$parcel$export(module.exports, "getLocale", () => $24a17ef08335b553$export$180605366c04f0cd);
const $24a17ef08335b553$export$fc970ed23da99565 = (state)=>state.context.isAdmin;
const $24a17ef08335b553$export$180605366c04f0cd = (state)=>state.context.locale;

});

parcelRegister("72B09", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $fbe19424e0fac03d$export$b70265791d2079d4);

var $7Z0qA = parcelRequire("7Z0qA");

var $hGeBN = parcelRequire("hGeBN");

var $8OWK3 = parcelRequire("8OWK3");

var $dw49z = parcelRequire("dw49z");
const $fbe19424e0fac03d$export$b70265791d2079d4 = (state)=>{
    if ((0, $8OWK3.getError)(state).message) return 'error';
    if ((0, $dw49z.isLoading)(state)) return 'has-components';
    const isFilterEmpty = (0, $hGeBN.getFilter)(state) === '';
    return (0, $7Z0qA.isEmpty)(state) && isFilterEmpty ? 'empty' : 'has-components';
};

});
parcelRegister("8OWK3", function(module, exports) {
$parcel$export(module.exports, "getError", () => $8b85b79c2feee9fd$export$e1599abf47b5b568);
const $8b85b79c2feee9fd$export$e1599abf47b5b568 = (state)=>state.ui.error;

});


parcelRegister("2vgP4c", function(module, exports) {
$parcel$export(module.exports, "default", () => $68052da357e3e241$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $48q59 = parcelRequire("48q59");

var $78OnL = parcelRequire("78OnL");

var $7pw1V = parcelRequire("7pw1V");

var $4cTDP = parcelRequire("4cTDP");

var $7tL08 = parcelRequire("7tL08");

var $lRq8t = parcelRequire("lRq8t");

var $86yAi = parcelRequire("86yAi");

var $kIrp0 = parcelRequire("kIrp0");

var $bZtXA = parcelRequire("bZtXA");

var $eIUgN = parcelRequire("eIUgN");

var $kD45J = parcelRequire("kD45J");

var $hccdg = parcelRequire("hccdg");

var $gswYm = parcelRequire("gswYm");

var $euomL = parcelRequire("euomL");

var $eVOc4 = parcelRequire("eVOc4");

var $es0nj = parcelRequire("es0nj");

var $g4HMN = parcelRequire("g4HMN");

var $dkXAu = parcelRequire("dkXAu");

var $5y4x3 = parcelRequire("5y4x3");

var $f3RSN = parcelRequire("f3RSN");
function $68052da357e3e241$var$AppViewNew(props) {
    const { onAddComponent: onAddComponent, status: status, editable: editable, projectKey: projectKey, projectType: projectType, isLoading: isLoading, globalComponentsProperty: globalComponentsProperty = {
        loading: false,
        enabled: false,
        hasCompassPermissions: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setProperty: ()=>{}
    } } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isProjectTypeJsw = projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
    let content = null;
    let searchBar = null;
    let createComponentButton = null;
    const isHideGlobalComponentsInIsolatedCloud = (0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('jira_fe_hide_components_list');
    const toggleButton = isProjectTypeJsw && !(0, $7pw1V.isFedrampModerate)() && !isHideGlobalComponentsInIsolatedCloud ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eVOc4.WrappedGlobalComponentsToggleButton), {
        globalComponentsProperty: {
            loading: globalComponentsProperty.loading,
            enabled: globalComponentsProperty.enabled,
            setProperty: globalComponentsProperty.setProperty
        },
        isEditable: editable
    }) : null;
    let actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, toggleButton);
    const statusWithLoading = isLoading || globalComponentsProperty.loading ? 'loading' : status;
    switch(statusWithLoading){
        case 'loading':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $es0nj.LoadingState), null);
            break;
        case 'empty':
            if (!(0, $7pw1V.isFedrampModerate)() && !isHideGlobalComponentsInIsolatedCloud && globalComponentsProperty.enabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86yAi.CompassEmptyState), {
                projectKey: projectKey
            });
            else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hccdg.default), {
                projectType: projectType
            });
            break;
        case 'has-components':
            if (editable) createComponentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kD45J.default), {
                testId: "project-directories.components.content.create-component-button",
                loading: globalComponentsProperty.loading,
                globalComponentsEnabled: globalComponentsProperty.enabled,
                oldOnAddComponent: onAddComponent,
                projectKey: projectKey
            });
            // check if a user has access to compass, if not show request access state
            if (!(0, $7pw1V.isFedrampModerate)() && !isHideGlobalComponentsInIsolatedCloud && globalComponentsProperty.enabled) {
                if (!globalComponentsProperty.hasCompassPermissions) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIUgN.RequestAccessState), null);
                else // FF on - Compass components
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZtXA.default), {
                    testId: "project-directories.components.content.compass-components-table",
                    projectKey: projectKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g4HMN.default), null));
            } else {
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dkXAu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g4HMN.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kIrp0.CompassTableCrossflowTouchPointWithEC), null));
                searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euomL.default), {
                    ariaLabel: formatMessage((0, $f3RSN.messages).filterInputLabel)
                });
            }
            actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, toggleButton, createComponentButton);
            break;
        case 'error':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gswYm.default), null);
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "project-directories.components.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tL08.PageTopBar), {
        actions: actions,
        bottomBar: isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5y4x3.HeaderBottombarContent), {
            isGlobalComponentsEnabled: globalComponentsProperty.enabled,
            searchBar: searchBar,
            formatMessage: formatMessage
        })) : searchBar
    }), content);
}
const $68052da357e3e241$var$AppView = $68052da357e3e241$var$AppViewNew;
var $68052da357e3e241$export$2e2bcd8739ae039 = $68052da357e3e241$var$AppView;

});
parcelRegister("7tL08", function(module, exports) {
$parcel$export(module.exports, "PageTopBar", () => $1fc13d53be5e9467$export$7e5801dc91bf1819);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

const $1fc13d53be5e9467$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: (0, $9fdce687ce348642$export$90c4434a1e138106),
        xcss: [
            $1fc13d53be5e9467$var$wrapperStyles,
            wrapAtMd ? $1fc13d53be5e9467$var$wrapAtMdStyle : $1fc13d53be5e9467$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: (0, $9fdce687ce348642$export$1742330ac6a668f0),
        xcss: [
            $1fc13d53be5e9467$var$actionsBoxStyles,
            wrapAtMd && $1fc13d53be5e9467$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $1fc13d53be5e9467$export$7e5801dc91bf1819 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fc13d53be5e9467$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    });
const $1fc13d53be5e9467$var$noWrapStyle = (0, $1DXK0.xcss)({
    flexWrap: 'nowrap'
});
const $1fc13d53be5e9467$var$wrapAtMdStyle = (0, $1DXK0.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $6efFi.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $1fc13d53be5e9467$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $6efFi.media).above.md]: {
        gap: 'space.300'
    }
});
const $1fc13d53be5e9467$var$actionsBoxAtMdStyles = (0, $1DXK0.xcss)({
    flex: '1 1 auto',
    [(0, $6efFi.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $1fc13d53be5e9467$var$actionsBoxStyles = (0, $1DXK0.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $9fdce687ce348642$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $9fdce687ce348642$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("86yAi", function(module, exports) {
$parcel$export(module.exports, "CompassEmptyState", () => $0f9c26b524c03700$export$c3891d38ba06b32e);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $5vQ2T = parcelRequire("5vQ2T");

var $1Ru5V = parcelRequire("1Ru5V");

var $fvOeu = parcelRequire("fvOeu");

var $es0nj = parcelRequire("es0nj");

var $6McP5 = parcelRequire("6McP5");

var $5gw8l = parcelRequire("5gw8l");
const $0f9c26b524c03700$var$TEST_ID = 'project-directories.components.compass-empty-state.empty';
const $0f9c26b524c03700$export$c3891d38ba06b32e = ({ projectKey: projectKey })=>{
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const [crossFlowComplete, setCrossFlowComplete] = (0, $eJOHy.useState)(false);
    let componentsTableEmptyState;
    const { count: count, loading: loading, error: error } = (0, $fvOeu.useCountCompassComponents)({
        skip: !(licensedProducts && licensedProducts.compass || crossFlowComplete)
    });
    // Render empty state if tenant has Compass, OR
    // We've completed cross flow. Licensed products won't be updated until page reload.
    if (licensedProducts && licensedProducts.compass || crossFlowComplete) {
        if (loading) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $es0nj.LoadingState), null);
        else if (error) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gw8l.ComponentsTableEmptyState), {
            testId: $0f9c26b524c03700$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            displayMode: "unknown"
        });
        else if (!count) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gw8l.ComponentsTableEmptyState), {
            testId: $0f9c26b524c03700$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            displayMode: "no-components"
        });
        else componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gw8l.ComponentsTableEmptyState), {
            testId: $0f9c26b524c03700$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            componentCount: count,
            displayMode: "no-linked-components"
        });
    } else componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6McP5.default), {
        origin: "project-pages.project-directories.components.view.empty",
        onCrossFlowComplete: ()=>setCrossFlowComplete(true)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "compassEmptyState",
        sendToPrivacyUnsafeSplunk: true
    }, componentsTableEmptyState);
};

});
parcelRegister("fvOeu", function(module, exports) {
$parcel$export(module.exports, "useCountCompassComponents", () => $4043a203b89fb29f$export$31d633df2827a840);

var $hA0fK = parcelRequire("hA0fK");

var $cHtIB = parcelRequire("cHtIB");

var $gbqxf = parcelRequire("gbqxf");
const $4043a203b89fb29f$export$31d633df2827a840 = (props)=>{
    const { skip: skip = false } = props ?? {};
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: data, loading: loading, error: error } = (0, $hA0fK.useFetchQuery)((0, $gbqxf.COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY), {
        cloudId: cloudId,
        query: {
            fieldFilters: [
                {
                    name: 'state',
                    filter: {
                        in: [
                            'ACTIVE'
                        ]
                    }
                }
            ],
            sort: []
        }
    }, {
        fetchPolicy: 'network-only',
        skip: skip
    });
    const count = data?.compass?.searchComponents?.__typename === 'CompassSearchComponentConnection' ? data?.compass?.searchComponents?.totalCount : null;
    return {
        count: count,
        loading: loading,
        error: error
    };
};

});
parcelRegister("hA0fK", function(module, exports) {
$parcel$export(module.exports, "useFetchQuery", () => $d0273eb92254771c$export$e0fe68859e28ee42);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");
// sounced from https://github.com/apollographql/apollo-client/blob/main/src/react/hooks/utils/useDeepMemo.ts
const $d0273eb92254771c$var$useDeepMemo = (memoFn, key)=>{
    const ref = (0, $eJOHy.useRef)();
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return ref.current.value;
};
const $d0273eb92254771c$export$e0fe68859e28ee42 = (query, vars, opts)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const [result, setResult] = (0, $eJOHy.useState)({
        data: null,
        error: null,
        loading: true
    });
    const { data: data, error: error, loading: loading } = result;
    const prevVariables = (0, $eJOHy.useRef)();
    const fetch = (variables, options)=>{
        const { fetchPolicy: fetchPolicy = 'network-only', skip: skip = false } = options || {};
        if (skip || (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevVariables.current, variables)) return;
        prevVariables.current = variables;
        // Don't trigger re-render if it's intial render
        if (!(loading === true && data == null && error === null)) setResult({
            error: null,
            loading: true,
            data: null
        });
        (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy
        }).toPromise().then((d)=>{
            setResult({
                error: null,
                loading: false,
                // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'null'.
                data: d
            });
        }).catch((e)=>{
            setResult({
                data: null,
                loading: false,
                error: e
            });
        });
    };
    const memo = {
        vars: vars,
        opts: opts
    };
    $d0273eb92254771c$var$useDeepMemo(()=>{
        fetch(vars, opts);
    }, memo);
    const nullableData = data == null ? null : data;
    return {
        data: nullableData,
        error: error,
        loading: loading
    };
};

});

parcelRegister("gbqxf", function(module, exports) {
$parcel$export(module.exports, "COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY", () => $6cbeacf64723fffc$export$e0e019aad11e83aa);

var $j44Zl = parcelRequire("j44Zl");
const $6cbeacf64723fffc$export$e0e019aad11e83aa = (0, $j44Zl.default);

});
parcelRegister("j44Zl", function(module, exports) {
$parcel$export(module.exports, "default", () => $632a1084fefab3df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35c66d1fe3da80e6066fb994a448a5b8>>
 * @relayHash 889293ef5047c9583bb7e73bf9000cdd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425
const $632a1084fefab3df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "concreteType": "CompassCatalogQueryApi",
            "kind": "LinkedField",
            "name": "compass",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "searchComponents",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ],
                            "type": "CompassSearchComponentConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlCountCompassComponentsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlCountCompassComponentsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425",
            "metadata": {},
            "name": "gqlCountCompassComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$632a1084fefab3df$var$node.hash = "db6ce5954b3b32b77dc71734e9b9557b";
var $632a1084fefab3df$export$2e2bcd8739ae039 = $632a1084fefab3df$var$node;

});



parcelRegister("es0nj", function(module, exports) {
$parcel$export(module.exports, "LoadingState", () => $75ae9d6826f816be$export$62aa48085237e36f);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $7ep4S = parcelRequire("7ep4S");
function $75ae9d6826f816be$export$62aa48085237e36f() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        testId: "project-directories.components.content.components-spinner"
    }));
}

});

parcelRegister("6McP5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3966793d8b76a07e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fgNzi = parcelRequire("fgNzi");

var $emaA9 = parcelRequire("emaA9");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3966793d8b76a07e$var$CrossFlowTouchPointWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});
class $3966793d8b76a07e$var$CompassCrossFlow extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            isCompassLicensed: false
        };
    }
    render() {
        const { isCompassLicensed: isCompassLicensed, origin: origin, onCrossFlowComplete: onCrossFlowComplete } = this.props;
        return !isCompassLicensed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emaA9.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3966793d8b76a07e$var$CrossFlowTouchPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgNzi.default), {
            origin: origin,
            eventSource: "jiraComponentsSection",
            onCrossFlowComplete: onCrossFlowComplete
        })));
    }
}
var $3966793d8b76a07e$export$2e2bcd8739ae039 = $3966793d8b76a07e$var$CompassCrossFlow;

});
parcelRegister("fgNzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $98801b38dd9ca402$export$2e2bcd8739ae039);

var $91dLC = parcelRequire("91dLC");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6X7AJ = parcelRequire("6X7AJ");
var $dNnxZ = parcelRequire("dNnxZ");

var $j4oe4 = parcelRequire("j4oe4");

var $9pTd3 = parcelRequire("9pTd3");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $lgMTT = parcelRequire("lgMTT");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");

var $6qaBj = parcelRequire("6qaBj");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $kRgKj = parcelRequire("kRgKj");

var $koAZ4 = parcelRequire("koAZ4");

var $1Yvty = parcelRequire("1Yvty");

var $kyq27 = parcelRequire("kyq27");

var $3osLr = parcelRequire("3osLr");

var $2aY2d = parcelRequire("2aY2d");

var $cx7jd = parcelRequire("cx7jd");


var $2tP6n = parcelRequire("2tP6n");

var $kp0YA = parcelRequire("kp0YA");

var $gVpyx = parcelRequire("gVpyx");

var $3GlBZ = parcelRequire("3GlBZ");
const $98801b38dd9ca402$var$gridStyles = {
    root: "_yv0e11cg"
};
const $98801b38dd9ca402$var$NewCrossFlowTouchPoint = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { enabled: enabled, onTry: onTry, onLearnMore: onLearnMore } = props;
    if (enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98801b38dd9ca402$var$ContentWrapper, {
        "data-testid": "compass-cross-flow.ui.empty-state-not-provisioned"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.CompassLogo), {
        appearance: "brand",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98801b38dd9ca402$var$TouchPointMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "large",
        as: "h2"
    }, formatMessage((0, $3GlBZ.default).headLine))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98801b38dd9ca402$var$TouchPointMessageDescriptionWrapper, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $3GlBZ.default).callToActionIssueTermRefresh : (0, $3GlBZ.default).callToAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: onTry
    }, formatMessage((0, $3GlBZ.default).engageMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        onClick: onLearnMore,
        href: (0, $cd0ffcaa21ba8fff$export$ae684c7694b92c83),
        target: "_blank"
    }, formatMessage((0, $3GlBZ.default).learnMoreMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cx7jd.CrossflowImage), null));
    return null;
};
/**
 * Basic crossflow touch point that shows a static message and a button to try Compass.
 */ const $98801b38dd9ca402$var$DefaultCrossFlowTouchPoint = (props)=>{
    const { origin: origin, eventSource: eventSource, onCrossFlowComplete: onCrossFlowComplete } = props;
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const { fireInteractedUIEvent: fireInteractedUIEvent, fireViewedUIEvent: fireViewedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!crossFlow.isEnabled) (0, $9pTd3.fireErrorAnalytics)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraCompassCrossFlow'
            }
        });
        else fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'tryCompassBanner'
        }, {
            recommendedProductIds: [
                (0, $dNnxZ.Targets).COMPASS
            ],
            source: eventSource
        });
    }, [
        crossFlow,
        eventSource,
        fireViewedUIEvent
    ]);
    const onTry = (0, $eJOHy.useCallback)(async (_, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryCompassButton'
        }, {
            targetProductId: (0, $dNnxZ.Targets).COMPASS,
            recommendedProductIds: [
                (0, $dNnxZ.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointTry');
        if (crossFlow.isEnabled) {
            // eslint-disable-next-line @atlassian/growth/no-deprecated-apis
            await crossFlow.api.open({
                journey: (0, $6X7AJ.Journeys).GET_STARTED,
                targetProduct: (0, $dNnxZ.Targets).COMPASS,
                sourceComponent: 'jira-compass-cross-flow-try',
                sourceContext: 'jira'
            }); // Refresh the Compass Crossflow Touchpoint once Compass is provisioned
            const result = await (0, $2tP6n.hasCompassBeenProvisioned)(cloudId);
            if (result) {
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandComplete', {
                    hasCompassProvisioned: result,
                    origin: origin
                });
                onCrossFlowComplete?.();
            } else (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandIncomplete', {
                hasCompassProvisioned: result,
                origin: origin
            });
        }
    }, [
        cloudId,
        crossFlow,
        origin,
        fireInteractedUIEvent,
        onCrossFlowComplete
    ]);
    const onLearnMore = (0, $eJOHy.useCallback)(async (event, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMoreCompassButton'
        }, {
            targetProductId: (0, $dNnxZ.Targets).COMPASS,
            recommendedProductIds: [
                (0, $dNnxZ.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointLearnMore');
    }, [
        fireInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        teamName: "compass-lodestone",
        id: "crossFlowTouchPoint",
        packageName: "jiraCompassCrossFlowTouchPoint",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "jiraCompassCrossFlowTouchPoint"
    }), $98801b38dd9ca402$var$NewCrossFlowTouchPoint({
        enabled: crossFlow.isEnabled,
        onTry: onTry,
        onLearnMore: onLearnMore
    }));
};
/**
 * This crossflow touch point advertises Compass capabilities using repository data associated with current Jira project pulled from Team Work Graph.
 */ const $98801b38dd9ca402$var$AutoCatalogViaTeamWorkGraphCrossFlowTouchPoint = (props)=>{
    const { origin: origin, eventSource: eventSource, onCrossFlowComplete: onCrossFlowComplete } = props;
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const { fireInteractedUIEvent: fireInteractedUIEvent, fireViewedUIEvent: fireViewedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const isStagingOrDev = (0, $kyq27.useIsStagingOrDevOrLocal)();
    const providerId = isStagingOrDev ? 'com.github.integration.staging' : 'com.github.integration.production';
    const projectContext = (0, $2aY2d.useProjectContext)();
    const projectId = projectContext.data?.projectId;
    if (!projectId) throw new Error('Provisioning did not return projectId');
    const jiraProjectAri = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId.toString()
    }).toString();
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $91dLC.default), {
        projectId: jiraProjectAri,
        first: 20
    });
    const repositories = data?.graphStore?.projectAssociatedRepo?.edges?.map((edge)=>edge?.node)?.filter((repo)=>repo?.__typename === 'DevOpsRepository') || [];
    const filteredRepositories = providerId ? repositories.filter((repo)=>repo?.__typename === 'DevOpsRepository' && repo?.providerId === providerId && repo?.name !== null) : repositories;
    (0, $eJOHy.useEffect)(()=>{
        if (!crossFlow.isEnabled) (0, $9pTd3.fireErrorAnalytics)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraCompassCrossFlow'
            }
        });
        else fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'tryCompassBanner'
        }, {
            recommendedProductIds: [
                (0, $dNnxZ.Targets).COMPASS
            ],
            source: eventSource
        }, {
            autoCatalogingViaTwg: true
        });
    }, [
        crossFlow,
        eventSource,
        fireViewedUIEvent
    ]);
    const onTry = (0, $eJOHy.useCallback)(async (_, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryCompassButton'
        }, {
            targetProductId: (0, $dNnxZ.Targets).COMPASS,
            recommendedProductIds: [
                (0, $dNnxZ.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        }, {
            autoCatalogingViaTwg: true
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointTry');
        if (crossFlow.isEnabled) {
            // eslint-disable-next-line @atlassian/growth/no-deprecated-apis
            await crossFlow.api.open({
                journey: (0, $6X7AJ.Journeys).GET_STARTED,
                targetProduct: (0, $dNnxZ.Targets).COMPASS,
                sourceComponent: 'jira-compass-cross-flow-try',
                sourceContext: 'jira',
                extraAnalyticsAttributes: {
                    autoCatalogingViaTwg: true
                }
            }); // Refresh the Compass Crossflow Touchpoint once Compass is provisioned
            const result = await (0, $2tP6n.hasCompassBeenProvisioned)(cloudId);
            if (result) {
                (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandComplete', {
                    hasCompassProvisioned: result,
                    origin: origin,
                    autoCatalogingViaTwg: true
                });
                onCrossFlowComplete?.();
            } else (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandIncomplete', {
                hasCompassProvisioned: result,
                origin: origin,
                autoCatalogingViaTwg: true
            });
        }
    }, [
        cloudId,
        crossFlow,
        origin,
        fireInteractedUIEvent,
        onCrossFlowComplete
    ]);
    if (filteredRepositories.length <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98801b38dd9ca402$var$DefaultCrossFlowTouchPoint, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        testId: "compass-cross-flow.ui.new-empty-state-not-provisioned",
        paddingBlock: "space.400",
        paddingBlockStart: "space.100",
        xcss: (0, $6qaBj.cx)($98801b38dd9ca402$var$containerStyle.root)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYvlq.default), {
        gap: "space.400",
        alignContent: "start",
        xcss: $98801b38dd9ca402$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVpyx.default), {
        onTry: onTry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp0YA.ConnectedRepositoryList), {
        filteredRepositories: filteredRepositories
    })));
};
// For historical reasons, we export the AutoCatalogViaTeamWorkGraphCrossFlowTouchPoint as CrossFlowTouchPoint.
// This allows us to keep the same import path for consumers of this component.
const $98801b38dd9ca402$var$CrossFlowTouchPoint = $98801b38dd9ca402$var$AutoCatalogViaTeamWorkGraphCrossFlowTouchPoint;
var $98801b38dd9ca402$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $98801b38dd9ca402$var$CrossFlowTouchPoint;
const $98801b38dd9ca402$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _1bsbj2pb _syazazsu _19pk1epz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98801b38dd9ca402$var$TouchPointMessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1wq8 _ca0qv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98801b38dd9ca402$var$TouchPointMessageDescriptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _ca0qv47k _u5f3idpf _n3tdv47k _19bvidpf",
            __cmplp.className
        ])
    });
});
const $98801b38dd9ca402$var$containerStyle = {
    root: "_p12f1fra"
};

});
parcelRegister("91dLC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca9db502d0fade53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcb00b72b0d5583cbb9553130291713e>>
 * @relayHash e71a775be71248f3cb49ccc2be7b37c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1fbccb3474bb76a8480c3dce8d82f8508178befb44a0a7c097e6f6c807407485
const $ca9db502d0fade53$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CrossFlowTouchPointQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                            "kind": "LinkedField",
                            "name": "projectAssociatedRepo",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "DevOpsRepository"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CrossFlowTouchPointQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                            "kind": "LinkedField",
                            "name": "projectAssociatedRepo",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "DevOpsRepository"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1fbccb3474bb76a8480c3dce8d82f8508178befb44a0a7c097e6f6c807407485",
            "metadata": {},
            "name": "CrossFlowTouchPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca9db502d0fade53$var$node.hash = "fc042f56cf05f88d9ce61034fa17ab46";
var $ca9db502d0fade53$export$2e2bcd8739ae039 = $ca9db502d0fade53$var$node;

});

parcelRegister("hYvlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});

parcelRegister("cx7jd", function(module, exports) {
$parcel$export(module.exports, "CrossflowImage", () => $10bb2e0598ef0c01$export$d0aa3e19f62b822f);

var $eJOHy = parcelRequire("eJOHy");

var $34TvF = parcelRequire("34TvF");
const $10bb2e0598ef0c01$export$d0aa3e19f62b822f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $34TvF.default), {
        alt: "Jira Crossflow",
        width: 457,
        height: 285
    });

});
parcelRegister("34TvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $43157bd2b2029682$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $3vp4N = parcelRequire("3vp4N");
const $43157bd2b2029682$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3vp4N)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3vp4N))
});
var $43157bd2b2029682$export$2e2bcd8739ae039 = $43157bd2b2029682$var$Illustration;
// for advanced use only
const $43157bd2b2029682$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("3vp4N", function(module, exports) {
module.exports = new URL("ui-jsw-compass-crossflow.0545e2c1.svg", import.meta.url).toString();

});



const $cd0ffcaa21ba8fff$export$ae684c7694b92c83 = 'https://www.atlassian.com/software/compass';

parcelRegister("kp0YA", function(module, exports) {
$parcel$export(module.exports, "ConnectedRepositoryList", () => $e8ee59961414ee05$export$fe586af18a4bb85b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");

var $8VwgY = parcelRequire("8VwgY");
const $e8ee59961414ee05$var$gridStyles = {
    root: "_yv0ewxkt"
};
const $e8ee59961414ee05$export$fe586af18a4bb85b = ({ filteredRepositories: filteredRepositories })=>{
    if (!filteredRepositories.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYvlq.default), {
        gap: "space.300",
        alignItems: "center",
        xcss: $e8ee59961414ee05$var$gridStyles.root
    }, filteredRepositories.slice(0, 6).map((repo, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8VwgY.default), {
            key: repo.name,
            repositoryName: repo.name,
            cardVisualConfigurationIndex: idx
        })));
};

});
parcelRegister("8VwgY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e24150d6d99045a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $9AYOJ = parcelRequire("9AYOJ");

var $eALjj = parcelRequire("eALjj");

var $cV8sz = parcelRequire("cV8sz");

var $6BR9Q = parcelRequire("6BR9Q");

var $cjq2C = parcelRequire("cjq2C");

var $806LH = parcelRequire("806LH");

var $dicM4 = parcelRequire("dicM4");

var $dcLzM = parcelRequire("dcLzM");

var $k71qx = parcelRequire("k71qx");
var $7AseU = parcelRequire("7AseU");

var $Ay1uj = parcelRequire("Ay1uj");

var $cxKOj = parcelRequire("cxKOj");

var $fafqI = parcelRequire("fafqI");

var $lRq8t = parcelRequire("lRq8t");

var $alxio = parcelRequire("alxio");

var $iqDHg = parcelRequire("iqDHg");
function $8e24150d6d99045a$var$isIconType(raw) {
    return raw in (0, $alxio.default);
}
const $8e24150d6d99045a$var$toComponentType = (raw)=>$8e24150d6d99045a$var$isIconType(raw) ? raw : 'OTHER';
const $8e24150d6d99045a$var$styles = {
    cardStyles: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _1bto1l2s _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj _1ul9124j",
    containerStyle: "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _4t3i1osq",
    unpressableButton: "_2rko12b0 _syazazsu _1e0c116y _bfhki8nm _2lx2vrvc _1n261q9c _u5f3pxbi _19bvu2gc _ca0q1b66 _n3td1b66",
    iconBox: "_19bvv77o _u5f31b66 _ca0qv77o _n3tdv77o",
    inlineTooltip: "_2rko12b0 _bfhkvuon _16qs130s _syazi7uo _c71l1mjv _p12f1mjv _1q51u2gc _85i5u2gc _bozgutpp _y4tiutpp",
    informationIcon: "_ca0qze3t _n3tdze3t",
    buttonStyle: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    completedActions: "_19bv1ejb"
};
const $8e24150d6d99045a$var$CustomTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7AseU.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $8e24150d6d99045a$var$styles.inlineTooltip,
            className
        ]),
        ref: ref,
        placement: "top"
    }, children);
});
function $8e24150d6d99045a$var$CompassRepositoryCard(props) {
    const projectAddedGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $iqDHg.messages).projectAddedGalaxia : (0, $iqDHg.messages).projectAdded;
    const testId = 'project-directories.components.view.compass-repository-card';
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configuration = [
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjq2C))), {
                    label: formatMessage((0, $iqDHg.messages).componentReadiness)
                }),
                message: formatMessage((0, $iqDHg.messages).componentReadiness)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                        label: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                        label: formatMessage((0, $iqDHg.messages).repositoryAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).repositoryAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        label: formatMessage((0, $iqDHg.messages).descriptionAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).descriptionAdded)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjq2C))), {
                    label: formatMessage((0, $iqDHg.messages).devOpsHealth)
                }),
                message: formatMessage((0, $iqDHg.messages).devOpsHealth)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                        label: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                        label: formatMessage((0, $iqDHg.messages).repositoryAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).repositoryAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).pullRequestCycleTime)
                    }),
                    message: formatMessage((0, $iqDHg.messages).pullRequestCycleTime)
                },
                {
                    message: formatMessage((0, $iqDHg.messages).plusOne)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjq2C))), {
                    label: formatMessage((0, $iqDHg.messages).softwareQuality)
                }),
                message: formatMessage((0, $iqDHg.messages).softwareQuality)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                        label: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).buildSuccessRate)
                    }),
                    message: formatMessage((0, $iqDHg.messages).buildSuccessRate)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).openBugs)
                    }),
                    message: formatMessage((0, $iqDHg.messages).openBugs)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).qualityGateConditions)
                    }),
                    message: formatMessage((0, $iqDHg.messages).qualityGateConditions)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjq2C))), {
                    label: formatMessage((0, $iqDHg.messages).openJiraIssues)
                }),
                message: formatMessage((0, $iqDHg.messages).openJiraIssues)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).openBugs)
                    }),
                    message: formatMessage((0, $iqDHg.messages).openBugs)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                        label: formatMessage(projectAddedGalaxia)
                    }),
                    message: formatMessage(projectAddedGalaxia)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                        label: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjq2C))), {
                    label: formatMessage((0, $iqDHg.messages).securityMetrics)
                }),
                message: formatMessage((0, $iqDHg.messages).securityMetrics)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).openCriticalSeverityVulnerabilities)
                    }),
                    message: formatMessage((0, $iqDHg.messages).openCriticalSeverityVulnerabilities)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dicM4))), {
                        label: formatMessage((0, $iqDHg.messages).openHighSeverityVulnerabilities)
                    }),
                    message: formatMessage((0, $iqDHg.messages).openHighSeverityVulnerabilities)
                },
                {
                    message: formatMessage((0, $iqDHg.messages).plusThree)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjq2C))), {
                    label: formatMessage((0, $iqDHg.messages).componentReadiness)
                }),
                message: formatMessage((0, $iqDHg.messages).componentReadiness)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                        label: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                        label: formatMessage((0, $iqDHg.messages).repositoryAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).repositoryAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        label: formatMessage((0, $iqDHg.messages).descriptionAdded)
                    }),
                    message: formatMessage((0, $iqDHg.messages).descriptionAdded)
                }
            ]
        }
    ];
    const { repositoryName: repositoryName, cardVisualConfigurationIndex: cardVisualConfigurationIndex } = props;
    const visualConfigIndex = (cardVisualConfigurationIndex ?? 0) % configuration.length;
    const visualConfig = configuration[visualConfigIndex];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: $8e24150d6d99045a$var$styles.cardStyles,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        xcss: $8e24150d6d99045a$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fafqI.ComponentTypeIcon), {
        type: $8e24150d6d99045a$var$toComponentType(visualConfig.componentType ?? 'OTHER'),
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small"
    }, repositoryName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        xcss: $8e24150d6d99045a$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $8e24150d6d99045a$var$styles.iconBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
        label: formatMessage((0, $iqDHg.messages).owner)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        as: "p",
        align: "start"
    }, formatMessage((0, $iqDHg.messages).owner))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        xcss: $8e24150d6d99045a$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $8e24150d6d99045a$var$styles.iconBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
        label: formatMessage((0, $iqDHg.messages).workItems)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        as: "p",
        align: "start"
    }, formatMessage((0, $iqDHg.messages).workItems))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        xcss: $8e24150d6d99045a$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $8e24150d6d99045a$var$styles.iconBox
    }, visualConfig.scorecard.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        as: "p",
        align: "start"
    }, visualConfig.scorecard.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        component: $8e24150d6d99045a$var$CustomTooltip,
        content: formatMessage((0, $iqDHg.messages).scorecardInfo)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            testId: `${testId}.scorecard-tooltip`,
            ...tooltipProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6BR9Q))),
            label: formatMessage((0, $iqDHg.messages).scorecardInfo),
            appearance: "subtle",
            spacing: "compact"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        wrap: "wrap",
        gap: "space.100",
        xcss: $8e24150d6d99045a$var$styles.completedActions
    }, visualConfig.completedActions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
            key: index,
            xcss: $8e24150d6d99045a$var$styles.unpressableButton,
            space: "space.050"
        }, action.icon ? action.icon : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            size: "medium",
            as: "p",
            align: "start"
        }, action.message)))));
}
var $8e24150d6d99045a$export$2e2bcd8739ae039 = $8e24150d6d99045a$var$CompassRepositoryCard;

});
parcelRegister("cjq2C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a4903e4ec58e62125197758e732a2ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f6b759e74d9e2e2$var$_react = $8f6b759e74d9e2e2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8f6b759e74d9e2e2$var$_baseNew = $8f6b759e74d9e2e2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8f6b759e74d9e2e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Scorecard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Scorecard in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f6b759e74d9e2e2$var$ScorecardIcon = (props)=>/*#__PURE__*/ $8f6b759e74d9e2e2$var$_react.default.createElement($8f6b759e74d9e2e2$var$_baseNew.default, Object.assign({
        name: "ScorecardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0 0 13V16a8 8 0 1 1 8-8h-1.5A6.5 6.5 0 0 0 8 1.5m4.326 3.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zm-1.889 8.548a6.52 6.52 0 0 0 3.59-3.59l1.391.562A8.03 8.03 0 0 1 11 15.418z" clip-rule="evenodd"/>`
    }, props));
$8f6b759e74d9e2e2$var$ScorecardIcon.displayName = 'ScorecardIcon';
var $8f6b759e74d9e2e2$var$_default = module.exports.default = $8f6b759e74d9e2e2$var$ScorecardIcon;

});

parcelRegister("fafqI", function(module, exports) {
$parcel$export(module.exports, "ComponentTypeIcon", () => $f2d532593d5807cd$export$cac930aaf0e7232e);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $alxio = parcelRequire("alxio");

var $4Wqt9 = parcelRequire("4Wqt9");
const $f2d532593d5807cd$export$cac930aaf0e7232e = (props)=>{
    const { type: providedType, testId: testId, size: size = 'medium' } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const type = !providedType.startsWith('ari:cloud:compass') ? providedType : 'OTHER';
    const componentType = (0, $alxio.default)[type] ?? (0, $alxio.default).OTHER;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage(componentType.name)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Wqt9.ComponentIconBackground), {
        testId: testId,
        type: type,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: formatMessage(componentType.name),
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
        glyph: componentType.icon
    })));
};

});
parcelRegister("alxio", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f25c57669959250$export$2e2bcd8739ae039);
// We had to disable the rule, because the "fill" and "stroke" attributes of the svg wanted a token, and there's no token for white
/**
 * This file contains the component types metadata that will need to be used throughout the Compass Frontend.
 * Actual field definitions and its options are fetched using a GraphQL query from the Compass Catalog.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $5ayAF = parcelRequire("5ayAF");
const $8f25c57669959250$export$bace2d8ac2cf2caa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z",
        fill: "#fff"
    }));
const $8f25c57669959250$var$componentTypesMetadata = {
    SERVICE: {
        id: 'SERVICE',
        name: (0, $5ayAF.default).service,
        color: (isDarkMode)=>isDarkMode ? '#8F7EE7' : '#6554C0',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z",
                fill: "#fff"
            }))
    },
    LIBRARY: {
        id: 'LIBRARY',
        name: (0, $5ayAF.default).library,
        color: (isDarkMode)=>isDarkMode ? '#F5CD47' : '#FF8B00',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z",
                fill: "#fff"
            }))
    },
    APPLICATION: {
        id: 'APPLICATION',
        name: (0, $5ayAF.default).application,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#36B37E',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z",
                fill: "#fff"
            }))
    },
    CAPABILITY: {
        id: 'CAPABILITY',
        name: (0, $5ayAF.default).capability,
        color: (isDarkMode)=>isDarkMode ? '#738496' : '#344563',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "path-4-inside-4_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                width: "24",
                height: "24",
                rx: "3",
                fill: "#44546F"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.7048 6.76169C10.7048 7.47703 11.2847 8.05693 12 8.05693C12.7154 8.05693 13.2953 7.47703 13.2953 6.76169C13.2953 6.04635 12.7154 5.46646 12 5.46646C11.2847 5.46646 10.7048 6.04635 10.7048 6.76169ZM11.2 9.54498C10.9878 9.48411 10.7856 9.39963 10.5965 9.29457L9.2954 10.5975C9.52591 11.013 9.65718 11.4911 9.65718 12C9.65718 13.599 8.36093 14.8952 6.76194 14.8952C5.16294 14.8952 3.8667 13.599 3.8667 12C3.8667 10.401 5.16294 9.10474 6.76194 9.10474C7.27055 9.10474 7.74854 9.23589 8.16392 9.46622L9.46569 8.1626C9.23572 7.74747 9.1048 7.26987 9.1048 6.76169C9.1048 5.1627 10.401 3.86646 12 3.86646C13.599 3.86646 14.8953 5.1627 14.8953 6.76169C14.8953 7.27051 14.764 7.74867 14.5335 8.16417L15.8358 9.46641C16.2512 9.23596 16.7293 9.10474 17.2381 9.10474C18.8371 9.10474 20.1333 10.401 20.1333 12C20.1333 13.599 18.8371 14.8952 17.2381 14.8952C15.6391 14.8952 14.3429 13.599 14.3429 12C14.3429 11.4913 14.4741 11.0132 14.7044 10.5978L13.402 9.29543C13.2133 9.4001 13.0116 9.48429 12.8 9.545V14.455C14.0099 14.8021 14.8953 15.9168 14.8953 17.2383C14.8953 18.8373 13.599 20.1335 12 20.1335C10.401 20.1335 9.1048 18.8373 9.1048 17.2383C9.1048 15.9168 9.99013 14.8021 11.2 14.455V9.54498ZM11.9931 15.943C11.281 15.9467 10.7048 16.5252 10.7048 17.2383C10.7048 17.9536 11.2847 18.5335 12 18.5335C12.7154 18.5335 13.2953 17.9536 13.2953 17.2383C13.2953 16.5252 12.7191 15.9467 12.0069 15.943C12.0046 15.9431 12.0023 15.9431 12 15.9431C11.9977 15.9431 11.9954 15.9431 11.9931 15.943ZM5.4667 12C5.4667 12.7153 6.0466 13.2952 6.76194 13.2952C7.47728 13.2952 8.05718 12.7153 8.05718 12C8.05718 11.2846 7.47728 10.7047 6.76194 10.7047C6.0466 10.7047 5.4667 11.2846 5.4667 12ZM15.9429 12C15.9429 12.7153 16.5228 13.2952 17.2381 13.2952C17.9534 13.2952 18.5333 12.7153 18.5333 12C18.5333 11.2846 17.9534 10.7047 17.2381 10.7047C16.5228 10.7047 15.9429 11.2846 15.9429 12Z",
                fill: "white"
            }))
    },
    CLOUD_RESOURCE: {
        id: 'CLOUD_RESOURCE',
        name: (0, $5ayAF.default).cloudResource,
        color: (isDarkMode)=>isDarkMode ? '#8F7EE7' : '#6554C0',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    DATA_PIPELINE: {
        id: 'DATA_PIPELINE',
        name: (0, $5ayAF.default).dataPipeline,
        color: (isDarkMode)=>isDarkMode ? '#E2483D' : '#FF5630',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                stroke: "#fff",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                stroke: "#fff",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    MACHINE_LEARNING_MODEL: {
        id: 'MACHINE_LEARNING_MODEL',
        name: (0, $5ayAF.default).machineLearningModel,
        color: (isDarkMode)=>isDarkMode ? '#E2483D' : '#FF5630',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M4.61222 7.89078L18.8696 16.1906",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M4.85273 16.2901L19.0688 7.95921",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "none",
                d: "M11.7317 20.2989L11.7317 3.24756",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "#FF5630",
                d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    TEMPLATE: {
        id: 'TEMPLATE',
        name: (0, $5ayAF.default).template,
        color: (isDarkMode)=>isDarkMode ? '#42B2D7' : '#00B8DA',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "path-1-outside-1_2331_289998",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "2.99998",
                width: "18",
                height: "18",
                fill: "black"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                fill: "white",
                x: "3",
                y: "2.99998",
                width: "18",
                height: "18"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M14.464 11.4051L18.853 11.405C18.8862 11.405 18.9131 11.432 18.9131 11.4652L18.9131 13.5996C18.9131 13.6328 18.8862 13.6597 18.853 13.6597L14.464 13.6597C14.4307 13.6597 14.4038 13.6328 14.4038 13.5996L14.4038 11.4652C14.4038 11.432 14.4307 11.4051 14.464 11.4051Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M8.74316 17.8442L8.74317 6.15577C8.74317 5.63419 8.74317 5.3734 8.5922 5.20279C8.57599 5.18447 8.55868 5.16716 8.54036 5.15096C8.36975 4.99998 8.10896 4.99998 7.58738 4.99998C7.0658 4.99999 6.80501 4.99999 6.63439 5.15096C6.61608 5.16717 6.59877 5.18448 6.58256 5.2028C6.43159 5.37341 6.43159 5.6342 6.43159 6.15578L6.43159 17.8442C6.43159 18.3658 6.43159 18.6266 6.58256 18.7972C6.59877 18.8155 6.61608 18.8328 6.6344 18.849C6.805 19 7.06579 19 7.58735 19C8.10894 19 8.36973 19 8.54035 18.849C8.55866 18.8328 8.57598 18.8155 8.59219 18.7972C8.74316 18.6266 8.74316 18.3658 8.74316 17.8442Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M9.89457 6.35349C9.4795 6.35349 9.14302 6.68998 9.14302 7.10505C9.14303 7.52012 9.47951 7.8566 9.89458 7.8566L9.89457 6.35349ZM16.0626 7.10502L16.0626 6.35347L16.0626 7.10502ZM16.8141 7.85657L16.0626 7.85657L16.0626 7.85657L16.8141 7.85657ZM16.0626 10.3539C16.0626 10.7689 16.399 11.1054 16.8141 11.1054C17.2292 11.1054 17.5657 10.7689 17.5657 10.3539L16.0626 10.3539ZM3.99996 6.4679C3.58489 6.46792 3.24843 6.80442 3.24845 7.21949C3.24847 7.63456 3.58497 7.97103 4.00004 7.97101L3.99996 6.4679ZM4.94361 7.97096C5.35868 7.97094 5.69515 7.63444 5.69513 7.21937C5.69511 6.80429 5.35861 6.46783 4.94354 6.46785L4.94361 7.97096ZM9.89458 7.8566L16.0626 7.85658L16.0626 6.35347L9.89457 6.35349L9.89458 7.8566ZM16.0626 7.85657L16.0626 10.3539L17.5657 10.3539L17.5657 7.85657L16.0626 7.85657ZM16.0626 7.85658L16.0626 7.85657L17.5657 7.85657C17.5657 7.02643 16.8927 6.35347 16.0626 6.35347L16.0626 7.85658ZM4.00004 7.97101L4.94361 7.97096L4.94354 6.46785L3.99996 6.4679L4.00004 7.97101ZM18.853 11.405L18.853 9.90194L18.853 11.405ZM14.464 11.4051L14.464 12.9082L14.464 11.4051ZM14.4038 11.4652L12.9007 11.4652L12.9007 11.4652L14.4038 11.4652ZM14.4038 13.5996L15.9069 13.5996L15.9069 13.5996L14.4038 13.5996ZM14.464 13.6597L14.464 15.1628L14.464 15.1628L14.464 13.6597ZM18.853 13.6597L18.853 12.1566L18.853 12.1566L18.853 13.6597ZM18.9131 13.5996L20.4163 13.5996L20.4163 13.5996L18.9131 13.5996ZM18.9131 11.4652L17.41 11.4652L17.41 11.4652L18.9131 11.4652ZM8.74317 6.15577L7.24006 6.15577L7.24006 6.15577L8.74317 6.15577ZM8.74316 17.8442L10.2463 17.8442L10.2463 17.8442L8.74316 17.8442ZM6.43159 17.8442L7.9347 17.8442L7.9347 17.8442L6.43159 17.8442ZM6.43159 6.15578L4.92848 6.15578L4.92848 6.15578L6.43159 6.15578ZM6.58256 5.2028L7.70823 6.19889L7.70825 6.19887L6.58256 5.2028ZM7.58738 4.99998L7.58738 6.50309L7.58738 4.99998ZM6.63439 5.15096L5.6383 4.02529L5.63829 4.0253L6.63439 5.15096ZM8.5922 5.20279L7.46651 6.19887L7.46653 6.19888L8.5922 5.20279ZM8.54036 5.15096L7.54427 6.27663L7.5443 6.27665L8.54036 5.15096ZM7.58735 19L7.58732 20.5031L7.58735 19ZM6.6344 18.849L5.6383 19.9747L5.6383 19.9747L6.6344 18.849ZM6.58256 18.7972L7.70824 17.8011L7.70824 17.8011L6.58256 18.7972ZM8.54035 18.849L9.53642 19.9747L9.53642 19.9747L8.54035 18.849ZM8.59219 18.7972L7.46652 17.8011L7.46652 17.8011L8.59219 18.7972ZM18.853 9.90194L14.4639 9.90195L14.464 12.9082L18.853 12.9081L18.853 9.90194ZM12.9007 11.4652L12.9007 13.5996L15.9069 13.5996L15.9069 11.4652L12.9007 11.4652ZM14.464 15.1628L18.853 15.1628L18.853 12.1566L14.4639 12.1566L14.464 15.1628ZM20.4163 13.5996L20.4163 11.4652L17.41 11.4652L17.41 13.5996L20.4163 13.5996ZM18.853 15.1628C19.7163 15.1628 20.4163 14.463 20.4163 13.5996L17.41 13.5996C17.41 12.8026 18.0561 12.1566 18.853 12.1566L18.853 15.1628ZM12.9007 13.5996C12.9007 14.4629 13.6006 15.1628 14.464 15.1628L14.4639 12.1566C15.2609 12.1566 15.9069 12.8027 15.9069 13.5996L12.9007 13.5996ZM14.4639 9.90195C13.6006 9.90196 12.9007 10.6018 12.9007 11.4652L15.9069 11.4652C15.9069 12.2621 15.2609 12.9082 14.464 12.9082L14.4639 9.90195ZM18.853 12.9081C18.0561 12.9082 17.41 12.2621 17.41 11.4652L20.4163 11.4652C20.4163 10.6018 19.7164 9.90193 18.853 9.90194L18.853 12.9081ZM7.24006 6.15577L7.24006 17.8442L10.2463 17.8442L10.2463 6.15577L7.24006 6.15577ZM7.9347 17.8442L7.93469 6.15578L4.92848 6.15578L4.92848 17.8442L7.9347 17.8442ZM7.93469 6.15578C7.93469 6.0202 7.93478 5.92531 7.93664 5.84611C7.93752 5.80852 7.93868 5.78111 7.9399 5.76104C7.94112 5.74089 7.94214 5.73268 7.94207 5.73321C7.942 5.73377 7.94027 5.74781 7.93493 5.77157C7.9295 5.79569 7.91973 5.83268 7.90261 5.8783C7.88522 5.92465 7.86087 5.97828 7.82715 6.0354C7.79317 6.09297 7.75326 6.148 7.70823 6.19889L5.45689 4.20671C5.09945 4.61065 4.99651 5.05936 4.95885 5.36214C4.92575 5.6282 4.92848 5.93394 4.92848 6.15578L7.93469 6.15578ZM7.58737 3.49688C7.36553 3.49688 7.05979 3.49415 6.79374 3.52725C6.49095 3.56491 6.04224 3.66785 5.6383 4.02529L7.63049 6.27663C7.5796 6.32166 7.52457 6.36157 7.467 6.39555C7.40988 6.42927 7.35625 6.45362 7.30991 6.47101C7.26428 6.48813 7.22729 6.4979 7.20318 6.50333C7.17941 6.50867 7.16537 6.5104 7.16481 6.51047C7.16428 6.51054 7.17249 6.50952 7.19265 6.5083C7.21272 6.50708 7.24013 6.50592 7.27772 6.50504C7.35691 6.50318 7.45181 6.50309 7.58738 6.50309L7.58737 3.49688ZM7.70825 6.19887C7.68392 6.22636 7.65795 6.25233 7.6305 6.27662L5.63829 4.0253C5.57421 4.08201 5.51362 4.1426 5.45688 4.20672L7.70825 6.19887ZM10.2463 6.15577C10.2463 5.93393 10.249 5.62819 10.2159 5.36214C10.1782 5.05935 10.0753 4.61064 9.71786 4.2067L7.46653 6.19888C7.42149 6.14799 7.38159 6.09296 7.3476 6.03539C7.31388 5.97827 7.28953 5.92464 7.27215 5.87829C7.25503 5.83267 7.24525 5.79568 7.23983 5.77156C7.23448 5.74779 7.23275 5.73375 7.23268 5.7332C7.23262 5.73267 7.23364 5.74088 7.23486 5.76103C7.23608 5.7811 7.23723 5.80851 7.23812 5.8461C7.23998 5.9253 7.24006 6.02019 7.24006 6.15577L10.2463 6.15577ZM7.58738 6.50309C7.72296 6.50309 7.81786 6.50318 7.89705 6.50504C7.93464 6.50592 7.96205 6.50708 7.98212 6.50829C8.00227 6.50952 8.01048 6.51053 8.00995 6.51047C8.0094 6.5104 7.99536 6.50867 7.97159 6.50332C7.94747 6.4979 7.91049 6.48812 7.86486 6.471C7.81852 6.45362 7.76489 6.42927 7.70776 6.39555C7.65019 6.36157 7.59516 6.32166 7.54427 6.27663L9.53645 4.02528C9.1325 3.66784 8.6838 3.5649 8.38101 3.52724C8.11495 3.49415 7.80921 3.49688 7.58737 3.49688L7.58738 6.50309ZM9.71788 4.20671C9.66115 4.1426 9.60055 4.08201 9.53643 4.02526L7.5443 6.27665C7.5168 6.25232 7.49083 6.22634 7.46651 6.19887L9.71788 4.20671ZM7.58738 17.4969C7.4518 17.4969 7.35691 17.4968 7.27772 17.4949C7.24013 17.494 7.21272 17.4929 7.19265 17.4917C7.1725 17.4904 7.16429 17.4894 7.16482 17.4895C7.16538 17.4896 7.17942 17.4913 7.20318 17.4966C7.2273 17.5021 7.26428 17.5118 7.30991 17.529C7.35625 17.5463 7.40988 17.5707 7.46701 17.6044C7.52458 17.6384 7.5796 17.6783 7.63049 17.7233L5.6383 19.9747C6.04224 20.3321 6.49093 20.435 6.79371 20.4727C7.05976 20.5058 7.36549 20.5031 7.58732 20.5031L7.58738 17.4969ZM4.92848 17.8442C4.92848 18.066 4.92576 18.3718 4.95885 18.6378C4.99651 18.9406 5.09944 19.3893 5.45687 19.7932L7.70824 17.8011C7.75327 17.852 7.79318 17.907 7.82716 17.9646C7.86088 18.0217 7.88523 18.0753 7.90261 18.1217C7.91973 18.1673 7.92951 18.2043 7.93493 18.2284C7.94027 18.2522 7.942 18.2662 7.94207 18.2668C7.94214 18.2673 7.94112 18.2591 7.9399 18.2389C7.93868 18.2189 7.93752 18.1915 7.93664 18.1539C7.93478 18.0747 7.9347 17.9798 7.9347 17.8442L4.92848 17.8442ZM7.63049 17.7233C7.65797 17.7477 7.68394 17.7736 7.70824 17.8011L5.45687 19.7932C5.51359 19.8573 5.57418 19.9179 5.6383 19.9747L7.63049 17.7233ZM7.58732 20.5031C7.80917 20.5031 8.11491 20.5058 8.38097 20.4727C8.68375 20.4351 9.13246 20.3322 9.53642 19.9747L7.54428 17.7233C7.59517 17.6783 7.65019 17.6384 7.70776 17.6044C7.76489 17.5707 7.81852 17.5464 7.86486 17.529C7.91049 17.5119 7.94748 17.5021 7.97159 17.4967C7.99536 17.4913 8.0094 17.4896 8.00996 17.4895C8.01048 17.4894 8.00227 17.4905 7.98212 17.4917C7.96205 17.4929 7.93464 17.4941 7.89705 17.4949C7.81785 17.4968 7.72296 17.4969 7.58738 17.4969L7.58732 20.5031ZM7.24006 17.8442C7.24006 17.9798 7.23997 18.0747 7.23811 18.1539C7.23723 18.1915 7.23607 18.2189 7.23485 18.2389C7.23363 18.2591 7.23261 18.2673 7.23268 18.2668C7.23275 18.2662 7.23448 18.2522 7.23982 18.2284C7.24525 18.2043 7.25502 18.1673 7.27214 18.1217C7.28953 18.0753 7.31388 18.0217 7.3476 17.9646C7.38158 17.907 7.42149 17.852 7.46652 17.8011L9.71786 19.7933C10.0753 19.3893 10.1782 18.9406 10.2159 18.6378C10.249 18.3718 10.2463 18.066 10.2463 17.8442L7.24006 17.8442ZM9.53642 19.9747C9.60052 19.918 9.66111 19.8574 9.71786 19.7933L7.46652 17.8011C7.49084 17.7736 7.51681 17.7476 7.54427 17.7233L9.53642 19.9747Z",
                fill: "white",
                mask: "url(#path-1-outside-1_2331_289998)"
            }))
    },
    UI_ELEMENT: {
        id: 'UI_ELEMENT',
        name: (0, $5ayAF.default).uiElement,
        color: (isDarkMode)=>isDarkMode ? '#F5CD47' : '#FF8B00',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "path-1-inside-1_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                x: "2.83353",
                y: "13.6489",
                width: "6.97358",
                height: "7.36887",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                fill: "none",
                x: "2.83353",
                y: "13.6489",
                width: "6.97358",
                height: "7.36887",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-1-inside-1_1403_23012)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "path-2-inside-2_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                x: "2.83353",
                y: "3.01807",
                width: "18.5455",
                height: "8.59702",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                fill: "none",
                x: "2.83353",
                y: "3.01807",
                width: "18.5455",
                height: "8.59702",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-2-inside-2_1403_23012)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "path-3-inside-3_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                x: "11.5089",
                y: "13.6489",
                width: "9.87006",
                height: "7.36887",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                fill: "none",
                x: "11.5089",
                y: "13.6489",
                width: "9.87006",
                height: "7.36887",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-3-inside-3_1403_23012)"
            }))
    },
    WEBSITE: {
        id: 'WEBSITE',
        name: (0, $5ayAF.default).website,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#36B37E',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "path-5-inside-5_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                width: "24",
                height: "24",
                rx: "3",
                fill: "#22A06B"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 18.375C12.8372 18.375 13.6662 18.2101 14.4396 17.8897C15.2131 17.5694 15.9158 17.0998 16.5078 16.5078C17.0998 15.9158 17.5694 15.2131 17.8897 14.4396C18.2101 13.6662 18.375 12.8372 18.375 12C18.375 11.1628 18.2101 10.3338 17.8897 9.56039C17.5694 8.78694 17.0998 8.08417 16.5078 7.49219C15.9158 6.90022 15.2131 6.43064 14.4396 6.11027C13.6662 5.78989 12.8372 5.625 12 5.625C10.3092 5.625 8.68774 6.29665 7.49219 7.49219C6.29665 8.68774 5.625 10.3092 5.625 12C5.625 13.6908 6.29665 15.3123 7.49219 16.5078C8.68774 17.7033 10.3092 18.375 12 18.375ZM11.3625 17.0554C10.1302 16.9017 8.99657 16.303 8.17476 15.372C7.35294 14.441 6.8996 13.2418 6.9 12C6.9 11.6047 6.951 11.2286 7.03387 10.8589L10.0875 13.9125V14.55C10.0875 15.2513 10.6613 15.825 11.3625 15.825V17.0554ZM15.7612 15.4361C15.6804 15.1785 15.5192 14.9535 15.3012 14.7941C15.0833 14.6346 14.82 14.5491 14.55 14.55H13.9125V12.6375C13.9125 12.2869 13.6256 12 13.275 12H9.45V10.725H10.725C11.0756 10.725 11.3625 10.4381 11.3625 10.0875V8.8125H12.6375C13.3387 8.8125 13.9125 8.23875 13.9125 7.5375V7.27612C15.7804 8.03475 17.1 9.86437 17.1 12C17.1 13.326 16.59 14.5309 15.7612 15.4361Z",
                fill: "white"
            }))
    },
    DATASET: {
        id: 'DATASET',
        name: (0, $5ayAF.default).dataset,
        color: (isDarkMode)=>isDarkMode ? '#DA62AC' : '#CD519D',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M3 0H21C22.7 0 24 1.3 24 3V21C24 22.7 22.7 24 21 24H3C1.3 24 0 22.7 0 21V3C0 1.3 1.3 0 3 0Z",
                fill: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 6.5V17.5H17.5V6.5H6.5ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 10.75H5V9.25H18V10.75Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 14.75H5V13.25H18V14.75Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.75 5L12.75 18L11.25 18L11.25 5L12.75 5Z",
                fill: "currentColor"
            }))
    },
    DATA_PRODUCT: {
        id: 'DATA_PRODUCT',
        name: (0, $5ayAF.default).dataProduct,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#2ABB7F',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M0 21V3c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3Z",
                fill: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.1 5a.9.9 0 0 1 .9-.9h4v1.8H5.9V9H4.1V5ZM19 4.1a.9.9 0 0 1 .9.9v4h-1.8V5.9H15V4.1h4ZM19.9 19a.9.9 0 0 1-.9.9h-4v-1.8h3.1V15h1.8v4ZM5 19.9a.9.9 0 0 1-.9-.9v-4h1.8v3.1H9v1.8H5Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M11 8h2v2h-2V8ZM8 11h2v2H8v-2ZM11 14h2v2h-2v-2ZM14 11h2v2h-2v-2Z",
                fill: "currentColor"
            }))
    },
    DASHBOARD: {
        id: 'DASHBOARD',
        name: (0, $5ayAF.default).dashboard,
        color: (isDarkMode)=>isDarkMode ? '#8777D9' : '#8777D9',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                d: "M0 21V3c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3Z",
                fill: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.5 17.5h13v-11h-13v11ZM4 18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4 9.25h8v1.5H4v-1.5ZM12 13.25h8v1.5h-8v-1.5Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.75 6v13h-1.5V6h1.5Z",
                fill: "currentColor"
            }))
    },
    OTHER: {
        id: 'OTHER',
        name: (0, $5ayAF.default).other,
        color: (isDarkMode)=>isDarkMode ? '#388BFF' : '#0065FF',
        icon: $8f25c57669959250$export$bace2d8ac2cf2caa
    }
};
var $8f25c57669959250$export$2e2bcd8739ae039 = $8f25c57669959250$var$componentTypesMetadata;

});
parcelRegister("5ayAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $65961b4f44f7f83a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $65961b4f44f7f83a$var$messages = (0, $7qGN1.defineMessages)({
    service: {
        "id": "compass-common.common.component-types-metadata.service",
        "defaultMessage": "Service"
    },
    library: {
        "id": "compass-common.common.component-types-metadata.library",
        "defaultMessage": "Library"
    },
    application: {
        "id": "compass-common.common.component-types-metadata.application",
        "defaultMessage": "Application"
    },
    other: {
        "id": "compass-common.common.component-types-metadata.other",
        "defaultMessage": "Other"
    },
    capability: {
        "id": "compass-common.common.component-types-metadata.capability",
        "defaultMessage": "Capability"
    },
    cloudResource: {
        "id": "compass-common.common.component-types-metadata.cloud-resource",
        "defaultMessage": "Cloud resource"
    },
    dataPipeline: {
        "id": "compass-common.common.component-types-metadata.data-pipeline",
        "defaultMessage": "Data pipeline"
    },
    machineLearningModel: {
        "id": "compass-common.common.component-types-metadata.machine-learning-model",
        "defaultMessage": "Machine learning model"
    },
    template: {
        "id": "compass-common.common.component-types-metadata.template",
        "defaultMessage": "Template"
    },
    uiElement: {
        "id": "compass-common.common.component-types-metadata.ui-element",
        "defaultMessage": "UI element"
    },
    website: {
        "id": "compass-common.common.component-types-metadata.website",
        "defaultMessage": "Website"
    },
    dataset: {
        "id": "compass-common.common.component-types-metadata.dataset",
        "defaultMessage": "Dataset"
    },
    dataProduct: {
        "id": "compass-common.common.component-types-metadata.data-product",
        "defaultMessage": "Data product"
    },
    dashboard: {
        "id": "compass-common.common.component-types-metadata.dashboard",
        "defaultMessage": "Dashboard"
    }
});
var $65961b4f44f7f83a$export$2e2bcd8739ae039 = $65961b4f44f7f83a$var$messages;

});


parcelRegister("4Wqt9", function(module, exports) {
$parcel$export(module.exports, "ComponentIconBackground", () => $beb4658a01f7e19a$export$2f11e092dd014dd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $anoAR = parcelRequire("anoAR");

var $58yRG = parcelRequire("58yRG");

var $alxio = parcelRequire("alxio");
function $beb4658a01f7e19a$export$2f11e092dd014dd4(props) {
    const { type: type, size: size = 'medium', testId: testId, children: children } = props;
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($beb4658a01f7e19a$var$IconBackground, {
        "data-testid": testId,
        size: size,
        color: (0, $alxio.default)[type].color(isDarkMode)
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beb4658a01f7e19a$var$IconBackground = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ke0o0q": (0, $awdRS.default)((0, $anoAR.sizes)[__cmplp.size]),
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb4cet _4t3i4cet _bfhk1cj8 _1p3rwubq _f2puwubq _1lvewubq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("anoAR", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("iqDHg", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0ebd93a4c496636d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $0ebd93a4c496636d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    owner: {
        "id": "compass-repository-card.owner",
        "defaultMessage": "Owner"
    },
    workItems: {
        "id": "compass-repository-card.work-items",
        "defaultMessage": "Work items"
    },
    scorecardInfo: {
        "id": "compass-repository-card.scorecard-info",
        "defaultMessage": "Use this scorecard in Compass to ensure component details are ready for development teams to reference in the catalog."
    },
    componentReadiness: {
        "id": "compass-repository-card.component-readiness",
        "defaultMessage": "Component readiness"
    },
    ownerTeamAdded: {
        "id": "compass-repository-card.owner-team-added",
        "defaultMessage": "Owner team added"
    },
    repositoryAdded: {
        "id": "compass-repository-card.repository-added",
        "defaultMessage": "Repository added"
    },
    descriptionAdded: {
        "id": "compass-repository-card.description-added",
        "defaultMessage": "Description added"
    },
    buildSuccessRate: {
        "id": "compass-repository-card.build-success-rate",
        "defaultMessage": "Build success rate"
    },
    pullRequestCycleTime: {
        "id": "compass-repository-card.pull-request-cycle-time",
        "defaultMessage": "Pull request cycle time"
    },
    projectAdded: {
        "id": "compass-repository-card.project-added",
        "defaultMessage": "Project added"
    },
    securityMetrics: {
        "id": "compass-repository-card.security-metrics",
        "defaultMessage": "Security metrics"
    },
    softwareQuality: {
        "id": "compass-repository-card.software-quality",
        "defaultMessage": "Software quality"
    },
    openJiraIssues: {
        "id": "compass-repository-card.open-jira-issues",
        "defaultMessage": "Open Jira work items"
    },
    devOpsHealth: {
        "id": "compass-repository-card.devops-health",
        "defaultMessage": "DevOps health"
    },
    openBugs: {
        "id": "compass-repository-card.open-bugs",
        "defaultMessage": "Open bugs"
    },
    qualityGateConditions: {
        "id": "compass-repository-card.quality-gate-conditions",
        "defaultMessage": "Quality gate conditions"
    },
    openCriticalSeverityVulnerabilities: {
        "id": "compass-repository-card.open-critical-severity-vulnerabilities",
        "defaultMessage": "Open critical severity vulnerabilities"
    },
    openHighSeverityVulnerabilities: {
        "id": "compass-repository-card.open-high-severity-vulnerabilities",
        "defaultMessage": "Open high severity vulnerabilities"
    },
    plusOne: {
        "id": "compass-repository-card.plus-one",
        "defaultMessage": "+1"
    },
    plusThree: {
        "id": "compass-repository-card.plus-three",
        "defaultMessage": "+3"
    },
    projectAddedGalaxia: {
        "id": "compass-repository-card.project-added-galaxia",
        "defaultMessage": "Space added"
    }
});

});



parcelRegister("gVpyx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3750d370eb3f91ea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $806LH = parcelRequire("806LH");

var $lgMTT = parcelRequire("lgMTT");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $O2sC7 = parcelRequire("O2sC7");

var $lRq8t = parcelRequire("lRq8t");

var $geOnH = parcelRequire("geOnH");
const $3750d370eb3f91ea$var$styles = {
    root: "_p12fxilx"
};
function $3750d370eb3f91ea$var$AutoCatalogEmptyStateLeftPanel(props) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { onTry: onTry } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200",
        alignInline: "start",
        xcss: $3750d370eb3f91ea$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $O2sC7.AppLogo), {
        icon: (0, $lgMTT.CompassIcon),
        name: "Compass",
        label: formatMessage((0, $geOnH.default).compass),
        href: "https://www.atlassian.com/software/compass/"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium",
        as: "h3"
    }, formatMessage((0, $geOnH.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.150"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $geOnH.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: onTry
    }, formatMessage((0, $geOnH.default).createYourCatalogButton))));
}
var $3750d370eb3f91ea$export$2e2bcd8739ae039 = $3750d370eb3f91ea$var$AutoCatalogEmptyStateLeftPanel;

});
parcelRegister("geOnH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eb518090970ff1d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1eb518090970ff1d$var$messages = (0, $7qGN1.defineMessages)({
    compass: {
        "id": "compass.components-left-panel.header",
        "defaultMessage": "Compass"
    },
    title: {
        "id": "compass.components-left-panel.title",
        "defaultMessage": "Create a catalog of your repositories linked in Jira and measure the health and performance of it for free"
    },
    description: {
        "id": "compass.components-left-panel.description",
        "defaultMessage": "Catalog these components and use them to track performance, health, and identify dependencies. Link work items to components \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    },
    createYourCatalogButton: {
        "id": "compass.components-left-panel.create-your-catalog.button",
        "defaultMessage": "Create your catalog in Compass"
    }
});
var $1eb518090970ff1d$export$2e2bcd8739ae039 = $1eb518090970ff1d$var$messages;

});


parcelRegister("3GlBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4453bf23342fa1e5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4453bf23342fa1e5$var$messages = (0, $7qGN1.defineMessages)({
    callToAction: {
        "id": "compass-cross-flow.call-to-action",
        "defaultMessage": "Create a comprehensive catalog of software components in Compass, then link them to issues \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    },
    engageMessage: {
        "id": "compass-cross-flow.engage-message",
        "defaultMessage": "Try Compass free"
    },
    headLine: {
        "id": "compass-cross-flow.head-line",
        "defaultMessage": "A new way to work on software components "
    },
    learnMoreMessage: {
        "id": "compass-cross-flow.learn-more-message",
        "defaultMessage": "Learn more about Compass"
    },
    callToActionIssueTermRefresh: {
        "id": "compass-cross-flow.call-to-action-issue-term-refresh",
        "defaultMessage": "Create a comprehensive catalog of software components in Compass, then link them to work items \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    }
});
var $4453bf23342fa1e5$export$2e2bcd8739ae039 = $4453bf23342fa1e5$var$messages;

});



parcelRegister("5gw8l", function(module, exports) {
$parcel$export(module.exports, "ComponentsTableEmptyState", () => $85e88be39d288eae$export$bbd499cf012bf709);
/* components-table-empty-state.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $48q59 = parcelRequire("48q59");

var $5bY40 = parcelRequire("5bY40");

var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $ezJEv = parcelRequire("ezJEv");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $kD45J = parcelRequire("kD45J");

var $gl6Zo = parcelRequire("gl6Zo");

var $9TGaC = parcelRequire("9TGaC");
const $85e88be39d288eae$var$ISSUES_URL = (projectKey)=>(0, $4cTDP.fg)('jira_list_nin_merge') ? encodeURI(`${globalThis.window.location.origin}/projects/${projectKey}/list`) : // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    encodeURI(`${window.location.origin}/browse/${projectKey}/issues`);
function $85e88be39d288eae$export$bbd499cf012bf709({ loading: loading, projectKey: projectKey, testId: testId, componentCount: componentCount, displayMode: displayMode }) {
    const headingGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9TGaC.default).headingGalaxia : (0, $9TGaC.default).heading;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const createButtonTestId = testId && `${testId}-create-button`; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'compassComponentsTableEmptyStateLearnMore');
    };
    const EmptyState = displayMode === 'no-linked-components' ? (0, $gl6Zo.EmptyStateImage) : (0, $gl6Zo.EmptyStateBlocks);
    const primaryAction = displayMode === 'no-linked-components' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
        appearance: "primary",
        href: $85e88be39d288eae$var$ISSUES_URL(projectKey)
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9TGaC.default).gotoIssuesIssueTermRefresh : (0, $9TGaC.default).gotoIssues)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kD45J.default), {
        testId: createButtonTestId,
        loading: loading,
        oldOnAddComponent: ()=>{},
        projectKey: projectKey,
        globalComponentsEnabled: true,
        verbose: true
    });
    let heading;
    let body;
    switch(displayMode){
        case 'no-components':
            heading = (0, $9TGaC.default).noComponentsHeading;
            body = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9TGaC.default).noComponentsBodyIssueTermRefresh : (0, $9TGaC.default).noComponentsBody;
            break;
        case 'no-linked-components':
            heading = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9TGaC.default).noLinkedComponentsHeadingIssueTermRefresh : (0, $9TGaC.default).noLinkedComponentsHeading;
            body = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9TGaC.default).noLinkedComponentsBodyIssueTermRefresh : (0, $9TGaC.default).noLinkedComponentsBody;
            break;
        case 'unknown':
            heading = headingGalaxia;
            body = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9TGaC.default).noComponentsBodyIssueTermRefresh : (0, $9TGaC.default).noComponentsBody;
            break;
        default:
            heading = headingGalaxia;
            body = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $9TGaC.default).noComponentsBodyIssueTermRefresh : (0, $9TGaC.default).noComponentsBody;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "componentsTableEmptyState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        eventName: "viewed componentsTableEmptyState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($85e88be39d288eae$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.400",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyState, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($85e88be39d288eae$var$Heading, null, formatMessage(heading, {
        componentCount: componentCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($85e88be39d288eae$var$Body, null, formatMessage(body, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.200",
        alignItems: "center"
    }, primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezJEv.default), {
        articleId: "6frUzedhV1M0c05JhXMvK0",
        appearance: "link",
        spacing: "none",
        onClick: onClickLearnMore,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/link-issues-to-compass-components/",
            onClick: onClickLearnMore,
            target: "_blank"
        }, formatMessage((0, $9TGaC.default).learnMore))
    }, formatMessage((0, $9TGaC.default).learnMore))))))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85e88be39d288eae$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1epz _2hwx1wug _otyr1epz _18u01wug _1bsbbhyd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85e88be39d288eae$var$Heading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85e88be39d288eae$var$Body = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyr1ejb _1bsbr5sb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezJEv", function(module, exports) {
$parcel$export(module.exports, "useHelpPanelLink", () => $906804a52fd3782f$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $906804a52fd3782f$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $906804a52fd3782f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $cxKOj = parcelRequire("cxKOj");
const $906804a52fd3782f$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $906804a52fd3782f$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $906804a52fd3782f$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $906804a52fd3782f$export$2e2bcd8739ae039 = $906804a52fd3782f$export$5a09250ffddd7fd1;
const $906804a52fd3782f$var$buttonWrapperStyles = null;
const $906804a52fd3782f$var$buttonWrapperSubtleStyles = null;

});
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;


parcelRegister("kD45J", function(module, exports) {
$parcel$export(module.exports, "default", () => $36d17bf8a6fa8e45$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");
var $5bY40 = parcelRequire("5bY40");

var $ac080 = parcelRequire("ac080");

var $7pw1V = parcelRequire("7pw1V");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $7Edap = parcelRequire("7Edap");
const $36d17bf8a6fa8e45$var$COMPASS_CREATE_COMPONENT_URL = (projectKey)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const projectLink = encodeURI(`${window.location.origin}/browse/${projectKey}`);
    return `/compass/home?showCreateComponentModal=true&projectLink=${projectLink}`;
};
function $36d17bf8a6fa8e45$export$2e2bcd8739ae039({ testId: testId, loading: loading, globalComponentsEnabled: globalComponentsEnabled = false, oldOnAddComponent: oldOnAddComponent, projectKey: projectKey, verbose: verbose = false }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!(0, $7pw1V.isFedrampModerate)() && !((0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('jira_fe_hide_components_list')) && globalComponentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
        testId: testId,
        href: $36d17bf8a6fa8e45$var$COMPASS_CREATE_COMPONENT_URL(projectKey),
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "primary",
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'createCompassComponent');
        },
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ac080)))
    }, formatMessage(verbose ? (0, $7Edap.default).addCompassComponent : (0, $7Edap.default).addComponent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "createComponentButton",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        isLoading: loading,
        testId: testId,
        appearance: "primary",
        onClick: oldOnAddComponent
    }, formatMessage((0, $7Edap.default).addComponent)));
}

});
parcelRegister("7Edap", function(module, exports) {
$parcel$export(module.exports, "default", () => $737a6971b3653a6e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $737a6971b3653a6e$var$messages = (0, $7qGN1.defineMessages)({
    addComponent: {
        "id": "project-components.create-component-button.trigger",
        "defaultMessage": "Create component"
    },
    addCompassComponent: {
        "id": "project-components.create-compass-component-button.trigger",
        "defaultMessage": "Create Compass component"
    }
});
var $737a6971b3653a6e$export$2e2bcd8739ae039 = $737a6971b3653a6e$var$messages;

});


parcelRegister("gl6Zo", function(module, exports) {
$parcel$export(module.exports, "EmptyStateBlocks", () => $82a569a44981cdef$export$58b6dcfb3ce70686);
$parcel$export(module.exports, "EmptyStateImage", () => $82a569a44981cdef$export$a7907bb86a15af4e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7nedo = parcelRequire("7nedo");

var $1PMGS = parcelRequire("1PMGS");
const $82a569a44981cdef$export$58b6dcfb3ce70686 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7nedo))),
        alt: "",
        width: 171.25
    });
const $82a569a44981cdef$var$imageTopMarginStyles = null;
const $82a569a44981cdef$export$a7907bb86a15af4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1PMGS))),
        alt: "",
        width: 336,
        className: (0, $hcewu.default)([
            "_19pkpxbi"
        ])
    });

});
parcelRegister("7nedo", function(module, exports) {
module.exports = new URL("empty-state-blocks.4f8f7da7.svg", import.meta.url).toString();

});

parcelRegister("1PMGS", function(module, exports) {
module.exports = new URL("issues-highlight.37797bd0.svg", import.meta.url).toString();

});


parcelRegister("9TGaC", function(module, exports) {
$parcel$export(module.exports, "default", () => $82c4d927741fa479$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $82c4d927741fa479$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "compass-common.components-table-empty-state.heading",
        "defaultMessage": "No Compass components are linked to your project"
    },
    noComponentsHeading: {
        "id": "compass-common.components-table-empty-state.no-components-heading",
        "defaultMessage": "You don't have any software components in Compass"
    },
    noLinkedComponentsHeading: {
        "id": "compass-common.components-table-empty-state.no-linked-components-heading",
        "defaultMessage": "{componentCount, plural, one {You have # software component in Compass, but it is not linked to an issue} other {You have # software components in Compass, but none are linked to issues}}"
    },
    body: {
        "id": "compass-common.components-table-empty-state.body",
        "defaultMessage": "Create a component in Compass, then add it to an issue's <b>Components</b> field. The component and its related information will appear here."
    },
    noComponentsBody: {
        "id": "compass-common.components-table-empty-state.no-components-body",
        "defaultMessage": "Issues can be linked to Compass software components, so you can track and manage the work on your software architecture."
    },
    noLinkedComponentsBody: {
        "id": "compass-common.components-table-empty-state.no-linked-components-body",
        "defaultMessage": "Add a component to an issue\u2019s <b>Components</b> field. Both will appear here, so you can track the work on your software architecture."
    },
    gotoIssues: {
        "id": "compass-common.components-table-empty-state.goto-issues",
        "defaultMessage": "Go to issues"
    },
    learnMore: {
        "id": "compass-common.components-table-empty-state.learn-more",
        "defaultMessage": "Learn more"
    },
    noLinkedComponentsHeadingIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.no-linked-components-heading-issue-term-refresh",
        "defaultMessage": "{componentCount, plural, one {You have # software component in Compass, but it is not linked to a work item} other {You have # software components in Compass, but none are linked to work items}}"
    },
    bodyIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.body-issue-term-refresh",
        "defaultMessage": "Create a component in Compass, then add it to the <b>Components</b> field in a work item. The component and its related information will appear here."
    },
    noComponentsBodyIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.no-components-body-issue-term-refresh",
        "defaultMessage": "Work items can be linked to Compass software components, so you can track and manage the work on your software architecture."
    },
    noLinkedComponentsBodyIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.no-linked-components-body-issue-term-refresh",
        "defaultMessage": "Add a component to the <b>Components</b> field in a work item. Both will appear here, so you can track the work on your software architecture."
    },
    gotoIssuesIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.goto-issues-issue-term-refresh",
        "defaultMessage": "Go to work items"
    },
    headingGalaxia: {
        "id": "compass-common.components-table-empty-state.heading-galaxia",
        "defaultMessage": "No Compass components are linked to your space"
    }
});
var $82c4d927741fa479$export$2e2bcd8739ae039 = $82c4d927741fa479$var$messages;

});



parcelRegister("kIrp0", function(module, exports) {
$parcel$export(module.exports, "CompassTableCrossflowTouchPointWithEC", () => $0a3ad07bbc770d4d$export$6d86b5ae49a52ead);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7pw1V = parcelRequire("7pw1V");

var $cgPoC = parcelRequire("cgPoC");

var $3Tj3c = parcelRequire("3Tj3c");

var $emaA9 = parcelRequire("emaA9");

var $4cTDP = parcelRequire("4cTDP");

var $04IXF = parcelRequire("04IXF");

var $3uXwz = parcelRequire("3uXwz");
const $0a3ad07bbc770d4d$var$CompassTableCrossflowTouchPoint = (props)=>{
    const { isCompassLicensed: isCompassLicensed, origin: origin } = props;
    const [{ hasBeenDismissed: hasBeenDismissed }, { dismiss: dismiss }] = (0, $3uXwz.useTouchPointDismissed)();
    const [{ hasBeenViewed: hasSpotlightBeenViewed }] = (0, $04IXF.useCompassComponentsSpotlightViewed)();
    const onDismiss = (0, $eJOHy.useCallback)(async ()=>{
        dismiss();
    }, [
        dismiss
    ]);
    // Conditions for when we should render the touch point.
    const shouldRender = (0, $eJOHy.useMemo)(()=>{
        if ((0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('jira_fe_hide_components_list')) // Don't render the touch point if the customer is an Isolated Cloud user.
        return false;
        if ((0, $7pw1V.isFedrampModerate)()) // Don't render the touch point if the customer is the FedRamp user.
        return false;
        if (isCompassLicensed) // Don't render the touch point if Compass is already provisioned.
        return false;
        if (!hasSpotlightBeenViewed) // Don't render the touch point until user has dismissed our first spotlight.
        return false;
        // Don't render the touch point if a user has already dismissed it.
        return !hasBeenDismissed;
    }, [
        isCompassLicensed,
        hasSpotlightBeenViewed,
        hasBeenDismissed
    ]);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emaA9.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Tj3c.AsyncCompassTableCrossFlowTouchPoint), {
        origin: origin,
        onDismiss: onDismiss
    }))) : null;
};
const $0a3ad07bbc770d4d$export$6d86b5ae49a52ead = (0, $cgPoC.withCompassEntitlementCheck)($0a3ad07bbc770d4d$var$CompassTableCrossflowTouchPoint, 'project-pages.project-directories.components.view.table');

});
parcelRegister("cgPoC", function(module, exports) {
$parcel$export(module.exports, "withCompassEntitlementCheck", () => $ed0018b3c8d3eb50$export$f091708323f34577);

var $eJOHy = parcelRequire("eJOHy");

var $1Ru5V = parcelRequire("1Ru5V");

var $koAZ4 = parcelRequire("koAZ4");
const $ed0018b3c8d3eb50$var$isCompassInLicensedProducts = (licensedProducts)=>licensedProducts && licensedProducts.compass || false;
const $ed0018b3c8d3eb50$export$4cfb87fbb2c1c13f = ()=>{
    const licensedProducts = (0, $1Ru5V.useLicensedProducts)();
    const memoisedData = (0, $eJOHy.useMemo)(()=>$ed0018b3c8d3eb50$var$isCompassInLicensedProducts(licensedProducts), [
        licensedProducts
    ]);
    return {
        isCompassLicensed: memoisedData
    };
};
function $ed0018b3c8d3eb50$export$f091708323f34577(WrappedComponent, origin) {
    // eslint-disable-next-line jira/react/no-class-components
    return class extends (0, $eJOHy.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: { licensedProducts: licensedProducts } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                    isCompassLicensed: $ed0018b3c8d3eb50$var$isCompassInLicensedProducts(licensedProducts),
                    origin: origin,
                    ...this.props
                })));
        }
    };
}

});

parcelRegister("3Tj3c", function(module, exports) {
$parcel$export(module.exports, "AsyncCompassTableCrossFlowTouchPoint", () => $6d3b7383ab4f9cd0$export$a46027b03a0a578b);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");

var $jtvH9 = parcelRequire("jtvH9");
const $6d3b7383ab4f9cd0$var$entryPointParams = {};
const $6d3b7383ab4f9cd0$export$a46027b03a0a578b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $jtvH9.asyncCompassTableCrossFlowTouchPoint), $6d3b7383ab4f9cd0$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.compass.table-cross-flow",
        packageName: "jiraCompassCrossFlow",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $6d3b7383ab4f9cd0$export$2e2bcd8739ae039 = $6d3b7383ab4f9cd0$export$a46027b03a0a578b;

});
parcelRegister("jtvH9", function(module, exports) {
$parcel$export(module.exports, "asyncCompassTableCrossFlowTouchPoint", () => $0ac275bb5e1ccc91$export$674e2f56ee41c337);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0ac275bb5e1ccc91$export$674e2f56ee41c337 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7syp8")).then((module)=>module.AsyncCompassTableCrossFlow), {
        moduleId: "95c02303",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7syp8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4oz7i").then(()=>parcelRequire('itNEA'));

});



parcelRegister("04IXF", function(module, exports) {
$parcel$export(module.exports, "useCompassComponentsSpotlightViewed", () => $41506375d28b27b6$export$3c55ae3693c7bfe9);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");

var $e6YEs = parcelRequire("e6YEs");
const $41506375d28b27b6$var$COMPASS_COMPONENTS_NAMESPACE = 'compass-components';
function $41506375d28b27b6$export$3c55ae3693c7bfe9() {
    const accountId = (0, $e6YEs.useAccountId)();
    const storageKey = `spotlight-viewed-${accountId}`;
    const storage = (0, $eJOHy.useMemo)(()=>(0, $3hRxq.createLocalStorageProvider)($41506375d28b27b6$var$COMPASS_COMPONENTS_NAMESPACE), []);
    const [hasBeenViewed, setHasBeenViewed] = (0, $eJOHy.useState)(storage.get(storageKey));
    const hide = (0, $eJOHy.useCallback)(()=>{
        setHasBeenViewed(true);
        storage.set(storageKey, true);
    }, [
        setHasBeenViewed,
        storage,
        storageKey
    ]);
    const reset = (0, $eJOHy.useCallback)(()=>{
        setHasBeenViewed(false);
        storage.remove(storageKey);
    }, [
        setHasBeenViewed,
        storage,
        storageKey
    ]);
    return [
        {
            hasBeenViewed: hasBeenViewed
        },
        {
            hide: hide,
            reset: reset
        }
    ];
}

});

parcelRegister("3uXwz", function(module, exports) {
$parcel$export(module.exports, "useTouchPointDismissed", () => $9478e55998b220a3$export$36756169aeb33eb4);

var $eJOHy = parcelRequire("eJOHy");

var $3hRxq = parcelRequire("3hRxq");

var $e6YEs = parcelRequire("e6YEs");
const $9478e55998b220a3$var$COMPASS_COMPONENTS_NAMESPACE = 'compass-components';
function $9478e55998b220a3$export$36756169aeb33eb4() {
    const accountId = (0, $e6YEs.useAccountId)();
    const storageKey = `table-crossflow-dismissed-${accountId}`;
    const storage = (0, $eJOHy.useMemo)(()=>(0, $3hRxq.createLocalStorageProvider)($9478e55998b220a3$var$COMPASS_COMPONENTS_NAMESPACE), []);
    const [hasBeenDismissed, setHasBeenDismissed] = (0, $eJOHy.useState)(storage.get(storageKey));
    const dismiss = (0, $eJOHy.useCallback)(()=>{
        setHasBeenDismissed(true);
        storage.set(storageKey, true);
    }, [
        setHasBeenDismissed,
        storage,
        storageKey
    ]);
    const reset = (0, $eJOHy.useCallback)(()=>{
        setHasBeenDismissed(false);
        storage.remove(storageKey);
    }, [
        setHasBeenDismissed,
        storage,
        storageKey
    ]);
    return [
        {
            hasBeenDismissed: hasBeenDismissed
        },
        {
            dismiss: dismiss,
            reset: reset
        }
    ];
}

});


parcelRegister("bZtXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $722dd4be304a81f1$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $7Z0qA = parcelRequire("7Z0qA");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");

var $dw49z = parcelRequire("dw49z");

var $a6Mn7 = parcelRequire("a6Mn7");

const $722dd4be304a81f1$var$mapStateToProps = (state)=>({
        isPageLoading: (0, $dw49z.isLoading)(state),
        // Ordered list of IDs returned from backend. Needed for rendering sorted order.
        componentIds: (0, $7Z0qA.getIds)(state),
        // Used to quickly fire search query.
        componentAris: (0, $7Z0qA.getAris)(state),
        // Needed to retrieve component by ARI and render.
        componentsById: state.components.byId,
        componentCount: (0, $7Z0qA.getTotalItems)(state),
        orderField: (0, $hGeBN.getOrderField)(state),
        orderDirection: (0, $hGeBN.getOrderDirection)(state)
    });
const $722dd4be304a81f1$var$mapDispatchToProps = (dispatch)=>({
        onSort: ({ key: key, sortOrder: sortOrder })=>{
            dispatch((0, $ksVok.patchQuery)({
                orderDirection: sortOrder,
                orderField: key,
                page: 1
            }));
            dispatch((0, $1jVSq.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).SORTING
            }));
        }
    });
var $722dd4be304a81f1$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($722dd4be304a81f1$var$mapStateToProps, $722dd4be304a81f1$var$mapDispatchToProps)((0, $a6Mn7.default));

});
parcelRegister("a6Mn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $525b3d8f3fa75eb4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9pTd3 = parcelRequire("9pTd3");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $lOOiG = parcelRequire("lOOiG");

var $806LH = parcelRequire("806LH");

var $2R0ne = parcelRequire("2R0ne");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $48BVs = parcelRequire("48BVs");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $ezJEv = parcelRequire("ezJEv");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");

var $cHtIB = parcelRequire("cHtIB");

var $4EKqI = parcelRequire("4EKqI");

var $2Jjb1 = parcelRequire("2Jjb1");

var $exivC = parcelRequire("exivC");

var $lvJvK = parcelRequire("lvJvK");

var $5zqq3 = parcelRequire("5zqq3");

var $gvfvt = parcelRequire("gvfvt");

var $czyOF = parcelRequire("czyOF");

var $8xD5e = parcelRequire("8xD5e");

var $7GTKv = parcelRequire("7GTKv");

var $a4oPc = parcelRequire("a4oPc");

var $MJDfz = parcelRequire("MJDfz");

var $aWq2n = parcelRequire("aWq2n");
const $525b3d8f3fa75eb4$var$useGetTeams = (components, siteId)=>{
    const [teamInfo, setTeamInfo] = (0, $eJOHy.useState)({});
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (components.length === 0) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setTeamInfo({});
            return;
        }
        const ownerIds = Array.from(new Set(// eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        components.map((component)=>component?.ownerId).filter(Boolean).map((0, $48BVs.getIdFromAri))));
        if (ownerIds.length === 0) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setTeamInfo({});
            return;
        }
        (0, $exivC.getTeams)(ownerIds, siteId).then((result)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const teamsByAri = Object.fromEntries(result.teams.map((team)=>[
                    team.id,
                    team
                ]));
            setTeamInfo(teamsByAri);
        }).catch((e)=>setError(e));
    }, [
        components,
        siteId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (error) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'useGetTeams',
                packageName: 'jiraProjectDirectoriesComponents',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    return {
        teamInfo: teamInfo,
        error: error
    };
};
function $525b3d8f3fa75eb4$export$2e2bcd8739ae039(props) {
    const componentCountGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $aWq2n.default).componentCountGalaxia : (0, $aWq2n.default).componentCount;
    const { testId: testId, projectKey: projectKey, isPageLoading: isPageLoading, componentIds: componentIds, componentsById: componentsById, componentAris: componentAris, componentCount: componentCount, orderField: orderField, orderDirection: orderDirection, onSort: onSort, children: children } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const siteId = (0, $cHtIB.useCloudId)();
    const { components: compassComponents, loading: compassComponentsLoading, error: compassComponentsError } = (0, $lvJvK.useGetCompassComponents)(componentAris);
    const loading = (0, $eJOHy.useMemo)(()=>compassComponentsLoading || isPageLoading, [
        compassComponentsLoading,
        isPageLoading
    ]); // Merged list of components in Jira that also exist in Compass.
    // This list is also sorted correctly via Jira.
    const mergedComponents = (0, $eJOHy.useMemo)(()=>{
        if (loading || compassComponents.length === 0) return [];
         // We reduce by `componentIds` as these are in correct sort order from server already.
        return componentIds.reduce((acc, componentId)=>{
            // Get the full Jira component from `componentsById`. We need the ARI and issue count.
            const jiraComponent = componentsById[componentId]; // Find a matching component that exists in Compass with the same ARI.
            const compassComponent = compassComponents.find((curCompassComponent)=>curCompassComponent.id === jiraComponent.ari); // Component exists in compass, we can render it.
            if (compassComponent) acc.push({
                ...compassComponent,
                issueCount: jiraComponent.issueCount
            });
            return acc;
        }, []);
    }, [
        loading,
        componentIds,
        componentsById,
        compassComponents
    ]);
    const { teamInfo: teamInfo } = $525b3d8f3fa75eb4$var$useGetTeams(mergedComponents, siteId);
    const head = (0, $eJOHy.useMemo)(()=>({
            cells: [
                {
                    key: (0, $2Jjb1.NAME),
                    content: formatMessage((0, $aWq2n.default).componentHeader),
                    width: 25,
                    isSortable: true
                },
                {
                    key: 'owner-team',
                    content: formatMessage((0, $aWq2n.default).ownerTeamHeader),
                    width: 25,
                    isSortable: false
                },
                {
                    key: 'repository',
                    content: formatMessage((0, $aWq2n.default).repositoryHeader),
                    width: 18,
                    isSortable: false
                },
                {
                    key: 'dependencies',
                    content: formatMessage((0, $aWq2n.default).dependenciesHeader),
                    width: 12,
                    isSortable: false
                },
                {
                    key: 'scorecard',
                    content: formatMessage((0, $aWq2n.default).scorecardHeader),
                    width: 12,
                    isSortable: false
                },
                {
                    key: (0, $2Jjb1.ISSUES),
                    content: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $aWq2n.default).issuesHeaderIssueTermRefresh : (0, $aWq2n.default).issuesHeader),
                    width: 8,
                    isSortable: true
                }
            ]
        }), [
        formatMessage
    ]);
    const rows = mergedComponents.map((component, idx)=>{
        const ownerId = (0, $48BVs.getIdFromAri)(component?.ownerId ?? '');
        return $525b3d8f3fa75eb4$var$compassComponentToRow({
            ...component,
            ownerName: teamInfo[ownerId]?.displayName ?? null
        }, projectKey, // Sorting is handled by API.
        orderDirection === 'DESC' ? -(idx + 1) : idx + 1);
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'learnMoreAboutLinkingIssuesToCompassLink');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small"
    }, formatMessage(componentCountGalaxia, {
        componentCount: componentCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "right-start",
        messageId: "project-directories.components.compass-table.popup",
        messageType: "transactional" // eslint-disable-next-line jira/import/no-direct-popup
        ,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                padding: "space.200",
                xcss: $525b3d8f3fa75eb4$var$tableHeaderStyles
            }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $aWq2n.default).componentInfoIssueTermRefresh : (0, $aWq2n.default).componentInfo, {
                bold: (0, $4cTDP.fg)('mcrtb-1008-enghealth-replace-typog-css-with-tokens') ? (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                        as: "strong"
                    }, text) : // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("strong", null, text),
                link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezJEv.default), {
                        articleId: "6frUzedhV1M0c05JhXMvK0",
                        appearance: "link",
                        spacing: "none",
                        onClick: onClickLearnMore,
                        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                            href: "https://support.atlassian.com/jira-software-cloud/docs/link-issues-to-compass-components/",
                            target: "_blank",
                            appearance: "link",
                            spacing: "none",
                            onClick: onClickLearnMore
                        }, text)
                    }, text)
            })),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))),
                label: "",
                spacing: "compact",
                appearance: "subtle",
                testId: "project-directories.components.compass-table.add",
                onClick: ()=>setIsOpen(!isOpen),
                ...triggerProps
            });
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($525b3d8f3fa75eb4$var$TableWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
        isFixedSize: true,
        loadingSpinnerSize: "large",
        head: head,
        rows: rows,
        isLoading: loading,
        sortKey: orderField,
        sortOrder: orderDirection,
        onSort: (data, analyticsEvent)=>{
            onSort?.(data);
            if (analyticsEvent) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'compassComponentsTableSorted', {
                key: data.key,
                sortOrder: data.sortOrder
            });
        },
        emptyView: compassComponentsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MJDfz.ComponentsTableErrorState), null) : undefined
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "compassComponentsTable",
        sendToPrivacyUnsafeSplunk: true
    }, content), !compassComponentsError && children);
}
function $525b3d8f3fa75eb4$var$compassComponentToRow(component, projectKey, key) {
    const componentId = (0, $48BVs.getIdFromAri)(component.id);
    const ownerId = component.ownerId ? (0, $48BVs.getIdFromAri)(component?.ownerId ?? '') : undefined;
    return {
        cells: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5zqq3.default), {
                    componentId: componentId,
                    name: component.name,
                    description: component.description,
                    typeId: component.typeId,
                    isArchived: component.state === 'ARCHIVED'
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8xD5e.default), {
                    ownerName: component.ownerName,
                    ownerId: ownerId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7GTKv.RepositoryCell), {
                    repositoryLinks: component.links
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gvfvt.default), {
                    componentId: componentId,
                    inwardRelationships: component.inwardRelationships,
                    outwardRelationships: component.outwardRelationships
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a4oPc.default // Use full component ARI to make scorecards query.
                ), {
                    componentId: component.id,
                    scorecardScores: component.scorecardScores
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $czyOF.default), {
                    projectKey: projectKey,
                    componentName: component.name,
                    issueCount: component.issueCount
                }),
                key: key
            }
        ]
    };
}
const $525b3d8f3fa75eb4$var$tableHeaderStyles = (0, $1DXK0.xcss)({
    width: '417px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $525b3d8f3fa75eb4$var$TableWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bve4j0fz _f96p1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lOOiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("aXVGO", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("khVsD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("1NCSA", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});



parcelRegister("iXYwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {
$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r1uh4 _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syazazsu _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});




parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});


parcelRegister("48BVs", function(module, exports) {
$parcel$export(module.exports, "getColorForProgress", () => $de59d015c44f2268$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $de59d015c44f2268$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $de59d015c44f2268$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $de59d015c44f2268$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $de59d015c44f2268$export$79640a85913af5aa);


var $9CuM6 = parcelRequire("9CuM6");
const $de59d015c44f2268$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $de59d015c44f2268$var$COLOR_RANGES = [
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.FAILING,
        end: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $7bb4c1736002a04a$exports).R300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING - 1,
        color: (0, $7bb4c1736002a04a$exports).Y300
    },
    {
        start: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        end: $de59d015c44f2268$export$aa91e30498abc411.PASSING,
        color: (0, $7bb4c1736002a04a$exports).G300
    }
];
const $de59d015c44f2268$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $de59d015c44f2268$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $7bb4c1736002a04a$exports).R300;
};
const $de59d015c44f2268$export$921f23fa0f13f23e = 90;
const $de59d015c44f2268$export$69a1d9a35c04a358 = 50;
const $de59d015c44f2268$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $de59d015c44f2268$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $de59d015c44f2268$export$69a1d9a35c04a358 && totalScore < $de59d015c44f2268$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $de59d015c44f2268$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $9CuM6.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $9CuM6.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $9CuM6.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $de59d015c44f2268$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $de59d015c44f2268$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("9CuM6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3693706a70d8818b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3693706a70d8818b$var$messages = (0, $7qGN1.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});
var $3693706a70d8818b$export$2e2bcd8739ae039 = $3693706a70d8818b$var$messages;

});


parcelRegister("exivC", function(module, exports) {
$parcel$export(module.exports, "getTeams", () => $a6737509e489eb11$export$5a622455e94bac3);

var $3ugTQ = parcelRequire("3ugTQ");

const $a6737509e489eb11$var$TEAMS_BULK_REST_API_URL_V4 = '/gateway/api/v4/teams/withMembers/bulk';
const $a6737509e489eb11$export$5a622455e94bac3 = async (teamIds, siteId)=>(0, $3ugTQ.performPostRequest)($a6737509e489eb11$var$TEAMS_BULK_REST_API_URL_V4, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            teamIds: teamIds,
            siteId: siteId
        })
    });

});

parcelRegister("lvJvK", function(module, exports) {
$parcel$export(module.exports, "useGetCompassComponents", () => $fea8bdf5fa4761a7$export$79b1cb1316dc1cf9);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $hA0fK = parcelRequire("hA0fK");

var $cHtIB = parcelRequire("cHtIB");

var $9hVFe = parcelRequire("9hVFe");

var $9RZwq = parcelRequire("9RZwq");
const $fea8bdf5fa4761a7$export$79b1cb1316dc1cf9 = (componentAris)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: data, loading: loading, error: error } = (0, $hA0fK.useFetchQuery)((0, $9RZwq.SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY), {
        cloudId: cloudId,
        query: {
            first: (0, $9hVFe.ITEMS_ON_PAGE),
            fieldFilters: [
                {
                    name: 'entityId',
                    filter: {
                        in: componentAris
                    }
                }
            ]
        }
    }, {
        fetchPolicy: 'network-only'
    });
    const components = (0, $eJOHy.useMemo)(()=>{
        if (data?.compass?.searchComponents?.__typename !== 'CompassSearchComponentConnection') return [];
        return data?.compass?.searchComponents.nodes?.map($fea8bdf5fa4761a7$var$mapNodeToComponent).filter((component)=>component != null) ?? [];
    }, [
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && error) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'useGetCompassComponents',
                packageName: 'jiraProjectDirectoriesComponents',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        loading,
        error
    ]);
    return {
        components: components,
        loading: loading,
        error: error
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fea8bdf5fa4761a7$var$mapNodeToComponent(node) {
    if (!node || !node.component || node.__typename !== 'CompassSearchComponentResult') return null;
    const { component: component } = node;
    let inwardRelationships;
    let outwardRelationships;
    if (component.inwardRelationships.__typename !== 'CompassRelationshipConnection') inwardRelationships = {
        nodes: [],
        pageInfo: {
            hasNextPage: false
        },
        error: component.inwardRelationships.message
    };
    else inwardRelationships = component.inwardRelationships;
    if (component.outwardRelationships.__typename !== 'CompassRelationshipConnection') outwardRelationships = {
        nodes: [],
        pageInfo: {
            hasNextPage: false
        },
        error: component.outwardRelationships.message
    };
    else outwardRelationships = component.outwardRelationships;
    const repositoryLinks = component.links?.reduce((acc, cur)=>{
        if (cur.type === 'REPOSITORY') acc.push(cur);
        return acc;
    }, []) ?? [];
    return {
        id: component.id,
        name: component.name,
        description: component.description,
        typeId: component.typeId,
        ownerId: component.ownerId,
        links: repositoryLinks,
        link: node.link,
        state: component.state,
        scorecardScores: component.scorecardScores,
        inwardRelationships: inwardRelationships,
        outwardRelationships: outwardRelationships
    };
}

});
parcelRegister("9RZwq", function(module, exports) {
$parcel$export(module.exports, "SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY", () => $d73c414b9c778144$export$bd252c97cab4a3b6);

var $8aH0u = parcelRequire("8aH0u");
const $d73c414b9c778144$export$bd252c97cab4a3b6 = (0, $8aH0u.default);

});
parcelRegister("8aH0u", function(module, exports) {
$parcel$export(module.exports, "default", () => $405b7f71416d596e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca58d674586260c252dd9c7a3486b4b7>>
 * @relayHash 98e8fb0777fab7eb66d33463c9f0871f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4ef783417e74213eaa4dc96b67b877132fc6ae850fda499d9ecc3d414b345479
const $405b7f71416d596e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "typeId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "ownerId"
    }, v6 = {
        "types": [
            "DEPENDS_ON"
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    }, v10 = [
        {
            "concreteType": "CompassCatalogQueryApi",
            "kind": "LinkedField",
            "name": "compass",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "searchComponents",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "CompassSearchComponentResult",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        },
                                        {
                                            "concreteType": "CompassComponent",
                                            "kind": "LinkedField",
                                            "name": "component",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "state"
                                                },
                                                {
                                                    "concreteType": "CompassLink",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": true,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CompassScorecardScore",
                                                    "kind": "LinkedField",
                                                    "name": "scorecardScores",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalScore"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "maxTotalScore"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "inwardRelationships",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "query",
                                                            "value": {
                                                                "direction": "INWARD",
                                                                "filters": v6 /*: any*/ ,
                                                                "first": 5
                                                            }
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CompassRelationship",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CompassComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "startNode",
                                                                            "plural": false,
                                                                            "selections": v7 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "CompassRelationshipConnection"
                                                        },
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "relationships(query:{\"direction\":\"INWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                                                },
                                                {
                                                    "alias": "outwardRelationships",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "query",
                                                            "value": {
                                                                "direction": "OUTWARD",
                                                                "filters": v6 /*: any*/ ,
                                                                "first": 5
                                                            }
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CompassRelationship",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CompassComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "endNode",
                                                                            "plural": false,
                                                                            "selections": v7 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "CompassRelationshipConnection"
                                                        },
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "relationships(query:{\"direction\":\"OUTWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CompassSearchComponentConnection"
                        },
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "id": "4ef783417e74213eaa4dc96b67b877132fc6ae850fda499d9ecc3d414b345479",
            "metadata": {},
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$405b7f71416d596e$var$node.hash = "8a9b9fd2ce363a346ece1981d9c0fc18";
var $405b7f71416d596e$export$2e2bcd8739ae039 = $405b7f71416d596e$var$node;

});



parcelRegister("5zqq3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a862ad1c56bb520f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $jdqdp = parcelRequire("jdqdp");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $fafqI = parcelRequire("fafqI");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $btzxJ = parcelRequire("btzxJ");
function $a862ad1c56bb520f$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, name: name, description: description, typeId: typeId, isArchived: isArchived } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: description ?? name
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...tooltipProps,
            testId: "project-directories.components.compass-table.cells.component.link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingInline: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fafqI.ComponentTypeIcon), {
                type: typeId
            })),
            iconAfter: isArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingInlineStart: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), null, formatMessage((0, $btzxJ.default).archived))) : undefined,
            appearance: "link",
            spacing: "none",
            href: `/compass/component/${componentId}`,
            target: "_blank",
            onClick: (_, analyticsEvent)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'compassComponentLink');
            }
        }, name));
}

});
parcelRegister("btzxJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a931e5b57dfd702$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5a931e5b57dfd702$var$messages = (0, $7qGN1.defineMessages)({
    archived: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.component.archived",
        "defaultMessage": "Archived"
    }
});
var $5a931e5b57dfd702$export$2e2bcd8739ae039 = $5a931e5b57dfd702$var$messages;

});


parcelRegister("gvfvt", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cb3a20295fb9a87$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");

var $kq24V = parcelRequire("kq24V");

var $aoSlJ = parcelRequire("aoSlJ");
const $2cb3a20295fb9a87$var$messages = (0, $7qGN1.defineMessages)({
    noDependencies: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-dependencies",
        "defaultMessage": "No dependencies"
    },
    viewDependencies: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.view-dependencies",
        "defaultMessage": "View dependencies"
    }
});
function $2cb3a20295fb9a87$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, inwardRelationships: inwardRelationships, outwardRelationships: outwardRelationships } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (inwardRelationships.nodes.length === 0 && outwardRelationships.nodes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kq24V.SubtleText), null, formatMessage($2cb3a20295fb9a87$var$messages.noDependencies));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        messageId: "project-directories.components.compass-table.cells.dependencies.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aoSlJ.default), {
                testId: "project-directories.components.compass-table.cells.dependencies.popup-wrapper",
                componentId: componentId,
                dependsOn: outwardRelationships,
                dependedOnBy: inwardRelationships
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                appearance: "link",
                spacing: "none",
                onClick: (_, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'viewDependenciesButton');
                    setIsOpen(!isOpen);
                }
            }, formatMessage($2cb3a20295fb9a87$var$messages.viewDependencies))
    });
}

});
parcelRegister("kq24V", function(module, exports) {
$parcel$export(module.exports, "SubtleText", () => $cae42d7730db9885$export$474d9b539a9b2a24);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cae42d7730db9885$export$474d9b539a9b2a24 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazazsu",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aoSlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $77c7cabeee87e861$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");

var $ac080 = parcelRequire("ac080");

var $7ep4S = parcelRequire("7ep4S");

var $48BVs = parcelRequire("48BVs");

var $cHtIB = parcelRequire("cHtIB");

var $exivC = parcelRequire("exivC");

var $dr5Ly = parcelRequire("dr5Ly");
function $77c7cabeee87e861$export$2e2bcd8739ae039(props) {
    const { testId: testId, componentId: componentId, dependsOn: dependsOn, dependedOnBy: dependedOnBy } = props;
    const [teamNamesById, setTeamNamesById] = (0, $eJOHy.useState)({});
    const [teamsLoading, setTeamsLoading] = (0, $eJOHy.useState)(true);
    const siteId = (0, $cHtIB.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        const uniqueOwnerIds = Array.from(new Set([
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            ...dependsOn.nodes.flatMap((node)=>node.endNode.ownerId ? [
                    (0, $48BVs.getIdFromAri)(node.endNode.ownerId)
                ] : []),
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            ...dependedOnBy.nodes.flatMap((node)=>node.startNode.ownerId ? [
                    (0, $48BVs.getIdFromAri)(node.startNode.ownerId)
                ] : [])
        ]));
        if (uniqueOwnerIds.length > 0) (0, $exivC.getTeams)(uniqueOwnerIds, siteId).then((teams)=>{
            setTeamNamesById(teams.teams.reduce((acc, curTeam)=>Object.assign(acc, {
                    [curTeam.id]: curTeam.displayName
                }), {}));
        }).catch(()=>setTeamNamesById({})).finally(()=>setTeamsLoading(false));
        else setTeamsLoading(false);
    }, [
        dependsOn,
        dependedOnBy,
        siteId
    ]);
    if (teamsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$ContentWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$ContentWrapper, {
        "data-testid": testId
    }, dependsOn.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "div"
    }, "Depends on")), dependsOn.nodes.map((node, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dr5Ly.default), {
            key: idx,
            node: {
                ...node.endNode
            },
            ownerName: teamNamesById[(0, $48BVs.getIdFromAri)(node.endNode.ownerId ?? '')]
        })), dependsOn.pageInfo.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$ViewMoreLink, {
        componentId: componentId
    })), dependedOnBy.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "div"
    }, "Depended on by")), dependedOnBy.nodes.map((node, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dr5Ly.default), {
            key: idx,
            node: {
                ...node.startNode
            },
            ownerName: teamNamesById[(0, $48BVs.getIdFromAri)(node.startNode.ownerId ?? '')]
        })), dependedOnBy.pageInfo.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$ViewMoreLink, {
        componentId: componentId
    })));
}
const $77c7cabeee87e861$var$ViewMoreLink = ({ componentId: componentId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77c7cabeee87e861$var$Link, {
        href: `/compass/component/${componentId}/dependencies`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, "View more ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ac080))), {
        label: ""
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77c7cabeee87e861$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $77c7cabeee87e861$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrutpp _ngc0i7uo",
            __cmplp.className
        ])
    });
});
const $77c7cabeee87e861$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbk5xz _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $77c7cabeee87e861$var$Link = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1ns9 _4cvr1h6o _24rc1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dr5Ly", function(module, exports) {
$parcel$export(module.exports, "default", () => $09addbbe66947321$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $alxio = parcelRequire("alxio");

var $48BVs = parcelRequire("48BVs");

var $fafqI = parcelRequire("fafqI");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $1kJkq = parcelRequire("1kJkq");
function $09addbbe66947321$var$isIconType(raw) {
    return raw in (0, $alxio.default);
}
const $09addbbe66947321$var$toComponentType = (raw)=>$09addbbe66947321$var$isIconType(raw) ? raw : 'OTHER';
function $09addbbe66947321$export$2e2bcd8739ae039(props) {
    const { node: node, ownerName: ownerName } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const componentId = (0, $eJOHy.useMemo)(()=>(0, $48BVs.getIdFromAri)(node.id), [
        node.id
    ]);
    const ownedBy = (0, $eJOHy.useMemo)(()=>{
        const componentNameComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $09addbbe66947321$var$iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fafqI.ComponentTypeIcon), {
            type: $09addbbe66947321$var$toComponentType(node.typeId),
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09addbbe66947321$var$Text, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            spacing: "none",
            href: `/compass/component/${componentId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (_, analyticsEvent)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dependencyComponentLink');
            }
        }, node.name)), "\xa0");
        if ((ownerName?.length ?? 0) > 0) {
            const ownerId = (0, $48BVs.getIdFromAri)(node.ownerId ?? '');
            const teamNameComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                spacing: "none",
                href: `/compass/people/team/${ownerId}`,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (_, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dependencyOwnerLink');
                }
            }, ownerName));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $1kJkq.default).ownedBy, {
                text: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09addbbe66947321$var$Text, null, chunks),
                componentName: componentNameComponent,
                teamName: teamNameComponent
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $1kJkq.default).noOwner, {
            text: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09addbbe66947321$var$Text, null, chunks),
            componentName: componentNameComponent
        }));
    }, [
        node.ownerId,
        ownerName,
        componentId,
        node.name,
        node.typeId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09addbbe66947321$var$Row, {
        "data-testid": "project-directories.components.compass-table.cells.dependencies.popup-content.depency-row.row"
    }, ownedBy);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $09addbbe66947321$var$Row = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _4cvr1h6o _1bsbk5xz _4t3i1ylp _otyru2gc _bfhkysee",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $09addbbe66947321$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $09addbbe66947321$var$iconWrapper = (0, $1DXK0.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});

});
parcelRegister("1kJkq", function(module, exports) {
$parcel$export(module.exports, "default", () => $40acee81696ebb82$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $40acee81696ebb82$var$messages = (0, $7qGN1.defineMessages)({
    ownedBy: {
        "id": "project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.owner-new",
        "defaultMessage": "{componentName} <text>owned by</text> {teamName}"
    },
    noOwner: {
        "id": "project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.no-owner-new",
        "defaultMessage": "{componentName} <text>No owner</text>"
    }
});
var $40acee81696ebb82$export$2e2bcd8739ae039 = $40acee81696ebb82$var$messages;

});




parcelRegister("czyOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $75c0f6cb4d1715c0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $4cTDP = parcelRequire("4cTDP");

var $bnIBr = parcelRequire("bnIBr");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $kq24V = parcelRequire("kq24V");
const $75c0f6cb4d1715c0$var$messages = (0, $7qGN1.defineMessages)({
    noIssues: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-issues",
        "defaultMessage": "No issues"
    },
    issueCount: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.issue-count",
        "defaultMessage": "{issueCount, plural, one {# issue} other {# issues}}"
    }
});
function $75c0f6cb4d1715c0$export$2e2bcd8739ae039(props) {
    const { projectKey: projectKey, componentName: componentName, issueCount: issueCount } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issuesUrl = (0, $eJOHy.useMemo)(()=>{
        const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND component = ${(0, $bnIBr.toQuotedString)(componentName)}`;
        return (0, $bnIBr.createAllWorkUrl)(jql);
    }, [
        projectKey,
        componentName
    ]);
    const link = (0, $4cTDP.fg)('replace-anchor-with-link__morphinecake') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        "data-testid": "project-directories.components.compass-table.cells.issues.link",
        href: issuesUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage($75c0f6cb4d1715c0$var$messages.issueCount, {
        issueCount: issueCount
    })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        "data-testid": "project-directories.components.compass-table.cells.issues.link",
        href: issuesUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage($75c0f6cb4d1715c0$var$messages.issueCount, {
        issueCount: issueCount
    }));
    return issueCount > 0 ? link : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kq24V.SubtleText), null, formatMessage($75c0f6cb4d1715c0$var$messages.noIssues));
}

});
parcelRegister("bnIBr", function(module, exports) {
$parcel$export(module.exports, "toQuotedString", () => $a183e8d5995c289a$export$dbeab020a4aa404);
$parcel$export(module.exports, "createProjectAllWorkUri", () => $a183e8d5995c289a$export$497544a08e0b5e51);
$parcel$export(module.exports, "createAllWorkUrl", () => $a183e8d5995c289a$export$ca075a1255c9a76d);

var $4cTDP = parcelRequire("4cTDP");
const $a183e8d5995c289a$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $a183e8d5995c289a$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $a183e8d5995c289a$var$ENCODE_MAP[character] || character;
};
const $a183e8d5995c289a$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $a183e8d5995c289a$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $a183e8d5995c289a$export$497544a08e0b5e51 = (jql)=>(0, $4cTDP.fg)('jira_list_nin_merge') ? `/list/?jql=${encodeURIComponent(jql)}` : `/issues/?jql=${encodeURIComponent(jql)}`;
const $a183e8d5995c289a$export$ca075a1255c9a76d = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("8xD5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $a84fe34048ddaf2b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $kq24V = parcelRequire("kq24V");
const $a84fe34048ddaf2b$var$messages = (0, $7qGN1.defineMessages)({
    noOwner: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-owner",
        "defaultMessage": "No owner"
    }
});
function $a84fe34048ddaf2b$export$2e2bcd8739ae039(props) {
    const { ownerName: ownerName, ownerId: ownerId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return ownerId && ownerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "project-directories.components.compass-table.cells.owner.link",
        appearance: "link",
        spacing: "none",
        href: `/compass/people/team/${ownerId}`,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'ownerLink');
        }
    }, ownerName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kq24V.SubtleText), null, formatMessage($a84fe34048ddaf2b$var$messages.noOwner));
}

});

parcelRegister("7GTKv", function(module, exports) {
$parcel$export(module.exports, "RepositoryCell", () => $3bc5782bcd1a2dde$export$b9085fe6b12a0b7b);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $18DG7 = parcelRequire("18DG7");
var $fqBfo = parcelRequire("fqBfo");

var $8YHJ2 = parcelRequire("8YHJ2");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kq24V = parcelRequire("kq24V");

var $8ytjA = parcelRequire("8ytjA");

var $1EGkp = parcelRequire("1EGkp");
const $3bc5782bcd1a2dde$var$RE_BITBUCKET_REPOSITORY = /^https?:\/\/bitbucket\.org\//;
const $3bc5782bcd1a2dde$export$ed662bf1621eb175 = 1;
function $3bc5782bcd1a2dde$export$b9085fe6b12a0b7b({ repositoryLinks: repositoryLinks }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const bubbledRepositoryLinks = (0, $eJOHy.useMemo)(()=>$3bc5782bcd1a2dde$export$37c5febb87944530(repositoryLinks), [
        repositoryLinks
    ]);
    if (bubbledRepositoryLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kq24V.SubtleText), null, formatMessage((0, $8ytjA.default).noRepository));
    const displayedRepositoryLinks = bubbledRepositoryLinks.slice(0, $3bc5782bcd1a2dde$export$ed662bf1621eb175);
    const remainingRepositoryLinks = bubbledRepositoryLinks.slice($3bc5782bcd1a2dde$export$ed662bf1621eb175);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, displayedRepositoryLinks.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bc5782bcd1a2dde$var$LinkContainer, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YHJ2.CardSSR), {
            testId: "project-directories.components.compass-table.cells.repository.smart-link",
            url: link.url,
            appearance: "inline",
            placeholder: link.name || link.url,
            ui: {
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                clickableContainer: true
            },
            onClick: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                });
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'repositoryLink');
            },
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $18DG7.CardAction).ChangeStatusAction
                ]
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
            text: link.name,
            maxLines: 1,
            hideIcon: true
        })), index === displayedRepositoryLinks.length - 1 && remainingRepositoryLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1EGkp.default), {
            repositories: remainingRepositoryLinks
        }))));
}
function $3bc5782bcd1a2dde$export$af662343bda1b144(links) {
    return links.filter((link)=>link.type === 'REPOSITORY');
}
function $3bc5782bcd1a2dde$export$37c5febb87944530(repositoryLinks, sort = true) {
    const bitbucketLinks = repositoryLinks.filter((link)=>$3bc5782bcd1a2dde$var$RE_BITBUCKET_REPOSITORY.test(link.url));
    const remainingLinks = repositoryLinks.filter((link)=>!$3bc5782bcd1a2dde$var$RE_BITBUCKET_REPOSITORY.test(link.url));
    if (sort) {
        const comparator = (a, b)=>{
            if (!!a.name && !b.name) return -1;
            if (!a.name && !!b.name) return 1;
            return (a.name || a.url).localeCompare(b.name || b.url);
        };
        bitbucketLinks.sort(comparator);
        remainingLinks.sort(comparator);
    }
    remainingLinks.unshift(...bitbucketLinks);
    return remainingLinks;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bc5782bcd1a2dde$var$LinkContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _116e116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("18DG7", function(module, exports) {
$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("fqBfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0af5d75f753a471$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $5FRJ8 = parcelRequire("5FRJ8");

var $i6ktq = parcelRequire("i6ktq");

var $6P8F3 = parcelRequire("6P8F3");

var $gjoE0 = parcelRequire("gjoE0");

var $haRRg = parcelRequire("haRRg");

var $1Ub5D = parcelRequire("1Ub5D");
const $a0af5d75f753a471$var$actionStyles = null;
const $a0af5d75f753a471$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return 0, $1Ub5D.default;
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return 0, $haRRg.default;
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return 0, $gjoE0.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $a0af5d75f753a471$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const { status: status = (0, $5NtHI.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6ktq.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $a0af5d75f753a471$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $a0af5d75f753a471$export$2e2bcd8739ae039 = $a0af5d75f753a471$var$TitleBlock;

});
parcelRegister("5NtHI", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc2e49eaf9e6df05$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc2e49eaf9e6df05$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc2e49eaf9e6df05$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc2e49eaf9e6df05$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc2e49eaf9e6df05$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc2e49eaf9e6df05$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc2e49eaf9e6df05$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc2e49eaf9e6df05$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc2e49eaf9e6df05$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc2e49eaf9e6df05$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc2e49eaf9e6df05$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc2e49eaf9e6df05$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc2e49eaf9e6df05$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc2e49eaf9e6df05$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc2e49eaf9e6df05$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc2e49eaf9e6df05$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc2e49eaf9e6df05$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc2e49eaf9e6df05$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804);
const $fc2e49eaf9e6df05$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc2e49eaf9e6df05$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc2e49eaf9e6df05$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc2e49eaf9e6df05$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc2e49eaf9e6df05$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc2e49eaf9e6df05$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc2e49eaf9e6df05$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc2e49eaf9e6df05$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc2e49eaf9e6df05$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc2e49eaf9e6df05$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc2e49eaf9e6df05$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc2e49eaf9e6df05$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc2e49eaf9e6df05$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc2e49eaf9e6df05$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc2e49eaf9e6df05$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc2e49eaf9e6df05$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc2e49eaf9e6df05$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc2e49eaf9e6df05$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("e3qu2", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $3d45ba8ff999246a$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $3d45ba8ff999246a$export$df67f318ded0283c);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $liquj = parcelRequire("liquj");
var $3d45ba8ff999246a$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $3d45ba8ff999246a$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $3d45ba8ff999246a$var$isNotLeftClick = (event)=>event.button !== 0;
const $3d45ba8ff999246a$export$df67f318ded0283c = (onMouseDown)=>{
    return $3d45ba8ff999246a$export$5993d3ca6c85f774(onMouseDown, $3d45ba8ff999246a$var$isNotLeftClick);
};

});
parcelRegister("liquj", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $9bb097c912a9f010$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $9bb097c912a9f010$export$263352d59c0c5966);

var $eJOHy = parcelRequire("eJOHy");

var $8GnsF = parcelRequire("8GnsF");

var $ca7s3 = parcelRequire("ca7s3");

var $cbSL1 = parcelRequire("cbSL1");

var $e3qu2 = parcelRequire("e3qu2");

var $b43DQ = parcelRequire("b43DQ");
const $9bb097c912a9f010$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $9bb097c912a9f010$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $9bb097c912a9f010$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $9bb097c912a9f010$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $8GnsF.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($9bb097c912a9f010$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $9bb097c912a9f010$var$linkClickedEventOld = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $9bb097c912a9f010$var$linkClickedEventWithShortLink = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented, isConfluenceShortLink: isConfluenceShortLink })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    });
const $9bb097c912a9f010$export$880d2168464029dd = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $9bb097c912a9f010$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $9bb097c912a9f010$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $9bb097c912a9f010$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $9bb097c912a9f010$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $9bb097c912a9f010$export$fb40cb818618aeeb = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $9bb097c912a9f010$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $9bb097c912a9f010$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $9bb097c912a9f010$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    let isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    const linkClickedEventResult = $9bb097c912a9f010$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $9bb097c912a9f010$export$7fedc699766c16de = (0, $ca7s3.functionWithCondition)(()=>(0, $cbSL1.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test'), $9bb097c912a9f010$export$fb40cb818618aeeb, $9bb097c912a9f010$export$880d2168464029dd);
const $9bb097c912a9f010$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $9bb097c912a9f010$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
const $9bb097c912a9f010$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $9bb097c912a9f010$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $e3qu2.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $e3qu2.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$9bb097c912a9f010$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("8GnsF", function(module, exports) {
$parcel$export(module.exports, "browser", () => $9001dc59012896ed$export$3f2684e5d7cb1006);
const $9001dc59012896ed$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9001dc59012896ed$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9001dc59012896ed$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9001dc59012896ed$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9001dc59012896ed$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9001dc59012896ed$var$result.android = /Android \d/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9001dc59012896ed$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9001dc59012896ed$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9001dc59012896ed$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9001dc59012896ed$export$3f2684e5d7cb1006() {
    return $9001dc59012896ed$var$result;
}

});

parcelRegister("ca7s3", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $2c308d3097081b64$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $2c308d3097081b64$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $2c308d3097081b64$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $2c308d3097081b64$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("b43DQ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3132e66a6b380708$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3132e66a6b380708$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3132e66a6b380708$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3132e66a6b380708$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3132e66a6b380708$export$b91e0203b928470c);
const $3132e66a6b380708$export$85183a312807388d = 'media';
const $3132e66a6b380708$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3132e66a6b380708$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3132e66a6b380708$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3132e66a6b380708$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3132e66a6b380708$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3132e66a6b380708$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3132e66a6b380708$export$85183a312807388d);
};

});



parcelRegister("5FRJ8", function(module, exports) {
$parcel$export(module.exports, "FlexibleCardContext", () => $26ead80b20537add$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $26ead80b20537add$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "useFlexibleUiContext", () => $26ead80b20537add$export$61d7957a243df7aa);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $26ead80b20537add$export$e6b5ad18b56e8f51);

var $eJOHy = parcelRequire("eJOHy");
const $26ead80b20537add$export$13dde4423ab71d62 = (0, $eJOHy.createContext)(undefined);
const $26ead80b20537add$export$a8c4167e4e9f26ab = ()=>(0, $eJOHy.useContext)($26ead80b20537add$export$13dde4423ab71d62);
const $26ead80b20537add$export$61d7957a243df7aa = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.data;
const $26ead80b20537add$export$e6b5ad18b56e8f51 = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.ui;

});

parcelRegister("i6ktq", function(module, exports) {
$parcel$export(module.exports, "default", () => $890c0338844dfde1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $890c0338844dfde1$var$TitleElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Title
    }) : null;
};
var $890c0338844dfde1$export$2e2bcd8739ae039 = $890c0338844dfde1$var$TitleElement;

});
parcelRegister("8ygPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $adbc5d7a57662063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $fQH39 = parcelRequire("fQH39");
const $adbc5d7a57662063$var$DEFAULT_MAX_LINES = 2;
const $adbc5d7a57662063$var$MAXIMUM_MAX_LINES = 2;
const $adbc5d7a57662063$var$MINIMUM_MAX_LINES = 1;
const $adbc5d7a57662063$var$containerStyles = null;
const $adbc5d7a57662063$var$getMaxLines = (maxLines)=>{
    if (maxLines > $adbc5d7a57662063$var$MAXIMUM_MAX_LINES) return $adbc5d7a57662063$var$DEFAULT_MAX_LINES;
    if (maxLines < $adbc5d7a57662063$var$MINIMUM_MAX_LINES) return $adbc5d7a57662063$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $adbc5d7a57662063$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $adbc5d7a57662063$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $adbc5d7a57662063$var$baseAnchorStyle = null;
const $adbc5d7a57662063$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $adbc5d7a57662063$var$anchorConstantsStyles = null;
const $adbc5d7a57662063$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $adbc5d7a57662063$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1gjq _f8pj1gjq _30l31gjq _10531gjq",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $adbc5d7a57662063$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $adbc5d7a57662063$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5NtHI.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const hasSpace = (0, $eJOHy.useMemo)(()=>text ? (0, $fQH39.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $adbc5d7a57662063$var$linkStyleSizeMap[size],
            $adbc5d7a57662063$var$anchorLineClampMap[$adbc5d7a57662063$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $adbc5d7a57662063$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 1 && $adbc5d7a57662063$var$anchorLinkLineHeight1Map[size],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 2 && $adbc5d7a57662063$var$anchorLinkLineHeight2Map[size],
            $adbc5d7a57662063$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $adbc5d7a57662063$var$withTooltip(anchor, text, testId)
    });
};
var $adbc5d7a57662063$export$2e2bcd8739ae039 = $adbc5d7a57662063$var$BaseLinkElement;
const $adbc5d7a57662063$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});
parcelRegister("fQH39", function(module, exports) {
$parcel$export(module.exports, "sizeToButtonSpacing", () => $18f1b25c1730b97c$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $18f1b25c1730b97c$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $18f1b25c1730b97c$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $18f1b25c1730b97c$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $18f1b25c1730b97c$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $18f1b25c1730b97c$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $18f1b25c1730b97c$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $18f1b25c1730b97c$export$619e376a425cb759);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $joSn0 = parcelRequire("joSn0");

var $5NtHI = parcelRequire("5NtHI");
const $18f1b25c1730b97c$export$9d642f65a919fb93 = {
    [(0, $5NtHI.SmartLinkSize).Small]: 'none',
    [(0, $5NtHI.SmartLinkSize).Medium]: 'compact',
    [(0, $5NtHI.SmartLinkSize).Large]: 'compact',
    [(0, $5NtHI.SmartLinkSize).XLarge]: 'default'
};
const $18f1b25c1730b97c$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        });
    }
};
const $18f1b25c1730b97c$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $18f1b25c1730b97c$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $18f1b25c1730b97c$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $18f1b25c1730b97c$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1.75;
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $18f1b25c1730b97c$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $18f1b25c1730b97c$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5NtHI.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $18f1b25c1730b97c$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("6P8F3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6bccbbfb4f78611$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $brTAh = parcelRequire("brTAh");

var $a86OV = parcelRequire("a86OV");
const $a6bccbbfb4f78611$var$styles = null;
const $a6bccbbfb4f78611$var$renderActionItems = (items = [], size = (0, $5NtHI.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a86OV.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a6bccbbfb4f78611$var$ActionGroup = ({ items: items = [], size: size = (0, $5NtHI.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gRw8I.di)((0, $7rjYb.default));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const renderableActionItems = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fQH39.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).more_actions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $a6bccbbfb4f78611$export$2e2bcd8739ae039 = $a6bccbbfb4f78611$var$ActionGroup;

});
parcelRegister("aMdh8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52a17cfb35b19ee3ae1ff9abc93d8023>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d88af49f9584885$var$_react = $7d88af49f9584885$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7d88af49f9584885$var$_showMoreHorizontal = $7d88af49f9584885$var$_interopRequireDefault((parcelRequire("NByNW")));

var $7d88af49f9584885$var$_more = $7d88af49f9584885$var$_interopRequireDefault((parcelRequire("31yN3")));
function $7d88af49f9584885$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d88af49f9584885$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $7d88af49f9584885$var$_react.default.createElement($7d88af49f9584885$var$_showMoreHorizontal.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        LEGACY_fallbackIcon: $7d88af49f9584885$var$_more.default
    }, props));
$7d88af49f9584885$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIconMigration';
var $7d88af49f9584885$var$_default = module.exports.default = $7d88af49f9584885$var$ShowMoreHorizontalIcon;

});
parcelRegister("31yN3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $233c73b2e7ab22d3$var$_react = $233c73b2e7ab22d3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $233c73b2e7ab22d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $233c73b2e7ab22d3$var$MoreIcon = (props)=>/*#__PURE__*/ $233c73b2e7ab22d3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props));
$233c73b2e7ab22d3$var$MoreIcon.displayName = 'MoreIcon';
var $233c73b2e7ab22d3$var$_default = module.exports.default = $233c73b2e7ab22d3$var$MoreIcon;

});


parcelRegister("19nmp", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d6bf071ed8fc5324$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d6bf071ed8fc5324$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Description on what Follow does'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    }
});

});

parcelRegister("brTAh", function(module, exports) {
$parcel$export(module.exports, "filterActionItems", () => $a0fe758b77d980f4$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $a0fe758b77d980f4$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $a0fe758b77d980f4$export$9678d3ca18bd7526);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $1YI3f = parcelRequire("1YI3f");

var $4RG9i = parcelRequire("4RG9i");

var $6P8F3 = parcelRequire("6P8F3");

var $k8J0S = parcelRequire("k8J0S");
const $a0fe758b77d980f4$export$f942619ce67b1a41 = {
    [(0, $5NtHI.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Location]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Preview]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).State]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Title]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).VoteCount]: [
        'inline'
    ]
};
const $a0fe758b77d980f4$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1;
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $a0fe758b77d980f4$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $6P8F3.default);
const $a0fe758b77d980f4$var$isElementDisplayValid = (name, display)=>{
    return $a0fe758b77d980f4$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $a0fe758b77d980f4$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $a0fe758b77d980f4$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && ((0, $1YI3f.isFlexibleUiElement)(node) || node.type === (0, $k8J0S.default));
const $a0fe758b77d980f4$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5NtHI.ActionName).DeleteAction:
            case (0, $5NtHI.ActionName).EditAction:
            case (0, $5NtHI.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5NtHI.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $a0fe758b77d980f4$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if ($a0fe758b77d980f4$var$isElementOrElementGroup(child) || $a0fe758b77d980f4$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $a0fe758b77d980f4$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4RG9i[name];
        const typedProps = props;
        if (Element && $a0fe758b77d980f4$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $gt9Am.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$a0fe758b77d980f4$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1YI3f", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiCard", () => $ec5109f5e7b621c7$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isStyleCacheProvider", () => $ec5109f5e7b621c7$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $ec5109f5e7b621c7$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $ec5109f5e7b621c7$export$c0547b4405cae584);

var $eJOHy = parcelRequire("eJOHy");

var $34CM9 = parcelRequire("34CM9");
var $fqBfo = parcelRequire("fqBfo");
var $8Rjtc = parcelRequire("8Rjtc");
var $lAF2k = parcelRequire("lAF2k");

var $4RG9i = parcelRequire("4RG9i");
const $ec5109f5e7b621c7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).some((child)=>$ec5109f5e7b621c7$export$df0092b19156b140(child))) return true;
    return false;
};
const $ec5109f5e7b621c7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($34CM9).some((type)=>type === node.type)) return true;
    return false;
};
const $ec5109f5e7b621c7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (Object.values($4RG9i).some((type)=>type === node.type)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $fqBfo.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $8Rjtc.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $lAF2k.default);

});
parcelRegister("34CM9", function(module, exports) {
$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("lAF2k")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gKsxm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("8Rjtc")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("5gb8b")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("fqBfo")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("bIdM1")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("3pcXQ")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("2qnEp")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("eMgzj")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("4cjOx")).default);

var $lAF2k = parcelRequire("lAF2k");

var $gKsxm = parcelRequire("gKsxm");

var $8Rjtc = parcelRequire("8Rjtc");

var $5gb8b = parcelRequire("5gb8b");

var $fqBfo = parcelRequire("fqBfo");

var $bIdM1 = parcelRequire("bIdM1");

var $3pcXQ = parcelRequire("3pcXQ");

var $2qnEp = parcelRequire("2qnEp");

var $eMgzj = parcelRequire("eMgzj");

var $4cjOx = parcelRequire("4cjOx");

});
parcelRegister("lAF2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b59a3b7a9f7670d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3pcXQ = parcelRequire("3pcXQ");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $9b59a3b7a9f7670d$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $9b59a3b7a9f7670d$export$2e2bcd8739ae039 = $9b59a3b7a9f7670d$var$FooterBlock;

});
parcelRegister("3pcXQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $462a2917906f3b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $6P8F3 = parcelRequire("6P8F3");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $462a2917906f3b08$var$actionGroupStyles = null;
const $462a2917906f3b08$var$safariStyles = null;
const $462a2917906f3b08$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5NtHI.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const hasActions = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                testId: "smart-element-group-actions",
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                className: (0, $hcewu.default)([
                    size === (0, $5NtHI.SmartLinkSize).XLarge && "_c71lxy5q",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $462a2917906f3b08$export$2e2bcd8739ae039 = $462a2917906f3b08$var$FooterBlockResolvedView;

});
parcelRegister("6l7Bk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a8115736e8f2ac6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $2a8115736e8f2ac6$var$ProviderElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Provider
    }) : null;
};
var $2a8115736e8f2ac6$export$2e2bcd8739ae039 = $2a8115736e8f2ac6$var$ProviderElement;

});
parcelRegister("4XCp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $e83b25175c466aed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $e83b25175c466aed$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $e83b25175c466aed$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $e83b25175c466aed$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $e83b25175c466aed$var$messageMapper = {
    [(0, $5NtHI.IconType).PriorityBlocker]: (0, $19nmp.messages).priority_blocker,
    [(0, $5NtHI.IconType).PriorityCritical]: (0, $19nmp.messages).priority_critical,
    [(0, $5NtHI.IconType).PriorityHigh]: (0, $19nmp.messages).priority_high,
    [(0, $5NtHI.IconType).PriorityHighest]: (0, $19nmp.messages).priority_highest,
    [(0, $5NtHI.IconType).PriorityLow]: (0, $19nmp.messages).priority_low,
    [(0, $5NtHI.IconType).PriorityLowest]: (0, $19nmp.messages).priority_lowest,
    [(0, $5NtHI.IconType).PriorityMajor]: (0, $19nmp.messages).priority_major,
    [(0, $5NtHI.IconType).PriorityMedium]: (0, $19nmp.messages).priority_medium,
    [(0, $5NtHI.IconType).PriorityMinor]: (0, $19nmp.messages).priority_minor,
    [(0, $5NtHI.IconType).PriorityTrivial]: (0, $19nmp.messages).priority_trivial,
    [(0, $5NtHI.IconType).PriorityUndefined]: (0, $19nmp.messages).priority_undefined
};
const $e83b25175c466aed$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e83b25175c466aed$var$messageMapper[icon];
        if (descriptor) return (0, $fQH39.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e83b25175c466aed$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e83b25175c466aed$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e83b25175c466aed$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const ui = (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FRJ8.useFlexibleUiOptionContext)() : undefined;
    const formattedMessageOrLabel = $e83b25175c466aed$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e83b25175c466aed$var$renderAtlaskitIcon(icon, testId) || $e83b25175c466aed$var$renderImageIcon(url, testId, ui?.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $hcewu.default)([
            $e83b25175c466aed$var$styles.container,
            $e83b25175c466aed$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $e83b25175c466aed$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $e83b25175c466aed$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
var $e83b25175c466aed$export$2e2bcd8739ae039 = (0, $9jYtV.withOverrideCss)($e83b25175c466aed$var$BaseBadgeRefreshNew);
const $e83b25175c466aed$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("b4zhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d5d1de8f417451$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $lgMTT = parcelRequire("lgMTT");

var $eGOwo = parcelRequire("eGOwo");

var $4Gz8O = parcelRequire("4Gz8O");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $d6d5d1de8f417451$var$getIconImportFn = (icon, size)=>{
    const item = (0, $FoFt2.getLazyIcons)()[icon];
    if ((0, $FoFt2.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $d6d5d1de8f417451$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $d6d5d1de8f417451$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5NtHI.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5NtHI.IconType).Document:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).Blog:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $d6d5d1de8f417451$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $d6d5d1de8f417451$var$importIcon(importFn);
    switch(icon){
        case (0, $5NtHI.IconType).Confluence:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5NtHI.IconType).Jira:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall',
                ...(0, $eGOwo.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            });
        case (0, $5NtHI.IconType).Error:
        case (0, $5NtHI.IconType).Forbidden:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $d6d5d1de8f417451$export$2e2bcd8739ae039 = $d6d5d1de8f417451$var$AtlaskitIcon;

});
parcelRegister("4Gz8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1589456b7a180f6b$export$2e2bcd8739ae039);

var $ihwup = parcelRequire("ihwup");

var $ff2hw = parcelRequire("ff2hw");

var $cPcks = parcelRequire("cPcks");
const $1589456b7a180f6b$var$BlogIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ihwup.default), (0, $ff2hw.default));
$1589456b7a180f6b$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $1589456b7a180f6b$export$2e2bcd8739ae039 = $1589456b7a180f6b$var$BlogIconWithColor;

});
parcelRegister("ihwup", function(module, exports) {
$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25f59ea2b6bc25c62576440e4e014d55>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $ixkyU = parcelRequire("ixkyU");

var $eGOwo = parcelRequire("eGOwo");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ixkyU.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("6IK2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $df1c2fc9df73f09d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $41qqA = parcelRequire("41qqA");

var $l77v2 = parcelRequire("l77v2");
// Color mapping for size 16 standalone icons that will no longer be tiles
const $df1c2fc9df73f09d$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $df1c2fc9df73f09d$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, LEGACY_fallbackComponent: LEGACY_fallbackComponent, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && (0, $eGOwo.fg)('platform_dst_icon_tile_circle_replacement')) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && (0, $eGOwo.fg)('platform_dst_new_icon_tile')) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            color: $df1c2fc9df73f09d$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $41qqA.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l77v2.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});
parcelRegister("41qqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef39d2750ac3c535$export$2e2bcd8739ae039);
/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ieO20 = parcelRequire("ieO20");
const $ef39d2750ac3c535$var$sizeCrossCompatibleMap = {
    // Size mapping from old pixel sizes to new t-shirt sizes
    '16': 'xsmall',
    // Not used
    '24': 'small',
    '32': 'medium',
    '40': 'large',
    '48': 'xlarge',
    xsmall: 'xsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
// Icon color mapping for Tile-based icons
const $ef39d2750ac3c535$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
// Background color mapping for Tile component
const $ef39d2750ac3c535$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $ef39d2750ac3c535$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'small', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ieO20.default), {
        size: $ef39d2750ac3c535$var$sizeCrossCompatibleMap[size],
        backgroundColor: $ef39d2750ac3c535$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            className: (0, $hcewu.default)([
                $ef39d2750ac3c535$var$iconColorMap[appearance]
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: label,
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("ieO20", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a27c3c406dff3d5$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9a27c3c406dff3d5$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $9a27c3c406dff3d5$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $9a27c3c406dff3d5$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $9a27c3c406dff3d5$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk18uv",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $9a27c3c406dff3d5$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hcewu.default)([
            $9a27c3c406dff3d5$var$styles.root,
            $9a27c3c406dff3d5$var$sizeMap[size],
            isInset ? $9a27c3c406dff3d5$var$styles.inset : $9a27c3c406dff3d5$var$styles.nonInset,
            isInset && $9a27c3c406dff3d5$var$insetSizeMap[size],
            $9a27c3c406dff3d5$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $9a27c3c406dff3d5$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("l77v2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd87b3d482b8dffc$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bd87b3d482b8dffc$var$sizeCrossCompatibleMap = {
    // Size mapping from new t-shirt sizes to old pixel sizes
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48',
    '16': '16',
    '24': '24',
    '32': '32',
    '40': '40',
    '48': '48'
};
const $bd87b3d482b8dffc$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $bd87b3d482b8dffc$var$appearanceMap = {
    grayBold: "_bfhk1i45 _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhk16e3 _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkya33 _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhk1qg1 _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk7qp0 _syaz1diz",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhk165s _syaz1j6y",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk1dy8 _syaz6txe",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1nm4 _syazuq3u",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk1773 _syaz1oqg"
};
const $bd87b3d482b8dffc$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $bd87b3d482b8dffc$var$iconTileStyles = null;
function $bd87b3d482b8dffc$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $bd87b3d482b8dffc$var$appearanceMap[appearance],
            $bd87b3d482b8dffc$var$sizeMap[$bd87b3d482b8dffc$var$sizeCrossCompatibleMap[size]],
            $bd87b3d482b8dffc$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});


parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b5ace82dd4a8965510da799b9153030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("ixkyU", function(module, exports) {
$parcel$export(module.exports, "default", () => $efb8455781b7b8dd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $amerd = parcelRequire("amerd");

var $gPsTF = parcelRequire("gPsTF");
function $efb8455781b7b8dd$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("gPsTF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9228c397c6e87f34$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $9228c397c6e87f34$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});


parcelRegister("37A7r", function(module, exports) {
$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7cef41f07f9ec4679337b66fb782a07>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("ff2hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $674c38c84d40fa8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee7129996bcdd9cb958d21a3e9c19719>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $amerd = parcelRequire("amerd");

var $iG796 = parcelRequire("iG796");

var $eGOwo = parcelRequire("eGOwo");

var $4HJXf = parcelRequire("4HJXf");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $674c38c84d40fa8d$var$Blog24Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iG796.default), {
        label: label,
        testId: testId,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
            label: label,
            testId: testId
        })
    });
};
$674c38c84d40fa8d$var$Blog24Icon.displayName = 'Blog24Icon';
var $674c38c84d40fa8d$export$2e2bcd8739ae039 = $674c38c84d40fa8d$var$Blog24Icon;

});
parcelRegister("iG796", function(module, exports) {
$parcel$export(module.exports, "default", () => $055e9e84485f53e7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $amerd = parcelRequire("amerd");

var $lkXQr = parcelRequire("lkXQr");
function $055e9e84485f53e7$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkXQr.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});
parcelRegister("lkXQr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9a1681b19d12ba2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $ieO20 = parcelRequire("ieO20");
function $e9a1681b19d12ba2$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $8GOss.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ieO20.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});


parcelRegister("4HJXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ddb48944e405ac0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90dcc35b3376b79911c4054d7edd4bc7>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $2ddb48944e405ac0$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$2ddb48944e405ac0$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ddb48944e405ac0$export$2e2bcd8739ae039 = $2ddb48944e405ac0$var$Blog24Icon;

});


parcelRegister("cPcks", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $5c2d46cff1f07a26$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $5c2d46cff1f07a26$export$87c3646d0e299cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $5c2d46cff1f07a26$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $5c2d46cff1f07a26$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $FoFt2.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $gt9Am.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(IconSmall, {
            ...props
        });
    };
};
const $5c2d46cff1f07a26$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
            appearance: appearance,
            icon: Icon,
            size: $5c2d46cff1f07a26$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $gt9Am.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("FoFt2", function(module, exports) {
$parcel$export(module.exports, "isSpecialEvent", () => $4836221d615e2d0d$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $4836221d615e2d0d$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $4836221d615e2d0d$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $4836221d615e2d0d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $4836221d615e2d0d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4836221d615e2d0d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4836221d615e2d0d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4836221d615e2d0d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4836221d615e2d0d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4836221d615e2d0d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4836221d615e2d0d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4836221d615e2d0d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $4836221d615e2d0d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $4836221d615e2d0d$export$6a4545d6b336c401);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $4CCpn = parcelRequire("4CCpn");

var $5NtHI = parcelRequire("5NtHI");

var $dyU3L = parcelRequire("dyU3L");
const $4836221d615e2d0d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4836221d615e2d0d$export$e6c5ffa684aac4d7() || $4836221d615e2d0d$export$d8de0cd37d316fdf(evt) || $4836221d615e2d0d$export$5b1771037ab7c451(evt));
const $4836221d615e2d0d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4836221d615e2d0d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $eGOwo.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $4836221d615e2d0d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4836221d615e2d0d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4836221d615e2d0d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};



























































































const $4836221d615e2d0d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5NtHI.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9dPtp")))
        },
        [(0, $5NtHI.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("4Gz8O")))
        },
        [(0, $5NtHI.IconType).Audio]: {
            default: ()=>(parcelRequire("cesFU"))
        },
        [(0, $5NtHI.IconType).Code]: {
            default: ()=>(parcelRequire("2hxmV"))
        },
        [(0, $5NtHI.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Folder]: {
            default: ()=>(parcelRequire("2vlwA"))
        },
        [(0, $5NtHI.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Image]: {
            default: ()=>(parcelRequire("ka9UC"))
        },
        [(0, $5NtHI.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("lQKQC")))
        },
        [(0, $5NtHI.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("4VIPx")))
        },
        [(0, $5NtHI.IconType).Video]: {
            default: ()=>(parcelRequire("4FvfE"))
        },
        [(0, $5NtHI.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lG2jM")))
        },
        [(0, $5NtHI.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kSre2")))
        },
        [(0, $5NtHI.IconType).Forbidden]: {
            default: ()=>(parcelRequire("c0UF0"))
        },
        [(0, $5NtHI.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("av9Of")))
        },
        [(0, $5NtHI.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("1NG86")))
        },
        [(0, $5NtHI.IconType).Archive]: {
            default: ()=>(parcelRequire("jpGdL")),
            large: ()=>(parcelRequire("1NPeV"))
        },
        [(0, $5NtHI.IconType).Executable]: {
            default: ()=>(parcelRequire("2SUZV")),
            large: ()=>(parcelRequire("ecxmi"))
        },
        [(0, $5NtHI.IconType).GIF]: {
            default: ()=>(parcelRequire("htCgV")),
            large: ()=>(parcelRequire("1o94f"))
        },
        [(0, $5NtHI.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("3iL1Z")),
            large: ()=>(parcelRequire("gTZE5"))
        },
        [(0, $5NtHI.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("dEWSV")),
            large: ()=>(parcelRequire("mDHVB"))
        },
        [(0, $5NtHI.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("lGiQr")),
            large: ()=>(parcelRequire("7SZRT"))
        },
        [(0, $5NtHI.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("1L06r")),
            large: ()=>(parcelRequire("ip4Y7"))
        },
        [(0, $5NtHI.IconType).MSExcel]: {
            default: ()=>(parcelRequire("hSMHC")),
            large: ()=>(parcelRequire("9GQwc"))
        },
        [(0, $5NtHI.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("1pcgz")),
            large: ()=>(parcelRequire("554ft"))
        },
        [(0, $5NtHI.IconType).MSWord]: {
            default: ()=>(parcelRequire("lt3XL")),
            large: ()=>(parcelRequire("19vwX"))
        },
        [(0, $5NtHI.IconType).PDF]: {
            default: ()=>(parcelRequire("5H4a5")),
            large: ()=>(parcelRequire("cMK2y"))
        },
        [(0, $5NtHI.IconType).Sketch]: {
            default: ()=>(parcelRequire("j6e97")),
            large: ()=>(parcelRequire("5sMJg"))
        },
        // Bitbucket icons
        [(0, $5NtHI.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("liS9g"))),
            large: ()=>(parcelRequire("bQ1N4"))
        },
        [(0, $5NtHI.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("6wUJL"))),
            large: ()=>(parcelRequire("4OxG9"))
        },
        [(0, $5NtHI.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("es92x"))),
            large: ()=>(parcelRequire("1JRRC"))
        },
        [(0, $5NtHI.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gSqCA"))),
            large: ()=>(parcelRequire("gjbfK"))
        },
        // Jira icons
        [(0, $5NtHI.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("i3nvV"))),
            large: ()=>(parcelRequire("jVyke"))
        },
        [(0, $5NtHI.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("59W6U"))),
            large: ()=>(parcelRequire("70fC5"))
        },
        [(0, $5NtHI.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("4VGMo"))),
            large: ()=>(parcelRequire("bUsl4"))
        },
        [(0, $5NtHI.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("h6Xfo"))),
            large: ()=>(parcelRequire("8jWxq"))
        },
        [(0, $5NtHI.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("erbJ6"))),
            large: ()=>(parcelRequire("7MVkC"))
        },
        [(0, $5NtHI.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("8WXuv"))),
            large: ()=>(parcelRequire("acF2K"))
        },
        [(0, $5NtHI.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("iaeCZ"))),
            large: ()=>(parcelRequire("5Z3lN"))
        },
        [(0, $5NtHI.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dV8me"))),
            large: ()=>(parcelRequire("1wvhU"))
        },
        [(0, $5NtHI.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("cOjgE"))),
            large: ()=>(parcelRequire("dyxwG"))
        },
        // Confluence icons
        [(0, $5NtHI.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("ilCAi"))),
            large: ()=>Promise.resolve((parcelRequire("hB03j")))
        },
        // Provider icons
        [(0, $5NtHI.IconType).Confluence]: {
            default: ()=>(parcelRequire("8A134")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5NtHI.IconType).Jira]: {
            default: ()=>(parcelRequire("6cjQd")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5NtHI.IconType).Attachment]: {
            default: ()=>(parcelRequire("bCsrc"))
        },
        [(0, $5NtHI.IconType).CheckItem]: {
            default: ()=>(parcelRequire("brHgq"))
        },
        [(0, $5NtHI.IconType).Component]: {
            default: ()=>(parcelRequire("bNgFX"))
        },
        [(0, $5NtHI.IconType).Comment]: {
            default: ()=>(parcelRequire("7gCMb"))
        },
        [(0, $5NtHI.IconType).View]: {
            default: ()=>(parcelRequire("koFqW"))
        },
        [(0, $5NtHI.IconType).React]: {
            default: ()=>(parcelRequire("fUMvo"))
        },
        [(0, $5NtHI.IconType).Vote]: {
            default: ()=>(parcelRequire("bAVbi"))
        },
        [(0, $5NtHI.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("fOxQN"))
        },
        [(0, $5NtHI.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("ekbvS"))
        },
        [(0, $5NtHI.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("j0sW6"))
        },
        [(0, $5NtHI.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("75OGX"))
        },
        [(0, $5NtHI.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("3aNz8"))
        },
        [(0, $5NtHI.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("4MiqP"))
        },
        [(0, $5NtHI.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("1Azbr"))
        },
        [(0, $5NtHI.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("hxTO3"))
        },
        [(0, $5NtHI.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("lRlMN"))
        },
        [(0, $5NtHI.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("gdaQK"))
        },
        [(0, $5NtHI.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("cH3kb"))
        },
        [(0, $5NtHI.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("4ft1P"))
        },
        [(0, $5NtHI.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("hMpZ8")))
        },
        [(0, $5NtHI.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("93JYU"))
        }
    };
};
const $4836221d615e2d0d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $dyU3L.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $4836221d615e2d0d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $4836221d615e2d0d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4836221d615e2d0d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4836221d615e2d0d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4836221d615e2d0d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4836221d615e2d0d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4836221d615e2d0d$export$e772c8ff12451969(interval);
            return $4836221d615e2d0d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4836221d615e2d0d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4836221d615e2d0d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4836221d615e2d0d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $4CCpn.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $4836221d615e2d0d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5NtHI.SmartLinkSize).Large,
        (0, $5NtHI.SmartLinkSize).XLarge
    ].includes(size);
const $4836221d615e2d0d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("dyU3L", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aa425783d81a7e4$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/i18n/no-literal-string-in-object */ 
var $5NtHI = parcelRequire("5NtHI");
const $9aa425783d81a7e4$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $9aa425783d81a7e4$export$2e2bcd8739ae039 = $9aa425783d81a7e4$var$extractFileFormatIcon;

});

parcelRegister("9dPtp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a49966ca6c4774bc$export$2e2bcd8739ae039);

var $lImMk = parcelRequire("lImMk");

var $gxCW9 = parcelRequire("gxCW9");

var $DtmfJ = parcelRequire("DtmfJ");

var $cPcks = parcelRequire("cPcks");
const $a49966ca6c4774bc$var$PageIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), 'blueBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lImMk))), (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9)))));
$a49966ca6c4774bc$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a49966ca6c4774bc$export$2e2bcd8739ae039 = $a49966ca6c4774bc$var$PageIconWithColor;

});
parcelRegister("lImMk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fcef605c5c3325f6$var$_react = $fcef605c5c3325f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $fcef605c5c3325f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcef605c5c3325f6$var$Document16Icon = (props)=>/*#__PURE__*/ $fcef605c5c3325f6$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fcef605c5c3325f6$var$Document16Icon.displayName = 'Document16Icon';
var $fcef605c5c3325f6$var$_default = module.exports.default = $fcef605c5c3325f6$var$Document16Icon;

});

parcelRegister("gxCW9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c0adee7b3af1dc62$var$_react = $c0adee7b3af1dc62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c0adee7b3af1dc62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0adee7b3af1dc62$var$Document24Icon = (props)=>/*#__PURE__*/ $c0adee7b3af1dc62$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c0adee7b3af1dc62$var$Document24Icon.displayName = 'Document24Icon';
var $c0adee7b3af1dc62$var$_default = module.exports.default = $c0adee7b3af1dc62$var$Document24Icon;

});


parcelRegister("cesFU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lBret").then(()=>parcelRequire('lT9gU'));

});

parcelRegister("2hxmV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c4Piz").then(()=>parcelRequire('b9JjP'));

});

parcelRegister("2vlwA", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fJRo2").then(()=>parcelRequire('3JiAU'));

});

parcelRegister("ka9UC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("68koG").then(()=>parcelRequire('htaza'));

});

parcelRegister("4FvfE", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfpt4").then(()=>parcelRequire('idFH3'));

});

parcelRegister("c0UF0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3roEx").then(()=>parcelRequire('eDFE1'));

});

parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7207a1a192d06bb66aba669d57a8645>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.displayName = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});


parcelRegister("jpGdL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9mQM4").then(()=>parcelRequire('8UJE5'));

});

parcelRegister("1NPeV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6TgwN").then(()=>parcelRequire('8ALRN'));

});

parcelRegister("2SUZV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("43EiL").then(()=>parcelRequire('bKXd3'));

});

parcelRegister("ecxmi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gwPcN").then(()=>parcelRequire('gAsmN'));

});

parcelRegister("htCgV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i35Uh").then(()=>parcelRequire('ccKWN'));

});

parcelRegister("1o94f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8hizo").then(()=>parcelRequire('2Pj0H'));

});

parcelRegister("3iL1Z", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9vjhq").then(()=>parcelRequire('aSnEf'));

});

parcelRegister("gTZE5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8NlQy").then(()=>parcelRequire('iqmbF'));

});

parcelRegister("dEWSV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("j5W60").then(()=>parcelRequire('ju9Zq'));

});

parcelRegister("mDHVB", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lrwAv").then(()=>parcelRequire('hLw8T'));

});

parcelRegister("lGiQr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gHrjT").then(()=>parcelRequire('4BqrB'));

});

parcelRegister("7SZRT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("baRsZ").then(()=>parcelRequire('jpYYq'));

});

parcelRegister("1L06r", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hCGN9").then(()=>parcelRequire('cwxjA'));

});

parcelRegister("ip4Y7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eu7SV").then(()=>parcelRequire('4SXVP'));

});

parcelRegister("hSMHC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("igTGi").then(()=>parcelRequire('llYLq'));

});

parcelRegister("9GQwc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVQR6").then(()=>parcelRequire('91IX3'));

});

parcelRegister("1pcgz", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8A7Un").then(()=>parcelRequire('bxHzv'));

});

parcelRegister("554ft", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hmJtw").then(()=>parcelRequire('jb8ZN'));

});

parcelRegister("lt3XL", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fnRpB").then(()=>parcelRequire('FXbTY'));

});

parcelRegister("19vwX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("aXLoO").then(()=>parcelRequire('4w1Xx'));

});

parcelRegister("5H4a5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fMJrt").then(()=>parcelRequire('do41j'));

});

parcelRegister("cMK2y", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8FXkX").then(()=>parcelRequire('6OBnQ'));

});

parcelRegister("j6e97", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cxAqh").then(()=>parcelRequire('gbtcZ'));

});

parcelRegister("5sMJg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4kqRf").then(()=>parcelRequire('heBKY'));

});

parcelRegister("bQ1N4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kvxvv").then(()=>parcelRequire('2j1uF'));

});

parcelRegister("4OxG9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5DW8N").then(()=>parcelRequire('8J7Hh'));

});

parcelRegister("1JRRC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("er5Rw").then(()=>parcelRequire('ktJB5'));

});

parcelRegister("gjbfK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("a4ZTh").then(()=>parcelRequire('1O53N'));

});

parcelRegister("jVyke", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fVZub").then(()=>parcelRequire('jYfQG'));

});

parcelRegister("70fC5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("biRPG").then(()=>parcelRequire('gR3IA'));

});

parcelRegister("bUsl4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5PIwW").then(()=>parcelRequire('dmWJ4'));

});

parcelRegister("8jWxq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1zPk8").then(()=>parcelRequire('eHIwa'));

});

parcelRegister("7MVkC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hy7F8").then(()=>parcelRequire('lR9WO'));

});

parcelRegister("acF2K", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5UA41").then(()=>parcelRequire('aozTf'));

});

parcelRegister("5Z3lN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jQGZH").then(()=>parcelRequire('3mwl5'));

});

parcelRegister("1wvhU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("55GNU").then(()=>parcelRequire('7lmhQ'));

});

parcelRegister("dyxwG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eiZZR").then(()=>parcelRequire('f8Y7f'));

});

parcelRegister("ilCAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a3170ce3e9e98d41$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cbe873b765d214e34343034c1ec2722>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $cruFS = parcelRequire("cruFS");

var $cDkKD = parcelRequire("cDkKD");

var $eGOwo = parcelRequire("eGOwo");

var $7KbsS = parcelRequire("7KbsS");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a3170ce3e9e98d41$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cDkKD.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
            label: label,
            testId: testId
        })
    });
};
$a3170ce3e9e98d41$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $a3170ce3e9e98d41$export$2e2bcd8739ae039 = $a3170ce3e9e98d41$var$PageLiveDoc16Icon;

});
parcelRegister("cruFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90efccf3a3cdec59$var$_react = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90efccf3a3cdec59$var$_baseNew = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90efccf3a3cdec59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90efccf3a3cdec59$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $90efccf3a3cdec59$var$_react.default.createElement($90efccf3a3cdec59$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$90efccf3a3cdec59$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $90efccf3a3cdec59$var$_default = module.exports.default = $90efccf3a3cdec59$var$PageLiveDocIcon;

});

parcelRegister("cDkKD", function(module, exports) {
$parcel$export(module.exports, "default", () => $480ad5126b51835b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cruFS = parcelRequire("cruFS");

var $gPsTF = parcelRequire("gPsTF");
function $480ad5126b51835b$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("7KbsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $49cedc712f457d93$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0790382970f68205e1cae24a5f79045>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $49cedc712f457d93$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$49cedc712f457d93$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49cedc712f457d93$export$2e2bcd8739ae039 = $49cedc712f457d93$var$PageLiveDoc16Icon;

});


parcelRegister("hB03j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0bd6bb1ec7db3603$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f200c2eac2cd9165b71d24b95a477cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $cruFS = parcelRequire("cruFS");

var $2291z = parcelRequire("2291z");

var $eGOwo = parcelRequire("eGOwo");

var $kZFQQ = parcelRequire("kZFQQ");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0bd6bb1ec7db3603$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2291z.default), {
        label: label,
        testId: testId,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
            label: label,
            testId: testId
        })
    });
};
$0bd6bb1ec7db3603$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $0bd6bb1ec7db3603$export$2e2bcd8739ae039 = $0bd6bb1ec7db3603$var$PageLiveDoc24Icon;

});
parcelRegister("2291z", function(module, exports) {
$parcel$export(module.exports, "default", () => $87752ca850cdb3ff$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cruFS = parcelRequire("cruFS");

var $lkXQr = parcelRequire("lkXQr");
function $87752ca850cdb3ff$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkXQr.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("kZFQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6dc3d78982b295d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d75248a4a7ee8ec7fdf265d35dbedf6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $b6dc3d78982b295d$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$b6dc3d78982b295d$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6dc3d78982b295d$export$2e2bcd8739ae039 = $b6dc3d78982b295d$var$PageLiveDoc24Icon;

});


parcelRegister("8A134", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8qkPR").then(()=>parcelRequire('dci17'));

});

parcelRegister("6cjQd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fbn5L").then(()=>parcelRequire('C9929'));

});

parcelRegister("bCsrc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gKXx1").then(()=>parcelRequire('4KX56'));

});

parcelRegister("brHgq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("76xTz").then(()=>parcelRequire('3Y0kU'));

});

parcelRegister("bNgFX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("7gCMb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("erj8t").then(()=>parcelRequire('amxqt'));

});

parcelRegister("koFqW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zrOr").then(()=>parcelRequire('dtTJ9'));

});

parcelRegister("fUMvo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l1bMV").then(()=>parcelRequire('6b4Xr'));

});

parcelRegister("bAVbi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("fOxQN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Eivj").then(()=>parcelRequire('gbfWz'));

});

parcelRegister("ekbvS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYxgH").then(()=>parcelRequire('dRjRH'));

});

parcelRegister("j0sW6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7Asrt").then(()=>parcelRequire('9Vj9G'));

});

parcelRegister("75OGX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lHw2B").then(()=>parcelRequire('eRvGI'));

});

parcelRegister("3aNz8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kjPUS").then(()=>parcelRequire('6l95m'));

});

parcelRegister("4MiqP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iNoMF").then(()=>parcelRequire('fuz0W'));

});

parcelRegister("1Azbr", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4oVpa").then(()=>parcelRequire('dn2cU'));

});

parcelRegister("hxTO3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("66VwL").then(()=>parcelRequire('cAlmw'));

});

parcelRegister("lRlMN", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("giNlE").then(()=>parcelRequire('9HReW'));

});

parcelRegister("gdaQK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8vZhS").then(()=>parcelRequire('8Pg2Y'));

});

parcelRegister("cH3kb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("gLziw")
]).then(()=>parcelRequire('lrD2G'));

});

parcelRegister("4ft1P", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4Z2q8").then(()=>parcelRequire('ka71P'));

});

parcelRegister("93JYU", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kzCMD").then(()=>parcelRequire('kmi1F'));

});




parcelRegister("9020Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9e6bf288701895f$export$2e2bcd8739ae039);

var $ilCAi = parcelRequire("ilCAi");

var $hB03j = parcelRequire("hB03j");

var $cPcks = parcelRequire("cPcks");
const $d9e6bf288701895f$var$LiveDocumentIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ilCAi.default), (0, $hB03j.default));
$d9e6bf288701895f$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $d9e6bf288701895f$export$2e2bcd8739ae039 = $d9e6bf288701895f$var$LiveDocumentIconWithColor;

});


parcelRegister("67ulW", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e2ae224831a17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2HNHt = parcelRequire("2HNHt");

var $65mpR = parcelRequire("65mpR");
const $78e2ae224831a17c$var$styles = {
    roundImg: "_2rko1rr0"
};
const $78e2ae224831a17c$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hcewu.default)([
            appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: url,
        loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $hcewu.default)([
                appearance === 'round' && $78e2ae224831a17c$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $78e2ae224831a17c$export$2e2bcd8739ae039 = $78e2ae224831a17c$var$ImageIcon;

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("65mpR", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $dc3223680a49307e$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dc3223680a49307e$var$animationNameStyles = null;
const $dc3223680a49307e$var$loadingSkeletonStyle = null;
const $dc3223680a49307e$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hcewu.default)([
            "_2rkolb4i _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("9jYtV", function(module, exports) {
$parcel$export(module.exports, "withOverrideCss", () => $641d28b8590b444f$export$e0bdcacb944f1da6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $641d28b8590b444f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $eJOHy.useRef)(null);
        (0, $eJOHy.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});



parcelRegister("bIdM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b32359b6ff0e19a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $2b32359b6ff0e19a$var$baseBlockStyles = null;
const $2b32359b6ff0e19a$var$highlightRemoveStyles = null;
const $2b32359b6ff0e19a$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $2b32359b6ff0e19a$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2b32359b6ff0e19a$var$Block = ({ children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $eJOHy.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $2b32359b6ff0e19a$var$directionStyles[direction],
            $2b32359b6ff0e19a$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId,
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $2b32359b6ff0e19a$export$2e2bcd8739ae039 = $2b32359b6ff0e19a$var$Block;

});

parcelRegister("k8J0S", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef789dfa4e54c3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $7ef789dfa4e54c3c$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $7ef789dfa4e54c3c$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $7ef789dfa4e54c3c$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $7ef789dfa4e54c3c$var$baseStyles = null;
const $7ef789dfa4e54c3c$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $7ef789dfa4e54c3c$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $7ef789dfa4e54c3c$var$horizontalStyleBase = null;
const $7ef789dfa4e54c3c$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $7ef789dfa4e54c3c$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $7ef789dfa4e54c3c$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $7ef789dfa4e54c3c$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7ef789dfa4e54c3c$var$ElementGroup = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5NtHI.SmartLinkWidth).FitToContent, position: position = (0, $5NtHI.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5NtHI.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7ef789dfa4e54c3c$var$baseStyleBySize[size],
            $7ef789dfa4e54c3c$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $7ef789dfa4e54c3c$var$alignmentStyleMap[align],
            "_1ul99by0",
            $7ef789dfa4e54c3c$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $7ef789dfa4e54c3c$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Left && $7ef789dfa4e54c3c$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Right && $7ef789dfa4e54c3c$var$gapStylesRight[size],
            $7ef789dfa4e54c3c$var$positionStyle[position],
            className
        ]),
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $7ef789dfa4e54c3c$export$2e2bcd8739ae039 = $7ef789dfa4e54c3c$var$ElementGroup;

});



parcelRegister("gKsxm", function(module, exports) {
$parcel$export(module.exports, "default", () => $948e354a880fdc81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $948e354a880fdc81$var$DEFAULT_MAX_LINES = 2;
const $948e354a880fdc81$var$MAXIMUM_MAX_LINES = 2;
const $948e354a880fdc81$var$MINIMUM_MAX_LINES = 1;
const $948e354a880fdc81$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $948e354a880fdc81$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $948e354a880fdc81$var$getMaxLines = (maxLines)=>{
    if (maxLines > $948e354a880fdc81$var$MAXIMUM_MAX_LINES) return $948e354a880fdc81$var$DEFAULT_MAX_LINES;
    if (maxLines < $948e354a880fdc81$var$MINIMUM_MAX_LINES) return $948e354a880fdc81$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $948e354a880fdc81$var$ElementItemRenderer = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5NtHI.SmartLinkSize).Medium, maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $brTAh.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
        align: align,
        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
        width: (0, $5NtHI.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hcewu.default)([
            $948e354a880fdc81$var$truncateStyles[maxLines],
            $948e354a880fdc81$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $948e354a880fdc81$var$MetadataBlock = ({ maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5NtHI.SmartLinkSize).Medium;
    const maxLinesTotal = $948e354a880fdc81$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
};
var $948e354a880fdc81$export$2e2bcd8739ae039 = $948e354a880fdc81$var$MetadataBlock;

});

parcelRegister("8Rjtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $56e117ae59d9b928$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bgqs9 = parcelRequire("bgqs9");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $56e117ae59d9b928$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgqs9.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $56e117ae59d9b928$export$2e2bcd8739ae039 = $56e117ae59d9b928$var$PreviewBlock;

});
parcelRegister("bgqs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7730cb1921d134f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $7Byzo = parcelRequire("7Byzo");

var $bIdM1 = parcelRequire("bIdM1");
const $7730cb1921d134f4$var$previewBlockStyleCommon = null;
const $7730cb1921d134f4$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $7730cb1921d134f4$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)(style ?? {});
    const updateStyles = (0, $eJOHy.useCallback)(()=>{
        if (placement === (0, $5NtHI.MediaPlacement).Left || placement === (0, $5NtHI.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5NtHI.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5NtHI.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $eJOHy.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Byzo.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $7730cb1921d134f4$export$2e2bcd8739ae039 = $7730cb1921d134f4$var$PreviewBlockResolvedView;

});
parcelRegister("7Byzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cb8c392c94261f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4YO5T = parcelRequire("4YO5T");
const $4cb8c392c94261f3$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5NtHI.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4YO5T.default), {
        ...rest,
        ...data
    });
};
var $4cb8c392c94261f3$export$2e2bcd8739ae039 = $4cb8c392c94261f3$var$PreviewElement;

});
parcelRegister("4YO5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7eb4202b966638f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cbSL1 = parcelRequire("cbSL1");

var $5FRJ8 = parcelRequire("5FRJ8");

var $67ulW = parcelRequire("67ulW");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $d7eb4202b966638f$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $d7eb4202b966638f$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FRJ8.useFlexibleUiOptionContext)() : undefined;
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
            hideLoadingSkeleton: ui?.hideLoadingSkeleton,
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $d7eb4202b966638f$export$2e2bcd8739ae039 = $d7eb4202b966638f$var$MediaElement;

});




parcelRegister("5gb8b", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbe48527b965b005$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $5MmSu = parcelRequire("5MmSu");

var $f7w3l = parcelRequire("f7w3l");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
const $fbe48527b965b005$var$DEFAULT_MAX_LINES = 3;
const $fbe48527b965b005$var$MAXIMUM_MAX_LINES = 6;
const $fbe48527b965b005$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $fbe48527b965b005$var$SnippetBlock = ({ maxLines: maxLines = $fbe48527b965b005$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const enableSnippetRenderer = (0, $5FRJ8.useFlexibleUiOptionContext)()?.enableSnippetRenderer;
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fQH39.getMaxLines)(maxLines, $fbe48527b965b005$var$DEFAULT_MAX_LINES, $fbe48527b965b005$var$MAXIMUM_MAX_LINES, $fbe48527b965b005$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7w3l.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $gt9Am.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet
    });
};
var $fbe48527b965b005$export$2e2bcd8739ae039 = $fbe48527b965b005$var$SnippetBlock;

});
parcelRegister("5MmSu", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkRenderers", () => $8065e50e2bfb34aa$export$c3514c024fefef57);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $8065e50e2bfb34aa$export$c3514c024fefef57 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eJOHy.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("f7w3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5970e5c744f439f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $b5970e5c744f439f$var$snippetBaseStyle = null;
const $b5970e5c744f439f$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $b5970e5c744f439f$export$2e2bcd8739ae039 = $b5970e5c744f439f$var$SnippetElement;

});
parcelRegister("38cBa", function(module, exports) {
$parcel$export(module.exports, "default", () => $6311575d89bb2b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $6311575d89bb2b6b$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $6311575d89bb2b6b$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $fQH39 = parcelRequire("fQH39");
const $6311575d89bb2b6b$var$baseStyle = null;
const $6311575d89bb2b6b$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $6311575d89bb2b6b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $fQH39.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $6311575d89bb2b6b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $awdRS.default)(maxLines)
        },
        children: formattedContent
    });
};
var $6311575d89bb2b6b$export$2e2bcd8739ae039 = $6311575d89bb2b6b$export$79422073c7118b5b;
const $6311575d89bb2b6b$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};
const $6311575d89bb2b6b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});



parcelRegister("2qnEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4a63c55a864af4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $gxvmf = parcelRequire("gxvmf");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $d4a63c55a864af4f$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxvmf.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $d4a63c55a864af4f$export$2e2bcd8739ae039 = $d4a63c55a864af4f$var$AISummaryBlock;

});
parcelRegister("gxvmf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5839dd28b40ea23d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $2LycE = parcelRequire("2LycE");

var $4zxv7 = parcelRequire("4zxv7");

var $ei710 = parcelRequire("ei710");

var $bIdM1 = parcelRequire("bIdM1");

var $cQU20 = parcelRequire("cQU20");
const $5839dd28b40ea23d$var$styles = null;
const $5839dd28b40ea23d$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $4zxv7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $2LycE.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eJOHy.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        direction: (0, $5NtHI.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQU20.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4zxv7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $5839dd28b40ea23d$export$2e2bcd8739ae039 = $5839dd28b40ea23d$var$AISummaryBlockResolvedView;

});
parcelRegister("2LycE", function(module, exports) {
$parcel$export(module.exports, "default", () => $442e3e8f06b649b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9R3Jd = parcelRequire("9R3Jd");
var $3seWH = parcelRequire("3seWH");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $5TXKo = parcelRequire("5TXKo");

var $5sknP = parcelRequire("5sknP");

var $k2hJv = parcelRequire("k2hJv");
const $442e3e8f06b649b8$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $442e3e8f06b649b8$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $k2hJv.useAISummaryConfig)();
    const cardState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $9R3Jd.extractAri)(data);
    const dataUrl = data && (0, $3seWH.extractLink)(data) || '';
    const onStart = (0, $eJOHy.useCallback)((id)=>{
        (0, $1mLfK.startUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eJOHy.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1mLfK.succeedUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eJOHy.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1mLfK.failUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $5sknP.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $442e3e8f06b649b8$export$2e2bcd8739ae039 = $442e3e8f06b649b8$var$useAISummaryAction;

});
parcelRegister("bmWcp", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $b236f5372ffdd3ba$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $928jS = parcelRequire("928jS");
const $b236f5372ffdd3ba$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $928jS.default)(...params));
        event.fire((0, $6462ef276ac974ec$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $6462ef276ac974ec$export$3f072f06b90c3985 = 'media';

parcelRegister("928jS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ac9e1681ec36717$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $5ac9e1681ec36717$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5ac9e1681ec36717$export$2e2bcd8739ae039 = $5ac9e1681ec36717$var$createEventPayload;

});


parcelRegister("1mLfK", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $e01fd61e15160d33$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e01fd61e15160d33$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e01fd61e15160d33$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $e01fd61e15160d33$export$4084c0df4a03a6af);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e01fd61e15160d33$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $e01fd61e15160d33$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9iIu4.ConcurrentExperience)('smart-link-rendered', $e01fd61e15160d33$var$renderExperience),
    'smart-link-authenticated': new (0, $9iIu4.ConcurrentExperience)('smart-link-authenticated', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9iIu4.ConcurrentExperience)('smart-link-action-invocation', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9iIu4.ConcurrentExperience)('smart-link-ai-summary', $e01fd61e15160d33$var$aiExperience)
};
const $e01fd61e15160d33$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $e01fd61e15160d33$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("5TXKo", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $644fcc1916cdb207$export$b0444d00ba7313c6);

var $iHcr1 = parcelRequire("iHcr1");

var $9kfy2 = parcelRequire("9kfy2");
const $644fcc1916cdb207$var$PENDING_STATE = {
    status: 'pending'
};
function $644fcc1916cdb207$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const cardState = (0, $iHcr1.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $644fcc1916cdb207$var$PENDING_STATE;
}

});

parcelRegister("5sknP", function(module, exports) {
$parcel$export(module.exports, "useAISummary", () => $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bI4It = parcelRequire("bI4It");

var $64EXn = parcelRequire("64EXn");
const $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eJOHy.useState)((0, $64EXn.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $64EXn.AISummariesStore).get(url)) (0, $64EXn.AISummariesStore).set(url, new (0, $bI4It.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $64EXn.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $64EXn.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("bI4It", function(module, exports) {
$parcel$export(module.exports, "AISummaryService", () => $ee3df5d12a847ac3$export$73e4b807d5bd74b6);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");

var $a5MXk = parcelRequire("a5MXk");

var $4NcaA = parcelRequire("4NcaA");

var $8hWqs = parcelRequire("8hWqs");

var $9ntiN = parcelRequire("9ntiN");
const $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $ee3df5d12a847ac3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
                return (0, $9ntiN.addPath)(baseUrl, $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT);
            }
            return (0, $9ntiN.addPath)('/gateway/api/', $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $4NcaA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $9ntiN.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') throw new (0, $8hWqs.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $8hWqs.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("4NcaA", function(module, exports) {
$parcel$export(module.exports, "readStream", () => $3c1ef1a29697a261$export$e45226161c660403);

var $9ntiN = parcelRequire("9ntiN");
async function* $3c1ef1a29697a261$export$e45226161c660403(response) {
    const reader = (0, $9ntiN.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("9ntiN", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $75d74a4f0b187756$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $75d74a4f0b187756$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $75d74a4f0b187756$export$ff2962de2b2c930f);
const $75d74a4f0b187756$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $75d74a4f0b187756$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $75d74a4f0b187756$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $75d74a4f0b187756$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $75d74a4f0b187756$export$ff2962de2b2c930f = (product)=>{
    if ($75d74a4f0b187756$var$isJiraProduct(product)) return $75d74a4f0b187756$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("8hWqs", function(module, exports) {
$parcel$export(module.exports, "ChunkProcessingError", () => $424f983e1007104e$export$fcec967a4b7ebd84);
class $424f983e1007104e$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $424f983e1007104e$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("64EXn", function(module, exports) {
$parcel$export(module.exports, "AISummariesStore", () => $6b567d039eac44f3$export$6979339b6d41707e);

var $7xkt0 = parcelRequire("7xkt0");
const $6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE = 100;
const $6b567d039eac44f3$export$6979339b6d41707e = new (0, $7xkt0.LRUMap)($6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("k2hJv", function(module, exports) {
$parcel$export(module.exports, "useAISummaryConfig", () => $3042bebadd8b2921$export$4480af2c00aa7ebe);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $3042bebadd8b2921$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4zxv7", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e0b0d82c1c1601$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gzZ1I = parcelRequire("gzZ1I");

var $3JG7o = parcelRequire("3JG7o");
const $50e0b0d82c1c1601$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $50e0b0d82c1c1601$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gzZ1I.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _syazazsu _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3JG7o.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $50e0b0d82c1c1601$export$2e2bcd8739ae039 = $50e0b0d82c1c1601$var$AISummary;

});
parcelRegister("gzZ1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $031d6845af3014cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $031d6845af3014cc$var$t() {
    return $031d6845af3014cc$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $031d6845af3014cc$var$t.apply(this, arguments);
}
const $031d6845af3014cc$var$n = [
    "children",
    "options"
], $031d6845af3014cc$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $031d6845af3014cc$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($031d6845af3014cc$var$i || ($031d6845af3014cc$var$i = {}));
const $031d6845af3014cc$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $031d6845af3014cc$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $031d6845af3014cc$var$o = [
    "style",
    "script"
], $031d6845af3014cc$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $031d6845af3014cc$var$s = /mailto:/i, $031d6845af3014cc$var$d = /\n{2,}$/, $031d6845af3014cc$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $031d6845af3014cc$var$u = /^ *> ?/gm, $031d6845af3014cc$var$f = /^ {2,}\n/, $031d6845af3014cc$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $031d6845af3014cc$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $031d6845af3014cc$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $031d6845af3014cc$var$k = /^(?:\n *)*\n/, $031d6845af3014cc$var$x = /\r\n?/g, $031d6845af3014cc$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $031d6845af3014cc$var$v = /^\[\^([^\]]+)]/, $031d6845af3014cc$var$S = /\f/g, $031d6845af3014cc$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $031d6845af3014cc$var$C = /^\s*?\[(x|\s)\]/, $031d6845af3014cc$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $031d6845af3014cc$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $031d6845af3014cc$var$T = /^<!--[\s\S]*?(?:-->)/, $031d6845af3014cc$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $031d6845af3014cc$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $031d6845af3014cc$var$M = /^\{.*\}$/, $031d6845af3014cc$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $031d6845af3014cc$var$I = /^<([^ >]+@[^ >]+)>/, $031d6845af3014cc$var$U = /^<([^ >]+:\/[^ >]+)>/, $031d6845af3014cc$var$D = /-([a-z])?/gi, $031d6845af3014cc$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $031d6845af3014cc$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $031d6845af3014cc$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $031d6845af3014cc$var$_ = /\t/g, $031d6845af3014cc$var$G = /(^ *\||\| *$)/g, $031d6845af3014cc$var$W = /^ *:-+: *$/, $031d6845af3014cc$var$Z = /^ *:-+ *$/, $031d6845af3014cc$var$q = /^ *-+: *$/, $031d6845af3014cc$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $031d6845af3014cc$var$V = new RegExp(`^([*_])\\1${$031d6845af3014cc$var$Q}\\1\\1(?!\\1)`), $031d6845af3014cc$var$X = new RegExp(`^([*_])${$031d6845af3014cc$var$Q}\\1(?!\\1|\\w)`), $031d6845af3014cc$var$J = new RegExp(`^==${$031d6845af3014cc$var$Q}==`), $031d6845af3014cc$var$K = new RegExp(`^~~${$031d6845af3014cc$var$Q}~~`), $031d6845af3014cc$var$Y = /^\\([^0-9A-Za-z\s])/, $031d6845af3014cc$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $031d6845af3014cc$var$te = /^\n+/, $031d6845af3014cc$var$ne = /^([ \t]*)/, $031d6845af3014cc$var$re = /\\([^\\])/g, $031d6845af3014cc$var$ie = / *\n+$/, $031d6845af3014cc$var$le = /(?:^|\n)( *)$/, $031d6845af3014cc$var$ae = "(?:\\d+\\.)", $031d6845af3014cc$var$oe = "(?:[*+-])";
function $031d6845af3014cc$var$ce(e) {
    return "( *)(" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + ") +";
}
const $031d6845af3014cc$var$se = $031d6845af3014cc$var$ce(1), $031d6845af3014cc$var$de = $031d6845af3014cc$var$ce(2);
function $031d6845af3014cc$var$pe(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de));
}
const $031d6845af3014cc$var$ue = $031d6845af3014cc$var$pe(1), $031d6845af3014cc$var$fe = $031d6845af3014cc$var$pe(2);
function $031d6845af3014cc$var$he(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $031d6845af3014cc$var$me = $031d6845af3014cc$var$he(1), $031d6845af3014cc$var$ge = $031d6845af3014cc$var$he(2);
function $031d6845af3014cc$var$ye(e) {
    const t = 1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $031d6845af3014cc$var$ke = $031d6845af3014cc$var$ye(1), $031d6845af3014cc$var$xe = $031d6845af3014cc$var$ye(2);
function $031d6845af3014cc$var$be(e, t) {
    const n = 1 === t, i = n ? $031d6845af3014cc$var$ke : $031d6845af3014cc$var$xe, l = n ? $031d6845af3014cc$var$me : $031d6845af3014cc$var$ge, a = n ? $031d6845af3014cc$var$ue : $031d6845af3014cc$var$fe;
    return {
        match (e, t) {
            const n = $031d6845af3014cc$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($031d6845af3014cc$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($031d6845af3014cc$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($031d6845af3014cc$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $031d6845af3014cc$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $031d6845af3014cc$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $031d6845af3014cc$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $031d6845af3014cc$var$Ee = [
    $031d6845af3014cc$var$p,
    $031d6845af3014cc$var$m,
    $031d6845af3014cc$var$g,
    $031d6845af3014cc$var$$,
    $031d6845af3014cc$var$z,
    $031d6845af3014cc$var$w,
    $031d6845af3014cc$var$T,
    $031d6845af3014cc$var$j,
    $031d6845af3014cc$var$me,
    $031d6845af3014cc$var$ke,
    $031d6845af3014cc$var$ge,
    $031d6845af3014cc$var$xe
], $031d6845af3014cc$var$Ce = [
    ...$031d6845af3014cc$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $031d6845af3014cc$var$L,
    $031d6845af3014cc$var$B
];
function $031d6845af3014cc$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $031d6845af3014cc$var$we(e) {
    return $031d6845af3014cc$var$q.test(e) ? "right" : $031d6845af3014cc$var$W.test(e) ? "center" : $031d6845af3014cc$var$Z.test(e) ? "left" : null;
}
function $031d6845af3014cc$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $031d6845af3014cc$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $031d6845af3014cc$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($031d6845af3014cc$var$G, "").split("|").map($031d6845af3014cc$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $031d6845af3014cc$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $031d6845af3014cc$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.paragraph
    };
}
function $031d6845af3014cc$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $031d6845af3014cc$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $031d6845af3014cc$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $031d6845af3014cc$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$031d6845af3014cc$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $031d6845af3014cc$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $031d6845af3014cc$var$Ue(e) {
    return e.replace($031d6845af3014cc$var$re, "$1");
}
function $031d6845af3014cc$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $031d6845af3014cc$var$He = (e, t, n)=>({
        children: $031d6845af3014cc$var$De(t, e[1], n)
    });
function $031d6845af3014cc$var$Fe() {
    return {};
}
function $031d6845af3014cc$var$Pe() {
    return null;
}
function $031d6845af3014cc$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $031d6845af3014cc$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $031d6845af3014cc$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $031d6845af3014cc$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $031d6845af3014cc$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $031d6845af3014cc$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $031d6845af3014cc$var$t({}, n, l, {
            className: $031d6845af3014cc$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($031d6845af3014cc$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $031d6845af3014cc$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($031d6845af3014cc$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $eJOHy.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($031d6845af3014cc$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($031d6845af3014cc$var$O) && (e = e.replace($031d6845af3014cc$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $031d6845af3014cc$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($031d6845af3014cc$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($031d6845af3014cc$var$L.test(p) || $031d6845af3014cc$var$B.test(p)) && (n[d] = $eJOHy.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$031d6845af3014cc$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $031d6845af3014cc$export$3e2338ea76b578c9, i.slugify = i.slugify || $031d6845af3014cc$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $031d6845af3014cc$var$t({}, $031d6845af3014cc$var$a, i.namedCodesToUnicode) : $031d6845af3014cc$var$a, i.createElement = i.createElement || $eJOHy.createElement;
    const Z = [], q = {}, Q = {
        [$031d6845af3014cc$export$e0aa44767d8750d5.blockQuote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($031d6845af3014cc$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakLine]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$f),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakThematic]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$h),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeBlock]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $031d6845af3014cc$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeFenced]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeInline]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnoteReference]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $031d6845af3014cc$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.gfmTask]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.heading]: {
            match: $031d6845af3014cc$var$Be(i.enforceAtxHeadings ? $031d6845af3014cc$var$w : $031d6845af3014cc$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[2], n),
                    id: i.slugify(e[2], $031d6845af3014cc$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.headingSetext]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.heading
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($031d6845af3014cc$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $031d6845af3014cc$var$Ce.some((e)=>e.test(c)) ? $031d6845af3014cc$var$Ne : $031d6845af3014cc$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $031d6845af3014cc$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlComment]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$T),
            order: 1,
            parse: ()=>({}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.image]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.link]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$je(t, e[1], n),
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $031d6845af3014cc$var$Te($031d6845af3014cc$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $031d6845af3014cc$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                };
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.orderedList]: $031d6845af3014cc$var$be(d, 1),
        [$031d6845af3014cc$export$e0aa44767d8750d5.unorderedList]: $031d6845af3014cc$var$be(d, 2),
        [$031d6845af3014cc$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$k),
            order: 3,
            parse: $031d6845af3014cc$var$Fe,
            render: ()=>"\n"
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.paragraph]: {
            match: $031d6845af3014cc$var$Re,
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.ref]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refImage]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refLink]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.table]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$j),
            order: 1,
            parse: $031d6845af3014cc$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $031d6845af3014cc$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $031d6845af3014cc$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.text]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($031d6845af3014cc$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textBolded]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEmphasized]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEscaped]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textMarked]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$J),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$K),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock], delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($031d6845af3014cc$var$x, "\n").replace($031d6845af3014cc$var$S, "").replace($031d6845af3014cc$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $031d6845af3014cc$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $031d6845af3014cc$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $031d6845af3014cc$var$n);
    return $eJOHy.cloneElement($031d6845af3014cc$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3JG7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f398c5c3f3cb7e7$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $8f398c5c3f3cb7e7$var$listStyles = null;
const $8f398c5c3f3cb7e7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ...props,
        className: (0, $hcewu.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $8f398c5c3f3cb7e7$export$2e2bcd8739ae039 = $8f398c5c3f3cb7e7$var$UList;

});


parcelRegister("ei710", function(module, exports) {
$parcel$export(module.exports, "default", () => $fda5b98323afadf3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $fda5b98323afadf3$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eJOHy.useState)(0);
    const ref = (0, $eJOHy.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eJOHy.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $fda5b98323afadf3$export$2e2bcd8739ae039 = $fda5b98323afadf3$export$6118ed0013927eb2;

});

parcelRegister("cQU20", function(module, exports) {
$parcel$export(module.exports, "default", () => $f73e03b62ddf95ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $f73e03b62ddf95ac$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f73e03b62ddf95ac$export$2e2bcd8739ae039 = $f73e03b62ddf95ac$var$AIEventSummaryViewed;

});



parcelRegister("eMgzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a57421ef9d4f6376$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $37K19 = parcelRequire("37K19");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $a57421ef9d4f6376$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37K19.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $a57421ef9d4f6376$export$2e2bcd8739ae039 = $a57421ef9d4f6376$var$AIFooterBlock;

});
parcelRegister("37K19", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a90281cb091ec71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $bIdM1 = parcelRequire("bIdM1");

var $kopBz = parcelRequire("kopBz");
const $3a90281cb091ec71$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopBz.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $3a90281cb091ec71$export$2e2bcd8739ae039 = $3a90281cb091ec71$var$AIFooterBlockResolvedView;

});
parcelRegister("kopBz", function(module, exports) {
$parcel$export(module.exports, "AIFooterMetadata", () => $bf118c10e8951921$export$175228cc2c92b3b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fOqNz = parcelRequire("fOqNz");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $19nmp = parcelRequire("19nmp");

var $2LycE = parcelRequire("2LycE");

var $bB163 = parcelRequire("bB163");
const $bf118c10e8951921$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bB163.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #505258)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
                label: "AI",
                color: "var(--ds-icon-subtle, #505258)"
            })
        ]
    });
};

});
parcelRegister("fOqNz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cff70d9276c693dca9eb8c1c54a9e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b830502683dea4c7$var$_react = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b830502683dea4c7$var$_baseNew = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b830502683dea4c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b830502683dea4c7$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $b830502683dea4c7$var$_react.default.createElement($b830502683dea4c7$var$_baseNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$b830502683dea4c7$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $b830502683dea4c7$var$_default = module.exports.default = $b830502683dea4c7$var$AtlassianIntelligenceIcon;

});

parcelRegister("bB163", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", () => $ebe2ee8525f34821$export$2957fc44b3d2481);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $klVDP = parcelRequire("klVDP");
const $ebe2ee8525f34821$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $klVDP.default),
        ...props
    });

});
parcelRegister("klVDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f050f94233fcee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aPN6Z = parcelRequire("aPN6Z");
const $95f050f94233fcee$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $95f050f94233fcee$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aPN6Z.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $95f050f94233fcee$var$InfoIconGlyph
    });
var $95f050f94233fcee$export$2e2bcd8739ae039 = $95f050f94233fcee$var$InfoIcon;

});
parcelRegister("aPN6Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d898e5ff95ec4e1$export$2e2bcd8739ae039);
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fL0In = parcelRequire("fL0In");

var $eGOwo = parcelRequire("eGOwo");
const $6d898e5ff95ec4e1$var$iconStyles = null;
const $6d898e5ff95ec4e1$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ const $6d898e5ff95ec4e1$var$baseHcmStyles = null;
const $6d898e5ff95ec4e1$var$primaryEqualsSecondaryHcmStyles = null;
const $6d898e5ff95ec4e1$var$secondaryTransparentHcmStyles = null;
const $6d898e5ff95ec4e1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.memo)(function Icon(props) {
    if ((0, $eGOwo.fg)('platform-custom-icon-migration')) {
        const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
        const glyphProps = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ (0, $gt9Am.jsx)(Glyph, {
                role: "presentation"
            }) : null
        };
        const customDimensions = width && height ? {
            width: width + 'px',
            height: height + 'px'
        } : null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-testid": testId,
            "data-vc": `icon-${testId}`,
            role: label ? 'img' : undefined,
            "aria-label": label ? label : undefined,
            "aria-hidden": label ? undefined : true,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...customDimensions,
                '--icon-primary-color': primaryColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--icon-secondary-color': secondaryColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                margin: UNSAFE_margin
            },
            ...glyphProps,
            className: (0, $hcewu.default)([
                "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
                "_jcxd1r8n _gq0g1onz _1trkwc43",
                primaryColor === secondaryColor && "_18hbwc43",
                secondaryColor === 'transparent' && "_4fyi3acm",
                size && $6d898e5ff95ec4e1$var$sizeStyles[size]
            ])
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        ...props
    });
});
var $6d898e5ff95ec4e1$export$2e2bcd8739ae039 = $6d898e5ff95ec4e1$export$f04a61298a47a40f;

});






parcelRegister("4cjOx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a174909684ab758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $lHA6U = parcelRequire("lHA6U");

var $1dIgp = parcelRequire("1dIgp");
const $3a174909684ab758$var$ignoreContainerPaddingStyles = null;
const $3a174909684ab758$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $3a174909684ab758$var$sort = (a, b)=>{
    let idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $3a174909684ab758$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $3a174909684ab758$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gRw8I.di)((0, $1dIgp.ActionFooter));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onLoadingChange = (0, $eJOHy.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $3a174909684ab758$export$1af10e3728e3a644(ui?.size || (0, $5NtHI.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eJOHy.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($3a174909684ab758$var$sort);
        return arr.map((name)=>{
            const Action = name in $lHA6U ? $lHA6U[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dIgp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $3a174909684ab758$export$2e2bcd8739ae039 = $3a174909684ab758$var$ActionBlock;

});
parcelRegister("lHA6U", function(module, exports) {
$parcel$export(module.exports, "CustomAction", () => (parcelRequire("9hHCO")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("dckwx")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("c0FsA")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("dGv8r")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("lSW97")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("3MDCL")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("b1dbu")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("cLrUd")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("2fs4B")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("1EoLm")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("bKvNh")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("fd4of")).default);

var $9hHCO = parcelRequire("9hHCO");

var $dckwx = parcelRequire("dckwx");

var $c0FsA = parcelRequire("c0FsA");

var $dGv8r = parcelRequire("dGv8r");

var $lSW97 = parcelRequire("lSW97");

var $3MDCL = parcelRequire("3MDCL");

var $b1dbu = parcelRequire("b1dbu");

var $cLrUd = parcelRequire("cLrUd");

var $2fs4B = parcelRequire("2fs4B");

var $1EoLm = parcelRequire("1EoLm");

var $bKvNh = parcelRequire("bKvNh");

var $fd4of = parcelRequire("fd4of");

});
parcelRegister("9hHCO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2469864747178fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $8ABAe = parcelRequire("8ABAe");

var $fh1oH = parcelRequire("fh1oH");

var $dQnV8 = parcelRequire("dQnV8");

var $cNUXI = parcelRequire("cNUXI");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $c2469864747178fa$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cNUXI.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fh1oH.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ABAe.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $c2469864747178fa$export$2e2bcd8739ae039 = $c2469864747178fa$var$Action;

});
parcelRegister("8ABAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $810b448b0b6757f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $810b448b0b6757f9$var$IconOnlyLarge = null;
const $810b448b0b6757f9$var$SizeSmall = null;
const $810b448b0b6757f9$var$SizeSmallIconOnly = null;
const $810b448b0b6757f9$var$SizeSmallNotIconOnly = null;
const $810b448b0b6757f9$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $810b448b0b6757f9$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $810b448b0b6757f9$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $810b448b0b6757f9$var$ActionButtonRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $eJOHy.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
const $810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss = (0, $9jYtV.withOverrideCss)($810b448b0b6757f9$var$ActionButtonRefresh);
const $810b448b0b6757f9$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            size === (0, $5NtHI.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5NtHI.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5NtHI.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $5NtHI.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fQH39.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $810b448b0b6757f9$var$ActionButton = (props)=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonNew, {
        ...props
    });
};
var $810b448b0b6757f9$export$2e2bcd8739ae039 = $810b448b0b6757f9$var$ActionButton;

});

parcelRegister("fh1oH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4141238200e2a86d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $FoFt2 = parcelRequire("FoFt2");
const $4141238200e2a86d$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $FoFt2.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4141238200e2a86d$export$2e2bcd8739ae039 = $4141238200e2a86d$var$ActionDropdownItem;

});

parcelRegister("dQnV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $182322eb34547fdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $182322eb34547fdc$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$stackItemIconStylesOld = null;
const $182322eb34547fdc$var$stackItemIconStylesCompiled = null;
const $182322eb34547fdc$var$ActionIcon = ({ size: size, testId: testId, icon: icon, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap[$182322eb34547fdc$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $182322eb34547fdc$export$2e2bcd8739ae039 = $182322eb34547fdc$var$ActionIcon;

});

parcelRegister("cNUXI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d23b94a27dbb965d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $e5DLq = parcelRequire("e5DLq");
const $d23b94a27dbb965d$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $d23b94a27dbb965d$export$2e2bcd8739ae039 = $d23b94a27dbb965d$var$ActionStackItem;

});
parcelRegister("e5DLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6dc8e23eec4828$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $fQH39 = parcelRequire("fQH39");

var $dQnV8 = parcelRequire("dQnV8");
const $0d6dc8e23eec4828$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c81o8v _syazi7uo"
};
const $0d6dc8e23eec4828$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fQH39.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $0d6dc8e23eec4828$export$2e2bcd8739ae039 = $0d6dc8e23eec4828$var$ActionButton;

});



parcelRegister("dckwx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3290b93af8be85b3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6J9k6 = parcelRequire("6J9k6");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $3290b93af8be85b3$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        ...props
    });
var $3290b93af8be85b3$export$2e2bcd8739ae039 = $3290b93af8be85b3$var$DeleteAction;

});

parcelRegister("c0FsA", function(module, exports) {
$parcel$export(module.exports, "default", () => $920fde411498a771$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bp0jd = parcelRequire("bp0jd");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $920fde411498a771$var$EditAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        ...props
    });
var $920fde411498a771$export$2e2bcd8739ae039 = $920fde411498a771$var$EditAction;

});
parcelRegister("bp0jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5f964c14b35b4c00537c8ae369245e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84d244d8a31b5641$var$_react = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84d244d8a31b5641$var$_edit = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $84d244d8a31b5641$var$_edit2 = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("dUYQ5")));
function $84d244d8a31b5641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84d244d8a31b5641$var$EditIcon = (props)=>/*#__PURE__*/ $84d244d8a31b5641$var$_react.default.createElement($84d244d8a31b5641$var$_edit.default, Object.assign({
        name: "EditIcon",
        LEGACY_fallbackIcon: $84d244d8a31b5641$var$_edit2.default
    }, props));
$84d244d8a31b5641$var$EditIcon.displayName = 'EditIconMigration';
var $84d244d8a31b5641$var$_default = module.exports.default = $84d244d8a31b5641$var$EditIcon;

});
parcelRegister("dUYQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21fb2aec03ab384$var$_react = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a21fb2aec03ab384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a21fb2aec03ab384$var$EditIcon = (props)=>/*#__PURE__*/ $a21fb2aec03ab384$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props));
$a21fb2aec03ab384$var$EditIcon.displayName = 'EditIcon';
var $a21fb2aec03ab384$var$_default = module.exports.default = $a21fb2aec03ab384$var$EditIcon;

});



parcelRegister("dGv8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea6a5d6049b9822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kHcBe = parcelRequire("kHcBe");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $bea6a5d6049b9822$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).DownloadAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $19nmp.messages).download_file : (0, $19nmp.messages).download;
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).download_description : (0, $19nmp.messages).download;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $bea6a5d6049b9822$export$2e2bcd8739ae039 = $bea6a5d6049b9822$var$DownloadAction;

});
parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c27208d6ab6791006597f11ce02c72b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        name: "DownloadIcon",
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.displayName = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});


parcelRegister("7xssH", function(module, exports) {
$parcel$export(module.exports, "default", () => $28096ecb360b0e22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $1mLfK = parcelRequire("1mLfK");
const $28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $28096ecb360b0e22$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $eJOHy.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $2QXr6.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1mLfK.startUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $2QXr6.mark(markName, 'resolved');
            (0, $1mLfK.succeedUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $2QXr6.mark(markName, 'errored');
            (0, $1mLfK.failUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $28096ecb360b0e22$export$2e2bcd8739ae039 = $28096ecb360b0e22$var$useInvokeClientAction;

});
parcelRegister("2QXr6", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $a922bc214c753b7c$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $a922bc214c753b7c$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $a922bc214c753b7c$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $a922bc214c753b7c$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $a922bc214c753b7c$export$185802fd694ee1f5);
const $a922bc214c753b7c$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $a922bc214c753b7c$var$hasPerformanceAPIAvailable = $a922bc214c753b7c$var$isPerformanceAPIAvailable();
const $a922bc214c753b7c$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $a922bc214c753b7c$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $a922bc214c753b7c$export$1a717feb4df1a945 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $a922bc214c753b7c$export$de42547d395c8271 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $a922bc214c753b7c$var$getMark = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $a922bc214c753b7c$export$185802fd694ee1f5 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measure = $a922bc214c753b7c$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $a922bc214c753b7c$var$getMark(id, 'pending');
            const endMark = $a922bc214c753b7c$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("lSW97", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe202eda411d4c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $59rsN = parcelRequire("59rsN");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $5UiT3 = parcelRequire("5UiT3");

var $kxXL5 = parcelRequire("kxXL5");


const $dfe202eda411d4c1$var$importIconMapper = {
    goal: ()=>(parcelRequire("iqCse")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("DxrmM")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $dfe202eda411d4c1$var$getIcon = (stackIconType)=>{
    const importFn = $dfe202eda411d4c1$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fQH39.importIcon)(importFn);
};
const $dfe202eda411d4c1$var$FollowAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $19nmp.messages).follow : (0, $19nmp.messages).unfollow;
    const projectMessage = value ? (0, $19nmp.messages).follow_project : (0, $19nmp.messages).unfollow_project;
    const goalMessage = value ? (0, $19nmp.messages).follow_goal : (0, $19nmp.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_project_descriptionGalaxia : (0, $19nmp.messages).follow_project_description : (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_project_descriptionGalaxia : (0, $19nmp.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $19nmp.messages).follow_goal_description : (0, $19nmp.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $dfe202eda411d4c1$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $kxXL5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UiT3.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $dfe202eda411d4c1$export$2e2bcd8739ae039 = $dfe202eda411d4c1$var$FollowAction;

});
parcelRegister("5UiT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce9aaae704363155$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $1rn8a = parcelRequire("1rn8a");

var $9hHCO = parcelRequire("9hHCO");
const $ce9aaae704363155$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const invoke = (0, $6O4ri.default)();
    const reload = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1rn8a.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $d0InI.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ce9aaae704363155$export$2e2bcd8739ae039 = $ce9aaae704363155$var$ServerAction;

});
parcelRegister("6O4ri", function(module, exports) {
$parcel$export(module.exports, "default", () => $b69a1ac7b939ac3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $18BbB = parcelRequire("18BbB");

var $9kfy2 = parcelRequire("9kfy2");
const $b69a1ac7b939ac3b$var$useInvoke = ()=>{
    const { connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const clientExt = (0, $18BbB.useSmartLinkClientExtension)(connections.client);
    return (0, $eJOHy.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b69a1ac7b939ac3b$export$2e2bcd8739ae039 = $b69a1ac7b939ac3b$var$useInvoke;

});
parcelRegister("18BbB", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkClientExtension", () => $365002b9ec3223b9$export$303ede4eed148855);

var $eJOHy = parcelRequire("eJOHy");

var $hhFie = parcelRequire("hhFie");

var $5CgrK = parcelRequire("5CgrK");

var $jAAbh = parcelRequire("jAAbh");
const $365002b9ec3223b9$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $jAAbh.useResolverUrl)(cardClient);
    const invoke = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            return await (0, $hhFie.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $5CgrK.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("5CgrK", function(module, exports) {
$parcel$export(module.exports, "SmartLinkActionType", () => $1ec6011516cb04bd$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $1ec6011516cb04bd$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $1ec6011516cb04bd$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $1ec6011516cb04bd$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("jAAbh", function(module, exports) {
$parcel$export(module.exports, "useResolverUrl", () => $248dfa90412a2e2f$export$d08617a365fbe694);

var $eJOHy = parcelRequire("eJOHy");

var $a5MXk = parcelRequire("a5MXk");
const $248dfa90412a2e2f$export$d08617a365fbe694 = (cardClient)=>(0, $eJOHy.useMemo)(()=>(0, $a5MXk.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("d0InI", function(module, exports) {
$parcel$export(module.exports, "getInvokeFailureReason", () => $842afed3b5601c74$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $842afed3b5601c74$export$1694272377fa07d8);

var $b43DQ = parcelRequire("b43DQ");
const $842afed3b5601c74$export$65b3f792dff0bd60 = (err)=>{
    if (!$842afed3b5601c74$export$1694272377fa07d8(err)) return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $b43DQ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    }
};
const $842afed3b5601c74$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("kbv8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $b139b7122b26d76a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3jSKi = parcelRequire("3jSKi");

var $9kfy2 = parcelRequire("9kfy2");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $99QxN = parcelRequire("99QxN");
const $b139b7122b26d76a$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $99QxN.default)();
    return (0, $eJOHy.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3jSKi.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1mLfK.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b139b7122b26d76a$export$2e2bcd8739ae039 = $b139b7122b26d76a$var$useResolve;

});
parcelRegister("99QxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b217076914baa8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
var $4pUJe = parcelRequire("4pUJe");
var $4g7cp = parcelRequire("4g7cp");

var $5NtHI = parcelRequire("5NtHI");

var $gA511 = parcelRequire("gA511");

const $69b217076914baa8$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eJOHy.useCallback)((url, metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eJOHy.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: url
        }, (0, $gA511.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4g7cp.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fallback', hostname, (0, $9121cfe34e6487d9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fatal', hostname, (0, $9121cfe34e6487d9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('error', hostname, (0, $9121cfe34e6487d9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $aQK2r.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $69b217076914baa8$export$2e2bcd8739ae039 = $69b217076914baa8$var$useResponse;

});
parcelRegister("gA511", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $af7c5b7c4494ebd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $af7c5b7c4494ebd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $af7c5b7c4494ebd5$export$e32193033a594efb);
const $af7c5b7c4494ebd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af7c5b7c4494ebd5$export$2796a804c6e44f63 = ()=>$af7c5b7c4494ebd5$var$emptyData;
const $af7c5b7c4494ebd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });
const $af7c5b7c4494ebd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });

});

const $9121cfe34e6487d9$export$297c39c8b9bfca0 = 'resolving';
const $9121cfe34e6487d9$export$b64a888338c24e0e = 'errored';
const $9121cfe34e6487d9$export$677b6edfa0002c70 = 'fallback';
const $9121cfe34e6487d9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $9121cfe34e6487d9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $9121cfe34e6487d9$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("1rn8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $6426c76052ace8de$export$2e2bcd8739ae039);
const $6426c76052ace8de$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $6426c76052ace8de$export$2e2bcd8739ae039 = $6426c76052ace8de$var$createInvokeRequest;

});


parcelRegister("kxXL5", function(module, exports) {
$parcel$export(module.exports, "getFollowActionErrorMessage", () => $b87644dc5deec150$export$49248678d3914625);

var $59rsN = parcelRequire("59rsN");

var $19nmp = parcelRequire("19nmp");
const $b87644dc5deec150$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).follow_project_errorGalaxia : (0, $19nmp.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $59rsN.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $19nmp.messages).unfollow_project_errorGalaxia : (0, $19nmp.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $19nmp.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $19nmp.messages).unfollow_goal_error;
    return (0, $19nmp.messages).generic_error_message;
};

});

parcelRegister("iqCse", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3nUhw")
]).then(()=>parcelRequire('k96Yq'));

});

parcelRegister("DxrmM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1877j")
]).then(()=>parcelRequire('c6wmU'));

});


parcelRegister("3MDCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7238a60227ffb9b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1hBh4 = parcelRequire("1hBh4");

var $f4WMd = parcelRequire("f4WMd");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $a7238a60227ffb9b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).PreviewAction];
    const hasPreviewPanel = data?.hasPreviewPanel;
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).preview_description : (0, $19nmp.messages).preview_improved;
    const actionIcon = (0, $eJOHy.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4WMd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview panel"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        });
    }, [
        hasPreviewPanel
    ]);
    const actionLabel = (0, $eJOHy.useCallback)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_panel
        });
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_modal
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_improved
        });
    }, [
        hasPreviewPanel
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: actionLabel(),
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $a7238a60227ffb9b$export$2e2bcd8739ae039 = $a7238a60227ffb9b$var$PreviewAction;

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2af12b1489cad8386543f983c1a67716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        name: "GrowDiagonalIcon",
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98db7ecf7a88004ad911d912e316fd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});


parcelRegister("f4WMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24c85da433a7def76f682c2e482c8374>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa4d2955554e918$var$_react = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afa4d2955554e918$var$_baseNew = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $afa4d2955554e918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa4d2955554e918$var$PanelRightIcon = (props)=>/*#__PURE__*/ $afa4d2955554e918$var$_react.default.createElement($afa4d2955554e918$var$_baseNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$afa4d2955554e918$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $afa4d2955554e918$var$_default = module.exports.default = $afa4d2955554e918$var$PanelRightIcon;

});


parcelRegister("b1dbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbc64436e41aec7f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $av9Of = parcelRequire("av9Of");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $cbc64436e41aec7f$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_url_to_clipboard);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $19nmp.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $cbc64436e41aec7f$export$2e2bcd8739ae039 = $cbc64436e41aec7f$var$CopyLinkAction;

});

parcelRegister("cLrUd", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c33132973d68a83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $8c33132973d68a83$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $8c33132973d68a83$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $6qaBj.cx)($8c33132973d68a83$var$styles.message, hasPadding && $8c33132973d68a83$var$styles.padding),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c33132973d68a83$var$styles.button,
        children: message
    }) : message;
};
var $8c33132973d68a83$export$2e2bcd8739ae039 = $8c33132973d68a83$var$UnresolvedAction;

});

parcelRegister("2fs4B", function(module, exports) {
$parcel$export(module.exports, "default", () => $b30a89f78a7b1395$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3IFDE = parcelRequire("3IFDE");
const $b30a89f78a7b1395$var$AISummaryAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IFDE.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b30a89f78a7b1395$export$2e2bcd8739ae039 = $b30a89f78a7b1395$var$AISummaryAction;

});
parcelRegister("3IFDE", function(module, exports) {
$parcel$export(module.exports, "AISummaryActionComponent", () => $f1effd59dd51917b$export$8eed96bc6d982595);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $4N9mw = parcelRequire("4N9mw");

var $9ljdO = parcelRequire("9ljdO");
const $f1effd59dd51917b$export$8eed96bc6d982595 = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $2LycE.default)(url);
    (0, $eJOHy.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ljdO.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4N9mw.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("4N9mw", function(module, exports) {
$parcel$export(module.exports, "AISummariseAction", () => $74950477f844069d$export$75a19de44af58722);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fOqNz = parcelRequire("fOqNz");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");

var $4XsCU = parcelRequire("4XsCU");
function $74950477f844069d$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onCompleted = (0, $eJOHy.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $4XsCU.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("4XsCU", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $97c2d7f54971c4db$export$82f46aa4e6535a45);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7tQSx = parcelRequire("7tQSx");

var $2Q7aM = parcelRequire("2Q7aM");

var $hDtQ6 = parcelRequire("hDtQ6");
const $97c2d7f54971c4db$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $7tQSx.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Q7aM.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDtQ6.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("7tQSx", function(module, exports) {
$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9b4bccd413fec8a7$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9b4bccd413fec8a7$export$cd2e891d7f87074d);

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $9b4bccd413fec8a7$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $9b4bccd413fec8a7$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $19nmp.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5NtHI.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $19nmp.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $19nmp.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $19nmp.messages).ai_summary_error_generic,
                url: (0, $5NtHI.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2Q7aM", function(module, exports) {
$parcel$export(module.exports, "default", () => $af835e3708ee9394$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $af835e3708ee9394$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $af835e3708ee9394$export$2e2bcd8739ae039 = $af835e3708ee9394$var$AIEventErrorViewed;

});

parcelRegister("hDtQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4df7b5a8aadcea38$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5NtHI = parcelRequire("5NtHI");
const $4df7b5a8aadcea38$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: (0, $5NtHI.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $4df7b5a8aadcea38$export$2e2bcd8739ae039 = $4df7b5a8aadcea38$var$AILearnMoreAnchor;

});



parcelRegister("9ljdO", function(module, exports) {
$parcel$export(module.exports, "CopySummaryAction", () => $d9ba8f475ac91e83$export$cfa1d3eed9a61059);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4TA31 = parcelRequire("4TA31");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
function $d9ba8f475ac91e83$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eJOHy.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $19nmp.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.displayName = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});





parcelRegister("1EoLm", function(module, exports) {
$parcel$export(module.exports, "default", () => $807f9b07437985a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $dtpha = parcelRequire("dtpha");

var $3cMgR = parcelRequire("3cMgR");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $4iE29 = parcelRequire("4iE29");

var $kkF5t = parcelRequire("kkF5t");

const $807f9b07437985a7$var$AutomationModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lCy2I")));
const $807f9b07437985a7$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const modal = (0, $fezTc.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5NtHI.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eJOHy.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $kkF5t.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($807f9b07437985a7$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $19nmp.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4iE29.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $807f9b07437985a7$export$2e2bcd8739ae039 = $807f9b07437985a7$var$AutomationAction;

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("fezTc", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalProvider", () => $a8c10a96c4151b39$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7JfLF = parcelRequire("7JfLF");
const $a8c10a96c4151b39$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a8c10a96c4151b39$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($a8c10a96c4151b39$var$FALLBACK_API);
const $a8c10a96c4151b39$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JfLF.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eJOHy.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8 = ()=>(0, $eJOHy.useContext)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c);

});
parcelRegister("7JfLF", function(module, exports) {
$parcel$export(module.exports, "StopPropagation", () => $7b6d8602f75ebf94$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $7b6d8602f75ebf94$var$styles = {
    pressable: "_c71lidpf _p12fidpf _kqswstnw"
};
const $7b6d8602f75ebf94$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: $7b6d8602f75ebf94$var$styles.pressable,
        onClick: onClick,
        children: children
    });
};

});


parcelRegister("4iE29", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe410232594ccf2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1fe410232594ccf2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1fe410232594ccf2$export$2e2bcd8739ae039 = $1fe410232594ccf2$var$AutomationManualTriggersGlyph;

});

parcelRegister("kkF5t", function(module, exports) {
$parcel$export(module.exports, "getModalContent", () => $c38c894acd6bcefe$export$93e707b363eaf5c8);

var $19nmp = parcelRequire("19nmp");
const $c38c894acd6bcefe$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $19nmp.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $19nmp.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("lCy2I", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kVzfx")
]).then(()=>parcelRequire('kczS3'));

});


parcelRegister("bKvNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8cb4fc04a0fca0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $8wmgQ = parcelRequire("8wmgQ");

const $1f8cb4fc04a0fca0$var$RelatedLinksModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("km9Nb")));
const $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $fezTc.useSmartLinkModal)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($1f8cb4fc04a0fca0$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).related_links_view_related_links
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wmgQ.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $1f8cb4fc04a0fca0$export$2e2bcd8739ae039 = $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction;

});
parcelRegister("8wmgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c344254860ed9d13$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i5stJ = parcelRequire("i5stJ");
const $c344254860ed9d13$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    });
var $c344254860ed9d13$export$2e2bcd8739ae039 = $c344254860ed9d13$var$RelatedLinksActionIcon;

});

parcelRegister("km9Nb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6ojIT").then(()=>parcelRequire('3cErl'));

});


parcelRegister("fd4of", function(module, exports) {
$parcel$export(module.exports, "default", () => $875ad99f72c777d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $875ad99f72c777d8$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $875ad99f72c777d8$var$validErrorStatuses = [
    (0, $5NtHI.SmartLinkStatus).Forbidden,
    (0, $5NtHI.SmartLinkStatus).Unauthorized
];
const $875ad99f72c777d8$var$validateErrorStatus = (status)=>{
    return status !== undefined && $875ad99f72c777d8$var$validErrorStatuses.includes(status);
};
const $875ad99f72c777d8$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$875ad99f72c777d8$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $875ad99f72c777d8$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $875ad99f72c777d8$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $875ad99f72c777d8$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...messageDescriptor,
            values: values
        })
    });
    const component = hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $875ad99f72c777d8$var$styles.button,
        children: message
    }) : message;
    return Container ? /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        children: component
    }) : component;
};
var $875ad99f72c777d8$export$2e2bcd8739ae039 = $875ad99f72c777d8$var$CustomUnresolvedAction;

});


parcelRegister("1dIgp", function(module, exports) {
$parcel$export(module.exports, "ActionFooter", () => $495d2943b4977c6a$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $ei710 = parcelRequire("ei710");
const $495d2943b4977c6a$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syazazsu"
};
const $495d2943b4977c6a$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $495d2943b4977c6a$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $495d2943b4977c6a$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $495d2943b4977c6a$var$styles.errorContentStyles,
                children: [
                    message.icon || $495d2943b4977c6a$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $495d2943b4977c6a$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});



parcelRegister("4RG9i", function(module, exports) {
$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("9Xcvc")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("41Mwl")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("lVTJZ")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("gl0Fx")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("iCDdz")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("cSuZU")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("gA3VJ")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("aiy2i")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("k4xpX")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("kCe9K")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("kB4Nm")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jPfaa")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("2Bqsd")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("1FNi6")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("81kl8")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("946bQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("4Nd99")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("7Byzo")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("5kUaD")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("8MxlB")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6l7Bk")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("lwvSM")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2ITMK")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("iw2r2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("f7w3l")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("6Po2h")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("4U5iq")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("jJD7c")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("7mGkc")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("w1OaX")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("cwvSG")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("2j4b1")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("i6ktq")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("iQvIm")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("bApaO")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("1IQ2A")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("lJDNU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("i4NpI")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("5d1ks")).default);

var $9Xcvc = parcelRequire("9Xcvc");

var $41Mwl = parcelRequire("41Mwl");

var $lVTJZ = parcelRequire("lVTJZ");

var $gl0Fx = parcelRequire("gl0Fx");

var $iCDdz = parcelRequire("iCDdz");

var $cSuZU = parcelRequire("cSuZU");

var $gA3VJ = parcelRequire("gA3VJ");

var $aiy2i = parcelRequire("aiy2i");

var $k4xpX = parcelRequire("k4xpX");

var $kCe9K = parcelRequire("kCe9K");

var $kB4Nm = parcelRequire("kB4Nm");

var $jPfaa = parcelRequire("jPfaa");

var $2Bqsd = parcelRequire("2Bqsd");

var $1FNi6 = parcelRequire("1FNi6");

var $81kl8 = parcelRequire("81kl8");

var $946bQ = parcelRequire("946bQ");

var $4Nd99 = parcelRequire("4Nd99");

var $7Byzo = parcelRequire("7Byzo");

var $5kUaD = parcelRequire("5kUaD");

var $8MxlB = parcelRequire("8MxlB");

var $6l7Bk = parcelRequire("6l7Bk");

var $lwvSM = parcelRequire("lwvSM");

var $2ITMK = parcelRequire("2ITMK");

var $iw2r2 = parcelRequire("iw2r2");

var $f7w3l = parcelRequire("f7w3l");

var $6Po2h = parcelRequire("6Po2h");

var $4U5iq = parcelRequire("4U5iq");

var $jJD7c = parcelRequire("jJD7c");

var $7mGkc = parcelRequire("7mGkc");

var $w1OaX = parcelRequire("w1OaX");

var $cwvSG = parcelRequire("cwvSG");

var $2j4b1 = parcelRequire("2j4b1");

var $i6ktq = parcelRequire("i6ktq");

var $iQvIm = parcelRequire("iQvIm");

var $bApaO = parcelRequire("bApaO");

var $1IQ2A = parcelRequire("1IQ2A");

var $lJDNU = parcelRequire("lJDNU");

var $i4NpI = parcelRequire("i4NpI");

var $5d1ks = parcelRequire("5d1ks");

});
parcelRegister("9Xcvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e65e4967ed5bbb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $68e65e4967ed5bbb$var$AssignedToElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedTo
    }) : null;
};
var $68e65e4967ed5bbb$export$2e2bcd8739ae039 = $68e65e4967ed5bbb$var$AssignedToElement;

});

parcelRegister("41Mwl", function(module, exports) {
$parcel$export(module.exports, "default", () => $54562c55fd1b3586$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $54562c55fd1b3586$var$AssignedToGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedToGroup
    }) : null;
};
var $54562c55fd1b3586$export$2e2bcd8739ae039 = $54562c55fd1b3586$var$AssignedToGroupElement;

});
parcelRegister("vUns3", function(module, exports) {
$parcel$export(module.exports, "default", () => $672b014d8429d73d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $672b014d8429d73d$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $gqBnP = parcelRequire("gqBnP");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $fQH39 = parcelRequire("fQH39");
const $672b014d8429d73d$var$styles = null;
const $672b014d8429d73d$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5NtHI.ElementName).AssignedToGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).assigned_to, personName);
        case (0, $5NtHI.ElementName).OwnedByGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).owned_by, personName);
        case (0, $5NtHI.ElementName).AuthorGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $672b014d8429d73d$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $lRq8t.default)();
    const data = (0, $eJOHy.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5NtHI.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $672b014d8429d73d$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $eGOwo.fg)('platform-linking-enable-avatar-data-separator') ? {
            ['data-separator']: true
        } : {},
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $672b014d8429d73d$export$2e2bcd8739ae039 = $672b014d8429d73d$var$BaseAvatarGroup;
const $672b014d8429d73d$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("lVTJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca273e569a0c1d25$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $ca273e569a0c1d25$var$AttachmentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AttachmentCount
    }) : null;
};
var $ca273e569a0c1d25$export$2e2bcd8739ae039 = $ca273e569a0c1d25$var$AttachmentCountElement;

});

parcelRegister("gl0Fx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5186dee07e48afde$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $5186dee07e48afde$var$AuthorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AuthorGroup
    }) : null;
};
var $5186dee07e48afde$export$2e2bcd8739ae039 = $5186dee07e48afde$var$AuthorGroupElement;

});

parcelRegister("iCDdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e60145f3c4ab217$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $0e60145f3c4ab217$var$ChecklistProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }) : null;
};
var $0e60145f3c4ab217$export$2e2bcd8739ae039 = $0e60145f3c4ab217$var$ChecklistProgressElement;

});

parcelRegister("cSuZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3e78c51e7c53936$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $b3e78c51e7c53936$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CollaboratorGroup
    }) : null;
};
var $b3e78c51e7c53936$export$2e2bcd8739ae039 = $b3e78c51e7c53936$var$CollaboratorGroupElement;

});

parcelRegister("gA3VJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55e7c0307b507f46$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $55e7c0307b507f46$var$CommentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).CommentCount
    }) : null;
};
var $55e7c0307b507f46$export$2e2bcd8739ae039 = $55e7c0307b507f46$var$CommentCountElement;

});

parcelRegister("aiy2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $932490ed3e7f327b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $932490ed3e7f327b$var$CreatedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedOn
    }) : null;
};
var $932490ed3e7f327b$export$2e2bcd8739ae039 = $932490ed3e7f327b$var$CreatedOnElement;

});
parcelRegister("aKX5a", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb039ade903c50b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $cb039ade903c50b2$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wSDf = parcelRequire("6wSDf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $19nmp = parcelRequire("19nmp");
const $cb039ade903c50b2$var$styles = null;
const $cb039ade903c50b2$var$typeToDescriptorMap = {
    created: {
        relative: (0, $19nmp.messages).created_on_relative,
        absolute: (0, $19nmp.messages).created_on_absolute
    },
    modified: {
        relative: (0, $19nmp.messages).modified_on_relative,
        absolute: (0, $19nmp.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $19nmp.messages).sent_on_relative,
        absolute: (0, $19nmp.messages).sent_on_absolute
    }
};
const $cb039ade903c50b2$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $cb039ade903c50b2$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $lRq8t.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $6wSDf.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...$cb039ade903c50b2$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $cb039ade903c50b2$var$fontOverrideStyleMap[fontSize],
            className
        ]),
        children: content
    });
};
var $cb039ade903c50b2$export$2e2bcd8739ae039 = $cb039ade903c50b2$var$BaseDateTimeElement;
const $cb039ade903c50b2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("k4xpX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f3b49272a6afc71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $3f3b49272a6afc71$var$CreatedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedBy
    }) : null;
};
var $3f3b49272a6afc71$export$2e2bcd8739ae039 = $3f3b49272a6afc71$var$CreatedByElement;

});

parcelRegister("kCe9K", function(module, exports) {
$parcel$export(module.exports, "default", () => $805a1aa3004ae832$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $805a1aa3004ae832$var$DueOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $cmzNL.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).DueOn
    }) : null;
};
var $805a1aa3004ae832$export$2e2bcd8739ae039 = $805a1aa3004ae832$var$DueOnElement;

});
parcelRegister("cmzNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $351b36f187c69d22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $351b36f187c69d22$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4Frd9 = parcelRequire("4Frd9");
const $351b36f187c69d22$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $351b36f187c69d22$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge', onAfterChanged: onAfterChanged })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Frd9.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex,
        onAfterChanged: onAfterChanged
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $351b36f187c69d22$export$2e2bcd8739ae039 = $351b36f187c69d22$var$BaseLozengeElement;
const $351b36f187c69d22$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qGN1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("4Frd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9074bb98cbadc69e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $EtcI0 = parcelRequire("EtcI0");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $CpyFM = parcelRequire("CpyFM");

var $b43DQ = parcelRequire("b43DQ");

var $hxkmu = parcelRequire("hxkmu");

var $e9seM = parcelRequire("e9seM");

var $5iuU7 = parcelRequire("5iuU7");

var $4dVhH = parcelRequire("4dVhH");

var $htuxE = parcelRequire("htuxE");

var $dsXZb = parcelRequire("dsXZb");
const $9074bb98cbadc69e$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9074bb98cbadc69e$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged })=>{
    const [selected, setSelected] = (0, $eJOHy.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [items, setItems] = (0, $eJOHy.useState)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)();
    const reload = (0, $kbv8x.default)();
    const invoke = (0, $6O4ri.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $eJOHy.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $EtcI0.default));
                const validItems = typeof text === 'string' ? $9074bb98cbadc69e$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $4dVhH.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $4dVhH.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsXZb.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $CpyFM.default)(updateAction, id);
                await invoke(request);
                onAfterChanged?.();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $d0InI.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $eJOHy.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5iuU7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htuxE.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        ...(0, $eGOwo.fg)('lozenge-dropdown-prop-should-render-to-parent') ? {
            shouldRenderToParent: true
        } : {},
        children: dropdownItemGroup
    });
};
var $9074bb98cbadc69e$export$2e2bcd8739ae039 = (0, $hxkmu.default)($9074bb98cbadc69e$var$LozengeAction);

});
parcelRegister("EtcI0", function(module, exports) {
$parcel$export(module.exports, "default", () => $377731e831492625$export$2e2bcd8739ae039);
const $377731e831492625$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $377731e831492625$export$2e2bcd8739ae039 = $377731e831492625$var$extractLozengeActionItems;

});

parcelRegister("CpyFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb2d7fc7fdf8041$export$2e2bcd8739ae039);
const $7cb2d7fc7fdf8041$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $7cb2d7fc7fdf8041$export$2e2bcd8739ae039 = $7cb2d7fc7fdf8041$var$createStatusUpdateRequest;

});

parcelRegister("hxkmu", function(module, exports) {
$parcel$export(module.exports, "default", () => $808be4e18c85f3f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $808be4e18c85f3f4$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: props?.appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };
var $808be4e18c85f3f4$export$2e2bcd8739ae039 = $808be4e18c85f3f4$var$withErrorBoundary;

});

parcelRegister("e9seM", function(module, exports) {
$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$618660b8f2aa87e2);
const $20533813e4fe1916$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $20533813e4fe1916$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $20533813e4fe1916$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $20533813e4fe1916$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("5iuU7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bafe1b037124149$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $1NG86 = parcelRequire("1NG86");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $7xssH = parcelRequire("7xssH");

var $fQH39 = parcelRequire("fQH39");
const $1bafe1b037124149$var$MAX_LINE_NUMBER = 8;
const $1bafe1b037124149$var$styles = {
    contentStyles: "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c82smr _bfhk18uv _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $1bafe1b037124149$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $1bafe1b037124149$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const invoke = (0, $7xssH.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $eJOHy.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.contentStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $hcewu.default)([
                                $1bafe1b037124149$var$styles.textStylesBase,
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $awdRS.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fQH39.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1bafe1b037124149$var$styles.linkStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                        testId: `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        xcss: $1bafe1b037124149$var$styles.openIssueInJiraStyles,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hcewu.default)([
            $1bafe1b037124149$var$styles.dropdownItemGroupStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $1bafe1b037124149$export$2e2bcd8739ae039 = $1bafe1b037124149$var$LozengeActionError;

});

parcelRegister("4dVhH", function(module, exports) {
$parcel$export(module.exports, "LozengeActionErrorMessages", () => $d6614d1ef8f5be72$export$4f2e371a667ad688);

var $19nmp = parcelRequire("19nmp");
const $d6614d1ef8f5be72$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $19nmp.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $19nmp.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $19nmp.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $19nmp.messages)['status_change_update_error']
    }
};

});

parcelRegister("htuxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $df529be6a716333d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aLJ1L = parcelRequire("aLJ1L");

var $aDuBe = parcelRequire("aDuBe");
const $df529be6a716333d$var$dropdownItemGroupStyles = null;
const $df529be6a716333d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hcewu.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $aDuBe.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $df529be6a716333d$export$2e2bcd8739ae039 = $df529be6a716333d$var$LozengeActionItemsGroup;

});
parcelRegister("aDuBe", function(module, exports) {
$parcel$export(module.exports, "default", () => $f377c3a55bec1fd7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $f377c3a55bec1fd7$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        role: "presentation",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $f377c3a55bec1fd7$export$2e2bcd8739ae039 = $f377c3a55bec1fd7$var$LozengeActionItem;

});


parcelRegister("dsXZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d29b99195ec403c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $8d29b99195ec403c$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w"
};
const $8d29b99195ec403c$var$triggerLozengeStyles = null;
const $8d29b99195ec403c$var$triggerButtonStyles = null;
const $8d29b99195ec403c$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $eJOHy.useState)(false);
    const [isPressing, setIsPressing] = (0, $eJOHy.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $eJOHy.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $eJOHy.useState)(undefined);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $eJOHy.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $eJOHy.useCallback)(()=>setIsPressing(false), []);
    (0, $eJOHy.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CFE1FD)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)($8d29b99195ec403c$var$styles.lozengeContainer, (isOpen || isPressing) && $8d29b99195ec403c$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                    className: (0, $hcewu.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $8d29b99195ec403c$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small",
                                "aria-hidden": true
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $8d29b99195ec403c$export$2e2bcd8739ae039 = $8d29b99195ec403c$var$LozengeActionTrigger;

});




parcelRegister("kB4Nm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e36aa41e9ad3ded$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $9e36aa41e9ad3ded$var$LatestCommitElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LatestCommit
    }) : null;
};
var $9e36aa41e9ad3ded$export$2e2bcd8739ae039 = $9e36aa41e9ad3ded$var$LatestCommitElement;

});

parcelRegister("jPfaa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3002c31f53401640$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $d6nZP = parcelRequire("d6nZP");
const $3002c31f53401640$var$LinkIconElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context) return null;
    const data = (0, $d6nZP.toLinkIconProps)(context?.linkIcon, context.type);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LinkIcon
    }) : null;
};
var $3002c31f53401640$export$2e2bcd8739ae039 = $3002c31f53401640$var$LinkIconElement;

});
parcelRegister("d6nZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a220f00187bff59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $7a220f00187bff59$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $fQH39 = parcelRequire("fQH39");
const $7a220f00187bff59$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7a220f00187bff59$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7a220f00187bff59$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $7a220f00187bff59$var$renderAtlaskitIcon = (icon, testId, size = (0, $5NtHI.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $7a220f00187bff59$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7a220f00187bff59$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5NtHI.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5NtHI.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7a220f00187bff59$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5NtHI.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $eJOHy.useMemo)(()=>{
        const defaultIcon = $7a220f00187bff59$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7a220f00187bff59$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton) || $7a220f00187bff59$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7a220f00187bff59$var$styles.container,
            $7a220f00187bff59$var$positionStyleMap[position],
            render && $7a220f00187bff59$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $7a220f00187bff59$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $7a220f00187bff59$export$2e2bcd8739ae039 = $7a220f00187bff59$var$IconElement;
const $7a220f00187bff59$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $FoFt2.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("2Bqsd", function(module, exports) {
$parcel$export(module.exports, "default", () => $684e70f9d4a0e20c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $684e70f9d4a0e20c$var$LocationElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        theme: (0, $5NtHI.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Location
    }) : null;
};
var $684e70f9d4a0e20c$export$2e2bcd8739ae039 = $684e70f9d4a0e20c$var$LocationElement;

});

parcelRegister("1FNi6", function(module, exports) {
$parcel$export(module.exports, "default", () => $59cc5cb27d2f6980$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $59cc5cb27d2f6980$var$ModifiedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ModifiedBy
    }) : null;
};
var $59cc5cb27d2f6980$export$2e2bcd8739ae039 = $59cc5cb27d2f6980$var$ModifiedByElement;

});

parcelRegister("81kl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b4cff059a6d0796$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $5b4cff059a6d0796$var$ModifiedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ModifiedOn
    }) : null;
};
var $5b4cff059a6d0796$export$2e2bcd8739ae039 = $5b4cff059a6d0796$var$ModifiedOnElement;

});

parcelRegister("946bQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $36681a63387d26b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $36681a63387d26b9$var$OwnedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages)[textPrefix], context?.ownedBy) : null;
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedBy
    }) : null;
};
var $36681a63387d26b9$export$2e2bcd8739ae039 = $36681a63387d26b9$var$OwnedByElement;

});

parcelRegister("4Nd99", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0ab17b3f9ac16f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $d0ab17b3f9ac16f4$var$OwnedByGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedByGroup
    }) : null;
};
var $d0ab17b3f9ac16f4$export$2e2bcd8739ae039 = $d0ab17b3f9ac16f4$var$OwnedByGroupElement;

});

parcelRegister("5kUaD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb8efb6535893df$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $8cb8efb6535893df$var$PriorityElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Priority
    }) : null;
};
var $8cb8efb6535893df$export$2e2bcd8739ae039 = $8cb8efb6535893df$var$PriorityElement;

});

parcelRegister("8MxlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $12bbc9fa6baf6ce0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ProgrammingLanguage
    }) : null;
};
var $12bbc9fa6baf6ce0$export$2e2bcd8739ae039 = $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement;

});

parcelRegister("lwvSM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c70b57958761eec$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $1c70b57958761eec$var$ReactCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ReactCount
    }) : null;
};
var $1c70b57958761eec$export$2e2bcd8739ae039 = $1c70b57958761eec$var$ReactCountElement;

});

parcelRegister("2ITMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2d9d65227b56648$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b2d9d65227b56648$var$ReadTimeElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ReadTime
    }) : null;
};
var $b2d9d65227b56648$export$2e2bcd8739ae039 = $b2d9d65227b56648$var$ReadTimeElement;

});

parcelRegister("iw2r2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e6bf42d4a97c401$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $0e6bf42d4a97c401$var$SentOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SentOn
    }) : null;
};
var $0e6bf42d4a97c401$export$2e2bcd8739ae039 = $0e6bf42d4a97c401$var$SentOnElement;

});

parcelRegister("6Po2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7164a95a609845f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $f7164a95a609845f$var$SourceBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SourceBranch
    }) : null;
};
var $f7164a95a609845f$export$2e2bcd8739ae039 = $f7164a95a609845f$var$SourceBranchElement;

});

parcelRegister("4U5iq", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd8773a8f5d6e97c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $cd8773a8f5d6e97c$var$StateElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).State
    }) : null;
};
var $cd8773a8f5d6e97c$export$2e2bcd8739ae039 = $cd8773a8f5d6e97c$var$StateElement;

});

parcelRegister("jJD7c", function(module, exports) {
$parcel$export(module.exports, "default", () => $e661b354f8faff8b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $e661b354f8faff8b$var$SubscriberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubscriberCount
    }) : null;
};
var $e661b354f8faff8b$export$2e2bcd8739ae039 = $e661b354f8faff8b$var$SubscriberCountElement;

});

parcelRegister("7mGkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $da8be0e62ff3be52$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $da8be0e62ff3be52$var$SubTasksProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubTasksProgress
    }) : null;
};
var $da8be0e62ff3be52$export$2e2bcd8739ae039 = $da8be0e62ff3be52$var$SubTasksProgressElement;

});

parcelRegister("w1OaX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da98c25506acfc3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hTi78 = parcelRequire("hTi78");
const $6da98c25506acfc3$var$StoryPointsElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $hTi78.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hTi78.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).StoryPoints
    }) : null;
};
var $6da98c25506acfc3$export$2e2bcd8739ae039 = $6da98c25506acfc3$var$StoryPointsElement;

});
parcelRegister("hTi78", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fb2764f8e50f778$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $5fb2764f8e50f778$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");
const $5fb2764f8e50f778$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $5fb2764f8e50f778$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
            children: value
        })
    });
};
var $5fb2764f8e50f778$export$2e2bcd8739ae039 = $5fb2764f8e50f778$var$BaseAtlaskitElementBadge;
const $5fb2764f8e50f778$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("cwvSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $44a8674c49925bc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $44a8674c49925bc5$var$TargetBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TargetBranch
    }) : null;
};
var $44a8674c49925bc5$export$2e2bcd8739ae039 = $44a8674c49925bc5$var$TargetBranchElement;

});

parcelRegister("2j4b1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee83b62dd045c6fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $ee83b62dd045c6fd$var$TeamMemberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT ? `${$ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TeamMemberCount
    }) : null;
};
var $ee83b62dd045c6fd$export$2e2bcd8739ae039 = $ee83b62dd045c6fd$var$TeamMemberCountElement;

});

parcelRegister("iQvIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $13574bab0abb9b76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $13574bab0abb9b76$var$UserAttributesElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5NtHI.ElementName).UserAttributes
                }, key));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: elements
    }) : null;
};
var $13574bab0abb9b76$export$2e2bcd8739ae039 = $13574bab0abb9b76$var$UserAttributesElement;

});

parcelRegister("bApaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $32db5b76dc584a40$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $32db5b76dc584a40$var$ViewCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).View,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ViewCount
    }) : null;
};
var $32db5b76dc584a40$export$2e2bcd8739ae039 = $32db5b76dc584a40$var$ViewCountElement;

});

parcelRegister("1IQ2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $49df200106082223$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $49df200106082223$var$VoteCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).VoteCount
    }) : null;
};
var $49df200106082223$export$2e2bcd8739ae039 = $49df200106082223$var$VoteCountElement;

});

parcelRegister("lJDNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b64afcea66b05029$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $b64afcea66b05029$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $19nmp.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Component,
        label: label,
        ...props
    });
};
var $b64afcea66b05029$export$2e2bcd8739ae039 = $b64afcea66b05029$var$AppliedToComponentsCountElement;

});

parcelRegister("i4NpI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e868f1df007f5c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $7e868f1df007f5c9$var$baseStyle = null;
const $7e868f1df007f5c9$var$isMessageDescriptor = (x)=>!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(x);
const $7e868f1df007f5c9$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $7e868f1df007f5c9$var$maxLinesCss = null;
const $7e868f1df007f5c9$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const contentForAccessType = props[accessType] ?? props.fallback;
    if (!contentForAccessType) return null;
    const values = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]?.values;
    if ($7e868f1df007f5c9$var$isMessageDescriptor(contentForAccessType)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...props,
        message: {
            descriptor: contentForAccessType,
            values: values
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        testId: testId,
        hideFormat: true
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: props.color
        },
        "data-separator": true,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            props.fontSize !== undefined && $7e868f1df007f5c9$var$fontOverrideStyleMap[props.fontSize],
            "_1yyjkb7n _102k1j6v",
            className
        ]),
        children: contentForAccessType
    });
};
var $7e868f1df007f5c9$export$2e2bcd8739ae039 = $7e868f1df007f5c9$var$CustomElementByAccessType;

});

parcelRegister("5d1ks", function(module, exports) {
$parcel$export(module.exports, "default", () => $255ff319c604874a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");
const $255ff319c604874a$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        children: component
    });
};
var $255ff319c604874a$export$2e2bcd8739ae039 = $255ff319c604874a$var$CustomByStatusElement;

});




parcelRegister("a86OV", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c0c5c54b91a954$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lHA6U = parcelRequire("lHA6U");
const $26c0c5c54b91a954$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $lHA6U ? $lHA6U[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $26c0c5c54b91a954$export$2e2bcd8739ae039 = $26c0c5c54b91a954$var$ActionGroupItem;

});


parcelRegister("gjoE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9925dc77e1d9b77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cLrUd = parcelRequire("cLrUd");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");
const $e9925dc77e1d9b77$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $e9925dc77e1d9b77$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context?.url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: context?.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position
            }),
            competitorPrompt ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                xcss: $e9925dc77e1d9b77$var$styles.titleBoxCard,
                children: [
                    title,
                    competitorPrompt
                ]
            }) : title,
            showRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cLrUd.default), {
                    testId: testId
                })
            }),
            actionGroup
        ]
    });
};
var $e9925dc77e1d9b77$export$2e2bcd8739ae039 = $e9925dc77e1d9b77$var$TitleBlockErroredView;

});

parcelRegister("haRRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bf1e0846d3cab95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $3bf1e0846d3cab95$var$style = null;
const $3bf1e0846d3cab95$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $3bf1e0846d3cab95$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $brTAh.renderElementItems)(metadata);
    const subtitleElements = (0, $brTAh.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Vertical,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $hcewu.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $3bf1e0846d3cab95$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5NtHI.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $3bf1e0846d3cab95$export$2e2bcd8739ae039 = $3bf1e0846d3cab95$var$TitleBlockResolvedView;

});

parcelRegister("1Ub5D", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9eea7741f2cb919$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $65mpR = parcelRequire("65mpR");

var $jPfaa = parcelRequire("jPfaa");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $f9eea7741f2cb919$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5NtHI.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && icon && (0, $eGOwo.fg)('platform_initial_icon_for_title_block') && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: true
            }),
            !hideIcon && (!icon || !(0, $eGOwo.fg)('platform_initial_icon_for_title_block')) && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $f9eea7741f2cb919$export$2e2bcd8739ae039 = $f9eea7741f2cb919$var$TitleBlockResolvingView;

});


parcelRegister("8YHJ2", function(module, exports) {
$parcel$export(module.exports, "CardSSR", () => $265c0be3b7df6739$export$7b5e1b7f9a325b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $aXKmr = parcelRequire("aXKmr");

var $e2B2h = parcelRequire("e2B2h");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
const $265c0be3b7df6739$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $eJOHy.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorFallbackComponent, {});
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...cardProps
        });
    };
    if ((0, $eGOwo.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: (0, $b43DQ.context),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                FallbackComponent: errorBoundaryFallbackComponent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                        ...cardProps
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: (0, $b43DQ.context),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("4oATR", function(module, exports) {
$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $kioCn = parcelRequire("kioCn");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");

var $ettNQ = parcelRequire("ettNQ");
const $e563c8affb3daadf$var$thirdPartyARIPrefix = 'ari:third-party';
const $e563c8affb3daadf$var$EmbedCardComponent = (0, $kioCn.componentWithFG)('rovo_chat_embed_card_dwell_and_hover_metrics', (0, $9uyEx.EmbedCardUpdated), (0, $9uyEx.EmbedCard));
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    const thirdPartyARI = (0, $03JM4.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $03JM4.getFirstPartyIdentifier)();
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    const fire3PClickEvent = (0, $eGOwo.fg)('platform_smartlink_3pclick_analytics') ? (0, $ettNQ.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
            if (thirdPartyARI && thirdPartyARI.startsWith($e563c8affb3daadf$var$thirdPartyARIPrefix)) {
                const clickURL = (0, $03JM4.getClickUrl)(url, state.details);
                if (clickURL === url && fire3PClickEvent) // For questions or concerns about this event,
                // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
                fire3PClickEvent();
            }
        }
        const isDisablePreviewPanel = disablePreviewPanel && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details),
                panelData: {
                    embedUrl: (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $hy9OT.extractSmartLinkEmbed)(state.details)?.src : undefined
                }
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        thirdPartyARI,
        disablePreviewPanel
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            placeholderData: (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? placeholderData : undefined,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
function $e563c8affb3daadf$var$ComponentUpdated({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    const thirdPartyARI = (0, $03JM4.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $03JM4.getFirstPartyIdentifier)();
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    const fire3PClickEvent = (0, $eGOwo.fg)('platform_smartlink_3pclick_analytics') ? (0, $ettNQ.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
            if (thirdPartyARI && thirdPartyARI.startsWith($e563c8affb3daadf$var$thirdPartyARIPrefix)) {
                const clickURL = (0, $03JM4.getClickUrl)(url, state.details);
                if (clickURL === url && fire3PClickEvent) // For questions or concerns about this event,
                // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
                fire3PClickEvent();
            }
        }
        const isDisablePreviewPanel = disablePreviewPanel && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details),
                panelData: {
                    embedUrl: (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $hy9OT.extractSmartLinkEmbed)(state.details)?.src : undefined
                }
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        thirdPartyARI,
        disablePreviewPanel
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'focus'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseEnter = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseenter'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseLeave = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseleave'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            placeholderData: (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? placeholderData : undefined,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$EmbedCardComponent, {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $e563c8affb3daadf$var$CardWithUrlContentComponent = (0, $kioCn.componentWithFG)('rovo_chat_embed_card_dwell_and_hover_metrics', $e563c8affb3daadf$var$ComponentUpdated, $e563c8affb3daadf$var$Component);
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$CardWithUrlContentComponent, {
                ...props
            })
        })
    });
};

});
parcelRegister("92xoS", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $19fb77b8a89e4410$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $19fb77b8a89e4410$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $19fb77b8a89e4410$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $dpRNR.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $19fb77b8a89e4410$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $bfW07._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});

parcelRegister("iT7eO", function(module, exports) {
$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("bde0S", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $59rsN = parcelRequire("59rsN");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $bwGXC = parcelRequire("bwGXC");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            const shouldShowInPopupWindow = status === 'unauthorized' && (0, $59rsN.default).getExperimentValue('platform_sl_3p_auth_window_experiment', 'cohort', 'control') === 'test';
            const windowFeatures = shouldShowInPopupWindow ? (0, $bwGXC.getWindowOpenFeatures)((0, $bwGXC.AUTH_WINDOW_HEIGHT), (0, $bwGXC.AUTH_WINDOW_WIDTH)) : undefined;
            (0, $ldBiz.auth)(services[0].url, windowFeatures).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("ldBiz", function(module, exports) {
$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("bwGXC", function(module, exports) {
$parcel$export(module.exports, "AUTH_WINDOW_HEIGHT", () => $a9e77956780d6380$export$9737b997a3f49711);
$parcel$export(module.exports, "AUTH_WINDOW_WIDTH", () => $a9e77956780d6380$export$9a6efef0b9731ce2);
$parcel$export(module.exports, "getWindowOpenFeatures", () => $a9e77956780d6380$export$ae408235f8b77e96);
const $a9e77956780d6380$var$BROWSER_SIZE_THRESHOLD = 38;
const $a9e77956780d6380$export$9737b997a3f49711 = 760;
const $a9e77956780d6380$export$9a6efef0b9731ce2 = 620;
const $a9e77956780d6380$export$ae408235f8b77e96 = (popupHeight, popupWidth)=>{
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const vl = window.screenLeft || 0;
    const vt = window.screenTop || 0;
    // Center the popup window
    const left = (vw - popupWidth) / 2 + vl;
    const top = (vh - popupHeight) / 2 + vt;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > popupWidth + $a9e77956780d6380$var$BROWSER_SIZE_THRESHOLD && vh > popupHeight + $a9e77956780d6380$var$BROWSER_SIZE_THRESHOLD ? `width=${popupWidth},height=${popupHeight},left=${left},top=${top}` : undefined;
    return windowFeatures;
};

});

parcelRegister("03JM4", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $a9130c46b8c7e440$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $a9130c46b8c7e440$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $eGOwo = parcelRequire("eGOwo");

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$e029950864672b4 = (details)=>{
    if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $a9130c46b8c7e440$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $a9130c46b8c7e440$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $a9130c46b8c7e440$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $a9130c46b8c7e440$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $a9130c46b8c7e440$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $a9130c46b8c7e440$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("70skx", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("2vJUc", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {
$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("44bDi", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $59rsN = parcelRequire("59rsN");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $59rsN.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("wq6W1", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("6jgT3", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("3u14o", function(module, exports) {
$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    });
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {
$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {
$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {
$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("kj3Kk", function(module, exports) {
$parcel$export(module.exports, "CardLinkView", () => $c60e87c9a02f8e5e$export$ce508304ed2dd145);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bu0pj = parcelRequire("bu0pj");
class $c60e87c9a02f8e5e$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("bu0pj", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $a33467e63cbde9e1$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3qu2 = parcelRequire("e3qu2");

var $hFjcp = parcelRequire("hFjcp");
const $a33467e63cbde9e1$export$b89a827e9254211a = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $hFjcp.WrapperAnchor) : (0, $hFjcp.WrapperSpan);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType,
        children: children
    });
});

});
parcelRegister("hFjcp", function(module, exports) {
$parcel$export(module.exports, "WrapperSpan", () => $410d9f0a7ea732a2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $410d9f0a7ea732a2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $g6YpQ = parcelRequire("g6YpQ");
const $410d9f0a7ea732a2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $g6YpQ.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && experimentValue !== 'control' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $g6YpQ.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rko12b0 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && experimentValue !== 'control' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19it1x13 _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw71x13 _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $410d9f0a7ea732a2$var$interactiveStyles = null;
const $410d9f0a7ea732a2$var$hoveredStyles = null;
const $410d9f0a7ea732a2$var$hoveredWithBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withoutBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withBackgroundStyles = null;
const $410d9f0a7ea732a2$var$truncateStyles = null;
const $410d9f0a7ea732a2$var$unauthorisedTruncateStyles = null;
const $410d9f0a7ea732a2$var$notSelectedStyle = null;
const $410d9f0a7ea732a2$var$selectedStyles = null;

});
parcelRegister("g6YpQ", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $f1d9f52443f254ec$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValNoExposure", () => $f1d9f52443f254ec$export$94f132839aec533f);

var $59rsN = parcelRequire("59rsN");

var $4iJGP = parcelRequire("4iJGP");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $f1d9f52443f254ec$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $bfW07._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $bfW07._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $59rsN.default).initializeCompleted()) return defaultValue;
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $59rsN.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $4iJGP.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $f1d9f52443f254ec$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $f1d9f52443f254ec$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
 * Use to check a any param value for an experiment without firing an exposure event
 *
 * **Note**: this will return the default value when the experiment;
 * - is not being served to the client (ie. pre start)
 * - or is not configured in experiments-config
 *
 * @example
 * ```ts
 * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
 * await new Promise(res => setTimeout(res, delay)
 * ```
 */ 
function $f1d9f52443f254ec$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $f1d9f52443f254ec$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});




parcelRegister("fQuyl", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E06C00)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {
$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                ...(0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? {
                    CompetitorPrompt: CompetitorPrompt
                } : undefined,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz13af"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc0i7uo"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {
$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $dBLxD = parcelRequire("dBLxD");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
const $b72b0d53d138fc6a$var$PENDING_LINK_STATUSES = [
    (0, $5NtHI.SmartLinkStatus).Pending,
    (0, $5NtHI.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $eJOHy.useMemo)(()=>$b72b0d53d138fc6a$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? (0, $dBLxD.extractPlaceHolderCardState)(placeholderData) : undefined, [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState?.status;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        onAuthorize,
        onClick,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        renderers,
        resolve,
        status,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: (0, $eGOwo.fg)('platform_initial_data_for_smart_cards') ? placeHolderStatus ?? status : status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                        extensionKey: details?.meta?.key
                    }
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dBLxD", function(module, exports) {
$parcel$export(module.exports, "extractPlaceHolderCardState", () => $d31cf9af0724655f$export$684541b2632ffbbc);
const $d31cf9af0724655f$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $d31cf9af0724655f$export$684541b2632ffbbc = (placeholderData)=>{
    return $d31cf9af0724655f$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};

});

parcelRegister("dpCTw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && (status === 'resolved' || hoverPreviewOptions?.render !== undefined && (0, $eGOwo.fg)('smart-link-custom-hover-card-content'));
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itia51 _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {
$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            role: 'presentation',
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {
$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $92xoS = parcelRequire("92xoS");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const handleSetIsOpen = (0, $eGOwo.fg)('hover-card-on-visibility-change-callback') ? (0, $eJOHy.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        if ((0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]) : undefined;
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        if (handleSetIsOpen && (0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen && (0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen && (0, $eGOwo.fg)('hover-card-on-visibility-change-callback')) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER,
                ...(0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                    className: $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    const popupComponent = (0, $eGOwo.fg)('hover-card-prop-should-render-to-parent') ? (0, $eJOHy.useMemo)(()=>{
        // Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
        // as it is assumed that the custom popup container has the desired styles
        return (0, $dNwAf.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined);
    }, [
        zIndex,
        shouldRenderToParent
    ]) : (0, $dNwAf.default);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        ...(0, $eGOwo.fg)('hover-card-prop-should-render-to-parent') ? {
            shouldRenderToParent: shouldRenderToParent
        } : {},
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: popupComponent
    });
};

});
parcelRegister("dNwAf", function(module, exports) {
$parcel$export(module.exports, "createCustomPopupContainer", () => $540bc4e78d228f2e$export$c98f335200f1c8df);
$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
const $540bc4e78d228f2e$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            },
            children: children
        }));
};
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {
$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    // Platform apps (Home, Goals, Projects, and Teams) should by default open in the same tab when the FF is enabled.
    const isSameTabAlignmentEnabled = (0, $eGOwo.fg)('townsquare-same-tab-alignment-gcko-849');
    const anchorTarget = product === 'ATLAS' && isSameTabAlignmentEnabled ? '_self' : undefined;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle,
        ...isSameTabAlignmentEnabled ? {
            anchorTarget: anchorTarget
        } : undefined
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        const overrideView = (0, $eGOwo.fg)('smart-link-custom-hover-card-content') ? hoverPreviewOptions?.render?.() : undefined;
        if (overrideView) return overrideView;
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {
$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("1UXt3", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $72576417d80bd61c$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $72576417d80bd61c$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $72576417d80bd61c$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $3jSKi = parcelRequire("3jSKi");
var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $72576417d80bd61c$export$b68822b76d5d51d5(response?.data);
};
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $72576417d80bd61c$export$44130aa92252501(response?.data);
};
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && $72576417d80bd61c$export$b592ddecae70b61d(response?.data);
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};

});

parcelRegister("3a3fF", function(module, exports) {
$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});



parcelRegister("2bxQs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rko1mok _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rko1mok _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {
$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13li1mok _qrwq1mok _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("7r0tl", function(module, exports) {
$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {
$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {
$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {
$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};

});




parcelRegister("1klMO", function(module, exports) {
$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).learn_more_about_connecting_account_appify : (0, $19nmp.messages).learn_more_about_connecting_account : (0, $19nmp.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_appify : (0, $19nmp.messages).connect_unauthorised_account_description;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...unauthorizedAccountDescriptionMessage,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_no_provider_appify : (0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: (0, $eGOwo.fg)('platform-linking-smart-card-layered-link-a11y') ? undefined : -1,
        "aria-hidden": (0, $eGOwo.fg)('platform-linking-smart-card-layered-link-a11y') ? undefined : true,
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {
$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                }
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {
$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractSmartLinkReactCount)(response),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSmartLinkSentOn)(response),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        type: (0, $dpM2S.extractType)(data),
        meta: {
            objectId: (0, $1UXt3.extractMetaObjectId)(meta),
            resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
            tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {
$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {
$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2fsAU", function(module, exports) {
$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("glHkX", function(module, exports) {
$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {
$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {
$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {
$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ccFJO", function(module, exports) {
$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $hy9OT.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("blyJR", function(module, exports) {
$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});



parcelRegister("7xgpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {
$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const result = (0, $5O37S.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});
parcelRegister("5O37S", function(module, exports) {
$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");

var $hziYa = parcelRequire("hziYa");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $hziYa.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel && (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel_modal', 'cohort', 'test')) return;
    if (src) {
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $hy9OT.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $aNEbu.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                            isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                            linkIcon: (0, $8z78z.extractLinkIcon)(response),
                            providerName: (0, $hy9OT.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $hy9OT.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $hy9OT.extractSmartLinkTitle)(response),
                            url: url,
                            isBlanketHidden: (0, $eGOwo.fg)('linking_platform_hide_preview_action_blanket_prop') ? actionOptions?.previewAction?.hideBlanket : undefined,
                            size: (0, $eGOwo.fg)('platform_linking_enable_card_preview_action_size') ? actionOptions?.previewAction?.size : undefined,
                            ...(0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5NtHI.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};

});
parcelRegister("hziYa", function(module, exports) {
$parcel$export(module.exports, "isWithinPreviewPanelIFrame", () => $4758778ac1a56d76$export$24def1b22639c691);
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $4758778ac1a56d76$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $4758778ac1a56d76$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $4758778ac1a56d76$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $4758778ac1a56d76$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $4758778ac1a56d76$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $4758778ac1a56d76$var$getUrlSearchParams(currentSearch);
            if (currentParams && $4758778ac1a56d76$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $4758778ac1a56d76$export$24def1b22639c691 = ()=>{
    return $4758778ac1a56d76$export$9f140ed41af5108c() && $4758778ac1a56d76$export$f274fcef361fe59d();
};

});

parcelRegister("aNEbu", function(module, exports) {
$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("3nRTS"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("3nRTS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {
$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {
$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {
$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {
$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {
$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {
$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {
$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {
$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {
$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {
$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});



parcelRegister("iJBt4", function(module, exports) {
$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $hy9OT = parcelRequire("hy9OT");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {
$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {
$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};

});


parcelRegister("13x9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {
$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {
$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {
$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {
$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {
$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {
$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {
$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {
$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {
$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g961mok _1qo31x13"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syazi7uo"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {
$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syazi7uo"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    uiOptions.enableSnippetRenderer = true;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz13af"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syazi7uo _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {
$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {
$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);
$parcel$export(module.exports, "EmbedCardUpdated", () => $05d9abb62f80e331$export$260b9bbcf2a80ca0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    });
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio,
                ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                    extensionKey: details?.meta?.key
                }
            });
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});
const $05d9abb62f80e331$export$260b9bbcf2a80ca0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio,
                ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                    extensionKey: details?.meta?.key
                }
            });
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {
$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, _platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {
$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("k4P1T", function(module, exports) {
$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::838f4f86c5032d94c12ae3c464c4518b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $awZZu = parcelRequire("awZZu");

var $kSlVI = parcelRequire("kSlVI");

var $eGOwo = parcelRequire("eGOwo");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kSlVI.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("kSlVI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f8594533ccfc7e7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $awZZu = parcelRequire("awZZu");

var $gPsTF = parcelRequire("gPsTF");
function $5f8594533ccfc7e7$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("cBTRt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d7da5f0a9dbfdcb61e67416f34ea57c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e074effda908d62315fc623bb11ea4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $8lO5P = parcelRequire("8lO5P");

var $ipwys = parcelRequire("ipwys");

var $eGOwo = parcelRequire("eGOwo");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ipwys.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("ipwys", function(module, exports) {
$parcel$export(module.exports, "default", () => $528bc82bd809f6ef$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8lO5P = parcelRequire("8lO5P");

var $gPsTF = parcelRequire("gPsTF");
function $528bc82bd809f6ef$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("j8Au4", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508b706ee3537e027a0453638a0b8ef4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6debd57b02ce07c26b500a40c5cf84fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $7XCnf = parcelRequire("7XCnf");

var $klMVJ = parcelRequire("klMVJ");

var $eGOwo = parcelRequire("eGOwo");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klMVJ.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("klMVJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f854a954aead859f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7XCnf = parcelRequire("7XCnf");

var $gPsTF = parcelRequire("gPsTF");
function $f854a954aead859f$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("1OiKX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::410fb939afe4c212397f97afe36b0581>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28ad781cda66347f47adf68d1b8c9215>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $MUJuW = parcelRequire("MUJuW");

var $5ZU2f = parcelRequire("5ZU2f");

var $eGOwo = parcelRequire("eGOwo");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5ZU2f.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("5ZU2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0ccf0bfb3196e91$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $MUJuW = parcelRequire("MUJuW");

var $gPsTF = parcelRequire("gPsTF");
function $f0ccf0bfb3196e91$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("3xtgM", function(module, exports) {
$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fa1181402c522778e280d3429cafbed>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba42c74cbfda9afab131839d0b6c6e6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $bwM92 = parcelRequire("bwM92");

var $iXN9z = parcelRequire("iXN9z");

var $eGOwo = parcelRequire("eGOwo");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXN9z.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("iXN9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4b71fd2f274d4b0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bwM92 = parcelRequire("bwM92");

var $gPsTF = parcelRequire("gPsTF");
function $b4b71fd2f274d4b0$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("dSbyY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3096846462441e20a58007578ded0cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hxN6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a53e84608f4cc80b860fc333251d7715>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc5b9b73b68cb559$var$_react = $cc5b9b73b68cb559$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cc5b9b73b68cb559$var$_baseNew = $cc5b9b73b68cb559$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $cc5b9b73b68cb559$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc5b9b73b68cb559$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $cc5b9b73b68cb559$var$_react.default.createElement($cc5b9b73b68cb559$var$_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$cc5b9b73b68cb559$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $cc5b9b73b68cb559$var$_default = module.exports.default = $cc5b9b73b68cb559$var$PeopleGroupIcon;

});

parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {
$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {
$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a76a3f4404ba59acd822415adfff8b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.displayName = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {
$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::167fa533efc4ba93e24036848d1072d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $9UdpB = parcelRequire("9UdpB");

var $lcl8I = parcelRequire("lcl8I");

var $eGOwo = parcelRequire("eGOwo");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lcl8I.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("lcl8I", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9279295c562e43$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9UdpB = parcelRequire("9UdpB");

var $gPsTF = parcelRequire("gPsTF");
function $9f9279295c562e43$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("ePICl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5651d34540e7f43d2ed8c5db6223a91c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57ea112ed25eedff788d2782c5430357>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $4aDUk = parcelRequire("4aDUk");

var $5A1xk = parcelRequire("5A1xk");

var $eGOwo = parcelRequire("eGOwo");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5A1xk.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("5A1xk", function(module, exports) {
$parcel$export(module.exports, "default", () => $181b872bc3049d17$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4aDUk = parcelRequire("4aDUk");

var $gPsTF = parcelRequire("gPsTF");
function $181b872bc3049d17$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("bqSXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e76b2e34bfd0965e8540e18ec2ba179>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d6daab6c18f6607b508ad6a232f29d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $gtN4u = parcelRequire("gtN4u");

var $5qGkP = parcelRequire("5qGkP");

var $eGOwo = parcelRequire("eGOwo");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qGkP.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("5qGkP", function(module, exports) {
$parcel$export(module.exports, "default", () => $46db67a1a90c5389$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gtN4u = parcelRequire("gtN4u");

var $gPsTF = parcelRequire("gPsTF");
function $46db67a1a90c5389$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("3zPlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a44d02da4898e1053cddbd7d9579da66>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a2ca9a3d5107d7ac162a2a33430a5c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $ljmsu = parcelRequire("ljmsu");

var $6JTVR = parcelRequire("6JTVR");

var $eGOwo = parcelRequire("eGOwo");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JTVR.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f39860ce7f984391648fef01b18ffad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("6JTVR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad5af7b2ef48268$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ljmsu = parcelRequire("ljmsu");

var $gPsTF = parcelRequire("gPsTF");
function $7ad5af7b2ef48268$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("ewxpd", function(module, exports) {
$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12651d67bb24f12b3cf36f86bf08144>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bca06c5d0b322c69c2d7dabe129b3860>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $c59mr = parcelRequire("c59mr");

var $hMLdG = parcelRequire("hMLdG");

var $eGOwo = parcelRequire("eGOwo");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hMLdG.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("hMLdG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0fecfbb7e320ff1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c59mr = parcelRequire("c59mr");

var $gPsTF = parcelRequire("gPsTF");
function $b0fecfbb7e320ff1$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("28xc1", function(module, exports) {
$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92eaddadffe090000f45e8586efb1edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4391ff6105029c3c00dcb25fe777d0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $gNXvC = parcelRequire("gNXvC");

var $k4LJo = parcelRequire("k4LJo");

var $eGOwo = parcelRequire("eGOwo");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k4LJo.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3166f2fe0f47ea82d95571c4b7ab84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("k4LJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $225b63a81c5c98f6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gNXvC = parcelRequire("gNXvC");

var $gPsTF = parcelRequire("gPsTF");
function $225b63a81c5c98f6$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("kFcVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f32c1be67ac8ff7b63f610c2491e7e9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58018d99cc8a0f6abeddbd3fccbd6413>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $hVZow = parcelRequire("hVZow");

var $1ln11 = parcelRequire("1ln11");

var $eGOwo = parcelRequire("eGOwo");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ln11.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("1ln11", function(module, exports) {
$parcel$export(module.exports, "default", () => $02d2d79053f6e150$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hVZow = parcelRequire("hVZow");

var $gPsTF = parcelRequire("gPsTF");
function $02d2d79053f6e150$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("ayExB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1896fd3bafdfc1bc71c0fcf57c8b2685>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ad746f8d6850770b3cdfa715cfc8204>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6IK2z = parcelRequire("6IK2z");

var $d67Vm = parcelRequire("d67Vm");

var $fDwRL = parcelRequire("fDwRL");

var $eGOwo = parcelRequire("eGOwo");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    // Feature flag to migrate to new object package
    if ((0, $eGOwo.fg)('platform_dst_icon_object_to_object')) // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fDwRL.default), {
        label: label,
        testId: testId,
        size: "medium"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6IK2z.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c160a9f26591f77220765c2e9d99939c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("fDwRL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e98ebbc21cca84e8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $d67Vm = parcelRequire("d67Vm");

var $gPsTF = parcelRequire("gPsTF");
function $e98ebbc21cca84e8$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPsTF.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kqL94", function(module, exports) {
$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7332e8f7ef1b441068cfb157f8d729a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {
$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("gxXx6", function(module, exports) {
$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type,
                    hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
const $7e6c0fa079b82f37$var$wrapperStylesOld = null;
const $7e6c0fa079b82f37$var$wrapperStylesNew = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>{
    const shouldAddLozengeAttribute = (0, $cbSL1.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $eGOwo.fg)('platform_editor_content_mode_button_mvp');
    if ((0, $eGOwo.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...shouldAddLozengeAttribute && {
            'data-inline-card-lozenge': true
        },
        className: (0, $hcewu.default)([
            "_1e0c1o8l _154i1n1a _kqswh2mm _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...shouldAddLozengeAttribute && {
            'data-inline-card-lozenge': true
        },
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
};
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz1rpy _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $FoFt2.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                onError: ()=>setHasImageErrored(true),
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {
$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {
$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {
$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9" : "_2rkolb4i _1h6d3acm _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9",
            !isSelected && "_2rkolb4i",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {
$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $kioCn = parcelRequire("kioCn");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$var$ExpandedFrame = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u1yw3",
    linkWrapperBorderAndBackground: "_1tqzia51 _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvia51 _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19itdlqj _2rko12b0 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1tt7",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};
const $5f28b71e696600f5$var$ExpandedFrameUpdated = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt, onContentMouseEnter: onContentMouseEnter, onContentMouseLeave: onContentMouseLeave })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            onMouseEnter: onContentMouseEnter,
            onMouseLeave: onContentMouseLeave,
            onFocus: onContentMouseEnter,
            onBlur: onContentMouseLeave,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$export$7b360cd785b6c366 = (0, $kioCn.componentWithFG)('rovo_chat_embed_card_dwell_and_hover_metrics', $5f28b71e696600f5$var$ExpandedFrameUpdated, $5f28b71e696600f5$var$ExpandedFrame);

});
parcelRegister("65oSX", function(module, exports) {
$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {
$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $cbSL1 = parcelRequire("cbSL1");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton && (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? {
            onError: handleError
        } : undefined
    });
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {
$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {
$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $eGOwo = parcelRequire("eGOwo");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: (0, $eGOwo.fg)('navx-2825-eslint-translation-fix-linking-platform') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    defaultMessage: "Search error"
                }) : 'Search error'
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {
$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $kioCn = parcelRequire("kioCn");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");

var $diXta = parcelRequire("diXta");
const $367ff287c16eda7a$var$FrameComponent = (0, $kioCn.componentWithFG)('rovo_chat_embed_card_dwell_and_hover_metrics', (0, $e3qHE.FrameUpdated), (0, $e3qHE.Frame));
const $367ff287c16eda7a$var$EmbedCardResolvedViewOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton
    ]);
    (0, $diXta.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text,
            extensionKey: extensionKey
        })
    });
});
const $367ff287c16eda7a$var$EmbedCardResolvedViewUpdated = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton
    ]);
    (0, $diXta.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    const [isMouseOver, setMouseOver] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        onContentMouseEnter: ()=>{
            setMouseOver(true);
            onIframeMouseEnter?.();
        },
        onContentMouseLeave: ()=>{
            setMouseOver(false);
            onIframeMouseLeave?.();
        },
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($367ff287c16eda7a$var$FrameComponent, {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            onIframeMouseEnter: onIframeMouseEnter,
            onIframeMouseLeave: onIframeMouseLeave,
            isMouseOver: isMouseOver,
            title: text,
            extensionKey: extensionKey
        })
    });
});
const $367ff287c16eda7a$export$30f3c6c32b384a8b = (0, $kioCn.componentWithFG)('rovo_chat_embed_card_dwell_and_hover_metrics', $367ff287c16eda7a$var$EmbedCardResolvedViewUpdated, $367ff287c16eda7a$var$EmbedCardResolvedViewOld);

});
parcelRegister("e3qHE", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
$parcel$export(module.exports, "FrameUpdated", () => $32febd87e387ddae$export$7831ce69b80d7805);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>{
                    setMouseOver(true);
                },
                onMouseLeave: ()=>{
                    setMouseOver(false);
                },
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                extensionKey: extensionKey,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});
const $32febd87e387ddae$export$7831ce69b80d7805 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isMouseOver: isMouseOverProp, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(document.hasFocus());
    // Use prop if provided (from wrapper), otherwise use local state (for backward compatibility)
    const effectiveMouseOver = isMouseOverProp !== undefined ? isMouseOverProp : isMouseOver;
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Initialize with current focus state
        setWindowFocused(document.hasFocus());
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: effectiveMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>{
                    onIframeMouseEnter?.();
                    // Use local state if prop not provided, otherwise prop takes precedence
                    if (isMouseOverProp === undefined) setMouseOver(true);
                },
                onMouseLeave: ()=>{
                    onIframeMouseLeave?.();
                    // Use local state if prop not provided, otherwise prop takes precedence
                    if (isMouseOverProp === undefined) setMouseOver(false);
                },
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                extensionKey: extensionKey,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {
$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3Gkc1 = parcelRequire("3Gkc1");

var $eGOwo = parcelRequire("eGOwo");

var $dxRkJ = parcelRequire("dxRkJ");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? (0, $dxRkJ.useConfluencePageData)(props.src || '', extensionKey || '') : undefined;
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Gkc1.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};

});
parcelRegister("3Gkc1", function(module, exports) {
$parcel$export(module.exports, "Page", () => $a2bc0e1a0c33c2da$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $gc6HS = parcelRequire("gc6HS");
const $a2bc0e1a0c33c2da$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gc6HS.Page), {
            ...props
        })
    });

});
parcelRegister("jyZeU", function(module, exports) {
$parcel$export(module.exports, "I18nProvider", () => $bad023223c621c92$export$a54013f0d02a8f82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $axNrS = parcelRequire("axNrS");
const $bad023223c621c92$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $axNrS.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $eJOHy.useState)();
    const locale = (0, $eJOHy.useMemo)(()=>(0, $axNrS.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $axNrS.DEFAULT_LOCALE),
        children: children
    });
};

});
parcelRegister("axNrS", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $e8050c0da9fad76c$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $e8050c0da9fad76c$export$dca0327c9b9c6498);
const $e8050c0da9fad76c$var$DEFAULT_LANGUAGE = 'en';
const $e8050c0da9fad76c$var$DEFAULT_REGION = 'US';
const $e8050c0da9fad76c$export$1af4c7e47ad72f44 = `${$e8050c0da9fad76c$var$DEFAULT_LANGUAGE}-${$e8050c0da9fad76c$var$DEFAULT_REGION}`;
const $e8050c0da9fad76c$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $e8050c0da9fad76c$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $e8050c0da9fad76c$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $e8050c0da9fad76c$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $e8050c0da9fad76c$export$1af4c7e47ad72f44;
};

});


parcelRegister("lWsis", function(module, exports) {
$parcel$export(module.exports, "default", () => $abece4116087a64f$export$2e2bcd8739ae039);

var $3i9VW = parcelRequire("3i9VW");

var $57But = parcelRequire("57But");
const $abece4116087a64f$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $3i9VW.default;
        case 'en-US':
        default:
            return 0, $57But.default;
    }
};
var $abece4116087a64f$export$2e2bcd8739ae039 = $abece4116087a64f$var$fetchTranslations;

});
parcelRegister("3i9VW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8a32cb4963d4eb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9a8a32cb4963d4eb$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("57But", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f988a238c590e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $22f988a238c590e1$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});


parcelRegister("gc6HS", function(module, exports) {
$parcel$export(module.exports, "Page", () => $85e32b2256736ca0$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5Mh3y = parcelRequire("5Mh3y");

var $lRq8t = parcelRequire("lRq8t");

var $4eSmy = parcelRequire("4eSmy");

var $6ijO8 = parcelRequire("6ijO8");
const $85e32b2256736ca0$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4eSmy.ViewPage), {
        locale: locale,
        ...props
    });
};
const $85e32b2256736ca0$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ijO8.EditPage), {
        locale: locale,
        ...props
    });
};
const $85e32b2256736ca0$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Mh3y.Page), {
        locale: locale,
        ...props,
        viewComponent: $85e32b2256736ca0$var$ViewComponent,
        editComponent: $85e32b2256736ca0$var$EditComponent
    });
};

});
parcelRegister("5Mh3y", function(module, exports) {
$parcel$export(module.exports, "Page", () => $e1e42838b53dfae8$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $5NuS5 = parcelRequire("5NuS5");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");
const $e1e42838b53dfae8$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NuS5.Page), {
                ...props
            })
        })
    });

});
parcelRegister("5NuS5", function(module, exports) {
$parcel$export(module.exports, "Page", () => $b83dd449ca0b36bb$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $9fAcm = parcelRequire("9fAcm");

var $52WL7 = parcelRequire("52WL7");

var $6DF4T = parcelRequire("6DF4T");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");
const $b83dd449ca0b36bb$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $b83dd449ca0b36bb$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $b83dd449ca0b36bb$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $9fAcm.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $eJOHy.useState)(mode);
    (0, $eJOHy.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $eJOHy.useState)(spaceKey);
    const switchToViewPage = (0, $eJOHy.useCallback)(()=>{
        setCurrentMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
				 * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
				 */ if (currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && ((0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.contentId === modifiers.contentId : true)) {
                    setCurrentMode((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $52WL7.useExperienceTracker)();
    (0, $eJOHy.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
				 * Using experienceTracker, we can switch from Edit to View page.
				 * 1. When the user clicks the Publish button and task success, it can switch to the View page.
				 *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
				 *          change the spaceKey during publish.
				 *          In that case, a new spaceKey will be added to the success event and tracked here.
				 * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
				 */ const isClosingPublishedEditPage = !draftShareId && name === $b83dd449ca0b36bb$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $b83dd449ca0b36bb$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null
    });
};

});
parcelRegister("52WL7", function(module, exports) {
$parcel$export(module.exports, "useExperienceTracker", () => $61f00e7f38957a02$export$cdefb2a8b53f879f);

var $eJOHy = parcelRequire("eJOHy");

var $87Obl = parcelRequire("87Obl");
var $40f0Z = parcelRequire("40f0Z");

var $9g7u4 = parcelRequire("9g7u4");

var $5ZujZ = parcelRequire("5ZujZ");
function $61f00e7f38957a02$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $eJOHy.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $87Obl.ExperienceTracker)();
    (0, $9g7u4.useAnalytics)(embeddedConfluenceETRef.current);
    $61f00e7f38957a02$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $61f00e7f38957a02$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $eJOHy.useRef)();
    const embeddingProductET = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $5ZujZ.setExperiencesForwarding)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("9g7u4", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $9b6e4424e97e8f9e$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $j2zMY = parcelRequire("j2zMY");

var $8NHBs = parcelRequire("8NHBs");

var $fnLem = parcelRequire("fnLem");
const $9b6e4424e97e8f9e$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $j2zMY.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $8NHBs.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $fnLem.ANALYTICS_CHANNEL));
    });
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("j2zMY", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_NAME_PREFIX", () => $a22062b7ca04dc2f$export$b9fadc635fed6276);
$parcel$export(module.exports, "ExperienceNames", () => $a22062b7ca04dc2f$export$312b1a9f1141bdaa);
$parcel$export(module.exports, "ExperienceReasons", () => $a22062b7ca04dc2f$export$db5add30a8721c38);
$parcel$export(module.exports, "SupportedExperienceNames", () => $a22062b7ca04dc2f$export$ce9b20b2ad3e7bc6);
const $a22062b7ca04dc2f$export$b9fadc635fed6276 = 'embedded-confluence/';
var $a22062b7ca04dc2f$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $a22062b7ca04dc2f$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $a22062b7ca04dc2f$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});

});

parcelRegister("8NHBs", function(module, exports) {
$parcel$export(module.exports, "createExperienceTrackerAnalyticsEventPayload", () => $55d79b53e5470d85$export$9c05e7ef9f2c8895);
const $55d79b53e5470d85$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $55d79b53e5470d85$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $55d79b53e5470d85$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}

});

parcelRegister("fnLem", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $4e744db00984a860$export$85183a312807388d);

var $9g7u4 = parcelRequire("9g7u4");
const $4e744db00984a860$export$85183a312807388d = 'embeddedConfluence';

});


parcelRegister("5ZujZ", function(module, exports) {
$parcel$export(module.exports, "setExperiencesForwarding", () => $08d63358f56f2fa7$export$7ecf150f65423c3f);
function $08d63358f56f2fa7$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}

});



parcelRegister("7oRxl", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundEmptyState", () => $9a8674d2e142bed1$export$d3ec4d3c4e3e468c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $Ov5I7 = parcelRequire("Ov5I7");

var $2XnNJ = parcelRequire("2XnNJ");
const $9a8674d2e142bed1$var$styles = {
    image: "_p12f1mjv _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
// Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const $9a8674d2e142bed1$var$PreviewPanelPageNotFoundSVG = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $9a8674d2e142bed1$var$styles.image,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2XnNJ.PageNotFoundSVG), {})
    });
};
const $9a8674d2e142bed1$export$d3ec4d3c4e3e468c = ({ embeddedConfluenceSource: embeddedConfluenceSource } = {})=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
    const EmptyStateImage = isInPreviewPanel ? $9a8674d2e142bed1$var$PreviewPanelPageNotFoundSVG : (0, $2XnNJ.PageNotFoundSVG);
    const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6MnLl.default), {
        header: formatMessage((0, $Ov5I7.default).emptyStateHeader),
        description: formatMessage((0, $Ov5I7.default).emptyStateDescription),
        width: EmptyStateWidth,
        renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(EmptyStateImage, {})
    });
};

});
parcelRegister("Ov5I7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e921b67742a22da0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e921b67742a22da0$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: 'embedded-confluence-common.src.content.empty-state-header',
        description: 'The header message in the empty state error screen shown to the user when there is no page to render'
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: 'embedded-confluence-common.src.content.empty-state-description',
        description: 'The description message in the empty state error screen shown to the user when there is no page to render'
    }
});
var $e921b67742a22da0$export$2e2bcd8739ae039 = $e921b67742a22da0$var$messages;

});

parcelRegister("2XnNJ", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundSVG", () => $608c538d98081b3b$export$7cd49dc959d58823);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $608c538d98081b3b$var$styles = `{
  cls4: { fill: '#b3f5ff' },
  cls50: { fill: '#79e2f2' },
  cls228: { fill: 'url(#radial-gradient-7)' },
  cls230: { fill: 'url(#radial-gradient-9)' },
  cls240: { fill: '#c1c7d0' },
  cls242: { fill: '#dfe1e5' },
  cls245: { fill: '#172b4d' },
  cls247: { fill: '#00c7e5' },
  cls249: { fill: 'none' },
  cls250: { fill: '#72594b' },
  cls261: { opacity: 0.6 },
  cls262: { fill: '#ff8b00' },
  cls263: { fill: '#ecc19c' },
}`;
const $608c538d98081b3b$export$7cd49dc959d58823 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "476.06",
        height: "482.63",
        viewBox: "0 0 476.06 482.63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "319.98",
                        y1: "322.55",
                        x2: "426.85",
                        y2: "215.68",
                        gradientTransform: "translate(-227.29)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".06",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".27",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".45",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".67"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".72",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "7261.66",
                        y1: "168.49",
                        x2: "7391.94",
                        y2: "38.21",
                        gradientTransform: "matrix(-1 0 0 1 7632.29 0)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: "146.17",
                        y1: "164.89",
                        x2: "239.99",
                        y2: "71.07",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: "782.51",
                        y1: "-1187.31",
                        x2: "790.62",
                        y2: "-1204.87",
                        gradientTransform: "rotate(-24.78 3495.39 868.508)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".25",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: "5.81",
                        y1: "472.52",
                        x2: "5.81",
                        y2: "284.67",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".43",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: "8.47",
                        y1: "472.52",
                        x2: "8.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: "69.15",
                        y1: "472.52",
                        x2: "69.15",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: "63.61",
                        y1: "472.52",
                        x2: "63.61",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: "67.33",
                        y1: "472.52",
                        x2: "67.33",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: "68.21",
                        y1: "472.52",
                        x2: "68.21",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: "68.78",
                        y1: "472.52",
                        x2: "68.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: "52.51",
                        y1: "472.52",
                        x2: "52.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: "56.67",
                        y1: "472.52",
                        x2: "56.67",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-15",
                        x1: "54.47",
                        y1: "472.52",
                        x2: "54.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: "60.3",
                        y1: "472.52",
                        x2: "60.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: "62.16",
                        y1: "472.52",
                        x2: "62.16",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-18",
                        x1: "58.5",
                        y1: "472.52",
                        x2: "58.5",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-19",
                        x1: "66.35",
                        y1: "472.52",
                        x2: "66.35",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-20",
                        x1: "3.23",
                        y1: "472.52",
                        x2: "3.23",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-21",
                        x1: "160.2",
                        y1: "472.52",
                        x2: "160.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-22",
                        x1: "71.2",
                        y1: "472.52",
                        x2: "71.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-23",
                        x1: "271.02",
                        y1: "472.52",
                        x2: "271.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-24",
                        x1: "4.82",
                        y1: "472.52",
                        x2: "4.82",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-25",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-26",
                        x1: "195.3",
                        y1: "472.52",
                        x2: "195.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-27",
                        x1: "3.53",
                        y1: "472.52",
                        x2: "3.53",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-28",
                        x1: "3.37",
                        y1: "472.52",
                        x2: "3.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-29",
                        x1: "4.07",
                        y1: "472.52",
                        x2: "4.07",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-30",
                        x1: "273.13",
                        y1: "472.52",
                        x2: "273.13",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-31",
                        x1: "273.13",
                        y1: "462.4",
                        x2: "273.13",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-32",
                        x1: "220.7",
                        y1: "472.52",
                        x2: "220.7",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-33",
                        x1: "220.7",
                        y1: "462.4",
                        x2: "220.7",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-34",
                        x1: "185.46",
                        y1: "472.52",
                        x2: "185.46",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-35",
                        x1: "185.46",
                        y1: "402.18",
                        x2: "185.46",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#abf2fd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".22",
                                stopColor: "#95ebf8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".4",
                                stopColor: "#85e6f5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".61",
                                stopColor: "#7ce3f3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".91",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-36",
                        x1: "148.26",
                        y1: "472.52",
                        x2: "148.26",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-37",
                        x1: "148.26",
                        y1: "402.18",
                        x2: "148.26",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-38",
                        x1: "186.02",
                        y1: "472.52",
                        x2: "186.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-39",
                        x1: "186.02",
                        y1: "462.4",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-40",
                        x1: "186.02",
                        y1: "402.18",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-41",
                        x1: "214.14",
                        y1: "472.52",
                        x2: "214.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-42",
                        x1: "214.14",
                        y1: "462.4",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-43",
                        x1: "214.14",
                        y1: "402.18",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-44",
                        x1: "185.54",
                        y1: "402.18",
                        x2: "185.54",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-45",
                        x1: "338.36",
                        y1: "472.52",
                        x2: "338.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-46",
                        x1: "338.36",
                        y1: "402.18",
                        x2: "338.36",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-47",
                        x1: "283.93",
                        y1: "472.52",
                        x2: "283.93",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-48",
                        x1: "283.93",
                        y1: "462.4",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-49",
                        x1: "283.93",
                        y1: "402.18",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-50",
                        x1: "403.38",
                        y1: "472.52",
                        x2: "403.38",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-51",
                        x1: "396.98",
                        y1: "411.33",
                        x2: "409.97",
                        y2: "305.52",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".02",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".78"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".61"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".07",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".47"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".1",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".34"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".23"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".17",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".15"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".03"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".52",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".67",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".74",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".04"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".09"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".83",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".16"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".86",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".25"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".93",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".49"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".65"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".82"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-52",
                        x1: "2.42",
                        y1: "362.88",
                        x2: "15.41",
                        y2: "257.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-53",
                        x1: "3.3",
                        y1: "362.99",
                        x2: "16.29",
                        y2: "257.18",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-54",
                        x1: "4.38",
                        y1: "363.12",
                        x2: "17.37",
                        y2: "257.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-55",
                        x1: "1.14",
                        y1: "362.72",
                        x2: "14.13",
                        y2: "256.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-56",
                        x1: "5.69",
                        y1: "363.28",
                        x2: "18.68",
                        y2: "257.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-57",
                        x1: "1.05",
                        y1: "362.71",
                        x2: "14.04",
                        y2: "256.9",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-58",
                        x1: "10.57",
                        y1: "363.88",
                        x2: "11.95",
                        y2: "352.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-59",
                        x1: "1.74",
                        y1: "362.79",
                        x2: "14.73",
                        y2: "256.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-60",
                        x1: "171.14",
                        y1: "472.52",
                        x2: "171.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-61",
                        x1: "165.11",
                        y1: "382.85",
                        x2: "178.1",
                        y2: "277.05",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-62",
                        x1: "251.72",
                        y1: "472.52",
                        x2: "251.72",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-63",
                        x1: "251.72",
                        y1: "462.4",
                        x2: "251.72",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-64",
                        x1: "249.31",
                        y1: "393.2",
                        x2: "262.3",
                        y2: "287.39",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-65",
                        x1: "237.87",
                        y1: "472.52",
                        x2: "237.87",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-66",
                        x1: "237.87",
                        y1: "462.4",
                        x2: "237.87",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-67",
                        x1: "235.86",
                        y1: "391.55",
                        x2: "248.85",
                        y2: "285.74",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-68",
                        x1: "153.84",
                        y1: "472.52",
                        x2: "153.84",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-69",
                        x1: "153.84",
                        y1: "402.18",
                        x2: "153.84",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-70",
                        x1: "152.5",
                        y1: "381.31",
                        x2: "165.5",
                        y2: "275.5",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-71",
                        x1: "172.27",
                        y1: "472.52",
                        x2: "172.27",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-72",
                        x1: "172.27",
                        y1: "462.4",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-73",
                        x1: "172.27",
                        y1: "402.18",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-74",
                        x1: "168.95",
                        y1: "383.33",
                        x2: "181.94",
                        y2: "277.52",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-75",
                        x1: "221.37",
                        y1: "472.52",
                        x2: "221.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-76",
                        x1: "221.37",
                        y1: "462.4",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-77",
                        x1: "221.37",
                        y1: "402.18",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-78",
                        x1: "218.94",
                        y1: "389.47",
                        x2: "231.93",
                        y2: "283.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-79",
                        x1: "187.52",
                        y1: "472.52",
                        x2: "187.52",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-80",
                        x1: "187.52",
                        y1: "462.4",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-81",
                        x1: "187.52",
                        y1: "402.18",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-82",
                        x1: "184.77",
                        y1: "385.27",
                        x2: "197.76",
                        y2: "279.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-83",
                        x1: "180.43",
                        y1: "402.18",
                        x2: "180.43",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-84",
                        x1: "178.58",
                        y1: "384.51",
                        x2: "191.57",
                        y2: "278.7",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-85",
                        x1: "193.4",
                        y1: "402.18",
                        x2: "193.4",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-86",
                        x1: "191.37",
                        y1: "386.08",
                        x2: "204.37",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-87",
                        x1: "240.98",
                        y1: "392.17",
                        x2: "253.97",
                        y2: "286.37",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-88",
                        x1: "333.44",
                        y1: "472.52",
                        x2: "333.44",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-89",
                        x1: "333.44",
                        y1: "402.18",
                        x2: "333.44",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-90",
                        x1: "329.79",
                        y1: "403.08",
                        x2: "342.78",
                        y2: "297.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-91",
                        x1: "283.96",
                        y1: "472.52",
                        x2: "283.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-92",
                        x1: "283.96",
                        y1: "462.4",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-93",
                        x1: "283.96",
                        y1: "402.18",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-94",
                        x1: "279.87",
                        y1: "396.95",
                        x2: "292.86",
                        y2: "291.14",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-95",
                        x1: "204.11",
                        y1: "472.52",
                        x2: "204.11",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-96",
                        x1: "184.3",
                        y1: "387.71",
                        x2: "228.81",
                        y2: "265.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-97",
                        x1: "197.55",
                        y1: "386.84",
                        x2: "210.54",
                        y2: "281.03",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-98",
                        x1: "375.18",
                        y1: "472.52",
                        x2: "375.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-99",
                        x1: "339.82",
                        y1: "444.31",
                        x2: "384.34",
                        y2: "322.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-100",
                        x1: "367.74",
                        y1: "407.74",
                        x2: "380.74",
                        y2: "301.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-101",
                        x1: "154.96",
                        y1: "472.52",
                        x2: "154.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-102",
                        x1: "154.96",
                        y1: "402.18",
                        x2: "154.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-103",
                        x1: "148.01",
                        y1: "374.5",
                        x2: "192.52",
                        y2: "252.19",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-104",
                        x1: "151.79",
                        y1: "381.22",
                        x2: "164.78",
                        y2: "275.42",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-105",
                        x1: "202.83",
                        y1: "472.52",
                        x2: "202.83",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-106",
                        x1: "202.83",
                        y1: "462.4",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-107",
                        x1: "202.83",
                        y1: "402.18",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-108",
                        x1: "190.53",
                        y1: "389.97",
                        x2: "235.04",
                        y2: "267.67",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-109",
                        x1: "199.1",
                        y1: "387.03",
                        x2: "212.09",
                        y2: "281.22",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-110",
                        x1: "170.79",
                        y1: "472.52",
                        x2: "170.79",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-111",
                        x1: "170.79",
                        y1: "462.4",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-112",
                        x1: "170.79",
                        y1: "402.18",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-113",
                        x1: "161.27",
                        y1: "379.33",
                        x2: "205.79",
                        y2: "257.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-114",
                        x1: "166.95",
                        y1: "383.08",
                        x2: "179.94",
                        y2: "277.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-115",
                        x1: "188.51",
                        y1: "472.52",
                        x2: "188.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-116",
                        x1: "188.51",
                        y1: "462.4",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-117",
                        x1: "188.51",
                        y1: "402.18",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-118",
                        x1: "177.1",
                        y1: "385.09",
                        x2: "221.61",
                        y2: "262.78",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-119",
                        x1: "184.49",
                        y1: "385.24",
                        x2: "197.49",
                        y2: "279.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-120",
                        x1: "181.55",
                        y1: "402.18",
                        x2: "181.55",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-121",
                        x1: "171.4",
                        y1: "383.01",
                        x2: "215.92",
                        y2: "260.71",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-122",
                        x1: "178.12",
                        y1: "384.46",
                        x2: "191.11",
                        y2: "278.65",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-123",
                        x1: "195.05",
                        y1: "402.18",
                        x2: "195.05",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-124",
                        x1: "183.47",
                        y1: "387.41",
                        x2: "227.99",
                        y2: "265.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-125",
                        x1: "191.39",
                        y1: "386.09",
                        x2: "204.38",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-126",
                        x1: "227.14",
                        y1: "403.3",
                        x2: "271.66",
                        y2: "281",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-127",
                        x1: "240.77",
                        y1: "392.15",
                        x2: "253.76",
                        y2: "286.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-128",
                        x1: "334.77",
                        y1: "472.52",
                        x2: "334.77",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-129",
                        x1: "334.77",
                        y1: "402.18",
                        x2: "334.77",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-130",
                        x1: "306.53",
                        y1: "432.19",
                        x2: "351.04",
                        y2: "309.89",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-131",
                        x1: "328.83",
                        y1: "402.96",
                        x2: "341.82",
                        y2: "297.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-132",
                        x1: "305.41",
                        y1: "472.52",
                        x2: "305.41",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-133",
                        x1: "305.41",
                        y1: "462.4",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-134",
                        x1: "305.41",
                        y1: "402.18",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-135",
                        x1: "280.29",
                        y1: "422.65",
                        x2: "324.81",
                        y2: "300.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-136",
                        x1: "299.79",
                        y1: "399.4",
                        x2: "312.78",
                        y2: "293.59",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-137",
                        x1: "237.39",
                        y1: "472.52",
                        x2: "237.39",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-138",
                        x1: "94.24",
                        y1: "336.36",
                        x2: "382.66",
                        y2: "336.36",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-139",
                        x1: "215.63",
                        y1: "399.11",
                        x2: "260.14",
                        y2: "276.81",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-140",
                        x1: "231.06",
                        y1: "390.96",
                        x2: "244.05",
                        y2: "285.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-141",
                        x1: "154.66",
                        y1: "472.52",
                        x2: "154.66",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-142",
                        x1: "154.66",
                        y1: "402.18",
                        x2: "154.66",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-143",
                        x1: "94.24",
                        y1: "347.55",
                        x2: "382.66",
                        y2: "347.55",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-144",
                        x1: "146.2",
                        y1: "373.84",
                        x2: "190.71",
                        y2: "251.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-145",
                        x1: "150.91",
                        y1: "381.12",
                        x2: "163.9",
                        y2: "275.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-146",
                        x1: "168.62",
                        y1: "472.52",
                        x2: "168.62",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-147",
                        x1: "168.62",
                        y1: "462.4",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-148",
                        x1: "168.62",
                        y1: "402.18",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-149",
                        x1: "94.24",
                        y1: "348.31",
                        x2: "382.66",
                        y2: "348.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-150",
                        x1: "157.53",
                        y1: "377.96",
                        x2: "202.04",
                        y2: "255.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-151",
                        x1: "164.09",
                        y1: "382.73",
                        x2: "177.09",
                        y2: "276.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-152",
                        x1: "188.58",
                        y1: "472.52",
                        x2: "188.58",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-153",
                        x1: "188.58",
                        y1: "462.4",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-154",
                        x1: "188.58",
                        y1: "402.18",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-155",
                        x1: "94.24",
                        y1: "350.99",
                        x2: "382.66",
                        y2: "350.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-156",
                        x1: "176.21",
                        y1: "384.76",
                        x2: "220.72",
                        y2: "262.46",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-157",
                        x1: "184.32",
                        y1: "385.22",
                        x2: "197.31",
                        y2: "279.41",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-158",
                        x1: "181.71",
                        y1: "402.18",
                        x2: "181.71",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-159",
                        x1: "94.24",
                        y1: "349.53",
                        x2: "382.66",
                        y2: "349.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-160",
                        x1: "170.01",
                        y1: "382.51",
                        x2: "214.52",
                        y2: "260.2",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-161",
                        x1: "177.73",
                        y1: "384.41",
                        x2: "190.72",
                        y2: "278.6",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-162",
                        x1: "193.08",
                        y1: "402.18",
                        x2: "193.08",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-163",
                        x1: "94.24",
                        y1: "352.21",
                        x2: "382.66",
                        y2: "352.21",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-164",
                        x1: "180.71",
                        y1: "386.4",
                        x2: "225.23",
                        y2: "264.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-165",
                        x1: "189.02",
                        y1: "385.79",
                        x2: "202.01",
                        y2: "279.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-166",
                        x1: "94.24",
                        y1: "349.07",
                        x2: "382.66",
                        y2: "349.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-167",
                        x1: "225.04",
                        y1: "402.53",
                        x2: "269.55",
                        y2: "280.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-168",
                        x1: "240.19",
                        y1: "392.08",
                        x2: "253.18",
                        y2: "286.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-169",
                        x1: "335.09",
                        y1: "472.52",
                        x2: "335.09",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-170",
                        x1: "335.09",
                        y1: "402.18",
                        x2: "335.09",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-171",
                        x1: "94.24",
                        y1: "346.43",
                        x2: "382.66",
                        y2: "346.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-172",
                        x1: "305.17",
                        y1: "431.7",
                        x2: "349.68",
                        y2: "309.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-173",
                        x1: "328.53",
                        y1: "402.92",
                        x2: "341.52",
                        y2: "297.12",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-174",
                        x1: "314.18",
                        y1: "472.52",
                        x2: "314.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-175",
                        x1: "314.18",
                        y1: "462.4",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-176",
                        x1: "314.18",
                        y1: "402.18",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-177",
                        x1: "94.24",
                        y1: "347.82",
                        x2: "382.66",
                        y2: "347.82",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-178",
                        x1: "286.17",
                        y1: "424.78",
                        x2: "330.68",
                        y2: "302.48",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-179",
                        x1: "307.73",
                        y1: "400.37",
                        x2: "320.72",
                        y2: "294.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-180",
                        x1: "238.45",
                        y1: "472.52",
                        x2: "238.45",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-181",
                        x1: "94.24",
                        y1: "336.66",
                        x2: "382.66",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-182",
                        x1: "120.57",
                        y1: "336.66",
                        x2: "356.32",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-183",
                        x1: "216.19",
                        y1: "399.31",
                        x2: "260.7",
                        y2: "277.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-184",
                        x1: "231.95",
                        y1: "391.07",
                        x2: "244.94",
                        y2: "285.26",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-185",
                        x1: "154.01",
                        y1: "472.52",
                        x2: "154.01",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-186",
                        x1: "154.01",
                        y1: "402.18",
                        x2: "154.01",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-187",
                        x1: "94.24",
                        y1: "340.77",
                        x2: "382.66",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-188",
                        x1: "120.57",
                        y1: "340.77",
                        x2: "356.32",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-189",
                        x1: "143.55",
                        y1: "372.88",
                        x2: "188.07",
                        y2: "250.57",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-190",
                        x1: "149.49",
                        y1: "380.94",
                        x2: "162.48",
                        y2: "275.13",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-191",
                        x1: "164.37",
                        y1: "472.52",
                        x2: "164.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-192",
                        x1: "164.37",
                        y1: "462.4",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-193",
                        x1: "164.37",
                        y1: "402.18",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-194",
                        x1: "94.24",
                        y1: "341.24",
                        x2: "382.66",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-195",
                        x1: "120.57",
                        y1: "341.24",
                        x2: "356.32",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-196",
                        x1: "151.77",
                        y1: "375.87",
                        x2: "196.28",
                        y2: "253.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-197",
                        x1: "159.34",
                        y1: "382.15",
                        x2: "172.34",
                        y2: "276.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-198",
                        x1: "94.24",
                        y1: "341.91",
                        x2: "382.66",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-199",
                        x1: "120.57",
                        y1: "341.91",
                        x2: "356.32",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-200",
                        x1: "221.5",
                        y1: "401.25",
                        x2: "266.01",
                        y2: "278.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-201",
                        x1: "238.15",
                        y1: "391.83",
                        x2: "251.14",
                        y2: "286.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-202",
                        x1: "335.78",
                        y1: "472.52",
                        x2: "335.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-203",
                        x1: "335.78",
                        y1: "402.18",
                        x2: "335.78",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-204",
                        x1: "94.24",
                        y1: "340.23",
                        x2: "382.66",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-205",
                        x1: "120.57",
                        y1: "340.23",
                        x2: "356.32",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-206",
                        x1: "303.69",
                        y1: "431.16",
                        x2: "348.2",
                        y2: "308.86",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-207",
                        x1: "328.42",
                        y1: "402.91",
                        x2: "341.41",
                        y2: "297.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-208",
                        x1: "326.47",
                        y1: "472.52",
                        x2: "326.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-209",
                        x1: "326.47",
                        y1: "462.4",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-210",
                        x1: "326.47",
                        y1: "402.18",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-211",
                        x1: "94.24",
                        y1: "340.83",
                        x2: "382.66",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-212",
                        x1: "120.57",
                        y1: "340.83",
                        x2: "356.32",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-213",
                        x1: "294.77",
                        y1: "427.92",
                        x2: "339.28",
                        y2: "305.61",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-214",
                        x1: "318.99",
                        y1: "401.75",
                        x2: "331.98",
                        y2: "295.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-215",
                        x1: "105.04",
                        y1: "472.52",
                        x2: "105.04",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-216",
                        x1: "134.74",
                        y1: "472.52",
                        x2: "134.74",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-217",
                        x1: "134.74",
                        y1: "402.18",
                        x2: "134.74",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-218",
                        x1: "115.09",
                        y1: "282.96",
                        x2: "376",
                        y2: "282.96",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3bac5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".85",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-219",
                        x1: "163.83",
                        y1: "347.6",
                        x2: "279.38",
                        y2: "232.05",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".14",
                                stopColor: "#c9ced6"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".68",
                                stopColor: "#e2e4e9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-220",
                        x1: "291.34",
                        y1: "337.73",
                        x2: "291.34",
                        y2: "198.21",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-221",
                        x1: "219.34",
                        y1: "215.53",
                        x2: "331.33",
                        y2: "215.53",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".18",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-222",
                        x1: "4697.25",
                        y1: "308.96",
                        x2: "4793.78",
                        y2: "308.96",
                        gradientTransform: "matrix(-1 0 0 1 4935.69 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-223",
                        x1: "-10103.77",
                        y1: "-1179.29",
                        x2: "-10103.77",
                        y2: "-1247.52",
                        gradientTransform: "matrix(.99 -.11 .11 .99 10362.66 390.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".37",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-224",
                        x1: "197.02",
                        y1: "184.01",
                        x2: "293.47",
                        y2: "87.57",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".36",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-225",
                        x1: "294.7",
                        y1: "238.16",
                        x2: "334.79",
                        y2: "238.16",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".12",
                                stopColor: "#0d6eff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".49",
                                stopColor: "#2f86ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".8",
                                stopColor: "#4495ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-226",
                        x1: "245.55",
                        y1: "299.49",
                        x2: "376",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".47",
                                stopColor: "#f5f6f8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-227",
                        x1: "153.96",
                        y1: "321.19",
                        x2: "337.13",
                        y2: "321.19",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-228",
                        x1: "115.09",
                        y1: "299.49",
                        x2: "245.55",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-229",
                        x1: "251.12",
                        y1: "196.75",
                        x2: "347.56",
                        y2: "100.3",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".08",
                                stopColor: "#ffa219"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#ffbb07"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-230",
                        x1: "-2946.9",
                        y1: "-501.86",
                        x2: "-2929.95",
                        y2: "-501.86",
                        gradientTransform: "matrix(-.75 .66 .66 .75 -1698.92 2528.01)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".54",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#00bddd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-231",
                        x1: "913.18",
                        y1: "236.51",
                        x2: "936.34",
                        y2: "213.36",
                        gradientTransform: "matrix(-1 0 0 1 1111.25 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".62",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-232",
                        x1: "2869.84",
                        y1: "1497.87",
                        x2: "2882.64",
                        y2: "1491.62",
                        gradientTransform: "matrix(-.9 -.43 -.43 .9 3435.48 110.98)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#00a8c5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#00b8d5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".84",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: "-6136.21",
                        y1: "5146.38",
                        x2: "-6130.92",
                        y2: "5141.09",
                        gradientTransform: "matrix(1 0 0 1.52 6291.96 -7637.21)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: "-6135.75",
                        y1: "5139.64",
                        x2: "-6131.37",
                        y2: "5135.26",
                        gradientTransform: "matrix(1 0 0 1.52 6301.53 -7627.42)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: "-6135.24",
                        y1: "5133.66",
                        x2: "-6131.89",
                        y2: "5130.31",
                        gradientTransform: "matrix(1 0 0 1.52 6309.67 -7619.1)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-233",
                        x1: "177.32",
                        y1: "462.13",
                        x2: "177.32",
                        y2: "382.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-234",
                        x1: "303.59",
                        y1: "388.02",
                        x2: "303.59",
                        y2: "380.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-235",
                        x1: "310.94",
                        y1: "133.6",
                        x2: "337.06",
                        y2: "186.14",
                        gradientTransform: "matrix(1 0 0 -1 0 582.59)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        gradientTransform: "matrix(1 0 0 .19 0 315.55)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".11",
                                stopColor: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#e6fcff",
                                stopOpacity: ".73"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".56",
                                stopColor: "#e6fcff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".77",
                                stopColor: "#e6fcff",
                                stopOpacity: ".19"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".92",
                                stopColor: "#e6fcff",
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#e6fcff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-3",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-4",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-5",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-6",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-7",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-8",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-9",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-10",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-12",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-13",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-15",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("style", {
                        children: $608c538d98081b3b$var$styles
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.11 212.89a42.69 42.69 0 00-23.17 17.18 32 32 0 00-19.06 0c-12.17 3.89-17.61 14-18.68 16.07a27.91 27.91 0 00-12.7-.75c-11.75 2.16-15.82 11.61-28.77 19.43a62.31 62.31 0 01-20.93 7.85h199.54c.21-1.14 2-11.54-5.62-19.8-8.13-8.86-19.65-7.25-20.55-7.1-.24-2.07-2.67-20.34-19.14-29.79-13.75-7.89-27.59-4.07-30.92-3.09z",
                                fill: "url(#linear-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M281.14 34.8a52.1 52.1 0 0128.24 21 39 39 0 0123.23 0c14.84 4.75 21.47 17 22.77 19.59a34 34 0 0115.49-.91c14.31 2.63 19.27 14.11 35.07 23.68a75.76 75.76 0 0025.5 9.57H188.21c-.26-1.39-2.41-14.07 6.84-24.14 9.92-10.8 24-8.83 25-8.66.3-2.52 3.26-24.78 23.34-36.3 16.82-9.63 33.68-5.02 37.75-3.83z",
                                fill: "url(#linear-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M118.71 264.49l-2.65-2.66a509.36 509.36 0 0070.25-87.4 509.23 509.23 0 0057.44-125.07l3.6 1.1a513.26 513.26 0 01-57.87 126 513.28 513.28 0 01-70.77 88.03z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z",
                                fill: "url(#linear-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M149.52 159.55a91.75 91.75 0 01-.5-82.63l81.91-.32a91.72 91.72 0 00.17 82.63z",
                                fill: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M152 139.06a217.27 217.27 0 0116.17-19.35 270.57 270.57 0 0021.13 19.19z",
                                fill: "url(#linear-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M165.12 139a226.29 226.29 0 0121.82-25.16 264.7 264.7 0 0026.61 25z",
                                fill: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.27 99.13c-.75 3.6-4 6.57-7.49 6.58a5.26 5.26 0 01-5.28-6.53 8.62 8.62 0 018-6.5c3.5-.02 5.5 2.84 4.77 6.45z",
                                fill: "#ffab00"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z",
                                opacity: ".4",
                                fill: "#79e2f2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.25 358.05z",
                                fill: "url(#linear-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M10.57 363.88a34.13 34.13 0 01-4.19-5.61 34.13 34.13 0 004.19 5.61z",
                                fill: "url(#linear-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.18 403.31c0-.11 0-.21-.05-.32.02.11.03.21.05.32z",
                                fill: "url(#linear-gradient-7)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36l-.39-.3z",
                                fill: "url(#linear-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.44 397l-.22-.43z",
                                fill: "url(#linear-gradient-9)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.24 399l-.06-.19z",
                                fill: "url(#linear-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.83 401.28c0-.17-.07-.33-.1-.5.03.22.07.33.1.5z",
                                fill: "url(#linear-gradient-11)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62z",
                                fill: "url(#linear-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M52.78 387.47l-.54-.15z",
                                fill: "url(#linear-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M56.85 388.76l-.36-.12z",
                                fill: "url(#linear-gradient-14)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M54.69 388l-.45-.13z",
                                fill: "url(#linear-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.44 390.25l-.28-.13z",
                                fill: "url(#linear-gradient-16)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M62.35 391.32l-.38-.23z",
                                fill: "url(#linear-gradient-17)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M58.76 389.5l-.51-.21z",
                                fill: "url(#linear-gradient-18)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M66.5 395.35l-.3-.44z",
                                fill: "url(#linear-gradient-19)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11a20.58 20.58 0 00.13 2.24 20.58 20.58 0 01-.13-2.24z",
                                fill: "url(#linear-gradient-20)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M261.42 301.27a609.78 609.78 0 00-90.77-6.5c-46.73 0-84 4.81-111.68 12.89 51-4.09 112.85-6.49 179.48-6.49q11.55 0 22.97.1z",
                                fill: "url(#linear-gradient-21)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M72.61 389.43c13.52 1.46 23-7.28 24.46-8.66a31.57 31.57 0 0018.2 9.25 28.77 28.77 0 006.33.13L131.82 373c-46.35-1.93-87.72-5.09-121.25-9.13a59.82 59.82 0 0010.28 8.71 120.25 120.25 0 0022.79 12.05 68.6 68.6 0 006.89 2.19 39.55 39.55 0 006.15-4.29 30.07 30.07 0 0015.93 6.9z",
                                fill: "url(#linear-gradient-22)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M155.07 392.74c2.57 1.87 4.48 3.74 4.48 5.61a412.84 412.84 0 01-90.34 11.72 28.54 28.54 0 01-1.91 7.77 16 16 0 00-1.3 6.21c0 26.77 37.45 48.47 124.94 48.47s158.43-21.7 158.43-48.47v-.78c63.6-3.54 113.92-18.7 126.69-38-.21-7.4-5.85-14.4-15.75-20.65-29.28 3.34-64.08 6-102.68 7.86l17.73 29.73L301.4 385l-56.53 77.4-48.33-66.17.86-13.31z",
                                fill: "url(#linear-gradient-23)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.12 355.81q-.33-.71-.6-1.44.27.74.6 1.44z",
                                fill: "url(#linear-gradient-24)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.37 407.61v.37c-.01-.13-.01-.25 0-.37z",
                                fill: "url(#linear-gradient-25)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.24 426.24a32 32 0 004.63-3.2 31.16 31.16 0 003.95-3.93q-1.92-3.23-3.81-6.79c-.87-1.64-1.68-3.25-2.46-4.83-.25.51-.53 1.05-.88 1.63-.56.89-1.11 1.81-1.67 2.75q-1.16 2-2.22 3.85a33.81 33.81 0 011.82 5.95 34.18 34.18 0 01.64 4.57z",
                                fill: "url(#linear-gradient-26)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.67 351.54q-.17-.74-.27-1.5.11.77.27 1.5z",
                                fill: "url(#linear-gradient-27)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.31 344.19c0-.32.08-.63.12-.95-.04.32-.09.63-.12.95z",
                                fill: "url(#linear-gradient-28)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.27 353.68c-.15-.46-.29-.92-.41-1.39.14.47.26.93.41 1.39z",
                                fill: "url(#linear-gradient-29)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-30)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-31)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-32)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-33)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-34)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-35)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-36)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-37)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-38)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-39)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-40)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-41)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-42)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-43)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z",
                                fill: "url(#linear-gradient-44)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-45)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-46)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-48)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-49)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-50)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-51)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.86 352.29c-.07-.25-.14-.5-.19-.75.05.25.12.46.19.75z",
                                fill: "url(#linear-gradient-52)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.52 354.37z",
                                fill: "url(#linear-gradient-53)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.36 356.36l-.24-.55z",
                                fill: "url(#linear-gradient-54)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11z",
                                fill: "url(#linear-gradient-55)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.38 358.27c0-.08-.08-.15-.13-.22s.08.14.13.22z",
                                fill: "url(#linear-gradient-56)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.44 343.18v.06a.64.64 0 000-.07z",
                                fill: "url(#linear-gradient-57)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-58)",
                                opacity: ".9",
                                d: "M10.57 363.88z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.4 350c0-.22-.08-.45-.11-.68.03.27.07.5.11.68z",
                                fill: "url(#linear-gradient-59)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-60)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-61)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-62)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-63)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-64)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-65)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-66)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-67)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-68)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-69)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-70)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-72)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-73)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-74)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-75)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-76)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-77)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-78)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-79)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-80)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-81)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-82)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-83)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-84)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-85)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-86)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z",
                                fill: "url(#linear-gradient-87)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-88)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-89)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-90)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-91)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-92)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-93)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-94)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-95)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-96)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-97)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-98)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-99)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-100)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-101)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-102)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-103)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-104)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-105)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-106)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-107)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-108)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-109)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-110)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-111)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-112)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-113)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-114)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-115)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-116)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-117)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-118)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-119)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-120)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-121)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-122)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-123)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-124)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-125)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-126)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-127)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-128)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-129)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-130)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-131)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-132)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-133)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-134)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-135)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-136)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-137)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-138)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-139)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-140)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-141)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-142)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-143)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-144)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-145)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-146)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-147)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-148)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-149)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-150)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-151)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-152)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-153)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-154)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-155)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-156)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-157)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-158)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-159)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-160)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-161)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-162)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-163)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-164)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-165)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-166)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-167)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-168)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-169)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-170)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-171)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-172)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-173)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-174)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-175)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-176)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-177)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-178)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-179)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-180)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-181)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-182)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-183)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-184)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-185)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-186)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-187)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-188)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-189)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-190)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-191)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-192)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-193)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-194)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-195)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-196)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-197)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-198)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-199)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-200)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-201)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-202)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-203)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-204)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-205)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-206)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-207)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-208)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-209)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-210)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-211)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-212)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-213)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-214)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.73 400.78z",
                                fill: "url(#radial-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.21 410.07z",
                                fill: "url(#radial-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.46c0-.72-.09-1.44-.18-2.15.09.69.15 1.43.18 2.15z",
                                fill: "url(#radial-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.13 403q-.12-.87-.3-1.71.17.83.3 1.71z",
                                fill: "url(#radial-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62v2c.03-.68.03-1.34 0-2z",
                                fill: "url(#radial-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45 13.64 13.64 0 00-1.2-1.45 12.87 12.87 0 00-1.19-1.1z",
                                fill: "url(#radial-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M56.49 388.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M50.53 386.83l1.71.49-1.71-.49z",
                                fill: "url(#radial-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M62 391.09q-.73-.45-1.53-.84.77.39 1.53.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.16 390.12z",
                                fill: "url(#radial-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-230",
                                d: "M58.25 389.29l-1.4-.53z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.18 398.84a15.81 15.81 0 00-.74-1.8 15.81 15.81 0 01.74 1.8z",
                                fill: "url(#radial-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.22 396.61a14.16 14.16 0 00-.72-1.26 14.16 14.16 0 01.72 1.26z",
                                fill: "url(#radial-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M54.24 387.91l-1.46-.44z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.42 392.06z",
                                fill: "url(#radial-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M159.55 398.35c0-1.87-1.91-3.74-4.48-5.61l-40.65 9.44 7.18-12a28.77 28.77 0 01-6.33-.13 31.57 31.57 0 01-18.2-9.25c-1.46 1.38-10.94 10.12-24.46 8.66a30.07 30.07 0 01-15.93-6.89 39.55 39.55 0 01-6.15 4.29l1.71.49.54.15 1.46.44.45.13c.6.19 1.21.39 1.8.6l.36.12 1.4.53.51.21c.48.2.94.4 1.4.62l.28.13q.8.39 1.53.84l.38.23c.37.24.73.49 1.07.74l.39.3a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45l.3.44a14.16 14.16 0 01.72 1.26l.22.43a15.81 15.81 0 01.74 1.8l.06.19c.18.57.35 1.15.49 1.75 0 .17.07.33.1.5q.18.84.3 1.71c0 .11 0 .21.05.32.09.71.15 1.43.18 2.15V408.02c0 .7-.07 1.4-.14 2.09a412.84 412.84 0 0090.33-11.76z",
                                fill: "url(#linear-gradient-215)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-216)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-217)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-218)",
                                d: "M245.54 265.79l-130.45-4.54 130.46 43.41L376 261.25l-130.46 4.54z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M239.61 200.11L154 337.73h91.59V198.21H243a4 4 0 00-3.39 1.9z",
                                fill: "url(#linear-gradient-219)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-240",
                                d: "M205.28 255.28l-3.12 5h43.39v-5h-40.27zM199.08 265.23l-3.11 5h49.58v-5h-46.47zM245.55 275.18h-52.66l-3.12 5h55.78v-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M251.49 200.11a4 4 0 00-3.41-1.9h-2.53v139.52h91.58z",
                                fill: "url(#linear-gradient-220)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M245.55 255.28h20.27v5.01h-20.27zM245.55 265.23h20.27v5.01h-20.27zM245.55 275.18h4.98v5.01h-4.98z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M246.9 226.91a41 41 0 0120.1 4.17 34.66 34.66 0 004.89 1.76l-20.36-32.73a4 4 0 00-3.41-1.9h-2.53V227c.41 0 .85-.06 1.31-.09z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-221)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("ellipse", {
                                cx: "190.18",
                                cy: "308.96",
                                rx: "48.27",
                                ry: "5.8",
                                fill: "url(#linear-gradient-222)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M185.7 301.74a14 14 0 01.43 3.35 14.28 14.28 0 01-.31 3l-1.61.68-.34-.66-.57 1.09a14.39 14.39 0 01-3.08 1.26 8.93 8.93 0 01-2.56.42c-1.39 0-3.44-.35-3.53-1.06-.06-.44.67-.68 2.25-1.89a15.9 15.9 0 002.73-2.66 11.3 11.3 0 001.8-3.36l.3-.87z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M174.84 236.19c0 1.93-.39 5.85-.31 9.29.3 12.41.56 19.91 2 30.32.89 6.27 2.08 15.42 3.16 26.77a8.92 8.92 0 006.88-1c-.18-1.82-.4-4.76-.41-8.4 0-6.72.73-9.48.3-14.85a45.06 45.06 0 00-1.57-8.63q1.4-9.27 2.78-18.54a11.6 11.6 0 007-6.47 11.37 11.37 0 00-2.1-11.53z",
                                fill: "url(#linear-gradient-223)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M196.05 302a13.43 13.43 0 00-.57 3.33 14 14 0 00.19 3l1.57.75.37-.65c.18.37.36.74.53 1.11a14.08 14.08 0 003 1.38 9.27 9.27 0 002.55.53c1.39.07 3.45-.21 3.57-.91.08-.44-.64-.71-2.18-2a16.49 16.49 0 01-2.62-2.77 11.21 11.21 0 01-1.65-3.44l-.27-.88zM192.04 238.74l-.09 4.58-8.74-4.11 8.83-.47zM191.79 237.53l1.88-.45 1.62-.19-1.63 2.37-1.87-1.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M177.85 236.91q1.92 5.47 3.8 11.05 3.84 11.43 7.23 22.54l5.25 32.69 6.81-.95q-1.2-16.9-2.41-33.8c-.2-3.54-1.43-25.55-2-28.67-.1-.56-.25-1.09-.25-1.09a16.4 16.4 0 00-1.92-4.36l-1.25.63z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M201.33 28.18l-16.94.27a13.73 13.73 0 00-13.51 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.82v.09c0 .06.11.06.12 0v-.09a8.28 8.28 0 017.9-6.08 13.71 13.71 0 0013.56-13.94 13.74 13.74 0 00-13.94-13.52zM384.25 141.53l-16.93.26a13.74 13.74 0 00-13.52 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.83v.08a.07.07 0 00.13 0v-.09a8.26 8.26 0 017.9-6.07A13.73 13.73 0 00398.19 155a13.73 13.73 0 00-13.94-13.47z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M228.71 128.46a89.94 89.94 0 00-10.59 37.28l20.12-.08c1.83 0 2.47-1.38 1.5-3.1a91.86 91.86 0 01-11.03-34.1z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-224)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M192.09 291.26l-3.44-1.53a612 612 0 0040.22-125.5A612.62 612.62 0 00241.27 45H245a615.38 615.38 0 01-12.47 120 615.64 615.64 0 01-40.44 126.26z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M342.5 235.7c.15-.74.44-1 1.47-2.24l.88-1c2-2.42 2.53-3.68 3.34-3.68.57 0 .92 1 2 2.06 1.33 1.24 1.26 2 1.14 2.62-.18.85-2.92 4.06-4.43 4.51-.45.13-3 1.24-3.43 1-.93-.5-1.19-2.08-1-3.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M299.43 243.7c.3.22.77.55 1.34.92 1.68 1.08 8.57 2.84 10.74 3.75s12.52 3.33 14.57 3.06a6.65 6.65 0 001.78-.49l16.46-11.48-1.32-4.81c-7 3.08-11.64 5.5-18.65 8.58l-22.71-6.32-2.13 3.22z",
                                fill: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M308.31 220.59c.57-.87 1.3-2.19.83-2.85s-1.42-.18-3.85-.08c-3.5.13-3.88-.47-5.65.09a6.82 6.82 0 00-3.52 2.44c-1.68 2.39-.9 5.38-.66 6.28a10 10 0 004.55 5.8l1.9 1.21 5.37-9.24z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.16 236.73h7.25a13.5 13.5 0 01-.78-8.17l-4.42-.21c-.06.26-.14.63-.27 1.08a3.75 3.75 0 01-.48 1.23 2.58 2.58 0 01-1.94.84c.21 1.74.42 3.49.64 5.23",
                                fill: "#543e36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.9 314.33c0-.14-2.25-.5-2.26-.65-.29-4.21-1-23.6-1.6-28.34-.89-7.08-1.73-13.77-1.27-16.81.12-.84.81-4 1.21-5.72a13.39 13.39 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.58.64.19a14.22 14.22 0 001.59.4c.45.09.82.14 1.09.17h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08 24.5 24.5 0 013.11 7.49c4.6 18.9 5.37 21.45 5.48 21.76v.2c.3 1.71 2.17 11.12 2.46 12.86-2.31 1.89-4.35 1.51-7.73 1.29-1.63-3.1-6.21-12.94-7.84-16.07l-3.58-6.91c0 5.11.16 22.38.13 27.49-3.05 1.27-4.25 4.1-7.41 3.55",
                                fill: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M300.94 274.09a11.32 11.32 0 01-2.37-5 15 15 0 01.41-6.31 14.78 14.78 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.59.64.2c.52.16 1 .3 1.59.41s.82.13 1.09.16h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08c2.66 4.2 3.58 9.74 4.87 14.53q1.46 5.37 2.73 10.79c.21.9 2.63 8.75 1.94 9.31-2.31 1.9-5.73 2.44-9.12 2.22-1.62-3.1-3.25-6.19-4.88-9.32-2-3.78-3.64-7.36-6.79-10.31a57.06 57.06 0 01-6-5.8",
                                fill: "#253858"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M308.31 220.59c.35.8.69 1.59 1 2.39l3.09 1.9c-.25.44-.5.88-.76 1.32l.27 4.75a11.78 11.78 0 01-3 1.6c-.42.14-.6.14-4.32.27-1.59.06-2.39.08-2.75-.36a2.08 2.08 0 01-.13-2c.24-.59.54-.54.82-1.12.43-.9-.11-1.42.17-2.27s.91-.67 1.9-1.71.9-1.95 2-3.35a6.5 6.5 0 011.69-1.45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M311.67 226.2a1.23 1.23 0 01.4.53 1.14 1.14 0 010 .73 4.73 4.73 0 01-1.2.42 4.66 4.66 0 01-.92.09c0 .24.06.57.11 1 .14 1 .22 1.13.31 1.18.33.18 1-.2 1.28-.75a1.45 1.45 0 00.14-.64 2.26 2.26 0 01.7 1.13 2.29 2.29 0 01-.28 1.63 3 3 0 01-2.26 1.29h-.15c-4 .2-4.31.2-4.56.13-2.28-.69-2.12-7.66-2.12-8l2.54-1.52a3.32 3.32 0 00-.32 2.85c.09.21.55 1.39 1.5 1.58s1.5-.89 3.4-1.42a6.35 6.35 0 011.4-.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M343 230.84s1.53 1.69.62 3.1c-.64 1 1.8 1.33 1.8 1.33a2.2 2.2 0 00.24-3.06c-1.29-1.77-2.66-2.34-2.66-1.37"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M372.38 264.49a513.32 513.32 0 01-70.76-88 512.55 512.55 0 01-57.87-126l3.59-1.1a508.92 508.92 0 0057.45 125.07A509.3 509.3 0 00375 261.83z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M348 228.66s-1.78 3.06-1.21 3.71 1.21-.08 1.21-.08-.73 1-.4 1.45 1.12-.32 1.12-.32-.64 1 0 1.37 1.05-.49 1.05-.49-.56 2.1 0 1.86 1.21-1 1.61-2.74-2-5.32-3.38-4.76M330.15 211.75c.29-.72-.1-1.12 0-3.88v-.51c0-1.44-.95-2-3.35-4.71-.59-.66-1.52-1.73-1.9-1.53a.67.67 0 00-.28.37c-.08.26.06.42 0 .53s-.55-.09-.73 0 .18 1.12.62 2.24c.8 2 .82 2.67.69 3.21 0 .13-.24.93-.7 1-.13 0-.3 0-.7-.34a8 8 0 01-1.14-1.27c-.52-.6-1.3-1.16-1.5-1s.13.53.27 1.39a13.9 13.9 0 010 1.62c.08.62.44 1 2.56 2.79a9.87 9.87 0 002.38 1.73 3.49 3.49 0 003.74-1.69"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M325.44 212.82c1.91 6.66 1 18.09 1 18.09s-13.3 3.32-16.49 3.61c0 0-6.81.64-10.54 2.5-.88.44-1.74.95-1.74.95-.47.28-.77.48-.77.48l-.1.06a4.93 4.93 0 00-1.9 5.56c.37 1.21.72 2.47 1.05 3.79a74.38 74.38 0 012.19 16.19 30.77 30.77 0 0021.17-1.62 99.26 99.26 0 01-1.49-11.3c-.18-2.33-.26-4.56-.28-6.67 2.38-.56 9.65-4.62 14.18-7.35a6.26 6.26 0 002.93-6.54c-1.15-6.13-2.93-16.42-4.23-19.47-3.12 1.12-4.98 1.72-4.98 1.72z",
                                fill: "url(#linear-gradient-225)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-226)",
                                d: "M376 261.25l-38.87 76.48-91.58-33.07L376 261.25z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M318.63 280.34l-5 1.67v35.67h5v-37.34zM328.59 277.03l-5.01 1.66v38.99h5.01v-40.65zM338.54 273.72l-5.01 1.66v27h5.01v-28.66z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-227)",
                                d: "M337.13 337.73H153.96l91.59-33.07 91.58 33.07z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-228)",
                                d: "M245.55 304.66l-91.59 33.07-38.87-76.48 130.46 43.41z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M245.55 0a5 5 0 015 5v201.67h-5V0z",
                                fill: "#fafbfc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-242",
                                d: "M245.54 0v206.67h-5V5a5 5 0 015-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M250 101.43a90.13 90.13 0 000 94.19h98.7a90.13 90.13 0 010-94.19z",
                                fill: "url(#linear-gradient-229)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306.75 128.62a6.3 6.3 0 01-5.66-3.1c-.89-1.2-1.45-2-3.23-2s-2.81.78-4.33 2c-1.75 1.38-3.86 3.1-7.17 3.1a6.29 6.29 0 01-5.66-3.1c-.89-1.2-1.45-2-3.24-2s-2.8.78-4.32 2c-1.75 1.38-3.86 3.1-7.18 3.1a6.28 6.28 0 01-5.65-3.1c-.89-1.2-1.45-2-3.23-2 .37-1.27.76-2.52 1.18-3.77 3.31 0 4.46 1.68 5.44 3 .85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3s4.47 1.68 5.45 3c.85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3a5.86 5.86 0 015.45 3c.85 1.19 1.44 2 3.22 2s2.79-.79 4.35-2c1.78-1.37 4.07-3 7.38-3-.42 1.25-.81 2.5-1.17 3.77-1.78 0-2.82.78-4.34 2-1.74 1.38-3.85 3.1-7.17 3.1z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.88 140.51a7.32 7.32 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.7.8-4.05 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.69.8-4 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1-1.22-1.72-2-3.5-2 .19-1.3.41-2.58.66-3.87 3.31 0 4.7 1.73 5.86 3.13 1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.59-1.4 3.64-3.13 7-3.13s4.7 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.6-1.4 3.64-3.13 7-3.13s4.71 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.69-.81 4.08-2c1.6-1.4 3.64-3.13 7-3.13-.24 1.29-.46 2.57-.65 3.87-1.78 0-2.71.8-4.06 2-1.73 1.4-3.61 3.15-6.93 3.15z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.61 152.52c-3.31 0-5.11-1.75-6.5-3.16-1.21-1.23-2-2-3.78-2s-2.58.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.22-1.23-2-2-3.78-2s-2.59.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.21-1.23-2-2-3.77-2 0-1.3.06-2.61.14-3.91 3.31 0 4.93 1.76 6.28 3.17 1.18 1.23 2 2 3.76 2s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.93 1.76 6.29 3.16c1.18 1.24 2 2.05 3.76 2.05s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.94 1.76 6.29 3.16c1.18 1.24 2 2.05 3.77 2.05s2.57-.81 3.8-2.05c1.41-1.41 3.22-3.16 6.54-3.16-.07 1.3-.12 2.61-.13 3.91-1.78 0-2.6.81-3.79 2-1.37 1.45-3.02 3.2-6.34 3.2z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306 164.48c-3.32 0-5.35-1.74-6.92-3.13-1.38-1.23-2.27-2-4.06-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.13c-1.38-1.23-2.27-2-4.05-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.14c-1.38-1.22-2.26-2-4-2-.16-1.29-.29-2.59-.38-3.89 3.31 0 5.16 1.75 6.7 3.16 1.34 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16s5.17 1.75 6.71 3.16c1.34 1.22 2.25 2 4 2s2.46-.81 3.54-2a7.4 7.4 0 016.11-3.16c3.32 0 5.17 1.75 6.71 3.16 1.35 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16.1 1.3.23 2.6.38 3.89-1.78 0-2.48.81-3.51 2-1.18 1.38-2.59 3.12-5.85 3.12z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M297.21 171.16c-1.78 0-2.37.8-3.24 2-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.35-3.06c-1.54-1.19-2.53-2-4.32-2s-2.37.8-3.24 2c-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.34-3.06c-1.55-1.19-2.54-2-4.32-2-.33-1.27-.63-2.54-.91-3.82 3.32 0 5.4 1.72 7.14 3.1 1.5 1.2 2.52 2 4.3 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1c3.31 0 5.4 1.73 7.13 3.1 1.51 1.2 2.53 2 4.31 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M182.26 189.82c-3.63 5.16 4.34 17.38 9.25 16.82 3.35-.38 5.2-6.62 5.37-7.19.51-1.71 1.53-5.17-.43-8.4a8.93 8.93 0 00-5.3-3.83c-3.29-.83-7.22.24-8.89 2.6z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M183 208.52l4.17 1 2.6-10.5-8.24-2.02c-.79.44-4 2.37-4.69 6-.18.92-.55 2.8.6 4.25s3.33 1.91 5.56 1.27z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M185 214.79c-3.72 1.33-6.9 2.27-9.32 2.92a48.24 48.24 0 01-6.84 1.37c-2.58.33-3.87.5-4.44.12-1.92-1.27-.92-5.22.43-16 .35-2.79.6-5.06.75-6.44.08-.62.17-1.24.25-1.86l4.48.28c-.36.73-.73 1.45-1.09 2.17q.09 7.35.17 14.7l11.43-4.33a6.71 6.71 0 011.79.42 5 5 0 012.6 2.17 5.08 5.08 0 01-.21 4.48z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M170.77 211.15l12.4-4.57a5.61 5.61 0 014 3.4 5.46 5.46 0 01-.66 4.76l-14 3.69a7.85 7.85 0 00-1.74-7.28z",
                                fill: "url(#linear-gradient-230)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175 217c.55-2.31 1.68-1.93 3.36-5.75a8.35 8.35 0 011.9-3.26 6.41 6.41 0 012.65-1.45h5.5a4.58 4.58 0 001.57 1.64c1.52.92 2.8.45 4.8.91h.1a6 6 0 012.88 1.68 5.09 5.09 0 011.45 3 15.48 15.48 0 01-1.72 8.3 33.5 33.5 0 00-2.49 10.49c.45 1.24 1 4.27 1.48 5.52a34.78 34.78 0 01-22.07.15c2-9.74 1.61-13.49 1.16-15.16-1.11-4.31-.89-4.72-.57-6.07z",
                                fill: "url(#linear-gradient-231)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.33 208.07a10.5 10.5 0 003.56.61 10.74 10.74 0 004.19-.87 8.4 8.4 0 01-1-2.18 7.87 7.87 0 01-.26-2.87l-6.77.9z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.82 190.38a22.9 22.9 0 00-1.07 2.16 22.06 22.06 0 00-1.08 3c-.11.14-.31.4-.58.71-.83.92-1.62 1.41-1.47 1.7 0 0 .75.45.87.58s-.3 2.64.09 3.7c.79 2.16 7.2 3.64 9.76 1a4.13 4.13 0 001.07-2.3 3.3 3.3 0 00-.32-.18 3.38 3.38 0 00-2.45-.1 4.19 4.19 0 00.05-2.92c-.35-.86-.82-.95-2.89-3.07a6.6 6.6 0 01-1.62-2.1 5.08 5.08 0 01-.36-2.18z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M191 210.05a4.52 4.52 0 004.83-.1 4.18 4.18 0 001.41-3c.12-1.79-.95-2.42-1.07-4.33a6.26 6.26 0 01.73-3.2 19.22 19.22 0 01-3.22-.73 20.07 20.07 0 01-4.09-1.86 5.26 5.26 0 01-.24 2.62c-1 2.6-3.62 2.62-4.52 5a4.53 4.53 0 00.6 4.25c1.11 1.49 3.31 1.99 5.57 1.35z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M200.34 250.5c-.18 1.21-.3 2.37-.43 3.57s-.23 2.66-.47 3.74a1.2 1.2 0 01-.67.84c-.22.1-.05-.37-.18-.24s0 .54-.24.73a.16.16 0 01-.17.07c-.13 0-.19-.43-.31-.42s-.17.38-.26.48-.21.31-.4.31-.11-.31-.32-.31-.2.69-.41.65-.29-.36-.31-.77c-.08-1.29.37-2.64.42-4.14a13.93 13.93 0 00-.26-2.58 7.75 7.75 0 00-.91 1.73 3.64 3.64 0 01-.74 1.27.89.89 0 01-.66.31c-.19 0-.46 0-.45-.14a14.18 14.18 0 01.73-2.6c.51-1.55 1.32-4.23 2.95-4.6s2.28 1.16 3.09 2.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M199.33 214.4c.9 4.85 1.91 8.62 2.45 14.62a80.48 80.48 0 01-1.44 21.89 21 21 0 01-3-.27c.2-6.68.5-13.68-1.15-20.08-1.24-4.83-3.2-9.14-4.74-13.52-.84-2.4-.6-3.89 1-5.53a2.41 2.41 0 011.84-.89c2.56.08 4.42.49 5.04 3.78z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.31 211.52a4.9 4.9 0 011.81-.94 4.37 4.37 0 015.16 3.47l1.82 8.67a8.3 8.3 0 00-3.41.68 9 9 0 00-3.26 1.74c-1-2.44-1.82-4.9-2.8-7.34a6 6 0 01-.45-4.56 4 4 0 011.13-1.72z",
                                fill: "url(#linear-gradient-232)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M156.83 188.77H160a.49.49 0 01.49.49v9.65h-4.14v-9.65a.49.49 0 01.48-.49z",
                                transform: "rotate(91.28 158.41 193.83)",
                                fill: "url(#New_Gradient_Swatch_13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.94 189.54H169a.5.5 0 01.5.5v8.51h-3.08V190a.5.5 0 01.52-.46z",
                                transform: "rotate(91.28 167.981 194.045)",
                                fill: "url(#New_Gradient_Swatch_13-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                transform: "rotate(91.28 176.118 194.226)",
                                fill: "url(#New_Gradient_Swatch_13-3)",
                                d: "M175.15 190.6h1.92v7.27h-1.92z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "178.59",
                                y: "193.96",
                                width: "3.06",
                                height: ".74",
                                rx: ".3",
                                transform: "rotate(91.28 180.12 194.325)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "150.26",
                                y: "193.12",
                                width: "4.96",
                                height: "1.2",
                                rx: ".49",
                                transform: "rotate(91.28 152.736 193.71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M168 194.23h1.47a.73.73 0 00.73-.73V192a1 1 0 00-.21-.52 1 1 0 00-.64-.36l-1.35-.02a.76.76 0 00-.56.24.85.85 0 00-.18.69v1.47a.74.74 0 00.74.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "166.04",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(180 166.77 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "169.9",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(-180 170.63 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M186.39 387.41l.65-2.09-.93.22c.1.62.19 1.24.28 1.87zM197.57 400.68c-.29 4.12-.58 7.54-.79 8.63-.1.55-.25 1.09-.25 1.09l-.14.48.38.12c-.45 1.24-1 4.28-1.48 5.52.14 1.52.35 2.89.59 4.14.22-.71.43-1.42.61-2.14 1.46-5.69 1.4-11.84 1.22-17.83zM344.22 423.89c-6-2.63-10-4.71-16-7.35l-2.05.57c2.65 1.35 6 3.24 8.38 4.69a5.4 5.4 0 012.52 5.62c-.48 2.55-1.08 5.92-1.7 9q4.68-5.9 9.55-11.63v-.06c-.31-.35-.54-.62-.7-.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M200.61 398.16h-.05c-.15-1.06-.26-2.09-.38-3.15s-.23-2.66-.47-3.74a1.2 1.2 0 00-.67-.84c-.22-.1 0 .36-.18.24s0-.55-.24-.73a.14.14 0 00-.17-.07c-.09 0-.14.19-.2.31.18-3 .33-5.72.44-7.56l-1.29.3-10.4 2.4-.65 2.09c-.09-.63-.18-1.25-.28-1.87L175.36 388c-.27 4.63-.41 9.51-.56 15.57-.05 2.44.1 5.11.21 7.15l-.31.09c2.05 9.75 1.61 13.5 1.16 15.17-.84 3.19-.93 4.24-.8 5.11a49.27 49.27 0 00-5.92-1.13c-2.58-.33-3.87-.49-4.44-.12-1.92 1.28-.92 5.23.43 16.05.35 2.79.6 5.06.75 6.43.05.4.11.79.16 1.19h-2.31a.5.5 0 00-.5-.48l-9.65.22a.47.47 0 00-.48-.43h-.23a.5.5 0 00-.48.5l.09 4a.49.49 0 00.5.47h.23a.48.48 0 00.46-.44l9.64-.21a.5.5 0 00.48-.51l2.51-.06v.44a.73.73 0 00.73.73.69.69 0 00.55-.26.9.9 0 00.14.22.81.81 0 00.56.24l1.35-.05a1 1 0 00.64-.36l.05-.09a.7.7 0 00.57.3.73.73 0 00.74-.73v-.56h.65a.52.52 0 00.49-.52v-.07l7.26-.16v.3a.3.3 0 00.3.29h.14a.31.31 0 00.3-.31l-.06-2.46a.29.29 0 00-.3-.29h-.14a.3.3 0 00-.3.31v.27l-7.27.17v1-1a.5.5 0 00-.51-.49h-1.86l-.84-1.68q.09-7.35.17-14.69l1.57.59a2.88 2.88 0 01-.22.27l7.91 2.91a3.91 3.91 0 00-1.24 1c-1.15 1.44-.78 3.32-.6 4.25a8.52 8.52 0 003 4.84l-.25.16c-.15.28.64.78 1.47 1.7.27.3.47.56.58.71-.53 2.19-.45 4.27.59 5.76 1.67 2.36 5.6 3.43 8.89 2.59a8.85 8.85 0 005.3-3.82c2-3.23.94-6.69.43-8.41-.05-.17-.26-.86-.61-1.75a5.53 5.53 0 01-.12-1.44c.12-1.91 1.19-2.55 1.08-4.33a4.5 4.5 0 00-1.1-2.67 6.4 6.4 0 001.63-1.21 5.13 5.13 0 001.44-2.92c0-.09.06-.18.08-.28l1.82-8.67h-.15c.33-1.89.62-3.93.83-6.32a80.51 80.51 0 00-1.38-21.92zm-4.12 20.36c-.18.72-.39 1.43-.61 2.14-.24-1.25-.45-2.62-.59-4.14.45-1.24 1-4.28 1.48-5.52l-.38-.12c.05-.17.11-.34.14-.48s.15-.54.25-1.09c.21-1.09.5-4.51.79-8.63h.14c.18 6 .29 12.15-1.22 17.84z",
                                fill: "url(#linear-gradient-233)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-234)",
                                d: "M301.4 385.02l4.39 1.02"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M327.83 451.92c.16.11.51-.12.63 0s0 .23 0 .45a.61.61 0 00.24.32c.32.17 1.12-.75 1.63-1.31 2.06-2.31 2.85-2.82 2.88-4.05v-.44a18.86 18.86 0 01.07-2.53q6.66-8.68 13.75-17c.64.85 1 1.38 1.39 1.56l.08.14c1 .4 2.55-1.6 2.88-3.17a1.68 1.68 0 000-.91 4.62 4.62 0 00-.76-1.83q9.87-11.32 20.49-21.94l-3.69-.86q-10.01 10.16-19.42 20.93a2 2 0 00-.41-.18c-.29-.09-1.56-.63-2.35-.82l.13-.5-14.14-9.86a5.44 5.44 0 00-1.53-.42c-1-.14-4.17.44-7.13 1.13 0-.3 0-.58.05-.88a85.6 85.6 0 011.28-9.71l-.86-.37a21.52 21.52 0 002.58-6.27c.11-.48.23-.94.34-1.4l.3-1.21-20.47-4.79a41.87 41.87 0 00-.41 8.76c.09.56.46 2.3.78 3.74l-.43.11a63.72 63.72 0 01-1.88 13.92c-.28 1.12-.58 2.21-.91 3.25a4.26 4.26 0 001.64 4.78h.09l.66.41s.73.44 1.5.82a14.06 14.06 0 002.25.86l-.27 2.27-1.49.95a8.58 8.58 0 00-3.91 5c-.21.78-.88 3.35.56 5.4a5.72 5.72 0 003 2.09c1.52.49 1.85 0 4.85.09 2.09.08 2.95.43 3.31-.07s-.22-1.71-.71-2.45c.29-.69.59-1.37.88-2.06l2.66-1.63c-.22-.38-.44-.76-.65-1.14a1.06 1.06 0 00.34-.45 1 1 0 000-.63l-.29-.13v-1a1.82 1.82 0 00.6-1 1.9 1.9 0 00-.24-1.4 2.56 2.56 0 00-1.94-1.11h-.13l-1.22-.06a12.75 12.75 0 01.27-1.55l1.08.12c2.74.26 14.17 3.11 14.17 3.11s.75 9.78-.88 15.51l-1.22 1c-1.82 1.5-2.13 1.86-2.2 2.4a9.91 9.91 0 010 1.39c-.12.73-.36 1.1-.23 1.2s.62-.21 1-.62q-5.31 7.17-10.32 14.54 3-1.26 5.7-2.58 2.89-4.12 5.86-8.2a.26.26 0 00.17.28zm-1.62-34.81l2.05-.57c6 2.64 10 4.72 16 7.35.16.22.39.49.72.87v.06q-4.87 5.73-9.55 11.63c.62-3.11 1.22-6.48 1.7-9a5.4 5.4 0 00-2.52-5.62c-2.43-1.48-5.75-3.37-8.4-4.72z",
                                fill: "url(#linear-gradient-235)"
                            })
                        ]
                    })
                })
            })
        ]
    });

});


parcelRegister("lzAG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2be71cde816260d0$export$2e2bcd8739ae039);

var $gVn2t = parcelRequire("gVn2t");
var $gF2uJ = parcelRequire("gF2uJ");
var $jIu2u = parcelRequire("jIu2u");
var $hOHHh = parcelRequire("hOHHh");
var $kbWAD = parcelRequire("kbWAD");
var $8VV1g = parcelRequire("8VV1g");
var $3RELU = parcelRequire("3RELU");
var $2GLVw = parcelRequire("2GLVw");
var $cyCkO = parcelRequire("cyCkO");
var $2kuK5 = parcelRequire("2kuK5");
var $ec4Zm = parcelRequire("ec4Zm");
var $adxPR = parcelRequire("adxPR");
var $7iSe8 = parcelRequire("7iSe8");
var $aRmqS = parcelRequire("aRmqS");
var $bSlng = parcelRequire("bSlng");
var $kZZGF = parcelRequire("kZZGF");
var $cZnHy = parcelRequire("cZnHy");
var $hmXBb = parcelRequire("hmXBb");
var $d39bX = parcelRequire("d39bX");
var $7em2L = parcelRequire("7em2L");
var $fbSjx = parcelRequire("fbSjx");
var $fazBu = parcelRequire("fazBu");
var $4lHnX = parcelRequire("4lHnX");
var $j9BMn = parcelRequire("j9BMn");
var $9CxAQ = parcelRequire("9CxAQ");
const $2be71cde816260d0$var$localeToTranslations = {
    'cs-CZ': $gVn2t.default,
    'da-DK': $gF2uJ.default,
    'de-DE': $jIu2u.default,
    'en-US': $hOHHh.default,
    'en-GB': $kbWAD.default,
    'en-ZZ': $8VV1g.default,
    'es-ES': $3RELU.default,
    'fi-FI': $2GLVw.default,
    'fr-FR': $cyCkO.default,
    'hu-HU': $2kuK5.default,
    'it-IT': $ec4Zm.default,
    'ja-JP': $adxPR.default,
    'ko-KR': $7iSe8.default,
    'no-NO': $aRmqS.default,
    'nl-NL': $bSlng.default,
    'pl-PL': $kZZGF.default,
    'pt-BR': $cZnHy.default,
    'ru-RU': $hmXBb.default,
    'sv-SE': $d39bX.default,
    'tr-TR': $fbSjx.default,
    'th-TH': $7em2L.default,
    'uk-UA': $fazBu.default,
    'vi-VN': $4lHnX.default,
    'zh-TW': $9CxAQ.default,
    'zh-CN': $j9BMn.default
};
const $2be71cde816260d0$var$fetchTranslations = async (locale)=>$2be71cde816260d0$var$localeToTranslations[locale] ?? $hOHHh.default;
var $2be71cde816260d0$export$2e2bcd8739ae039 = $2be71cde816260d0$var$fetchTranslations;

});
parcelRegister("gVn2t", function(module, exports) {
$parcel$export(module.exports, "default", () => $de84e86711535e87$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $86zeU = parcelRequire("86zeU");
var $de84e86711535e87$export$2e2bcd8739ae039 = (0, $86zeU.default);

});
parcelRegister("86zeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8813ea85494e9a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $f8813ea85494e9a0$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};

});


parcelRegister("gF2uJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4151db95aa266f6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iCo1l = parcelRequire("iCo1l");
var $d4151db95aa266f6$export$2e2bcd8739ae039 = (0, $iCo1l.default);

});
parcelRegister("iCo1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $e04985d3e12bc10d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $e04985d3e12bc10d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};

});


parcelRegister("jIu2u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae8fd2519722df33$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OKt1m = parcelRequire("OKt1m");
var $ae8fd2519722df33$export$2e2bcd8739ae039 = (0, $OKt1m.default);

});
parcelRegister("OKt1m", function(module, exports) {
$parcel$export(module.exports, "default", () => $4268ac55a57b7b64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $4268ac55a57b7b64$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};

});


parcelRegister("hOHHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aac9ab42f58e18$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fa9oE = parcelRequire("fa9oE");
var $35aac9ab42f58e18$export$2e2bcd8739ae039 = (0, $fa9oE.default);

});
parcelRegister("fa9oE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e00759fdb5dd3dbf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e00759fdb5dd3dbf$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("kbWAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2722a1e3e6a2d193$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4SI1O = parcelRequire("4SI1O");
var $2722a1e3e6a2d193$export$2e2bcd8739ae039 = (0, $4SI1O.default);

});
parcelRegister("4SI1O", function(module, exports) {
$parcel$export(module.exports, "default", () => $9591cf622278f558$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9591cf622278f558$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("8VV1g", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fde875848e0e1d3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iUxRF = parcelRequire("iUxRF");
var $5fde875848e0e1d3$export$2e2bcd8739ae039 = (0, $iUxRF.default);

});
parcelRegister("iUxRF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2695162625fbad9d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2695162625fbad9d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};

});


parcelRegister("3RELU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd33c96d2c6a3b38$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OyaMN = parcelRequire("OyaMN");
var $bd33c96d2c6a3b38$export$2e2bcd8739ae039 = (0, $OyaMN.default);

});
parcelRegister("OyaMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8002adc7390303d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $d8002adc7390303d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};

});


parcelRegister("2GLVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $79757001bdda6d20$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $k8GmK = parcelRequire("k8GmK");
var $79757001bdda6d20$export$2e2bcd8739ae039 = (0, $k8GmK.default);

});
parcelRegister("k8GmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf006fcc6db4a0c7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $bf006fcc6db4a0c7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};

});


parcelRegister("cyCkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1b75c40aca6111$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $97WrX = parcelRequire("97WrX");
var $6d1b75c40aca6111$export$2e2bcd8739ae039 = (0, $97WrX.default);

});
parcelRegister("97WrX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3ccc23c0718289$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ad3ccc23c0718289$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};

});


parcelRegister("2kuK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b0a53f3901ee842$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1uArQ = parcelRequire("1uArQ");
var $5b0a53f3901ee842$export$2e2bcd8739ae039 = (0, $1uArQ.default);

});
parcelRegister("1uArQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e95b01e8c12f0776$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $e95b01e8c12f0776$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};

});


parcelRegister("ec4Zm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5d40f2dbcf6c2db$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7MLET = parcelRequire("7MLET");
var $e5d40f2dbcf6c2db$export$2e2bcd8739ae039 = (0, $7MLET.default);

});
parcelRegister("7MLET", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a304e9615ca1cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $08a304e9615ca1cb$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};

});


parcelRegister("adxPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $090a54f256654417$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fRbOB = parcelRequire("fRbOB");
var $090a54f256654417$export$2e2bcd8739ae039 = (0, $fRbOB.default);

});
parcelRegister("fRbOB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e13736617ad05247$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e13736617ad05247$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};

});


parcelRegister("7iSe8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3175ea772765cd21$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bZXf1 = parcelRequire("bZXf1");
var $3175ea772765cd21$export$2e2bcd8739ae039 = (0, $bZXf1.default);

});
parcelRegister("bZXf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef766d79add86b1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $1ef766d79add86b1$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};

});


parcelRegister("aRmqS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7176f6091fac65c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6njdR = parcelRequire("6njdR");
var $b7176f6091fac65c$export$2e2bcd8739ae039 = (0, $6njdR.default);

});
parcelRegister("6njdR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebcf052d0bd9e2ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $ebcf052d0bd9e2ed$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};

});


parcelRegister("bSlng", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c106f196b16ae8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3lN6l = parcelRequire("3lN6l");
var $c1c106f196b16ae8$export$2e2bcd8739ae039 = (0, $3lN6l.default);

});
parcelRegister("3lN6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $758a1d2aec1019fe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $758a1d2aec1019fe$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};

});


parcelRegister("kZZGF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7970253c953659f7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3eKOc = parcelRequire("3eKOc");
var $7970253c953659f7$export$2e2bcd8739ae039 = (0, $3eKOc.default);

});
parcelRegister("3eKOc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4da433e029a4a52$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $c4da433e029a4a52$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};

});


parcelRegister("cZnHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cd3d203e236cba1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $Z01Pj = parcelRequire("Z01Pj");
var $1cd3d203e236cba1$export$2e2bcd8739ae039 = (0, $Z01Pj.default);

});
parcelRegister("Z01Pj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98b0e2c7a5a4e37$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $f98b0e2c7a5a4e37$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};

});


parcelRegister("hmXBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4515fc80428e0f3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5ak3O = parcelRequire("5ak3O");
var $e4515fc80428e0f3$export$2e2bcd8739ae039 = (0, $5ak3O.default);

});
parcelRegister("5ak3O", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d90428c652fb203$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $4d90428c652fb203$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("d39bX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3deeb5c49f5203b2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eiLYJ = parcelRequire("eiLYJ");
var $3deeb5c49f5203b2$export$2e2bcd8739ae039 = (0, $eiLYJ.default);

});
parcelRegister("eiLYJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d587b136dfe8dd7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $4d587b136dfe8dd7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};

});


parcelRegister("7em2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $27e7b432d02653a9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aT0sX = parcelRequire("aT0sX");
var $27e7b432d02653a9$export$2e2bcd8739ae039 = (0, $aT0sX.default);

});
parcelRegister("aT0sX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b61e557bbfdc46d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $9b61e557bbfdc46d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};

});


parcelRegister("fbSjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a67694ba155303$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fx6jl = parcelRequire("fx6jl");
var $01a67694ba155303$export$2e2bcd8739ae039 = (0, $fx6jl.default);

});
parcelRegister("fx6jl", function(module, exports) {
$parcel$export(module.exports, "default", () => $695eab6677f02e30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $695eab6677f02e30$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};

});


parcelRegister("fazBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1029988d2fbab422$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ll0mb = parcelRequire("ll0mb");
var $1029988d2fbab422$export$2e2bcd8739ae039 = (0, $ll0mb.default);

});
parcelRegister("ll0mb", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca0ed95888e2625$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $bca0ed95888e2625$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("4lHnX", function(module, exports) {
$parcel$export(module.exports, "default", () => $276bc4890ca504b9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $b6xoa = parcelRequire("b6xoa");
var $276bc4890ca504b9$export$2e2bcd8739ae039 = (0, $b6xoa.default);

});
parcelRegister("b6xoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d3e0f1c67bfee9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $d6d3e0f1c67bfee9$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};

});


parcelRegister("j9BMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ad23d78b1003b5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $d1LQj = parcelRequire("d1LQj");
var $c4ad23d78b1003b5$export$2e2bcd8739ae039 = (0, $d1LQj.default);

});
parcelRegister("d1LQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $de006bcaad3f1476$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $de006bcaad3f1476$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};

});


parcelRegister("9CxAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $55cf7277abe54f0f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8sNnA = parcelRequire("8sNnA");
var $55cf7277abe54f0f$export$2e2bcd8739ae039 = (0, $8sNnA.default);

});
parcelRegister("8sNnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $986beac2870673da$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $986beac2870673da$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};

});




parcelRegister("4eSmy", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $0e0b16901c3f6e75$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $hEWmq = parcelRequire("hEWmq");
const $0e0b16901c3f6e75$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hEWmq.ViewPage), {
            ...props
        })
    });

});
parcelRegister("hEWmq", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $84f48369079b110f$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $35jyw = parcelRequire("35jyw");

var $lRq8t = parcelRequire("lRq8t");
const $84f48369079b110f$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $35jyw.ViewPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("35jyw", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $a8eed96c071859b9$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $dqJsX = parcelRequire("dqJsX");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");
const $a8eed96c071859b9$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8edRS.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dqJsX.ViewPage), {
                    ...props
                })
            })
        })
    });
};

});
parcelRegister("dqJsX", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $c7ae8fd93015352f$export$767e3006bdbb424a);
/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");
var $27wdK = parcelRequire("27wdK");

var $jWzbc = parcelRequire("jWzbc");

var $lCbi5 = parcelRequire("lCbi5");

var $8edRS = parcelRequire("8edRS");
const $c7ae8fd93015352f$var$embeddedPageContainerSytles = null;
const $c7ae8fd93015352f$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: children
    });
};
const $c7ae8fd93015352f$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { height: height } = (0, $27wdK.useContentSize)(uniqueKey);
    (0, $lCbi5.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>({
            experiences: {
                experience: (0, $j2zMY.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $j2zMY.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c7ae8fd93015352f$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%',
                    children: children
                }),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jWzbc.Content), {
        ...props,
        contentType: (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};

});
parcelRegister("27wdK", function(module, exports) {
$parcel$export(module.exports, "useContentSize", () => $135b10d553c176e1$export$7e7123f55b1139c9);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8qtes = parcelRequire("8qtes");

var $fSqCk = parcelRequire("fSqCk");
const $135b10d553c176e1$var$MESSAGE_TYPE = 'contentSize';
const $135b10d553c176e1$export$7e7123f55b1139c9 = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $eJOHy.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/ const { isMediaOpen: isMediaOpen } = (0, $8qtes.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $fSqCk.useIframeVisibleHeight)(uniqueKey);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $135b10d553c176e1$var$MESSAGE_TYPE && data?.height && (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};

});
parcelRegister("8qtes", function(module, exports) {
$parcel$export(module.exports, "useMediaViewerListener", () => $77826dd02e2a6e26$export$6d8905296959d5f5);

var $eJOHy = parcelRequire("eJOHy");
const $77826dd02e2a6e26$export$6d8905296959d5f5 = ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $eJOHy.useState)(false);
    const mediaMessageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};

});

parcelRegister("fSqCk", function(module, exports) {
$parcel$export(module.exports, "useIframeVisibleHeight", () => $fd2a92adc4bbbe65$export$4b9c38587bbe6e8b);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $fd2a92adc4bbbe65$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $fd2a92adc4bbbe65$export$4b9c38587bbe6e8b = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $eJOHy.useState)(1000);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $fd2a92adc4bbbe65$var$MESSAGE_TYPE && data?.value && (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        visibleHeight: visibleHeight
    };
};

});


parcelRegister("jWzbc", function(module, exports) {
$parcel$export(module.exports, "Content", () => $dc9eb7549e787e58$export$7c6e2c02157bb7d2);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5XSQP = parcelRequire("5XSQP");
var $40f0Z = parcelRequire("40f0Z");

var $52WL7 = parcelRequire("52WL7");
var $7LOUI = parcelRequire("7LOUI");

var $kUYZz = parcelRequire("kUYZz");

var $fuXvj = parcelRequire("fuXvj");
var $73Fae = parcelRequire("73Fae");
var $27wdK = parcelRequire("27wdK");
var $jgJaV = parcelRequire("jgJaV");
var $bbc8b = parcelRequire("bbc8b");

var $8edRS = parcelRequire("8edRS");

var $7oRxl = parcelRequire("7oRxl");

var $3ca9m = parcelRequire("3ca9m");

var $lRq8t = parcelRequire("lRq8t");

var $bF4mB = parcelRequire("bF4mB");
const $dc9eb7549e787e58$var$IframeWrapper = ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: wrapper?.(children) ?? children
    });
// helper to merge iframe refs
function $dc9eb7549e787e58$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $dc9eb7549e787e58$export$7c6e2c02157bb7d2 = (props)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, embeddedConfluenceSource: embeddedConfluenceSource, ...passThroughProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const experienceTracker = (0, $52WL7.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $7LOUI.useSetUpExperience)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $bbc8b.useUrl)(props);
    /**
	 * The difference between hasFooter and hasFooterLogo can be found here
	 * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
	 *
	 * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
	 */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $jgJaV.useFooter)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $27wdK.useContentSize)(uniqueKey);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5XSQP.Experience), {
            name: experience,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $73Fae.PageLoadValidation), {
                ...props,
                children: ({ iframeRef: iframeRef, iframeLoaded: iframeLoaded, isLoading: isLoading, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)($dc9eb7549e787e58$var$IframeWrapper, {
                                wrapper: contentConfiguration.getWrapperElement,
                                children: embeddedConfluenceUrl ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bF4mB.IframeLoadingScreen), {
                                    iframeLoaded: iframeLoaded,
                                    isLoading: isLoading,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kUYZz.Iframe), {
                                        ref: $dc9eb7549e787e58$var$mergeIframeRefs(iframeRef, externalIframeRef),
                                        // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
                                        src: redirectedToLogin ? '' : embeddedConfluenceUrl,
                                        ...passThroughProps,
                                        navigationPolicy: navigationPolicy,
                                        style: {
                                            flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
                                        },
                                        uniqueKey: uniqueKey,
                                        onLoad: (e)=>{
                                            handleIframeOnLoad();
                                            onLoad?.(e);
                                        },
                                        onUnload: handleIframeUnload,
                                        onContentLoadStarted: handleContentLoadStarted
                                    })
                                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {
                                    embeddedConfluenceSource: embeddedConfluenceSource
                                })
                            }),
                            showFooter && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fuXvj.Footer), {
                                url: footerUrl,
                                linkTooltip: formatMessage((0, $3ca9m.default).viewInConfluence),
                                label: formatMessage((0, $3ca9m.default).poweredBy)
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("5XSQP", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $34f6e829880f545b$export$c90b54e658fc4d7c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $boRG7 = parcelRequire("boRG7");
function $34f6e829880f545b$export$c90b54e658fc4d7c({ children: children, name: name }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $boRG7.ExperienceContext).Provider, {
        value: name,
        children: children
    });
}

});
parcelRegister("boRG7", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $1a24cfa7a9df9c2e$export$fb99266658f5da06);

var $eJOHy = parcelRequire("eJOHy");
const $1a24cfa7a9df9c2e$var$defaultExperienceContextValue = undefined;
const $1a24cfa7a9df9c2e$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($1a24cfa7a9df9c2e$var$defaultExperienceContextValue);

});


parcelRegister("7LOUI", function(module, exports) {
$parcel$export(module.exports, "useSetUpExperience", () => $249484d1e0a88b58$export$48d5d434479c259e);

var $eJOHy = parcelRequire("eJOHy");

var $bq2fr = parcelRequire("bq2fr");
const $249484d1e0a88b58$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $eJOHy.useRef)();
    const ccExperienceStartedRef = (0, $eJOHy.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
	 * Start experience as close to the user action as possible.
	 * Our approximation is component's first render.
	 *
	 * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
	 * We need to re-start experience if `contentId` or `spaceKey` has changed.
	 * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
	 */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
				 * We have experience forwarding from confluence-frontend
				 * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
				 */ experience.stopOn(events.find((event)=>(0, $bq2fr.isStop)(event) && event.name === ccExperience && event.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            /**
			 * User can navigates away (EP component unmount) before CC experience started
			 * In this case, we want to abort EP experience as the conclusion.
			 */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};

});
parcelRegister("bq2fr", function(module, exports) {
$parcel$export(module.exports, "isStop", () => $9cb259e8198ec504$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $9cb259e8198ec504$export$57069f5b2ecc9128);
const $9cb259e8198ec504$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $9cb259e8198ec504$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});


parcelRegister("kUYZz", function(module, exports) {
$parcel$export(module.exports, "Iframe", () => $addf700416df7c9f$export$5137ec99f248330b);
/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eaiF1 = parcelRequire("eaiF1");

var $huqaB = parcelRequire("huqaB");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");

var $eGOwo = parcelRequire("eGOwo");
const $addf700416df7c9f$var$iframeStyles = null;
const $addf700416df7c9f$export$5137ec99f248330b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $eJOHy.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    (0, $eJOHy.useEffect)(()=>{
        const handler = (e)=>{
            // only fire onUnload handler if uniqueKey (if it exists) matches
            const uniqueKeyMatch = !uniqueKey || !e.data?.uniqueKey || e.data.uniqueKey === uniqueKey || !(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed');
            if (e.data.type === 'windowUnload' && uniqueKeyMatch) onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload,
        uniqueKey
    ]);
    (0, $huqaB.useHostOffsetOverride)();
    const channel = (0, $eaiF1.useIframeCommunicationChannel)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    });
    // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        // Grant features to iframe (Currently the same as smart card iframe's granted features)
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...passThroughProps,
        className: (0, $hcewu.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    });
});

});
parcelRegister("eaiF1", function(module, exports) {
$parcel$export(module.exports, "useIframeCommunicationChannel", () => $cd35ea78faffb064$export$c745b3af35ea8585);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $8FR7r = parcelRequire("8FR7r");

var $eGOwo = parcelRequire("eGOwo");

var $8edRS = parcelRequire("8edRS");
let $cd35ea78faffb064$var$host = null;


// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // unable to evaluate fg('platform_deprecate_lp_cc_embed') at the module level and using uniqueKey query param (which is feature gated) instead
    let hasUniqueKey = false;
    if (typeof window !== 'undefined') try {
        hasUniqueKey = new URL(window.location.href).searchParams.has('uniqueKey');
    } catch (e) {
        hasUniqueKey = false;
    }
    $cd35ea78faffb064$var$host = hasUniqueKey ? (parcelRequire("1oIvu")) : (parcelRequire("818E2"));
}
function $cd35ea78faffb064$var$defineModule(name, module) {
    $cd35ea78faffb064$var$host.defineModule(name, module);
}
const $cd35ea78faffb064$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $eJOHy.useRef)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $cd35ea78faffb064$var$defineModule(uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `${0, $8FR7r.EXPERIENCE_FORWARDING_MODULE_NAME}_${uniqueKey}` : (0, $8FR7r.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $cd35ea78faffb064$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $eJOHy.useCallback)(()=>{
        $cd35ea78faffb064$var$host.dispatch((0, $8FR7r.PROPS_UPDATED), {
            addon_key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME) : (0, $8FR7r.CHANNEL_NAME),
            ...(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') && {
                key: passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME)
            }
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
		 * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
		 * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
		 **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps),
        passThroughProps.uniqueKey
    ]);
    const dispatchPropsUpdatedRef = (0, $eJOHy.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $cd35ea78faffb064$var$defineModule(passThroughProps.uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `${0, $8FR7r.PASSTHROUGH_PROPS_MODULE_NAME}_${passThroughProps.uniqueKey}` : (0, $8FR7r.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $eJOHy.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $cd35ea78faffb064$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $eJOHy.useRef)();
    const uniqueKey = passThroughProps.uniqueKey ?? (0, $8FR7r.CHANNEL_NAME);
    $cd35ea78faffb064$var$useExperienceForwardingModule();
    $cd35ea78faffb064$var$usePassThroughPropsModule(passThroughProps);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $cd35ea78faffb064$var$host.create({
        addon_key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $8FR7r.CHANNEL_NAME),
        key: (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $8FR7r.CHANNEL_NAME),
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}

});
parcelRegister("8FR7r", function(module, exports) {
$parcel$export(module.exports, "CHANNEL_NAME", () => $0b197a18be2c51cd$export$ab9998995666ebe3);
$parcel$export(module.exports, "createUniqueKey", () => $0b197a18be2c51cd$export$f2fe03976fe13de);
$parcel$export(module.exports, "PASSTHROUGH_PROPS_MODULE_NAME", () => $0b197a18be2c51cd$export$45b0adb7f9689286);
$parcel$export(module.exports, "PROPS_UPDATED", () => $0b197a18be2c51cd$export$78cada8c8749e264);
$parcel$export(module.exports, "EXPERIENCE_FORWARDING_MODULE_NAME", () => $0b197a18be2c51cd$export$b75934a6b56fd9ba);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");
const $0b197a18be2c51cd$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $0b197a18be2c51cd$export$f2fe03976fe13de = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return `${$0b197a18be2c51cd$export$ab9998995666ebe3}-${(0, $aXKmr.v4)()}`;
};
const $0b197a18be2c51cd$export$45b0adb7f9689286 = 'passThroughProps';
const $0b197a18be2c51cd$export$78cada8c8749e264 = 'propsUpdated';
const $0b197a18be2c51cd$export$b75934a6b56fd9ba = 'experienceForwarding';

});

parcelRegister("8edRS", function(module, exports) {
$parcel$export(module.exports, "UniqueKeyProvider", () => $ac62a64a0b58e7a2$export$71829d27b87a2006);
$parcel$export(module.exports, "useUniqueKey", () => $ac62a64a0b58e7a2$export$cef64a0cfb90e369);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8FR7r = parcelRequire("8FR7r");
const $ac62a64a0b58e7a2$var$UniqueKeyContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    uniqueKey: undefined
});
const $ac62a64a0b58e7a2$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $eJOHy.useMemo)(()=>(0, $8FR7r.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ac62a64a0b58e7a2$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $ac62a64a0b58e7a2$export$cef64a0cfb90e369 = ()=>{
    return (0, $eJOHy.useContext)($ac62a64a0b58e7a2$var$UniqueKeyContext);
};

});

parcelRegister("1oIvu", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _util = _interopRequireDefault(_dereq_("./util"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PostMessage = /*#__PURE__*/ function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                var _default = PostMessage;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if (_typeof(source) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn("".concat(t.name, " object was detected and removed from the message."));
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && _typeof(value) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                         // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname; //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                var _default = util;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _xdmrpc = _interopRequireDefault(_dereq_("./xdmrpc"));
                var _util = _interopRequireDefault(_dereq_("../common/util"));
                var _featureFlag = _dereq_("./feature-flag");
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var Connect = /*#__PURE__*/ function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: "dispatch",
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: "broadcast",
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: "_createId",
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util.default.randomString();
                            }
                        },
                        {
                            key: "create",
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                options.platformFeatureFlags = (0, _featureFlag.getPlatformFeatureFlags)();
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            } // This is called from ACJS
                        },
                        {
                            key: "registerRequestNotifier",
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: "registerExtension",
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: "registerKeyListener",
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: "unregisterKeyListener",
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: "registerClickHandler",
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: "unregisterClickHandler",
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: "defineModule",
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: "isModuleDefined",
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: "defineGlobals",
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: "getExtensions",
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: "unregisterExtension",
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: "returnsPromise",
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: "setFeatureFlagGetter",
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: "registerExistingExtension",
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                var _default = Connect;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "../common/util": 2,
                "./feature-flag": 4,
                "./xdmrpc": 6
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getPlatformFeatureFlags = getPlatformFeatureFlags;
                var allowedPlatformFeatureFlags = [
                    'platform-visual-refresh-icons'
                ];
                function getPlatformFeatureFlags() {
                    var flags = {};
                    if (window.connectHost && window.connectHost.getBooleanFeatureFlag) allowedPlatformFeatureFlags.forEach(function(key) {
                        return flags[key] = window.connectHost.getBooleanFeatureFlag(key);
                    });
                    return flags;
                }
            },
            {}
        ],
        5: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _connect = _interopRequireDefault(_dereq_("./connect"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var _default = new _connect.default();
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "./connect": 3
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _util = _interopRequireDefault(_dereq_("../common/util"));
                var _postmessage = _interopRequireDefault(_dereq_("../common/postmessage"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _construct(Parent, args, Class) {
                    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
                    else _construct = function _construct(Parent, args, Class) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor();
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                    return _construct.apply(null, arguments);
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = /*#__PURE__*/ function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    var _super = _createSuper(XDMRPC);
                    function XDMRPC(config) {
                        var _this;
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        _this = _super.call(this, config);
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandlers = [];
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: "_padUndefinedArguments",
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        },
                        {
                            key: "_verifyAPI",
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                                else console.warn("_verifyAPI postMessage skipped as event source missing.");
                            }
                        },
                        {
                            key: "_handleInit",
                            value: function _handleInit(event, reg) {
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                else console.warn("_handleInit postMessage skipped as event source missing.");
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: "_getHostOffset",
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0; // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                                else console.warn("_getHostOffset postMessage skipped as event source missing.");
                            }
                        },
                        {
                            key: "_hasSameOrigin",
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {}
                                return false;
                            }
                        },
                        {
                            key: "_handleResponse",
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: "registerRequestNotifier",
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: "_handleRequest",
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util.default.sanitizeStructuredClone(_util.default.argumentsToArray(arguments));
                                    if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                    else console.warn("_handleRequest postMessage skipped as event source missing.");
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = _construct(Cls.constructor, args);
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!(_typeof(promiseResult) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            args: methodArgs,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "_handleBroadcast",
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: "_handleKeyTriggered",
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: "defineAPIModule",
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: "isAPIModuleDefined",
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: "_pendingEventKey",
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = "".concat(key, "@@").concat(targetSpec.key);
                                key = "".concat(key, "@@").concat(time);
                                return key;
                            }
                        },
                        {
                            key: "queueEvent",
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: "_cleanupInvalidEvents",
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: "_handleEventQuery",
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: "_handleUnload",
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: "dispatch",
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: "_findRegistrations",
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: "registerExtension",
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: "_keycodeKey",
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: "registerKeyListener",
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: "unregisterKeyListener",
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: "registerClickHandler",
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                this._clickHandlers.push(callback);
                            }
                        },
                        {
                            key: "_handleAddonClick",
                            value: function _handleAddonClick(event, reg) {
                                for(var i = 0; i < this._clickHandlers.length; i++)if (typeof this._clickHandlers[i] === 'function') this._clickHandlers[i]({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: "unregisterClickHandler",
                            value: function unregisterClickHandler() {
                                this._clickHandlers = [];
                            }
                        },
                        {
                            key: "getApiSpec",
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(_typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: "_originEqual",
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util.default.getOrigin(url); // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            } // validate origin of postMessage
                        },
                        {
                            key: "_checkOrigin",
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && no_source_types.includes(event.data.type);
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches); // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                 // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: "getRegisteredExtensions",
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: "unregisterExtension",
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: "setFeatureFlagGetter",
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage.default);
                var _default = XDMRPC;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        5
    ])(5);
});

});

parcelRegister("818E2", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_("./util");
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var PostMessage = function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util2.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg = void 0;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                exports.default = PostMessage;
                module1.exports = exports["default"];
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if ((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn(t.name + " object was detected and removed from the message.");
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue = void 0;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                        // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                        //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                exports.default = util;
                module1.exports = exports["default"];
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _xdmrpc = _dereq_('./xdmrpc');
                var _xdmrpc2 = _interopRequireDefault(_xdmrpc);
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Connect = function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc2.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: 'broadcast',
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: '_createId',
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util2.default.randomString();
                            }
                        },
                        {
                            key: 'create',
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util2.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: 'defineModule',
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: 'isModuleDefined',
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: 'defineGlobals',
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: 'getExtensions',
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: 'returnsPromise',
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: 'registerExistingExtension',
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                exports.default = Connect;
                module1.exports = exports['default'];
            },
            {
                "../common/util": 2,
                "./xdmrpc": 5
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _connect = _dereq_('./connect');
                var _connect2 = _interopRequireDefault(_connect);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                exports.default = new _connect2.default();
                module1.exports = exports['default'];
            },
            {
                "./connect": 3
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                var _postmessage = _dereq_('../common/postmessage');
                var _postmessage2 = _interopRequireDefault(_postmessage);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self, call) {
                    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                } /**
  * Postmessage format:
  *
  * Initialization
  * --------------
  * {
  *   type: 'init',
  *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
  * }
  *
  * Request
  * -------
  * {
  *   type: 'req',
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, required for callbacks
  *   mod: 'cookie',  // the module name
  *   fn: 'read',  // the method name
  *   args: [arguments]  // the method arguments
  * }
  *
  * Response
  * --------
  * {
  *   type: 'resp'
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, obtained from the request
  *   args: [arguments]  // the callback arguments
  * }
  *
  * Event
  * -----
  * {
  *   type: 'evt',
  *   etyp: 'some-event',
  *   evnt: { ... }  // the event data
  *   mid: 'xyz', // a unique message identifier for the event
  * }
  **/ 
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    _createClass(XDMRPC, [
                        {
                            key: '_padUndefinedArguments',
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        }
                    ]);
                    function XDMRPC(config) {
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        var _this = _possibleConstructorReturn(this, (XDMRPC.__proto__ || Object.getPrototypeOf(XDMRPC)).call(this, config));
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandler = null;
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload,
                            sub: _this._handleSubInit
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: '_verifyAPI',
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                            }
                        },
                        {
                            key: '_handleInit',
                            value: function _handleInit(event, reg) {
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: '_handleSubInit',
                            value: function _handleSubInit(event, reg) {
                                var blocked = reg.extension.options.noSub || this._getBooleanFeatureFlag && this._getBooleanFeatureFlag('com.atlassian.connect.resolve_inner_iframe_url');
                                var data = event.data;
                                if (blocked) _util2.default.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
                                else this.registerExtension(data.ext.id, {
                                    extension: data.ext
                                });
                                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                    sub: data.ext,
                                    type: data.type,
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id,
                                    blocked: blocked
                                });
                            }
                        },
                        {
                            key: '_getHostOffset',
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0;
                                    // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                            }
                        },
                        {
                            key: '_hasSameOrigin',
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {
                                // A exception will be thrown if the windows doesn't have the same origin
                                }
                                return false;
                            }
                        },
                        {
                            key: '_handleResponse',
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: '_handleRequest',
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util2.default.sanitizeStructuredClone(_util2.default.argumentsToArray(arguments));
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = new (Function.prototype.bind.apply(Cls.constructor, [
                                                        null
                                                    ].concat(args)))();
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!((typeof promiseResult === 'undefined' ? 'undefined' : _typeof(promiseResult)) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: '_handleBroadcast',
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: '_handleKeyTriggered',
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: 'defineAPIModule',
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util2.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: 'isAPIModuleDefined',
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: '_pendingEventKey',
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = key + '@@' + targetSpec.key;
                                key = key + '@@' + time;
                                return key;
                            }
                        },
                        {
                            key: 'queueEvent',
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util2.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: '_cleanupInvalidEvents',
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: '_handleEventQuery',
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: '_handleUnload',
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util2.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util2.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: '_findRegistrations',
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util2.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: '_keycodeKey',
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                                this._clickHandler = callback;
                            }
                        },
                        {
                            key: '_handleAddonClick',
                            value: function _handleAddonClick(event, reg) {
                                if (typeof this._clickHandler === 'function') this._clickHandler({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._clickHandler = null;
                            }
                        },
                        {
                            key: 'getApiSpec',
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(typeof member === 'undefined' ? 'undefined' : _typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util2.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: '_originEqual',
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util2.default.getOrigin(url);
                                // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            }
                        },
                        {
                            key: '_checkOrigin',
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                                // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: 'getRegisteredExtensions',
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage2.default);
                exports.default = XDMRPC;
                module1.exports = exports['default'];
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        4
    ])(4);
});

});


parcelRegister("huqaB", function(module, exports) {
$parcel$export(module.exports, "useHostOffsetOverride", () => $2eb8a60db06bd239$export$db5957f3934e2c38);

var $eJOHy = parcelRequire("eJOHy");
function $2eb8a60db06bd239$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $2eb8a60db06bd239$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $2eb8a60db06bd239$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($2eb8a60db06bd239$var$isSameOrigin(window1.top)) {
            const containerDepth = $2eb8a60db06bd239$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$2eb8a60db06bd239$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $2eb8a60db06bd239$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($2eb8a60db06bd239$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $2eb8a60db06bd239$export$db5957f3934e2c38() {
    (0, $eJOHy.useEffect)(()=>{
        $2eb8a60db06bd239$var$attachHostOffsetOverride(window);
        return ()=>{
            $2eb8a60db06bd239$var$detachHostOffsetOverride();
        };
    }, []);
}

});

parcelRegister("4nJ3E", function(module, exports) {
$parcel$export(module.exports, "usePerformanceMetrics", () => $212d532a1326c787$export$865423e6f8e2e839);
$parcel$export(module.exports, "PerformanceMetricsProvider", () => $212d532a1326c787$export$c6f19d9afc6c86c8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5P7sD = parcelRequire("5P7sD");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $212d532a1326c787$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $212d532a1326c787$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $212d532a1326c787$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $eJOHy.useState)(contentType);
    const isInitialized = (0, $eJOHy.useRef)(true);
    const iframeLoadMetrics = (0, $eJOHy.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $5P7sD.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$e5b04c2a3cc97ddc):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$9f8bbf62fac57d48):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$e08d2ab8ef653595):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $e5befacaa387021d$export$ad3f29048eb3061) + (0, $e5befacaa387021d$export$73b982309451f084):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $212d532a1326c787$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $5P7sD.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $eJOHy.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $eJOHy.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $212d532a1326c787$export$865423e6f8e2e839 = ()=>{
    return (0, $eJOHy.useContext)($212d532a1326c787$var$PerformanceMetricsContext);
};
const $212d532a1326c787$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $212d532a1326c787$export$865423e6f8e2e839();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $gt9Am.jsx)($212d532a1326c787$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};

});
parcelRegister("5P7sD", function(module, exports) {
$parcel$export(module.exports, "embeddedViewToEditTransitionMetric", () => $e30bbd423029a7b8$export$4de078c3b9971f9b);
$parcel$export(module.exports, "embeddedConfluenceIframeLoadMetrics", () => $e30bbd423029a7b8$export$a23245993532c751);

var $hqYEY = parcelRequire("hqYEY");

var $cXQfL = parcelRequire("cXQfL");
const $e30bbd423029a7b8$export$4de078c3b9971f9b = ()=>(0, $hqYEY.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e30bbd423029a7b8$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e30bbd423029a7b8$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e30bbd423029a7b8$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $cXQfL.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e30bbd423029a7b8$var$timings
    }
};
const $e30bbd423029a7b8$export$a23245993532c751 = (contentType)=>(0, $hqYEY.metrics).pageSegmentLoad($e30bbd423029a7b8$var$loadingMetricsConfig[contentType]);

});

const $e5befacaa387021d$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $e5befacaa387021d$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $e5befacaa387021d$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $e5befacaa387021d$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $e5befacaa387021d$export$73b982309451f084 = 'embedded-iframe-content-initialized';



parcelRegister("fuXvj", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $aa643ac6d9a3565e$export$a06f1c675e846f6f);
/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-anchor */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ftN6c = parcelRequire("ftN6c");

var $lgMTT = parcelRequire("lgMTT");

var $k71qx = parcelRequire("k71qx");

var $fnLem = parcelRequire("fnLem");
const $aa643ac6d9a3565e$var$FOOTER_CONTENT_HEIGHT = 52;
const $aa643ac6d9a3565e$var$FOOTER_BORDER_PX = 2;
const $aa643ac6d9a3565e$export$a2dd5f25b5a4e5d2 = $aa643ac6d9a3565e$var$FOOTER_CONTENT_HEIGHT + $aa643ac6d9a3565e$var$FOOTER_BORDER_PX;
const $aa643ac6d9a3565e$var$containerStyles = null;
const $aa643ac6d9a3565e$var$contentWrapperStyles = null;
const $aa643ac6d9a3565e$var$logoWrapperSyles = null;
const $aa643ac6d9a3565e$var$linkStyles = null;
const $aa643ac6d9a3565e$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "footer-container",
        className: (0, $hcewu.default)([
            "_11c8dcr7 _16jlidpf _1o9zidpf _i0dl1ex1 _x3dowsm2 _4t3i1ex1 _syaz1n3s _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]),
        children: url ? /*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$ContentAction, {
            tooltipText: linkTooltip,
            href: url,
            children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$Content, {
                    isHovered: isHovered,
                    label: label
                })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)($aa643ac6d9a3565e$var$Content, {
            label: label
        })
    });
const $aa643ac6d9a3565e$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"
        ]),
        children: [
            label,
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                    appearance: isHovered ? 'brand' : 'neutral',
                    size: "xxsmall"
                })
            })
        ]
    });
const $aa643ac6d9a3565e$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $fnLem.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipText,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
            href: href,
            target: "_blank",
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseEnter: ()=>{
                setIsHovered(true);
            },
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: ()=>{
                setIsHovered(false);
            },
            onClick: handleClick,
            "data-testid": "link",
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"
            ]),
            children: children({
                isHovered: isHovered
            })
        })
    });
};

});

parcelRegister("73Fae", function(module, exports) {
$parcel$export(module.exports, "PageLoadValidation", () => $8aa4abb0dea40b7c$export$3b0759108d92fe77);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $drmS4 = parcelRequire("drmS4");

var $e5FZ0 = parcelRequire("e5FZ0");

var $bQ7Jf = parcelRequire("bQ7Jf");

var $ftN6c = parcelRequire("ftN6c");

var $bbc8b = parcelRequire("bbc8b");

var $d5di2 = parcelRequire("d5di2");

var $fnLem = parcelRequire("fnLem");
const $8aa4abb0dea40b7c$var$noop = ()=>{};
const $8aa4abb0dea40b7c$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $bbc8b.useUrl)(props);
    const { state: { contentLoadStarted: contentLoadStarted, iframeLoaded: iframeLoaded } } = (0, $d5di2.useValidationState)();
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $eJOHy.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        isLoading: contentLoadStarted && !iframeLoaded || false,
        iframeLoaded: iframeLoaded || true,
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $8aa4abb0dea40b7c$var$noop,
        handleContentLoadStarted: $8aa4abb0dea40b7c$var$noop,
        handleIframeUnload: $8aa4abb0dea40b7c$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($8aa4abb0dea40b7c$var$CrossDomainErrorValidation, {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    }, embeddedConfluenceUrl || props.contentId);
};
const $8aa4abb0dea40b7c$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $d5di2.useValidationState)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $eJOHy.useRef)(null);
    /* This ref is specifically used for the purpose of recoding whether or not a delayed dispatch of the iframe occured.
		This recorded value is later used to fire analytics if contentLoadStarted arrives after the delayed dispatch, and reset
		once the event has fired or if the users needs to go through login flow.
	*/ const iframeLoadedWithDelayRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isLoginFlowDisabled = (0, $eJOHy.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $eJOHy.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
      If anonymous access is permitted globally but restricted on a content's parent space,
      the iframe will attempt a login redirect which we intercept.
      To avoid an error in the iframe, we need to wait for the iframe window to unload
      before unmouting the Iframe component.
    */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // modifiy the navigationPolicy to intercept login redirects
                // so that login can be handled outside of the iframe
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $d5di2.Subjects).CONTENT_LOAD,
                        status: (0, $d5di2.LoadingStatus).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    const handleIframeOnLoad = (0, $eJOHy.useCallback)(()=>{
        const dispatchNow = ()=>{
            dispatch({
                subject: (0, $d5di2.Subjects).CONTENT_LOAD,
                status: (0, $d5di2.LoadingStatus).IFRAME_LOADED
            });
        };
        const totalNumberOfTries = 2;
        const iframeOfDispatch = iframeRef.current;
        const iframeSrcOfDispatch = iframeOfDispatch?.src;
        let tries = 0;
        const dispatchWithDelay = ()=>{
            /* We verify whether the iframeRef is current, as our intent is to invoke this only for the Iframe component created within the Content component (embedded-confluence-common/src/content/Content.tsx).
			It's important to note that the same Iframe component is also used by the StorageAccessPage component; however, we do not need to perform that check in this context.
			Additionally, the src of the iframe may change during transitions between view/edit modes or other redirects. Therefore, we must ensure that our invocation is limited to the current src of the iframe.
			*/ if (iframeRef.current !== iframeOfDispatch || iframeOfDispatch?.src !== iframeSrcOfDispatch) return;
            ++tries;
            if (contentLoadStarted || tries > totalNumberOfTries) {
                // If content load arrived after a timeout, failure to load was prevented by the delay
                if (contentLoadStarted && iframeLoadedWithDelayRef.current) {
                    createAnalyticsEvent({
                        action: 'delayedDispatch',
                        actionSubject: 'iframeOnLoad',
                        actionSubjectId: 'crossDomainErrorValidation',
                        source: 'pageLoadValidation',
                        eventType: 'track'
                    }).fire((0, $fnLem.ANALYTICS_CHANNEL));
                    //reset the ref for now. If the delayed dispatch is triggered again, the event will get fired too
                    iframeLoadedWithDelayRef.current = false;
                }
                dispatchNow();
            } else {
                /* This determines whether to fire a track analytics event
				to log instances where iframe load is delayed to wait for the confluence content to load.*/ if (!iframeLoadedWithDelayRef.current) iframeLoadedWithDelayRef.current = true;
                setTimeout(dispatchWithDelay, 1000);
            }
        };
        dispatchWithDelay();
    }, [
        contentLoadStarted,
        createAnalyticsEvent,
        dispatch
    ]);
    const handleContentLoadStarted = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $d5di2.Subjects).CONTENT_LOAD,
            status: (0, $d5di2.LoadingStatus).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        isLoading: contentLoadStarted && !iframeLoaded,
        iframeLoaded: iframeLoaded,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQ7Jf.StorageAccessPage), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5FZ0.LoginPage), {
            contentId: contentId,
            parentProduct: parentProduct,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $drmS4.ErrorScreen), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};

});
parcelRegister("drmS4", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", () => $2d64f4bf7c30dace$export$42f84e610f279c31);
/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $5bY40 = parcelRequire("5bY40");

var $806LH = parcelRequire("806LH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lgMTT = parcelRequire("lgMTT");

var $9itkV = parcelRequire("9itkV");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $boRG7 = parcelRequire("boRG7");
var $40f0Z = parcelRequire("40f0Z");

var $j2zMY = parcelRequire("j2zMY");

var $lKjnT = parcelRequire("lKjnT");

var $ijVIe = parcelRequire("ijVIe");

var $4nJ3E = parcelRequire("4nJ3E");
const $2d64f4bf7c30dace$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $2d64f4bf7c30dace$var$styles = {
    loginButtonWrapper: "_19pkxy5q _otyrpxbi",
    mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
const $2d64f4bf7c30dace$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const experience = (0, $eJOHy.useContext)((0, $boRG7.ExperienceContext));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $j2zMY.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "error-screen-container",
        className: (0, $hcewu.default)([
            $2d64f4bf7c30dace$var$styles.mainWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lKjnT.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $ijVIe.default).paragraphLogin)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2d64f4bf7c30dace$var$styles.loginButtonWrapper,
                // data tag for JSM KB to target for excluding LinkButton from global styles
                // used instead of className as the className prop is not allowed
                // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
                "data-embedded-confluence-no-global-styles-link-button": "true",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                    appearance: "primary",
                    "aria-label": formatMessage((0, $ijVIe.default).buttonLoginToConfluenceNewTab),
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
                    href: standaloneConfluenceUrl ?? '',
                    target: "_blank",
                    children: formatMessage((0, $ijVIe.default).buttonLoginToConfluenceNewTab)
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: formatMessage((0, $ijVIe.default).paragraphAlreadyLoggedIn)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: formatMessage((0, $ijVIe.default).paragraphStillHavingTrouble, {
                            link: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                href: $2d64f4bf7c30dace$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
                                target: "_blank",
                                "aria-label": formatMessage((0, $ijVIe.default).linkAriaLabel),
                                children: formatMessage((0, $ijVIe.default).linkTroubleshootingText)
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("lKjnT", function(module, exports) {
$parcel$export(module.exports, "LoginToConfluenceIcon", () => $449669a96dd7ddb7$export$ae31f6824db63a1c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $449669a96dd7ddb7$export$ae31f6824db63a1c = ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        width: "148",
        height: "160",
        viewBox: "0 0 148 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_499_12980)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "147.652",
                        height: "160",
                        transform: "translate(0.174194)",
                        fill: "var(--ds-icon-inverse, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z",
                        fill: "url(#paint0_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 44.9982H121.774V46.1167H147.826V44.9982Z",
                            fill: "url(#paint1_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 47.9763H121.774V49.0948H147.826V47.9763Z",
                            fill: "url(#paint2_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M141.564 50.951H121.774V52.0696H141.564V50.951Z",
                            fill: "url(#paint3_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 0H56.186V1.11852H82.238V0Z",
                            fill: "url(#paint4_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 2.97815H56.186V4.09667H82.238V2.97815Z",
                            fill: "url(#paint5_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z",
                            fill: "url(#paint6_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z",
                        fill: "url(#paint7_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z",
                        fill: "url(#paint8_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z",
                        fill: "var(--ds-icon-inverse, white)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #CCE0FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z",
                        fill: "url(#paint9_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFFAE5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z",
                        fill: "url(#paint10_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z",
                        fill: "url(#paint11_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6116 84.6954V74.9203V65.1453V55.3737",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3518 84.4312V75.1948V65.9584V56.722",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z",
                        fill: "url(#paint12_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z",
                        fill: "url(#paint13_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z",
                        fill: "url(#paint14_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z",
                        fill: "url(#paint15_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z",
                        fill: "url(#paint16_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "url(#paint17_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "url(#paint18_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.5641 127.131L58.1314 128.784L49.5641 127.131Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L67.4159 130.575L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L83.9638 133.77L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z",
                        fill: "url(#paint19_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "url(#paint20_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M106.598 139.729L88.1222 136.103L106.598 139.729Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint21_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint22_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z",
                        fill: "url(#paint23_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00B8D9)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z",
                        fill: "url(#paint24_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z",
                        fill: "url(#paint25_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z",
                        fill: "url(#paint26_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z",
                        fill: "url(#paint27_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z",
                        fill: "url(#paint28_linear_499_12980)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_499_12980",
                        x1: "50.6701",
                        y1: "127.204",
                        x2: "144.895",
                        y2: "32.9795",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2415",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFF)",
                                stopOpacity: "0.7585"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4317",
                                stopColor: "var(--ds-background-accent-blue-bolder, #59A1FF)",
                                stopOpacity: "0.5683"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6043",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AABFF)",
                                stopOpacity: "0.3957"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7666",
                                stopColor: "var(--ds-background-accent-blue-subtle, #81B8FF)",
                                stopOpacity: "0.2334"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9202",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #9FC9FF)",
                                stopOpacity: "0.0798"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_499_12980",
                        x1: "121.776",
                        y1: "45.5575",
                        x2: "147.826",
                        y2: "45.5575",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_499_12980",
                        x1: "121.776",
                        y1: "48.5346",
                        x2: "147.826",
                        y2: "48.5346",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_499_12980",
                        x1: "121.776",
                        y1: "51.5113",
                        x2: "141.565",
                        y2: "51.5113",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint4_linear_499_12980",
                        x1: "56.1854",
                        y1: "0.55854",
                        x2: "82.2361",
                        y2: "0.55854",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_499_12980",
                        x1: "56.1854",
                        y1: "3.53525",
                        x2: "82.2361",
                        y2: "3.53525",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_499_12980",
                        x1: "56.1854",
                        y1: "6.51231",
                        x2: "75.9746",
                        y2: "6.51231",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_499_12980",
                        x1: "54.7482",
                        y1: "124.969",
                        x2: "145.885",
                        y2: "33.833",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #2684FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3613",
                                stopColor: "var(--ds-background-accent-blue-subtle, #2986FF)",
                                stopOpacity: "0.6387"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6457",
                                stopColor: "var(--ds-background-accent-blue-subtle, #338CFF)",
                                stopOpacity: "0.3543"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9031",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4495FF)",
                                stopOpacity: "0.0969"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_499_12980",
                        x1: "132.434",
                        y1: "109.023",
                        x2: "129.764",
                        y2: "78.307",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7911",
                                stopColor: "var(--ds-background-accent-blue-subtle, #66A3FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_499_12980",
                        x1: "23.785",
                        y1: "51.7314",
                        x2: "42.402",
                        y2: "33.1132",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2089",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_499_12980",
                        x1: "42.596",
                        y1: "129.08",
                        x2: "141.953",
                        y2: "29.7225",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_499_12980",
                        x1: "37.0626",
                        y1: "130.862",
                        x2: "125.647",
                        y2: "42.2776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DEEBFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6383",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #EBF1FA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_499_12980",
                        x1: "94.0388",
                        y1: "28.347",
                        x2: "117.556",
                        y2: "28.347",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtle, #6E7C93)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtle, #6C798F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_499_12980",
                        x1: "50.5705",
                        y1: "26.7136",
                        x2: "49.861",
                        y2: "13.9285",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_499_12980",
                        x1: "45.5246",
                        y1: "24.8807",
                        x2: "54.0025",
                        y2: "13.9733",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_499_12980",
                        x1: "101.929",
                        y1: "89.445",
                        x2: "103.151",
                        y2: "76.738",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_499_12980",
                        x1: "96.7524",
                        y1: "86.8327",
                        x2: "105.46",
                        y2: "77.236",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_499_12980",
                        x1: "46.7436",
                        y1: "124.678",
                        x2: "85.5786",
                        y2: "85.843",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_499_12980",
                        x1: "55.645",
                        y1: "135.098",
                        x2: "94.1816",
                        y2: "96.5612",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint19_linear_499_12980",
                        x1: "82.9016",
                        y1: "129.529",
                        x2: "83.3365",
                        y2: "138.118",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint20_linear_499_12980",
                        x1: "66.7271",
                        y1: "153.359",
                        x2: "112.794",
                        y2: "115.971",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint21_linear_499_12980",
                        x1: "64.8985",
                        y1: "150.541",
                        x2: "110.859",
                        y2: "113.239",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint22_linear_499_12980",
                        x1: "99.6982",
                        y1: "120.33",
                        x2: "103.749",
                        y2: "121.161",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint23_linear_499_12980",
                        x1: "0.174194",
                        y1: "146.568",
                        x2: "56.0521",
                        y2: "146.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint24_linear_499_12980",
                        x1: "58.1309",
                        y1: "158.125",
                        x2: "87.7433",
                        y2: "158.125",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint25_linear_499_12980",
                        x1: "78.6253",
                        y1: "150.658",
                        x2: "68.697",
                        y2: "151.584",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.452",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint26_linear_499_12980",
                        x1: "79.3893",
                        y1: "142.265",
                        x2: "75.8395",
                        y2: "140.601",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3539",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFB500)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7017",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint27_linear_499_12980",
                        x1: "76.9238",
                        y1: "139.183",
                        x2: "90.7241",
                        y2: "138.741",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7262",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint28_linear_499_12980",
                        x1: "90.4515",
                        y1: "22.6491",
                        x2: "117.556",
                        y2: "22.6491",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.0346",
                                stopColor: "var(--ds-icon-inverse, white)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3965",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F7F7F8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9604",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #E1E3E6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_499_12980",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "147.652",
                            height: "160",
                            fill: "var(--ds-icon-inverse, white)",
                            transform: "translate(0.174194)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("ijVIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a66953f9d62b484$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66953f9d62b484$var$messages = (0, $7qGN1.defineMessages)({
    connectToConfluenceHeading: {
        id: 'embedded.confluence.connect-to-confluence.heading',
        description: 'The heading for the connect to Confluence page',
        defaultMessage: 'Connect to Confluence'
    },
    connectToConfluenceDescription: {
        id: 'embedded.confluence.connect-to-confluence.description',
        description: 'The description for the connect to Confluence page',
        defaultMessage: 'Save ideas, track agenda items, and take notes together as a team.'
    },
    connectConfluenceButton: {
        id: 'embedded.confluence.connect-to-confluence.button',
        description: 'The text inside the connect to Confluence button',
        defaultMessage: 'Connect Confluence'
    },
    connectConfluenceButtonAriaLabel: {
        id: 'embedded.confluence.connect-to-confluence.button.aria-label',
        description: 'The aria label for the connect to Confluence button',
        defaultMessage: 'Connect Confluence Button'
    },
    buttonLoginToConfluenceNewTab: {
        id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
        description: 'The text inside the login to Confluence button',
        defaultMessage: 'Log in to Confluence'
    },
    paragraphLogin: {
        id: 'embedded.confluence.need-to-log-in-paragraph',
        description: 'The text inside embedded confluence that tell user they need to be logged in to view this page',
        defaultMessage: 'You need to be logged in to view this page'
    },
    paragraphAlreadyLoggedIn: {
        id: 'embedded.confluence.already-logged-in-paragraph',
        description: 'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
        defaultMessage: 'Already logged in? Try refreshing.'
    },
    paragraphStillHavingTrouble: {
        id: 'embedded.confluence.still-having-trouble-paragraph',
        description: 'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
        defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}'
    },
    linkTroubleshootingText: {
        id: 'embedded.confluence.troubleshooting-link-text',
        description: 'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
        defaultMessage: 'refer to this troubleshooting guide.'
    },
    linkAriaLabel: {
        id: 'embedded.confluence.troubleshooting-link.aria-label',
        description: 'The aria label for troubleshooting link.',
        defaultMessage: 'troubleshooting guide link'
    },
    loginAriaLabel: {
        id: 'embedded.confluence.login-page.login-button.aria-label',
        description: 'The aria label for login button',
        defaultMessage: 'Login Button'
    },
    loginText: {
        id: 'embedded.confluence.login-page.login-text',
        description: 'Text to display before login button',
        defaultMessage: 'You need to be logged in to view this page'
    },
    loginButton: {
        id: 'embedded.confluence.login-page.login-button',
        description: 'The label for login button',
        defaultMessage: 'Log in to Confluence'
    },
    refreshBanner: {
        id: 'embedded.confluence.login-page.refresh-page-banner',
        description: 'The banner displayed prompting a user to refresh the page',
        defaultMessage: 'After logging in, this page should refresh automatically. If not, you can click here to refresh'
    },
    refreshBannerLink: {
        id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
        description: 'A link to refresh the page',
        defaultMessage: 'Refresh page'
    }
});
var $1a66953f9d62b484$export$2e2bcd8739ae039 = $1a66953f9d62b484$var$messages;

});


parcelRegister("e5FZ0", function(module, exports) {
$parcel$export(module.exports, "LoginPage", () => $46ab436a36e209ea$export$f14c0e3f98d164c0);
/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");
var $78OnL = parcelRequire("78OnL");

var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $806LH = parcelRequire("806LH");

var $5CSKW = parcelRequire("5CSKW");

var $lgMTT = parcelRequire("lgMTT");

var $kopi2 = parcelRequire("kopi2");

var $lKjnT = parcelRequire("lKjnT");

var $j2zMY = parcelRequire("j2zMY");

var $8edRS = parcelRequire("8edRS");

var $4AWDd = parcelRequire("4AWDd");

var $ijVIe = parcelRequire("ijVIe");

var $4nJ3E = parcelRequire("4nJ3E");

var $kfi6y = parcelRequire("kfi6y");

var $5qJVF = parcelRequire("5qJVF");
const $46ab436a36e209ea$var$fadeIn = null;
const $46ab436a36e209ea$var$styles = {
    loginButtonWrapper: "_19pkxy5q",
    parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
    refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n",
    loomHeading: "_11c8nf1z _k48p1pd9 _syazi7uo",
    loomLoginButton: "_2rko1tm3 _11c81ixg _v5642hjt _1bsb842n _4t3i8vuz _bfhk1856 _syaz15cr _k48p1pd9 _o7ks2hjt _irr3hf2y _1di6g6ey"
};
const $46ab436a36e209ea$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $46ab436a36e209ea$export$f14c0e3f98d164c0 = ({ contentId: contentId, parentProduct: parentProduct, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $eJOHy.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        const uniqueKeyParam = uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `&uniqueKey=${uniqueKey}` : '';
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$46ab436a36e209ea$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}${uniqueKeyParam}`;
    }, [
        url,
        locale,
        uniqueKey
    ]);
    const isLoomParentProduct = parentProduct === 'loom' && (0, $eGOwo.fg)('mr2-meeting-recording-notes-confluence');
    const handleClick = ()=>{
        $46ab436a36e209ea$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $eJOHy.useState)(false);
    return isLoomParentProduct ? /*#__PURE__*/ (0, $gt9Am.jsx)($46ab436a36e209ea$export$e65dcd3f2d7567ae, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($46ab436a36e209ea$export$50083a1d14fa7d72, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    });
};
const $46ab436a36e209ea$export$e65dcd3f2d7567ae = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hcewu.default)([
            $46ab436a36e209ea$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}-loom`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.400",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                        space: "space.200",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kfi6y.ConnectLoomToConfluenceSVG), {}),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                                space: "space.100",
                                alignInline: "center",
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                        as: "h2",
                                        size: "large",
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                            xcss: $46ab436a36e209ea$var$styles.loomHeading,
                                            children: formatMessage((0, $ijVIe.default).connectToConfluenceHeading)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                        color: "color.text.subtlest",
                                        size: "medium",
                                        children: formatMessage((0, $ijVIe.default).connectToConfluenceDescription)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                        xcss: $46ab436a36e209ea$var$styles.loomLoginButton,
                        onClick: handleClick,
                        testId: "connect-confluence-button",
                        "aria-label": formatMessage((0, $ijVIe.default).connectConfluenceButtonAriaLabel),
                        children: formatMessage((0, $ijVIe.default).connectConfluenceButton)
                    })
                ]
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $46ab436a36e209ea$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4AWDd.default), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $ijVIe.default).refreshBanner),
                    actionLabel: formatMessage((0, $ijVIe.default).refreshBannerLink)
                })
            })
        ]
    });
};
const $46ab436a36e209ea$export$50083a1d14fa7d72 = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hcewu.default)([
            $46ab436a36e209ea$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lKjnT.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $ijVIe.default).loginText)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $46ab436a36e209ea$var$styles.loginButtonWrapper,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "login-button",
                    "aria-label": formatMessage((0, $ijVIe.default).loginAriaLabel),
                    appearance: "primary",
                    onClick: handleClick,
                    children: formatMessage((0, $ijVIe.default).loginButton)
                })
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $46ab436a36e209ea$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4AWDd.default), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $ijVIe.default).refreshBanner),
                    actionLabel: formatMessage((0, $ijVIe.default).refreshBannerLink)
                })
            })
        ]
    });
};
function $46ab436a36e209ea$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}

});
parcelRegister("kopi2", function(module, exports) {
$parcel$export(module.exports, "ExperienceStart", () => $80a280f19a7661a1$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");
function $80a280f19a7661a1$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const wasCalledRef = (0, $eJOHy.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("4AWDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd4c0eb9ad4557e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h0TP6 = parcelRequire("h0TP6");

var $3wl9L = parcelRequire("3wl9L");

const $4fd4c0eb9ad4557e$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $h0TP6.default), {
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
            spacing: "spacious",
            color: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $4fd4c0eb9ad4557e$export$2e2bcd8739ae039 = $4fd4c0eb9ad4557e$var$RefreshBanner;

});

parcelRegister("kfi6y", function(module, exports) {
$parcel$export(module.exports, "ConnectLoomToConfluenceSVG", () => $7848c829a07d8eab$export$b8ca9c7db864e9fb);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $7848c829a07d8eab$export$b8ca9c7db864e9fb = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "167",
        height: "110",
        viewBox: "0 0 167 110",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M31.3301 44.2761C32.0417 39.4311 36.5463 36.0803 41.3913 36.792L76.4821 41.9462C81.3272 42.6579 84.6779 47.1624 83.9663 52.0075L78.812 87.0983C78.1004 91.9433 73.5958 95.294 68.7508 94.5824L33.66 89.4282C28.815 88.7165 25.4642 84.2119 26.1759 79.3669L31.3301 44.2761Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M67.5284 73.4352C59.3 67.8513 56.8065 66.8312 53.0744 66.2831C48.6954 65.6399 44.6958 66.9131 40.6098 71.5432L39.9395 72.2997C39.3904 72.9231 39.2547 73.1546 39.2113 73.45C39.1679 73.7454 39.2811 74.0134 39.7778 74.4384L44.8874 78.7596C45.1571 79.0004 45.3914 79.1354 45.6402 79.1719C45.9388 79.2158 46.1595 79.0973 46.5232 78.6981L47.6213 77.4513C49.3256 75.5391 50.6708 75.0326 52.2632 75.2665C53.6565 75.4712 55.2408 76.1062 57.1364 77.3904L62.6032 81.0097C63.157 81.3928 63.8256 81.3401 64.2254 80.6948L67.9086 74.9997C68.3084 74.3544 68.1745 73.8821 67.5284 73.4352ZM43.286 58.8607C51.5144 64.4446 54.0079 65.4647 57.74 66.0129C62.119 66.656 66.1186 65.3828 70.2046 60.7527L70.8749 59.9962C71.424 59.3728 71.5597 59.1413 71.6031 58.8459C71.6464 58.5505 71.5333 58.2825 71.0366 57.8575L65.9269 53.5363C65.6573 53.2956 65.4229 53.1606 65.1741 53.124C64.8756 53.0802 64.6548 53.1986 64.2912 53.5978L63.193 54.8446C61.4888 56.7568 60.1435 57.2633 58.5512 57.0294C57.1579 56.8247 55.5736 56.1897 53.678 54.9055L48.2111 51.2862C47.6574 50.9031 46.9888 50.9558 46.589 51.6011L42.9058 57.2962C42.506 57.9415 42.6399 58.4138 43.286 58.8607Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M79.0185 46.5871C78.7238 41.699 82.4475 37.4974 87.3356 37.2027L122.739 35.0683C127.627 34.7736 131.828 38.4973 132.123 43.3855L134.257 78.7885C134.552 83.6766 130.828 87.8782 125.94 88.1729L90.5372 90.3073C85.6491 90.602 81.4476 86.8782 81.1529 81.9901L79.0185 46.5871Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M131.339 50.0102C131.38 50.4171 131.327 50.505 131.302 50.1756C131.296 50.0816 131.32 49.9587 131.339 50.0102ZM131.57 52.9057C131.605 53.3647 131.523 53.1278 131.517 53.0508C131.491 52.7277 131.544 52.4429 131.45 52.3368C131.432 52.1403 131.48 52.3249 131.475 52.2024C131.466 51.974 131.411 51.7504 131.395 51.5148C131.394 51.4988 131.393 51.4827 131.392 51.4667C131.409 51.4389 131.425 51.3739 131.444 51.3812C131.483 51.6293 131.561 52.7919 131.57 52.9057ZM131.427 50.9503C131.427 51.0635 131.396 51.0164 131.425 51.2291C131.405 51.2768 131.371 51.0701 131.365 50.9646C131.366 50.9616 131.384 50.975 131.383 50.95C131.373 50.7637 131.336 50.4831 131.384 50.4742C131.369 50.6602 131.426 50.8363 131.427 50.9503ZM131.282 48.5903C131.246 48.5428 131.245 48.4575 131.257 48.3261C131.265 48.3353 131.273 48.3382 131.281 48.3488C131.28 48.4257 131.282 48.5106 131.282 48.5903ZM131.26 48.1016C131.214 48.0042 131.204 47.4619 131.229 47.556C131.24 47.7377 131.25 47.9201 131.26 48.1016ZM107.62 90.4766C107.274 90.5679 106.006 90.5716 105.721 90.5878C104.407 90.6624 103.378 90.7473 102.165 90.8174C101.392 90.862 100.675 90.8822 99.9078 90.9254C99.7367 90.8515 99.5625 90.7784 99.3886 90.705C99.498 90.7054 99.555 90.7128 99.6801 90.7055C99.8054 90.698 100.106 90.6919 100.18 90.6481C100.066 90.6154 99.6636 90.6311 99.5409 90.6386C99.305 90.6532 99.4564 90.6823 99.2947 90.7011C99.1322 90.7198 98.859 90.6833 98.6613 90.7154C98.1978 90.7907 99.0717 90.7683 99.232 90.7501C99.1833 90.8416 98.7878 90.762 98.6394 90.8403C98.6993 90.8575 98.9438 90.8941 99.0348 90.8735C99.125 90.8526 98.9797 90.809 99.1761 90.8123C99.3083 90.8528 99.4553 90.895 99.5867 90.9362C99.3933 90.9602 99.0982 90.9499 98.9253 90.9616C97.8606 91.0345 96.8159 91.0945 95.7699 91.1505C94.9029 91.1696 94.0376 91.187 93.174 91.2031C93.1836 91.205 93.1924 91.2072 93.2008 91.2093C93.2152 91.2129 93.2294 91.2164 93.2482 91.2186C93.2489 91.2181 93.2496 91.2176 93.2504 91.2171C93.2716 91.22 93.3038 91.2207 93.3367 91.2214C93.3818 91.2223 93.4283 91.2234 93.4497 91.2302C93.4243 91.2339 93.3988 91.2377 93.3734 91.2414C93.3171 91.2482 93.2574 91.2556 93.2003 91.2626C93.1442 91.2437 93.0882 91.2247 93.0322 91.2058C92.7606 91.2108 92.489 91.2157 92.2176 91.2205C92.2071 91.2169 92.1935 91.2133 92.1762 91.2101C92.1625 91.2076 92.1487 91.2051 92.135 91.2025C92.1133 91.2019 92.0916 91.2013 92.0699 91.2006C91.957 91.1974 91.8172 91.1977 91.7043 91.1983C91.674 91.1985 91.6449 91.1988 91.6183 91.199C91.5339 91.1995 91.4672 91.2 91.416 91.1995C91.4092 91.1994 91.4019 91.1995 91.3948 91.1994C91.3921 91.197 91.3877 91.1948 91.3823 91.1928C91.342 91.1785 91.2874 91.1824 91.2329 91.1949C91.2272 91.1964 91.2215 91.1979 91.2158 91.1994C91.1868 91.1995 91.1581 91.1996 91.132 91.1996C91.0351 91.1998 90.9251 91.1993 90.7943 91.1963C90.7267 91.1947 90.6606 91.1924 90.5904 91.1899C90.5804 91.1896 90.5702 91.1894 90.56 91.189C90.5594 91.189 90.5589 91.189 90.5583 91.189C90.5114 91.1876 90.4628 91.1858 90.411 91.1836C90.3415 91.1806 90.267 91.1769 90.1953 91.1735C90.1278 91.1703 90.0396 91.1663 89.946 91.164C89.7468 91.1666 88.9653 91.107 88.5938 91.034C88.4281 91.0058 88.2629 90.9911 88.1944 91.0022C88.101 90.9806 88.007 90.9575 87.9141 90.9331C87.9082 90.9345 87.8999 90.9352 87.8885 90.9345C87.864 90.9327 87.823 90.9258 87.7788 90.9177C87.6952 90.9027 87.6003 90.8836 87.5888 90.8972C87.6785 90.9206 87.7675 90.9425 87.8575 90.9632C87.8634 90.9646 87.8693 90.9661 87.8752 90.9675C87.9335 90.993 87.6034 90.9524 87.4974 90.905C87.413 90.8688 87.4552 90.8308 87.4954 90.8131C87.4526 90.7998 87.4099 90.7861 87.3674 90.7721C87.3541 90.7724 87.3444 90.775 87.3343 90.7775C87.3182 90.7815 87.3009 90.7859 87.265 90.7827C87.0814 90.7695 86.6535 90.5904 86.8491 90.6095C86.7354 90.5643 86.716 90.5671 86.6938 90.5718C86.6703 90.5765 86.6421 90.5832 86.4934 90.5273C86.3176 90.4597 86.2527 90.4186 86.1919 90.3808C86.1597 90.3605 86.1282 90.3405 86.0824 90.3162C86.0409 90.2943 85.967 90.2599 85.8842 90.2195C85.7023 90.1317 85.48 90.011 85.4441 89.959C85.4025 89.9008 85.4973 89.942 85.58 89.9786C85.3732 89.8604 85.1712 89.7347 84.9742 89.6018C84.9683 89.6082 84.9628 89.6164 84.9563 89.626C84.6803 89.4614 84.6463 89.4058 84.7056 89.4138C84.4619 89.2369 84.2266 89.0487 84.0011 88.8505C83.9491 88.815 83.898 88.778 83.8573 88.7474C83.8663 88.77 83.9181 88.8143 83.9672 88.8549C84.0087 88.8894 84.0486 88.9216 84.0578 88.9379C84.1217 89.065 83.5954 88.7066 83.7348 88.7207C83.7682 88.7247 83.8061 88.7288 83.773 88.6802C83.7475 88.644 83.6269 88.5267 83.5785 88.4881C83.58 88.4881 83.5814 88.4881 83.5829 88.4881C83.5793 88.4851 83.5723 88.4815 83.5627 88.4766C83.5507 88.4709 83.5388 88.4651 83.5268 88.4593C83.495 88.4441 83.4558 88.4248 83.4272 88.4066C83.3929 88.384 83.3536 88.3551 83.3137 88.325C82.8696 87.978 83.1905 88.265 82.8441 87.8048C82.8172 87.7684 82.7836 87.7308 82.7522 87.695C82.7247 87.6635 82.6985 87.6329 82.6802 87.6068C82.6449 87.5582 82.616 87.5138 82.5881 87.4702C82.5357 87.3883 82.4859 87.3084 82.4032 87.2011C82.4008 87.1982 82.4038 87.2055 82.4083 87.2165C82.5222 87.4874 82.2959 87.0342 82.2912 87.0204C82.2843 87.0085 82.2788 86.9991 82.2796 86.9978C82.2871 86.9874 82.3585 87.0764 82.4443 87.1771C82.525 87.2721 82.6195 87.3779 82.6785 87.4268C82.6462 87.3841 82.6142 87.341 82.5827 87.2978C82.544 87.2596 82.5018 87.2089 82.4626 87.1481C82.4523 87.1315 82.4576 87.1307 82.4627 87.1299C82.4628 87.1298 82.4629 87.1298 82.4629 87.1297C82.4354 87.0902 82.4081 87.0506 82.3812 87.0107C82.3732 87.0062 82.3701 87.0087 82.3696 87.0092C82.3688 87.0091 82.3681 87.009 82.3673 87.0089C82.3132 86.9471 82.1273 86.6606 82.1188 86.6193C82.1159 86.6088 82.1154 86.6013 82.1174 86.5973C82.0521 86.4889 81.989 86.3792 81.9282 86.2686C81.92 86.2589 81.9122 86.2484 81.9052 86.2367C81.8892 86.2113 81.8767 86.182 81.8655 86.1525C81.8362 86.0972 81.8071 86.0414 81.779 85.9858C81.7779 85.9858 81.7768 85.9858 81.7757 85.9858C81.7681 85.986 81.7599 85.986 81.7526 85.9766C81.9146 86.2648 81.8715 86.2166 81.8189 86.1646C81.795 86.1404 81.7701 86.115 81.7643 86.1207C81.7571 86.1293 81.7854 86.1854 81.8128 86.238C81.8471 86.3039 81.8798 86.3648 81.835 86.3242C81.7541 86.1559 81.6866 86.0493 81.6196 85.9409C81.4113 85.5958 81.4418 85.5059 81.5671 85.7679C81.5941 85.8225 81.6228 85.879 81.6506 85.9161C81.6827 85.9595 81.7048 85.9637 81.7246 85.9673C81.734 85.9691 81.7432 85.9709 81.7526 85.9766C81.7505 85.9738 81.7485 85.971 81.7465 85.9681C81.7389 85.9589 81.5991 85.7219 81.5883 85.6967C81.5147 85.5528 81.5228 85.5549 81.535 85.5597C81.5414 85.5621 81.5492 85.5651 81.5486 85.5495C81.5479 85.5434 81.5404 85.5246 81.533 85.5057C81.5233 85.4809 81.5138 85.4558 81.5184 85.4579C81.5225 85.4581 81.5307 85.4662 81.5403 85.4775C81.5243 85.4406 81.5084 85.4033 81.4928 85.3661C81.4797 85.3476 81.4678 85.3297 81.4595 85.3121C81.4553 85.3034 81.3896 85.1212 81.3911 85.1194C81.3912 85.1189 81.3925 85.12 81.3947 85.1222C81.2502 84.748 81.1298 84.3647 81.0343 83.9759C81.0341 83.9724 81.0338 83.9689 81.0336 83.9654C81.0332 83.9596 81.0329 83.9536 81.0325 83.9476C81.0317 83.9311 81.0309 83.9146 81.0301 83.8981C81.0275 83.8381 81.0247 83.7495 81.0197 83.6666C81.0161 83.6075 81.0102 83.5303 80.9992 83.4389C80.9883 83.3487 80.9675 83.2035 80.9296 83.0313C80.9038 82.9144 80.8771 82.8037 80.8493 82.7188C80.8136 82.6096 80.7836 82.558 80.7674 82.5406C80.7627 82.5356 80.7584 82.5334 80.7545 82.5341C80.7425 82.5071 80.7338 82.4871 80.733 82.4854C80.7088 82.3834 80.7232 82.3809 80.7338 82.3798C80.7362 82.3795 80.7386 82.3791 80.7402 82.3776C80.7451 82.3701 80.7683 82.3392 80.7809 82.3254C80.7742 82.2219 80.7692 82.1179 80.7659 82.0134C80.7559 81.6901 80.7456 81.3663 80.7349 81.0422C80.7207 80.6135 80.7032 80.181 80.6826 79.745C80.6695 79.4657 80.6552 79.1847 80.6397 78.9027C80.6302 78.9271 80.6201 78.9398 80.6023 78.8581C80.5776 78.7426 80.5856 78.4294 80.5869 78.3818C80.585 78.373 80.5814 78.3636 80.5772 78.3522C80.5673 78.3258 80.5531 78.288 80.5445 78.2183C80.5251 78.0634 80.3678 77.3508 80.3787 77.1825C80.3693 77.0425 80.3596 76.9019 80.3497 76.7614C80.348 76.7092 80.3461 76.6588 80.3445 76.6114C80.348 76.5958 80.3509 76.5773 80.3531 76.555C80.3757 76.3205 80.3758 75.8656 80.4059 75.605C80.4224 75.6733 80.4382 75.7545 80.4543 75.8278C80.4653 75.7741 80.4764 75.7195 80.4874 75.665C80.4942 75.6747 80.5009 75.6836 80.5077 75.6925C80.5085 75.5271 80.5092 75.3616 80.51 75.1962C80.5093 75.1966 80.5085 75.1968 80.5078 75.1971C80.4996 75.1382 80.5033 75.1116 80.5104 75.095C80.5108 75.0137 80.5113 74.9324 80.5117 74.8511C80.5071 74.8269 80.5022 74.8005 80.497 74.7742C80.4786 74.7564 80.4601 74.7386 80.4416 74.7209C80.4489 74.6766 80.4562 74.6324 80.4635 74.5882C80.4432 74.4592 80.4319 74.3318 80.4533 74.2422C80.4471 74.1671 80.4409 74.0919 80.4347 74.0168C80.4269 73.9667 80.4215 73.911 80.4189 73.8562C80.3929 73.7794 80.2514 73.5491 80.2112 73.1899C80.2561 73.1982 80.301 73.2066 80.346 73.215C80.3322 73.1088 80.3184 73.0027 80.3046 72.8965C80.275 72.8709 80.2454 72.8452 80.2159 72.8196C80.2372 72.806 80.2586 72.7923 80.2799 72.7787C80.264 72.5745 80.2481 72.3704 80.2322 72.1662C80.2318 72.1662 80.2314 72.1663 80.2311 72.1663C80.2279 72.1399 80.2271 72.1211 80.2277 72.1076C80.2256 72.0798 80.2234 72.052 80.2212 72.0242C80.2403 72.0275 80.2593 72.0309 80.2784 72.0343C80.2785 72.0312 80.2788 72.0281 80.2787 72.0245C80.2776 71.9657 80.2699 71.9109 80.2596 71.8565C80.2526 71.8783 80.2457 71.9001 80.2388 71.9219C80.2027 71.6505 80.1667 71.3791 80.1307 71.1076C80.1409 71.072 80.1512 71.0364 80.1615 71.0008C80.1598 70.9882 80.1585 70.9758 80.1579 70.9648C80.1582 70.9631 80.1657 70.9624 80.1731 70.9594C80.1772 70.9448 80.1814 70.9302 80.1856 70.9156C80.1853 70.9103 80.185 70.9051 80.1846 70.8998C80.1459 70.8409 80.1072 70.7821 80.0684 70.7233C80.0579 70.5699 80.0474 70.4165 80.037 70.2631C80.035 70.1419 80.0339 70.0263 80.0328 69.9182C80.0445 69.7275 80.0562 69.5368 80.0678 69.346C80.0515 69.3242 80.0392 69.3047 80.0301 69.2856C80.0302 69.2133 80.0303 69.1724 80.0303 69.1724C80.0221 69.163 80.0138 69.1537 80.0055 69.1444C80.0071 69.0531 80.0211 68.9288 79.969 68.6875C80.0104 68.6956 80.0517 68.7037 80.0931 68.7117C80.0956 68.688 80.0999 68.6606 80.1057 68.631C80.0471 68.3825 79.9886 68.1341 79.9301 67.8857C79.9837 67.7705 80.0373 67.6552 80.0909 67.54C80.0838 67.262 80.0766 66.9841 80.0695 66.7062C80.0664 66.6765 80.0636 66.6465 80.0605 66.6168C80.0416 66.7078 80.0226 66.7988 80.0037 66.8898C79.944 66.8071 79.8842 66.7244 79.8245 66.6416C79.8578 66.4725 79.8911 66.3034 79.9244 66.1342C79.8061 65.3199 79.9727 64.5136 79.7355 64.8227C79.7519 64.9322 79.7684 65.0417 79.7848 65.1512C79.7383 65.0113 79.6918 64.8714 79.6454 64.7315C79.6676 64.5993 79.6898 64.4671 79.712 64.3348C79.6892 64.1731 79.6663 64.0114 79.6435 63.8497C79.671 63.8019 79.6985 63.7542 79.726 63.7065C79.6899 63.5758 79.6537 63.4451 79.6176 63.3144C79.6609 63.2008 79.7042 63.0871 79.7475 62.9735C79.6979 62.3226 79.6483 61.6717 79.5987 61.0208C79.6525 60.0392 79.5116 60.5012 79.4237 59.8255C79.4384 59.5102 79.4531 59.195 79.4678 58.8797C79.4325 58.7663 79.3972 58.6529 79.362 58.5395C79.3723 58.4369 79.3826 58.3344 79.393 58.2318C79.3687 57.749 79.3445 57.2662 79.3202 56.7834C79.2766 56.8794 79.233 56.9754 79.1894 57.0714C79.1742 56.982 79.1591 56.8925 79.1439 56.8031C79.1899 56.564 79.2358 56.3249 79.2818 56.0858C79.2522 55.9 79.2227 55.7143 79.1932 55.5286C79.1887 55.2678 79.1841 55.0071 79.1795 54.7464C79.2151 54.7336 79.2506 54.7209 79.2861 54.7082C79.2221 54.6167 79.158 54.5251 79.094 54.4336C79.0614 54.0636 79.0287 53.6935 78.996 53.3235C79.0365 53.5433 79.077 53.7631 79.1175 53.9829C79.1303 53.7921 79.1431 53.6013 79.1559 53.4105C79.1273 53.2084 79.0986 53.0062 79.07 52.8041C79.0432 52.7445 79.0165 52.685 78.9898 52.6254C78.9878 52.2029 78.9857 51.7805 78.9837 51.358C78.954 50.8549 78.9243 50.3518 78.8946 49.8487C78.7823 49.4097 78.8897 48.6265 78.6532 48.5856C78.6472 48.1752 78.6413 47.7648 78.6354 47.3544C78.617 47.2651 78.5985 47.1759 78.5801 47.0866C78.6077 47.0381 78.6353 46.9897 78.6629 46.9412C78.6391 46.8317 78.6154 46.7223 78.5916 46.6128C78.5777 46.5465 78.5646 46.48 78.5521 46.4135C78.544 46.1586 78.5462 45.9011 78.5589 45.6468C78.5767 45.7278 78.5956 45.8079 78.6155 45.888C78.6565 45.1694 78.7813 44.4595 78.9865 43.7757C78.9398 43.7258 78.8935 43.6754 78.8475 43.6243C78.9342 43.3654 79.0325 43.1102 79.1413 42.861C79.12 42.8162 79.0991 42.771 79.0784 42.7256C79.233 42.3018 79.4186 41.8886 79.6329 41.4908C79.8971 41.1088 80.1878 40.7491 80.501 40.4152C80.7499 39.8965 81.5911 38.9271 81.9551 38.918C82.4932 38.438 83.09 38.0189 83.7307 37.6738C83.7112 37.7222 83.692 37.7707 83.6735 37.8191C83.7343 37.7993 83.7953 37.7801 83.8561 37.7618C83.8806 37.6928 83.9062 37.6239 83.9328 37.5549C84.1786 37.4814 84.4251 37.419 84.673 37.3669C84.5981 37.4263 84.5235 37.487 84.4508 37.5484C84.3568 37.5872 84.264 37.6274 84.1714 37.6694C84.3145 37.6444 84.457 37.6232 84.5999 37.6053C84.5945 37.6084 84.5891 37.6114 84.5836 37.6145C85.2161 37.4001 85.7845 37.3042 86.2854 37.2596C86.3256 37.2564 86.3657 37.2534 86.4059 37.2506C86.9855 37.2195 87.24 37.3094 87.3206 37.3772C87.3386 37.3929 87.3481 37.4094 87.3491 37.4263C87.3491 37.4263 87.3491 37.4263 87.3491 37.4263C87.3536 37.5039 87.1847 37.5851 86.856 37.6805C86.8279 37.6884 86.7999 37.6964 86.7721 37.7045C86.3117 37.8332 85.8271 37.9752 85.3817 38.137C85.4686 38.1219 85.5525 38.1102 85.6205 38.1063C85.5736 38.1325 85.517 38.1606 85.4671 38.1881C85.5109 38.1893 85.5557 38.1906 85.5999 38.1924C85.5919 38.2047 85.5899 38.215 85.578 38.2289C85.3094 38.3084 84.98 38.4856 84.7525 38.5867C84.5446 38.6783 84.408 38.6911 84.2496 38.7672C84.0868 38.8398 83.6355 39.1787 83.6803 39.0438C83.6527 39.0557 83.6141 39.0751 83.5873 39.0857C83.615 39.1859 83.3832 39.2423 83.1935 39.3952C83.1035 39.4659 82.8854 39.7388 83.0403 39.4458C83.0091 39.4667 82.9936 39.4718 82.9658 39.4879C82.7884 39.7796 82.6552 39.8348 82.3589 40.0477C82.1924 40.1656 81.8866 40.4424 82.0829 40.3758C81.9825 40.5636 81.7389 40.6956 81.648 40.8147C81.5589 40.9321 81.7257 40.811 81.6061 40.9687C81.5856 40.9942 81.4152 41.2135 81.3615 41.2767C81.3074 41.3385 81.3322 41.2371 81.2587 41.3492C80.9423 41.8384 80.7524 42.3451 80.5338 42.8996C80.0775 44.0705 79.8857 45.2827 79.9687 46.5298C80.0068 47.0976 80.0444 47.6739 80.0832 48.2653C80.1054 48.6026 80.2269 50.3483 80.2056 50.5496C80.1319 51.2394 79.9913 49.7944 80.0004 50.7772C80.3346 51.0247 80.2752 51.6099 80.3287 52.4314C80.3681 53.0372 80.4728 54.0132 80.4669 54.5351C80.4607 55.092 80.3957 54.6488 80.3477 54.9832C80.4922 55.1983 80.5351 55.4647 80.5703 55.922C80.6074 56.4025 80.5958 56.8851 80.616 57.3871C80.6228 57.5562 80.6651 57.7847 80.6653 57.9784C80.6656 58.2199 80.587 58.1635 80.585 58.3117C80.5831 58.4603 80.6621 58.3274 80.6855 58.4876C80.6962 58.5605 80.7297 59.0693 80.7028 59.1805C80.6965 59.2064 80.6631 59.1128 80.6386 59.1345C80.6252 59.1465 80.5177 59.1487 80.5343 59.2722C80.6361 59.3769 80.733 59.3798 80.7632 59.7658C80.8107 60.376 80.801 60.9562 80.8335 61.6063C80.8409 61.7518 80.9318 62.092 80.8594 62.2541C80.8383 62.3014 80.7444 62.2823 80.7631 62.5136C80.7791 62.7126 80.823 62.7413 80.8651 62.9129C80.881 62.978 80.8385 62.9994 80.8719 63.1225C80.9052 63.2464 80.9753 63.4223 80.8664 63.5094C80.902 63.5238 80.9328 63.5246 80.9664 63.5343C80.9856 63.7547 80.882 64.1396 80.983 64.0672C80.9972 64.2942 81.0114 64.5217 81.0256 64.7487C80.9906 64.7907 80.9553 64.8316 80.9201 64.8736C80.8761 64.7406 80.9118 64.5274 80.8399 64.5069C80.8461 64.7026 80.8524 64.9009 80.8585 65.0948C81.0434 65.0319 81.1744 65.6375 80.9695 65.514C80.9306 65.491 80.9861 65.8896 81.0041 65.9755C81.022 66.0608 81.0994 66.0792 81.0619 66.2597C81.0407 66.3622 80.9991 66.427 81.0658 66.6657C81.0782 66.5177 81.0946 66.3596 81.109 66.2086C81.1136 66.43 81.157 66.7154 81.1287 66.9141C81.1216 66.9632 81.082 66.7738 81.0714 66.8647C81.0607 66.9559 81.0921 67.3236 81.1609 67.2422C81.0275 67.4207 81.1452 67.3897 81.1706 67.7482C81.1736 67.7938 81.0587 68.1645 81.1418 68.3253C81.1714 68.3821 81.262 68.2671 81.2374 68.5537C81.2192 68.7646 81.1234 68.5544 81.0907 68.789C81.1945 68.6745 81.2802 69.0334 81.2957 69.2456C81.3233 69.6218 81.2503 69.5699 81.2271 69.6922C81.1854 69.9128 81.2883 70.0951 81.2113 70.2217C81.2053 70.1579 81.195 70.1003 81.1874 70.0389C81.1847 70.1751 81.1825 70.3115 81.1798 70.4471C81.2253 70.4385 81.271 70.4288 81.3161 70.4208C81.345 70.6481 81.2953 70.7473 81.2954 70.9378C81.2955 70.9645 81.3263 70.9358 81.3283 70.963C81.3444 71.1821 81.3311 71.2535 81.4059 71.4106C81.2912 71.4278 81.385 71.7063 81.3478 71.9351C81.3372 71.9992 81.2802 72.0386 81.4063 72.0244C81.4037 72.4543 81.4333 72.7757 81.3579 73.1275C81.4762 72.9922 81.5078 73.4838 81.4906 73.7712C81.4857 73.8479 81.4013 73.9199 81.4262 74.0801C81.4614 74.0345 81.5017 73.9823 81.5381 73.9337C81.57 74.2598 81.449 74.1949 81.4783 74.4711C81.4913 74.5923 81.6174 74.5074 81.5731 74.7418C81.5476 74.876 81.3938 74.9617 81.5904 74.999C81.6113 75.1832 81.5413 75.0724 81.5417 75.202C81.5421 75.2834 81.6195 75.3695 81.6182 75.4949C81.6153 75.7334 81.4976 76.062 81.6404 76.0674C81.6607 76.2346 81.5938 76.1173 81.6107 76.2693C81.6334 76.473 81.7574 76.9754 81.6503 77.0673C81.6505 77.0675 81.6507 77.0678 81.6509 77.068C81.7258 77.2307 81.7354 77.7772 81.6288 77.65C81.6382 77.3597 81.5181 77.1442 81.537 77.4343C81.5561 77.7269 81.5481 77.8044 81.5098 77.8429C81.5386 77.9894 81.5777 78.0631 81.596 78.2689C81.609 78.4151 81.6007 78.6197 81.6128 78.7972C81.631 78.7961 81.6476 78.8036 81.6596 78.845C81.6904 78.9522 81.6575 79.3112 81.6652 79.4291C81.6653 79.4313 81.6656 79.4336 81.6657 79.4358C81.6852 79.4575 81.7136 79.4506 81.7332 79.5715C81.7387 79.6052 81.717 79.6885 81.7063 79.7898C81.7181 79.8755 81.7292 79.9576 81.7347 80.0388C81.7367 80.0694 81.7375 80.1027 81.7376 80.1375C81.7695 80.2945 81.8212 80.5598 81.8288 80.6757C81.8332 80.7442 81.8059 80.8818 81.8057 80.9081C81.8064 80.9997 81.8553 80.954 81.8643 81.033C81.8969 81.3173 81.9205 81.6306 81.9422 81.9425C81.9631 82.243 81.9994 82.539 82.052 82.7981C82.1536 83.2782 82.2275 83.5353 82.3958 84.0036C82.5562 84.4368 82.8028 84.7398 82.412 84.5236C82.5366 84.891 82.5486 84.7214 82.6308 84.7478C82.6799 84.7633 82.6931 84.8683 82.7088 84.884C82.7603 84.9343 82.7158 84.7788 82.7556 84.82C82.9001 84.9919 83.3403 85.854 83.4787 86.0175C84.0563 86.7981 84.6208 87.2996 85.3402 87.8156C85.802 88.1402 86.2618 88.4206 86.7771 88.6427C86.8985 88.785 87.0282 88.9245 87.1654 89.0607C87.0867 89.0258 87.0454 88.9991 86.9579 88.9657C86.8696 88.9331 86.6612 88.8338 86.6134 88.8547C86.6948 88.9347 86.9796 89.0561 87.0671 89.0859C87.2348 89.1449 87.1205 89.0645 87.2341 89.0941C87.3474 89.124 87.5549 89.2431 87.6944 89.2594C88.0173 89.2978 87.3797 89.0942 87.2703 89.0588C87.2884 88.9737 87.5891 89.1765 87.6807 89.128C87.6323 89.0937 87.4491 88.9855 87.3889 88.9811C87.3283 88.9775 87.4408 89.0691 87.2998 89.007C87.1981 88.9223 87.0888 88.829 86.994 88.7398C87.1234 88.7776 87.3311 88.8802 87.4512 88.916C88.4365 89.2163 89.4532 89.3364 90.4743 89.2633C90.8804 89.2347 91.2884 89.2062 91.6995 89.1771C91.8445 89.1668 92.1325 89.1468 92.2748 89.1505C92.3853 89.1536 92.3677 89.2155 92.469 89.1912C92.4791 89.1873 92.4249 89.1528 92.5623 89.1345C92.8227 89.0996 93.4025 89.0557 93.6957 89.0353C96.5687 88.834 99.3834 88.6223 102.299 88.5115C102.451 88.5058 103.024 88.4704 103.131 88.4848C103.449 88.5281 103.397 88.6145 103.568 88.4739C103.736 88.4566 103.622 88.5264 103.701 88.5388C103.733 88.5427 103.924 88.4412 104.009 88.4683C104.2 88.5309 103.884 88.5563 103.773 88.5974C104.056 88.6222 104.336 88.5333 104.575 88.5172C104.642 88.5126 104.656 88.5819 104.671 88.5833C104.954 88.5902 104.918 88.4547 104.901 88.3978C104.759 88.3992 104.619 88.4005 104.477 88.4024C104.752 88.3656 104.959 88.394 105.24 88.3953C105.307 88.3955 105.213 88.338 105.367 88.3528C105.418 88.3939 105.467 88.438 105.517 88.4802C105.873 88.4196 105.998 88.3857 105.547 88.3423C105.725 88.3324 105.904 88.3219 106.082 88.3124C106.021 88.3626 106.118 88.4302 106.291 88.3759C106.331 88.363 106.221 88.3202 106.272 88.3024C106.323 88.2848 106.709 88.2737 106.742 88.2755C107.039 88.2932 107.092 88.3899 107.343 88.3227C107.266 88.3299 106.926 88.2971 107.145 88.2565C107.39 88.2114 108.407 88.2081 108.705 88.2089C109.212 88.2105 109.458 88.2207 109.897 88.2667C109.98 88.2755 109.978 88.3383 110.14 88.3529C110.355 88.3722 110.745 88.3682 110.988 88.3942C110.94 88.4105 110.881 88.4262 110.829 88.4421C110.882 88.452 110.936 88.462 110.99 88.4719C110.984 88.482 110.984 88.4913 110.974 88.5021C110.673 88.5279 110.308 88.6122 110.039 88.6372C109.793 88.6598 109.625 88.6255 109.433 88.6384C109.242 88.6515 108.673 88.7619 108.731 88.6614C108.696 88.6601 108.647 88.6605 108.613 88.658C108.644 88.7564 108.354 88.7045 108.102 88.7394C107.983 88.7559 107.671 88.8672 107.906 88.706C107.864 88.7076 107.844 88.7037 107.807 88.7028C107.543 88.8488 107.362 88.8217 106.946 88.8124C106.713 88.8072 106.255 88.815 106.512 88.8899C106.327 88.9652 105.984 88.8972 105.827 88.9157C105.671 88.9344 105.92 88.9671 105.71 88.9911C105.673 88.9953 105.372 89.0192 105.278 89.0191C105.184 89.0188 105.265 88.9734 105.124 88.9901C104.51 89.0621 103.982 89.1887 103.336 89.2587C103.094 89.285 102.852 89.3103 102.612 89.3348C103.136 89.3553 103.527 89.4546 104.191 89.1609C104.628 89.1218 105.064 89.0827 105.5 89.0436C105.526 89.056 105.553 89.0685 105.579 89.081C105.608 89.0781 105.634 89.0753 105.658 89.0731C105.831 89.0562 106.036 89.0382 106.257 89.0201C106.703 88.9836 107.28 88.9407 107.942 88.8939C109.272 88.7999 111.002 88.6864 112.838 88.572C112.849 88.5713 112.861 88.5706 112.872 88.5698C112.883 88.5693 112.894 88.5687 112.905 88.5681C112.961 88.5653 113.023 88.5624 113.082 88.5602C113.115 88.5589 113.245 88.5537 113.383 88.5549C113.421 88.5552 113.677 88.5565 113.854 88.5927C113.881 88.5982 113.905 88.6045 113.926 88.6114C114.067 88.616 114.208 88.6206 114.349 88.6252C114.348 88.6452 114.347 88.6651 114.347 88.6851C114.461 88.6773 114.575 88.6697 114.688 88.662C114.702 88.6539 114.717 88.6458 114.731 88.6377C115.087 88.6059 115.443 88.574 115.798 88.5422C115.898 88.5507 115.997 88.5592 116.097 88.5677C116.427 88.5464 116.746 88.5261 117.049 88.5076C117.064 88.4833 117.078 88.459 117.093 88.4347C117.255 88.4484 117.417 88.4622 117.579 88.4759C117.893 88.4577 118.183 88.4419 118.441 88.4289C118.433 88.4203 118.425 88.4116 118.417 88.4029C118.735 88.3554 119.053 88.3078 119.371 88.2603C119.503 88.2731 119.635 88.286 119.767 88.2989C119.867 88.2753 119.966 88.2518 120.066 88.2283C120.499 88.1981 120.932 88.1679 121.365 88.1377C121.473 88.1688 121.581 88.1999 121.689 88.231C121.816 88.2179 121.943 88.2047 122.069 88.1916C121.967 88.1745 121.865 88.1574 121.763 88.1403C122.122 88.1116 122.481 88.083 122.84 88.0544C122.848 88.0184 122.855 87.9825 122.863 87.9465C122.758 87.9585 122.656 87.9697 122.565 87.9757C122.487 87.9806 122.505 87.9378 122.489 87.9378C122.177 87.9428 122.154 88.0258 122.146 88.0605C122.305 88.055 122.461 88.0495 122.62 88.0437C122.297 88.0756 122.079 88.0649 121.767 88.0733C121.693 88.0754 121.77 88.108 121.605 88.1038C121.567 88.08 121.533 88.0542 121.498 88.0297C121.073 88.079 120.918 88.1043 121.4 88.1163C121.197 88.1283 120.994 88.1407 120.79 88.1525C120.882 88.1193 120.806 88.0807 120.588 88.1199C120.537 88.1292 120.638 88.1522 120.573 88.165C120.508 88.1776 120.071 88.1974 120.038 88.1973C119.715 88.1961 119.702 88.1381 119.392 88.1879C119.481 88.181 119.842 88.19 119.579 88.2223C119.286 88.2584 118.152 88.2938 117.821 88.3031C117.257 88.3189 116.987 88.321 116.519 88.3069C116.43 88.3042 116.463 88.2649 116.29 88.2612C116.059 88.2563 115.622 88.2717 115.364 88.2636C115.384 88.2597 115.408 88.256 115.431 88.2521C115.678 88.2338 115.914 88.22 116.121 88.2141C116.872 88.0834 117.738 88.0405 118.013 88.0156C118.011 88.0179 118.009 88.0205 118.004 88.0234C118.042 88.023 118.096 88.0211 118.133 88.0216C118.138 87.9958 118.196 87.9857 118.284 87.9797C118.325 87.9786 118.375 87.9773 118.439 87.9758C118.436 87.9748 118.435 87.9736 118.433 87.9726C118.522 87.9693 118.624 87.9653 118.727 87.9556C118.805 87.9602 118.886 87.9625 118.958 87.964C118.953 87.9655 118.948 87.9671 118.943 87.9686C118.991 87.9663 119.011 87.9678 119.052 87.9672C119.053 87.9669 119.055 87.9665 119.056 87.9662C119.062 87.9664 119.069 87.9666 119.075 87.9667C119.093 87.9671 119.113 87.9674 119.133 87.9679C119.242 87.9703 119.371 87.9732 119.491 87.9741C119.62 87.9749 119.744 87.9695 119.928 87.9564C120.006 87.9509 120.1 87.9437 120.217 87.9341C120.044 87.9827 120.346 88.0334 120.852 87.9989C120.922 87.964 120.731 87.9939 120.73 87.9773C120.73 87.9605 120.921 87.9679 120.85 87.9414C120.536 87.9517 120.684 87.9779 120.446 87.9994C120.502 87.9778 120.439 87.9481 120.481 87.9303C120.546 87.9024 120.683 87.9095 120.71 87.8922C120.728 87.8906 120.746 87.8888 120.765 87.8872C120.906 87.8801 121.047 87.8728 121.187 87.8654C121.326 87.8394 121.86 87.8849 122.121 87.9005C122.105 87.9033 122.089 87.906 122.074 87.9087C122.113 87.9071 122.151 87.9055 122.189 87.9039C122.208 87.9047 122.223 87.9054 122.235 87.9055C122.301 87.9056 122.339 87.9142 122.366 87.9207C122.354 87.9247 122.348 87.9287 122.353 87.9325C122.544 87.9232 122.742 87.9132 122.941 87.9033C122.941 87.9079 122.935 87.9127 122.926 87.9177C123.208 87.8993 123.488 87.8798 123.767 87.8594C124.202 87.8274 124.634 87.7928 125.061 87.7554C125.345 87.7305 125.628 87.7054 125.911 87.68C126.043 87.6679 126.173 87.6528 126.303 87.6347C126.313 87.6199 126.335 87.5917 126.341 87.585C126.342 87.5832 126.342 87.5806 126.342 87.5781C126.341 87.5674 126.34 87.5536 126.434 87.5554C126.435 87.5557 126.454 87.5599 126.481 87.5655C126.481 87.5694 126.484 87.5733 126.489 87.5767C126.508 87.5884 126.56 87.6062 126.664 87.6115C126.745 87.6157 126.851 87.6086 126.958 87.5941C127.117 87.5727 127.247 87.5341 127.325 87.5069C127.404 87.4794 127.469 87.4507 127.517 87.4273C127.584 87.3947 127.655 87.3548 127.702 87.3278C127.718 87.3186 127.732 87.3105 127.741 87.3051C127.746 87.3025 127.75 87.3 127.754 87.2975C127.757 87.2959 127.76 87.2943 127.762 87.2927C128.1 87.1798 128.431 87.0443 128.749 86.8889C128.746 86.8889 128.745 86.8886 128.745 86.8882C128.748 86.8852 128.895 86.8048 128.903 86.8005C128.918 86.7936 128.937 86.7882 128.957 86.7836C128.988 86.7672 129.019 86.7506 129.05 86.7339C129.037 86.736 129.027 86.7365 129.024 86.734C129.02 86.7324 129.04 86.7204 129.059 86.7084C129.075 86.6992 129.09 86.6898 129.094 86.6857C129.102 86.6747 129.095 86.6719 129.089 86.6697C129.077 86.6652 129.071 86.663 129.196 86.5998C129.219 86.5885 129.433 86.4869 129.443 86.4816C129.446 86.4805 129.449 86.4793 129.452 86.4782C129.433 86.4722 129.414 86.4662 129.395 86.4601C129.383 86.4588 129.367 86.4603 129.345 86.4681C129.307 86.481 129.26 86.5078 129.214 86.5329C129.134 86.5772 129.058 86.6166 129.051 86.5739C129.161 86.5089 129.247 86.4702 129.331 86.4309C129.43 86.385 129.528 86.3379 129.655 86.2407C129.706 86.2297 129.658 86.2638 129.605 86.2998C129.563 86.3285 129.518 86.3585 129.521 86.3692C129.523 86.3769 129.554 86.3695 129.583 86.3624C129.645 86.3462 129.702 86.3349 129.452 86.4782C129.462 86.4749 129.468 86.4792 129.474 86.4836C129.475 86.4842 129.476 86.4848 129.477 86.4855C129.524 86.4564 129.57 86.4265 129.616 86.3965C129.637 86.3782 129.658 86.3608 129.681 86.3479C129.691 86.3418 129.702 86.3367 129.712 86.3326C129.804 86.2711 129.894 86.2074 129.983 86.1423C129.982 86.1381 129.985 86.1318 129.991 86.124C130.012 86.0944 130.249 85.9165 130.307 85.8774C130.308 85.8775 130.309 85.8776 130.309 85.8777C130.309 85.8777 130.311 85.8819 130.32 85.8805C130.353 85.8541 130.385 85.8274 130.417 85.8004C130.417 85.8004 130.416 85.8005 130.416 85.8006C130.412 85.7982 130.407 85.7954 130.42 85.7836C130.466 85.741 130.511 85.7077 130.552 85.6836C130.586 85.6529 130.621 85.6213 130.656 85.5901C130.596 85.6207 130.497 85.6917 130.408 85.7519C130.314 85.8157 130.232 85.8677 130.228 85.8562C130.227 85.8549 130.234 85.8485 130.243 85.8402C130.274 85.8105 130.329 85.7572 130.191 85.8127C130.472 85.5813 130.408 85.6674 130.382 85.7054C130.376 85.7138 130.373 85.7193 130.375 85.7176C130.467 85.6474 130.522 85.5887 130.578 85.528C130.607 85.4957 130.637 85.4623 130.673 85.426C130.691 85.4065 130.717 85.3844 130.744 85.3613C130.774 85.3349 130.806 85.3068 130.831 85.2782C130.851 85.255 130.899 85.1862 130.943 85.119C130.991 85.0465 131.036 84.975 131.047 84.9659C131.083 84.9693 131.162 84.9106 131.238 84.8515C131.271 84.8257 131.303 84.8002 131.332 84.78C131.356 84.7637 131.388 84.7468 131.415 84.7325C131.425 84.7269 131.436 84.7212 131.446 84.7155C131.454 84.7109 131.46 84.7067 131.463 84.704C131.461 84.7043 131.46 84.7045 131.458 84.7048C131.497 84.6685 131.585 84.5547 131.599 84.5197C131.613 84.4847 131.598 84.4795 131.577 84.4817C131.563 84.4842 131.549 84.4866 131.535 84.489C131.517 84.4905 131.51 84.4841 131.536 84.4487C131.655 84.2828 131.801 84.1881 131.79 84.2561C131.786 84.2719 131.76 84.307 131.732 84.3431C131.699 84.3855 131.663 84.4303 131.66 84.4516C131.69 84.42 131.727 84.3805 131.764 84.3419C131.913 84.1343 132.052 83.9202 132.18 83.7006C132.132 83.723 132.143 83.6714 132.289 83.4458C132.299 83.4514 132.307 83.4563 132.315 83.4595C132.41 83.2835 132.499 83.1033 132.579 82.9216C132.54 82.9868 132.492 83.0585 132.489 82.9968C132.485 82.9427 132.577 82.7558 132.642 82.604C132.672 82.5347 132.697 82.4729 132.71 82.4363C132.723 82.396 132.729 82.3658 132.735 82.3352C132.738 82.3218 132.741 82.3078 132.744 82.2931C132.782 82.1944 132.821 82.0863 132.859 81.9722C132.876 81.9428 132.887 81.9347 132.897 81.9279C132.914 81.9169 132.928 81.9075 132.955 81.8102C132.919 81.8613 132.911 81.8385 132.918 81.7847C132.946 81.6947 132.972 81.6017 132.996 81.5089C133.005 81.4862 133.015 81.4652 133.024 81.4486C133.039 81.4227 133.051 81.413 133.062 81.4039C133.069 81.3981 133.076 81.3924 133.082 81.3835C133.09 81.3478 133.097 81.312 133.104 81.2762C133.088 81.2863 133.067 81.2937 133.05 81.2902C133.06 81.2491 133.07 81.2079 133.078 81.1673C133.094 81.1486 133.113 81.0868 133.13 81.03C133.14 80.995 133.149 80.9614 133.156 80.9429C133.16 80.9343 133.164 80.929 133.167 80.9251C133.179 80.8476 133.19 80.7706 133.2 80.6932C133.232 80.6454 133.27 80.512 133.283 80.3756C133.294 80.2724 133.307 80.1304 133.315 79.9834C133.325 79.9753 133.339 79.948 133.357 79.8382C133.345 79.7991 133.334 79.7573 133.326 79.713C133.33 79.5149 133.326 79.3393 133.323 79.2639C133.321 79.1879 133.314 79.1164 133.308 79.0613C133.301 79.003 133.292 78.9429 133.283 78.8869C133.281 78.8736 133.279 78.8605 133.277 78.8476C133.272 78.8168 133.267 78.787 133.263 78.7583C133.263 78.7578 133.263 78.7573 133.263 78.7568C133.251 78.6812 133.24 78.6108 133.229 78.5391C133.203 78.1079 133.188 77.6693 133.161 77.2203C133.15 77.0263 133.115 76.7699 133.106 76.5463C133.095 76.2674 133.143 76.3188 133.137 76.1472C133.132 75.9753 133.092 76.1431 133.071 75.9624C133.061 75.8798 133.019 75.298 133.03 75.1653C133.032 75.1349 133.056 75.2369 133.069 75.2075C133.077 75.1913 133.138 75.1689 133.123 75.0298C133.059 74.9272 133.003 74.9409 132.968 74.5007C132.913 73.8049 132.892 73.1341 132.844 72.3894C132.833 72.223 132.765 71.8461 132.8 71.6461C132.81 71.5878 132.865 71.5929 132.844 71.3293C132.825 71.1027 132.799 71.0775 132.767 70.887C132.754 70.8146 132.778 70.7824 132.753 70.6461C132.728 70.5091 132.68 70.3183 132.739 70.1985C132.718 70.1882 132.7 70.1922 132.68 70.1869C132.659 69.936 132.701 69.4743 132.646 69.5758C132.628 69.3163 132.609 69.0564 132.591 68.7969C132.609 68.7422 132.627 68.6882 132.646 68.6335C132.677 68.7791 132.666 69.0318 132.709 69.0427C132.697 68.8178 132.684 68.5898 132.672 68.3669C132.567 68.4724 132.464 67.7985 132.588 67.9045C132.612 67.9234 132.562 67.4736 132.547 67.3777C132.533 67.2825 132.488 67.2752 132.501 67.0603C132.509 66.9381 132.53 66.8557 132.48 66.5919C132.48 66.7649 132.478 66.9499 132.476 67.1268C132.463 66.8719 132.425 66.5505 132.433 66.3161C132.435 66.2582 132.466 66.4693 132.468 66.3623C132.47 66.2551 132.435 65.8367 132.399 65.9429C132.468 65.7132 132.402 65.77 132.371 65.3609C132.367 65.3094 132.417 64.8613 132.361 64.6902C132.342 64.63 132.294 64.7782 132.296 64.4427C132.297 64.1959 132.362 64.4216 132.37 64.1445C132.315 64.2953 132.249 63.8967 132.231 63.6546C132.198 63.2254 132.242 63.2722 132.25 63.1271C132.264 62.8651 132.196 62.6724 132.235 62.5126C132.241 62.5853 132.25 62.6501 132.257 62.7197C132.253 62.562 132.248 62.4048 132.243 62.2478C132.217 62.2659 132.191 62.2843 132.165 62.3016C132.138 62.0443 132.163 61.9213 132.154 61.7012C132.153 61.6709 132.136 61.7093 132.134 61.6783C132.115 61.4283 132.119 61.3443 132.069 61.1763C132.134 61.136 132.067 60.8303 132.079 60.5596C132.082 60.4838 132.113 60.4288 132.041 60.4675C132.023 59.9708 131.991 59.6054 132.019 59.1859C131.956 59.3629 131.916 58.8021 131.913 58.4674C131.912 58.3778 131.958 58.2791 131.936 58.0983C131.918 58.1571 131.897 58.2242 131.878 58.2868C131.845 57.9164 131.918 57.9698 131.888 57.6564C131.875 57.5189 131.806 57.6392 131.821 57.3614C131.83 57.2019 131.915 57.0757 131.799 57.0675C131.779 56.8584 131.824 56.9736 131.818 56.824C131.814 56.7302 131.766 56.6446 131.761 56.4997C131.752 56.2239 131.805 55.8229 131.722 55.8421C131.703 55.6533 131.747 55.7774 131.73 55.6053C131.708 55.3744 131.613 54.8165 131.671 54.6914C131.671 54.6912 131.671 54.6909 131.671 54.6907C131.62 54.5165 131.59 53.8865 131.657 54.0142C131.665 54.3512 131.744 54.5785 131.72 54.2468C131.68 53.7032 131.708 53.8023 131.777 53.6702C131.787 53.6508 131.783 53.4961 131.799 53.5269C131.815 53.5575 131.851 53.8877 131.87 53.7C131.874 53.6637 131.839 53.4949 131.869 53.4577C131.86 53.424 131.851 53.4078 131.842 53.3809C131.892 53.0737 131.914 53.0428 131.958 53.6011C131.942 53.5874 131.926 53.5739 131.91 53.5595C131.933 53.6377 131.956 53.7046 131.98 53.7908C132.017 54.4028 132.128 55.2221 132.143 55.7752C132.156 56.2587 132.104 55.5966 132.1 55.5852C132.063 55.4654 132.064 55.6879 132.045 55.6935C132.026 55.6983 131.979 55.4282 132.004 55.6719C132.007 55.7043 132.087 56.0233 132.096 56.034C132.141 56.085 132.154 56.0152 132.171 56.0846C132.101 54.5358 132.049 53.278 131.995 52.0608C131.981 51.7405 131.966 51.4202 131.952 51.0999C131.898 49.9494 131.872 49.0718 131.852 48.3491C131.828 48.1218 131.803 47.8945 131.779 47.6671C131.783 47.5914 131.787 47.5156 131.792 47.4398C131.768 47.0426 131.745 46.6453 131.721 46.248C131.733 46.2299 131.745 46.2118 131.757 46.1938C131.595 45.5363 131.853 45.3268 131.604 44.7653C131.583 44.5234 131.561 44.2816 131.54 44.0398C131.566 43.9841 131.593 43.9283 131.619 43.8726C131.61 43.8508 131.6 43.829 131.591 43.8071C131.589 43.6774 131.588 43.5476 131.586 43.4178C131.586 43.3393 131.584 43.2609 131.581 43.1828C131.546 43.0366 131.506 42.8909 131.463 42.7476C131.558 42.6223 131.163 41.5097 131.287 41.7132C131.241 41.5509 131.19 41.3921 131.134 41.233C131.158 41.2671 131.182 41.3014 131.205 41.336C131.205 41.3084 131.205 41.2808 131.205 41.2532C131.151 41.1392 131.095 41.0276 131.036 40.9169C131.096 40.6984 130.914 40.5445 130.869 40.4701C130.798 40.3466 130.678 40.1145 130.667 40.1011C130.651 40.081 130.728 40.3091 130.618 40.1405C130.589 40.0362 130.558 39.9325 130.524 39.8288C130.507 39.8241 130.491 39.8195 130.474 39.815C130.444 39.7481 130.413 39.6816 130.382 39.6155C130.394 39.6095 130.407 39.6035 130.42 39.5975C130.402 39.5581 130.383 39.5189 130.365 39.4797C130.341 39.4653 130.317 39.4511 130.294 39.437C130.189 39.2836 130.079 39.134 129.964 38.9883C129.9 38.8652 129.832 38.743 129.761 38.6223C129.713 38.5675 129.665 38.5135 129.616 38.4601C129.587 38.4642 129.558 38.4685 129.53 38.4729C129.425 38.3071 129.314 38.1441 129.196 37.9845C129.116 37.9124 129.034 37.8419 128.951 37.7732C128.961 37.7995 128.971 37.8258 128.98 37.8521C129.014 37.873 129.047 37.8942 129.08 37.9157C129.079 37.9287 129.077 37.9417 129.075 37.9547C128.945 37.8497 128.811 37.749 128.675 37.6526C128.632 37.5997 128.587 37.5473 128.542 37.4953C128.496 37.4695 128.449 37.4442 128.402 37.4193C128.224 37.2819 128.041 37.1517 127.853 37.0291C127.819 36.9813 127.784 36.9338 127.749 36.8864C127.691 36.8533 127.633 36.8209 127.575 36.7892C127.613 36.8275 127.651 36.8661 127.688 36.905C127.528 36.8085 127.365 36.7176 127.199 36.6322C127.18 36.6525 127.161 36.6728 127.143 36.6932C127.073 36.65 127.002 36.608 126.931 36.5669C126.933 36.5516 126.936 36.5363 126.938 36.5211C126.646 36.3466 126.343 36.1897 126.028 36.0514C126.006 36.0736 125.984 36.0958 125.962 36.1181C125.54 35.9251 125.065 35.8467 124.661 35.7684C124.491 35.7341 124.274 35.6311 124.298 35.7111C123.964 35.6614 123.628 35.6323 123.29 35.6237C123.191 35.6378 123.096 35.6536 122.999 35.6711C122.924 35.6625 122.849 35.6549 122.774 35.6484C122.696 35.6423 122.619 35.6363 122.542 35.6302C122.312 35.7014 121.11 35.8108 121.139 35.7249C120.872 35.7608 120.892 35.7418 120.569 35.7903C120.491 35.7786 120.412 35.7669 120.334 35.7552C120.197 35.7604 120.06 35.7655 119.923 35.7707C119.743 35.7964 119.562 35.8221 119.381 35.8478C119.258 35.829 119.135 35.8102 119.011 35.7915C119.006 35.8123 119.001 35.8332 118.997 35.854C118.89 35.8672 118.783 35.8803 118.677 35.8935C118.392 36.0132 118.724 35.6983 117.818 35.8742C117.957 35.8675 118.095 35.8608 118.233 35.8542C118.287 35.8762 118.342 35.8983 118.397 35.9204C118.205 35.9423 118.013 35.9641 117.821 35.986C117.685 35.986 117.549 35.9859 117.413 35.9859C117.3 36.0001 117.187 36.0144 117.074 36.0287C116.772 36.0305 116.47 36.0324 116.168 36.0343C115.885 36.0577 115.601 36.0811 115.317 36.1046C115.265 36.0916 115.213 36.0787 115.162 36.0657C115.038 36.0926 114.914 36.1195 114.79 36.1464C114.74 36.1462 114.69 36.146 114.64 36.1458C114.625 36.1327 114.609 36.1196 114.594 36.1064C114.368 36.1281 114.142 36.1498 113.916 36.1715C113.757 36.1684 113.598 36.1654 113.439 36.1624C113.446 36.1744 113.453 36.1865 113.46 36.1985C112.731 36.2409 112.003 36.2834 111.274 36.3258C111.272 36.3257 111.271 36.3257 111.269 36.3256C111.19 36.291 110.813 36.4017 110.852 36.276C110.83 36.2894 110.808 36.3029 110.786 36.3163C110.707 36.3138 110.628 36.3113 110.549 36.3088C110.553 36.2943 110.557 36.2798 110.561 36.2653C110.502 36.2683 110.443 36.2713 110.383 36.2742C110.379 36.2924 110.375 36.3105 110.37 36.3286C110.438 36.3364 110.505 36.3441 110.573 36.3518C110.405 36.3557 110.238 36.3596 110.071 36.3635C110.093 36.3501 110.115 36.3367 110.138 36.3233C109.921 36.3029 109.286 36.485 109.756 36.1744C109.873 36.1791 109.99 36.1838 110.106 36.1886C110.04 36.1672 109.975 36.1458 109.909 36.1245C109.925 36.1028 109.941 36.0812 109.956 36.0596C110.062 36.0668 110.169 36.0739 110.275 36.0811C110.328 36.064 110.381 36.047 110.434 36.0299C110.396 36.0236 110.358 36.0174 110.32 36.0111C110.382 35.9955 110.445 35.9799 110.508 35.9643C110.719 35.9478 110.929 35.9313 111.14 35.9148C111.177 35.9215 111.214 35.9281 111.251 35.9347C111.615 35.9169 111.98 35.8992 112.345 35.8814C112.302 35.8999 112.259 35.9184 112.216 35.9369C112.312 35.9316 112.408 35.9263 112.505 35.921C112.535 35.9047 112.565 35.8884 112.595 35.8721C112.691 35.8623 112.787 35.8525 112.882 35.8427C112.865 35.872 112.848 35.9013 112.831 35.9306C112.739 35.9561 112.648 35.9817 112.556 36.0072C112.633 36.0116 112.71 36.016 112.787 36.0205C112.8 35.9989 112.813 35.9773 112.825 35.9557C112.936 35.9506 113.046 35.9456 113.156 35.9406C113.102 35.9286 113.048 35.9166 112.995 35.9047C113.02 35.886 113.046 35.8673 113.072 35.8486C113.227 35.8318 113.382 35.8149 113.537 35.7981C113.554 35.8096 113.572 35.8212 113.589 35.8328C113.702 35.8111 113.816 35.7894 113.929 35.7677C113.986 35.7728 114.043 35.7779 114.099 35.7831C114.124 35.7736 114.149 35.7642 114.173 35.7548C114.304 35.7483 114.435 35.7419 114.566 35.7354C114.647 35.7443 114.728 35.7532 114.809 35.7621C114.891 35.7449 114.972 35.7277 115.053 35.7106C115.545 35.6941 116.036 35.6777 116.527 35.6612C116.856 35.5677 117.633 35.6326 117.584 35.5636C118.002 35.5409 118.42 35.5182 118.838 35.4956C118.922 35.502 119.006 35.5085 119.09 35.515C119.507 35.4826 119.925 35.4502 120.343 35.4178C120.866 35.4084 121.388 35.399 121.911 35.3896C121.856 35.3675 121.802 35.3454 121.748 35.3233C121.912 35.315 122.076 35.3067 122.24 35.2984C122.34 35.3105 122.44 35.3225 122.539 35.3345C122.61 35.3183 122.681 35.3021 122.752 35.2859C122.773 35.281 122.794 35.2763 122.814 35.2716C122.943 35.393 123.258 35.2276 123.672 35.2888C123.898 35.1876 124.206 35.4015 124.478 35.3244C124.464 35.3346 124.449 35.3449 124.435 35.3553C124.52 35.3677 124.606 35.3816 124.691 35.3966C124.869 35.4115 125.048 35.4322 125.225 35.4585C125.227 35.4759 125.229 35.4933 125.23 35.5108C125.304 35.5309 125.377 35.5521 125.45 35.5742C125.406 35.5771 125.362 35.5802 125.319 35.5838C125.382 35.6039 125.445 35.6248 125.508 35.6464C125.742 35.6916 125.974 35.7471 126.205 35.8123C126.258 35.8455 126.311 35.8793 126.364 35.9135C126.399 35.9138 126.434 35.9143 126.469 35.9151C126.596 35.9769 126.722 36.042 126.845 36.1097C126.841 36.0941 126.837 36.0784 126.833 36.0628C126.775 36.0358 126.717 36.0095 126.659 35.9838C126.667 35.9739 126.675 35.9639 126.683 35.954C126.878 36.0402 127.07 36.1338 127.257 36.2341C127.246 36.2187 127.234 36.2034 127.223 36.1881C127.383 36.2724 127.541 36.362 127.696 36.4561C127.693 36.4535 127.69 36.4503 127.687 36.4476C127.636 36.3952 127.725 36.3498 127.392 36.1706C127.104 36.0218 127.036 36.0295 126.767 35.9363C126.664 35.9023 126.656 35.8572 126.459 35.8008C126.259 35.743 125.963 35.6941 125.883 35.5686C125.844 35.5869 125.829 35.6091 125.798 35.6287C125.462 35.5228 124.905 35.2966 124.976 35.4036C124.619 35.3307 124.255 35.2802 123.891 35.2531C123.835 35.2171 123.778 35.1816 123.72 35.1466C123.947 35.1269 124.278 35.2048 124.335 35.1531C124.019 35.1084 123.696 35.0808 123.38 35.0709C123.416 35.1789 122.962 35.2483 122.749 35.2444C122.65 35.241 122.602 35.2155 122.677 35.1589C122.721 35.125 122.061 35.1877 121.918 35.2063C121.776 35.2249 121.732 35.2917 121.445 35.2665C121.282 35.2523 121.184 35.2192 120.782 35.2855C121.021 35.2904 121.274 35.2983 121.517 35.3048C121.156 35.3172 120.684 35.3652 120.365 35.3486C120.286 35.3444 120.602 35.3035 120.456 35.2979C120.31 35.2923 119.706 35.333 119.825 35.3887C119.56 35.2815 119.587 35.3808 118.998 35.4163C118.923 35.4206 118.342 35.3367 118.064 35.414C117.966 35.4415 118.136 35.5144 117.673 35.5043C117.333 35.4968 117.694 35.4069 117.317 35.3879C117.484 35.4723 116.883 35.5593 116.534 35.5806C115.917 35.6185 116.016 35.5542 115.821 35.539C115.47 35.5117 115.153 35.6068 114.961 35.5459C115.066 35.5383 115.161 35.5272 115.263 35.5184C115.042 35.5213 114.82 35.5247 114.6 35.5276C114.605 35.5661 114.612 35.6047 114.617 35.6429C114.241 35.6763 114.089 35.6377 113.779 35.6451C113.735 35.6461 113.776 35.6713 113.731 35.6741C113.371 35.6962 113.258 35.6877 112.988 35.7576C112.982 35.6602 112.508 35.7512 112.143 35.7279C112.041 35.7213 111.989 35.6743 111.987 35.7814C111.287 35.7957 110.759 35.8332 110.2 35.7821C110.398 35.8781 109.591 35.924 109.126 35.9203C109.002 35.9193 108.901 35.8495 108.635 35.8769C108.703 35.9053 108.779 35.9378 108.851 35.9671C108.314 36.0067 108.443 35.901 107.988 35.9365C107.788 35.9523 107.902 36.0569 107.529 36.028C107.315 36.0114 107.205 35.883 107.106 36.0526C106.802 36.0775 106.997 36.0133 106.785 36.0187C106.652 36.0222 106.497 36.0916 106.293 36.0953C105.905 36.102 105.392 36.0139 105.356 36.1362C105.08 36.1598 105.285 36.0983 105.034 36.1185C104.699 36.1456 103.855 36.271 103.726 36.1828C103.726 36.183 103.726 36.1832 103.726 36.1834C103.447 36.2537 102.553 36.2827 102.781 36.1867C103.252 36.1836 103.626 36.0727 103.15 36.1C102.369 36.1447 102.527 36.1069 102.397 36.0022C102.378 35.9871 102.159 35.9891 102.214 35.9659C102.269 35.9427 102.753 35.8987 102.509 35.8651C102.462 35.8588 102.2 35.906 102.171 35.8609C102.118 35.8743 102.09 35.8863 102.045 35.8992C101.659 35.8179 101.633 35.7849 102.438 35.7342C102.407 35.7575 102.375 35.7809 102.343 35.8042C102.469 35.7711 102.579 35.7396 102.716 35.7057C103.59 35.6669 104.806 35.5239 105.581 35.5156C106.258 35.5083 105.311 35.5684 105.288 35.5735C105.093 35.6256 105.402 35.6293 105.395 35.6578C105.387 35.6862 104.977 35.7485 105.333 35.7176C105.38 35.7133 105.88 35.6045 105.903 35.5916C106.068 35.4887 105.755 35.4966 106.498 35.4299C106.763 35.4061 107.53 35.3537 107.821 35.3325C108.141 35.3093 108.403 35.342 108.594 35.3256C108.784 35.309 108.603 35.289 108.828 35.2707C109.274 35.2347 109.919 35.2277 110.33 35.2024C110.796 35.1737 110.928 35.1187 111.379 35.0913C111.691 35.0723 112.114 35.083 112.465 35.0473C112.549 35.0677 112.396 35.1728 112.63 35.1527C112.915 35.128 112.514 35.0935 112.655 35.0565C112.943 35.0245 112.74 35.0796 112.75 35.0804C112.893 35.0905 113.134 35.0635 113.309 35.0627C113.192 35.05 113.078 35.039 112.954 35.0265C113.434 35.03 113.186 34.9767 113.568 34.9401C113.668 34.9307 113.899 34.9892 114.245 34.9488C114.327 34.9392 115.139 34.8437 115.402 34.8309C115.515 34.8254 115.7 34.8475 115.74 34.8468C115.883 34.8442 115.866 34.8011 115.999 34.7913C116.986 34.7187 118.122 34.6777 119.064 34.6194C119.96 34.5639 120.448 34.5326 121.361 34.477C122.208 34.4255 122.977 34.3084 122.073 34.5841C122.722 34.5761 122.541 34.5229 122.702 34.4601C122.704 34.4594 122.705 34.4588 122.707 34.4582C122.816 34.4198 122.974 34.4433 123.022 34.4367C123.182 34.4134 122.902 34.3951 123.027 34.3775C123.538 34.2573 125.375 34.5579 125.762 34.7148C127.6 35.2452 128.929 36.0678 130.156 37.3315C130.928 38.1493 131.498 39.04 131.948 40.0575C131.981 40.3059 132.005 40.5576 132.019 40.8061C131.972 40.6587 131.953 40.581 131.887 40.4157C131.824 40.25 131.655 39.8569 131.576 39.7753C131.621 39.9302 131.841 40.4527 131.898 40.6166C132.014 40.9288 131.972 40.7191 132.054 40.9349C132.136 41.1519 132.2 41.53 132.278 41.7994C132.46 42.438 132.217 41.2218 132.119 41.0109C132.217 41.0611 132.288 41.6184 132.388 41.8178C132.388 41.7321 132.344 41.3851 132.293 41.2614C132.244 41.1394 132.261 41.3471 132.192 41.0768C132.175 40.8878 132.147 40.678 132.118 40.4892C132.231 40.7481 132.339 41.1613 132.404 41.403C132.58 42.043 132.686 42.6965 132.723 43.3493C132.834 45.305 132.93 47.2322 133.032 49.2082C133.044 49.4466 133.068 49.9182 133.068 50.1363C133.067 50.3058 133.011 50.2089 133.035 50.3943C133.039 50.4161 133.069 50.3663 133.088 50.604C133.125 51.0502 133.177 52.0064 133.202 52.4879C133.41 56.5582 133.625 60.5694 133.784 64.6007C133.791 64.5582 133.798 64.5158 133.804 64.4733C133.833 64.5867 133.861 64.7 133.889 64.8133C133.919 65.1931 133.949 65.5729 133.978 65.9526C133.966 66.0193 133.954 66.086 133.942 66.1526C133.975 66.8104 134.007 67.4682 134.039 68.1259C134.005 68.0486 133.972 67.9714 133.939 67.8941C133.948 68.0677 133.958 68.2413 133.968 68.4149C133.997 68.4695 134.026 68.5241 134.055 68.5787C134.073 68.7508 134.091 68.9229 134.108 69.095C134.056 69.0642 134.003 69.0334 133.95 69.0026C133.92 68.8957 133.891 68.7887 133.861 68.6818C133.861 68.6842 133.86 68.6865 133.86 68.6894C133.856 68.7328 133.953 69.1494 133.93 69.2508C133.926 69.2674 133.922 69.2793 133.919 69.2884C133.923 69.3886 133.928 69.4887 133.932 69.5889C133.954 69.4922 133.975 69.3955 133.997 69.2988C134.031 69.3451 134.064 69.3914 134.098 69.4377C134.128 69.7178 134.158 69.9979 134.189 70.2779C134.168 70.3086 134.147 70.3393 134.127 70.37C134.166 70.5746 134.205 70.7791 134.244 70.9836C134.235 71.0864 134.225 71.1891 134.216 71.2919C134.233 71.3359 134.25 71.3799 134.267 71.424C134.279 71.6601 134.29 71.8963 134.302 72.1324C134.286 72.2788 134.27 72.4253 134.254 72.5717C134.285 72.7184 134.316 72.865 134.347 73.0116C134.377 73.8981 134.406 74.7845 134.436 75.671C134.604 76.2637 134.488 77.6653 134.612 77.5753C134.633 77.9713 134.655 78.3672 134.676 78.7632C134.697 79.1403 134.695 79.5156 134.67 79.8915C134.64 80.0475 134.606 80.2011 134.568 80.3546C134.494 81.1362 134.319 81.91 134.047 82.6502C133.656 83.5536 133.122 84.3874 132.476 85.1127C132.573 85.066 132.669 85.0173 132.766 84.9665C132.575 85.2102 132.372 85.4444 132.159 85.6678C132.007 85.7815 131.853 85.8898 131.697 85.9928C131.59 86.1326 131.478 86.2698 131.361 86.4043C131.036 86.3762 130.727 86.9835 129.99 87.3186C129.721 87.7028 129.021 87.677 128.625 88.026C128.635 88.025 128.645 88.0241 128.655 88.0232C128.645 88.0401 128.642 88.0551 128.63 88.0723C128.55 88.0903 128.461 88.1139 128.376 88.1331C128.424 88.0634 128.501 88.0396 128.617 88.0271C128.631 88.0014 128.645 87.9758 128.659 87.9501C128.503 88.0071 128.344 88.0602 128.185 88.1086C127.866 88.2362 127.537 88.3464 127.204 88.438C127.187 88.4108 127.17 88.3836 127.154 88.3563C127.059 88.3709 126.964 88.3842 126.869 88.3959C126.876 88.4053 126.874 88.416 126.856 88.4267C126.406 88.5112 126.336 88.4129 126.695 88.3664C126.734 88.3609 126.776 88.3629 126.809 88.3695C126.854 88.3475 126.898 88.3251 126.943 88.3023C126.816 88.3157 126.69 88.3262 126.563 88.3343C126.361 88.374 126.161 88.4066 125.956 88.4329C125.752 88.4596 125.547 88.4863 125.343 88.513C125.362 88.5313 125.377 88.5503 125.366 88.57C125.206 88.6001 124.717 88.6347 124.315 88.6599C124.315 88.6608 124.314 88.6617 124.314 88.6625C124.242 88.6661 124.171 88.6696 124.099 88.6731C123.916 88.684 123.777 88.6919 123.74 88.6945C123.667 88.6995 123.611 88.7004 123.569 88.6992C123.439 88.7056 123.309 88.712 123.179 88.7185C123.168 88.7203 123.156 88.722 123.143 88.7235C123.174 88.7356 123.204 88.7477 123.235 88.7597C122.901 88.7763 122.567 88.7928 122.233 88.8093C122.092 88.8421 122.063 88.887 122.286 88.8734C122.864 88.838 122.748 88.8796 122.848 89.0078C122.863 89.0262 123.024 89.0289 122.984 89.0553C122.944 89.0818 122.586 89.1231 122.769 89.1689C122.804 89.1775 122.996 89.1271 123.019 89.1816C123.058 89.1669 123.078 89.1533 123.11 89.139C123.399 89.2452 123.42 89.285 122.824 89.327C122.847 89.2999 122.869 89.2726 122.892 89.2456C122.799 89.2821 122.72 89.3172 122.619 89.3545C121.973 89.3807 121.075 89.5236 120.501 89.5155C119.999 89.5085 120.702 89.4584 120.717 89.453C120.859 89.3953 120.632 89.3838 120.635 89.3501C120.639 89.3163 120.942 89.2512 120.679 89.2797C120.645 89.2836 120.275 89.403 120.26 89.4174C120.141 89.5363 120.372 89.5342 119.824 89.5967C119.628 89.619 119.061 89.6637 118.846 89.6823C118.609 89.7026 118.414 89.6574 118.273 89.6727C118.132 89.688 118.267 89.7161 118.101 89.7327C117.772 89.7655 117.294 89.759 116.99 89.7796C116.645 89.8032 116.549 89.8659 116.216 89.8882C115.985 89.9037 115.672 89.881 115.412 89.9155C115.349 89.8893 115.46 89.7672 115.287 89.7859C115.076 89.8088 115.374 89.8592 115.271 89.9C115.06 89.9315 115.204 89.8715 115.2 89.8694C115.094 89.854 114.916 89.8807 114.786 89.8777C114.872 89.8955 114.957 89.9114 115.05 89.9291C114.694 89.9138 114.879 89.9831 114.598 90.018C114.524 90.027 114.351 89.9518 114.095 89.9921C114.034 90.0018 113.435 90.0968 113.241 90.1061C113.157 90.1099 113.019 90.0793 112.99 90.0792C112.884 90.079 112.898 90.1308 112.8 90.1394C112.07 90.2033 111.229 90.2262 110.532 90.274C109.87 90.3196 109.509 90.3456 108.834 90.3908C108.208 90.4327 107.641 90.5548 108.303 90.2464C107.818 90.2409 107.961 90.3101 107.837 90.3823C107.764 90.4248 107.653 90.397 107.62 90.4059C107.511 90.4363 107.705 90.4539 107.62 90.4766ZM131.794 52.3138C131.865 52.5254 131.873 52.3166 131.849 52.7824C131.761 52.3416 131.766 52.982 131.713 52.9884C131.683 52.9912 131.687 52.7722 131.668 52.708C131.637 52.6094 131.608 52.7596 131.585 52.6413C131.562 52.5233 131.565 52.1028 131.555 51.968C131.536 51.7101 131.503 51.4911 131.487 51.2759C131.472 51.0606 131.475 50.7198 131.469 50.5801C131.463 50.4409 131.448 50.3074 131.443 50.2849C131.416 50.1545 131.379 50.2499 131.366 50.0615C131.406 50.0349 131.454 49.7515 131.497 50.0189C131.495 49.9786 131.5 49.9263 131.496 49.8883C131.479 49.7092 131.429 49.8289 131.414 49.7475C131.388 49.6101 131.438 49.6921 131.441 49.69C131.465 49.5367 131.43 49.6213 131.409 49.5658C131.398 49.5359 131.36 49.2703 131.357 49.2118C131.354 49.1542 131.381 49.2189 131.38 49.1802C131.374 49.0128 131.368 48.8403 131.352 48.6767C131.336 48.5134 131.291 48.4341 131.347 48.4165C131.356 48.4141 131.37 48.5046 131.389 48.4676C131.389 48.4676 131.389 48.4676 131.389 48.4676C131.395 48.4553 131.417 48.3092 131.449 48.4889C131.458 48.5397 131.465 48.5956 131.469 48.6538C131.46 48.6352 131.451 48.6174 131.443 48.5988C131.445 48.644 131.448 48.6892 131.45 48.7343C131.429 48.7159 131.407 48.6962 131.386 48.6852C131.37 48.7512 131.401 48.805 131.402 48.8157C131.404 48.9735 131.363 48.9729 131.417 49.0624C131.418 48.9551 131.419 48.8488 131.42 48.7444C131.43 48.7432 131.441 48.7418 131.451 48.7403C131.452 48.7608 131.453 48.7814 131.454 48.802C131.461 48.7879 131.469 48.7732 131.476 48.7591C131.483 48.9071 131.48 49.0652 131.475 49.2047C131.461 49.1624 131.444 49.1151 131.429 49.0738C131.451 49.2503 131.42 49.1556 131.415 49.2861C131.464 49.3031 131.458 49.3771 131.462 49.4841C131.466 49.5909 131.492 49.4415 131.503 49.5473C131.526 49.7631 131.495 50.1544 131.568 50.1875C131.544 50.4811 131.515 50.141 131.497 50.1276C131.419 50.0712 131.488 50.6371 131.534 50.7113C131.516 50.7991 131.484 50.8107 131.507 51.0233C131.538 51.3118 131.535 50.6664 131.568 51.0611C131.59 51.3252 131.554 51.2992 131.554 51.4335C131.556 51.6831 131.602 52.1117 131.641 51.9425C131.656 51.8744 131.618 51.6965 131.634 51.6182C131.642 51.575 131.748 51.6318 131.656 51.4304C131.646 51.4109 131.618 51.544 131.605 51.3602C131.601 51.3073 131.622 51.1205 131.602 50.9737C131.594 50.9093 131.53 50.6479 131.535 50.4764C131.541 50.2913 131.568 50.562 131.58 50.4896C131.591 50.4161 131.574 50.1928 131.608 50.1896C131.653 50.2972 131.596 50.3317 131.601 50.3705C131.622 50.5197 131.67 50.3759 131.678 50.5992C131.65 50.6429 131.556 50.4724 131.598 50.789C131.6 50.7891 131.614 50.7074 131.627 50.8091C131.651 50.9872 131.682 51.3335 131.696 51.5571C131.74 51.526 131.718 51.2533 131.74 51.1036C131.768 51.4018 131.805 51.7324 131.776 51.9668C131.763 51.8553 131.748 51.7433 131.735 51.6325C131.746 51.7651 131.757 51.898 131.768 52.0299C131.746 51.9871 131.678 51.7047 131.681 51.9204C131.732 51.9198 131.76 52.2129 131.794 52.3138ZM131.642 53.9472C131.594 53.8009 131.588 53.572 131.574 53.3321C131.617 53.3703 131.623 53.7664 131.642 53.9472ZM131.363 47.6522C131.417 47.4685 131.453 48.0949 131.461 48.3485C131.457 48.2902 131.453 48.2308 131.45 48.1725C131.438 48.2037 131.425 48.2326 131.413 48.2638C131.407 48.2002 131.401 48.1367 131.395 48.0731C131.386 48.1539 131.375 48.227 131.365 48.3044C131.294 48.1639 131.331 48.1368 131.324 47.8932C131.319 47.7372 131.294 47.6861 131.28 47.4964C131.211 46.6087 131.12 45.7047 131.067 44.7863C131.118 44.7651 131.132 44.7807 131.15 44.9467C131.135 44.9461 131.119 44.948 131.104 44.948C131.117 45.057 131.131 45.1637 131.145 45.2694C131.146 45.1636 131.148 45.0585 131.151 44.955C131.156 45.0052 131.162 45.0686 131.17 45.1479C131.175 45.2062 131.197 45.2125 131.2 45.2933C131.207 45.4662 131.161 45.7143 131.19 45.895C131.207 45.9996 131.253 45.8296 131.255 46.0957C131.203 45.9589 131.16 45.8661 131.204 46.258C131.224 46.0124 131.223 46.2008 131.247 46.2773C131.263 46.3255 131.235 45.9881 131.274 46.1972C131.282 46.242 131.352 46.9125 131.316 46.8992C131.237 46.8687 131.243 46.8309 131.316 47.2533C131.307 46.686 131.392 47.1732 131.388 47.4287C131.386 47.5588 131.336 47.358 131.363 47.6522ZM131.08 44.3431C131.088 44.515 131.126 44.5458 131.111 44.6817C131.109 44.6934 131.067 44.5942 131.06 44.5127C131.053 44.4306 131.032 43.8971 131.036 43.8783C131.085 43.6976 131.077 44.2829 131.08 44.3431ZM131.048 43.8066C131.039 43.6884 131.03 43.5702 131.021 43.4519C131.015 43.3722 131.008 43.2929 131 43.2141C131 43.2143 131 43.2146 131 43.2148C131.008 43.2189 131.016 43.2238 131.024 43.2285C131.029 43.3024 131.032 43.3766 131.035 43.4511C131.039 43.5696 131.044 43.6882 131.048 43.8066ZM131.776 54.7145C131.722 54.6726 131.729 54.8776 131.735 54.9556C131.758 55.2351 131.726 55.4132 131.784 55.5167C131.803 55.3426 131.76 55.235 131.758 55.152C131.755 54.9705 131.796 54.9531 131.776 54.7145ZM131.834 55.7916C131.828 55.8681 131.8 55.8417 131.8 55.9447C131.799 56.048 131.809 56.3449 131.826 56.4513C131.843 56.5573 131.881 56.5278 131.901 56.6113C131.879 56.3344 131.857 56.0687 131.834 55.7916ZM131.953 57.3753C131.946 57.2172 131.881 57.046 131.915 57.4011C131.916 57.4166 131.959 57.5354 131.944 57.6485C131.934 57.7217 131.917 57.6735 131.907 57.7701C131.896 57.8666 131.984 58.0666 131.953 57.3753ZM132.146 60.93C132.141 60.8557 132.111 60.7747 132.109 60.8122C132.096 61.1066 132.171 61.2751 132.146 60.93ZM131.151 44.955C131.151 44.9522 131.15 44.9494 131.15 44.9467C131.15 44.9467 131.151 44.9466 131.151 44.9466C131.151 44.9493 131.151 44.9523 131.151 44.955ZM132.109 60.2066C132.127 60.3438 132.146 60.4813 132.165 60.6185C132.168 60.5296 132.171 60.4412 132.174 60.3529C132.152 60.3046 132.13 60.2551 132.109 60.2066ZM132.199 59.9528C132.165 59.942 132.137 59.9665 132.128 60.1413C132.162 60.1665 132.18 60.066 132.199 59.9528ZM132.264 62.1801C132.248 62.3839 132.382 62.4757 132.307 62.2002C132.299 62.174 132.266 62.1651 132.264 62.1801ZM131.451 48.7403C131.45 48.7383 131.45 48.7363 131.45 48.7343C131.452 48.7361 131.455 48.7381 131.457 48.7399C131.455 48.7402 131.453 48.74 131.451 48.7403ZM93.3376 89.2456C93.4786 89.2881 93.6173 89.1511 93.5883 89.1444C93.4469 89.113 93.2374 89.2151 93.3376 89.2456ZM132.148 57.9964C132.166 57.5171 132.062 57.4667 132.05 57.4352C131.987 57.2718 132.07 57.1938 132.067 57.1526C132.051 56.957 131.975 57.2219 131.975 57.2495C131.978 57.684 132.043 57.5514 132.068 57.5882C132.123 57.6695 132.103 57.9714 132.148 57.9964ZM131.476 48.7591C131.474 48.7236 131.472 48.6886 131.47 48.6546C131.471 48.6585 131.474 48.6631 131.475 48.667C131.475 48.5996 131.475 48.5322 131.475 48.4647C131.485 48.5442 131.496 48.6234 131.506 48.7022C131.496 48.7214 131.486 48.7399 131.476 48.7591ZM132.637 67.2545C132.682 66.9435 132.544 65.9749 132.564 66.6367C132.567 66.7509 132.584 66.6872 132.589 66.7575C132.589 66.7577 132.589 66.758 132.589 66.7583C132.595 66.8291 132.603 67.4856 132.637 67.2545ZM131.869 54.5247C131.843 54.6183 131.863 54.7594 131.88 54.9295C131.89 54.9086 131.901 54.8873 131.911 54.8665C131.897 54.7529 131.883 54.6382 131.869 54.5247ZM91.1452 89.4018C91.2906 89.3803 91.5548 89.3909 91.5384 89.3233C91.4172 89.3231 91.2956 89.3226 91.1744 89.3224C91.1647 89.3488 91.155 89.3754 91.1452 89.4018ZM89.6884 89.5722C89.8134 89.5537 89.6778 89.5091 89.7259 89.4792C89.7745 89.4514 90.1742 89.4666 89.9016 89.387C89.8181 89.3656 89.3461 89.4106 89.1993 89.3395C89.1109 89.4847 89.3859 89.4038 89.5757 89.4759C89.6332 89.4977 89.4673 89.5638 89.6884 89.5722ZM132.687 68.2316C132.702 68.3677 132.717 68.5051 132.733 68.6411C132.725 68.5062 132.717 68.3704 132.71 68.2355C132.702 68.2344 132.695 68.2327 132.687 68.2316ZM131.352 84.5971C131.364 84.5782 131.377 84.5592 131.389 84.5401C131.435 84.4867 131.478 84.4353 131.518 84.3872C131.542 84.3727 131.566 84.3581 131.59 84.3433C131.512 84.4297 131.433 84.5143 131.352 84.5971ZM132.93 71.0545C132.936 70.8174 132.867 70.5127 132.85 70.6924C132.829 70.9085 132.921 71.44 132.93 71.0545ZM132.792 69.6947C132.811 70.2086 132.913 70.5556 132.846 69.8968C132.842 69.8604 132.8 69.8162 132.792 69.6947ZM130.528 85.422C130.69 85.3417 130.168 85.8454 129.979 85.9428C130.014 85.8872 130.047 85.8314 130.08 85.7754C130.101 85.7589 130.123 85.7392 130.145 85.7188C130.205 85.673 130.307 85.5936 130.429 85.4905C130.479 85.4567 130.525 85.4248 130.53 85.4224C130.529 85.4222 130.529 85.4221 130.528 85.422ZM84.7985 87.5101C85.0408 87.9015 85.2114 87.8508 85.0075 87.6512C84.9826 87.6273 84.8108 87.4837 84.7985 87.5101ZM132.262 59.3645C132.276 59.3477 132.37 59.4982 132.287 59.2264C132.258 59.1327 132.237 59.1571 132.215 58.8796C132.239 59.1362 132.174 59.1114 132.172 59.1404C132.15 59.377 132.24 59.6048 132.269 59.5529C132.277 59.5369 132.248 59.382 132.262 59.3645ZM131.492 47.9518C131.483 47.8133 131.475 47.6741 131.467 47.5357C131.479 47.5483 131.491 47.5595 131.503 47.572C131.499 47.6991 131.497 47.8289 131.492 47.9518ZM86.1421 88.7104C86.1822 88.6832 85.9517 88.3588 85.9174 88.3224C85.6791 88.0937 85.4797 88.0842 85.2615 87.8631C85.2656 88.0089 85.4902 88.0781 85.615 88.2244C85.6541 88.2696 85.4269 88.2397 85.6581 88.4205C85.6583 88.4207 85.6584 88.4209 85.6586 88.421C85.7331 88.4803 86.0396 88.6231 86.1421 88.7104ZM129.735 86.0995C129.823 86.0603 129.709 86.2261 129.508 86.2753C129.501 86.2763 129.502 86.2702 129.502 86.2646C129.503 86.2594 129.504 86.2544 129.498 86.2556C129.48 86.2611 129.408 86.2971 129.322 86.3369C129.149 86.4191 128.917 86.5129 128.989 86.4538C129.097 86.3971 129.205 86.338 129.312 86.2761C129.34 86.2678 129.366 86.2627 129.39 86.258C129.424 86.2516 129.458 86.2449 129.5 86.2283C129.577 86.1977 129.663 86.1443 129.709 86.1151C129.727 86.104 129.738 86.0967 129.741 86.0955C129.739 86.0968 129.737 86.0982 129.735 86.0995ZM82.9098 85.881C82.9177 85.9342 83.0551 86.1475 83.082 86.1532C83.1064 86.1586 83.0981 86.1199 83.0914 86.0852C83.0763 86.0588 83.0613 86.0323 83.0464 86.0057C83.0605 86.0268 83.0749 86.048 83.0891 86.0689C83.0833 86.0332 83.0853 86.0121 83.1408 86.0698C83.2656 86.2594 83.4012 86.4487 83.5431 86.6292C83.5513 86.5874 83.5602 86.5458 83.5694 86.5047C83.5329 86.4775 83.4962 86.4496 83.46 86.4219C83.4398 86.379 83.4201 86.3361 83.4006 86.2932C83.6219 86.2859 83.7143 86.7281 84.017 86.9257C83.9891 86.9517 83.9622 86.9811 83.9335 87.0049C84.3273 87.4778 84.0702 87.1425 84.1079 87.0467C84.1293 86.9918 84.2365 87.1707 84.2684 87.1891C84.4813 87.3127 84.0977 86.8238 83.9759 86.6783C83.8482 86.5374 83.6247 86.3727 83.4946 86.2004C83.4178 86.0982 83.4391 86.0599 83.3651 85.9557C83.2533 85.8 83.0772 85.5091 82.9732 85.3762C82.9351 85.3286 82.9 85.4151 82.9014 85.4346C82.9059 85.4819 82.9805 85.5347 83.0005 85.5802C83.0204 85.6257 82.9776 85.6139 83.0086 85.6705C83.0388 85.7288 83.2375 86.0038 83.2563 86.0179C83.3586 86.1037 83.2731 85.914 83.3702 86.0626C83.2969 86.3955 83.0793 85.817 83.0286 85.7527C82.9008 85.6109 82.9017 85.6486 82.9268 85.7191C82.9837 85.8289 83.042 85.9367 83.0414 85.945C83.0323 86.0253 82.9837 85.9628 82.935 85.8712C82.9193 85.8647 82.9056 85.8603 82.9086 85.8793C82.909 85.8799 82.9094 85.8804 82.9098 85.881ZM81.7036 78.6226C81.6739 78.2203 81.7973 78.4439 81.8031 78.5116C81.8267 78.7953 81.7165 79.0257 81.8694 79.1412C81.8875 79.3137 81.8178 79.1428 81.8178 79.2492C81.8181 79.4602 81.9074 79.68 81.911 79.8998C81.8801 79.9191 81.8489 79.9722 81.8155 79.9607C81.7667 79.7386 81.7111 78.7236 81.7036 78.6226ZM131.997 56.0241C132.022 56.2069 132.048 56.3902 132.073 56.573C132.049 56.3065 132.038 56.2099 132.067 56.0365C132.044 56.0326 132.02 56.028 131.997 56.0241ZM132.703 67.0617C132.706 67.0355 132.666 66.5469 132.641 66.5505C132.638 66.6399 132.677 67.2342 132.703 67.0617ZM81.9024 81.1621C81.8613 80.8032 81.9575 80.7415 81.977 81.0299C81.9824 81.1123 81.9327 81.2116 81.9024 81.1621ZM104.208 88.6997C104.254 88.6981 104.861 88.6579 104.799 88.599C104.472 88.6106 104.122 88.6242 103.787 88.6369C103.808 88.6552 103.903 88.6705 103.951 88.6755C104.069 88.6886 104.04 88.7054 104.208 88.6997ZM81.8166 80.3344C81.8232 80.237 81.8731 80.285 81.8385 80.0952C81.8432 80.0939 81.8479 80.0926 81.8526 80.0913C81.886 80.1043 81.9197 80.2573 81.9227 80.3378C81.9223 80.3409 81.8918 80.3237 81.8921 80.3457C81.8967 80.5078 81.9401 80.7574 81.8576 80.7525C81.8965 80.5974 81.8102 80.4322 81.8166 80.3344ZM132.182 57.3238C132.17 57.1167 132.116 57.0025 132.087 57.0456C132.102 57.1816 132.118 57.3184 132.133 57.4544C132.149 57.411 132.165 57.3673 132.182 57.3238ZM107.736 88.4741C107.674 88.4709 107.612 88.468 107.55 88.4649C107.586 88.4564 107.623 88.448 107.66 88.4395C107.608 88.4358 107.554 88.4322 107.501 88.4285C107.447 88.4637 107.393 88.499 107.338 88.5343C107.47 88.5143 107.603 88.494 107.736 88.4741ZM84.7116 87.9431C84.8085 88.0758 84.849 87.9309 84.7906 87.8662C84.7319 87.8016 84.584 87.7179 84.5657 87.6274C84.67 87.6832 84.7485 87.7956 84.8731 87.8734C85.0203 87.9641 84.9147 87.795 84.8683 87.7806C84.7748 87.7518 84.8187 87.8592 84.6768 87.6794C84.5587 87.5254 84.7885 87.5663 84.6743 87.4567C84.5315 87.3167 84.5397 87.4239 84.5643 87.5075C84.4633 87.4335 84.3649 87.3556 84.2678 87.2762C84.5375 87.5358 84.5163 87.6274 84.4989 87.7635C84.6143 87.8796 84.5484 87.7216 84.6704 87.8379C84.7135 87.8786 84.7038 87.9317 84.7116 87.9431ZM90.646 89.5248C90.9748 89.5026 90.9658 89.4159 90.689 89.4751C90.6301 89.4877 90.6353 89.5061 90.646 89.5248ZM132.1 56.6454C132.106 56.7579 132.112 56.8708 132.118 56.9833C132.126 56.9844 132.134 56.9861 132.142 56.9872C132.136 56.8749 132.129 56.7624 132.123 56.65C132.116 56.649 132.108 56.6465 132.1 56.6454ZM131.967 54.4085C131.983 54.5582 131.975 54.8174 132.012 54.8188C132.009 54.6843 132.006 54.5492 132.002 54.4147C131.991 54.4125 131.979 54.4101 131.967 54.4085ZM132.705 66.6199C132.705 66.6517 132.707 66.6798 132.709 66.7049C132.708 66.6764 132.706 66.6477 132.705 66.6191C132.705 66.6194 132.705 66.6197 132.705 66.6199ZM131.934 53.7989C131.948 53.9124 131.962 54.0273 131.976 54.1407C131.973 54.0288 131.971 53.9164 131.969 53.8051C131.957 53.8028 131.946 53.8012 131.934 53.7989ZM126.522 87.3726C126.484 87.3868 126.322 87.3981 126.174 87.4025C126.076 87.4057 125.983 87.4065 125.932 87.4099C126.116 87.2733 126.551 87.3634 126.522 87.3726ZM106.342 88.7655C107.128 88.7354 106.76 88.517 106.131 88.5628C106.091 88.617 106.246 88.5768 106.259 88.6044C106.271 88.632 106.09 88.6105 106.173 88.6576C106.454 88.6559 106.301 88.6055 106.504 88.5817C106.468 88.6144 106.545 88.6663 106.52 88.6936C106.472 88.7445 106.297 88.7094 106.342 88.7655ZM82.2246 84.1768C82.2244 84.175 82.224 84.1728 82.2238 84.1711C82.2113 84.059 82.3347 83.9972 82.3325 83.9769C82.2954 83.7471 82.1456 83.6669 82.1392 83.8189C82.1363 83.9087 82.2588 84.0157 82.1785 84.0459C82.1401 83.8734 82.1126 83.8154 82.0906 83.8005C82.132 83.9265 82.1769 84.0521 82.2246 84.1768ZM81.7253 78.2566C81.6546 78.2125 81.6704 77.871 81.6507 77.7114C81.7214 77.849 81.7163 78.0472 81.7253 78.2566ZM132.249 58.7529C132.266 59.0153 132.29 58.9544 132.308 58.9963C132.305 58.9355 132.302 58.8748 132.299 58.8149C132.282 58.7942 132.266 58.7734 132.249 58.7529ZM81.2569 71.6008C81.2611 71.6659 81.3077 71.7436 81.3133 71.7114C81.3553 71.4628 81.2377 71.2987 81.2569 71.6008ZM82.5823 84.9327C82.6884 85.0831 82.8245 85.4296 82.8973 85.3549C82.7981 85.0454 82.828 85.1727 82.7186 85.0707C82.6451 85.001 82.6327 84.8291 82.5823 84.9327ZM105.072 88.6515C104.972 88.654 104.871 88.6565 104.771 88.6589C104.808 88.676 104.846 88.6933 104.884 88.7104C104.946 88.6909 105.01 88.6711 105.072 88.6515ZM126.991 87.3618C126.96 87.4289 126.252 87.4813 126.353 87.4411C126.637 87.4164 126.618 87.398 126.597 87.3806C126.587 87.3719 126.576 87.3624 126.595 87.35C126.701 87.286 127.016 87.3135 126.991 87.3618ZM132.196 56.9296C132.193 57.0068 132.189 57.0847 132.186 57.1612C132.199 57.1904 132.211 57.2195 132.224 57.2488C132.221 57.178 132.217 57.1075 132.214 57.038C132.208 57.0019 132.202 56.9657 132.196 56.9296ZM82.0184 83.4501C82.0595 83.1711 82.123 83.1168 82.0321 83.118C82.0339 83.1715 82.0283 83.2016 82.0124 83.1772C82.0086 83.1579 82.0052 83.1387 82.0016 83.1193C81.9868 83.1207 81.9692 83.1221 81.9491 83.1245C81.9699 83.2326 81.9932 83.3425 82.0184 83.4501ZM81.3478 74.6949C81.3493 74.8321 81.449 74.9953 81.4157 74.6825C81.4138 74.6683 81.3497 74.5561 81.3814 74.4634C81.4037 74.403 81.4293 74.4484 81.4544 74.3684C81.4793 74.2886 81.3419 74.0949 81.3478 74.6949ZM81.3858 75.3624C81.4048 75.6052 81.4251 75.8388 81.446 76.0822C81.4605 76.0183 81.5074 76.0481 81.5148 75.9602C81.5222 75.8717 81.5251 75.6145 81.5033 75.5192C81.4814 75.4244 81.4154 75.4392 81.3858 75.3624ZM124.13 87.8099C124.014 87.8233 123.755 87.8529 123.808 87.8219C123.831 87.8099 123.9 87.8079 123.96 87.8063C124.032 87.8043 124.094 87.8026 124.061 87.7847C123.817 87.758 123.608 87.7793 123.323 87.8087C123.315 87.8096 123.306 87.8105 123.298 87.8114C123.295 87.8122 123.305 87.8147 123.319 87.8182C123.356 87.8273 123.423 87.8438 123.383 87.8593C123.365 87.8582 123.348 87.8573 123.334 87.8569C123.208 87.8527 123.249 87.8414 123.058 87.8506C123.046 87.8512 123.002 87.854 122.941 87.8583C122.921 87.8555 122.898 87.8534 122.871 87.8527C122.83 87.8516 122.778 87.8533 122.723 87.8552C122.635 87.8582 122.54 87.8615 122.477 87.8532C122.516 87.8291 122.7 87.8319 122.851 87.8344C122.945 87.8359 123.025 87.8373 123.05 87.8318C123.056 87.8306 123.068 87.8217 123.082 87.8104C123.105 87.7923 123.135 87.768 123.164 87.7592C123.147 87.7587 123.111 87.7624 123.071 87.7666C122.992 87.7751 122.897 87.7852 122.909 87.7656C122.91 87.7648 122.91 87.7639 122.911 87.7631C122.912 87.7621 122.912 87.7611 122.912 87.7601C122.913 87.76 122.913 87.7599 122.913 87.7598C122.931 87.7293 122.961 87.6793 123.139 87.6672C123.154 87.6659 123.166 87.669 123.179 87.6726C123.194 87.6768 123.212 87.6815 123.241 87.6807C123.284 87.6791 123.331 87.6744 123.379 87.6696C123.441 87.6633 123.505 87.6567 123.559 87.6572C123.575 87.6572 123.593 87.661 123.612 87.6651C123.637 87.6704 123.664 87.6761 123.694 87.6753C123.717 87.6745 123.751 87.6674 123.793 87.6587C123.866 87.6433 123.964 87.6231 124.061 87.6244C124.127 87.6249 124.246 87.6736 124.12 87.6916C124.043 87.7027 124.026 87.6959 124.011 87.69C124.003 87.6869 123.994 87.6841 123.979 87.6843C123.943 87.6851 123.9 87.6891 123.859 87.6932C123.762 87.7028 123.668 87.7122 123.667 87.6762C123.571 87.6814 123.582 87.7201 123.61 87.7267C123.684 87.747 124.514 87.7353 124.591 87.7142C124.593 87.7134 124.588 87.7121 124.582 87.7102C124.556 87.7026 124.496 87.6843 124.654 87.6398C124.776 87.6061 124.927 87.5992 124.997 87.596C125.018 87.5951 125.031 87.5944 125.035 87.5935C125.039 87.5922 125.029 87.5868 125.015 87.5795C124.958 87.55 124.837 87.4877 125.304 87.5182C125.36 87.5101 125.349 87.5004 125.34 87.4922C125.333 87.4864 125.328 87.4812 125.346 87.4778C125.399 87.4677 125.62 87.4463 125.646 87.4483C125.659 87.4581 125.672 87.4679 125.685 87.4777C125.681 87.4787 125.657 87.4811 125.623 87.4847C125.511 87.4965 125.284 87.5205 125.296 87.5409C125.565 87.5097 125.668 87.5159 125.882 87.529C125.887 87.5292 125.894 87.5299 125.902 87.5308C125.909 87.5318 125.918 87.5332 125.927 87.5347C125.987 87.544 126.076 87.5563 126.115 87.5169C126.124 87.5084 126.085 87.5082 126.043 87.5077C125.986 87.5072 125.923 87.5056 125.954 87.4861C126.091 87.4774 126.164 87.4582 126.25 87.435C126.256 87.4336 126.261 87.4321 126.266 87.4306C126.301 87.4366 126.27 87.4482 126.243 87.4581C126.224 87.4648 126.206 87.471 126.214 87.4742C126.218 87.4775 126.417 87.4899 126.428 87.4894C126.465 87.4875 126.553 87.476 126.64 87.4627C126.699 87.4537 126.758 87.4439 126.801 87.4373C126.846 87.43 126.905 87.4242 126.952 87.4189C126.988 87.4148 127.018 87.4112 127.032 87.4082C127.059 87.402 127.087 87.3916 127.115 87.3808C127.15 87.3676 127.187 87.3533 127.227 87.3449C127.247 87.3408 127.272 87.3394 127.299 87.3382C127.284 87.346 127.268 87.3543 127.25 87.363C127.225 87.3755 127.202 87.3872 127.179 87.3984C127.139 87.4186 127.1 87.4376 127.053 87.4576C127.044 87.4554 127.032 87.4539 127.019 87.453C126.975 87.4313 126.799 87.463 126.538 87.5065C126.476 87.5165 126.471 87.5243 126.467 87.5312C126.464 87.5356 126.462 87.5397 126.445 87.5434C126.35 87.5625 126.229 87.5784 126.105 87.5915C126.039 87.5984 125.971 87.6047 125.906 87.6107C125.828 87.6179 125.754 87.6257 125.689 87.6348C125.694 87.648 125.763 87.6403 125.818 87.6342C125.845 87.6312 125.869 87.6287 125.88 87.6293C125.893 87.6303 125.907 87.6387 125.909 87.6489C125.909 87.6495 125.909 87.6502 125.909 87.6508C125.909 87.6628 125.891 87.6767 125.838 87.6842C125.645 87.7101 125.58 87.6922 125.519 87.6752C125.489 87.6668 125.46 87.6587 125.416 87.656C125.132 87.6399 124.744 87.6883 124.948 87.7375C124.708 87.7288 124.702 87.7356 124.693 87.7463C124.689 87.751 124.684 87.7563 124.66 87.7614C124.463 87.8045 124.417 87.8038 124.338 87.8022C124.3 87.8015 124.254 87.8005 124.18 87.8043C124.172 87.8049 124.154 87.8071 124.13 87.8099ZM81.472 77.0184C81.5626 77.0688 81.5638 76.8911 81.5584 76.8229C81.539 76.5779 81.6055 76.4342 81.5129 76.3303C81.4691 76.4742 81.5342 76.5771 81.5318 76.6486C81.5256 76.8052 81.4538 76.809 81.472 77.0184ZM81.921 82.5539C81.933 82.5801 81.9307 82.6841 81.9594 82.8546C81.9545 82.8183 81.9499 82.7815 81.9455 82.7456C81.9659 82.7663 81.9825 82.8109 81.9959 82.8638C81.9681 82.6976 81.9503 82.5926 81.9288 82.5577C81.9262 82.5566 81.9236 82.5552 81.921 82.5539C81.9183 82.5481 81.9148 82.5436 81.9103 82.5462C81.9103 82.5467 81.9102 82.5472 81.9102 82.5476C81.9138 82.5501 81.9175 82.5521 81.921 82.5539ZM108.385 88.5644C108.346 88.5441 108.306 88.5236 108.267 88.5033C108.231 88.5374 108.196 88.5717 108.161 88.6058C108.235 88.5921 108.31 88.5781 108.385 88.5644ZM127.47 87.2361C127.402 87.2471 127.331 87.2537 127.336 87.241C127.429 87.2233 127.504 87.1948 127.571 87.1643C127.57 87.1649 127.569 87.1656 127.569 87.1662C127.568 87.1669 127.567 87.1675 127.566 87.1682C127.565 87.1689 127.564 87.1696 127.563 87.1703C127.536 87.1908 127.503 87.2143 127.47 87.2361ZM128.144 87.056C128.117 87.0661 128.093 87.0727 128.071 87.0771C128.08 87.07 128.088 87.063 128.096 87.0564C128.129 87.0273 128.147 87.0057 128.161 86.9859C128.22 86.9652 128.279 86.9441 128.309 86.9344C128.336 86.9515 128.302 86.9985 128.144 87.056ZM82.6844 39.6906C82.7068 39.7005 82.7294 39.7104 82.7517 39.7205C82.7392 39.7075 82.734 39.6804 82.7273 39.6549C82.713 39.6668 82.6987 39.6787 82.6844 39.6906ZM80.5969 62.726C80.5714 62.9275 80.6682 63.2065 80.7098 63.0575C80.7594 62.878 80.6385 62.399 80.5969 62.726ZM91.5024 89.5393C91.6757 89.6012 92.1506 89.5893 91.7996 89.5346C91.7106 89.5208 91.5964 89.5366 91.5024 89.5393ZM81.2728 72.2303C81.2497 72.1078 81.2266 71.984 81.2035 71.8615C81.1925 71.9368 81.1817 72.013 81.1706 72.0877C81.2047 72.1349 81.2389 72.1832 81.2728 72.2303ZM80.8435 66.0569C80.7454 66.3113 80.9161 67.1766 80.9267 66.6046C80.9283 66.5067 80.8955 66.5562 80.891 66.495C80.891 66.4948 80.8911 66.4945 80.8912 66.4943C80.887 66.4321 80.9168 65.8682 80.8435 66.0569ZM81.1394 70.4994C81.1811 70.3294 80.9574 70.2156 81.0681 70.4712C81.0789 70.4955 81.1358 70.5117 81.1394 70.4994ZM80.7428 63.9299C80.7447 63.4833 80.593 63.1574 80.6632 63.7406C80.6676 63.773 80.7384 63.8221 80.7428 63.9299ZM80.8231 65.2072C80.8064 65.0867 80.7897 64.9652 80.7729 64.8447C80.7765 64.9622 80.7803 65.0808 80.7838 65.1982C80.7969 65.2012 80.81 65.2042 80.8231 65.2072ZM127.167 87.3282C127.238 87.3084 127.333 87.2857 127.424 87.2662C127.414 87.2726 127.404 87.2787 127.395 87.2842C127.383 87.2916 127.37 87.2992 127.357 87.3068C127.294 87.3147 127.23 87.3218 127.167 87.3282ZM81.8165 81.8566C81.8182 81.8535 81.8193 81.8485 81.8191 81.8406C81.8191 81.8391 81.8187 81.8372 81.8185 81.8354C81.8178 81.8423 81.8172 81.8499 81.8165 81.8566ZM81.7781 82.0282C81.7937 82.0792 81.7988 82.037 81.8077 81.9506C81.8103 81.923 81.8131 81.8912 81.8165 81.8566C81.8075 81.8729 81.7779 81.8337 81.7779 81.862C81.7779 81.8919 81.7777 81.9221 81.7777 81.9524C81.7776 81.9777 81.7777 82.003 81.7781 82.0282ZM81.6684 81.2003C81.6716 81.2434 81.6752 81.2859 81.6797 81.3235C81.7109 81.3349 81.746 81.3254 81.7579 81.3671C81.7623 81.3829 81.765 81.3954 81.7662 81.4051C81.7754 81.3469 81.7779 81.2629 81.7727 81.1782C81.7361 81.2132 81.6992 81.2416 81.6684 81.2003ZM81.102 72.4233C81.1593 72.4415 81.2085 72.4275 81.2352 72.2802C81.1784 72.2496 81.1409 72.3312 81.102 72.4233ZM81.7109 81.4605C81.733 81.4969 81.7499 81.4788 81.761 81.4318C81.7468 81.4429 81.7105 81.4077 81.7083 81.4093C81.7049 81.4176 81.7019 81.4258 81.6995 81.4325C81.7029 81.444 81.7068 81.4537 81.7109 81.4605ZM81.6209 80.2956C81.6262 80.34 81.6363 80.3767 81.6513 80.3859C81.6794 80.4025 81.6855 80.3202 81.6831 80.2397C81.6627 80.1033 81.6412 80.2376 81.6209 80.2956ZM81.6443 80.8861C81.649 80.921 81.6529 80.9704 81.6566 81.0251C81.6941 81.0329 81.7092 80.9814 81.71 80.9079C81.6922 80.8835 81.6703 80.8737 81.6443 80.8861ZM101.029 36.5274C101.182 36.5225 101.457 36.4608 101.523 36.4955C101.364 36.5181 101.623 36.5744 101.779 36.5445C101.926 36.5192 101.902 36.5028 101.78 36.4883C102.291 36.4586 102.88 36.3927 103.286 36.41C103.208 36.4222 103.195 36.4392 103.182 36.4572C103.182 36.4575 103.182 36.4578 103.182 36.4581C103.344 36.4501 103.434 36.4733 103.625 36.4508C103.595 36.428 103.533 36.4183 103.47 36.4097C103.882 36.3966 104.455 36.3113 104.743 36.3547C104.425 36.3725 104.187 36.3818 104.271 36.4592C104.404 36.4462 104.534 36.4321 104.664 36.4194C104.87 36.4568 104.473 36.5151 104.71 36.5083C104.933 36.4726 104.985 36.5133 105.204 36.4772C105.212 36.4204 105.151 36.3733 104.95 36.315C105.679 36.2586 106.418 36.1983 107.132 36.1488C106.901 36.204 106.627 36.1988 106.506 36.2122C106.398 36.2245 106.417 36.2535 106.323 36.2681C106.338 36.2649 106.037 36.2551 106.09 36.2918C106.193 36.3004 106.297 36.3089 106.402 36.3165C106.718 36.3051 106.562 36.2542 106.819 36.2369C106.953 36.2659 107.633 36.2414 107.443 36.1736C107.3 36.1845 107.078 36.2302 107.081 36.1732C107.324 36.144 107.454 36.1678 107.728 36.1255C107.851 36.1477 107.581 36.203 107.831 36.1903C107.934 36.1794 107.859 36.1543 107.938 36.1418C108.144 36.2329 108.636 36.1927 109.075 36.1762C108.849 36.2248 108.594 36.3283 108.295 36.3124C108.367 36.3419 108.241 36.3552 108.215 36.3772C107.984 36.3702 107.403 36.4572 107.541 36.4088C107.589 36.3924 107.8 36.3926 107.75 36.3687C107.47 36.3503 107.004 36.4954 107.54 36.4656C107.41 36.4783 107.282 36.4924 107.152 36.5051C106.968 36.4437 107.274 36.4199 107.209 36.3679C107.096 36.3579 106.841 36.3992 106.766 36.4323C107.165 36.4027 106.803 36.4395 107.023 36.4811C106.617 36.4888 106.43 36.5693 106.062 36.5602C106.305 36.5333 106.461 36.462 106.612 36.3913C106.42 36.3867 106.069 36.4637 106.089 36.52C105.899 36.5332 105.702 36.5199 105.726 36.5759C105.83 36.5751 105.928 36.5756 106.01 36.5847C105.316 36.6953 104.534 36.7187 103.435 36.847C103.275 36.8463 103.146 36.831 102.969 36.8382C102.738 36.8957 102.355 36.877 102.218 36.8772C102.079 36.8767 101.87 36.9017 101.802 36.9006C101.379 36.8912 101.154 36.8027 100.846 36.7533C100.844 36.7532 100.842 36.7532 100.84 36.7532C101.003 36.6866 100.903 36.5974 101.029 36.5274ZM81.629 79.7333C81.626 79.5695 81.4776 79.2026 81.5664 79.6329C81.5496 79.6474 81.533 79.6621 81.5163 79.6767C81.516 79.6791 81.5156 79.682 81.5151 79.6843C81.553 79.7005 81.5911 79.7165 81.629 79.7333ZM81.6007 79.4919C81.6 79.4894 81.5994 79.4869 81.5987 79.4844C81.5988 79.4902 81.599 79.4969 81.5989 79.5025C81.5995 79.4993 81.6001 79.4951 81.6007 79.4919ZM81.4127 77.9062C81.4106 78.0109 81.3998 78.1324 81.4327 78.2221C81.4594 78.1742 81.4864 78.1247 81.5133 78.0761C81.4857 78.017 81.467 77.9525 81.4544 77.881C81.4419 77.8879 81.4279 77.8957 81.4127 77.9062ZM133.569 80.8831C133.503 81.0256 133.376 81.5059 133.498 81.187C133.529 81.1056 133.549 80.9804 133.569 80.8831ZM81.2042 74.9135C81.2495 74.8874 81.3018 74.8103 81.3027 74.7966C81.3231 74.4783 81.2387 74.5022 81.1884 74.4924C81.1929 74.5434 81.1968 74.5937 81.1996 74.6427C81.2004 74.6439 81.2012 74.6451 81.2021 74.6463C81.2284 74.7022 81.2213 74.7403 81.2044 74.77C81.2049 74.7942 81.2055 74.819 81.2053 74.8425C81.2052 74.8702 81.2047 74.8936 81.2042 74.9135ZM82.1842 84.2491C82.207 84.305 82.2293 84.3621 82.2499 84.4163C82.2645 84.4018 82.2485 84.3438 82.1843 84.202C82.1845 84.2209 82.1844 84.2362 82.1842 84.2491ZM83.7732 86.9562C83.7606 86.927 83.7485 86.8979 83.7362 86.8686C83.6877 86.8608 83.6389 86.8527 83.5899 86.8435C83.6132 86.8718 83.6379 86.9013 83.6615 86.9295C83.6986 86.9386 83.7362 86.9478 83.7732 86.9562ZM81.8376 82.9071C81.8442 82.9766 81.861 83.0215 81.88 83.072C81.8654 83.0004 81.8496 82.9265 81.8348 82.8603C81.8352 82.8747 81.8361 82.8903 81.8376 82.9071ZM118.613 88.0392C118.524 88.0501 118.433 88.0611 118.344 88.072C118.378 88.0834 118.413 88.0948 118.447 88.1061C118.502 88.0838 118.558 88.0614 118.613 88.0392ZM80.7176 66.2042C80.7102 66.2241 80.7465 66.6552 80.7894 66.659C80.799 66.5835 80.7739 66.0636 80.7176 66.2042ZM80.3254 61.8665C80.3625 61.8345 80.4762 61.8296 80.4854 61.7254C80.4996 61.5596 80.4398 61.4029 80.3905 61.4993C80.3757 61.528 80.3637 61.8461 80.3254 61.8665ZM83.3254 86.4265C83.3113 86.4244 83.2619 86.356 83.2485 86.3477C83.2655 86.375 83.2828 86.4024 83.3001 86.4294C83.3085 86.4284 83.3172 86.4276 83.3254 86.4265ZM133.512 75.2744C133.517 75.3542 133.521 75.4301 133.525 75.5024C133.524 75.4709 133.523 75.4363 133.52 75.394C133.517 75.3632 133.515 75.3209 133.512 75.2744ZM133.63 75.943C133.617 75.9181 133.601 76.0104 133.597 75.8461C133.602 75.8135 133.606 75.7795 133.61 75.7457C133.599 75.6422 133.586 75.5339 133.576 75.4276C133.562 75.5008 133.548 75.5741 133.534 75.6476C133.556 76.0183 133.573 76.2816 133.587 76.4727C133.597 76.3885 133.572 75.9187 133.56 75.8106C133.613 75.8311 133.582 76.2331 133.631 76.353C133.636 76.3173 133.641 76.2225 133.643 76.1326C133.641 76.0958 133.639 76.0588 133.636 76.022C133.635 75.9965 133.633 75.9699 133.63 75.943ZM133.482 73.9872C133.463 73.7822 133.444 73.5743 133.427 73.3638C133.428 73.4069 133.427 73.4494 133.424 73.4879C133.422 73.5023 133.417 73.497 133.41 73.4864C133.412 73.5271 133.415 73.5678 133.417 73.6076C133.428 73.799 133.438 73.9791 133.447 74.1487C133.461 74.0941 133.474 74.0345 133.482 73.9872ZM126.032 36.0474C126.083 36.0565 126.134 36.0661 126.185 36.0762C126.143 36.0577 126.101 36.0396 126.058 36.0218C126.049 36.0303 126.041 36.0389 126.032 36.0474ZM133.726 80.0079C133.696 80.3617 133.741 80.4003 133.748 80.0788C133.749 80.0108 133.738 80.0066 133.726 80.0079ZM133.318 71.8059C133.318 71.8059 133.318 71.8059 133.318 71.8059C133.322 71.8856 133.326 71.9649 133.331 72.043C133.331 72.0435 133.332 72.0439 133.333 72.0443C133.328 71.9651 133.323 71.8854 133.318 71.8059ZM80.2024 58.5658C80.1792 58.7024 80.2264 58.9079 80.2591 58.8033C80.2916 58.6983 80.2314 58.3968 80.2024 58.5658ZM82.0528 84.6593C82.0908 84.6992 82.2209 84.7949 82.249 84.7732C82.2933 84.7383 82.2682 84.5679 82.199 84.4631C82.1816 84.4644 82.1637 84.4572 82.146 84.4162C82.1096 84.4153 82.0698 84.4613 82.0391 84.2628C82.0376 84.2525 82.0391 84.2255 82.0413 84.1923C81.997 84.0904 81.9292 83.9079 81.907 83.7979C81.882 83.7832 81.8583 83.777 81.8394 83.8061C81.8076 83.8553 81.9031 84.0877 81.9296 84.1915C81.9402 84.2358 81.9143 84.272 81.916 84.2807C81.9397 84.3855 81.9869 84.4063 82.0251 84.4966C82.0429 84.5385 82.015 84.6196 82.0528 84.6593ZM119.496 88.0562C119.339 88.073 119.181 88.0899 119.024 88.1067C119.092 88.1066 119.159 88.1065 119.227 88.1064C119.182 88.1129 119.137 88.1192 119.093 88.1257C119.149 88.1263 119.207 88.1269 119.263 88.1274C119.341 88.1038 119.418 88.0799 119.496 88.0562ZM80.5658 64.534C80.5609 64.5817 80.5561 64.6301 80.5511 64.6784C80.5705 64.6734 80.59 64.6678 80.6093 64.6628C80.5835 64.5696 80.5576 64.4762 80.5318 64.3836C80.5232 64.4196 80.5145 64.4571 80.5059 64.4931C80.5258 64.507 80.546 64.5201 80.5658 64.534ZM81.0342 73.1327C81.0347 73.1409 81.0354 73.1492 81.0359 73.1575C81.0608 73.1355 81.0898 73.1388 81.0933 73.1269C81.1398 72.9555 81.0409 72.7678 80.9794 72.7464C80.9884 72.8029 80.9974 72.8783 81.0064 72.975C80.9806 72.9735 80.9544 72.9712 80.9286 72.9692C80.964 73.0245 80.9981 73.0704 81.0342 73.1327ZM80.3682 66.0206C80.3882 66.3026 80.4091 66.5823 80.4308 66.8595C80.5164 66.8311 80.5597 67.0675 80.6336 67.0376C80.6763 67.0199 80.6405 66.7491 80.6451 66.6435C80.6472 66.5986 80.6837 66.5905 80.6847 66.5822C80.6925 66.4787 80.6527 66.4224 80.6443 66.3189C80.6406 66.271 80.6946 66.2324 80.6715 66.17C80.6481 66.1074 80.5566 65.9214 80.5218 65.9132C80.4595 65.899 80.421 66.0983 80.4795 66.2525C80.508 66.3278 80.5947 66.2657 80.5578 66.4955C80.5526 66.5264 80.4678 66.6581 80.4802 66.7697C80.4164 66.6354 80.3911 66.1849 80.3958 65.9941C80.3828 65.9914 80.3741 66.0017 80.3682 66.0206ZM84.5878 88.1085C84.7082 88.2337 84.841 88.2676 84.7791 88.1527C84.7594 88.119 84.5298 87.8979 84.5276 87.8427C84.5398 87.9034 84.5123 88.0292 84.5878 88.1085ZM81.1393 74.8555C81.1429 74.9015 81.1562 74.9197 81.1738 74.9221C81.1692 74.892 81.1646 74.857 81.1605 74.824C81.1481 74.8362 81.1388 74.8462 81.1393 74.8555ZM87.034 89.4018C87.133 89.4795 87.4018 89.5205 87.2431 89.4281C87.1164 89.354 86.9367 89.3253 87.034 89.4018ZM81.5247 81.2226C81.5034 81.4155 81.4723 81.4408 81.5059 81.6526C81.5293 81.54 81.5799 81.3141 81.5247 81.2226ZM123.359 87.9212C123.41 87.9142 123.46 87.9069 123.496 87.8996C123.423 87.8982 123.347 87.9008 123.27 87.9058C123.298 87.9057 123.325 87.9055 123.352 87.9054C123.354 87.9107 123.357 87.9159 123.359 87.9212ZM81.2476 78.0506C81.2926 78.0488 81.3762 78.071 81.2734 77.9116C81.2625 77.8947 81.2519 77.8854 81.242 77.8757C81.2429 77.9143 81.266 78.0067 81.2476 78.0506ZM80.9772 73.1671C80.9874 73.2041 80.9962 73.2553 81.0028 73.3377C80.9947 73.2625 81.0014 73.2168 81.014 73.1883C81.0142 73.177 81.0145 73.1655 81.0147 73.1543C81.0022 73.1582 80.9897 73.163 80.9772 73.1671ZM82.8947 86.1337C82.8813 86.095 82.8676 86.0553 82.8549 86.0166C82.8366 86.0234 82.818 86.0304 82.7997 86.0372C82.7789 85.9916 82.7584 85.9458 82.7383 85.8995C82.7383 85.8996 82.7382 85.8996 82.7381 85.8997C82.729 85.9221 82.7201 85.9449 82.7112 85.9674C82.7717 86.0241 82.8332 86.0797 82.8947 86.1337ZM125.41 87.8882C125.306 87.8935 125.202 87.899 125.097 87.9042C124.924 87.9129 124.27 87.9536 124.158 87.9482C123.825 87.9318 123.922 87.8765 123.667 87.9693C123.471 87.9857 123.632 87.9385 123.549 87.9335C123.532 87.9327 123.457 87.9501 123.376 87.9656C123.379 87.9715 123.381 87.9774 123.384 87.9832C124.042 87.9912 124.7 87.9991 125.359 88.0071C125.376 87.9675 125.393 87.9278 125.41 87.8882ZM80.9778 74.8207C81.0082 74.9136 81.0614 74.9619 81.0976 74.9411C81.0898 74.8854 81.0819 74.8298 81.074 74.7741C81.0661 74.8031 81.0582 74.83 81.0478 74.8361C81.0171 74.8538 80.9567 74.6544 80.9778 74.8207ZM131.784 42.7479C131.771 42.6394 131.749 42.516 131.723 42.3865C131.717 42.4038 131.711 42.4211 131.706 42.4384C131.719 42.4954 131.732 42.5525 131.744 42.6093C131.728 42.6103 131.712 42.6112 131.697 42.6122C131.703 42.6919 131.708 42.7718 131.713 42.8519C131.746 42.9233 131.778 42.9954 131.809 43.0677C131.809 43.0387 131.808 43.0098 131.808 42.9809C131.801 42.9036 131.793 42.8255 131.784 42.7479ZM81.138 75.8296C81.1354 75.7729 81.1329 75.7161 81.1303 75.6595C81.1219 75.6624 81.1133 75.6651 81.105 75.6678C81.1027 75.6866 81.0992 75.7049 81.0945 75.7235C81.096 75.7556 81.0975 75.7878 81.099 75.8199C81.1119 75.8231 81.125 75.8264 81.138 75.8296ZM80.1231 62.0486C80.1542 61.9444 80.2161 61.9373 80.2866 61.9224C80.2919 61.7569 80.2194 61.8792 80.2219 61.7058C80.2228 61.6448 80.2705 61.6407 80.2737 61.6287C80.3098 61.4835 80.1709 61.4757 80.1608 61.5608C80.1509 61.6462 80.1915 61.8398 80.138 61.8906C80.1047 61.7531 80.1342 61.6288 80.1099 61.4642C80.1026 61.4147 80.0931 61.3887 80.0835 61.3782C80.0875 61.4448 80.0915 61.5116 80.0955 61.5783C80.1101 61.5969 80.1161 61.6197 80.1032 61.7092C80.1099 61.8223 80.1165 61.9355 80.1231 62.0486ZM132.005 46.1879C131.991 46.1045 131.979 46.0163 131.968 45.9213C131.957 45.9454 131.945 45.9695 131.934 45.9936C131.935 46.0428 131.936 46.0921 131.938 46.1413C131.949 46.1373 131.961 46.1387 131.975 46.1497C131.985 46.1583 131.995 46.1719 132.005 46.1879ZM80.7327 69.2916C80.7065 69.3868 80.6503 69.5749 80.7055 69.6942C80.7309 69.5207 80.7633 69.5142 80.7327 69.2916ZM81.0633 76.1256C81.0681 76.1171 81.073 76.1104 81.0786 76.1103C81.1119 76.1107 81.174 76.355 81.1475 76.1394C81.1458 76.1285 81.1301 76.0851 81.1101 76.0322C81.0893 76.0233 81.068 76.0281 81.051 76.0486C81.0551 76.0741 81.0592 76.1001 81.0633 76.1256ZM132.537 53.5224C132.503 53.4528 132.473 53.3746 132.449 53.2884C132.437 53.3762 132.425 53.464 132.413 53.5518C132.407 53.5441 132.4 53.5365 132.393 53.5288C132.393 53.5331 132.394 53.5374 132.394 53.5416C132.413 53.6001 132.426 53.653 132.435 53.7023C132.464 53.4831 132.517 53.8725 132.553 54.075C132.552 53.9446 132.551 53.8143 132.551 53.684C132.546 53.6303 132.542 53.5762 132.537 53.5224ZM131.002 40.1377C130.977 40.1239 130.953 40.1102 130.928 40.0966C130.99 40.206 131.05 40.3168 131.107 40.4295C131.114 40.4759 131.12 40.5221 131.125 40.5683C131.16 40.6091 131.194 40.6504 131.228 40.6923C131.254 40.8022 131.277 40.9125 131.298 41.0223C131.332 41.0471 131.367 41.0722 131.401 41.0976C131.394 41.0829 131.387 41.0659 131.379 41.0452C131.35 40.9713 131.214 40.6053 131.095 40.3297C131.065 40.2652 131.034 40.2012 131.002 40.1377ZM133.305 68.4963C133.306 68.525 133.307 68.5536 133.308 68.5823C133.309 68.5754 133.31 68.5685 133.312 68.5616C133.31 68.54 133.308 68.518 133.305 68.4963ZM132.387 53.0135C132.383 53.0412 132.379 53.0689 132.375 53.0965C132.375 53.1039 132.375 53.1117 132.376 53.1191C132.383 53.1016 132.39 53.0841 132.397 53.0665C132.394 53.0492 132.39 53.0313 132.387 53.0135ZM80.476 67.6761C80.4868 67.8375 80.4976 67.999 80.5084 68.1604C80.5609 68.2325 80.5489 68.0376 80.5384 67.8724C80.5307 67.9521 80.5227 68.0319 80.5132 68.1095C80.5065 67.9881 80.4996 67.8659 80.4927 67.7446C80.5058 67.7468 80.519 67.7492 80.5322 67.7512C80.5309 67.7171 80.5306 67.6901 80.5333 67.6779C80.5496 67.6075 80.6504 67.6333 80.5953 67.4454C80.5743 67.3742 80.5333 67.4622 80.5329 67.5518C80.4653 67.2331 80.4428 67.3078 80.4429 67.4931C80.4539 67.5541 80.465 67.6151 80.476 67.6761ZM79.723 53.9517C79.7901 53.8201 79.7866 53.3561 79.7238 53.6632C79.7081 53.7412 79.722 53.8596 79.723 53.9517ZM80.3503 63.2875C80.349 63.249 80.3477 63.2085 80.3465 63.17C80.3223 63.126 80.2979 63.0817 80.2737 63.0377C80.2649 63.0648 80.2559 63.0907 80.2471 63.1178C80.2814 63.1739 80.316 63.2309 80.3503 63.2875ZM80.2783 64.6563C80.2956 64.6347 80.3006 64.5128 80.3106 64.4686C80.3277 64.3941 80.3695 64.5644 80.388 64.5236C80.388 64.5229 80.388 64.5221 80.3879 64.5214C80.4064 64.4789 80.3969 64.2148 80.3775 64.1845C80.3352 64.1204 80.3179 64.3619 80.281 64.1744C80.2728 63.9334 80.2649 63.6861 80.2567 63.4427C80.2397 63.4494 80.2227 63.4565 80.2058 63.4631C80.2293 63.8626 80.2536 64.2608 80.2783 64.6563ZM131.545 41.3086C131.488 41.1013 131.474 41.2529 131.402 41.0989C131.432 41.2276 131.459 41.3563 131.482 41.4852C131.487 41.4481 131.491 41.4108 131.494 41.3734C131.518 41.4056 131.542 41.438 131.565 41.4706C131.568 41.4336 131.567 41.3916 131.545 41.3086ZM81.0342 75.2779C81.037 75.2569 81.041 75.2344 81.0464 75.2115C81.0457 75.1887 81.0448 75.1657 81.0442 75.1429C81.0313 75.147 81.0184 75.1509 81.0056 75.155C81.0067 75.1936 81.0078 75.2325 81.009 75.2711C81.0174 75.273 81.0258 75.2758 81.0342 75.2779ZM95.1887 89.8143C95.3234 89.769 95.4333 89.734 94.9234 89.7476C94.923 89.7496 94.922 89.7518 94.9215 89.7538C95.1096 89.7509 95.2175 89.7658 95.1887 89.8143ZM133.565 71.5946C133.562 71.5501 133.559 71.5228 133.555 71.5069C133.559 71.5608 133.563 71.6147 133.567 71.6685C133.558 71.8401 133.559 71.9322 133.567 71.9895C133.57 71.8389 133.573 71.7008 133.565 71.5946ZM80.8592 72.9167C80.8616 72.9129 80.8641 72.9067 80.8671 72.9034C80.8629 72.8963 80.8588 72.8926 80.8548 72.8875C80.8542 72.8942 80.8555 72.9036 80.8592 72.9167ZM130.263 38.8951C130.263 38.8933 130.263 38.8915 130.263 38.8897C130.255 38.8789 130.248 38.8681 130.24 38.8574C130.248 38.8699 130.255 38.8825 130.263 38.8951ZM81.1668 77.9731C81.1657 77.9708 81.1645 77.9688 81.1634 77.9665C81.1635 77.968 81.1635 77.9695 81.1636 77.971C81.1647 77.9717 81.1657 77.9725 81.1668 77.9731ZM82.0074 84.6689C82.0074 84.6677 82.0073 84.6662 82.0073 84.665C82.0067 84.6539 81.9744 84.5774 81.9372 84.4955C81.96 84.5532 81.9834 84.6113 82.0074 84.6689ZM127.961 36.6673C127.976 36.6741 127.991 36.6809 128.005 36.6877C127.975 36.6684 127.946 36.649 127.918 36.63C127.933 36.6424 127.947 36.6548 127.961 36.6673ZM83.8995 87.6155C83.8909 87.5939 83.8735 87.5638 83.8438 87.5223C83.7826 87.4369 83.701 87.3669 83.6415 87.3341C83.7276 87.4339 83.8155 87.5295 83.8995 87.6155ZM129.116 37.5548C129.123 37.5591 129.131 37.5633 129.139 37.5675C129.109 37.5386 129.078 37.5096 129.048 37.4809C129.071 37.5054 129.093 37.5301 129.116 37.5548ZM80.0336 60.5589C80.0448 60.5395 80.0533 60.5005 80.0568 60.4314C80.0569 60.4314 80.057 60.4314 80.0571 60.4314C80.0618 60.3344 80.0137 59.9561 80.0392 59.8306C80.0277 59.8184 80.0093 59.8285 79.988 59.8503C80.0035 60.0857 80.0188 60.3221 80.0336 60.5589ZM131.054 39.8634C130.987 39.8079 130.933 39.7772 130.872 39.7236C130.934 39.8371 130.994 39.9521 131.051 40.0686C131.044 40.0701 131.036 40.0716 131.029 40.0731C131.042 40.0852 131.054 40.0924 131.056 40.0809C131.06 40.0616 131.152 40.0406 131.054 39.8634ZM118.686 88.4018C118.661 88.4082 118.635 88.4145 118.61 88.4209C118.649 88.4194 118.688 88.4184 118.726 88.4178C118.713 88.4125 118.7 88.4072 118.686 88.4018ZM101.642 89.4297C101.632 89.4307 101.621 89.4317 101.61 89.4327C101.612 89.4337 101.613 89.4347 101.615 89.4357C101.623 89.4337 101.634 89.4317 101.642 89.4297ZM80.1782 62.8411C80.1856 62.4545 80.1786 62.4592 80.1509 62.5226C80.157 62.6274 80.163 62.7323 80.1691 62.8371C80.1721 62.8387 80.1752 62.8395 80.1782 62.8411ZM79.9449 59.2134C79.9634 59.081 79.9532 58.8218 79.9474 58.7345C79.9372 58.5795 79.9163 58.6283 79.8994 58.5879C79.9151 58.7953 79.9302 59.004 79.9449 59.2134ZM79.5953 55.4016C79.6192 55.5974 79.6424 55.7947 79.6644 55.9947C79.6657 55.9576 79.6696 55.9204 79.6791 55.8896C79.6959 55.8356 79.7792 56.0494 79.7671 55.8081C79.7379 55.6609 79.7033 55.791 79.6686 55.7234C79.6409 55.6688 79.632 55.3817 79.5953 55.4016ZM125.354 88.0165C125.257 88.0374 125.161 88.0583 125.064 88.0792C125.152 88.0785 125.239 88.0779 125.327 88.0772C125.336 88.057 125.345 88.0367 125.354 88.0165ZM132.589 54.146C132.587 54.1585 132.585 54.1709 132.583 54.1834C132.586 54.1811 132.588 54.1723 132.589 54.1543C132.589 54.1516 132.589 54.1487 132.589 54.146ZM79.6925 54.7675C79.6757 54.4383 79.5863 54.398 79.6422 54.6981C79.6541 54.7619 79.6731 54.7672 79.6925 54.7675ZM79.884 58.3864C79.8875 58.2653 79.8984 58.1222 79.8778 58.0123C79.864 57.9392 79.8534 57.9085 79.8455 57.9055C79.8586 58.065 79.8715 58.2255 79.884 58.3864ZM79.4095 52.0066C79.4271 52.0339 79.4444 52.044 79.4549 52.019C79.4847 51.947 79.4379 51.8344 79.3988 51.7694C79.4024 51.8484 79.4058 51.9275 79.4095 52.0066ZM127.191 35.8966C126.914 35.7202 126.441 35.6033 126.641 35.7315C126.882 35.8772 127.633 36.1811 127.191 35.8966ZM98.9819 36.4348C99.3531 36.3845 101.015 36.2982 101.182 36.288C101.844 36.2471 101.455 36.3616 101.344 36.3689C100.877 36.4 100.524 36.3144 100.306 36.4495C100.021 36.4717 100.313 36.4054 100.139 36.4096C99.795 36.4179 99.4207 36.5025 99.0621 36.514C99.0616 36.514 99.0611 36.5141 99.0606 36.5141C99.0352 36.4884 98.9567 36.4637 98.9819 36.4348ZM112.707 35.6375C112.6 35.6435 112.464 35.6863 112.516 35.6898C112.913 35.7163 113.202 35.6095 112.707 35.6375ZM97.0078 36.555C97.6005 36.5061 97.6824 36.5861 97.2084 36.6137C97.0732 36.6216 96.9212 36.5828 97.0078 36.555ZM98.3727 36.4499C98.5301 36.4518 98.4406 36.4965 98.7568 36.4596C98.759 36.4615 98.7611 36.4633 98.7632 36.4652C98.7706 36.4954 98.4876 36.5346 98.3464 36.5406C98.3418 36.5402 98.3752 36.5137 98.3396 36.5148C98.0747 36.5249 97.6595 36.5718 97.6833 36.501C97.9286 36.5284 98.2146 36.4481 98.3727 36.4499ZM125.295 35.2743C125.99 35.4727 126.56 35.564 125.624 35.3001C125.572 35.2875 125.464 35.3154 125.295 35.2743ZM121.816 35.0722C121.421 34.998 119.978 35.1769 120.907 35.1641C121.067 35.1618 120.993 35.1356 121.094 35.1294C121.094 35.1295 121.094 35.1295 121.094 35.1295C121.196 35.1235 122.11 35.1277 121.816 35.0722ZM123.206 35.0342C123.206 35.0343 123.206 35.0344 123.206 35.0345C123.408 35.0261 123.608 35.0241 123.811 35.0291C123.617 35.0137 123.425 35.0047 123.23 35.0017C123.222 35.0126 123.214 35.0233 123.206 35.0342ZM107.65 35.8334C107.426 35.8398 107.139 35.9317 107.656 35.8911C107.679 35.8892 107.874 35.8298 108.019 35.8534C108.113 35.8702 108.034 35.894 108.159 35.9124C108.159 35.9124 108.158 35.9124 108.158 35.9125C108.283 35.9306 108.627 35.8055 107.65 35.8334ZM101.775 36.2925C101.86 36.2303 102.413 36.2308 102.676 36.2078C102.439 36.2735 102.118 36.2768 101.775 36.2925ZM105.37 35.9704C105.472 35.9803 105.413 36.0217 105.556 36.0246C105.556 36.0247 105.556 36.0248 105.556 36.0249C105.699 36.0279 106.117 36.0206 106.276 35.9983C106.436 35.976 106.423 35.9197 106.554 35.8914C106.155 35.917 105.77 35.9432 105.37 35.9704ZM111.678 35.6752C111.882 35.6508 112.087 35.6263 112.291 35.6019C112.171 35.5953 112.049 35.589 111.929 35.5824C111.846 35.6133 111.762 35.6444 111.678 35.6752ZM114.523 35.4949C114.792 35.5243 115.02 35.3284 114.582 35.433C114.54 35.4432 114.503 35.4927 114.523 35.4949ZM103.84 36.0287C103.741 36.108 104.029 36.1021 104.141 36.0949C104.544 36.0689 104.765 36.1204 104.953 36.0373C104.726 36.0054 104.546 36.065 104.43 36.0656C104.176 36.0663 104.184 36.0051 103.84 36.0287ZM128.56 36.5079C128.576 36.5607 128.505 36.6259 128.632 36.7379C128.835 36.9158 129.068 37.0601 128.985 36.9295C128.961 36.887 128.563 36.5468 128.56 36.5079ZM111.396 35.5366C111.356 35.5863 111.369 35.6277 111.604 35.645C111.665 35.5952 111.539 35.5663 111.396 35.5366ZM131.763 40.8993C131.718 40.6819 131.556 40.3657 131.588 40.5318C131.622 40.6959 131.82 41.1667 131.763 40.8993ZM100.534 35.9434C100.881 35.8439 100.599 35.8272 101.225 35.8737C100.547 35.9927 101.438 36.0011 101.406 36.0789C101.387 36.1228 101.087 36.1118 100.984 36.1391C100.825 36.1812 101.009 36.2281 100.829 36.2587C100.649 36.2892 100.071 36.2749 99.8767 36.2859C99.5062 36.3073 99.1785 36.3507 98.8691 36.3687C98.5598 36.3867 98.0913 36.373 97.8934 36.3788C97.6958 36.3846 97.4987 36.4028 97.4649 36.4091C97.2643 36.4463 97.3687 36.5024 97.0984 36.5177C97.0919 36.4578 96.7367 36.3806 97.1396 36.3239C97.0826 36.3252 97.0136 36.3172 96.9582 36.3215C96.6976 36.342 96.8254 36.4185 96.701 36.4392C96.4899 36.4742 96.6453 36.4012 96.6419 36.3985C96.4487 36.359 96.5397 36.4118 96.4467 36.4423C96.398 36.4579 96.0001 36.5071 95.9177 36.5097C95.8362 36.5123 95.9466 36.4741 95.8922 36.4752C95.6559 36.4805 95.4134 36.4844 95.1751 36.5039C94.937 36.5236 94.7946 36.5875 94.8127 36.5047C94.8164 36.4917 94.9505 36.4726 94.9133 36.4448C94.9133 36.4446 94.9133 36.4445 94.9133 36.4443C94.9008 36.4353 94.7161 36.3985 94.9888 36.3564C95.0661 36.3445 95.1489 36.336 95.2334 36.3304C95.2007 36.3432 95.1679 36.356 95.1352 36.3688C95.2 36.366 95.2644 36.3635 95.3288 36.3609C95.2873 36.3917 95.2431 36.4241 95.2128 36.4533C95.2918 36.4802 95.3908 36.4344 95.405 36.434C95.6249 36.4345 95.5916 36.4953 95.7566 36.4172C95.6084 36.4143 95.4632 36.4099 95.3202 36.4051C95.3262 36.3903 95.3324 36.3753 95.3379 36.3605C95.3669 36.3593 95.396 36.3582 95.4252 36.357C95.4112 36.3459 95.3972 36.3346 95.3832 36.3235C95.5926 36.3173 95.8085 36.3249 95.9971 36.336C95.9278 36.3561 95.8512 36.3787 95.7827 36.3999C96.0429 36.3724 95.8875 36.4164 96.0645 36.427C96.1257 36.354 96.223 36.3652 96.3739 36.3623C96.5246 36.3593 96.3367 36.3175 96.492 36.3032C96.8078 36.2742 97.3243 36.33 97.425 36.2237C97.813 36.266 97.3221 36.3002 97.2892 36.3266C97.1524 36.4395 97.9869 36.352 98.1242 36.2868C98.2319 36.3152 98.2235 36.3631 98.5348 36.3342C98.9568 36.295 98.0621 36.2836 98.6329 36.2445C99.0148 36.2184 98.9511 36.2719 99.1368 36.2742C99.4829 36.2783 100.11 36.2201 99.9046 36.1598C99.8217 36.1358 99.5478 36.1867 99.4517 36.162C99.3987 36.1482 99.5573 35.9951 99.2094 36.1254C99.1757 36.1384 99.3381 36.1828 99.074 36.1978C98.9982 36.2021 98.7561 36.1671 98.5384 36.1924C98.4431 36.2035 98.0328 36.2911 97.7998 36.2789C97.5478 36.2662 97.9434 36.2321 97.851 36.2139C97.7578 36.1958 97.4387 36.2144 97.4592 36.1655C97.6426 36.1015 97.6469 36.1857 97.7047 36.1789C97.9263 36.1518 97.763 36.0779 98.0772 36.0713C98.1165 36.1139 97.8104 36.2488 98.2802 36.194C98.2825 36.1919 98.1774 36.1694 98.329 36.1518C98.5928 36.1211 99.0939 36.0845 99.4136 36.0696C99.4041 36.0038 99.0117 36.0288 98.8216 35.9929C99.2548 35.959 99.739 35.9136 100.041 35.961C99.8768 35.9786 99.7121 35.9964 99.5485 36.014C99.7404 36.0009 99.9328 35.9879 100.124 35.9748C100.047 36.0067 99.606 36.0994 99.907 36.0993C99.9444 36.0254 100.369 35.9907 100.534 35.9434ZM101.072 89.7744C101.077 89.7789 101.082 89.7834 101.086 89.7877C101.29 89.7757 101.493 89.7674 101.695 89.7608C101.487 89.7653 101.28 89.7699 101.072 89.7744ZM94.6675 36.6006C94.7732 36.6038 94.8929 36.6033 95.0037 36.6042C94.9106 36.6564 94.7917 36.6557 94.6189 36.6347C94.6378 36.6233 94.6467 36.612 94.6675 36.6006ZM121.6 34.9703C121.57 34.9646 120.86 35.0121 120.846 35.0491C120.966 35.0544 121.818 35.0131 121.6 34.9703ZM93.5344 36.6567C93.7938 36.6447 94.0522 36.6352 94.3103 36.6254C94.1411 36.6899 93.3828 36.6917 93.5344 36.6567ZM133.838 68.9527C133.829 68.873 133.819 68.7951 133.809 68.7378C133.806 68.8008 133.806 68.8672 133.808 68.9349C133.818 68.9409 133.828 68.9468 133.838 68.9527ZM124.385 34.925C124.309 34.9085 124.231 34.8931 124.153 34.8785C124.155 34.8953 124.157 34.9125 124.159 34.9293C124.321 34.9289 124.483 34.9326 124.645 34.9409C124.589 34.9228 124.532 34.9051 124.476 34.8882C124.446 34.9002 124.415 34.9127 124.385 34.925ZM80.2875 71.401C80.3022 71.5012 80.3177 71.6443 80.3323 71.797C80.338 71.6881 80.3438 71.5793 80.3495 71.4705C80.3284 71.4121 80.3073 71.3537 80.2861 71.2954C80.2866 71.3306 80.2871 71.3658 80.2875 71.401ZM111.806 89.3959C111.699 89.3072 112.001 89.2292 112.253 89.1969C112.217 89.1893 112.182 89.1818 112.146 89.1742C112.13 89.1754 112.113 89.1766 112.097 89.1778C112.011 89.209 111.925 89.2402 111.839 89.2714C111.688 89.2574 111.537 89.2434 111.386 89.2293C111.313 89.2347 111.241 89.2401 111.169 89.2454C111.12 89.2823 111.07 89.3191 111.021 89.356C110.91 89.3514 110.8 89.3467 110.689 89.3421C110.848 89.369 111.106 89.4084 111.251 89.3477C111.323 89.3172 111.195 89.2259 111.538 89.2487C111.791 89.2656 111.526 89.3645 111.806 89.3959ZM108.654 35.5629C108.006 35.5253 107.858 35.6758 107.805 35.6929C107.532 35.7812 107.486 35.6582 107.427 35.6614C107.145 35.6795 107.453 35.7985 107.491 35.7989C108.095 35.8051 107.96 35.706 108.03 35.67C108.184 35.5921 108.586 35.6278 108.654 35.5629ZM112.954 89.2398C112.996 89.208 113.037 89.1763 113.079 89.1445C112.957 89.1582 112.835 89.1719 112.713 89.1856C112.803 89.2001 112.818 89.2286 112.884 89.2446C112.907 89.243 112.93 89.2414 112.954 89.2398ZM121.227 34.5272C120.848 34.5141 120.512 34.6355 120.716 34.6672C120.836 34.6857 121.167 34.5996 121.085 34.6765C120.525 34.6741 120.577 34.7336 120.585 34.7441C120.641 34.8196 120.223 34.8665 120.259 34.9302C120.279 34.966 120.728 34.9251 120.899 34.925C120.972 34.925 120.978 34.9561 120.991 34.9564C121.159 34.9591 121.257 34.9231 121.428 34.912C121.507 34.907 121.558 34.9516 121.665 34.9294C121.771 34.907 122.092 34.8216 122.112 34.7916C122.147 34.7378 121.831 34.7126 121.568 34.7686C121.44 34.7959 121.524 34.8674 121.157 34.8447C121.108 34.8417 120.91 34.7739 120.725 34.7888C120.956 34.729 121.695 34.6904 122.005 34.6871C122.039 34.6305 121.52 34.679 121.322 34.6631C121.155 34.6497 121.258 34.529 121.227 34.5272ZM103.948 89.701C103.942 89.7056 103.935 89.7101 103.929 89.7147C103.953 89.7464 103.989 89.7869 104.152 89.7814C104.084 89.7546 104.016 89.7278 103.948 89.701ZM110.352 89.3477C110.383 89.3421 110.418 89.337 110.458 89.3325C110.4 89.33 110.343 89.3276 110.286 89.3251C110.308 89.3326 110.33 89.3402 110.352 89.3477ZM132.702 48.4934C132.649 48.6949 132.67 49.4525 132.712 48.9647C132.723 48.8407 132.706 48.6437 132.702 48.4934ZM80.5889 76.3505C80.5882 76.3314 80.5875 76.3124 80.5868 76.2933C80.5842 76.2859 80.5815 76.2785 80.5789 76.2711C80.5822 76.2974 80.5856 76.3244 80.5889 76.3505ZM107.839 89.5453C107.807 89.585 108.296 89.5252 108.401 89.5063C108.446 89.4981 108.479 89.4787 108.517 89.4623C108.508 89.4581 108.499 89.4539 108.489 89.4496C108.402 89.4567 108.323 89.4632 108.254 89.4689C108.124 89.4799 107.993 89.4909 107.863 89.502C107.86 89.5143 107.853 89.5287 107.839 89.5453ZM93.7674 36.4622C93.5536 36.3785 94.4477 36.3414 94.804 36.3359C94.7208 36.3398 94.6366 36.3438 94.5533 36.3479C94.5874 36.3662 94.6162 36.3851 94.6503 36.4034C94.5578 36.4108 94.4662 36.418 94.3737 36.4254C94.4786 36.4407 94.5719 36.4592 94.672 36.4748C94.4235 36.5766 94.4139 36.521 94.0717 36.526C93.8522 36.5293 93.7627 36.5643 93.4891 36.5812C92.2105 36.6604 90.8926 36.7713 89.5835 36.8266C89.5923 36.7521 89.6247 36.7321 89.8679 36.7092C89.8554 36.7318 89.8458 36.7545 89.8342 36.7771C89.9948 36.7607 90.1536 36.7429 90.3105 36.7247C90.1654 36.7196 90.0213 36.7143 89.8799 36.7081C89.9534 36.7014 90.0456 36.6941 90.1609 36.6852C90.2457 36.6786 90.2709 36.6471 90.385 36.6444C90.629 36.6386 90.9367 36.7121 91.2083 36.6738C91.3658 36.6516 91.1658 36.5797 91.5351 36.5831C91.307 36.6558 91.146 36.7168 91.721 36.6614C91.3973 36.626 91.6553 36.6331 91.7799 36.5987C91.858 36.5767 91.3714 36.6097 91.6899 36.5582C91.7545 36.5478 92.7393 36.4599 92.6914 36.5134C92.5898 36.6283 92.5426 36.6183 93.182 36.5215C92.3907 36.5205 93.1282 36.4082 93.4779 36.4207C93.6557 36.4271 93.3405 36.4953 93.7674 36.4622ZM124.509 88.5731C124.68 88.5718 124.86 88.5304 125.04 88.5012C124.987 88.4938 124.934 88.4864 124.881 88.479C124.822 88.5046 124.763 88.5302 124.704 88.5558C124.626 88.5552 124.548 88.5544 124.47 88.5538C124.463 88.5645 124.464 88.5735 124.509 88.5731ZM110.631 35.4286C110.619 35.4074 110.897 35.274 110.458 35.3894C110.307 35.4294 110.326 35.4609 109.926 35.4867C110.298 35.4573 110.214 35.5515 110.252 35.5562C110.563 35.5943 110.945 35.4675 110.896 35.4234C110.881 35.4107 110.644 35.4496 110.631 35.4286ZM107.398 89.5394C107.391 89.54 107.382 89.5406 107.374 89.5412C107.381 89.5414 107.388 89.5415 107.395 89.5417C107.396 89.541 107.397 89.5402 107.398 89.5394ZM123.964 88.6004C124.121 88.6114 124.25 88.6187 124.347 88.5525C124.203 88.5511 124.059 88.5497 123.915 88.5483C123.932 88.5657 123.948 88.5831 123.964 88.6004ZM128.891 36.3448C128.596 36.1145 128.611 36.2091 128.66 36.2908C128.454 36.1542 128.247 36.0267 128.033 35.9069C128.624 36.2793 128.554 36.3483 128.512 36.4295C128.728 36.602 128.617 36.436 128.843 36.6209C128.922 36.687 128.892 36.7156 128.905 36.7301C129.064 36.9058 129.175 36.8484 129.074 36.7477C128.972 36.6462 128.689 36.4619 128.657 36.3819C128.866 36.5076 129.009 36.6574 129.235 36.8328C129.501 37.044 129.336 36.8208 129.245 36.7641C129.064 36.653 129.138 36.7688 128.878 36.5131C128.653 36.2977 129.12 36.5285 128.891 36.3448ZM88.3058 36.8508C88.0927 36.7735 88.8978 36.8003 88.9814 36.7974C89.2257 36.7889 89.2952 36.7353 89.4722 36.7596C89.488 36.7625 89.318 36.8225 89.1994 36.831C89.0797 36.8395 88.3283 36.8576 88.3058 36.8508ZM125.818 88.5659C125.701 88.5599 125.765 88.5087 125.532 88.5456C125.53 88.5433 125.529 88.5409 125.527 88.5386C125.521 88.5024 125.73 88.4619 125.834 88.458C125.838 88.4583 125.814 88.4896 125.84 88.4892C125.877 88.488 125.917 88.4855 125.959 88.4827C126.147 88.4705 126.352 88.4435 126.342 88.5123C126.215 88.4923 126.078 88.5259 125.963 88.5479C125.907 88.559 125.857 88.5679 125.818 88.5659ZM115.704 89.1292C115.727 89.1349 115.741 89.1303 115.744 89.0883C115.709 89.0876 115.674 89.0869 115.639 89.0861C115.661 89.1005 115.682 89.1149 115.704 89.1292ZM103.647 35.8871C103.756 35.9288 103.966 35.9017 104.214 35.8812C104.193 35.8655 104.172 35.8498 104.151 35.8341C103.984 35.8517 103.815 35.8696 103.647 35.8871ZM126.486 35.3307C126.487 35.3308 126.487 35.331 126.488 35.3312C126.548 35.3552 126.609 35.3803 126.669 35.4057C126.75 35.4189 126.833 35.4339 126.914 35.4495C126.878 35.424 126.842 35.3989 126.805 35.3738C126.699 35.3575 126.593 35.3434 126.486 35.3307ZM88.2156 36.8313C87.9159 36.8491 87.6161 36.8668 87.3164 36.8846C87.3167 36.8845 87.3169 36.8845 87.3172 36.8844C87.3303 36.8726 87.3447 36.8609 87.3588 36.849C87.6443 36.8431 87.9301 36.8372 88.2156 36.8313ZM127.246 35.2891C126.907 35.1266 126.329 34.9625 125.93 34.8472C125.693 34.7782 125.71 34.7481 125.467 34.6873C125.105 34.5937 124.459 34.4811 124.106 34.4746C123.979 34.471 124.004 34.5356 124.026 34.5445C124.084 34.5656 124.287 34.5547 124.372 34.5716C124.457 34.5881 124.358 34.6009 124.475 34.6192C124.593 34.6315 125.243 34.7418 125.289 34.7532C125.572 34.7902 125.241 34.6758 125.563 34.7615C125.655 34.9971 124.77 34.6596 124.592 34.6589C123.951 34.6204 124.468 34.7019 124.586 34.7389C124.705 34.7747 124.404 34.7581 124.466 34.7851C124.467 34.7852 124.468 34.7852 124.469 34.7853C124.532 34.8089 124.976 34.8891 125.033 34.8882C125.156 34.8795 124.763 34.7749 125.089 34.8172C125.493 34.9051 125.9 35.0235 126.29 35.1665C126.287 35.1358 126.283 35.105 126.28 35.0745C126.187 35.0521 126.092 35.0307 125.999 35.0114C125.93 34.9805 125.861 34.9506 125.791 34.9216C126.266 34.9002 126.727 35.2333 127.423 35.5033C127.371 35.5129 127.323 35.5265 127.268 35.535C128.209 36.071 127.595 35.7026 127.653 35.6403C127.687 35.6053 127.955 35.8043 128.023 35.8383C128.5 36.0684 127.597 35.4335 127.246 35.2891ZM119.44 34.8638C120.623 34.7083 118.602 34.8174 118.468 34.8609C118.217 34.9433 119.121 34.8582 119.235 34.869C119.347 34.8801 119.284 34.9674 119.601 34.913C119.722 34.8923 119.586 34.8607 119.44 34.8638ZM116.568 35.1013C116.417 35.0826 116.122 35.0415 115.917 35.0934C116.195 35.1084 116.199 35.1359 116.568 35.1013ZM89.8799 36.7081C89.8759 36.7085 89.8717 36.7088 89.8679 36.7092C89.8681 36.7088 89.869 36.7083 89.8693 36.7079C89.8693 36.7078 89.8693 36.7077 89.8693 36.7076C89.8728 36.7077 89.8764 36.708 89.8799 36.7081ZM106.881 89.6672C106.791 89.6717 106.702 89.6762 106.613 89.6808C106.612 89.6821 106.61 89.6838 106.609 89.6852C106.715 89.6817 106.821 89.6781 106.927 89.6746C106.912 89.6721 106.896 89.6696 106.881 89.6672ZM132.729 44.7556C132.585 44.4656 132.706 45.0606 132.665 45.3447C132.665 45.3442 132.665 45.3437 132.665 45.3432C132.653 45.4279 132.573 45.066 132.593 45.4615C132.624 45.7066 132.648 45.501 132.68 45.6178C132.713 45.7357 132.734 46.4439 132.781 46.0308C132.796 45.9025 132.695 44.9799 132.729 44.7556ZM132.696 47.1708C132.723 47.7102 132.802 47.7935 132.742 47.2942C132.73 47.1874 132.713 47.1751 132.696 47.1708ZM80.785 83.1802C80.7615 83.0409 80.6517 82.5606 80.6005 82.0234C80.5098 81.1258 80.426 80.0982 80.6325 80.5719C80.6353 80.5782 80.6371 80.582 80.6376 80.5791C80.6862 80.2546 80.2813 79.5046 80.5519 79.0711C80.5614 79.0558 80.5689 79.0436 80.5694 79.0376C80.5718 79.0118 80.5607 78.9315 80.548 78.8388C80.5274 78.6893 80.5023 78.5066 80.5214 78.4651C80.5373 78.5267 80.5456 78.6212 80.5532 78.7093C80.5579 78.7638 80.5625 78.8159 80.5685 78.8564C80.5765 78.9107 80.5878 78.9457 80.5992 78.9806C80.6158 79.0322 80.6325 79.0841 80.6385 79.1972C80.6537 79.479 80.6085 79.3588 80.5881 79.3045C80.5829 79.2908 80.5793 79.2816 80.5787 79.2839C80.5789 79.2927 80.5791 79.3015 80.5792 79.3103C80.5843 79.5967 80.588 79.8064 80.644 80.0456C80.6657 80.0763 80.6601 80.0146 80.6534 79.9431C80.6478 79.8825 80.6413 79.8145 80.6505 79.79C80.675 79.7341 80.6764 79.9941 80.6771 80.1108C80.6772 80.1354 80.6774 80.1539 80.6777 80.1614C80.6829 80.2358 80.6892 80.2813 80.6946 80.319C80.7056 80.3969 80.7119 80.4418 80.6928 80.643C80.6906 80.6679 80.6858 80.6732 80.6816 80.6776C80.6721 80.6879 80.6661 80.6953 80.7036 80.9323C80.6302 80.7357 80.6288 81.1267 80.6789 81.4065C80.6868 81.4495 80.6985 81.4777 80.7104 81.5065C80.7347 81.5651 80.76 81.6269 80.7575 81.8216C80.7556 81.9259 80.7136 81.9 80.708 81.8698C80.7062 81.8597 80.7059 81.8357 80.7057 81.8081C80.7051 81.753 80.7044 81.6837 80.6906 81.6806C80.6887 81.7788 80.6923 81.8972 80.6969 82.0176C80.6982 82.0502 80.6997 82.083 80.7014 82.1155C80.7087 82.2566 80.7192 82.3932 80.724 82.5007C80.7247 82.5205 80.7214 82.524 80.7178 82.5279C80.681 82.5645 80.7779 83.1092 80.8216 83.1492C80.8275 83.1627 80.8334 83.1736 80.839 83.1823C80.8393 83.2397 80.838 83.288 80.8369 83.3387C80.8363 83.3667 80.8358 83.3954 80.8358 83.4273C80.8358 83.4493 80.836 83.4703 80.836 83.4894C80.7843 83.3599 80.8073 83.3152 80.785 83.1802ZM105.815 35.7362C106.087 35.7034 106.359 35.6708 106.63 35.6382C106.244 35.6664 106.102 35.681 105.885 35.6338C105.862 35.6678 105.838 35.7021 105.815 35.7362ZM129.99 37.2615C129.952 37.358 130.344 37.6871 130.486 37.945C130.53 38.0209 130.159 37.6948 130.459 38.1037C130.459 38.104 130.459 38.1042 130.459 38.1044C130.559 38.2332 130.959 38.7521 131.041 38.9452C131.125 39.0063 130.988 38.5208 130.944 38.4462C130.683 37.966 130.327 37.6729 129.99 37.2615ZM95.3379 36.3605C95.335 36.3606 95.3317 36.3607 95.3288 36.3609C95.333 36.3578 95.337 36.3546 95.3411 36.3516C95.34 36.3545 95.3389 36.3575 95.3379 36.3605ZM104.433 89.9464C104.673 89.9707 105.021 89.8699 104.846 89.8288C104.635 89.7799 104.043 89.9068 104.433 89.9464ZM133.101 52.1987C133.127 52.0128 133.03 51.5696 133.005 51.6926C132.97 51.8654 133.096 52.2355 133.101 52.1987ZM107.751 35.4965C107.456 35.508 107.257 35.5862 107.295 35.6292C107.495 35.6102 107.694 35.591 107.893 35.572C107.846 35.5469 107.798 35.5216 107.751 35.4965ZM124.229 89.1211C123.975 89.2321 124.185 89.2585 123.72 89.1884C124.219 89.062 123.558 89.0312 123.579 88.9391C123.592 88.887 123.815 88.9072 123.89 88.877C124.007 88.8304 123.869 88.7699 124.002 88.7375C124.135 88.7052 124.563 88.7358 124.707 88.7271C124.981 88.7102 125.223 88.666 125.452 88.6516C125.603 88.6421 125.807 88.6508 125.969 88.6571C126.057 88.66 126.134 88.661 126.186 88.6589C126.341 88.6528 126.493 88.6266 126.519 88.6181C126.672 88.5679 126.585 88.5053 126.792 88.4756C126.803 88.5469 127.094 88.6195 126.784 88.7081C126.829 88.7039 126.885 88.7096 126.928 88.7013C127.132 88.6604 127.018 88.5776 127.112 88.5443C127.27 88.487 127.163 88.5843 127.165 88.5881C127.324 88.619 127.243 88.564 127.31 88.5199C127.345 88.4984 127.643 88.3984 127.705 88.3835C127.767 88.3703 127.692 88.4286 127.733 88.4206C127.914 88.3846 128.103 88.3428 128.279 88.2791C128.455 88.2146 128.54 88.1122 128.556 88.2103C128.558 88.2259 128.461 88.274 128.5 88.2988C128.5 88.2989 128.5 88.2991 128.5 88.2993C128.512 88.3072 128.669 88.3132 128.471 88.4145C128.415 88.4428 128.353 88.4677 128.289 88.4888C128.311 88.4684 128.331 88.4481 128.352 88.4276C128.303 88.4423 128.254 88.4565 128.205 88.4702C128.228 88.4276 128.251 88.3831 128.265 88.3442C128.195 88.3267 128.133 88.3961 128.122 88.3982C128.123 88.3983 128.123 88.3984 128.123 88.3985C127.952 88.4325 127.961 88.356 127.854 88.4702C127.97 88.4531 128.085 88.436 128.197 88.4177C128.197 88.4359 128.198 88.4541 128.198 88.4722C128.176 88.4785 128.152 88.4849 128.13 88.491C128.144 88.5016 128.159 88.5121 128.173 88.5226C128.01 88.5645 127.837 88.5864 127.686 88.5964C127.736 88.5645 127.79 88.5282 127.838 88.4943C127.642 88.5603 127.752 88.4888 127.612 88.4979C127.581 88.5905 127.501 88.5892 127.383 88.6074C127.265 88.6251 127.42 88.6567 127.301 88.6878C127.055 88.7533 126.639 88.7101 126.568 88.838C126.254 88.7966 126.645 88.7448 126.666 88.7108C126.76 88.5751 126.118 88.6973 126.009 88.7666C125.996 88.7613 125.985 88.7555 125.975 88.7495C125.922 88.7152 125.896 88.6774 125.7 88.7006C125.389 88.7377 126.052 88.7718 125.63 88.8053C125.348 88.8275 125.394 88.7652 125.256 88.7581C125 88.7453 124.536 88.8001 124.69 88.8769C124.752 88.9078 124.954 88.8533 125.026 88.8851C125.065 88.903 124.952 89.0818 125.206 88.9344C125.231 88.9197 125.11 88.8629 125.305 88.851C125.361 88.8478 125.542 88.895 125.702 88.8697C125.742 88.8634 125.856 88.8303 125.978 88.8064C126.08 88.7877 126.185 88.7724 126.266 88.7784C126.466 88.792 126.154 88.8348 126.229 88.856C126.305 88.8785 126.558 88.8502 126.546 88.9084C126.403 88.9892 126.394 88.8881 126.349 88.8969C126.172 88.9302 126.308 89.0196 126.052 89.0248C126.023 88.9786 126.215 88.847 125.982 88.8633C125.958 88.8649 125.928 88.8683 125.894 88.8738C125.889 88.8754 125.971 88.9054 125.858 88.9232C125.663 88.9537 125.292 88.986 125.056 88.9965C125.065 89.0753 125.356 89.0544 125.498 89.1016C125.178 89.1321 124.82 89.1753 124.594 89.1117C124.716 89.0945 124.838 89.0769 124.959 89.0597C124.817 89.0709 124.674 89.082 124.533 89.0931C124.589 89.0568 124.913 88.9563 124.691 88.9494C124.665 89.0368 124.35 89.0684 124.229 89.1211ZM121.777 88.9428C121.849 88.8502 121.634 88.8505 121.551 88.8566C121.254 88.8782 121.088 88.8116 120.952 88.9065C121.121 88.95 121.253 88.8829 121.339 88.8849C121.527 88.8899 121.523 88.9629 121.777 88.9428ZM95.3832 36.3235C95.3327 36.325 95.2826 36.3272 95.2334 36.3304C95.2403 36.3277 95.2471 36.325 95.254 36.3223C95.1608 36.3207 95.0683 36.3193 94.9751 36.3178C95.0927 36.3047 95.2095 36.2915 95.3261 36.2783C95.3451 36.2934 95.3642 36.3085 95.3832 36.3235ZM108.48 89.6691C108.746 89.7572 109.634 89.6199 109.307 89.5869C109.225 89.592 109.142 89.5971 109.06 89.6022C109.052 89.609 109.043 89.6154 109.014 89.6174C109.014 89.6173 109.013 89.6172 109.013 89.6171C108.938 89.622 108.261 89.596 108.48 89.6691ZM105.903 89.7886C105.364 89.79 104.952 89.9469 105.664 89.8709C105.703 89.8664 105.772 89.7935 105.903 89.7886ZM107.453 89.6965C107.305 89.7144 107.157 89.7326 107.01 89.7507C107.152 89.746 107.295 89.7411 107.437 89.7366C107.442 89.7233 107.447 89.7099 107.453 89.6965ZM115.977 89.1835C115.926 89.1918 115.874 89.2002 115.823 89.2086C115.824 89.2092 115.825 89.2098 115.826 89.2105C115.818 89.2109 115.81 89.2114 115.803 89.2119C115.71 89.2269 115.617 89.2418 115.525 89.2568C115.615 89.2674 115.705 89.2779 115.794 89.2885C115.854 89.2535 115.917 89.2183 115.977 89.1835ZM132.818 48.0885C132.84 48.3396 132.836 48.7425 132.897 48.7928C132.894 48.6032 132.892 48.4134 132.89 48.2238C132.866 48.1791 132.842 48.1333 132.818 48.0885ZM118.959 89.0876C119.125 89.0852 119.334 88.9822 118.952 89.0187C118.935 89.0207 118.792 89.0867 118.684 89.0552C118.659 89.0471 118.651 89.0381 118.646 89.0291C118.609 89.0406 118.571 89.052 118.534 89.0634C118.605 89.0797 118.735 89.0909 118.959 89.0876ZM110.983 35.1699C110.703 35.2294 110.441 35.2483 110.083 35.2545C109.98 35.314 109.877 35.3734 109.775 35.4329C110.327 35.4055 109.926 35.3414 110.407 35.3248C110.469 35.296 110.197 35.3245 110.245 35.3074C110.477 35.2242 110.798 35.2971 111.122 35.2394C111.077 35.2163 111.029 35.1931 110.983 35.1699ZM129.448 87.737C129.264 87.8216 129.077 87.8974 128.889 87.967C128.991 87.8613 129.541 87.6596 129.448 87.737ZM117.226 89.1192C117.438 89.3064 117.899 89.2232 117.88 89.1046C117.754 89.1114 117.627 89.1182 117.501 89.125C117.409 89.123 117.317 89.1211 117.226 89.1192ZM106.751 35.6C106.911 35.5938 107.072 35.5876 107.233 35.5813C107.24 35.57 107.248 35.5587 107.255 35.5475C107.095 35.5538 106.935 35.5598 106.775 35.566C106.768 35.5773 106.759 35.5887 106.751 35.6ZM113.875 89.3328C113.674 89.2915 113.51 89.5203 113.831 89.4056C113.862 89.3945 113.889 89.3363 113.875 89.3328ZM119.769 89.0436C120.064 89.0223 120.348 88.9999 120.644 88.9767C120.608 88.9698 120.599 88.9548 120.588 88.9405C120.409 88.9537 120.23 88.9668 120.052 88.98C119.991 88.9783 119.93 88.9765 119.869 88.9748C119.843 88.9999 119.821 89.027 119.769 89.0436ZM116.19 89.3556C116.219 89.2972 116.208 89.2474 116.033 89.2214C115.99 89.2794 116.084 89.3168 116.19 89.3556ZM103.56 35.7405C103.779 35.7205 104.131 35.7396 104.161 35.6839C103.973 35.6856 103.784 35.6874 103.595 35.6892C103.583 35.7062 103.571 35.7234 103.56 35.7405ZM113.704 35.0307C113.445 35.0368 112.705 35.1783 113.478 35.0892C113.482 35.1057 113.487 35.1221 113.491 35.1386C113.562 35.1027 113.633 35.0666 113.704 35.0307ZM107.217 35.4659C107.322 35.4727 107.426 35.4796 107.529 35.4865C107.632 35.4493 107.737 35.4122 107.841 35.375C107.633 35.4052 107.425 35.4357 107.217 35.4659ZM102.693 35.7741C102.861 35.7565 103.029 35.7391 103.197 35.7215C103.041 35.7221 102.884 35.7223 102.729 35.7229C102.717 35.7399 102.705 35.757 102.693 35.7741ZM123.934 34.5065C123.395 34.4194 123.594 34.4633 123.27 34.498C123.052 34.5239 122.818 34.4803 122.856 34.555C123.233 34.5071 123.872 34.5816 123.934 34.5065ZM116.498 34.9205C116.842 34.8335 115.585 34.8459 115.524 34.9927C115.762 34.9731 116.336 34.9613 116.498 34.9205ZM103.363 90.2292C103.329 90.1918 103.336 90.0763 103.212 90.0678C103.013 90.0547 102.818 90.1168 102.928 90.1661C102.962 90.1809 103.343 90.1905 103.363 90.2292ZM129.365 88.0148C129.567 88.0514 128.9 88.3309 128.622 88.4017C128.685 88.3803 128.749 88.3577 128.812 88.3348C128.779 88.3214 128.75 88.3065 128.717 88.2929C128.785 88.2649 128.853 88.2362 128.921 88.2065C128.835 88.2133 128.756 88.2131 128.674 88.2162C128.825 88.0478 128.853 88.1102 129.108 88.022C129.271 87.9636 129.324 87.9018 129.517 87.8072C130.423 87.3601 131.254 86.7229 131.999 86.0189C132.054 86.089 132.051 86.1246 131.917 86.2661C131.907 86.2395 131.896 86.2136 131.885 86.1876C131.799 86.281 131.713 86.373 131.627 86.4632C131.723 86.4001 131.818 86.3364 131.911 86.2725C131.87 86.3148 131.817 86.3666 131.751 86.4297C131.702 86.4762 131.71 86.5171 131.638 86.5732C131.484 86.6937 131.229 86.76 131.073 86.9104C130.982 86.9971 131.167 86.9868 130.912 87.1343C131.021 86.9677 131.09 86.846 130.733 87.1289C130.979 87.037 130.797 87.1328 130.732 87.2159C130.692 87.2693 131.008 87.0432 130.82 87.2216C130.785 87.2658 130.134 87.7125 130.135 87.6342C130.144 87.4762 130.19 87.4791 129.773 87.782C130.352 87.5322 129.875 87.8935 129.602 87.9798C129.466 88.023 129.67 87.861 129.365 88.0148ZM108.643 89.7959C108.667 89.8032 109.19 89.763 109.2 89.7193C109.11 89.7101 108.48 89.7397 108.643 89.7959ZM114.749 34.997C114.853 34.9503 114.373 34.9747 114.319 34.9891C114.105 35.0462 114.643 35.0437 114.749 34.997ZM129.548 36.8176C129.504 36.7703 129.174 36.4895 129.144 36.4991C129.584 37.0211 129.899 37.1889 129.548 36.8176ZM118.222 89.3878C118.703 89.4476 118.809 89.2713 118.848 89.252C119.048 89.1528 119.085 89.3008 119.129 89.2983C119.337 89.2832 119.105 89.134 119.077 89.1326C118.629 89.1112 118.733 89.2327 118.682 89.274C118.57 89.3637 118.27 89.3118 118.222 89.3878ZM99.3675 90.3806C99.5296 90.4032 99.7832 90.3534 99.6607 90.3211C99.5378 90.2888 99.1671 90.3525 99.3675 90.3806ZM132.718 85.3167C132.907 85.2584 132.431 85.6897 132.381 85.7323C132.246 85.8693 132.248 85.9517 132.121 86.0216C132.109 86.0271 132.163 85.8883 132.225 85.8192C132.292 85.7533 132.702 85.328 132.718 85.3167ZM81.0778 84.4811C81.1711 84.754 81.0451 84.7462 81.0459 84.4359C81.046 84.4244 81.0462 84.4126 81.0462 84.4002C81.0568 84.4232 81.0672 84.4491 81.0778 84.4811ZM106.61 89.9637C106.667 89.9684 106.725 89.9728 106.782 89.9774C106.779 89.9578 106.774 89.9379 106.77 89.9183C106.655 89.9452 106.54 89.9723 106.425 89.9993C106.467 90.0078 106.51 90.0164 106.553 90.0249C106.572 90.0046 106.591 89.984 106.61 89.9637ZM132.785 85.2811C132.934 85.0957 133.076 84.9043 133.21 84.7084C133.21 84.7089 133.21 84.7094 133.209 84.7098C133.214 84.7263 133.218 84.7431 133.222 84.7603C133.083 84.9391 132.937 85.1133 132.785 85.2811ZM108.932 90.334C109.213 90.3583 109.46 90.2208 109.307 90.1782C109.218 90.1535 108.974 90.2488 109.033 90.1587C109.448 90.1747 109.407 90.1026 109.401 90.0898C109.357 89.9982 109.666 89.9518 109.638 89.8748C109.622 89.8315 109.291 89.87 109.164 89.8661C109.111 89.8643 109.105 89.8282 109.095 89.8266C109.095 89.8266 109.094 89.8267 109.094 89.8267C108.969 89.8195 108.898 89.8601 108.772 89.8695C108.714 89.8736 108.674 89.8192 108.596 89.8432C108.518 89.8676 108.282 89.9619 108.268 89.9973C108.243 90.0609 108.479 90.0984 108.672 90.0377C108.766 90.0081 108.702 89.9205 108.975 89.9561C109.011 89.9608 109.16 90.0464 109.296 90.0331C109.126 90.0991 108.58 90.1281 108.35 90.1248C108.326 90.1917 108.711 90.1455 108.858 90.1691C108.983 90.1889 108.909 90.3306 108.932 90.334ZM116.76 89.5023C116.77 89.5278 116.567 89.681 116.889 89.5531C117 89.5089 116.986 89.4709 117.281 89.4493C117.006 89.4756 117.066 89.3654 117.038 89.3587C116.807 89.306 116.526 89.4486 116.564 89.5024C116.575 89.518 116.75 89.477 116.76 89.5023ZM131.911 86.2725C131.913 86.2704 131.915 86.2681 131.917 86.2661C131.917 86.2665 131.918 86.2669 131.918 86.2673C131.916 86.2688 131.913 86.2709 131.911 86.2725ZM121.924 89.1162C121.842 89.064 121.687 89.0914 121.504 89.1102C121.52 89.1295 121.536 89.1486 121.552 89.1679C121.676 89.1508 121.801 89.1333 121.924 89.1162ZM128.198 88.4722C128.2 88.4716 128.203 88.4709 128.205 88.4702C128.203 88.4745 128.199 88.4791 128.197 88.4833C128.197 88.4797 128.198 88.4758 128.198 88.4722ZM93.745 90.9047C93.5941 90.8377 93.0333 90.8451 93.3963 90.9065C93.4885 90.9219 93.6339 90.9065 93.745 90.9047ZM103.266 90.6276C103.526 90.6251 103.476 90.5514 103.412 90.508C103.584 90.4879 103.755 90.4696 103.926 90.4504C103.435 90.4732 103.443 90.382 103.428 90.2683C103.228 90.2641 103.367 90.337 103.158 90.3358C103.084 90.3352 103.085 90.287 103.071 90.2838C102.9 90.2481 102.875 90.3899 102.976 90.3992C103.079 90.4084 103.316 90.3658 103.37 90.4198C103.201 90.4548 103.054 90.4257 102.853 90.4517C102.614 90.4828 102.809 90.5428 102.882 90.5208C103.028 90.4766 102.934 90.4263 103.192 90.4616C103.413 90.4918 103.061 90.6294 103.266 90.6276ZM120.322 89.2463C120.121 89.2791 119.92 89.3118 119.72 89.3445C120.005 89.3197 120.11 89.3057 120.273 89.3671C120.289 89.3269 120.305 89.2865 120.322 89.2463ZM128.173 88.5226C128.212 88.5126 128.251 88.5015 128.288 88.4892C128.284 88.4934 128.279 88.4978 128.275 88.5021C128.348 88.4878 128.421 88.4726 128.495 88.4564C128.407 88.4941 128.319 88.5307 128.231 88.5657C128.211 88.5515 128.193 88.5369 128.173 88.5226ZM105.08 90.1929C105.033 90.1945 104.985 90.196 104.939 90.1974C104.883 90.2224 104.826 90.2476 104.77 90.2727C104.801 90.2814 104.833 90.29 104.865 90.2987C104.937 90.2635 105.007 90.2281 105.08 90.1929ZM112.369 89.7559C112.481 89.7818 112.701 89.8376 112.851 89.7805C112.645 89.7561 112.641 89.7231 112.369 89.7559ZM118.893 89.4878C119.111 89.481 119.257 89.3924 119.227 89.3401C119.08 89.3582 118.932 89.3764 118.785 89.3945C118.821 89.4256 118.857 89.4567 118.893 89.4878ZM110.246 89.9729C109.374 90.1315 110.871 90.0478 110.968 89.999C111.151 89.9064 110.482 89.9873 110.399 89.9716C110.316 89.9556 110.359 89.8529 110.126 89.9106C110.038 89.9325 110.138 89.9732 110.246 89.9729ZM104.624 90.6203C104.882 90.6056 105.291 90.5153 105.58 90.4987C105.751 90.489 105.747 90.5295 105.919 90.5197C106.177 90.5053 106.629 90.4875 106.87 90.4488C106.958 90.4346 106.933 90.3617 106.916 90.3542C106.873 90.3366 106.736 90.3817 106.675 90.3782C106.615 90.3746 106.68 90.3405 106.597 90.3416C106.514 90.3427 106.056 90.3806 106.023 90.3881C105.827 90.4334 106.071 90.4602 105.839 90.4658C105.721 90.2172 106.392 90.3399 106.511 90.319C106.957 90.2405 106.589 90.2405 106.5 90.2237C106.412 90.2069 106.624 90.1629 106.576 90.1444C106.576 90.1445 106.575 90.1446 106.574 90.1448C106.526 90.1261 106.204 90.1378 106.166 90.1579C106.083 90.2015 106.373 90.217 106.142 90.2561C105.851 90.2663 105.552 90.2763 105.258 90.2866C105.269 90.3193 105.281 90.352 105.291 90.3847C105.357 90.3699 105.425 90.3547 105.491 90.3397C105.544 90.3474 105.597 90.3552 105.65 90.3627C105.348 90.5633 104.96 90.3801 104.441 90.492C104.468 90.4519 104.492 90.4104 104.522 90.3712C103.755 90.3639 104.264 90.388 104.253 90.484C104.247 90.539 104.013 90.501 103.96 90.5124C103.597 90.5928 104.365 90.6352 104.624 90.6203ZM119.631 89.3874C119.512 89.3911 119.393 89.3947 119.275 89.3984C119.27 89.4118 119.264 89.4254 119.259 89.4386C119.378 89.4348 119.496 89.4313 119.614 89.4275C119.619 89.4142 119.626 89.4007 119.631 89.3874ZM116.507 89.8033C116.713 89.7388 116.906 89.7222 117.171 89.723C117.246 89.6544 117.321 89.5859 117.395 89.5174C116.986 89.5373 117.286 89.6228 116.929 89.6315C116.884 89.6645 117.085 89.6367 117.05 89.656C116.88 89.7502 116.64 89.6556 116.402 89.717C116.436 89.7457 116.472 89.7745 116.507 89.8033ZM102.275 90.726C102.239 90.6114 101.888 90.7024 101.683 90.6548C101.622 90.6399 101.961 90.5268 101.601 90.5137C101.484 90.5096 101.023 90.5615 100.874 90.5366C100.809 90.5847 101.159 90.7443 101.217 90.7533C101.597 90.8105 101.903 90.6918 102.275 90.726ZM96.5166 91.0243C96.727 90.8592 96.2894 90.9895 96.0777 90.9341C96.0152 90.9173 96.2816 90.8313 95.9901 90.8454C95.8093 90.8763 95.9616 90.9102 95.8761 90.9461C95.7897 90.9819 95.2646 90.9908 95.5724 91.0569C95.6679 91.0773 96.3489 90.9785 96.5166 91.0243ZM94.7251 90.9293C94.3261 90.949 94.2669 91.0403 94.6353 90.9811C94.7139 90.9685 94.7224 90.9491 94.7251 90.9293ZM121.992 89.2938C121.831 89.3125 121.569 89.2814 121.549 89.3471C121.688 89.3495 121.828 89.3518 121.967 89.354C121.976 89.334 121.985 89.3139 121.992 89.2938ZM122.634 89.2735C122.511 89.2907 122.386 89.3077 122.262 89.3248C122.378 89.3277 122.494 89.3309 122.609 89.3339C122.618 89.3138 122.626 89.2936 122.634 89.2735ZM119.289 89.5369C119.212 89.5264 119.135 89.5156 119.058 89.5051C118.982 89.5471 118.906 89.5891 118.83 89.6311C118.983 89.5998 119.136 89.5682 119.289 89.5369ZM114.494 89.9066C114.687 89.905 115.229 89.7535 114.66 89.842C114.656 89.8222 114.652 89.8024 114.648 89.7826C114.597 89.8238 114.546 89.8654 114.494 89.9066ZM94.0484 91.053C93.8629 91.074 93.5645 91.0599 93.5291 91.1311C93.6694 91.1327 93.8097 91.1345 93.95 91.1361C93.9825 91.1084 94.0159 91.0806 94.0484 91.053ZM112.426 89.9733C112.173 90.0693 113.105 90.0841 113.146 89.91C112.97 89.9279 112.546 89.9284 112.426 89.9733ZM113.72 89.9227C113.644 89.976 113.998 89.9581 114.039 89.9422C114.196 89.8789 113.797 89.8693 113.72 89.9227ZM106.984 90.3869C107.364 90.4307 107.222 90.4016 107.444 90.34C107.594 90.2983 107.76 90.3535 107.731 90.2637C107.467 90.3106 107.018 90.2852 106.984 90.3869ZM102.709 90.7199C102.752 90.722 103.054 90.7082 103.063 90.6785C102.587 90.5537 102.353 90.7029 102.709 90.7199Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M122.985 59.8655L113.36 60.4458L121.405 55.1309L119.384 52.0699L111.338 57.3847L115.647 48.7601L112.365 47.1197L108.057 55.7444L107.476 46.1206L103.815 46.3413L104.396 55.966L99.0799 47.9207L96.0198 49.9425L101.335 57.9869L92.7092 53.678L91.0698 56.9589L99.6951 61.2687L90.0707 61.8489L90.2915 65.5102L99.915 64.93L91.8707 70.2448L93.8925 73.3059L101.937 67.9919L97.6271 76.6166L100.909 78.256L105.218 69.6305L105.799 79.2551L109.46 79.0344L108.88 69.4107L114.193 77.4551L117.254 75.4333L111.94 67.388L120.565 71.6978L122.204 68.416L113.58 64.1071L123.203 63.5269L122.983 59.8656L122.985 59.8655ZM106.938 67.6672C104.178 67.8337 101.805 65.7311 101.639 62.9703C101.472 60.2096 103.575 57.8371 106.336 57.6706C109.096 57.5042 111.469 59.607 111.635 62.3677C111.801 65.1284 109.699 67.5008 106.938 67.6672Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M79.8862 43.1973C82.7846 45.0075 84.4952 48.4161 83.9666 52.0133L80.886 72.9769C80.5274 72.0368 80.324 71.0191 80.3072 69.9547L79.8862 43.1973Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M152.163 41.95C152.422 42.1727 157.679 41.5416 156.414 40.7276C156.007 40.3685 155.55 40.383 155.288 40.8755C155.355 39.9005 154.106 41.1453 153.715 40.8078C154.029 40.1402 152.331 41.483 152.754 40.7931C147.444 39.8042 134.971 45.8342 149.285 42.5314C148.017 42.1648 149.336 41.9571 149.903 42.1348C148.852 42.9578 151.526 42.3273 152.055 42.0509C151.274 42.0312 152.697 41.4548 152.161 41.9477L152.163 41.95Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M144.103 33.2987C144.826 33.2902 148.886 28.6898 149.364 28.2563C150.233 27.1752 148.612 27.0082 148.131 27.9422C147.96 28.0977 147.191 29.4236 146.989 28.83C145.525 29.0606 144.786 31.4609 143.573 31.5539C143.69 31.8803 143.187 32.2387 143.235 32.4555C142.892 32.4019 142.593 32.851 142.668 32.8962C140.902 34.0119 142.442 35.5039 143.632 33.8363C143.677 33.9123 144.152 33.631 144.102 33.3032L144.103 33.2987Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M127.951 23.5219C127.133 24.2779 127.365 23.4494 127.768 23.0838C128.184 23.8171 128.556 22.1695 128.459 21.7379C128.385 21.9073 128.074 21.9198 128.207 21.5664C128.861 21.9306 130.489 17.4535 128.262 19.3334C128.24 19.4107 128.809 19.5378 128.599 19.599C127.769 19.307 128.15 20.1124 128.152 20.3224C127.697 20.2448 128.058 20.5024 127.853 20.5223C127.319 20.1801 127.968 21.4947 127.451 21.121C126.178 22.0024 126.739 24.2402 125.63 24.8919C126.478 25.6001 123.857 28.6536 126.237 27.6949C127.149 26.3436 127.783 25.2187 127.951 23.5219Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M141.26 16.6354C139.968 16.0531 139.255 19.1998 138.4 19.9494C137.24 20.8363 130.777 31.3271 134.487 28.9268C136.417 25.7404 138.534 23.3591 140.406 19.293C140.758 18.6458 142.275 16.7035 141.26 16.6354Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M142.897 51.6418C141.713 52.6636 141.02 51.0539 139.942 51.8779C138.193 53.5089 148.442 55.7454 148.714 53.8345C148.718 52.1988 143.419 52.438 142.897 51.6418Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M34.0511 21.4768C34.2527 21.2013 33.2103 16.0093 32.4983 17.3346C32.1723 17.7687 32.2227 18.2234 32.7342 18.4455C31.757 18.4552 33.0961 19.603 32.7904 20.0191C32.1002 19.759 33.5723 21.3456 32.8512 20.9785C32.2828 26.35 39.2746 38.31 34.8569 24.2999C34.5911 25.5931 34.2804 24.2942 34.413 23.7151C35.3161 24.6984 34.4773 22.0823 34.1602 21.5767C34.2019 22.3562 33.5154 20.9832 34.0489 21.4788L34.0511 21.4768Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M26.0595 30.1916C25.9942 29.4715 21.0889 25.7855 20.6193 25.3436C19.4732 24.562 19.4342 26.1915 20.403 26.5975C20.5714 26.7551 21.9537 27.4177 21.3778 27.666C21.7228 29.1074 24.1738 29.6551 24.3617 30.8568C24.678 30.7147 25.0748 31.1878 25.2873 31.1236C25.2607 31.4691 25.7319 31.7319 25.7711 31.6538C27.0221 33.3266 28.3884 31.6739 26.6325 30.6184C26.7047 30.5685 26.3869 30.1163 26.0641 30.1922L26.0595 30.1916Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M17.583 47.0616C18.401 47.8181 17.5568 47.6517 17.1607 47.2789C17.859 46.8064 16.1872 46.5647 15.7646 46.6957C15.9394 46.7564 15.9762 47.0647 15.6134 46.9599C15.9251 46.2791 11.3339 45.0084 13.383 47.0808C13.4619 47.097 13.5438 46.5198 13.6214 46.7245C13.3954 47.5741 14.1684 47.1313 14.3777 47.1132C14.336 47.573 14.5644 47.192 14.6005 47.3953C14.3013 47.9545 15.5608 47.2038 15.2289 47.7488C16.2076 48.9483 18.3943 48.213 19.1312 49.2674C19.7707 48.367 23.0207 50.7398 21.8778 48.4424C20.4591 47.6393 19.2878 47.0962 17.583 47.0616Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M9.67164 34.335C9.19267 35.669 12.3858 36.1327 13.2002 36.9259C14.1755 38.0131 25.1419 43.6314 22.4575 40.1213C19.1292 38.4474 16.5888 36.5239 12.3882 34.9777C11.7153 34.6782 9.65976 33.3177 9.67164 34.335Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M44.4412 29.9519C45.553 31.0521 44.0027 31.8695 44.9089 32.8789C46.6723 34.4945 48.0962 24.1012 46.1699 23.9803C44.539 24.1056 45.1939 29.3686 44.4412 29.9519Z",
                fill: "#101214"
            })
        ]
    });

});


parcelRegister("bQ7Jf", function(module, exports) {
$parcel$export(module.exports, "StorageAccessPage", () => $ed3c22dd93ae1fa7$export$64a8a56a2c35628c);
/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $kopi2 = parcelRequire("kopi2");

var $j2zMY = parcelRequire("j2zMY");

var $lRq8t = parcelRequire("lRq8t");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");

var $eGOwo = parcelRequire("eGOwo");
const $ed3c22dd93ae1fa7$var$iframeStyles = null;
const $ed3c22dd93ae1fa7$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const iframeRef = (0, $eJOHy.useRef)(null);
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $eJOHy.useMemo)(()=>{
        const uniqueKeyParam = uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? `&uniqueKey=${uniqueKey}` : '';
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}${uniqueKeyParam}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url,
        uniqueKey
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopi2.ExperienceStart), {
                name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                "data-testid": "storage-access-page-iframe",
                title: "storage-access-iframe",
                src: src,
                ref: iframeRef,
                className: (0, $hcewu.default)([
                    "_19itglyw _1bsb1osq _4t3i1osq"
                ])
            })
        ]
    });
};

});

parcelRegister("bbc8b", function(module, exports) {
$parcel$export(module.exports, "themeStateObjectToQueryString", () => $05685c35af67dcaf$export$6e43e60d51b79331);
$parcel$export(module.exports, "useUrl", () => $05685c35af67dcaf$export$305222dff575c4e3);

var $eJOHy = parcelRequire("eJOHy");

var $4CCpn = parcelRequire("4CCpn");

var $eGOwo = parcelRequire("eGOwo");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");

var $8HgDC = parcelRequire("8HgDC");

var $lRq8t = parcelRequire("lRq8t");

var $944VV = parcelRequire("944VV");

var $8edRS = parcelRequire("8edRS");
const $05685c35af67dcaf$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $4CCpn.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $05685c35af67dcaf$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $05685c35af67dcaf$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $05685c35af67dcaf$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $eJOHy.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $eJOHy.useMemo)(()=>allowedFeatures === 'all' ? (0, $8HgDC.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$05685c35af67dcaf$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $944VV.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $944VV.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $lRq8t.default)();
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const queryParams = (0, $eJOHy.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $05685c35af67dcaf$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            ...$05685c35af67dcaf$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $05685c35af67dcaf$var$CONTEXT_PATH = '/wiki/spaces';
const $05685c35af67dcaf$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $05685c35af67dcaf$var$constructUrl(mode = (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$05685c35af67dcaf$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$05685c35af67dcaf$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$05685c35af67dcaf$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $05685c35af67dcaf$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}

});
parcelRegister("944VV", function(module, exports) {
$parcel$export(module.exports, "isRedirectionEnabled", () => $96d0b9880a83dcb1$export$51abd16148027412);
$parcel$export(module.exports, "getCrossSiteTenantIdFromAllowedFeature", () => $96d0b9880a83dcb1$export$243fbba563b8aa8e);
const $96d0b9880a83dcb1$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $96d0b9880a83dcb1$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};

});


parcelRegister("d5di2", function(module, exports) {
$parcel$export(module.exports, "Subjects", () => $5039f3b5eeec03e2$export$29953e2fb702813a);
$parcel$export(module.exports, "LoadingStatus", () => $5039f3b5eeec03e2$export$19d37de7e9a4af59);
$parcel$export(module.exports, "useValidationState", () => $5039f3b5eeec03e2$export$1faa35b5a06780c0);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");

var $eGOwo = parcelRequire("eGOwo");

var $j2zMY = parcelRequire("j2zMY");

var $8edRS = parcelRequire("8edRS");
var $5039f3b5eeec03e2$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $5039f3b5eeec03e2$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $5039f3b5eeec03e2$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $5039f3b5eeec03e2$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $5039f3b5eeec03e2$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
					 */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported.
          So we can skip asking for storage access and direct user to the Login CTA.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $5039f3b5eeec03e2$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $eJOHy.useReducer)($5039f3b5eeec03e2$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    const { uniqueKey: uniqueKey } = (0, $8edRS.useUniqueKey)();
    const messageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { subject: subject, result: result, embeddedConfluenceUrl: embeddedConfluenceUrl } = messageEvent.data ?? {};
        const messageKey = embeddedConfluenceUrl && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed') ? new URL(embeddedConfluenceUrl).searchParams.get('uniqueKey') : null;
        if (!subject || !result || messageKey && uniqueKey && messageKey !== uniqueKey && (0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $j2zMY.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $j2zMY.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $j2zMY.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker,
        uniqueKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};

});


parcelRegister("jgJaV", function(module, exports) {
$parcel$export(module.exports, "useFooter", () => $ccc878979acefb1a$export$d07da6ac6fc160b0);

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $3V5nR = parcelRequire("3V5nR");
const $ccc878979acefb1a$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $eJOHy.useState)(standaloneConfluenceUrl);
    (0, $eJOHy.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $j2zMY.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
	 * Currently footer is hidden for the JSM Portal view which passes
	 * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
	 *
	 * JSM portal view will provide "JSM-Portal" as the parent product eventually
	 * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
	 * We need to support these two parent product keys to keep backward compatible for the time being.
	 *
	 * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
	 *
	 * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
	 * External API remains unchanged.
	 */ const showFooter = (0, $eJOHy.useMemo)(()=>{
        const parentProducts = [
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $3V5nR.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};

});

parcelRegister("3ca9m", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ddffc24222dbaf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $72ddffc24222dbaf$var$messages = (0, $7qGN1.defineMessages)({
    viewInConfluence: {
        id: 'embedded.confluence.footer.hover.text',
        description: 'Hover text on Confluence Footer Content',
        defaultMessage: 'View in Confluence'
    },
    poweredBy: {
        id: 'embedded.confluence.footer.prefix',
        description: 'Prefix label on Confluence Logo',
        defaultMessage: 'Powered by'
    }
});
var $72ddffc24222dbaf$export$2e2bcd8739ae039 = $72ddffc24222dbaf$var$messages;

});

parcelRegister("bF4mB", function(module, exports) {
$parcel$export(module.exports, "IframeLoadingScreen", () => $b8e6c349b8b4992c$export$666e684aed003bfe);
/* IframeLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");

var $jjS5D = parcelRequire("jjS5D");
const $b8e6c349b8b4992c$var$visibilityStyles = {
    hidden: "_1e0cglyw",
    invisible: "_tzy4idpf _4t3i1osq",
    visible: "_tzy4kb7n _4t3i1osq"
};
const $b8e6c349b8b4992c$var$overlayStyles = {
    default: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _1bahv2br _1pbyb4wl"
};
const $b8e6c349b8b4992c$var$containerStyles = {
    default: "_kqswh2mm _1bsb1osq _4t3i1osq"
};
const $b8e6c349b8b4992c$export$666e684aed003bfe = ({ children: children, iframeLoaded: iframeLoaded, isLoading: isLoading })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
        xcss: $b8e6c349b8b4992c$var$containerStyles.default,
        "aria-busy": isLoading,
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hYvlq.default), {
                gap: "space.400",
                alignItems: "start",
                xcss: isLoading ? $b8e6c349b8b4992c$var$overlayStyles.default : $b8e6c349b8b4992c$var$visibilityStyles.hidden,
                "aria-hidden": !isLoading,
                role: "status",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "250px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjS5D.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.0",
                "aria-hidden": isLoading,
                xcss: !iframeLoaded ? $b8e6c349b8b4992c$var$visibilityStyles.invisible : $b8e6c349b8b4992c$var$visibilityStyles.visible,
                children: children
            })
        ]
    });

});


parcelRegister("lCbi5", function(module, exports) {
$parcel$export(module.exports, "useGetCurrentScrollPosition", () => $8510204e3c256619$export$4d8f561c32665bbe);

var $eJOHy = parcelRequire("eJOHy");

var $8qtes = parcelRequire("8qtes");
// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $8510204e3c256619$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $8510204e3c256619$export$4d8f561c32665bbe = (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $eJOHy.useState)(0);
    const defaultScrollPosition = (0, $eJOHy.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $eJOHy.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $8qtes.useMediaViewerListener)();
    (0, $eJOHy.useEffect)(()=>{
        const handleScroll = $8510204e3c256619$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
					Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
					it may already have been opened or closed, and we do not have control over the actions that occur
					just before the media viewer is activated (which happens in a different package that we do not manage).
					Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
					This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
					which is misleading since the container height will have been reduced at this point.
					To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
					When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
					inaccuracies associated with saving the scroll position under the conditions of a condensed height.
				*/ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};

});





parcelRegister("6ijO8", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $8212e0b78a96b746$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jyZeU = parcelRequire("jyZeU");

var $lWsis = parcelRequire("lWsis");

var $gWqMk = parcelRequire("gWqMk");
const $8212e0b78a96b746$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lWsis.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gWqMk.EditPage), {
            ...props
        })
    });

});
parcelRegister("gWqMk", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $1919213bb3817aab$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6q6x9 = parcelRequire("6q6x9");

var $lRq8t = parcelRequire("lRq8t");
const $1919213bb3817aab$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6q6x9.EditPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("6q6x9", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $e16a2d7d4327cedc$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $TJJ14 = parcelRequire("TJJ14");

var $7oRxl = parcelRequire("7oRxl");

var $jyZeU = parcelRequire("jyZeU");

var $lzAG1 = parcelRequire("lzAG1");

var $4nJ3E = parcelRequire("4nJ3E");

var $8edRS = parcelRequire("8edRS");
const $e16a2d7d4327cedc$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $4nJ3E.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jyZeU.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $lzAG1.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8edRS.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7oRxl.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $TJJ14.EditPage), {
                    ...props
                })
            })
        })
    });
};

});
parcelRegister("TJJ14", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $2003a24730d7f067$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j2zMY = parcelRequire("j2zMY");

var $fzBRQ = parcelRequire("fzBRQ");
var $6DF4T = parcelRequire("6DF4T");

var $jWzbc = parcelRequire("jWzbc");
const $2003a24730d7f067$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $2003a24730d7f067$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>{
        const isTemplateBrowserEnabled = allowedFeatures === 'all' || allowedFeatures?.find((feature)=>feature === 'template-browser' || feature.hasOwnProperty('template-browser')) !== undefined;
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $2003a24730d7f067$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $j2zMY.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $j2zMY.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jWzbc.Content), {
        ...props,
        contentType: (0, $fzBRQ.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $6DF4T.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};

});






parcelRegister("dxRkJ", function(module, exports) {
$parcel$export(module.exports, "useConfluencePageData", () => $069cdb8482617006$export$10fb2803bc7b79fc);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $7y92E = parcelRequire("7y92E");
var $4CCpn = parcelRequire("4CCpn");
var $069cdb8482617006$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $069cdb8482617006$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $069cdb8482617006$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $069cdb8482617006$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $eGOwo.fg)('platform_deprecate_lp_cc_embed')) return undefined;
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($069cdb8482617006$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $4CCpn.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $eJOHy.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $7y92E.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};

});


parcelRegister("RCgNH", function(module, exports) {
$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        // Require: iframe loaded, mouse over, and >75% visible
        const isDwellAndHoverMetricsEnabled = (0, $eGOwo.fg)('rovo_chat_embed_card_dwell_and_hover_metrics');
        if (isDwellAndHoverMetricsEnabled) {
            // Note: Removed isWindowFocused requirement as it's unreliable and prevents tracking
            // The mouse over check is sufficient to indicate user engagement
            const shouldTrack = isIframeLoaded && isMouseOver && iframePercentVisible > 0.75;
            if (shouldTrack) {
                if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
                dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
            } else if (dwellTimeoutId.current) {
                clearInterval(dwellTimeoutId.current);
                dwellTimeoutId.current = undefined;
            }
        } else if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("diXta", function(module, exports) {
$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa);

var $eJOHy = parcelRequire("eJOHy");

var $kbv8x = parcelRequire("kbv8x");
const $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $kbv8x.default)();
    (0, $eJOHy.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve(url, true);
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});


parcelRegister("iUsXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {
$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    });
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title,
                    ...(0, $eGOwo.fg)('expose-product-details-from-smart-card') && {
                        extensionKey: details?.meta?.key
                    }
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details?.meta?.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {
$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1NG86 = parcelRequire("1NG86");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("4Rp6r", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");

var $g6YpQ = parcelRequire("g6YpQ");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v"
};
const $36fa193905cb5ef0$var$experimentEnabledStyles = {
    control: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    test1: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk",
    test2: "_syaz15cr _80omtlke _bfhk1i45 _qrwqlb4i _1o0zlb4i _irr3byip _1di61van"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $g6YpQ.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : experimentValue !== 'control' ? $36fa193905cb5ef0$var$experimentEnabledStyles[experimentValue] : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});


parcelRegister("6kw7n", function(module, exports) {
$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                appearance: "moved",
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: renderForbiddenAccessMessage()
            })
        });
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {
$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {
$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $eGOwo = parcelRequire("eGOwo");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            viewType: 'unauthorised',
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        viewType: "unauthorised",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            (0, $eGOwo.fg)('navx-2479-sl-fix-inilne-card-show-connect-button') ? onAuthorise && renderActionButton() : renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});


parcelRegister("ettNQ", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $6b9d8190953f47e0$export$ed70996d478e16d3);
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $6b9d8190953f47e0$export$e682245dc886cff2);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $b43DQ = parcelRequire("b43DQ");
function $6b9d8190953f47e0$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $eJOHy.useMemo)(()=>new (0, $b43DQ.SmartLinkEvents)(), []);
    return events;
}
function $6b9d8190953f47e0$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});


parcelRegister("k9P6L", function(module, exports) {
$parcel$export(module.exports, "LoadingCardLink", () => $9acebe3c2480723a$export$1ca0544321134ad6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kj3Kk = parcelRequire("kj3Kk");

const $9acebe3c2480723a$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ed49f57481afa45$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
const $6ed49f57481afa45$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';



parcelRegister("8ytjA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c96e4e33526d3a2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9c96e4e33526d3a2$var$messages = (0, $7qGN1.defineMessages)({
    noRepository: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-repository",
        "defaultMessage": "No repositories"
    },
    repositories: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.repositories.popup.heading",
        "defaultMessage": "Repositories"
    }
});
var $9c96e4e33526d3a2$export$2e2bcd8739ae039 = $9c96e4e33526d3a2$var$messages;

});

parcelRegister("1EGkp", function(module, exports) {
$parcel$export(module.exports, "default", () => $00acf8d77ad7b1c1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");

var $806LH = parcelRequire("806LH");

var $4cFYC = parcelRequire("4cFYC");
var $18DG7 = parcelRequire("18DG7");
var $fqBfo = parcelRequire("fqBfo");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $8ytjA = parcelRequire("8ytjA");
const $00acf8d77ad7b1c1$export$f5bfd0a3f83b1bb1 = 99;
const $00acf8d77ad7b1c1$var$RepositoriesPopup = ({ repositories: repositories })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    if (repositories.length === 0) return null;
    const list = repositories.slice(0, $00acf8d77ad7b1c1$export$f5bfd0a3f83b1bb1);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00acf8d77ad7b1c1$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00acf8d77ad7b1c1$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
            size: "xxsmall",
            as: "div"
        }, formatMessage((0, $8ytjA.default).repositories))), list.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00acf8d77ad7b1c1$var$Row, {
                key: `repository-link[${link.id}]`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00acf8d77ad7b1c1$var$CardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
                testId: "project-directories.components.compass-table.cells.repository.repository-links-popup.smart-link",
                url: link.url,
                appearance: "inline",
                placeholder: link.name || link.url,
                ui: {
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    clickableContainer: true
                },
                onClick: ()=>{
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    });
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'repositoryLink');
                },
                actionOptions: {
                    hide: false,
                    exclude: [
                        (0, $18DG7.CardAction).ChangeStatusAction
                    ]
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
                text: link.name,
                maxLines: 1
            }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        messageId: "project-directories.components.compass-table.cells.repository.repository-links-popup.popup",
        messageType: "transactional",
        content: content,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00acf8d77ad7b1c1$var$BadgeContainer, {
                ...triggerProps,
                onClick: ()=>{
                    setIsOpen(!isOpen);
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button'
                    });
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'repositoryLinkPopup');
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
                testId: "project-directories.components.compass-table.cells.repository.repository-links-popup.badge-button",
                appearance: !isOpen ? undefined : 'primaryInverted'
            }, "+", list.length))
    });
};
var $00acf8d77ad7b1c1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $00acf8d77ad7b1c1$var$RepositoriesPopup;
const $00acf8d77ad7b1c1$var$BadgeContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80omtlke _19pk1b66 _2hwxidpf _otyr1b66 _18u01b66 _ll8p4viv _1lginkaw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00acf8d77ad7b1c1$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb35xw _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00acf8d77ad7b1c1$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrutpp _ngc0i7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00acf8d77ad7b1c1$var$CardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00acf8d77ad7b1c1$var$Row = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _4cvr1h6o _1bsb35xw _4t3i1ylp _otyru2gc _bfhkysee",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4cFYC", function(module, exports) {
$parcel$export(module.exports, "Card", () => $67163b0d69104250$export$60332b2344f7fe41);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $b43DQ = parcelRequire("b43DQ");

var $8BtgY = parcelRequire("8BtgY");
class $67163b0d69104250$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BtgY.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: content
        });
    }
}
const $67163b0d69104250$export$60332b2344f7fe41 = (0, $dUaMU.default)((0, $b43DQ.context))((0, $4J0ad.default)()((0, $6YFG2.default)($67163b0d69104250$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("8BtgY", function(module, exports) {
$parcel$export(module.exports, "CardWithURLRenderer", () => $6c611c6f38b38dd4$export$e00a7788e30dc998);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $FoFt2 = parcelRequire("FoFt2");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $k9P6L = parcelRequire("k9P6L");

const $6c611c6f38b38dd4$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(0, $FoFt2.importWithRetry)(()=>(parcelRequire("eqNuj"))));
function $6c611c6f38b38dd4$export$e00a7788e30dc998(props) {
    (0, $gRw8I.di)($6c611c6f38b38dd4$export$a7690c318cd6a95e);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $eJOHy.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $2QXr6.clearMarks)(id);
            (0, $2QXr6.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $1YI3f.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $eJOHy.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($6c611c6f38b38dd4$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("eqNuj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("6nRbC")
]).then(()=>parcelRequire('kzwZ8'));

});





parcelRegister("a4oPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $610e33837d234016$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6wydN = parcelRequire("6wydN");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $kq24V = parcelRequire("kq24V");
const $610e33837d234016$var$messages = (0, $7qGN1.defineMessages)({
    noScorecards: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-scorecards",
        "defaultMessage": "No scorecards"
    }
});
function $610e33837d234016$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, scorecardScores: scorecardScores } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (scorecardScores.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6wydN.default), {
        componentId: componentId,
        scorecardScores: scorecardScores,
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'scorecardHealthLozenge');
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kq24V.SubtleText), null, formatMessage($610e33837d234016$var$messages.noScorecards));
}

});
parcelRegister("6wydN", function(module, exports) {
$parcel$export(module.exports, "default", () => $44d55b4638d187a7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $48BVs = parcelRequire("48BVs");

var $02X06 = parcelRequire("02X06");
function $44d55b4638d187a7$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, scorecardScores: scorecardScores, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [isLozengeHovered, setIsLozengeHovered] = (0, $eJOHy.useState)(false);
    const scorecardHealthCount = (0, $eJOHy.useMemo)(()=>(0, $48BVs.getScorecardHealthCountsFromScores)(scorecardScores), [
        scorecardScores
    ]);
    const summary = (0, $eJOHy.useMemo)(()=>(0, $48BVs.getSummaryText)(scorecardHealthCount, scorecardScores.length, formatMessage), [
        scorecardHealthCount,
        scorecardScores.length,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        messageId: "compass-common.ui.scorecards-health-lozenge.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $02X06.default), {
                componentId: componentId
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "none",
                onClick: (e, analyticsEvent)=>{
                    setIsOpen(!isOpen);
                    onClick?.(e, analyticsEvent);
                },
                onMouseOver: ()=>{
                    setIsLozengeHovered(true);
                },
                onFocus: ()=>{
                    setIsLozengeHovered(true);
                },
                onMouseLeave: ()=>{
                    setIsLozengeHovered(false);
                },
                onBlur: ()=>{
                    // React uses onFocus and onBlur instead of onFocusIn and onFocusOut.
                    setIsLozengeHovered(false);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                isBold: isLozengeHovered,
                appearance: $44d55b4638d187a7$var$getLozengeStyle(scorecardHealthCount)
            }, summary))
    });
}
const $44d55b4638d187a7$var$getLozengeStyle = (scorecardHealthCount)=>{
    if (scorecardHealthCount.passing + scorecardHealthCount.needsAttention < scorecardHealthCount.total) return 'removed';
    if (scorecardHealthCount.needsAttention > 0) return 'moved';
    return 'success';
};

});
parcelRegister("02X06", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c151400f4a19ad5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $48BVs = parcelRequire("48BVs");

var $7AoUp = parcelRequire("7AoUp");

var $64JNK = parcelRequire("64JNK");

var $ddydw = parcelRequire("ddydw");

var $6Poc4 = parcelRequire("6Poc4");

var $YOkQb = parcelRequire("YOkQb");

var $la82x = parcelRequire("la82x");
const $7c151400f4a19ad5$var$NUMBER_OF_SCORECARDS_TO_DISPLAY = 5;
function $7c151400f4a19ad5$export$2e2bcd8739ae039({ testId: testId, componentId: componentId }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { scorecards: scorecards, loading: loading, error: error } = (0, $7AoUp.useGetComponentScorecards)(componentId);
    const scorecardsSortedByHealth = (0, $eJOHy.useMemo)(()=>(0, $48BVs.getScorecardsSortedByHealth)(scorecards), [
        scorecards
    ]);
    const handleViewMoreClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'scorecardsHealthInfoDetailsViewMore');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ContentWrapper, {
        "data-testid": testId
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Poc4.default), null), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ddydw.GenericErrorGlyph), {
        "data-testid": `${testId}.generic-error-glyph`
    })), !loading && !error && scorecardsSortedByHealth.slice(0, $7c151400f4a19ad5$var$NUMBER_OF_SCORECARDS_TO_DISPLAY).map((scorecard, i)=>{
        const totalScore = scorecard?.scorecardScore?.totalScore ?? 0;
        const { id: scorecardId } = scorecard;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: scorecardId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ScorecardWrapper, {
            "data-testid": `${testId}-scorecard-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ScorecardInfoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ScorecardName, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ScorecardButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'scorecardsHealthInfoDetailsScorecardName');
            },
            href: `/compass/scorecard/${(0, $48BVs.getIdFromAri)(scorecardId)}`,
            target: "_blank",
            rel: "noopener noreferrer",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $7c151400f4a19ad5$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $64JNK.ScorecardGlyph), null))
        }, scorecard.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$ScorecardScore, null, totalScore, "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $la82x.default), {
            progress: totalScore,
            size: "medium",
            testId: `dragonfruit-scorecards.common.ui.progress-bar-${scorecardId}`
        })));
    }), !error && scorecards.length > $7c151400f4a19ad5$var$NUMBER_OF_SCORECARDS_TO_DISPLAY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c151400f4a19ad5$var$LinkWrapper, {
        href: `/compass/component/${(0, $48BVs.getIdFromAri)(componentId)}`,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handleViewMoreClick
    }, formatMessage((0, $YOkQb.default).viewMore)));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbncxg _1tke1ul9 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ScorecardWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_iv8mpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ScorecardInfoWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ScorecardName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjt94y _sudp1e54",
            __cmplp.className
        ])
    });
});
const $7c151400f4a19ad5$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ScorecardButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1tjq4viv _9n9ov77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ScorecardScore = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8140y _syazi7uo _ca0qv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$LinkWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _19pkpxbi _k48p1wq8 _syazi7uo _30l3i7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c151400f4a19ad5$var$ErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7AoUp", function(module, exports) {
$parcel$export(module.exports, "useGetComponentScorecards", () => $0881c1b506a6acfc$export$be1e628de8d400bd);

var $eJOHy = parcelRequire("eJOHy");

var $hA0fK = parcelRequire("hA0fK");

var $lSQFj = parcelRequire("lSQFj");
const $0881c1b506a6acfc$export$be1e628de8d400bd = (componentId)=>{
    const { data: data, loading: loading, error: error } = (0, $hA0fK.useFetchQuery)((0, $lSQFj.GET_COMPASS_COMPONENTS_SCORECARDS_QUERY), {
        componentId: componentId
    });
    const scorecards = (0, $eJOHy.useMemo)(()=>{
        if (!loading && data?.compass?.component?.__typename === 'CompassComponent') {
            const dataFields = data.compass.component.scorecards ?? [];
            return dataFields?.map((field)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    id: field?.id ?? '',
                    name: field?.name ?? '',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    scorecardScore: {
                        totalScore: field.scorecardScore?.totalScore ?? 0,
                        maxTotalScore: field.scorecardScore?.maxTotalScore ?? 0
                    }
                }));
        }
        return [];
    }, [
        data,
        loading
    ]);
    return {
        scorecards: scorecards,
        loading: loading,
        error: error
    };
};

});
parcelRegister("lSQFj", function(module, exports) {
$parcel$export(module.exports, "GET_COMPASS_COMPONENTS_SCORECARDS_QUERY", () => $cf8b46db3a296362$export$c0ea2bb8dbfa2db2);

var $eqd0W = parcelRequire("eqd0W");
const $cf8b46db3a296362$export$c0ea2bb8dbfa2db2 = (0, $eqd0W.default);

});
parcelRegister("eqd0W", function(module, exports) {
$parcel$export(module.exports, "default", () => $522d0ca485b17123$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bb7716660d4602799b0a763d0a653cf>>
 * @relayHash b79d01d1417dd5ebf35e9e6ce7e430a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7febdf10a70f7001516fe01753aeea30c50d464b1f2371636cb48600d3aaf387
const $522d0ca485b17123$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "componentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "componentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "concreteType": "CompassScorecard",
                "kind": "LinkedField",
                "name": "scorecards",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "componentId",
                                        "variableName": "componentId"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "query"
                            }
                        ],
                        "concreteType": "CompassScorecardScore",
                        "kind": "LinkedField",
                        "name": "scorecardScore",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalScore"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "maxTotalScore"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "CompassComponent"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getCompassComponentsScorecardsQuery",
            "selections": [
                {
                    "concreteType": "CompassCatalogQueryApi",
                    "kind": "LinkedField",
                    "name": "compass",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getCompassComponentsScorecardsQuery",
            "selections": [
                {
                    "concreteType": "CompassCatalogQueryApi",
                    "kind": "LinkedField",
                    "name": "compass",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7febdf10a70f7001516fe01753aeea30c50d464b1f2371636cb48600d3aaf387",
            "metadata": {},
            "name": "getCompassComponentsScorecardsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$522d0ca485b17123$var$node.hash = "1f4b6300c590b864105e7550b7750dd7";
var $522d0ca485b17123$export$2e2bcd8739ae039 = $522d0ca485b17123$var$node;

});



parcelRegister("64JNK", function(module, exports) {
$parcel$export(module.exports, "ScorecardGlyph", () => $877ac2df2de7a325$export$7d48f4d7960794bf);

var $eJOHy = parcelRequire("eJOHy");
function $877ac2df2de7a325$export$7d48f4d7960794bf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.4188 11.9992C15.6081 14.0027 14.0093 15.603 12.0069 16.4157",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 7L8 11L6 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }));
}

});

parcelRegister("ddydw", function(module, exports) {
$parcel$export(module.exports, "GenericErrorGlyph", () => $bee8185d16777c63$export$1e65f4e15a4452f7);
// We are disabling the design rules because the "fill" attributes of the svg require a token that is not currently available for white

var $eJOHy = parcelRequire("eJOHy");
function $bee8185d16777c63$export$1e65f4e15a4452f7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "164",
        height: "212",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
}

});

parcelRegister("6Poc4", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a8ab5b4cccf6a7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
function $73a8ab5b4cccf6a7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73a8ab5b4cccf6a7$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), props));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73a8ab5b4cccf6a7$var$SpinnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("YOkQb", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b037a7a34aeb3b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3b037a7a34aeb3b4$var$messages = (0, $7qGN1.defineMessages)({
    viewMore: {
        "id": "compass-common.scorecards-health-lozenge.popup-content.view-more",
        "defaultMessage": "View more"
    }
});
var $3b037a7a34aeb3b4$export$2e2bcd8739ae039 = $3b037a7a34aeb3b4$var$messages;

});

parcelRegister("la82x", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d7d4549f19c3d3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $48BVs = parcelRequire("48BVs");
function $48d7d4549f19c3d3$export$2e2bcd8739ae039({ testId: testId, progress: progress, size: size = 'small' }) {
    const curProgress = Math.max(0, Math.min(progress, 100));
    const progressColor = (0, $48BVs.getColorForProgress)(curProgress);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48d7d4549f19c3d3$var$ProgressBarWrapper, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($48d7d4549f19c3d3$var$Bar, {
        "data-testid": testId,
        width: curProgress,
        background: progressColor,
        size: size
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48d7d4549f19c3d3$var$ProgressBarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _bfhk1l7x _kqswh2mm _1bsb1osq",
            __cmplp.size === 'small' ? "_4t3i1b66" : "_4t3iu2gc",
            __cmplp.className
        ])
    });
});
const $48d7d4549f19c3d3$var$Bar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $awdRS.default)(__cmplp.background),
            "--_1y04s53": (0, $awdRS.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11q71i36 _v564calv _1e0c1ule _kqswstnw _1bsb1mcm",
            __cmplp.size === 'small' ? "_4t3i1b66" : "_4t3iu2gc",
            __cmplp.className
        ])
    });
});

});




parcelRegister("MJDfz", function(module, exports) {
$parcel$export(module.exports, "ComponentsTableErrorState", () => $f1ed843e4a9e0367$export$ac3671872e9d0a72);
/* components-table-error-state.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $jas6a = parcelRequire("jas6a");

var $eus6H = parcelRequire("eus6H");
function $f1ed843e4a9e0367$export$ac3671872e9d0a72({ testId: testId }) {
    (0, $gRw8I.di)(window);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const reloadButtonTestId = testId && `${testId}-reload-button`;
    const handleReloadClick = (0, $eJOHy.useCallback)((_, analyticEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'compassComponentsTableErrorStateReload');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1ed843e4a9e0367$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.400",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f1ed843e4a9e0367$var$errorStateImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jas6a.ErrorStateImage), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1ed843e4a9e0367$var$Heading, null, formatMessage((0, $eus6H.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f1ed843e4a9e0367$var$bodyStyles
    }, formatMessage((0, $eus6H.default).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: reloadButtonTestId,
        appearance: "primary",
        onClick: handleReloadClick
    }, formatMessage((0, $eus6H.default).reload)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1ed843e4a9e0367$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1ogm",
            __cmplp.className
        ])
    });
});
const $f1ed843e4a9e0367$var$Heading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $f1ed843e4a9e0367$var$bodyStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.300'
});
const $f1ed843e4a9e0367$var$errorStateImageWrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.500'
});

});
parcelRegister("jas6a", function(module, exports) {
$parcel$export(module.exports, "ErrorStateImage", () => $76ec98411e771fff$export$69a679459027c35e);

var $eJOHy = parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");

var $j4YqP = parcelRequire("j4YqP");
const $76ec98411e771fff$export$69a679459027c35e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j4YqP))),
        alt: "",
        width: 171.25
    });

});
parcelRegister("j4YqP", function(module, exports) {
module.exports = new URL("error-state.7a6adba2.svg", import.meta.url).toString();

});


parcelRegister("eus6H", function(module, exports) {
$parcel$export(module.exports, "default", () => $07224e3f162d829a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $07224e3f162d829a$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "compass-common.components-table-error-state.heading-non-final",
        "defaultMessage": "We're having trouble showing Compass components"
    },
    body: {
        "id": "compass-common.components-table-error-state.body-non-final",
        "defaultMessage": "Reloading the page might resolve this issue."
    },
    reload: {
        "id": "compass-common.components-table-empty-state.reload-non-final",
        "defaultMessage": "Reload"
    }
});
var $07224e3f162d829a$export$2e2bcd8739ae039 = $07224e3f162d829a$var$messages;

});


parcelRegister("aWq2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d01d155d8388871$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8d01d155d8388871$var$messages = (0, $7qGN1.defineMessages)({
    componentHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.component-head",
        "defaultMessage": "Component"
    },
    ownerTeamHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.owner-team-head",
        "defaultMessage": "Owner team"
    },
    repositoryHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.repository-head",
        "defaultMessage": "Repository"
    },
    dependenciesHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.dependencies-head",
        "defaultMessage": "Dependencies"
    },
    scorecardHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.scorecard-head",
        "defaultMessage": "Scorecards"
    },
    issuesHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.issues-head",
        "defaultMessage": "Issues"
    },
    componentCount: {
        "id": "project-pages-project-directories.components.view.compass-table.component-count",
        "defaultMessage": "{componentCount, plural, one {# component} other {# components}} linked to project"
    },
    componentInfo: {
        "id": "project-pages-project-directories.components.view.compass-table.component-info",
        "defaultMessage": "Compass components appear here when they\u2019re added to an issue\u2019s <bold>Components</bold> field. <link>Learn more</link>"
    },
    issuesHeaderIssueTermRefresh: {
        "id": "project-pages-project-directories.components.view.compass-table.issues-head-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    componentInfoIssueTermRefresh: {
        "id": "project-pages-project-directories.components.view.compass-table.component-info-issue-term-refresh",
        "defaultMessage": "Compass components appear here when they\u2019re added to the <bold>Components</bold> field in a work item. <link>Find out more</link>"
    },
    componentCountGalaxia: {
        "id": "project-pages-project-directories.components.view.compass-table.component-count-galaxia",
        "defaultMessage": "{componentCount, plural, one {# component} other {# components}} linked to space"
    }
});
var $8d01d155d8388871$export$2e2bcd8739ae039 = $8d01d155d8388871$var$messages;

});



parcelRegister("eIUgN", function(module, exports) {
$parcel$export(module.exports, "RequestAccessState", () => $374a804f305949af$export$bc16bfb757adb731);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $8RHPx = parcelRequire("8RHPx");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $koAZ4 = parcelRequire("koAZ4");

var $eIyrz = parcelRequire("eIyrz");

var $24OFc = parcelRequire("24OFc");
const $374a804f305949af$var$COMPASS_SITE_ARI_PREFIX = 'ari:cloud:compass::site';
function $374a804f305949af$var$compassSiteAriFor(cloudId) {
    return `${$374a804f305949af$var$COMPASS_SITE_ARI_PREFIX}/${cloudId}`;
}
function $374a804f305949af$var$getUserUpsellUrl(cloudId) {
    const compassResourceAri = $374a804f305949af$var$compassSiteAriFor(cloudId);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const continueUrl = window.location.href;
    return `${(0, $8RHPx.getATLContextUrl)('id')}/join/user-access?resource=${encodeURIComponent(compassResourceAri)}&continue=${encodeURIComponent(continueUrl)}`;
}
const $374a804f305949af$export$bc16bfb757adb731 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const upsellUrl = $374a804f305949af$var$getUserUpsellUrl(cloudId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "componentsTableRequestAccessState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        eventName: "viewed componentsTableRequestAccessState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $374a804f305949af$var$contentStyles,
        alignBlock: "center",
        testId: "project-directories.components.compass-table.request-access-state.request-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIyrz.RequestAccessImage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $374a804f305949af$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $374a804f305949af$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $24OFc.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $374a804f305949af$var$descriptionStyles
    }, formatMessage((0, $24OFc.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        target: "_blank",
        href: upsellUrl,
        onClick: (_, analyticEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'compassRequestAccessUpSell');
        }
    }, formatMessage((0, $24OFc.default).requestAccessButtonText)))));
};
const $374a804f305949af$var$contentStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '700px',
    marginTop: 'space.1000',
    marginBottom: 'space.250',
    marginLeft: 'auto',
    marginRight: 'auto'
});
const $374a804f305949af$var$headingStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.250'
});
const $374a804f305949af$var$descriptionStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.250',
    paddingBottom: 'space.250'
});
const $374a804f305949af$var$textStyles = (0, $1DXK0.xcss)({
    maxWidth: '500px',
    color: 'color.text.subtle'
});

});
parcelRegister("eIyrz", function(module, exports) {
$parcel$export(module.exports, "RequestAccessImage", () => $f9a7814f3f034852$export$cb181e9b99786285);

var $eJOHy = parcelRequire("eJOHy");

var $8wyVH = parcelRequire("8wyVH");

var $lRq8t = parcelRequire("lRq8t");

var $24OFc = parcelRequire("24OFc");

var $dXrNG = parcelRequire("dXrNG");
const $f9a7814f3f034852$export$cb181e9b99786285 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dXrNG))),
        alt: formatMessage((0, $24OFc.default).requestAccessAltText)
    });
};

});
parcelRegister("24OFc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2abed2b9ab612c2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b2abed2b9ab612c2$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "project-directories.components.common.request-access.heading",
        "defaultMessage": "You don\u2019t have access to Compass components"
    },
    description: {
        "id": "project-directories.components.common.request-access.description",
        "defaultMessage": "Ask your admin to give you access to Compass, so you can track the work your team is doing on components of your software architecture."
    },
    requestAccessButtonText: {
        "id": "project-directories.components.common.request-access.button-text",
        "defaultMessage": "Request access"
    },
    requestAccessAltText: {
        "id": "project-directories.components.common.request-access.image-alt-text",
        "defaultMessage": "Request access to Compass"
    }
});
var $b2abed2b9ab612c2$export$2e2bcd8739ae039 = $b2abed2b9ab612c2$var$messages;

});

parcelRegister("dXrNG", function(module, exports) {
module.exports = new URL("request-access-lock.c6207860.svg", import.meta.url).toString();

});



parcelRegister("hccdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9467b05785bd73$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $a4ieE = parcelRequire("a4ieE");

var $jxax6 = parcelRequire("jxax6");

var $gaIMx = parcelRequire("gaIMx");

var $jfj2K = parcelRequire("jfj2K");
const $2e9467b05785bd73$var$mapStateToProps = (state)=>({
        analyticsData: (0, $a4ieE.get)(state),
        canAddComponent: (0, $jxax6.isAdmin)(state)
    });
const $2e9467b05785bd73$var$mapDispatchToProps = {
    onAddComponent: (0, $gaIMx.initiate)
};
var $2e9467b05785bd73$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($2e9467b05785bd73$var$mapStateToProps, $2e9467b05785bd73$var$mapDispatchToProps)((0, $jfj2K.default));

});
parcelRegister("jfj2K", function(module, exports) {
$parcel$export(module.exports, "default", () => $09f4e7351f36586c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $FhXEJ = parcelRequire("FhXEJ");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $ezJEv = parcelRequire("ezJEv");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");

var $iYHhb = parcelRequire("iYHhb");
const $09f4e7351f36586c$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1ejb _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $09f4e7351f36586c$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-components.empty-placeholder-nothing-added-yet",
        "defaultMessage": "This project doesn't have any components, yet"
    },
    description: {
        "id": "project-components.empty-placeholder-components-are-subsections",
        "defaultMessage": "Components are subsections of a project. Use them to group issues within a project into smaller parts."
    },
    addComponent: {
        "id": "project-components.empty-placeholder-add-a-component",
        "defaultMessage": "Create component"
    },
    learnMore: {
        "id": "project-components.empty-placeholder-read-more",
        "defaultMessage": "Learn more"
    },
    learnMoreAriaLabelText: {
        "id": "project-components.empty-placeholder-read-more-aria-label-text",
        "defaultMessage": "Learn more about components"
    },
    learnMoreJiraComponentsAriaLabelText: {
        "id": "project-components.empty-placeholder-read-more-jira-components-aria-label-text",
        "defaultMessage": "Learn how to configure Jira components"
    }
});
class $09f4e7351f36586c$var$EmptyPlaceholderView extends (0, $eJOHy.PureComponent) {
    renderAddComponentButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: this.props.onAddComponent
        }, this.props.intl.formatMessage($09f4e7351f36586c$var$messages.addComponent));
    }
    renderLinkButton() {
        let articleId;
        let fallbackLink;
        let learnMoreAriaLabelText;
        if (this.props.projectType === (0, $FhXEJ.SOFTWARE_PROJECT)) {
            // For JSW projects, show the newer Jira Components help articles (which contains references to Compass Components)
            articleId = 'XFBVB5cRw96Y4KvDXxiuM';
            fallbackLink = 'https://support.atlassian.com/jira-software-cloud/docs/configure-jira-components/';
            learnMoreAriaLabelText = $09f4e7351f36586c$var$messages.learnMoreJiraComponentsAriaLabelText;
        } else {
            // For non-JSW projects (JSM), show the original Jira Components help articles (Compass Components are not available in JSM)
            articleId = 'kG5jarMna4VfUEbBkegtI';
            fallbackLink = 'https://confluence.atlassian.com/display/ADMINJIRACLOUD/Managing+components';
            learnMoreAriaLabelText = $09f4e7351f36586c$var$messages.learnMoreAriaLabelText;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezJEv.default), {
            "aria-label": this.props.intl.formatMessage(learnMoreAriaLabelText),
            articleId: articleId,
            appearance: "subtle-link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                "aria-label": this.props.intl.formatMessage(learnMoreAriaLabelText),
                appearance: "subtle-link",
                href: fallbackLink,
                target: "_blank"
            }, this.props.intl.formatMessage($09f4e7351f36586c$var$messages.learnMore))
        }, this.props.intl.formatMessage($09f4e7351f36586c$var$messages.learnMore));
    }
    render() {
        const { canAddComponent: canAddComponent, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09f4e7351f36586c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iYHhb))),
            width: "narrow",
            header: formatMessage($09f4e7351f36586c$var$messages.header),
            description: formatMessage($09f4e7351f36586c$var$messages.description),
            primaryAction: !canAddComponent ? null : this.renderAddComponentButton(),
            tertiaryAction: this.renderLinkButton()
        }));
    }
}
var $09f4e7351f36586c$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($09f4e7351f36586c$var$EmptyPlaceholderView);

});
parcelRegister("iYHhb", function(module, exports) {
module.exports = new URL("components.37259031.svg", import.meta.url).toString();

});



parcelRegister("gswYm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae6437c2ecf814b4$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1jVSq = parcelRequire("1jVSq");

var $hGeBN = parcelRequire("hGeBN");

var $dw49z = parcelRequire("dw49z");

var $dZT8R = parcelRequire("dZT8R");
const $ae6437c2ecf814b4$var$mapStateToProps = (state)=>({
        isLoading: (0, $dw49z.isLoading)(state),
        currentPage: (0, $hGeBN.getCurrentPage)(state)
    });
const $ae6437c2ecf814b4$var$mapDispatchToProps = {
    onRetry: (0, $1jVSq.getComponentsPageRequest)
};
var $ae6437c2ecf814b4$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($ae6437c2ecf814b4$var$mapStateToProps, $ae6437c2ecf814b4$var$mapDispatchToProps)((0, $dZT8R.default));

});
parcelRegister("dZT8R", function(module, exports) {
$parcel$export(module.exports, "default", () => $026ea4361e7dda39$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4sAyo = parcelRequire("4sAyo");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $jhUy1 = parcelRequire("jhUy1");
const $026ea4361e7dda39$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-components.error-header",
        "defaultMessage": "An error occurred"
    },
    description: {
        "id": "project-components.error-description",
        "defaultMessage": "There was a problem loading your components. Try again or contact your administrator for support."
    }
});
function $026ea4361e7dda39$var$ErrorView(props) {
    const { onRetry: onRetry, currentPage: currentPage, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4sAyo.default), {
        header: formatMessage($026ea4361e7dda39$var$messages.header),
        description: formatMessage($026ea4361e7dda39$var$messages.description),
        isLoading: isLoading,
        onRetry: ()=>onRetry({
                page: currentPage,
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).VIEW
            })
    });
}
$026ea4361e7dda39$var$ErrorView.defaultProps = {
    isLoading: false
};
var $026ea4361e7dda39$export$2e2bcd8739ae039 = $026ea4361e7dda39$var$ErrorView;

});
parcelRegister("4sAyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $453bd51fb9ccfc1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $bJscI = parcelRequire("bJscI");

var $idGBm = parcelRequire("idGBm");

var $ixx7q = parcelRequire("ixx7q");

var $3Wbl1 = parcelRequire("3Wbl1");

var $ahcp8 = parcelRequire("ahcp8");
function $453bd51fb9ccfc1a$var$ErrorNew({ header: header = '', description: description, size: size = 'wide', onRetry: onRetry, isLoading: isLoading = false, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle = false, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage = (0, $ahcp8.default).retry, renderErrorImage: renderErrorImage, headingLevel: headingLevel }) {
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($ixx7q))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Wbl1)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
function $453bd51fb9ccfc1a$var$ErrorOld(props) {
    const { header: header = '', description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage = (0, $ahcp8.default).retry, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($ixx7q))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Wbl1)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$453bd51fb9ccfc1a$var$ErrorOld.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $ahcp8.default).retry
};
const $453bd51fb9ccfc1a$export$edf27be85e5f6da0 = (0, $bJscI.componentWithFG)('jiv-migrate-default-props-error-state', $453bd51fb9ccfc1a$var$ErrorNew, $453bd51fb9ccfc1a$var$ErrorOld);
var $453bd51fb9ccfc1a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($453bd51fb9ccfc1a$export$edf27be85e5f6da0);

});
parcelRegister("ixx7q", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("3Wbl1", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("ahcp8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c9decea4f84155e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3c9decea4f84155e$var$messages = (0, $7qGN1.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});
var $3c9decea4f84155e$export$2e2bcd8739ae039 = $3c9decea4f84155e$var$messages;

});




parcelRegister("euomL", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c70281c7db6c729$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $a4ieE = parcelRequire("a4ieE");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");

var $W9F9I = parcelRequire("W9F9I");
const $4c70281c7db6c729$var$mapStateToProps = (state)=>({
        value: (0, $hGeBN.getFilter)(state),
        analyticsData: (0, $a4ieE.get)(state)
    });
const $4c70281c7db6c729$var$mapDispatchToProps = (dispatch)=>({
        onChange: (value)=>{
            dispatch((0, $ksVok.patchQuery)({
                filter: value,
                page: 1
            }));
            dispatch((0, $1jVSq.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).FILTERING
            }));
        }
    });
var $4c70281c7db6c729$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4c70281c7db6c729$var$mapStateToProps, $4c70281c7db6c729$var$mapDispatchToProps)((0, $W9F9I.default));

});
parcelRegister("W9F9I", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d237979e1786567$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $gPaDt = parcelRequire("gPaDt");
class $8d237979e1786567$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: ''
        };
    }
    render() {
        const { value: value = '' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPaDt.default), {
            value: value,
            onChange: this.onChange,
            ariaLabelText: this.props.ariaLabel,
            hasAutoFocus: true
        });
    }
    constructor(...args){
        super(...args), this.onChange = (value)=>{
            this.props.onChange(value);
        };
    }
}

});
parcelRegister("gPaDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae2458133d2ad358$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dqc6Z = parcelRequire("dqc6Z");
const $ae2458133d2ad358$export$4c4c11a6ab1f5b09 = 1000;
const $ae2458133d2ad358$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value, callback)=>callback(value), $ae2458133d2ad358$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $ae2458133d2ad358$var$Filter extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: true
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $ae2458133d2ad358$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $ae2458133d2ad358$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $ae2458133d2ad358$export$2e2bcd8739ae039 = $ae2458133d2ad358$var$Filter;

});
parcelRegister("dqc6Z", function(module, exports) {
$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null, tooltipShortcut: tooltipShortcut })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]);
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps;
    const showTooltip = (0, $eJOHy.useMemo)(()=>{
        return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
    }, [
        renderTooltipContent,
        value
    ]);
    const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: renderTooltipContent,
        shortcut: tooltipShortcut,
        canAppear: useShowTooltip,
        position: "bottom-start",
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true
    }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ...tooltipProps,
            ...restTextFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {},
            onFocus: (0, $eJOHy.useCallback)((event)=>{
                onFocusTextField && onFocusTextField(event);
                onFocusTooltip(event);
            }, [
                onFocusTooltip
            ]),
            onBlur: (0, $eJOHy.useCallback)((event)=>{
                onBlurTextField && onBlurTextField(event);
                onBlurTooltip(event);
            }, [
                onBlurTooltip
            ]),
            ref: (0, $bzbsd.mergeRefs)(textFieldRef, tooltipRef),
            "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
        }))));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-radius-small, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {
$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {
$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $4cTDP = parcelRequire("4cTDP");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});





parcelRegister("eVOc4", function(module, exports) {
$parcel$export(module.exports, "WrappedGlobalComponentsToggleButton", () => $4895ac22058e9043$export$3e1dcbc2cb650833);

var $eJOHy = parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");

var $cA0Y2 = parcelRequire("cA0Y2");

var $7pw1V = parcelRequire("7pw1V");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $kRgKj = parcelRequire("kRgKj");

var $3EpyI = parcelRequire("3EpyI");

var $guLgo = parcelRequire("guLgo");

var $dJ8fs = parcelRequire("dJ8fs");
function $4895ac22058e9043$export$7b6a4d9163c73b70(props) {
    const { testId: testId, loading: loading, enabled: enabled, setProperty: setProperty, isAdminContext: isAdminContext, isOpen: isOpen, toggleOpen: toggleOpen } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>toggleOpen(false),
        placement: "bottom-end",
        messageId: "project-directories.components.global-components-toggle-button.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJ8fs.PopupContent), {
                isAdminContext: isAdminContext,
                loading: loading,
                globalComponentsEnabled: !!enabled,
                setGlobalComponentsProperty: setProperty
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
                ...triggerProps,
                testId: testId,
                isLoading: loading,
                isSelected: isOpen,
                onClick: (_, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'globalComponentsToggleButton', {
                        opened: !isOpen
                    });
                    toggleOpen(!isOpen);
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })
            }, formatMessage((0, $guLgo.default).productComponents, {
                product: enabled ? 'Compass' : 'Jira'
            }))
    });
}
function $4895ac22058e9043$export$3e1dcbc2cb650833(props) {
    const { globalComponentsProperty: globalComponentsProperty, isEditable: isEditable } = props;
    const [isGlobalComponentsPopupOpen, setIsGlobalComponentsPopupOpen] = (0, $eJOHy.useState)(false);
    // https://switcheroo.atlassian.com/ui/gates/1b168ef2-2b46-4911-a34c-48247c85f7b9
    // If the customer is FedRamp, don't render ads and toggle buttons
    if ((0, $7pw1V.isFedrampModerate)()) return null;
    // If the customer is Isolated Cloud, don't render ads and toggle buttons
    if ((0, $7pw1V.isIsolatedCloud)() && (0, $4cTDP.fg)('jira_fe_hide_components_list')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "wrappedGlobalComponentsToggleButton",
        sendToPrivacyUnsafeSplunk: true
    }, !(0, $4cTDP.fg)('compass-components-upsell-ad') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3EpyI.CompassComponentsSpotlight), {
        testId: "project-directories.components.global-components-toggle-button.compass-components-spotlight",
        targetRadius: 3,
        dialogPlacement: "bottom right",
        isVisible: !globalComponentsProperty?.loading && !globalComponentsProperty?.enabled,
        onDismiss: (_, analyticEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'compassComponentsSpotlightDismiss');
        },
        onLearnMore: (e, analyticEvent)=>{
            e.stopPropagation();
            setIsGlobalComponentsPopupOpen(true);
            (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'compassComponentSpotlightLearnMore');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4895ac22058e9043$export$7b6a4d9163c73b70, {
        toggleOpen: setIsGlobalComponentsPopupOpen,
        isOpen: isGlobalComponentsPopupOpen,
        testId: "project-directories.components.global-components-toggle-button.compass-global-components-toggle-button",
        isAdminContext: isEditable,
        ...globalComponentsProperty
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4895ac22058e9043$export$7b6a4d9163c73b70, {
        toggleOpen: setIsGlobalComponentsPopupOpen,
        isOpen: isGlobalComponentsPopupOpen,
        testId: "project-directories.components.global-components-toggle-button.compass-global-components-toggle-button",
        isAdminContext: isEditable,
        ...globalComponentsProperty
    }));
}

});
parcelRegister("3EpyI", function(module, exports) {
$parcel$export(module.exports, "CompassComponentsSpotlight", () => $0885cc4adb1ca3f2$export$789e02269f603bf7);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $04IXF = parcelRequire("04IXF");

var $iS909 = parcelRequire("iS909");
const $0885cc4adb1ca3f2$var$TARGET = 'project-directories.components.compass-components-spotlight.target';
function $0885cc4adb1ca3f2$export$789e02269f603bf7({ isVisible: isVisible = true, onDismiss: onDismiss, onLearnMore: onLearnMore, children: children, ...forwardProps }) {
    const [{ hasBeenViewed: hasBeenViewed }, { hide: hide }] = (0, $04IXF.useCompassComponentsSpotlightViewed)();
    const handleDismiss = (e, analyticsEvent)=>{
        hide();
        onDismiss?.(e, analyticsEvent);
    };
    const handleLearnMore = (e, analyticsEvent)=>{
        hide();
        onLearnMore?.(e, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: $0885cc4adb1ca3f2$var$TARGET
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isVisible && !hasBeenViewed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa),
        sourceName: "compassComponentsSpotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iS909.CompassComponentsPopup), {
        target: $0885cc4adb1ca3f2$var$TARGET,
        onDismiss: handleDismiss,
        onLearnMore: handleLearnMore,
        ...forwardProps
    }))));
}

});
parcelRegister("iS909", function(module, exports) {
$parcel$export(module.exports, "CompassComponentsPopup", () => $ec94b71ef5660c8f$export$cc486d32c3044612);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $iC2Fk = parcelRequire("iC2Fk");

var $aC8Pi = parcelRequire("aC8Pi");

var $kdPdC = parcelRequire("kdPdC");
function $ec94b71ef5660c8f$export$cc486d32c3044612({ onLearnMore: onLearnMore, onDismiss: onDismiss, testId: testId, ...forwardProps }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const learnMoreTestId = testId && `${testId}-learn-more`;
    const dismissTestId = testId && `${testId}-dismiss`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iC2Fk.JiraSpotlight), {
        ...forwardProps,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($aC8Pi))),
        dialogWidth: 320,
        actions: [
            {
                text: formatMessage((0, $kdPdC.default).learnMore),
                onClick: onLearnMore,
                testId: learnMoreTestId
            },
            {
                appearance: 'subtle-link',
                text: formatMessage((0, $kdPdC.default).dismiss),
                onClick: onDismiss,
                testId: dismissTestId
            }
        ],
        heading: formatMessage((0, $kdPdC.default).heading),
        testId: testId,
        messageId: "project-directories.components.compass-components-spotlight.compass-components-popup.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $kdPdC.default).summary));
}

});
parcelRegister("aC8Pi", function(module, exports) {
module.exports = new URL("popup-image.c1b1bf07.svg", import.meta.url).toString();

});

parcelRegister("kdPdC", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fd363ace6b27f3d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5fd363ace6b27f3d$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "project-components.compass-components-popup.heading",
        "defaultMessage": "A new way to work on software components"
    },
    summary: {
        "id": "project-components.compass-components-popup.summary",
        "defaultMessage": "Use Compass components to group and track work around pieces of your software architecture."
    },
    learnMore: {
        "id": "project-components.compass-components-popup.learn-more",
        "defaultMessage": "Show me"
    },
    dismiss: {
        "id": "project-components.compass-components-popup.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $5fd363ace6b27f3d$export$2e2bcd8739ae039 = $5fd363ace6b27f3d$var$messages;

});



parcelRegister("guLgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3072c3dfd673eb5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e3072c3dfd673eb5$var$messages = (0, $7qGN1.defineMessages)({
    productComponents: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.product-components",
        "defaultMessage": "{product} components"
    }
});
var $e3072c3dfd673eb5$export$2e2bcd8739ae039 = $e3072c3dfd673eb5$var$messages;

});

parcelRegister("dJ8fs", function(module, exports) {
$parcel$export(module.exports, "PopupContent", () => $9b28f7228a96c547$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $7saMl = parcelRequire("7saMl");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $8CBYv = parcelRequire("8CBYv");

var $k71qx = parcelRequire("k71qx");

var $ezJEv = parcelRequire("ezJEv");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $iIAek = parcelRequire("iIAek");

var $loFCj = parcelRequire("loFCj");
function $9b28f7228a96c547$export$2a2c7ba12d3231e3(props) {
    const { isAdminContext: isAdminContext, loading: loading, globalComponentsEnabled: globalComponentsEnabled, setGlobalComponentsProperty: setGlobalComponentsProperty } = props;
    const { openGlobalComponentsFeedbackCollector: openGlobalComponentsFeedbackCollector } = (0, $iIAek.useCompassComponentsFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const adminAwareToggle = (0, $eJOHy.useMemo)(()=>{
        const toggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
            testId: "project-directories.components.global-components-toggle-button.popup-content.toggle",
            isDisabled: // Only admins can turn on Compass components.
            !isAdminContext || loading,
            isChecked: globalComponentsEnabled,
            onChange: (_, analyticEvent)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticEvent, 'globalComponentsProperty', {
                    value: !globalComponentsEnabled
                });
                setGlobalComponentsProperty(!globalComponentsEnabled); // Request feedback when global components are disabled (i.e. was enabled, becoming disabled).
                if (globalComponentsEnabled) openGlobalComponentsFeedbackCollector({
                    cancelButtonLabel: formatMessage((0, $loFCj.default).skipButtonLabel)
                });
            }
        });
        if (isAdminContext) return toggle;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            testId: "project-directories.components.global-components-toggle-button.popup-content.tooltip",
            content: formatMessage((0, $loFCj.default).askAdmin)
        }, toggle);
    }, [
        formatMessage,
        loading,
        isAdminContext,
        globalComponentsEnabled,
        setGlobalComponentsProperty,
        openGlobalComponentsFeedbackCollector
    ]);
    const actionHint = (0, $eJOHy.useMemo)(()=>{
        if (globalComponentsEnabled) {
            if (isAdminContext) return (0, $loFCj.default).jiraAdminActionHint;
            return (0, $loFCj.default).jiraActionHint;
        }
        if (isAdminContext) return (0, $loFCj.default).compassAdminActionHint;
        return (0, $loFCj.default).compassActionHint;
    }, [
        globalComponentsEnabled,
        isAdminContext
    ]); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticEvent, globalComponentsEnabled ? 'learnMoreAboutJiraLink' : 'learnMoreAboutCompassLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$1171103ea9083ffa),
        sourceName: "globalComponentsTogglePopup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b28f7228a96c547$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b28f7228a96c547$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small"
    }, formatMessage(globalComponentsEnabled ? (0, $loFCj.default).switchToJiraCta : (0, $loFCj.default).switchToCompassCta)), adminAwareToggle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b28f7228a96c547$var$Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b28f7228a96c547$var$ComponentsDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...globalComponentsEnabled ? (0, $loFCj.default).jiraDescription : (0, $loFCj.default).compassDescription,
        values: {
            // @ts-expect-error - Type '(learnMore: string) => JSX.Element' is not assignable to type 'ReactNode'.
            link: (learnMore)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezJEv.default), {
                    articleId: globalComponentsEnabled ? (0, $b5691e94f0e54299$export$d519c2877b8b5078) : (0, $b5691e94f0e54299$export$46b2089262397762),
                    appearance: "link",
                    spacing: "none",
                    onClick: onClickLearnMore,
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                        href: globalComponentsEnabled ? (0, $b5691e94f0e54299$export$c0a683dd07e215fe) : (0, $b5691e94f0e54299$export$6b933388fae9d233),
                        onClick: onClickLearnMore,
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, learnMore)
                }, learnMore)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b28f7228a96c547$var$SwitchInfo, null, formatMessage(actionHint))))), globalComponentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'compassFeedbackCollector');
            openGlobalComponentsFeedbackCollector();
        }
    }, formatMessage((0, $loFCj.default).giveFeedback)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b28f7228a96c547$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1a2h _ca0qpxbi _u5f3v47k _n3tdpxbi _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b28f7228a96c547$var$Header = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _otyrpxbi _tqeh1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b28f7228a96c547$var$Body = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b28f7228a96c547$var$ComponentsDetails = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _syazi7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b28f7228a96c547$var$SwitchInfo = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1rpy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8CBYv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b71259385cf6352$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6XkOW = parcelRequire("6XkOW");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $6fs4r = parcelRequire("6fs4r");

var $hqCmO = parcelRequire("hqCmO");
const $8b71259385cf6352$var$LOADING_LABEL = ', Loading';
const $8b71259385cf6352$var$basicStyles = null;
const $8b71259385cf6352$var$iconStyles = null;
const $8b71259385cf6352$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $8b71259385cf6352$var$noop = (0, $3Vuhz.default);
const $8b71259385cf6352$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8b71259385cf6352$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $8b71259385cf6352$var$Toggle = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $8b71259385cf6352$var$noop, onChange: providedChange = $8b71259385cf6352$var$noop, onFocus: providedFocus = $8b71259385cf6352$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eJOHy.useState)(defaultChecked);
    const loadingLabelId = (0, $gl2vi.useId)();
    const handleBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleChange = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const legacyIconSize = $8b71259385cf6352$var$iconSizeMap[size];
    const labelId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        ...controlProps,
        className: (0, $hcewu.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys4194a _krlfnqa1 _ju3ddkaa _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _i5ec1w7i",
            size === 'large' && !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $8b71259385cf6352$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$8b71259385cf6352$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                id: loadingLabelId,
                children: $8b71259385cf6352$var$LOADING_LABEL
            })
        ]
    });
}));
$8b71259385cf6352$var$Toggle.displayName = 'Toggle';
var $8b71259385cf6352$export$2e2bcd8739ae039 = $8b71259385cf6352$var$Toggle;

});
parcelRegister("6XkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b8f5df6a73844cbfa316238c6d2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5108674e45de2f8c$var$_react = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5108674e45de2f8c$var$_checkMark = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("lwpci")));

var $5108674e45de2f8c$var$_done = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("37Ug4")));
function $5108674e45de2f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5108674e45de2f8c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5108674e45de2f8c$var$_react.default.createElement($5108674e45de2f8c$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $5108674e45de2f8c$var$_done.default
    }, props));
$5108674e45de2f8c$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $5108674e45de2f8c$var$_default = module.exports.default = $5108674e45de2f8c$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("37Ug4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $246daa468c067835$var$_react = $246daa468c067835$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $246daa468c067835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $246daa468c067835$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $246daa468c067835$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props));
$246daa468c067835$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $246daa468c067835$var$_default = module.exports.default = $246daa468c067835$var$EditorDoneIcon;

});


parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});


parcelRegister("hqCmO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d938694e808b84dc$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $d938694e808b84dc$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $d938694e808b84dc$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($d938694e808b84dc$var$styles.iconContainer, isHidden && (0, $eGOwo.fg)('platform-visual-refresh-icons') && $d938694e808b84dc$var$styles.hidden, size === 'regular' && $d938694e808b84dc$var$styles.iconContainerRegular, size === 'large' && $d938694e808b84dc$var$styles.iconContainerLarge, position === 'left' && $d938694e808b84dc$var$styles.left, position === 'right' && $d938694e808b84dc$var$styles.right),
        children: children
    });
};
var $d938694e808b84dc$export$2e2bcd8739ae039 = $d938694e808b84dc$var$IconContainer;

});


const $b5691e94f0e54299$export$6b933388fae9d233 = 'https://support.atlassian.com/jira-software-cloud/docs/what-are-compass-components/';
const $b5691e94f0e54299$export$c0a683dd07e215fe = 'https://support.atlassian.com/jira-software-cloud/docs/what-are-jira-components/';
const $b5691e94f0e54299$export$46b2089262397762 = 'vnkvMTEMH9pGdm5r9sTtl';
const $b5691e94f0e54299$export$d519c2877b8b5078 = '6PbqxN3PWhkG7F5OE18WqX';

parcelRegister("iIAek", function(module, exports) {
$parcel$export(module.exports, "useCompassComponentsFeedbackCollectorActions", () => $3bdcddd358137dac$export$f2628ebb122d157e);

var $eJOHy = parcelRequire("eJOHy");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $lRq8t = parcelRequire("lRq8t");

var $edqnL = parcelRequire("edqnL");

var $loFCj = parcelRequire("loFCj");
const $3bdcddd358137dac$export$f2628ebb122d157e = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const openGlobalComponentsFeedbackCollector = (0, $eJOHy.useCallback)((props)=>{
        openFeedbackCollector({
            feedbackGroupId: (0, $edqnL.feedback).GLOBAL_COMPONENTS,
            entrypointId: (0, $gdeTc.ENTRY_POINT_ID_COMPASS),
            feedbackTitle: formatMessage((0, $loFCj.default).feedbackTitle),
            showTypeField: true,
            showDefaultTextFields: true,
            submitButtonLabel: formatMessage((0, $loFCj.default).submitButtonLabel),
            feedbackContext: [
                {
                    id: (0, $gdeTc.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                    value: (0, $edqnL.feedback).LOCATION
                }
            ],
            ...props
        });
    }, [
        formatMessage,
        openFeedbackCollector
    ]);
    return {
        openGlobalComponentsFeedbackCollector: openGlobalComponentsFeedbackCollector
    };
};

});
parcelRegister("edqnL", function(module, exports) {
$parcel$export(module.exports, "feedback", () => $a25dc0ae5f82f8b3$export$2696717cee565f14);
const $a25dc0ae5f82f8b3$export$2696717cee565f14 = {
    LOCATION: 'Project Components',
    GLOBAL_COMPONENTS: 'jsw.components.global-components'
};

});

parcelRegister("loFCj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e75fd0753e81bed$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8e75fd0753e81bed$var$messages = (0, $7qGN1.defineMessages)({
    switchToCompassCta: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-compass-cta",
        "defaultMessage": "Switch to Compass components"
    },
    compassDescription: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-description",
        "defaultMessage": "Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more</link>"
    },
    compassAdminActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-admin-action-hint",
        "defaultMessage": "If you switch, you\u2019ll still see read-only Jira components. You can switch back at any time."
    },
    compassActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-action-hint",
        "defaultMessage": "If your admin switches, you\u2019ll still see read-only Jira components."
    },
    switchToJiraCta: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-jira-cta",
        "defaultMessage": "Switch to Jira components"
    },
    jiraDescription: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-description",
        "defaultMessage": "Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more</link>"
    },
    jiraAdminActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-admin-action-hint",
        "defaultMessage": "If you switch, you\u2019ll still see read-only Compass components. You can switch back at any time."
    },
    jiraActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-action-hint",
        "defaultMessage": "If your admin switches, you\u2019ll still see read-only Compass components."
    },
    newLozenge: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.new-lozenge",
        "defaultMessage": "New"
    },
    giveFeedback: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.give-feedback",
        "defaultMessage": "Give feedback"
    },
    askAdmin: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.ask-admin",
        "defaultMessage": "Ask your admin to switch to Compass components."
    },
    feedbackTitle: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.title",
        "defaultMessage": "Give feedback"
    },
    feedbackPlaceholder: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.placeholder",
        "defaultMessage": "Write feedback"
    },
    submitButtonLabel: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.submit-button",
        "defaultMessage": "Submit"
    },
    skipButtonLabel: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.skip-button",
        "defaultMessage": "Skip"
    }
});
var $8e75fd0753e81bed$export$2e2bcd8739ae039 = $8e75fd0753e81bed$var$messages;

});




parcelRegister("g4HMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $df97e30b8f976b67$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $a4ieE = parcelRequire("a4ieE");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");

var $3ijEH = parcelRequire("3ijEH");

var $IDuNt = parcelRequire("IDuNt");
const $df97e30b8f976b67$var$mapStateToProps = (state)=>({
        currentPage: (0, $hGeBN.getCurrentPage)(state),
        totalPages: (0, $3ijEH.getTotalPages)(state),
        analyticsData: (0, $a4ieE.get)(state)
    });
const $df97e30b8f976b67$var$mapDispatchToProps = (dispatch)=>({
        onPageChange: (number)=>{
            dispatch((0, $ksVok.patchQuery)({
                page: number
            }));
            return dispatch((0, $1jVSq.getComponentsPageRequest)({
                page: number,
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).VIEW
            }));
        }
    });
var $df97e30b8f976b67$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($df97e30b8f976b67$var$mapStateToProps, $df97e30b8f976b67$var$mapDispatchToProps)((0, $IDuNt.default));

});
parcelRegister("3ijEH", function(module, exports) {
$parcel$export(module.exports, "getTotalPages", () => $ad1597720c137bc2$export$652b307566494a6);
$parcel$export(module.exports, "getIssuesUrl", () => $ad1597720c137bc2$export$390b5477b70c6392);

var $bnIBr = parcelRequire("bnIBr");

var $2CrAx = parcelRequire("2CrAx");

var $7Z0qA = parcelRequire("7Z0qA");

var $jv7JI = parcelRequire("jv7JI");

var $dw49z = parcelRequire("dw49z");
const $ad1597720c137bc2$export$652b307566494a6 = (state)=>(0, $2CrAx.calculateTotalPages)((0, $7Z0qA.getTotalItems)(state), (0, $dw49z.getItemsOnPage)(state));
const $ad1597720c137bc2$export$390b5477b70c6392 = (state, componentId)=>{
    if (!(0, $7Z0qA.getComponent)(state, componentId)) return '';
    const projectKey = (0, $jv7JI.getProjectKey)(state);
    const componentName = (0, $7Z0qA.getName)(state, componentId);
    const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND component = ${(0, $bnIBr.toQuotedString)(componentName)}`;
    return (0, $bnIBr.createAllWorkUrl)(jql);
};

});

parcelRegister("IDuNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3564dc9d6b6a335e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $tGEEK = parcelRequire("tGEEK");

var $b3eVo = parcelRequire("b3eVo");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");
const $3564dc9d6b6a335e$var$messages = (0, $7qGN1.defineMessages)({
    previousButton: {
        "id": "project-components.paginator.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "project-components.paginator.next-button",
        "defaultMessage": "Next"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3564dc9d6b6a335e$var$Container = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1syuewr-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        marginTop: "var(--ds-space-300, 24px)",
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-negative-200, -16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.totalPages <= 1 ? 'none' : 'block'
    }));
// eslint-disable-next-line jira/react/no-class-components
class $3564dc9d6b6a335e$var$PaginatorView extends (0, $eJOHy.PureComponent) {
    render() {
        const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3564dc9d6b6a335e$var$Container, {
            totalPages: totalPages,
            "data-test-id": "project-directories.components.paginator.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
            testId: "project-directories.components.paginator.pagination",
            selectedIndex: currentPage - 1,
            onChange: this.onPageChange,
            pages: (0, (/*@__PURE__*/$parcel$interopDefault($tGEEK)))(1, totalPages + 1),
            previousLabel: formatMessage($3564dc9d6b6a335e$var$messages.previousButton),
            nextLabel: formatMessage($3564dc9d6b6a335e$var$messages.nextButton)
        }));
    }
    constructor(...args){
        super(...args), this.onPageChange = (event, page)=>{
            this.props.onPageChange(page);
        };
    }
}
var $3564dc9d6b6a335e$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($3564dc9d6b6a335e$var$PaginatorView);

});


parcelRegister("dkXAu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a6a8255b2f6d692$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $jhUy1 = parcelRequire("jhUy1");

var $1jVSq = parcelRequire("1jVSq");

var $7Z0qA = parcelRequire("7Z0qA");

var $jxax6 = parcelRequire("jxax6");

var $ksVok = parcelRequire("ksVok");

var $hGeBN = parcelRequire("hGeBN");

var $dw49z = parcelRequire("dw49z");

var $2B0oJ = parcelRequire("2B0oJ");
const $1a6a8255b2f6d692$var$mapStateToProps = (state)=>({
        componentIds: (0, $7Z0qA.getIds)(state),
        isLoading: (0, $dw49z.isLoading)(state),
        editable: (0, $jxax6.isAdmin)(state),
        orderField: (0, $hGeBN.getOrderField)(state),
        orderDirection: (0, $hGeBN.getOrderDirection)(state),
        query: (0, $hGeBN.getFilter)(state)
    });
const $1a6a8255b2f6d692$var$mapDispatchToProps = (dispatch)=>({
        onSort: ({ key: key, sortOrder: sortOrder })=>{
            dispatch((0, $ksVok.patchQuery)({
                orderDirection: sortOrder,
                orderField: key,
                page: 1
            }));
            dispatch((0, $1jVSq.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $jhUy1.FETCH_COMPONENTS_REASON).SORTING
            }));
        }
    });
var $1a6a8255b2f6d692$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1a6a8255b2f6d692$var$mapStateToProps, $1a6a8255b2f6d692$var$mapDispatchToProps)((0, $2B0oJ.default));

});
parcelRegister("2B0oJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6d5fd60d0439654$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lOOiG = parcelRequire("lOOiG");

var $78OnL = parcelRequire("78OnL");

var $4cTDP = parcelRequire("4cTDP");

var $8nw3F = parcelRequire("8nw3F");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $idGBm = parcelRequire("idGBm");

var $bJscI = parcelRequire("bJscI");


var $2Jjb1 = parcelRequire("2Jjb1");

var $7b4ly = parcelRequire("7b4ly");

var $ev0gh = parcelRequire("ev0gh");

var $4fAbZ = parcelRequire("4fAbZ");

var $kS6IB = parcelRequire("kS6IB");

var $kcaJd = parcelRequire("kcaJd");

var $5NsGp = parcelRequire("5NsGp");

var $fb9EG = parcelRequire("fb9EG");
const $c6d5fd60d0439654$var$messages = (0, $7qGN1.defineMessages)({
    component: {
        "id": "project-components.table-header-component",
        "defaultMessage": "Component"
    },
    issues: {
        "id": "project-components.table-header-issues",
        "defaultMessage": "Issues"
    },
    lead: {
        "id": "project-components.table-header-lead",
        "defaultMessage": "Component lead"
    },
    description: {
        "id": "project-components.table-header-description",
        "defaultMessage": "Description"
    },
    defaultAssignee: {
        "id": "project-components.table-header-default-assignee",
        "defaultMessage": "Default assignee"
    },
    moreActions: {
        "id": "project-components.table-header-more-actions",
        "defaultMessage": "More actions"
    },
    componentsTableLabel: {
        "id": "project-components.table-components-label",
        "defaultMessage": "Table of components"
    },
    searchResults: {
        "id": "project-components.table-search-results",
        "defaultMessage": "{total, plural, =0 {No suggestions available for typed text} one {# suggestion available for typed text} other {# suggestions available for typed text}}"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $c6d5fd60d0439654$var$TableViewOld extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            editable: false,
            isLoading: false,
            orderField: (0, $2Jjb1.NAME),
            orderDirection: (0, $83529e13d1b38819$export$1dee026a19752d6b)
        };
    }
    render() {
        const { isLoading: isLoading, componentIds: componentIds, editable: editable, onSort: onSort, orderField: orderField, orderDirection: orderDirection, intl: intl } = this.props;
        const { formatMessage: formatMessage } = intl;
        const actionCellHeader = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            "data-test-id": "project-directories.components.table.action-cell-header-container"
        }, formatMessage($c6d5fd60d0439654$var$messages.moreActions));
        const headCells = [
            {
                key: (0, $2Jjb1.NAME),
                content: formatMessage($c6d5fd60d0439654$var$messages.component),
                width: 20,
                isSortable: true
            },
            {
                key: (0, $2Jjb1.DESCRIPTION),
                content: formatMessage($c6d5fd60d0439654$var$messages.description),
                width: 30,
                isSortable: true
            },
            {
                key: (0, $2Jjb1.LEAD),
                content: formatMessage($c6d5fd60d0439654$var$messages.lead),
                width: 20,
                isSortable: true
            },
            {
                content: formatMessage($c6d5fd60d0439654$var$messages.defaultAssignee),
                width: 15
            },
            {
                key: (0, $2Jjb1.ISSUES),
                content: formatMessage($c6d5fd60d0439654$var$messages.issues),
                width: 10,
                isSortable: true
            },
            {
                content: actionCellHeader,
                width: 6
            }
        ];
        const head = {
            cells: editable ? headCells : headCells.slice(0, headCells.length - 1)
        };
        const rowCells = componentIds.map((componentId, index)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = orderDirection === 'DESC' ? -(index + 1) : index + 1;
            const cells = [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6d5fd60d0439654$var$ComponentCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ev0gh.default), {
                        componentId: componentId
                    })),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kS6IB.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NsGp.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fAbZ.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kcaJd.default), {
                        componentId: componentId
                    }),
                    key: key
                }
            ];
            if (editable) // @ts-expect-error - TS2345 - Argument of type '{ content: JSX.Element; }' is not assignable to parameter of type '{ content: JSX.Element; key: number; }'.
            cells.push({
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7b4ly.default), {
                    componentId: componentId
                })
            });
            return {
                cells: cells
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6d5fd60d0439654$var$TableContainer, {
            "data-test-id": "project-directories.components.table.table-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
            isFixedSize: true,
            head: head,
            rows: rowCells,
            onSort: onSort,
            sortKey: orderField,
            sortOrder: orderDirection,
            isLoading: isLoading,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6d5fd60d0439654$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fb9EG.default), null),
            label: formatMessage($c6d5fd60d0439654$var$messages.componentsTableLabel)
        }));
    }
}
const $c6d5fd60d0439654$var$usePrevious = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $c6d5fd60d0439654$var$defaultProps = {
    editable: false,
    isLoading: false,
    orderField: (0, $2Jjb1.NAME),
    orderDirection: (0, $83529e13d1b38819$export$1dee026a19752d6b),
    query: ''
};
const $c6d5fd60d0439654$var$TableViewNew = ({ isLoading: isLoading = $c6d5fd60d0439654$var$defaultProps.isLoading, componentIds: componentIds, editable: editable = $c6d5fd60d0439654$var$defaultProps.editable, onSort: onSort, orderField: orderField = $c6d5fd60d0439654$var$defaultProps.orderField, orderDirection: orderDirection = $c6d5fd60d0439654$var$defaultProps.orderDirection, query: query = $c6d5fd60d0439654$var$defaultProps.query })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const prevQuery = $c6d5fd60d0439654$var$usePrevious(query);
    const shouldAnnounce = !isLoading && Boolean(query) && prevQuery !== query;
    const actionCellHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        as: "span",
        testId: "project-directories.components.table.action-cell-header-container"
    }, formatMessage($c6d5fd60d0439654$var$messages.moreActions));
    const headCells = [
        {
            key: (0, $2Jjb1.NAME),
            content: formatMessage($c6d5fd60d0439654$var$messages.component),
            width: 20,
            isSortable: true
        },
        {
            key: (0, $2Jjb1.DESCRIPTION),
            content: formatMessage($c6d5fd60d0439654$var$messages.description),
            width: 30,
            isSortable: true
        },
        {
            key: (0, $2Jjb1.LEAD),
            content: formatMessage($c6d5fd60d0439654$var$messages.lead),
            width: 20,
            isSortable: true
        },
        {
            content: formatMessage($c6d5fd60d0439654$var$messages.defaultAssignee),
            width: 15
        },
        {
            key: (0, $2Jjb1.ISSUES),
            content: formatMessage($c6d5fd60d0439654$var$messages.issues),
            width: 10,
            isSortable: true
        },
        {
            content: actionCellHeader,
            width: 6
        }
    ];
    const head = {
        cells: editable ? headCells : headCells.slice(0, headCells.length - 1)
    };
    const rowCells = componentIds.map((componentId, index)=>{
        // the page is already sorted (by the API), so fake key,
        // so that DynamicTable won't destroy it
        const key = orderDirection === 'DESC' ? -(index + 1) : index + 1;
        const cells = [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6d5fd60d0439654$var$ComponentCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ev0gh.default), {
                    componentId: componentId
                })),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kS6IB.default), {
                    componentId: componentId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5NsGp.default), {
                    componentId: componentId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fAbZ.default), {
                    componentId: componentId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kcaJd.default), {
                    componentId: componentId
                }),
                key: key
            }
        ];
        if (editable) // @ts-expect-error - TS2345 - Argument of type '{ content: JSX.Element; }' is not assignable to parameter of type '{ content: JSX.Element; key: number; }'.
        cells.push({
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7b4ly.default), {
                componentId: componentId
            })
        });
        return {
            cells: cells
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6d5fd60d0439654$var$TableContainer, {
        "data-testid": "project-directories.components.table.table-container"
    }, (0, $4cTDP.fg)('mc-devops-proj-components-a11y') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
        message: formatMessage($c6d5fd60d0439654$var$messages.searchResults, {
            total: rowCells.length
        }),
        shouldAnnounce: shouldAnnounce
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
        isFixedSize: true,
        head: head,
        rows: rowCells,
        onSort: onSort,
        sortKey: orderField,
        sortOrder: orderDirection,
        isLoading: isLoading,
        emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6d5fd60d0439654$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fb9EG.default), null),
        label: formatMessage($c6d5fd60d0439654$var$messages.componentsTableLabel)
    }));
};
var $c6d5fd60d0439654$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $bJscI.componentWithFG)('mc-devops-proj-components-a11y', $c6d5fd60d0439654$var$TableViewNew, (0, $idGBm.injectIntlV2)($c6d5fd60d0439654$var$TableViewOld));
const $c6d5fd60d0439654$var$TableContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2ws7jp4b _p4liutpp _6aututpp _jrvj1hna _fdle1hna _1vd212x7 _10uc12x7 _v8u71b66 _1gnfze3t _1prjusic _10wbnkob _y4k2usic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6d5fd60d0439654$var$ComponentCellContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91l8a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6d5fd60d0439654$var$EmptyLoadingView = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
});

});
const $83529e13d1b38819$export$1dee026a19752d6b = 'ASC';
const $83529e13d1b38819$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("7b4ly", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c5f70cabc63a4ab$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1jVSq = parcelRequire("1jVSq");

var $7Z0qA = parcelRequire("7Z0qA");

var $3CaJv = parcelRequire("3CaJv");

var $kQzc0 = parcelRequire("kQzc0");

var $1R2Bg = parcelRequire("1R2Bg");
const $1c5f70cabc63a4ab$var$mapStateToProps = (state, ownProps)=>({
        showSpinner: (0, $kQzc0.showSpinner)(state, ownProps.componentId),
        name: (0, $7Z0qA.getName)(state, ownProps.componentId)
    });
const $1c5f70cabc63a4ab$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onEdit: ()=>dispatch((0, $1jVSq.initiateUpdateComponent)({
                id: ownProps.componentId
            })),
        onDelete: ()=>dispatch((0, $3CaJv.deleteComponentStarted)({
                id: ownProps.componentId
            }))
    });
var $1c5f70cabc63a4ab$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1c5f70cabc63a4ab$var$mapStateToProps, $1c5f70cabc63a4ab$var$mapDispatchToProps)((0, $1R2Bg.default));

});
parcelRegister("kQzc0", function(module, exports) {
$parcel$export(module.exports, "showSpinner", () => $e98ae9ebcfaeff48$export$2a7a135fa1ec651f);

var $jPUTR = parcelRequire("jPUTR");

var $86SzG = parcelRequire("86SzG");
const $e98ae9ebcfaeff48$export$2a7a135fa1ec651f = (state, id)=>{
    if ((0, $86SzG.isInitialising)(state, id)) return true;
    return (0, $jPUTR.isSpinnerVisible)(state, id);
};

});
parcelRegister("jPUTR", function(module, exports) {
$parcel$export(module.exports, "isSpinnerVisible", () => $d247423018c8060f$export$b0b0e195937a1a6f);
$parcel$export(module.exports, "componentsBeingDeleted", () => $d247423018c8060f$export$fac926d1ed969680);
const $d247423018c8060f$export$b0b0e195937a1a6f = (state, id)=>state.ui.delete.spinner[id];
const $d247423018c8060f$export$fac926d1ed969680 = (state)=>state.ui.delete.componentsBeingDeleted;

});


parcelRegister("1R2Bg", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5ddc1b7c339b781$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $7ep4S = parcelRequire("7ep4S");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5ddc1b7c339b781$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i7vkz _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $b5ddc1b7c339b781$var$messages = (0, $7qGN1.defineMessages)({
    editAction: {
        "id": "project-components.table-actions-cell-edit",
        "defaultMessage": "Edit"
    },
    deleteAction: {
        "id": "project-components.table-actions-cell-delete",
        "defaultMessage": "Delete"
    },
    moreActions: {
        "id": "project-components.table-header-more-actions",
        "defaultMessage": "More actions for {componentName}"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $b5ddc1b7c339b781$var$ActionsView extends (0, $eJOHy.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, name: name } = this.props;
        const IconBefore = this.props.showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b5ddc1b7c339b781$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
            spacing: "spacious",
            label: formatMessage($b5ddc1b7c339b781$var$messages.moreActions, {
                componentName: name
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
            shouldRenderToParent: true,
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    iconBefore: IconBefore
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: this.onEditClicked
        }, formatMessage($b5ddc1b7c339b781$var$messages.editAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: this.onDeleteClicked
        }, formatMessage($b5ddc1b7c339b781$var$messages.deleteAction))));
    }
    constructor(...args){
        super(...args), this.onEditClicked = ()=>this.props.onEdit(), this.onDeleteClicked = ()=>this.props.onDelete();
    }
}
var $b5ddc1b7c339b781$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($b5ddc1b7c339b781$var$ActionsView);

});


parcelRegister("ev0gh", function(module, exports) {
$parcel$export(module.exports, "default", () => $df0c7c3a2e82ef92$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7Z0qA = parcelRequire("7Z0qA");

var $3ijEH = parcelRequire("3ijEH");

var $dX6Z1 = parcelRequire("dX6Z1");
const $df0c7c3a2e82ef92$var$mapStateToProps = (state, ownProps)=>({
        name: (0, $7Z0qA.getName)(state, ownProps.componentId),
        issuesUrl: (0, $3ijEH.getIssuesUrl)(state, ownProps.componentId)
    });
var $df0c7c3a2e82ef92$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($df0c7c3a2e82ef92$var$mapStateToProps, {})((0, $dX6Z1.default));

});
parcelRegister("dX6Z1", function(module, exports) {
$parcel$export(module.exports, "default", () => $80caf129f024fa0a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c9uTK = parcelRequire("c9uTK");
function $80caf129f024fa0a$export$2e2bcd8739ae039(props) {
    const { name: name, issuesUrl: issuesUrl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        href: issuesUrl,
        "data-testid": "project-directories.components.table.cell.component.link"
    }, name);
}

});


parcelRegister("4fAbZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $921fdc3d2d2eada6$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7Z0qA = parcelRequire("7Z0qA");

var $glqnk = parcelRequire("glqnk");
const $921fdc3d2d2eada6$var$mapStateToProps = (state, ownProps)=>({
        defaultAssignee: (0, $7Z0qA.getDefaultAssignee)(state, ownProps.componentId)
    });
var $921fdc3d2d2eada6$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($921fdc3d2d2eada6$var$mapStateToProps, {})((0, $glqnk.default));

});
parcelRegister("glqnk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f6b2775393da02c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7mF43 = parcelRequire("7mF43");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");
const $7f6b2775393da02c$var$messages = (0, $7qGN1.defineMessages)({
    componentLead: {
        "id": "project-components.table-default-assignee-cell-component-lead",
        "defaultMessage": "Component lead"
    },
    projectDefault: {
        "id": "project-components.table-default-assignee-cell-project-default",
        "defaultMessage": "Project default"
    },
    projectLead: {
        "id": "project-components.table-default-assignee-cell-project-lead",
        "defaultMessage": "Project lead"
    },
    unassigned: {
        "id": "project-components.table-default-assignee-cell-unassigned",
        "defaultMessage": "Unassigned"
    }
});
function $7f6b2775393da02c$var$DefaultAssigneeView(props) {
    const { defaultAssignee: defaultAssignee, intl: { formatMessage: formatMessage } } = props;
    if (!defaultAssignee) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-test-id": "project-directories.components.table.cell.default-assignee"
    }, formatMessage($7f6b2775393da02c$var$messages[(0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(defaultAssignee)]));
}
var $7f6b2775393da02c$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($7f6b2775393da02c$var$DefaultAssigneeView);

});


parcelRegister("kS6IB", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b34e03275300334$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7Z0qA = parcelRequire("7Z0qA");

var $ke1BZ = parcelRequire("ke1BZ");
const $0b34e03275300334$var$mapStateToProps = (state, ownProps)=>({
        description: (0, $7Z0qA.getDescription)(state, ownProps.componentId)
    });
var $0b34e03275300334$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($0b34e03275300334$var$mapStateToProps, {})((0, $ke1BZ.default));

});
parcelRegister("ke1BZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $10dee27df9078d33$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $10dee27df9078d33$export$2e2bcd8739ae039(props) {
    const { description: description } = props;
    if (!description) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-test-id": "project-directories.components.table.cell.description"
    }, description);
}

});


parcelRegister("kcaJd", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c01f405f0889a08$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7Z0qA = parcelRequire("7Z0qA");

var $3ijEH = parcelRequire("3ijEH");

var $hUJoR = parcelRequire("hUJoR");
const $6c01f405f0889a08$var$mapStateToProps = (state, ownProps)=>({
        name: (0, $7Z0qA.getName)(state, ownProps.componentId),
        number: (0, $7Z0qA.getIssueCount)(state, ownProps.componentId),
        issuesUrl: (0, $3ijEH.getIssuesUrl)(state, ownProps.componentId)
    });
var $6c01f405f0889a08$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($6c01f405f0889a08$var$mapStateToProps, {})((0, $hUJoR.default));

});
parcelRegister("hUJoR", function(module, exports) {
$parcel$export(module.exports, "default", () => $426a45d8e2f7bbf4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c9uTK = parcelRequire("c9uTK");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");
const $426a45d8e2f7bbf4$var$messages = (0, $7qGN1.defineMessages)({
    issueCount: {
        "id": "project-components.table-issues-cell-content",
        "defaultMessage": "{number} {number, plural, one {issue} other {issues}}"
    },
    ariaLabel: {
        "id": "project-components.table-issues-cell-content-aria-label",
        "defaultMessage": "{number} {number, plural, one {issue} other {issues}} for {name}"
    }
});
function $426a45d8e2f7bbf4$var$IssuesView(props) {
    const { number: number, issuesUrl: issuesUrl, name: name, intl: { formatMessage: formatMessage } } = props;
    const content = formatMessage($426a45d8e2f7bbf4$var$messages.issueCount, {
        number: number.toString()
    });
    const ariaLabel = formatMessage($426a45d8e2f7bbf4$var$messages.ariaLabel, {
        number: number.toString(),
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        href: issuesUrl,
        "aria-label": ariaLabel
    }, content);
}
var $426a45d8e2f7bbf4$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($426a45d8e2f7bbf4$var$IssuesView);

});


parcelRegister("5NsGp", function(module, exports) {
$parcel$export(module.exports, "default", () => $01c777ded0e38265$export$2e2bcd8739ae039);

var $6YFG2 = parcelRequire("6YFG2");

var $gnQAk = parcelRequire("gnQAk");

var $7Z0qA = parcelRequire("7Z0qA");

var $8KRxo = parcelRequire("8KRxo");
const $01c777ded0e38265$var$mapStateToProps = (state, ownProps)=>({
        user: (0, $7Z0qA.getLead)(state, ownProps.componentId)
    });
var $01c777ded0e38265$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($01c777ded0e38265$var$mapStateToProps, {})((0, $6YFG2.default)((0, $8KRxo.default)));

});
parcelRegister("8KRxo", function(module, exports) {
$parcel$export(module.exports, "default", () => $96aaccea1f43d3c9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $bse5g = parcelRequire("bse5g");
function $96aaccea1f43d3c9$export$2e2bcd8739ae039(props) {
    const { formatMessage: formatMessage } = props.intl;
    if (!props.user) return null;
    const { avatarUrl: avatarUrl, displayName: displayName, profileUrl: profileUrl, active: active } = props.user;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: profileUrl,
        "data-testid": "project-directories.components.table.cell.lead.link",
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_u5f3u2gc _1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        key: "avatar"
    })), active === true ? displayName : // @ts-expect-error - TS2769: No overload matches this call.
    formatMessage((0, $bse5g.default).deactivated, {
        userName: displayName,
        status: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                className: (0, $hcewu.default)([
                    "_syaz1rpy"
                ])
            }, text[0])
    })));
}
const $96aaccea1f43d3c9$var$WrapperStyles = null;
const $96aaccea1f43d3c9$var$LinkStyles = null;
const $96aaccea1f43d3c9$var$AvatarContainerStyles = null;
const $96aaccea1f43d3c9$var$UserStatusStyles = null;

});
parcelRegister("bse5g", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bd3a438c6661869$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9bd3a438c6661869$var$messages = (0, $7qGN1.defineMessages)({
    deactivated: {
        "id": "project-components.lead.deactivated-status",
        "defaultMessage": "{userName} <status>(Deactivated)</status>"
    }
});
var $9bd3a438c6661869$export$2e2bcd8739ae039 = $9bd3a438c6661869$var$messages;

});



parcelRegister("fb9EG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c4a12bcaea0e1c4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");

var $3bzFi = parcelRequire("3bzFi");
const $1c4a12bcaea0e1c4$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-components.filter-no-results-nothing-matched-your-search",
        "defaultMessage": "We didn't find any components that matched your search"
    },
    emptyStateMessageDescription: {
        "id": "project-components.filter-no-results-nothing-matched-your-search-description",
        "defaultMessage": "Try using specific component names or terms."
    }
});
function $1c4a12bcaea0e1c4$var$EmptyView(props) {
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3bzFi))),
        header: formatMessage($1c4a12bcaea0e1c4$var$messages.header),
        description: formatMessage($1c4a12bcaea0e1c4$var$messages.emptyStateMessageDescription),
        headingLevel: 2,
        width: "narrow"
    });
}
var $1c4a12bcaea0e1c4$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($1c4a12bcaea0e1c4$var$EmptyView);

});
parcelRegister("3bzFi", function(module, exports) {
module.exports = new URL("empty.565fbc78.svg", import.meta.url).toString();

});




parcelRegister("5y4x3", function(module, exports) {
$parcel$export(module.exports, "HeaderBottombarContent", () => $da302a4b4b59108b$export$503cbcd19e8ae377);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ezJEv = parcelRequire("ezJEv");

var $kRgKj = parcelRequire("kRgKj");


var $irKLN = parcelRequire("irKLN");
const $da302a4b4b59108b$export$503cbcd19e8ae377 = (props)=>{
    const { isGlobalComponentsEnabled: isGlobalComponentsEnabled, searchBar: searchBar, formatMessage: formatMessage } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const learnMoreOnClick = (_, analyticEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticEvent, isGlobalComponentsEnabled ? 'learnMoreAboutCompassComponentsLink' : 'learnMoreAboutJiraComponentsLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: isGlobalComponentsEnabled ? 'project-directories.components.content.compass-header-content' : 'project-directories.components.content.jira-header-content',
        xcss: $da302a4b4b59108b$var$compassHeaderTextStyles,
        paddingBlockEnd: "space.300"
    }, formatMessage(isGlobalComponentsEnabled ? (0, $irKLN.default).headerCompass : (0, $irKLN.default).headerJira, {
        link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezJEv.default), {
                articleId: isGlobalComponentsEnabled ? (0, $b5691e94f0e54299$export$46b2089262397762) : (0, $b5691e94f0e54299$export$d519c2877b8b5078),
                appearance: "link",
                onClick: learnMoreOnClick,
                spacing: "none",
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    href: isGlobalComponentsEnabled ? (0, $b5691e94f0e54299$export$6b933388fae9d233) : (0, $b5691e94f0e54299$export$c0a683dd07e215fe),
                    target: "_blank",
                    onClick: learnMoreOnClick,
                    appearance: "link",
                    spacing: "none"
                }, text)
            }, text)
    })), !isGlobalComponentsEnabled && searchBar);
};
const $da302a4b4b59108b$var$compassHeaderTextStyles = (0, $1DXK0.xcss)({
    width: '611px'
});

});
parcelRegister("irKLN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1e28f841551f294$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e1e28f841551f294$var$messages = (0, $7qGN1.defineMessages)({
    headerCompass: {
        "id": "project-components.compass-header",
        "defaultMessage": "Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more about Compass components</link>"
    },
    headerJira: {
        "id": "project-components.jira-header",
        "defaultMessage": "Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more about Jira Components</link>"
    }
});
var $e1e28f841551f294$export$2e2bcd8739ae039 = $e1e28f841551f294$var$messages;

});


parcelRegister("f3RSN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9a9976ababf99c36$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9a9976ababf99c36$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    filterInputLabel: {
        "id": "project.directories.components.header.filterInputLabel",
        "defaultMessage": "Filter components"
    },
    addComponent: {
        "id": "project-components.add-component.trigger",
        "defaultMessage": "Create component"
    },
    caption: {
        "id": "project-components.header-caption",
        "defaultMessage": "Components"
    },
    successFlagTitle: {
        "id": "project-components.add-component.success-flag-title",
        "defaultMessage": "Success"
    },
    successFlagDescription: {
        "id": "project-components.add-component.success-flag-description",
        "defaultMessage": "New component was created successfully"
    }
});

});



parcelRegister("e6HZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ed01954f5336a81$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FdK7X = parcelRequire("FdK7X");

var $ejDmu = parcelRequire("ejDmu");

var $i9ub4 = parcelRequire("i9ub4");
function $2ed01954f5336a81$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ejDmu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9ub4.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $FdK7X.default), null));
}

});
parcelRegister("FdK7X", function(module, exports) {
$parcel$export(module.exports, "default", () => $866231ecd4ac813e$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $jPUTR = parcelRequire("jPUTR");

var $f6MCs = parcelRequire("f6MCs");
const $866231ecd4ac813e$var$mapStateToProps = (state)=>({
        componentsBeingDeleted: (0, $jPUTR.componentsBeingDeleted)(state)
    });
var $866231ecd4ac813e$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($866231ecd4ac813e$var$mapStateToProps, {})((0, $f6MCs.default));

});
parcelRegister("f6MCs", function(module, exports) {
$parcel$export(module.exports, "default", () => $002b7ba70a7499ca$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9m3XM = parcelRequire("9m3XM");
function $002b7ba70a7499ca$var$ViewComponent(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, props.componentsBeingDeleted.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9m3XM.default), {
            id: id,
            key: id
        })));
}
var $002b7ba70a7499ca$export$2e2bcd8739ae039 = $002b7ba70a7499ca$var$ViewComponent;

});
parcelRegister("9m3XM", function(module, exports) {
$parcel$export(module.exports, "default", () => $afa6a49b70c82448$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1jVSq = parcelRequire("1jVSq");

var $a4ieE = parcelRequire("a4ieE");

var $7Z0qA = parcelRequire("7Z0qA");

var $jxax6 = parcelRequire("jxax6");

var $jv7JI = parcelRequire("jv7JI");

var $3ijEH = parcelRequire("3ijEH");

var $3CaJv = parcelRequire("3CaJv");

var $jXEHn = parcelRequire("jXEHn");
const $afa6a49b70c82448$var$mapStateToProps = (state, { id: id })=>({
        component: (0, $7Z0qA.getComponent)(state, id),
        projectKey: (0, $jv7JI.getProjectKey)(state),
        locale: (0, $jxax6.getLocale)(state),
        analyticsData: (0, $a4ieE.get)(state),
        relatedIssueUrl: (0, $3ijEH.getIssuesUrl)(state, id)
    });
const $afa6a49b70c82448$var$mapDispatchToProps = (dispatch, { id: id })=>({
        onPatchComponentIssueCount: (issueCount)=>{
            dispatch((0, $1jVSq.patchComponent)({
                id: id,
                component: {
                    issueCount: issueCount
                }
            }));
        },
        onDeleteComponentSuccessful: (component)=>{
            dispatch((0, $1jVSq.deleteComponentSuccess)({
                id: id,
                component: component
            }));
        },
        onDeleteComponentFailure: (error, isDialogOpen)=>{
            dispatch((0, $1jVSq.deleteComponentFailure)({
                id: id,
                error: error,
                isDialogOpen: isDialogOpen
            }));
        },
        onDeleteDialogDisplay: ()=>{
            dispatch((0, $3CaJv.deleteComponentDialogDisplayed)({
                id: id
            }));
        },
        onDeleteDialogCancel: ()=>{
            dispatch((0, $3CaJv.deleteComponentCancel)({
                id: id
            }));
        }
    });
var $afa6a49b70c82448$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($afa6a49b70c82448$var$mapStateToProps, $afa6a49b70c82448$var$mapDispatchToProps)((0, $jXEHn.default));

});
parcelRegister("jXEHn", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fefa7a57bfa404e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $lMA54 = parcelRequire("lMA54");
// component name is handled via state because we want to show component name when dialog fades out
// eslint-disable-next-line jira/react/no-class-components
class $2fefa7a57bfa404e$var$ViewComponent extends (0, $eJOHy.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { component: component, relatedIssueUrl: relatedIssueUrl } = nextProps;
        if (component && this.state.component !== component) this.setState({
            component: component
        });
        if (relatedIssueUrl && this.state.url !== relatedIssueUrl) this.setState({
            url: relatedIssueUrl
        });
    }
    render() {
        const { component: { name: name, issueCount: issueCount }, url: url } = this.state;
        const { id: id, locale: locale, projectKey: projectKey, analyticsData: analyticsData, onDeleteComponentFailure: onDeleteComponentFailure, onDeleteDialogDisplay: onDeleteDialogDisplay, onDeleteDialogCancel: onDeleteDialogCancel, onPatchComponentIssueCount: onPatchComponentIssueCount } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lMA54.default), {
            onFail: onDeleteComponentFailure,
            onSuccessful: this.onDeleteComponentSuccessful,
            onDialogDisplay: onDeleteDialogDisplay,
            onIssueCountFetched: onPatchComponentIssueCount,
            onDialogCancel: onDeleteDialogCancel,
            id: id,
            locale: locale,
            analyticsData: analyticsData,
            relatedIssueCount: issueCount,
            relatedIssueUrl: url,
            name: name,
            projectKey: projectKey
        });
    }
    constructor(...args){
        super(...args), this.state = {
            component: this.props.component,
            url: this.props.relatedIssueUrl
        }, this.onDeleteComponentSuccessful = ()=>{
            this.props.onDeleteComponentSuccessful(this.state.component);
        };
    }
}
var $2fefa7a57bfa404e$export$2e2bcd8739ae039 = $2fefa7a57bfa404e$var$ViewComponent;

});
parcelRegister("lMA54", function(module, exports) {
$parcel$export(module.exports, "default", () => $74655464b3f3b400$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8sbs2 = parcelRequire("8sbs2");

var $fGnU6 = parcelRequire("fGnU6");

var $7iHUq = parcelRequire("7iHUq");

var $PJsGf = parcelRequire("PJsGf");

var $h2RpP = parcelRequire("h2RpP");

var $8265I = parcelRequire("8265I");

var $6wMl2 = parcelRequire("6wMl2");

var $Qodx6 = parcelRequire("Qodx6");
const $74655464b3f3b400$var$pickContextFromProps = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(props, [
        'id',
        'name',
        'projectKey',
        'locale',
        'analyticsData',
        'relatedIssueCount',
        'relatedIssueUrl'
    ]);
const $74655464b3f3b400$var$pickCallbackFromProps = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(props, [
        'onIssueCountFetched',
        'onSuccessful',
        'onFail',
        'onDialogDisplay',
        'onDialogCancel'
    ]);
class $74655464b3f3b400$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.store = (0, $6wMl2.default)((0, $PJsGf.default), this.props.name);
        this.setAppProps(this.props);
    }
    componentDidMount() {
        this.store.dispatch((0, $8265I.deleteComponentRequest)());
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.props, nextProps)) this.setAppProps(nextProps);
    }
    setAppProps(props) {
        this.store.dispatch((0, $h2RpP.setAppProps)({
            context: $74655464b3f3b400$var$pickContextFromProps(props),
            callbacks: $74655464b3f3b400$var$pickCallbackFromProps(props)
        }));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Qodx6.default), null)));
    }
}

});
parcelRegister("PJsGf", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4fe850ae41deb5a$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $7IOcp = parcelRequire("7IOcp");

var $cuSVJ = parcelRequire("cuSVJ");
const $a4fe850ae41deb5a$var$rootEpic = (0, $4tM8k.combineEpics)((0, $cuSVJ.deleteComponentRequest), (0, $cuSVJ.deleteComponentSafe), (0, $cuSVJ.deleteComponentConfirmed), (0, $7IOcp.dialogDisplayed), (0, $7IOcp.componentDeleted), (0, $7IOcp.failure), (0, $7IOcp.cancel));
var $a4fe850ae41deb5a$export$2e2bcd8739ae039 = $a4fe850ae41deb5a$var$rootEpic;

});
parcelRegister("7IOcp", function(module, exports) {
$parcel$export(module.exports, "dialogDisplayed", () => $eb4be50f98282f4c$export$c57e151085f519af);
$parcel$export(module.exports, "componentDeleted", () => $eb4be50f98282f4c$export$b986928a2f340a61);
$parcel$export(module.exports, "failure", () => $eb4be50f98282f4c$export$af2dba6db4e9e1f0);
$parcel$export(module.exports, "cancel", () => $eb4be50f98282f4c$export$70b61ad426ddbe54);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $8265I = parcelRequire("8265I");

var $h96fg = parcelRequire("h96fg");

var $6Tsv8 = parcelRequire("6Tsv8");
const $eb4be50f98282f4c$export$c57e151085f519af = (action$, store)=>action$.ofType((0, $8265I.DELETE_COMPONENT_CONFIRMATION)).mergeMap(()=>{
        (0, $h96fg.onDialogDisplay)(store.getState())();
        return (0, $7kixv.Observable).empty();
    });
const $eb4be50f98282f4c$export$b986928a2f340a61 = (action$, store)=>action$.ofType((0, $8265I.DELETE_COMPONENT_SUCCESS)).mergeMap(()=>{
        (0, $h96fg.onSuccessful)(store.getState())();
        return (0, $7kixv.Observable).empty();
    });
const $eb4be50f98282f4c$export$af2dba6db4e9e1f0 = (action$, store)=>action$.ofType((0, $8265I.DELETE_COMPONENT_FAIL)).mergeMap((action)=>{
        const { payload: { error: error } } = action;
        const state = store.getState();
        (0, $h96fg.onFail)(state)(error, (0, $6Tsv8.isDialogOpen)(state));
        return (0, $7kixv.Observable).empty();
    });
const $eb4be50f98282f4c$export$70b61ad426ddbe54 = (action$, store)=>action$.ofType((0, $8265I.CANCEL)).mergeMap(()=>{
        (0, $h96fg.onDialogCancel)(store.getState())();
        return (0, $7kixv.Observable).empty();
    });

});
parcelRegister("8265I", function(module, exports) {
$parcel$export(module.exports, "DELETE_COMPONENT_REQUEST", () => $4764d036610ad1fc$export$24e2bdb9f02e5fb4);
$parcel$export(module.exports, "deleteComponentRequest", () => $4764d036610ad1fc$export$e4a1f64fe436caf8);
$parcel$export(module.exports, "DELETE_COMPONENT_SAFE", () => $4764d036610ad1fc$export$38c2b9f6b042ef0f);
$parcel$export(module.exports, "deleteComponentSafe", () => $4764d036610ad1fc$export$624d4d9a2c81f4fc);
$parcel$export(module.exports, "DELETE_COMPONENT_CONFIRMATION", () => $4764d036610ad1fc$export$b831980d93222685);
$parcel$export(module.exports, "deleteComponentConfirmation", () => $4764d036610ad1fc$export$ad2794195cfdcdd1);
$parcel$export(module.exports, "DELETE_COMPONENT_CONFIRMED", () => $4764d036610ad1fc$export$ee9d0d88840ce8bd);
$parcel$export(module.exports, "deleteComponentConfirmed", () => $4764d036610ad1fc$export$45e8f2bd48b3a662);
$parcel$export(module.exports, "DELETE_COMPONENT_SUCCESS", () => $4764d036610ad1fc$export$da077ae08c543bd0);
$parcel$export(module.exports, "deleteComponentSuccess", () => $4764d036610ad1fc$export$8d34c79dac47f8f3);
$parcel$export(module.exports, "DELETE_COMPONENT_FAIL", () => $4764d036610ad1fc$export$4520c4bcba87d72a);
$parcel$export(module.exports, "deleteComponentFail", () => $4764d036610ad1fc$export$5698fe655dd4ff82);
$parcel$export(module.exports, "CANCEL", () => $4764d036610ad1fc$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $4764d036610ad1fc$export$70b61ad426ddbe54);
const $4764d036610ad1fc$export$24e2bdb9f02e5fb4 = 'state.actions.DELETE_COMPONENT_REQUEST';
const $4764d036610ad1fc$export$e4a1f64fe436caf8 = ()=>({
        type: $4764d036610ad1fc$export$24e2bdb9f02e5fb4
    });
const $4764d036610ad1fc$export$38c2b9f6b042ef0f = 'state.actions.DELETE_COMPONENT_SAFE';
const $4764d036610ad1fc$export$624d4d9a2c81f4fc = ()=>({
        type: $4764d036610ad1fc$export$38c2b9f6b042ef0f
    });
const $4764d036610ad1fc$export$b831980d93222685 = 'state.actions.DELETE_COMPONENT_CONFIRMATION';
const $4764d036610ad1fc$export$ad2794195cfdcdd1 = ()=>({
        type: $4764d036610ad1fc$export$b831980d93222685
    });
const $4764d036610ad1fc$export$ee9d0d88840ce8bd = 'state.actions.DELETE_COMPONENT_CONFIRMED';
const $4764d036610ad1fc$export$45e8f2bd48b3a662 = (payload)=>({
        type: $4764d036610ad1fc$export$ee9d0d88840ce8bd,
        payload: payload
    });
const $4764d036610ad1fc$export$da077ae08c543bd0 = 'state.actions.DELETE_COMPONENT_SUCCESS';
const $4764d036610ad1fc$export$8d34c79dac47f8f3 = ()=>({
        type: $4764d036610ad1fc$export$da077ae08c543bd0
    });
const $4764d036610ad1fc$export$4520c4bcba87d72a = 'state.actions.DELETE_COMPONENT_FAIL';
const $4764d036610ad1fc$export$5698fe655dd4ff82 = (payload)=>({
        type: $4764d036610ad1fc$export$4520c4bcba87d72a,
        payload: payload
    });
const $4764d036610ad1fc$export$2b10f4b30fb65583 = 'state.actions.CANCEL';
const $4764d036610ad1fc$export$70b61ad426ddbe54 = ()=>({
        type: $4764d036610ad1fc$export$2b10f4b30fb65583
    });

});

parcelRegister("h96fg", function(module, exports) {
$parcel$export(module.exports, "onIssueCountFetched", () => $c450bb42fc70a70e$export$363d6ea633d615fc);
$parcel$export(module.exports, "onSuccessful", () => $c450bb42fc70a70e$export$d5d6a762d03166fa);
$parcel$export(module.exports, "onFail", () => $c450bb42fc70a70e$export$5d3242f81f2f2d43);
$parcel$export(module.exports, "onDialogDisplay", () => $c450bb42fc70a70e$export$4a76bd015b2d4167);
$parcel$export(module.exports, "onDialogCancel", () => $c450bb42fc70a70e$export$ac3df3705c165fdc);
const $c450bb42fc70a70e$export$363d6ea633d615fc = (state)=>state.callbacks.onIssueCountFetched;
const $c450bb42fc70a70e$export$d5d6a762d03166fa = (state)=>state.callbacks.onSuccessful;
const $c450bb42fc70a70e$export$5d3242f81f2f2d43 = (state)=>state.callbacks.onFail;
const $c450bb42fc70a70e$export$4a76bd015b2d4167 = (state)=>state.callbacks.onDialogDisplay;
const $c450bb42fc70a70e$export$ac3df3705c165fdc = (state)=>state.callbacks.onDialogCancel;

});

parcelRegister("6Tsv8", function(module, exports) {
$parcel$export(module.exports, "isDialogOpen", () => $3f3470e9ea6ff03b$export$61d407d1c7ec6926);
$parcel$export(module.exports, "isInProgress", () => $3f3470e9ea6ff03b$export$350bfa81fecdb6f3);
const $3f3470e9ea6ff03b$export$61d407d1c7ec6926 = (state)=>state.ui.requiresConfirmation;
const $3f3470e9ea6ff03b$export$350bfa81fecdb6f3 = (state)=>state.ui.deleteInProgress;

});


parcelRegister("cuSVJ", function(module, exports) {
$parcel$export(module.exports, "deleteComponentRequest", () => $b7f667de9f9af32d$export$e4a1f64fe436caf8);
$parcel$export(module.exports, "deleteComponentSafe", () => $b7f667de9f9af32d$export$624d4d9a2c81f4fc);
$parcel$export(module.exports, "deleteComponentConfirmed", () => $b7f667de9f9af32d$export$45e8f2bd48b3a662);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $cZMbd = parcelRequire("cZMbd");

var $8265I = parcelRequire("8265I");

var $h96fg = parcelRequire("h96fg");

var $kJ7La = parcelRequire("kJ7La");
const $b7f667de9f9af32d$var$LOG_LOCATION = 'project-components.state.epics.delete';
const $b7f667de9f9af32d$var$deleteComponentPerform = (moveIssuesTo, store)=>{
    const state = store.getState();
    const id = (0, $kJ7La.getComponentId)(state);
    return (0, $7kixv.Observable).fromPromise((0, $cZMbd.deleteComponent)(id, moveIssuesTo)).flatMap(()=>(0, $7kixv.Observable).of((0, $8265I.deleteComponentSuccess)())).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData($b7f667de9f9af32d$var$LOG_LOCATION, error.message, error);
        return (0, $7kixv.Observable).of((0, $8265I.deleteComponentFail)({
            error: error
        }));
    });
};
const $b7f667de9f9af32d$export$e4a1f64fe436caf8 = (action$, store)=>action$.ofType((0, $8265I.DELETE_COMPONENT_REQUEST)).mergeMap(()=>{
        const id = (0, $kJ7La.getComponentId)(store.getState());
        return (0, $7kixv.Observable).fromPromise((0, $cZMbd.getComponentRelatedIssueCount)(id)).mergeMap((result)=>{
            const state = store.getState();
            (0, $h96fg.onIssueCountFetched)(state)(result.issueCount);
            if (result.issueCount === 0) return (0, $7kixv.Observable).of((0, $8265I.deleteComponentSafe)());
            return (0, $7kixv.Observable).of((0, $8265I.deleteComponentConfirmation)());
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData($b7f667de9f9af32d$var$LOG_LOCATION, error.message, error);
            return (0, $7kixv.Observable).of((0, $8265I.deleteComponentFail)({
                error: error
            }));
        });
    });
const $b7f667de9f9af32d$export$624d4d9a2c81f4fc = (action$, store)=>action$.ofType((0, $8265I.DELETE_COMPONENT_SAFE)).mergeMap(()=>$b7f667de9f9af32d$var$deleteComponentPerform(undefined, store));
const $b7f667de9f9af32d$export$45e8f2bd48b3a662 = (action$, store)=>action$.ofType((0, $8265I.DELETE_COMPONENT_CONFIRMED)).mergeMap((action)=>$b7f667de9f9af32d$var$deleteComponentPerform(action.payload, store));

});
parcelRegister("cZMbd", function(module, exports) {
$parcel$export(module.exports, "deleteComponent", () => $881ca6e6561d60fa$export$b131bf5b3493873b);
$parcel$export(module.exports, "getComponentRelatedIssueCount", () => $881ca6e6561d60fa$export$4adab71254d91864);

var $kxlQy = parcelRequire("kxlQy");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");

var $hvCtF = parcelRequire("hvCtF");

var $lB86I = parcelRequire("lB86I");
const $881ca6e6561d60fa$export$b131bf5b3493873b = async (componentId, moveIssuesTo)=>{
    const result = await (0, $lB86I.deleteComponent)(componentId, moveIssuesTo);
    if (result.ok) {
        try {
            componentId && (0, $kxlQy.default).remove(componentId.toString());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.components.cache.remove', error.message);
        }
        return {
            id: componentId
        };
    }
    const error = await (0, $hvCtF.getErrorMessage)(result);
    throw new (0, $14RSn.default)(result.status, error);
};
const $881ca6e6561d60fa$export$4adab71254d91864 = async (componentId)=>{
    const result = await (0, $lB86I.getComponentRelatedIssueCount)(componentId);
    if (result.ok) {
        const json = await result.json();
        return {
            id: componentId,
            issueCount: json.issueCount
        };
    }
    const error = await (0, $hvCtF.getErrorMessage)(result);
    throw new (0, $14RSn.default)(result.status, error);
};

});
parcelRegister("hvCtF", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $7b37d6345475d5ed$export$82f46aa4e6535a45);
const $7b37d6345475d5ed$export$82f46aa4e6535a45 = async (response)=>{
    try {
        const json = await response.json();
        return json.errorMessages[0] || '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return '';
    }
};

});

parcelRegister("lB86I", function(module, exports) {
$parcel$export(module.exports, "deleteComponent", () => $143d89673c455172$export$b131bf5b3493873b);
$parcel$export(module.exports, "getComponentRelatedIssueCount", () => $143d89673c455172$export$4adab71254d91864);

var $2xPWQ = parcelRequire("2xPWQ");
const $143d89673c455172$var$getUrl = (componentId)=>`/rest/api/2/component/${componentId}`;
const $143d89673c455172$export$b131bf5b3493873b = async (componentId, moveIssuesTo)=>{
    const queryString = moveIssuesTo ? `?moveIssuesTo=${moveIssuesTo}` : '';
    const fullUrl = `${$143d89673c455172$var$getUrl(componentId)}${queryString}`;
    return fetch(fullUrl, (0, $2xPWQ.createOptions)('DELETE'));
};
const $143d89673c455172$export$4adab71254d91864 = async (componentId)=>{
    const fullUrl = `${$143d89673c455172$var$getUrl(componentId)}/relatedIssueCounts`;
    return fetch(fullUrl, (0, $2xPWQ.createOptions)('GET'));
};

});


parcelRegister("kJ7La", function(module, exports) {
$parcel$export(module.exports, "getContext", () => $267e0f437744021f$export$31553aaa555c1514);
$parcel$export(module.exports, "getComponentId", () => $267e0f437744021f$export$19f56ea1d359a013);
const $267e0f437744021f$export$31553aaa555c1514 = (state)=>state.context;
const $267e0f437744021f$export$19f56ea1d359a013 = (state)=>$267e0f437744021f$export$31553aaa555c1514(state).id;
const $267e0f437744021f$export$128e6d32dd8f7139 = (state)=>$267e0f437744021f$export$31553aaa555c1514(state).analyticsData;

});



parcelRegister("h2RpP", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $40bcf6f877fa2c1d$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $40bcf6f877fa2c1d$export$cfda7627848a58cd);
const $40bcf6f877fa2c1d$export$8aefe701a6f431e0 = 'state.actions.SET_APP_PROPS';
const $40bcf6f877fa2c1d$export$cfda7627848a58cd = (payload)=>({
        type: $40bcf6f877fa2c1d$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("6wMl2", function(module, exports) {
$parcel$export(module.exports, "default", () => $245fb8065a6605c9$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $dFg4o = parcelRequire("dFg4o");

var $4tM8k = parcelRequire("4tM8k");

var $abRw5 = parcelRequire("abRw5");

var $kqAfW = parcelRequire("kqAfW");

var $jVKmp = parcelRequire("jVKmp");

const $245fb8065a6605c9$var$createStore1 = (rootOperation, name)=>{
    const middlewares = [];
    if ((0, $abRw5.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("f8FDM"));
        middlewares.push(logger);
    }
    return (0, $7HHI1.createStore)((0, $dFg4o.enableBatching)((0, $jVKmp.default)), undefined, (0, $kqAfW.default)({
        name: `Delete component '${name}'`
    })((0, $7HHI1.applyMiddleware)(...middlewares, (0, $4tM8k.createEpicMiddleware)(rootOperation))));
};
var $245fb8065a6605c9$export$2e2bcd8739ae039 = $245fb8065a6605c9$var$createStore1;

});
parcelRegister("jVKmp", function(module, exports) {
$parcel$export(module.exports, "default", () => $50becf8d82f537cf$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4oPgW = parcelRequire("4oPgW");

var $5QAFi = parcelRequire("5QAFi");

var $1ZIFC = parcelRequire("1ZIFC");
const $50becf8d82f537cf$var$combinedReducer = (0, $7HHI1.combineReducers)({
    ui: $1ZIFC.default,
    callbacks: $4oPgW.default,
    context: $5QAFi.default
});
var $50becf8d82f537cf$export$2e2bcd8739ae039 = $50becf8d82f537cf$var$combinedReducer;

});
parcelRegister("4oPgW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e7583262792af5e$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $12DRg = parcelRequire("12DRg");

var $h2RpP = parcelRequire("h2RpP");
const $7e7583262792af5e$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    onIssueCountFetched: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onSuccessful: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onFail: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDialogDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $7e7583262792af5e$var$callbacks = (state = $7e7583262792af5e$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $h2RpP.SET_APP_PROPS:
            return (0, $iWqim.assign)(state, action.payload.callbacks);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $7e7583262792af5e$export$2e2bcd8739ae039 = $7e7583262792af5e$var$callbacks;

});

parcelRegister("5QAFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be3c0736c22314a$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $jbr6p = parcelRequire("jbr6p");

var $h2RpP = parcelRequire("h2RpP");
const $3be3c0736c22314a$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    id: '',
    name: '',
    locale: (0, $jbr6p.defaultLocale),
    projectKey: '',
    analyticsData: {
        projectType: ''
    },
    relatedIssueCount: 0,
    relatedIssueUrl: ''
});
const $3be3c0736c22314a$var$context = (state = $3be3c0736c22314a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $h2RpP.SET_APP_PROPS:
            return (0, $iWqim.assign)(state, action.payload.context);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $3be3c0736c22314a$export$2e2bcd8739ae039 = $3be3c0736c22314a$var$context;

});

parcelRegister("1ZIFC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e395b888d899992$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $8265I = parcelRequire("8265I");
const $4e395b888d899992$export$d4c72bab9d6cc13a = (0, $iWqim.freeze)({
    requiresConfirmation: false,
    deleteInProgress: false
});
const $4e395b888d899992$var$ui = (state = $4e395b888d899992$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $8265I.CANCEL:
            return (0, $iWqim.assign)(state, {
                requiresConfirmation: false,
                deleteInProgress: false
            });
        case 0, $8265I.DELETE_COMPONENT_FAIL:
            return (0, $iWqim.assign)(state, {
                deleteInProgress: false
            });
        case 0, $8265I.DELETE_COMPONENT_SAFE:
        case 0, $8265I.DELETE_COMPONENT_CONFIRMED:
            return (0, $iWqim.assign)(state, {
                deleteInProgress: true
            });
        case 0, $8265I.DELETE_COMPONENT_CONFIRMATION:
            return (0, $iWqim.assign)(state, {
                requiresConfirmation: true
            });
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $4e395b888d899992$export$2e2bcd8739ae039 = $4e395b888d899992$var$ui;

});



parcelRegister("Qodx6", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3630adda2f69cfb$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $8265I = parcelRequire("8265I");

var $kJ7La = parcelRequire("kJ7La");

var $6Tsv8 = parcelRequire("6Tsv8");

var $ihs41 = parcelRequire("ihs41");
const $f3630adda2f69cfb$var$mapStateToProps = (state)=>({
        context: (0, $kJ7La.getContext)(state),
        isDialogOpen: (0, $6Tsv8.isDialogOpen)(state),
        isInProgress: (0, $6Tsv8.isInProgress)(state)
    });
const $f3630adda2f69cfb$var$mapDispatchToProps = (dispatch)=>({
        onCancel: ()=>{
            dispatch((0, $8265I.cancel)());
        },
        onConfirm: (moveIssuesTo)=>{
            dispatch((0, $8265I.deleteComponentConfirmed)(moveIssuesTo));
        }
    });
var $f3630adda2f69cfb$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($f3630adda2f69cfb$var$mapStateToProps, $f3630adda2f69cfb$var$mapDispatchToProps)((0, $ihs41.default));

});
parcelRegister("ihs41", function(module, exports) {
$parcel$export(module.exports, "default", () => $c178bbcb26503222$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gPG64 = parcelRequire("gPG64");

var $7ep4S = parcelRequire("7ep4S");

var $lJKII = parcelRequire("lJKII");

var $4B7rn = parcelRequire("4B7rn");

var $gfe1x = parcelRequire("gfe1x");

var $4cTDP = parcelRequire("4cTDP");

var $idGBm = parcelRequire("idGBm");

var $hvcaL = parcelRequire("hvcaL");
// eslint-disable-next-line jira/react/no-class-components
class $c178bbcb26503222$var$ViewComponent extends (0, $eJOHy.Component) {
    getMoveIssuesTo() {
        const { shouldSwap: shouldSwap, swapComponent: swapComponent } = this.state;
        if (shouldSwap && swapComponent) return swapComponent.id;
        return undefined;
    }
    isDeleteDisabled() {
        if (this.state.shouldSwap) return !this.state.swapComponent;
        return this.props.isInProgress;
    }
    render() {
        const { context: { projectKey: projectKey, id: componentId, relatedIssueCount: relatedIssueCount, relatedIssueUrl: relatedIssueUrl, name: name }, onCancel: onCancel, isDialogOpen: isDialogOpen, intl: { formatMessage: formatMessage } } = this.props;
        const { shouldSwap: shouldSwap } = this.state;
        const dialogDescription = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, (0, $4cTDP.fg)('replace-anchor-with-link__morphinecake') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: relatedIssueUrl
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $hvcaL.default).deleteComponentWarningLinkIssueTermRefresh : (0, $hvcaL.default).deleteComponentWarningLink, {
            relatedIssueCount: relatedIssueCount
        })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: relatedIssueUrl
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $hvcaL.default).deleteComponentWarningLinkIssueTermRefresh : (0, $hvcaL.default).deleteComponentWarningLink, {
            relatedIssueCount: relatedIssueCount
        })), ' ', formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $hvcaL.default).deleteComponentWillAffectIssuesIssueTermRefresh : (0, $hvcaL.default).deleteComponentWillAffectIssues, {
            relatedIssueCount: relatedIssueCount
        }), ' ', formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $hvcaL.default).deleteComponentYouCanChangeIssuesIssueTermRefresh : (0, $hvcaL.default).deleteComponentYouCanChangeIssues, {
            relatedIssueCount: relatedIssueCount
        }));
        if (!isDialogOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
            messageId: "project-directories.components.delete.modal-dialog",
            messageType: "transactional",
            width: "medium",
            onClose: onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
            appearance: "danger",
            isMultiline: false
        }, formatMessage((0, $hvcaL.default).headerNew, {
            component: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, dialogDescription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $c178bbcb26503222$var$deleteOptionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
            name: "swap-option-swap",
            isChecked: shouldSwap,
            onChange: this.onSwapComponentsSelected,
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $hvcaL.default).changeComponentRadioIssueTermRefresh : (0, $hvcaL.default).changeComponentRadio)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c178bbcb26503222$var$ComponentPickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfe1x.default), {
            projectKeyOrId: projectKey,
            ignore: [
                componentId
            ],
            placeholder: formatMessage((0, $hvcaL.default).componentPickerPlaceholder),
            onSelected: this.onSwapComponentChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
            name: "swap-option-remove",
            isChecked: !shouldSwap,
            onChange: this.onRemoveComponentFromIssuesSelected,
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $hvcaL.default).removeComponentRadioIssueTermRefresh : (0, $hvcaL.default).removeComponentRadio)
        }))), this.renderFooter())));
    }
    constructor(...args){
        super(...args), this.state = {
            shouldSwap: true,
            swapComponent: undefined
        }, this.onPrimaryClick = ()=>{
            const moveIssuesTo = this.getMoveIssuesTo();
            this.props.onConfirm(moveIssuesTo);
        }, this.onSwapComponentsSelected = ()=>{
            this.setState({
                shouldSwap: true
            });
        }, this.onRemoveComponentFromIssuesSelected = ()=>{
            this.setState({
                shouldSwap: false
            });
        }, this.onSwapComponentChange = (components)=>{
            this.setState({
                swapComponent: components && components[0]
            });
        }, this.renderFooter = ()=>{
            const { isInProgress: isInProgress, onCancel: onCancel, intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c178bbcb26503222$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c178bbcb26503222$var$ButtonsContainer, null, isInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $c178bbcb26503222$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "subtle-link",
                isDisabled: isInProgress,
                onClick: onCancel
            }, formatMessage((0, $hvcaL.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "danger",
                type: "submit",
                isDisabled: this.isDeleteDisabled(),
                onClick: this.onPrimaryClick
            }, formatMessage((0, $hvcaL.default).deleteButton)))));
        };
    }
}
var $c178bbcb26503222$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($c178bbcb26503222$var$ViewComponent);
const $c178bbcb26503222$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c178bbcb26503222$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
});
const $c178bbcb26503222$var$deleteOptionsContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c178bbcb26503222$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c178bbcb26503222$var$ComponentPickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv _19pk1b66 _2hwxidpf _otyrpxbi _18u01ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gfe1x", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9253b05458c671d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $bkRWZ = parcelRequire("bkRWZ");

var $fJTOm = parcelRequire("fJTOm");

var $idGBm = parcelRequire("idGBm");

var $cn53Z = parcelRequire("cn53Z");

var $eEyxI = parcelRequire("eEyxI");
const $e9253b05458c671d$var$optionFromComponent = (component)=>({
        value: component.id,
        label: component.name
    });
const $e9253b05458c671d$var$componentFromOption = (option)=>({
        id: option.value,
        name: option.label
    });
const $e9253b05458c671d$var$hasSameComponentIds = (newComponents, oldComponents)=>{
    if (newComponents === undefined || oldComponents === undefined) return newComponents === oldComponents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bkRWZ)))(newComponents, oldComponents, 'id').length === 0;
};
class $e9253b05458c671d$export$893706da3f9272af extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isMulti: false,
            isClearableWithCrossIcon: false,
            selectedComponents: undefined,
            label: '',
            placeholder: '',
            ignore: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!$e9253b05458c671d$var$hasSameComponentIds(props.selectedComponents, state.prevSelectedComponents)) return {
            ...state,
            selectedComponents: props.selectedComponents,
            prevSelectedComponentIds: props.selectedComponents
        };
        return null;
    }
    componentDidMount() {
        const { selectedComponents: selectedComponents } = this.state;
        if (selectedComponents && selectedComponents.some((x)=>!x.name)) this.fetchAndUpdateComponents(selectedComponents);
    }
    componentDidUpdate() {
        const { selectedComponents: selectedComponents } = this.state;
        if (selectedComponents && selectedComponents.some((x)=>!x.name)) this.fetchAndUpdateComponents(selectedComponents);
    }
    fetchAndUpdateComponents(selectedComponents) {
        const fillInSelectedComponents = (filledInComponents)=>{
            // Update the state only in case the component list wasn't changed
            if ($e9253b05458c671d$var$hasSameComponentIds(this.state.selectedComponents, selectedComponents)) {
                this.setState({
                    selectedComponents: filledInComponents
                });
                this.props.onSelected(filledInComponents);
            }
        };
        (0, $cn53Z.requestComponentObjects)(selectedComponents.map((x)=>x.id)).then(fillInSelectedComponents).catch(()=>fillInSelectedComponents(selectedComponents.filter((x)=>x.name)));
    }
    render() {
        const { label: label, placeholder: placeholder, isRequired: isRequired, isDisabled: isDisabled, isClearableWithCrossIcon: isClearableWithCrossIcon, isMulti: isMulti, intl: intl } = this.props;
        const selectedComponents = this.state.selectedComponents?.filter((x)=>x.name);
        const pickerProps = {
            label: label,
            placeholder: placeholder,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $eEyxI.default).error),
            options: this.renderOptions,
            ...isMulti ? {
                value: selectedComponents?.map($e9253b05458c671d$var$optionFromComponent),
                isMulti: true,
                onMultiSelected: this.onMultiSelected
            } : {
                value: selectedComponents && selectedComponents[0] && $e9253b05458c671d$var$optionFromComponent(selectedComponents[0]),
                isMulti: false,
                onSelected: this.onSelected
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.Picker), {
            intl: intl,
            ...pickerProps
        });
    }
    constructor(...args){
        super(...args), this.state = {
            selectedComponents: this.props.selectedComponents,
            prevSelectedComponents: this.props.selectedComponents
        }, this.onMultiSelected = (selectedOptions)=>{
            if (selectedOptions) {
                this.setState({
                    selectedComponents: selectedOptions.map($e9253b05458c671d$var$componentFromOption)
                });
                this.props.onSelected(selectedOptions.map($e9253b05458c671d$var$componentFromOption));
            } else {
                this.setState({
                    selectedComponents: undefined
                });
                this.props.onSelected(undefined);
            }
        }, this.onSelected = (selectedOption)=>{
            this.onMultiSelected(selectedOption && [
                selectedOption
            ]);
        }, this.renderOptions = (filter)=>// @ts-expect-error - TS2349 - This expression is not callable.
            (0, $cn53Z.requestComponentOptions)(this.props.projectKeyOrId, this.props.isMulti ? this.props.ignore.concat(this.state.selectedComponents?.map((x)=>x.id) || []) : this.props.ignore, filter);
    }
}
var $e9253b05458c671d$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($e9253b05458c671d$export$893706da3f9272af);

});
parcelRegister("bkRWZ", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $1lM9j = parcelRequire("1lM9j");

var $l76qh = parcelRequire("l76qh");

var $hm1zt = parcelRequire("hm1zt");

var $d1ShJ = parcelRequire("d1ShJ");

var $1ilzu = parcelRequire("1ilzu");
/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */ var $840b6961656f76bb$var$xorBy = $l76qh(function(arrays) {
    var iteratee = $1ilzu(arrays);
    if ($d1ShJ(iteratee)) iteratee = undefined;
    return $hm1zt($821Ou(arrays, $d1ShJ), $1lM9j(iteratee, 2));
});
module.exports = $840b6961656f76bb$var$xorBy;

});
parcelRegister("hm1zt", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $1txRh = parcelRequire("1txRh");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $ca25b5c1c14f707f$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $1txRh(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $leN9Q(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $1txRh($72Qfa(result, 1), iteratee, comparator);
}
module.exports = $ca25b5c1c14f707f$var$baseXor;

});


parcelRegister("fJTOm", function(module, exports) {
$parcel$export(module.exports, "getOptionBaseStyles", () => $69685483963d086b$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $69685483963d086b$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $69685483963d086b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $4ibbN = parcelRequire("4ibbN");

var $1jVV7 = parcelRequire("1jVV7");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $3DNvO = parcelRequire("3DNvO");
var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");
var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $lxUP5 = parcelRequire("lxUP5");

var $6joHJ = parcelRequire("6joHJ");

var $6YFG2 = parcelRequire("6YFG2");

var $6rlhA = parcelRequire("6rlhA");
const $69685483963d086b$export$3a3072dd741f354b = 500;
const $69685483963d086b$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #6B6E76)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $69685483963d086b$export$ba25329847403e11 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.clearButtonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $6rlhA.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.valueContainer,
                onClick: onValueContainerClick,
                testId: "common-components-picker.base.react-dnd-and-select-focus-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props)));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $69685483963d086b$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $3DNvO.default) : (0, $kVcjU.default);
        if (isAsync) return 0, $4ibbN.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $6UCkD.default) : (0, $c4OV1.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $6rlhA.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $6rlhA.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $6rlhA.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : (0, $fceQU.getDocument)()?.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $1jVV7.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$69685483963d086b$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                menu: (base)=>{
                    return {
                        ...base,
                        width: 'max-content',
                        // This makes the menu fit the widest content
                        minWidth: '100%'
                    };
                }
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxUP5.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
// @ts-expect-error This is required because of the ratcheted conversion from intlV2 to intl
const $69685483963d086b$var$PickerWithIntl = (0, $6YFG2.default)($69685483963d086b$export$ba25329847403e11);
const $69685483963d086b$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$PickerWithIntl, props);
};
$69685483963d086b$var$DefaultPicker.defaultProps = $69685483963d086b$export$ba25329847403e11.defaultProps;
var $69685483963d086b$export$2e2bcd8739ae039 = $69685483963d086b$var$DefaultPicker;
const $69685483963d086b$var$styles = {
    clearButtonWrapper: "_n7zlia51",
    valueContainer: "_16jlkb7n"
};

});
parcelRegister("4ibbN", function(module, exports) {
$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $ff7c32c387190ed2$export$ee664e5add893f9);

var $gWITR = parcelRequire("gWITR");

var $as6H2 = parcelRequire("as6H2");
const $ff7c32c387190ed2$export$ee664e5add893f9 = (0, $as6H2.default)('select', {
    onChange: 'changed'
})((0, $gWITR.default));

});

parcelRegister("3DNvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aa8c3d4d43b8a4$export$2e2bcd8739ae039);

var $7pkFT = parcelRequire("7pkFT");

var $dDv66 = parcelRequire("dDv66");
const $35aa8c3d4d43b8a4$var$AsyncCreatableSelect = (0, $dDv66.default)((0, $7pkFT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35aa8c3d4d43b8a4$export$2e2bcd8739ae039 = $35aa8c3d4d43b8a4$var$AsyncCreatableSelect;

});
parcelRegister("7pkFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $69fba18f5363b86b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $69fba18f5363b86b$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iSKoM.default)(props);
    const creatableProps = (0, $gVVTN.default)(stateManagerProps);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69fba18f5363b86b$export$2e2bcd8739ae039 = $69fba18f5363b86b$var$AsyncCreatableSelect;

});


parcelRegister("lxUP5", function(module, exports) {
$parcel$export(module.exports, "FieldLabel", () => $02d61fcf6733b580$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $02d61fcf6733b580$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02d61fcf6733b580$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1rpy _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02d61fcf6733b580$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $02d61fcf6733b580$var$labelStyle = null;
const $02d61fcf6733b580$var$requiredIndicatorStyle = null;

});

parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("6rlhA", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c5e69dae6a49f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $742c5e69dae6a49f$var$messages = (0, $7qGN1.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});
var $742c5e69dae6a49f$export$2e2bcd8739ae039 = $742c5e69dae6a49f$var$messages;

});


parcelRegister("cn53Z", function(module, exports) {
$parcel$export(module.exports, "requestComponentOptions", () => $9488bab708a41e84$export$b17a6324e2e1c7f7);
$parcel$export(module.exports, "requestComponentObjects", () => $9488bab708a41e84$export$57acaec04cc6f107);

var $jg5Id = parcelRequire("jg5Id");

var $53qUw = parcelRequire("53qUw");
const $9488bab708a41e84$export$b17a6324e2e1c7f7 = (projectKeyOrId, ignore, filter)=>(0, $jg5Id.getComponents)(projectKeyOrId, filter, ignore).then((data)=>(0, $53qUw.transformToOptions)(data, ignore));
const $9488bab708a41e84$export$57acaec04cc6f107 = (componentIds)=>Promise.allSettled(componentIds.map((0, $jg5Id.getComponent))).then((results)=>results.flatMap((x)=>x.status === 'fulfilled' ? [
                (0, $53qUw.transformToComponent)(x.value)
            ] : []));

});
parcelRegister("jg5Id", function(module, exports) {
$parcel$export(module.exports, "MAX_RESULTS", () => $bb09a7be4217ba2a$export$f6b2881bc1090cea);
$parcel$export(module.exports, "getComponents", () => $bb09a7be4217ba2a$export$4e811121b221213b);
$parcel$export(module.exports, "getComponent", () => $bb09a7be4217ba2a$export$21a8719ce41a1de2);

var $hgi0g = parcelRequire("hgi0g");
const $bb09a7be4217ba2a$export$f6b2881bc1090cea = 5;
const $bb09a7be4217ba2a$export$4aa7fe68c5163f3d = (projectKeyOrId)=>`/rest/api/2/project/${projectKeyOrId}/component`;
const $bb09a7be4217ba2a$export$7b8ce8b3873e394d = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/component`;
const $bb09a7be4217ba2a$export$5f0555d9912ed84 = (filter, ignore)=>`startAt=0&maxResults=${$bb09a7be4217ba2a$export$f6b2881bc1090cea + ignore.length}&query=${encodeURIComponent(filter)}`;
const $bb09a7be4217ba2a$export$1adc93310c566826 = (projectKeyOrId, filter, ignore)=>`${$bb09a7be4217ba2a$export$4aa7fe68c5163f3d(projectKeyOrId)}?${$bb09a7be4217ba2a$export$5f0555d9912ed84(filter, ignore)}`;
const $bb09a7be4217ba2a$export$379bde45c66d6bf3 = (projectKeyOrId, filter, ignore)=>`${$bb09a7be4217ba2a$export$7b8ce8b3873e394d(projectKeyOrId)}?${$bb09a7be4217ba2a$export$5f0555d9912ed84(filter, ignore)}`;
const $bb09a7be4217ba2a$export$e1462d7e65c4432f = (projectKeyOrId, filter, ignore)=>(0, $hgi0g.default)($bb09a7be4217ba2a$export$1adc93310c566826(projectKeyOrId, filter, ignore));
const $bb09a7be4217ba2a$export$4e811121b221213b = (projectKeyOrId, filter, ignore)=>(0, $hgi0g.default)($bb09a7be4217ba2a$export$379bde45c66d6bf3(projectKeyOrId, filter, ignore));
const $bb09a7be4217ba2a$export$2b0e03bdc48b0fb8 = (componentId)=>`/rest/api/3/component/${componentId}`;
const $bb09a7be4217ba2a$export$21a8719ce41a1de2 = (componentId)=>(0, $hgi0g.default)($bb09a7be4217ba2a$export$2b0e03bdc48b0fb8(componentId));

});

parcelRegister("53qUw", function(module, exports) {
$parcel$export(module.exports, "transformToComponent", () => $88533a17b131477d$export$4db7477f39e92dcc);
$parcel$export(module.exports, "transformToOptions", () => $88533a17b131477d$export$899758961952c638);

var $jg5Id = parcelRequire("jg5Id");
const $88533a17b131477d$var$transformOption = (component)=>({
        value: component.id,
        label: component.name
    });
const $88533a17b131477d$export$4db7477f39e92dcc = ({ id: id, name: name })=>({
        id: id,
        name: name
    });
const $88533a17b131477d$export$899758961952c638 = (data, ignore)=>{
    const { values: values } = data;
    return values.filter((value)=>!ignore.includes(value.id)).map($88533a17b131477d$var$transformOption).slice(0, (0, $jg5Id.MAX_RESULTS));
};

});


parcelRegister("eEyxI", function(module, exports) {
$parcel$export(module.exports, "default", () => $19b4126219a631f4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $19b4126219a631f4$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "component-picker.error",
        "defaultMessage": "We couldn't retrieve components"
    }
});
var $19b4126219a631f4$export$2e2bcd8739ae039 = $19b4126219a631f4$var$messages;

});


parcelRegister("hvcaL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba70121bdd1cb7e8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ba70121bdd1cb7e8$var$messages = (0, $7qGN1.defineMessages)({
    headerNew: {
        "id": "project-directories.components.delete.header-new",
        "defaultMessage": "Delete {component} component"
    },
    deleteButton: {
        "id": "project-directories.components.delete.delete-button",
        "defaultMessage": "Delete"
    },
    cancelButton: {
        "id": "project-directories.components.delete.cancel-button",
        "defaultMessage": "Cancel"
    },
    deleteComponentCount: {
        "id": "project-directories.components.delete.delete-component-count",
        "defaultMessage": "{count} {count, plural, one {issue} other {issues}}"
    },
    deleteComponentRestMessage: {
        "id": "project-directories.components.delete.delete-component-rest-message",
        "defaultMessage": " use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this issue} other {these issues}}."
    },
    deleteComponentWarningLink: {
        "id": "project-directories.components.delete.delete-component-warning-link",
        "defaultMessage": "{relatedIssueCount, plural, one {There is 1 issue} other {There are {relatedIssueCount} issues}} using this component."
    },
    deleteComponentWillAffectIssues: {
        "id": "project-directories.components.delete.delete-component-will-affect-issues",
        "defaultMessage": "Deleting this component will affect {relatedIssueCount, plural, one {this issue} other {these issues}}."
    },
    deleteComponentYouCanChangeIssues: {
        "id": "project-directories.components.delete.delete-component-you-can-change-issues",
        "defaultMessage": "You can change the component or remove the component {relatedIssueCount, plural, one {from this issue} other {from these issues}}."
    },
    changeComponentRadio: {
        "id": "project-directories.components.delete.change-component-radio",
        "defaultMessage": "Change current issues to component"
    },
    removeComponentRadio: {
        "id": "project-directories.components.delete.remove-component-radio",
        "defaultMessage": "Remove component from all issues."
    },
    componentPickerPlaceholder: {
        "id": "project-directories.components.delete.component-picker-placeholder",
        "defaultMessage": "Select component"
    },
    deleteComponentCountIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-count-issue-term-refresh",
        "defaultMessage": "{count} {count, plural, one {work item} other {work items}}"
    },
    deleteComponentRestMessageIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-rest-message-issue-term-refresh",
        "defaultMessage": " use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this work item} other {these work items}}."
    },
    deleteComponentWarningLinkIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-warning-link-issue-term-refresh",
        "defaultMessage": "{relatedIssueCount, plural, one {There is 1 work item} other {There are {relatedIssueCount} work items}} using this component."
    },
    deleteComponentWillAffectIssuesIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-will-affect-issues-issue-term-refresh",
        "defaultMessage": "Deleting this component will affect {relatedIssueCount, plural, one {this work item} other {these work items}}."
    },
    deleteComponentYouCanChangeIssuesIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-you-can-change-issues-issue-term-refresh",
        "defaultMessage": "You can change the component or remove the component {relatedIssueCount, plural, one {from this work item} other {from these work items}}."
    },
    changeComponentRadioIssueTermRefresh: {
        "id": "project-directories.components.delete.change-component-radio-issue-term-refresh",
        "defaultMessage": "Change current work items to component"
    },
    removeComponentRadioIssueTermRefresh: {
        "id": "project-directories.components.delete.remove-component-radio-issue-term-refresh",
        "defaultMessage": "Remove component from all work items."
    }
});
var $ba70121bdd1cb7e8$export$2e2bcd8739ae039 = $ba70121bdd1cb7e8$var$messages;

});








parcelRegister("ejDmu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d58f2d850adc1599$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gnQAk = parcelRequire("gnQAk");

var $dMBVc = parcelRequire("dMBVc");

var $1jVSq = parcelRequire("1jVSq");

var $jxax6 = parcelRequire("jxax6");

var $jv7JI = parcelRequire("jv7JI");

var $gaIMx = parcelRequire("gaIMx");

var $284Hf = parcelRequire("284Hf");
function $d58f2d850adc1599$var$AddModal(props) {
    const { locale: locale, projectId: projectId, projectKey: projectKey, projectDefaultAssignee: projectDefaultAssignee, projectLead: projectLead, onClose: onClose, onComplete: onComplete, onError: onError, isDialogOpen: isDialogOpen } = props;
    if (!isDialogOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMBVc.default), {
        locale: locale,
        projectId: projectId,
        projectKey: projectKey,
        projectDefaultAssignee: projectDefaultAssignee,
        projectLead: projectLead,
        onClose: onClose,
        onComplete: onComplete,
        onError: onError
    });
}
const $d58f2d850adc1599$var$mapStateToProps = (state)=>({
        locale: (0, $jxax6.getLocale)(state),
        isDialogOpen: (0, $284Hf.isOpen)(state),
        projectId: (0, $jv7JI.getProjectId)(state),
        projectKey: (0, $jv7JI.getProjectKey)(state),
        projectDefaultAssignee: (0, $jv7JI.getProjectDefaultAssignee)(state),
        projectLead: (0, $jv7JI.getProjectLead)(state)
    });
const $d58f2d850adc1599$var$mapDispatchToProps = {
    onClose: (0, $gaIMx.cancel),
    onComplete: (0, $1jVSq.addComponentSuccess),
    onError: (0, $1jVSq.addComponentFail)
};
var $d58f2d850adc1599$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d58f2d850adc1599$var$mapStateToProps, $d58f2d850adc1599$var$mapDispatchToProps)($d58f2d850adc1599$var$AddModal);

});
parcelRegister("dMBVc", function(module, exports) {
$parcel$export(module.exports, "default", () => $6088c99ac18de703$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fGnU6 = parcelRequire("fGnU6");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $3PCdW = parcelRequire("3PCdW");

var $ckmIk = parcelRequire("ckmIk");

var $e55Vq = parcelRequire("e55Vq");

var $4C1KG = parcelRequire("4C1KG");
class $6088c99ac18de703$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            projectDefaultAssignee: undefined,
            projectLead: undefined
        };
    }
    constructor(props){
        super(props);
        // @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
        this.store = (0, $e55Vq.default)((0, $3PCdW.default));
        this.initializeProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.initializeProps(nextProps);
    }
    initializeProps(props) {
        this.store.dispatch((0, $ckmIk.setAppProps)(props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4C1KG.default), null))));
    }
}

});
parcelRegister("3PCdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bf871e7b74367ac$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $2bkw5 = parcelRequire("2bkw5");
var $0bf871e7b74367ac$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $2bkw5.onSave), (0, $2bkw5.onClose), (0, $2bkw5.onComplete), (0, $2bkw5.onError));

});
parcelRegister("2bkw5", function(module, exports) {
$parcel$export(module.exports, "onClose", () => $2342c8baf293b5ac$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "onComplete", () => $2342c8baf293b5ac$export$e82b76dc89ff0f64);
$parcel$export(module.exports, "onError", () => $2342c8baf293b5ac$export$2288787135a8f66e);
$parcel$export(module.exports, "onSave", () => $2342c8baf293b5ac$export$87b124fe38894ca4);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("1AyD5");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");

var $XLYkN = parcelRequire("XLYkN");

var $ckmIk = parcelRequire("ckmIk");

var $aqYyt = parcelRequire("aqYyt");
const $2342c8baf293b5ac$var$LOG_LOCATION = 'project-components.state.epics.create';
const $2342c8baf293b5ac$var$epicOf = (type, handler)=>(action$, store)=>action$.ofType(type).mergeMap((action)=>handler(action, store.getState()));
const $2342c8baf293b5ac$export$f312d3bc7ef841a8 = $2342c8baf293b5ac$var$epicOf((0, $ckmIk.CANCEL), (action, state)=>{
    (0, $aqYyt.getOnClose)(state)();
    return (0, $7kixv.Observable).empty();
});
const $2342c8baf293b5ac$export$e82b76dc89ff0f64 = $2342c8baf293b5ac$var$epicOf((0, $ckmIk.SUCCESS), ({ payload: payload }, state)=>{
    (0, $aqYyt.getOnComplete)(state)(payload);
    return (0, $7kixv.Observable).empty();
});
const $2342c8baf293b5ac$export$2288787135a8f66e = $2342c8baf293b5ac$var$epicOf((0, $ckmIk.FAILURE), (action, state)=>{
    (0, $aqYyt.getOnError)(state)();
    return (0, $7kixv.Observable).empty();
});
const $2342c8baf293b5ac$export$87b124fe38894ca4 = $2342c8baf293b5ac$var$epicOf((0, $ckmIk.SAVE), (action, state)=>{
    const projectId = (0, $aqYyt.getProjectId)(state);
    const projectKey = (0, $aqYyt.getProjectKey)(state);
    const component = (0, $aqYyt.getComponent)(state);
    return (0, $7kixv.Observable).fromPromise((0, $XLYkN.create)(projectId, projectKey, component)).mergeMap((createdComponent)=>(0, $7kixv.Observable).of((0, $ckmIk.success)(createdComponent)))// @ts-expect-error - TS2345 - Argument of type '(error: any) => Observable<ValidationFailureAction> | Observable<FailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<SuccessAction>) => ObservableInput<ValidationFailureAction>'.
    .catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData($2342c8baf293b5ac$var$LOG_LOCATION, error.message, error);
        if (error instanceof (0, $14RSn.ValidationError)) return (0, $7kixv.Observable).of((0, $ckmIk.validationFailure)(error.errors));
        return (0, $7kixv.Observable).of((0, $ckmIk.failure)());
    });
});

});
parcelRegister("XLYkN", function(module, exports) {
$parcel$export(module.exports, "create", () => $2d901a57931cf80c$export$185802fd694ee1f5);

var $huC4o = parcelRequire("huC4o");

var $ftTCL = parcelRequire("ftTCL");

var $e0sMI = parcelRequire("e0sMI");
const $2d901a57931cf80c$export$185802fd694ee1f5 = (projectId, projectKey, component)=>{
    const { name: name, description: description, lead: lead, defaultAssignee: defaultAssignee } = component;
    const componentLeadField = lead && {
        leadAccountId: lead.accountId
    };
    const payload = {
        name: name,
        description: description,
        assigneeType: defaultAssignee,
        project: projectKey,
        projectId: projectId,
        ...componentLeadField
    };
    return (0, $huC4o.default)((0, $ftTCL.create)(payload), (0, $e0sMI.transformComponent), projectKey);
};

});
parcelRegister("huC4o", function(module, exports) {
$parcel$export(module.exports, "default", () => $de05280205915c1a$export$2e2bcd8739ae039);

var $8dH3d = parcelRequire("8dH3d");

var $8sbs2 = parcelRequire("8sbs2");

var $aDqEX = parcelRequire("aDqEX");

var $kxlQy = parcelRequire("kxlQy");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");
const $de05280205915c1a$var$componentHandler = (promise, transformer, projectKey)=>promise.then((response)=>Promise.all([
            response.ok,
            response.json()
        ])) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .then(([ok, json])=>{
        if (ok) {
            const component = transformer(json);
            if (component.id !== undefined) {
                const newComponent = {
                    ...component,
                    projectKey: projectKey
                };
                try {
                    (0, $kxlQy.default).set(component.id.toString(), newComponent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.components.cache.set', error.message);
                }
            }
            return component;
        }
        const errors = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(json.errors, [
            'name',
            'componentLead'
        ]);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errors)) {
            const fieldErrors = (0, (/*@__PURE__*/$parcel$interopDefault($aDqEX)))(errors).map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            ([field, error])=>({
                    field: field,
                    error: error
                }));
            throw new (0, $14RSn.ValidationError)('Validation error', fieldErrors);
        }
        throw new Error(`Request failed with a json response but cannot extract validation errors: ${JSON.stringify(json)}`);
    }).catch((e)=>{
        throw e instanceof Error ? e : new Error(e);
    });
var $de05280205915c1a$export$2e2bcd8739ae039 = $de05280205915c1a$var$componentHandler;

});
parcelRegister("aDqEX", function(module, exports) {

var $43fco = parcelRequire("43fco");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */ var $7be239ef8bf585e8$var$toPairs = $43fco($4c94y);
module.exports = $7be239ef8bf585e8$var$toPairs;

});
parcelRegister("43fco", function(module, exports) {

var $94c5e = parcelRequire("94c5e");

var $PodIB = parcelRequire("PodIB");

var $fy1iF = parcelRequire("fy1iF");

var $dkJtE = parcelRequire("dkJtE");
/** `Object#toString` result references. */ var $2f333b71c1fa6e41$var$mapTag = '[object Map]', $2f333b71c1fa6e41$var$setTag = '[object Set]';
/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */ function $2f333b71c1fa6e41$var$createToPairs(keysFunc) {
    return function(object) {
        var tag = $PodIB(object);
        if (tag == $2f333b71c1fa6e41$var$mapTag) return $fy1iF(object);
        if (tag == $2f333b71c1fa6e41$var$setTag) return $dkJtE(object);
        return $94c5e(object, keysFunc(object));
    };
}
module.exports = $2f333b71c1fa6e41$var$createToPairs;

});
parcelRegister("94c5e", function(module, exports) {

var $lylkU = parcelRequire("lylkU");
/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */ function $699ddc42dfa898c4$var$baseToPairs(object, props) {
    return $lylkU(props, function(key) {
        return [
            key,
            object[key]
        ];
    });
}
module.exports = $699ddc42dfa898c4$var$baseToPairs;

});

parcelRegister("dkJtE", function(module, exports) {
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */ function $9b506b71029020c4$var$setToPairs(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = [
            value,
            value
        ];
    });
    return result;
}
module.exports = $9b506b71029020c4$var$setToPairs;

});




parcelRegister("ftTCL", function(module, exports) {
$parcel$export(module.exports, "create", () => $c93e177e8a81df40$export$185802fd694ee1f5);

var $2xPWQ = parcelRequire("2xPWQ");
const $c93e177e8a81df40$export$94df0e59ebebf4a7 = ()=>'/rest/api/2/component';
const $c93e177e8a81df40$export$185802fd694ee1f5 = (payload)=>fetch($c93e177e8a81df40$export$94df0e59ebebf4a7(), (0, $2xPWQ.createOptions)('POST', payload));

});

parcelRegister("e0sMI", function(module, exports) {
$parcel$export(module.exports, "transformComponent", () => $19dde35002c7d187$export$79ccea7e11af4b35);
const $19dde35002c7d187$export$79ccea7e11af4b35 = (component)=>{
    const { id: id, name: name, self: self } = component;
    return {
        id: id,
        name: name,
        self: self
    };
};

});


parcelRegister("ckmIk", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $a6fe5a8a67ca7c50$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $a6fe5a8a67ca7c50$export$cfda7627848a58cd);
$parcel$export(module.exports, "SAVE", () => $a6fe5a8a67ca7c50$export$f9ec4afc4535638b);
$parcel$export(module.exports, "save", () => $a6fe5a8a67ca7c50$export$a1544dad697b423d);
$parcel$export(module.exports, "CANCEL", () => $a6fe5a8a67ca7c50$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $a6fe5a8a67ca7c50$export$70b61ad426ddbe54);
$parcel$export(module.exports, "UPDATE", () => $a6fe5a8a67ca7c50$export$e271b26eefe41db8);
$parcel$export(module.exports, "update", () => $a6fe5a8a67ca7c50$export$722fbec263ad908a);
$parcel$export(module.exports, "SUCCESS", () => $a6fe5a8a67ca7c50$export$638cc6e36b2a737a);
$parcel$export(module.exports, "success", () => $a6fe5a8a67ca7c50$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "VALIDATION_FAILURE", () => $a6fe5a8a67ca7c50$export$f73e519c8b2ca03a);
$parcel$export(module.exports, "validationFailure", () => $a6fe5a8a67ca7c50$export$ad2c1d94a94ea0c1);
$parcel$export(module.exports, "FAILURE", () => $a6fe5a8a67ca7c50$export$5b1e245d5eac107);
$parcel$export(module.exports, "failure", () => $a6fe5a8a67ca7c50$export$af2dba6db4e9e1f0);
const $a6fe5a8a67ca7c50$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $a6fe5a8a67ca7c50$export$cfda7627848a58cd = (payload)=>({
        type: $a6fe5a8a67ca7c50$export$8aefe701a6f431e0,
        payload: payload
    });
const $a6fe5a8a67ca7c50$export$f9ec4afc4535638b = 'state.SAVE';
const $a6fe5a8a67ca7c50$export$a1544dad697b423d = ()=>({
        type: $a6fe5a8a67ca7c50$export$f9ec4afc4535638b
    });
const $a6fe5a8a67ca7c50$export$2b10f4b30fb65583 = 'state.CANCEL';
const $a6fe5a8a67ca7c50$export$70b61ad426ddbe54 = ()=>({
        type: $a6fe5a8a67ca7c50$export$2b10f4b30fb65583
    });
const $a6fe5a8a67ca7c50$export$e271b26eefe41db8 = 'state.UPDATE';
const $a6fe5a8a67ca7c50$export$722fbec263ad908a = (payload)=>({
        type: $a6fe5a8a67ca7c50$export$e271b26eefe41db8,
        payload: payload
    });
const $a6fe5a8a67ca7c50$export$638cc6e36b2a737a = 'state.SUCCESS';
const $a6fe5a8a67ca7c50$export$fe7c49d056ea1d88 = (payload)=>({
        type: $a6fe5a8a67ca7c50$export$638cc6e36b2a737a,
        payload: payload
    });
const $a6fe5a8a67ca7c50$export$f73e519c8b2ca03a = 'state.VALIDATION_FAILURE';
const $a6fe5a8a67ca7c50$export$ad2c1d94a94ea0c1 = (payload)=>({
        type: $a6fe5a8a67ca7c50$export$f73e519c8b2ca03a,
        payload: payload
    });
const $a6fe5a8a67ca7c50$export$5b1e245d5eac107 = 'state.FAILURE';
const $a6fe5a8a67ca7c50$export$af2dba6db4e9e1f0 = ()=>({
        type: $a6fe5a8a67ca7c50$export$5b1e245d5eac107
    });

});

parcelRegister("aqYyt", function(module, exports) {
$parcel$export(module.exports, "getProjectKey", () => $dca57288b6aa30a6$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $dca57288b6aa30a6$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectDefaultAssignee", () => $dca57288b6aa30a6$export$be28a82d4e8d697f);
$parcel$export(module.exports, "getProjectLeadName", () => $dca57288b6aa30a6$export$c5b979a08b55628c);
$parcel$export(module.exports, "getOnClose", () => $dca57288b6aa30a6$export$87f3187c49e686c);
$parcel$export(module.exports, "getOnComplete", () => $dca57288b6aa30a6$export$a92edfca0b454563);
$parcel$export(module.exports, "getOnError", () => $dca57288b6aa30a6$export$60888e2ed0df5dfd);
$parcel$export(module.exports, "getComponent", () => $dca57288b6aa30a6$export$21a8719ce41a1de2);
$parcel$export(module.exports, "getName", () => $dca57288b6aa30a6$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getDescription", () => $dca57288b6aa30a6$export$67580b1c13935958);
$parcel$export(module.exports, "getDefaultAssignee", () => $dca57288b6aa30a6$export$725da8bee1e71eb0);
$parcel$export(module.exports, "getLead", () => $dca57288b6aa30a6$export$97850e2d25587c0d);
$parcel$export(module.exports, "getNameErrorMessage", () => $dca57288b6aa30a6$export$6222164b63cc3ae9);
$parcel$export(module.exports, "isSaving", () => $dca57288b6aa30a6$export$3b51d1dcee070cea);
$parcel$export(module.exports, "canSubmit", () => $dca57288b6aa30a6$export$f5bccce225aa614b);
const $dca57288b6aa30a6$export$667f2a0f99c75faa = (state)=>state.appProps.projectKey;
const $dca57288b6aa30a6$export$89040d072f281f85 = (state)=>state.appProps.projectId;
const $dca57288b6aa30a6$export$be28a82d4e8d697f = (state)=>state.appProps.projectDefaultAssignee;
const $dca57288b6aa30a6$export$c5b979a08b55628c = (state)=>state.appProps.projectLead ? state.appProps.projectLead.displayName : '';
const $dca57288b6aa30a6$export$87f3187c49e686c = (state)=>state.appProps.onClose;
const $dca57288b6aa30a6$export$a92edfca0b454563 = (state)=>state.appProps.onComplete;
const $dca57288b6aa30a6$export$60888e2ed0df5dfd = (state)=>state.appProps.onError;
const $dca57288b6aa30a6$export$21a8719ce41a1de2 = (state)=>state.component;
const $dca57288b6aa30a6$export$7d9f7e9c1c02b41e = (state)=>state.component.name;
const $dca57288b6aa30a6$export$67580b1c13935958 = (state)=>state.component.description;
const $dca57288b6aa30a6$export$725da8bee1e71eb0 = (state)=>state.component.defaultAssignee;
const $dca57288b6aa30a6$export$97850e2d25587c0d = (state)=>state.component.lead;
const $dca57288b6aa30a6$export$6222164b63cc3ae9 = (state)=>state.errors.name;
const $dca57288b6aa30a6$export$8802ac508ab8d49a = (state)=>state.errors.componentLead;
const $dca57288b6aa30a6$export$3b51d1dcee070cea = (state)=>state.isSaving;
const $dca57288b6aa30a6$export$f5bccce225aa614b = (state)=>!$dca57288b6aa30a6$export$3b51d1dcee070cea(state) && !!$dca57288b6aa30a6$export$7d9f7e9c1c02b41e(state).trim();

});



parcelRegister("e55Vq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b49f787eb2b28d9$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4tM8k = parcelRequire("4tM8k");

var $kqAfW = parcelRequire("kqAfW");

var $94zwf = parcelRequire("94zwf");
const $6b49f787eb2b28d9$var$createStore1 = (rootEpic, initialState, middlewares = [])=>(0, $7HHI1.createStore)((0, $94zwf.default), initialState, (0, $kqAfW.default)({
        name: 'Create component modal'
    })((0, $7HHI1.applyMiddleware)(...middlewares, (0, $4tM8k.createEpicMiddleware)(rootEpic))));
var $6b49f787eb2b28d9$export$2e2bcd8739ae039 = $6b49f787eb2b28d9$var$createStore1;

});
parcelRegister("94zwf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3d83bfdb4c3cd60$export$2e2bcd8739ae039);

var $6kS6u = parcelRequire("6kS6u");

var $12DRg = parcelRequire("12DRg");

var $jbr6p = parcelRequire("jbr6p");


var $ckmIk = parcelRequire("ckmIk");
const $e3d83bfdb4c3cd60$var$defaultState = {
    appProps: {
        locale: (0, $jbr6p.defaultLocale),
        projectId: NaN,
        projectKey: '',
        projectDefaultAssignee: undefined,
        projectLead: undefined,
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    },
    isSaving: false,
    component: {
        name: '',
        description: '',
        defaultAssignee: (0, $34654ae9c709da9a$export$dfc4824370fdf2e8),
        lead: undefined
    },
    errors: {
        name: '',
        componentLead: ''
    }
};
const $e3d83bfdb4c3cd60$var$getFieldError = (payload, field)=>{
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(payload, {
        field: field
    }) || {};
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type '{}'.
    return result.error || '';
};
const $e3d83bfdb4c3cd60$var$rootReducer = (state = $e3d83bfdb4c3cd60$var$defaultState, action)=>{
    switch(action.type){
        case 0, $ckmIk.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $ckmIk.UPDATE:
            return {
                ...state,
                component: action.payload
            };
        case 0, $ckmIk.SAVE:
            return {
                ...state,
                isSaving: true,
                errors: {
                    name: '',
                    componentLead: ''
                }
            };
        case 0, $ckmIk.VALIDATION_FAILURE:
            return {
                ...state,
                isSaving: false,
                errors: {
                    name: $e3d83bfdb4c3cd60$var$getFieldError(action.payload, 'name'),
                    componentLead: $e3d83bfdb4c3cd60$var$getFieldError(action.payload, 'componentLead')
                }
            };
        case 0, $ckmIk.FAILURE:
        case 0, $ckmIk.CANCEL:
        case 0, $ckmIk.SUCCESS:
            return {
                ...state,
                isSaving: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $e3d83bfdb4c3cd60$export$2e2bcd8739ae039 = $e3d83bfdb4c3cd60$var$rootReducer;

});
parcelRegister("6kS6u", function(module, exports) {

var $dSzgR = parcelRequire("dSzgR");

var $gyBpf = parcelRequire("gyBpf");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $49ce942e5e13bbf0$var$find = $dSzgR($gyBpf);
module.exports = $49ce942e5e13bbf0$var$find;

});
parcelRegister("dSzgR", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $7H30b = parcelRequire("7H30b");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a1abad92a1851e60$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$7H30b(collection)) {
            var iteratee = $1lM9j(predicate, 3);
            collection = $4c94y(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a1abad92a1851e60$var$createFind;

});

parcelRegister("gyBpf", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0dcd66d5aa7faa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c0dcd66d5aa7faa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c9FP3(fromIndex);
    if (index < 0) index = $c0dcd66d5aa7faa7$var$nativeMax(length + index, 0);
    return $9gUEB(array, $1lM9j(predicate, 3), index);
}
module.exports = $c0dcd66d5aa7faa7$var$findIndex;

});


const $34654ae9c709da9a$export$e141a3d44fafd179 = 'COMPONENT_LEAD';
const $34654ae9c709da9a$export$dfc4824370fdf2e8 = 'PROJECT_DEFAULT';
const $34654ae9c709da9a$export$3c83461db52a5dd6 = 'PROJECT_LEAD';
const $34654ae9c709da9a$export$3f4d79509888a8a1 = 'UNASSIGNED';



parcelRegister("4C1KG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0305ee59dedb1528$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $ckmIk = parcelRequire("ckmIk");

var $aqYyt = parcelRequire("aqYyt");

var $cV8iD = parcelRequire("cV8iD");
const $0305ee59dedb1528$var$mapStateToProps = (state)=>({
        isSaving: (0, $aqYyt.isSaving)(state),
        canSubmit: (0, $aqYyt.canSubmit)(state),
        projectDefaultAssignee: (0, $aqYyt.getProjectDefaultAssignee)(state),
        projectLeadName: (0, $aqYyt.getProjectLeadName)(state),
        name: (0, $aqYyt.getName)(state),
        description: (0, $aqYyt.getDescription)(state),
        lead: (0, $aqYyt.getLead)(state),
        defaultAssignee: (0, $aqYyt.getDefaultAssignee)(state),
        nameErrorMessage: (0, $aqYyt.getNameErrorMessage)(state)
    });
const $0305ee59dedb1528$var$mapDispatchToProps = {
    onCancel: (0, $ckmIk.cancel),
    onConfirm: (0, $ckmIk.save),
    onUpdateComponent: (0, $ckmIk.update)
};
var $0305ee59dedb1528$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($0305ee59dedb1528$var$mapStateToProps, $0305ee59dedb1528$var$mapDispatchToProps)((0, $cV8iD.default));

});
parcelRegister("cV8iD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0b064358acda67f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lJKII = parcelRequire("lJKII");

var $4B7rn = parcelRequire("4B7rn");

var $idGBm = parcelRequire("idGBm");

var $kqWOy = parcelRequire("kqWOy");

var $1Yvms = parcelRequire("1Yvms");
const $f0b064358acda67f$var$Header = ({ intl: { formatMessage: formatMessage } })=>// eslint-disable-next-line @atlaskit/design-system/use-heading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h2", null, formatMessage((0, $1Yvms.default).globalComponentsHeader));
const $f0b064358acda67f$var$Footer = ({ intl: { formatMessage: formatMessage }, isSaving: isSaving, canSubmit: canSubmit, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f0b064358acda67f$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f0b064358acda67f$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        type: "submit",
        onClick: onConfirm,
        isDisabled: !canSubmit,
        externalId: "project-components.item.add"
    }, formatMessage((0, $1Yvms.default).saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancel,
        isDisabled: isSaving
    }, formatMessage((0, $1Yvms.default).cancelButton))));
function $f0b064358acda67f$var$CreateModal(props) {
    const { projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName, isSaving: isSaving, canSubmit: canSubmit, name: name, description: description, lead: lead, defaultAssignee: defaultAssignee, intl: intl, onConfirm: onConfirm, onCancel: onCancel, onUpdateComponent: onUpdateComponent, nameErrorMessage: nameErrorMessage } = props;
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const HeaderComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f0b064358acda67f$var$Header, {
            intl: intl
        }); // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const FooterComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f0b064358acda67f$var$Footer, {
            intl: intl,
            isSaving: isSaving,
            canSubmit: canSubmit,
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        autoFocus: true,
        onClose: onCancel,
        width: "medium",
        messageId: "project-directories.components.create-modal.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqWOy.default), {
        onUpdateComponent: onUpdateComponent,
        projectDefaultAssignee: projectDefaultAssignee,
        projectLeadName: projectLeadName,
        name: name,
        description: description,
        lead: lead,
        defaultAssignee: defaultAssignee,
        nameErrorMessage: nameErrorMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FooterComponent, null)));
}
var $f0b064358acda67f$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($f0b064358acda67f$var$CreateModal);
const $f0b064358acda67f$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f0b064358acda67f$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kqWOy", function(module, exports) {
$parcel$export(module.exports, "default", () => $54adcf525fa2338d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $5toMF = parcelRequire("5toMF");
var $lP4Q7 = parcelRequire("lP4Q7");

var $sY9BV = parcelRequire("sY9BV");

var $idGBm = parcelRequire("idGBm");

var $fucyK = parcelRequire("fucyK");

var $lCR5V = parcelRequire("lCR5V");

var $czi8W = parcelRequire("czi8W");
// eslint-disable-next-line jira/react/no-class-components
class $54adcf525fa2338d$var$ModalCommonContent extends (0, $eJOHy.PureComponent) {
    componentDidUpdate(prevProps) {
        if (this.props.nameErrorMessage && !prevProps.nameErrorMessage) // do it a little bit later to avoid animation clipping
        setTimeout(()=>{
            if (this.nameFieldInstance) this.nameFieldInstance.focus();
        });
    }
    inputChange(update) {
        const { name: name, description: description, lead: lead, defaultAssignee: defaultAssignee, onUpdateComponent: onUpdateComponent } = this.props;
        const oldComponent = {
            name: name,
            description: description,
            lead: lead,
            defaultAssignee: defaultAssignee
        };
        const newComponent = {
            ...oldComponent,
            ...update
        };
        onUpdateComponent(newComponent);
    }
    generateLeadWithStatus(lead) {
        const { formatMessage: formatMessage } = this.props.intl;
        if (lead && lead.active === false) return {
            ...lead,
            displayName: formatMessage((0, $czi8W.default).deactivated, {
                userName: lead.displayName
            })
        };
        return lead;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, nameErrorMessage: nameErrorMessage, projectLeadName: projectLeadName, projectDefaultAssignee: projectDefaultAssignee, name: name, description: description, lead: lead, defaultAssignee: defaultAssignee } = this.props;
        const isInvalid = !!nameErrorMessage;
        const selectedLead = this.generateLeadWithStatus(lead);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-test-id": "project-directories.components.common.components.configuration"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5toMF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
            "aria-hidden": "true"
        }, formatMessage((0, $czi8W.default).requiredFieldsInformMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lP4Q7.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "component-name",
            isRequired: true,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54adcf525fa2338d$var$FieldLabelWrapper, null, formatMessage((0, $czi8W.default).componentName))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...fieldProps,
                ...isInvalid ? {
                    'aria-describedby': `${fieldProps.id}-error ${fieldProps['aria-describedby']}`
                } : {},
                autoFocus: true,
                onChange: this.onChangeComponentName,
                value: name,
                isInvalid: isInvalid,
                "aria-invalid": isInvalid,
                maxLength: 255,
                ref: (instance)=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    this.nameFieldInstance = instance;
                }
            }), nameErrorMessage !== undefined && nameErrorMessage !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, nameErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "component-description",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54adcf525fa2338d$var$FieldLabelWrapper, null, formatMessage((0, $czi8W.default).description))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...fieldProps,
                onChange: this.onChangeComponentDescription,
                value: description
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fucyK.default), {
            label: formatMessage((0, $czi8W.default).componentLead),
            placeholder: formatMessage((0, $czi8W.default).componentLeadPlaceholder),
            selectedUser: selectedLead,
            onChange: this.onLeadSelected,
            shouldFitContainer: true,
            isClearable: true,
            isClearableWithCrossIcon: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lCR5V.default), {
            label: formatMessage((0, $czi8W.default).defaultAssignee),
            projectDefaultAssignee: projectDefaultAssignee,
            projectLeadName: projectLeadName,
            componentLeadName: lead && lead.displayName,
            onSelected: this.onAssigneeChange,
            value: defaultAssignee
        }));
    }
    constructor(...args){
        super(...args), this.onChangeComponentName = (e)=>{
            this.inputChange({
                name: e.target.value
            });
        }, this.onChangeComponentDescription = (e)=>{
            this.inputChange({
                description: e.target.value
            });
        }, this.onLeadSelected = (user)=>{
            this.inputChange({
                lead: user ? {
                    accountId: user.accountId,
                    displayName: user.displayName,
                    avatarUrl: user.avatarUrl,
                    /*
                        This is hardcoded to true as user from the user picker does not return its status.
                        Since user picker is always returning the active user, it should be safe to hard code to be active user.
                         */ active: true
                } : undefined
            });
        }, this.onAssigneeChange = (assignee)=>{
            this.inputChange({
                defaultAssignee: assignee
            });
        };
    }
}
var $54adcf525fa2338d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($54adcf525fa2338d$var$ModalCommonContent);
const $54adcf525fa2338d$var$FieldLabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fucyK", function(module, exports) {
$parcel$export(module.exports, "default", () => $cace7a5a03fd5f19$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $aPsSO = parcelRequire("aPsSO");
var $cace7a5a03fd5f19$export$2e2bcd8739ae039 = (0, $as6H2.default)('UserPicker', {
    onChange: 'changed'
})((0, $aPsSO.default));

});
parcelRegister("aPsSO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8995af3cbc8e38f3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $eSnSE = parcelRequire("eSnSE");

var $idGBm = parcelRequire("idGBm");

var $2e8aC = parcelRequire("2e8aC");

var $d5dE5 = parcelRequire("d5dE5");
class $8995af3cbc8e38f3$export$83e0c73b09b3a9cd extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $2e8aC.requestUsers)(query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $2e8aC.requestUser)(suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $eSnSE.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $2e8aC.requestUser)(accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $d5dE5.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $d5dE5.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $d5dE5.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $8995af3cbc8e38f3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($8995af3cbc8e38f3$export$83e0c73b09b3a9cd);

});
parcelRegister("2sHLK", function(module, exports) {
$parcel$export(module.exports, "PickerWithAvatar", () => $3183b99370c8c0ed$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $3183b99370c8c0ed$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $as6H2 = parcelRequire("as6H2");

var $fJTOm = parcelRequire("fJTOm");

var $87K62 = parcelRequire("87K62");
const $3183b99370c8c0ed$export$e6b8a87858f7afd1 = (0, $87K62.default);
const $3183b99370c8c0ed$export$3d409af828769e2e = (0, $as6H2.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $87K62.default));
const $3183b99370c8c0ed$export$d8d9f25d80d89b16 = (0, $as6H2.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $fJTOm.default));

});
parcelRegister("87K62", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a231bde2dbcecf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $2sLVw = parcelRequire("2sLVw");

var $fJTOm = parcelRequire("fJTOm");
class $33a231bde2dbcecf$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33a231bde2dbcecf$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $33a231bde2dbcecf$var$LabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2e8aC", function(module, exports) {
$parcel$export(module.exports, "requestUser", () => $340ce2eca69238dd$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $340ce2eca69238dd$export$55b721778f931cc1);

var $37Xqw = parcelRequire("37Xqw");

var $1otmW = parcelRequire("1otmW");
const $340ce2eca69238dd$export$949646a1c1731536 = (accountId)=>(0, $37Xqw.getUser)(accountId).then((0, $1otmW.transformUser));
const $340ce2eca69238dd$export$55b721778f931cc1 = (query)=>(0, $37Xqw.getUsers)(query).then((0, $1otmW.transformUsers));

});
parcelRegister("37Xqw", function(module, exports) {
$parcel$export(module.exports, "getUser", () => $143cc0293437bb25$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $143cc0293437bb25$export$925a4945a6cd0f3e);

var $hgi0g = parcelRequire("hgi0g");
const $143cc0293437bb25$export$e45b57f6c6c40475 = 5;
const $143cc0293437bb25$export$7eaa662f51e316ae = ()=>'/rest/api/2/user';
const $143cc0293437bb25$export$8df721f926f55c9a = (accountId = '')=>`${$143cc0293437bb25$export$7eaa662f51e316ae()}?accountId=${encodeURIComponent(accountId)}`;
const $143cc0293437bb25$export$715964ba85b11e2b = ()=>'/rest/api/2/user/picker';
const $143cc0293437bb25$export$977bdbd87001f83 = (query = '')=>`${$143cc0293437bb25$export$715964ba85b11e2b()}?showAvatar=true&maxResults=${$143cc0293437bb25$export$e45b57f6c6c40475}&query=${query}`;
const $143cc0293437bb25$export$7cbf767827cd68ba = (accountId = '')=>(0, $hgi0g.default)($143cc0293437bb25$export$8df721f926f55c9a(accountId));
const $143cc0293437bb25$export$925a4945a6cd0f3e = (query = '')=>(0, $hgi0g.default)($143cc0293437bb25$export$977bdbd87001f83(query));

});

parcelRegister("1otmW", function(module, exports) {
$parcel$export(module.exports, "transformUser", () => $19e9ef34e6aae24a$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $19e9ef34e6aae24a$export$fb8c90bfc4beaa59);
const $19e9ef34e6aae24a$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $19e9ef34e6aae24a$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("d5dE5", function(module, exports) {
$parcel$export(module.exports, "default", () => $61835bca22ccc32e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $61835bca22ccc32e$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});
var $61835bca22ccc32e$export$2e2bcd8739ae039 = $61835bca22ccc32e$var$messages;

});



parcelRegister("lCR5V", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb65a8b73afc3ec6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6kS6u = parcelRequire("6kS6u");

var $1jVV7 = parcelRequire("1jVV7");

var $6svxr = parcelRequire("6svxr");

var $c4OV1 = parcelRequire("c4OV1");

var $cxKOj = parcelRequire("cxKOj");

var $idGBm = parcelRequire("idGBm");


var $6thpz = parcelRequire("6thpz");
const $cb65a8b73afc3ec6$var$getAssigneeItems = (props)=>{
    const assigneeProjectLeadGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6thpz.default).assigneeProjectLeadGalaxia : (0, $6thpz.default).assigneeProjectLead;
    const assigneeProjectDefaultGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6thpz.default).assigneeProjectDefaultGalaxia : (0, $6thpz.default).assigneeProjectDefault;
    const { intl: { formatMessage: formatMessage }, componentLeadName: componentLeadName, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName } = props;
    const unassignedMessage = formatMessage((0, $6thpz.default).assigneeUnassigned);
    const projectLeadMessage = formatMessage(assigneeProjectLeadGalaxia);
    const projectDefaultMessage = formatMessage(assigneeProjectDefaultGalaxia);
    return [
        {
            value: (0, $34654ae9c709da9a$export$e141a3d44fafd179),
            label: formatMessage((0, $6thpz.default).assigneeTypeWithDetails, {
                assigneeType: formatMessage((0, $6thpz.default).assigneeComponentLead),
                displayName: componentLeadName || unassignedMessage
            })
        },
        {
            value: (0, $34654ae9c709da9a$export$dfc4824370fdf2e8),
            label: projectDefaultAssignee ? formatMessage((0, $6thpz.default).assigneeTypeWithDetails, {
                assigneeType: projectDefaultMessage,
                displayName: projectDefaultAssignee === (0, $34654ae9c709da9a$export$3f4d79509888a8a1) ? unassignedMessage : projectLeadMessage
            }) : projectDefaultMessage
        },
        {
            value: (0, $34654ae9c709da9a$export$3c83461db52a5dd6),
            label: projectLeadName ? formatMessage((0, $6thpz.default).assigneeTypeWithDetails, {
                assigneeType: projectLeadMessage,
                displayName: projectLeadName
            }) : projectLeadMessage
        },
        {
            value: (0, $34654ae9c709da9a$export$3f4d79509888a8a1),
            label: unassignedMessage
        }
    ];
};
const $cb65a8b73afc3ec6$var$getAssigneeItemByValue = (props, value)=>{
    const futureAssigneeItems = $cb65a8b73afc3ec6$var$getAssigneeItems(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(futureAssigneeItems, (i)=>i.value === value);
}; // eslint-disable-next-line jira/react/no-class-components
class $cb65a8b73afc3ec6$export$935c4082cfb74cb6 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            label: ''
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const selectedItem = prevState.selectedItem;
        const nextState = {
            value: nextProps.value,
            componentLeadName: nextProps.componentLeadName
        };
        if (prevState.value !== nextProps.value) {
            if (!selectedItem || nextProps.value !== selectedItem.value) nextState.selectedItem = $cb65a8b73afc3ec6$var$getAssigneeItemByValue(nextProps, nextProps.value);
        } else if (selectedItem && prevState.componentLeadName !== nextProps.componentLeadName) {
            const updatedCurrentSelection = $cb65a8b73afc3ec6$var$getAssigneeItemByValue(nextProps, selectedItem.value);
            if (updatedCurrentSelection && updatedCurrentSelection.label !== selectedItem.label) nextState.selectedItem = updatedCurrentSelection;
        }
        return nextState;
    }
    constructor(props){
        super(props), this.onSelected = (selected)=>{
            this.setState({
                selectedItem: selected,
                isOpen: false
            });
            this.props.onSelected(selected.value);
        }, this.onMenuOpenHandler = ()=>this.setState({
                isOpen: true
            }), this.onMenuCloseHandler = ()=>this.setState({
                isOpen: false
            });
        this.state = {
            selectedItem: props.value ? $cb65a8b73afc3ec6$var$getAssigneeItemByValue(props, props.value) : undefined,
            isOpen: false
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, label: label } = this.props;
        const { selectedItem: selectedItem, isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "component-assignee",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cb65a8b73afc3ec6$var$FieldLabelWrapper, null, label)
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
                inputId: fieldProps.id,
                noOptionsMessage: ()=>formatMessage((0, $6thpz.default).noMatches),
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, $1jVV7.layers).modal
                        })
                },
                placeholder: formatMessage((0, $6thpz.default).placeholder),
                options: $cb65a8b73afc3ec6$var$getAssigneeItems(this.props),
                onChange: this.onSelected,
                value: selectedItem,
                menuIsOpen: isOpen,
                onMenuOpen: this.onMenuOpenHandler,
                onMenuClose: this.onMenuCloseHandler
            }));
    }
}
var $cb65a8b73afc3ec6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($cb65a8b73afc3ec6$export$935c4082cfb74cb6);
const $cb65a8b73afc3ec6$var$FieldLabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6thpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9ff69a73e11ca51$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a9ff69a73e11ca51$var$messages = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "project-components.component-assignee-placeholder",
        "defaultMessage": "Default assignee"
    },
    noMatches: {
        "id": "project-components.component-assignee-no-matches",
        "defaultMessage": "No Matches"
    },
    assigneeTypeWithDetails: {
        "id": "project-components.component-assignee-type-with-details",
        "defaultMessage": "{assigneeType} ({displayName})"
    },
    assigneeComponentLead: {
        "id": "project-components.assignee-component-lead",
        "defaultMessage": "Component lead"
    },
    assigneeProjectDefault: {
        "id": "project-components.assignee-project-default",
        "defaultMessage": "Project default"
    },
    assigneeProjectLead: {
        "id": "project-components.assignee-project-lead",
        "defaultMessage": "Project lead"
    },
    assigneeUnassigned: {
        "id": "project-components.assignee-unassigned",
        "defaultMessage": "Unassigned"
    },
    assigneeProjectDefaultGalaxia: {
        "id": "project-components.assignee-project-default-galaxia",
        "defaultMessage": "Space default"
    },
    assigneeProjectLeadGalaxia: {
        "id": "project-components.assignee-project-lead-galaxia",
        "defaultMessage": "Space owner"
    }
});
var $a9ff69a73e11ca51$export$2e2bcd8739ae039 = $a9ff69a73e11ca51$var$messages;

});


parcelRegister("czi8W", function(module, exports) {
$parcel$export(module.exports, "default", () => $461ea5556173f005$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $461ea5556173f005$var$messages = (0, $7qGN1.defineMessages)({
    componentName: {
        "id": "project-components.edit-modal-dialog-component-name-label",
        "defaultMessage": "Name"
    },
    componentLead: {
        "id": "project-components.edit-modal-dialog-component-lead-label",
        "defaultMessage": "Component lead"
    },
    componentLeadPlaceholder: {
        "id": "project-components.edit-modal-dialog-component-lead-placeholder",
        "defaultMessage": "Select person"
    },
    description: {
        "id": "project-components.edit-modal-dialog-description-label",
        "defaultMessage": "Description"
    },
    defaultAssignee: {
        "id": "project-components.edit-modal-dialog-default-assignee-label",
        "defaultMessage": "Default assignee"
    },
    deactivated: {
        "id": "project-components.edit-modal-dialog-deactivated-status-label",
        "defaultMessage": "{userName} (Deactivated)"
    },
    requiredFieldsInformMessage: {
        "id": "project-components.edit-modal-dialog-required-field-inform-text-message",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});
var $461ea5556173f005$export$2e2bcd8739ae039 = $461ea5556173f005$var$messages;

});


parcelRegister("1Yvms", function(module, exports) {
$parcel$export(module.exports, "default", () => $84922dff693010c6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $84922dff693010c6$var$messages = (0, $7qGN1.defineMessages)({
    globalComponentsHeader: {
        "id": "project-directories.components.create-modal.global-components-header",
        "defaultMessage": "Create Jira component"
    },
    header: {
        "id": "project-directories.components.create-modal.header",
        "defaultMessage": "Create component"
    },
    saveButton: {
        "id": "project-directories.components.create-modal.save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "project-directories.components.create-modal.cancel-button",
        "defaultMessage": "Cancel"
    }
});
var $84922dff693010c6$export$2e2bcd8739ae039 = $84922dff693010c6$var$messages;

});




parcelRegister("284Hf", function(module, exports) {
$parcel$export(module.exports, "isOpen", () => $9a1d0c3ec9de6e20$export$ea0830439c7fc698);
const $9a1d0c3ec9de6e20$export$ea0830439c7fc698 = (state)=>state.ui.add.isOpen;

});


parcelRegister("i9ub4", function(module, exports) {
$parcel$export(module.exports, "default", () => $24c52f60541ae36a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4B7rn = parcelRequire("4B7rn");

var $7qGN1 = parcelRequire("7qGN1");

var $idGBm = parcelRequire("idGBm");

var $lJKII = parcelRequire("lJKII");

var $gnQAk = parcelRequire("gnQAk");

var $kqWOy = parcelRequire("kqWOy");

var $1jVSq = parcelRequire("1jVSq");

var $jv7JI = parcelRequire("jv7JI");

var $57k4O = parcelRequire("57k4O");

var $86SzG = parcelRequire("86SzG");
const $24c52f60541ae36a$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $24c52f60541ae36a$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $24c52f60541ae36a$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-components.dialogs-edit-header",
        "defaultMessage": "Edit component"
    },
    saveButton: {
        "id": "project-components.dialogs-edit-save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "project-components.dialogs-edit-cancel-button",
        "defaultMessage": "Cancel"
    }
});
class $24c52f60541ae36a$export$97b20acb2862c69e extends (0, $eJOHy.Component) {
    render() {
        const { component: component, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName, onCancel: onCancel, nameErrorMessage: nameErrorMessage, isDialogOpen: isDialogOpen } = this.props;
        if (!isDialogOpen || !component) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
            onClose: onCancel,
            width: "medium",
            messageId: "project-directories.components.modals.edit.modal-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, this.renderHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqWOy.default), {
            name: component.name,
            description: component.description,
            lead: component.lead,
            defaultAssignee: component.defaultAssignee,
            onUpdateComponent: this.onUpdateComponent,
            projectDefaultAssignee: projectDefaultAssignee,
            projectLeadName: projectLeadName,
            nameErrorMessage: nameErrorMessage
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, this.renderFooter()))));
    }
    constructor(...args){
        super(...args), this.state = {
            isSaveDisabled: false
        }, this.onUpdateComponent = (component)=>{
            const isSaveDisabled = !component.name || !component.name.trim();
            this.setState({
                isSaveDisabled: isSaveDisabled
            });
            this.props.onUpdateComponent(component);
        }, // eslint-disable-next-line @atlaskit/design-system/use-heading
        this.renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h2", null, this.props.intl.formatMessage($24c52f60541ae36a$var$messages.header)), this.renderFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24c52f60541ae36a$var$ButtonsContainer, null, this.props.isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $24c52f60541ae36a$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "primary",
                type: "submit",
                onClick: this.props.onConfirm,
                isDisabled: this.props.isSaving || this.state.isSaveDisabled
            }, this.props.intl.formatMessage($24c52f60541ae36a$var$messages.saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "subtle-link",
                onClick: this.props.onCancel,
                isDisabled: this.props.isSaving
            }, this.props.intl.formatMessage($24c52f60541ae36a$var$messages.cancelButton)));
    }
}
const $24c52f60541ae36a$var$mapStateToProps = (state)=>({
        isDialogOpen: (0, $86SzG.isEditing)(state),
        isSaving: (0, $86SzG.saveIsInProgress)(state),
        projectDefaultAssignee: (0, $jv7JI.getProjectDefaultAssignee)(state),
        projectLeadName: (0, $jv7JI.getProjectLeadName)(state),
        component: (0, $86SzG.getEditedComponent)(state),
        nameErrorMessage: (0, $86SzG.getNameErrorMessage)(state)
    });
const $24c52f60541ae36a$var$mapDispatchToProps = {
    onCancel: (0, $57k4O.cancel),
    onConfirm: (0, $1jVSq.updateComponentRequest),
    onUpdateComponent: (0, $57k4O.updateEditedComponent)
};
const $24c52f60541ae36a$var$Connected = (0, $gnQAk.connect)($24c52f60541ae36a$var$mapStateToProps, $24c52f60541ae36a$var$mapDispatchToProps)((0, $idGBm.injectIntlV2)($24c52f60541ae36a$export$97b20acb2862c69e));
var $24c52f60541ae36a$export$2e2bcd8739ae039 = $24c52f60541ae36a$var$Connected;

});




parcelRegister("1SsnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f6731237dc34f1f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fGnU6 = parcelRequire("fGnU6");

var $fdpHV = parcelRequire("fdpHV");

var $1qbKn = parcelRequire("1qbKn");


var $2vBmG = parcelRequire("2vBmG");

var $jUHqr = parcelRequire("jUHqr");

var $TALfu = parcelRequire("TALfu");

var $gWu57 = parcelRequire("gWu57");

var $cH6Qf = parcelRequire("cH6Qf");

var $4EKqI = parcelRequire("4EKqI");

var $6D4rJ = parcelRequire("6D4rJ");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8f6731237dc34f1f$var$noop = ()=>{};
function $8f6731237dc34f1f$var$ProjectComponents({ Updater: Updater, ProjectDirectoriesApp: ProjectDirectoriesApp, tenantContext: tenantContext, projectContext: projectContext, prefetchResult: prefetchResult, query: query, onQueryChanged: onQueryChanged }) {
    const { error: prefetchError, data: data } = prefetchResult;
    const { data: project } = projectContext;
    if (prefetchError) // @ts-expect-error - react-resource-router types return Record<string,any> but ErrorFlagRenderer only accepts Errors
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "project-components",
        error: prefetchError
    });
    if (!data || !(project && project.projectKey)) return null;
    const { isAdmin: isAdmin, locale: locale } = tenantContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "project-components-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectComponents",
        teamName: "morphinecake",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProjectDirectoriesApp, {
        locale: locale,
        projectKey: project.projectKey,
        projectId: project.projectId,
        projectName: project.projectName,
        projectType: project.projectType,
        isAdmin: isAdmin || project.isProjectAdmin === true || false,
        prefetchedData: data,
        onUnmount: $8f6731237dc34f1f$var$noop,
        query: query,
        onQueryChanged: onQueryChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        metricKey: "jira.project.components",
        metric: (0, $6D4rJ.projectComponentsPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $2vBmG.appBundleReadyMark),
            (0, $2vBmG.prefetchApiReadyMark)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $TALfu.default), {
        projectKey: project.projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null))));
}
var $8f6731237dc34f1f$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('project-components', (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a))($8f6731237dc34f1f$var$ProjectComponents);

});
parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $12DRg = parcelRequire("12DRg");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));

});


parcelRegister("TALfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddfa7ac58314469e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $3aa9n = parcelRequire("3aa9n");

var $3ugTQ = parcelRequire("3ugTQ");
const $ddfa7ac58314469e$export$fa156a01818e3239 = (projectKey)=>(0, $3ugTQ.performPostRequest)(`/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
    });
const $ddfa7ac58314469e$var$AddProjectToHistory = ({ projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: ()=>$ddfa7ac58314469e$export$fa156a01818e3239(projectKey)
    });
var $ddfa7ac58314469e$export$2e2bcd8739ae039 = $ddfa7ac58314469e$var$AddProjectToHistory;

});

parcelRegister("gWu57", function(module, exports) {
$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.300"
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: [
            hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStyles,
            (0, $4cTDP.fg)('global_rovo_button_in_jira') && $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles
        ]
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});
const $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.500'
});

});

parcelRegister("6D4rJ", function(module, exports) {
$parcel$export(module.exports, "projectComponentsPageLoad", () => $90c08013fe75bb85$export$4b4575b030c402bb);

var $hqYEY = parcelRequire("hqYEY");
const $90c08013fe75bb85$export$4b4575b030c402bb = (0, $hqYEY.metrics).pageLoad({
    key: 'project-components',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-project-components.5766737c.js.map
